var TL = Object.defineProperty;
var _L = (e, t, r) => t in e ? TL(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Oo = (e, t, r) => (_L(e, typeof t != "symbol" ? t + "" : t, r), r), iE = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
};
var le = (e, t, r) => (iE(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ot = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, xt = (e, t, r, o) => (iE(e, t, "write to private field"), o ? o.call(e, r) : t.set(e, r), r);
var Ut = (e, t, r) => (iE(e, t, "access private method"), r);
function RL(e, t) {
  for (var r = 0; r < t.length; r++) {
    const o = t[r];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const l in o)
        if (l !== "default" && !(l in e)) {
          const d = Object.getOwnPropertyDescriptor(o, l);
          d && Object.defineProperty(e, l, d.get ? d : {
            enumerable: !0,
            get: () => o[l]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var l1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function km(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var QE = { exports: {} }, Bv = {}, XE = { exports: {} }, Xt = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IO;
function OL() {
  if (IO)
    return Xt;
  IO = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), f = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), b = Symbol.iterator;
  function k(z) {
    return z === null || typeof z != "object" ? null : (z = b && z[b] || z["@@iterator"], typeof z == "function" ? z : null);
  }
  var T = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, O = Object.assign, R = {};
  function j(z, oe, ke) {
    this.props = z, this.context = oe, this.refs = R, this.updater = ke || T;
  }
  j.prototype.isReactComponent = {}, j.prototype.setState = function(z, oe) {
    if (typeof z != "object" && typeof z != "function" && z != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, z, oe, "setState");
  }, j.prototype.forceUpdate = function(z) {
    this.updater.enqueueForceUpdate(this, z, "forceUpdate");
  };
  function I() {
  }
  I.prototype = j.prototype;
  function N(z, oe, ke) {
    this.props = z, this.context = oe, this.refs = R, this.updater = ke || T;
  }
  var L = N.prototype = new I();
  L.constructor = N, O(L, j.prototype), L.isPureReactComponent = !0;
  var B = Array.isArray, H = Object.prototype.hasOwnProperty, V = { current: null }, W = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Y(z, oe, ke) {
    var Qe, Xe = {}, bt = null, at = null;
    if (oe != null)
      for (Qe in oe.ref !== void 0 && (at = oe.ref), oe.key !== void 0 && (bt = "" + oe.key), oe)
        H.call(oe, Qe) && !W.hasOwnProperty(Qe) && (Xe[Qe] = oe[Qe]);
    var ut = arguments.length - 2;
    if (ut === 1)
      Xe.children = ke;
    else if (1 < ut) {
      for (var wt = Array(ut), pt = 0; pt < ut; pt++)
        wt[pt] = arguments[pt + 2];
      Xe.children = wt;
    }
    if (z && z.defaultProps)
      for (Qe in ut = z.defaultProps, ut)
        Xe[Qe] === void 0 && (Xe[Qe] = ut[Qe]);
    return { $$typeof: e, type: z, key: bt, ref: at, props: Xe, _owner: V.current };
  }
  function ce(z, oe) {
    return { $$typeof: e, type: z.type, key: oe, ref: z.ref, props: z.props, _owner: z._owner };
  }
  function ve(z) {
    return typeof z == "object" && z !== null && z.$$typeof === e;
  }
  function Se(z) {
    var oe = { "=": "=0", ":": "=2" };
    return "$" + z.replace(/[=:]/g, function(ke) {
      return oe[ke];
    });
  }
  var De = /\/+/g;
  function Re(z, oe) {
    return typeof z == "object" && z !== null && z.key != null ? Se("" + z.key) : oe.toString(36);
  }
  function Pe(z, oe, ke, Qe, Xe) {
    var bt = typeof z;
    (bt === "undefined" || bt === "boolean") && (z = null);
    var at = !1;
    if (z === null)
      at = !0;
    else
      switch (bt) {
        case "string":
        case "number":
          at = !0;
          break;
        case "object":
          switch (z.$$typeof) {
            case e:
            case t:
              at = !0;
          }
      }
    if (at)
      return at = z, Xe = Xe(at), z = Qe === "" ? "." + Re(at, 0) : Qe, B(Xe) ? (ke = "", z != null && (ke = z.replace(De, "$&/") + "/"), Pe(Xe, oe, ke, "", function(pt) {
        return pt;
      })) : Xe != null && (ve(Xe) && (Xe = ce(Xe, ke + (!Xe.key || at && at.key === Xe.key ? "" : ("" + Xe.key).replace(De, "$&/") + "/") + z)), oe.push(Xe)), 1;
    if (at = 0, Qe = Qe === "" ? "." : Qe + ":", B(z))
      for (var ut = 0; ut < z.length; ut++) {
        bt = z[ut];
        var wt = Qe + Re(bt, ut);
        at += Pe(bt, oe, ke, wt, Xe);
      }
    else if (wt = k(z), typeof wt == "function")
      for (z = wt.call(z), ut = 0; !(bt = z.next()).done; )
        bt = bt.value, wt = Qe + Re(bt, ut++), at += Pe(bt, oe, ke, wt, Xe);
    else if (bt === "object")
      throw oe = String(z), Error("Objects are not valid as a React child (found: " + (oe === "[object Object]" ? "object with keys {" + Object.keys(z).join(", ") + "}" : oe) + "). If you meant to render a collection of children, use an array instead.");
    return at;
  }
  function se(z, oe, ke) {
    if (z == null)
      return z;
    var Qe = [], Xe = 0;
    return Pe(z, Qe, "", "", function(bt) {
      return oe.call(ke, bt, Xe++);
    }), Qe;
  }
  function ge(z) {
    if (z._status === -1) {
      var oe = z._result;
      oe = oe(), oe.then(function(ke) {
        (z._status === 0 || z._status === -1) && (z._status = 1, z._result = ke);
      }, function(ke) {
        (z._status === 0 || z._status === -1) && (z._status = 2, z._result = ke);
      }), z._status === -1 && (z._status = 0, z._result = oe);
    }
    if (z._status === 1)
      return z._result.default;
    throw z._result;
  }
  var de = { current: null }, pe = { transition: null }, fe = { ReactCurrentDispatcher: de, ReactCurrentBatchConfig: pe, ReactCurrentOwner: V };
  return Xt.Children = { map: se, forEach: function(z, oe, ke) {
    se(z, function() {
      oe.apply(this, arguments);
    }, ke);
  }, count: function(z) {
    var oe = 0;
    return se(z, function() {
      oe++;
    }), oe;
  }, toArray: function(z) {
    return se(z, function(oe) {
      return oe;
    }) || [];
  }, only: function(z) {
    if (!ve(z))
      throw Error("React.Children.only expected to receive a single React element child.");
    return z;
  } }, Xt.Component = j, Xt.Fragment = r, Xt.Profiler = l, Xt.PureComponent = N, Xt.StrictMode = o, Xt.Suspense = v, Xt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fe, Xt.cloneElement = function(z, oe, ke) {
    if (z == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + z + ".");
    var Qe = O({}, z.props), Xe = z.key, bt = z.ref, at = z._owner;
    if (oe != null) {
      if (oe.ref !== void 0 && (bt = oe.ref, at = V.current), oe.key !== void 0 && (Xe = "" + oe.key), z.type && z.type.defaultProps)
        var ut = z.type.defaultProps;
      for (wt in oe)
        H.call(oe, wt) && !W.hasOwnProperty(wt) && (Qe[wt] = oe[wt] === void 0 && ut !== void 0 ? ut[wt] : oe[wt]);
    }
    var wt = arguments.length - 2;
    if (wt === 1)
      Qe.children = ke;
    else if (1 < wt) {
      ut = Array(wt);
      for (var pt = 0; pt < wt; pt++)
        ut[pt] = arguments[pt + 2];
      Qe.children = ut;
    }
    return { $$typeof: e, type: z.type, key: Xe, ref: bt, props: Qe, _owner: at };
  }, Xt.createContext = function(z) {
    return z = { $$typeof: f, _currentValue: z, _currentValue2: z, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, z.Provider = { $$typeof: d, _context: z }, z.Consumer = z;
  }, Xt.createElement = Y, Xt.createFactory = function(z) {
    var oe = Y.bind(null, z);
    return oe.type = z, oe;
  }, Xt.createRef = function() {
    return { current: null };
  }, Xt.forwardRef = function(z) {
    return { $$typeof: m, render: z };
  }, Xt.isValidElement = ve, Xt.lazy = function(z) {
    return { $$typeof: x, _payload: { _status: -1, _result: z }, _init: ge };
  }, Xt.memo = function(z, oe) {
    return { $$typeof: w, type: z, compare: oe === void 0 ? null : oe };
  }, Xt.startTransition = function(z) {
    var oe = pe.transition;
    pe.transition = {};
    try {
      z();
    } finally {
      pe.transition = oe;
    }
  }, Xt.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, Xt.useCallback = function(z, oe) {
    return de.current.useCallback(z, oe);
  }, Xt.useContext = function(z) {
    return de.current.useContext(z);
  }, Xt.useDebugValue = function() {
  }, Xt.useDeferredValue = function(z) {
    return de.current.useDeferredValue(z);
  }, Xt.useEffect = function(z, oe) {
    return de.current.useEffect(z, oe);
  }, Xt.useId = function() {
    return de.current.useId();
  }, Xt.useImperativeHandle = function(z, oe, ke) {
    return de.current.useImperativeHandle(z, oe, ke);
  }, Xt.useInsertionEffect = function(z, oe) {
    return de.current.useInsertionEffect(z, oe);
  }, Xt.useLayoutEffect = function(z, oe) {
    return de.current.useLayoutEffect(z, oe);
  }, Xt.useMemo = function(z, oe) {
    return de.current.useMemo(z, oe);
  }, Xt.useReducer = function(z, oe, ke) {
    return de.current.useReducer(z, oe, ke);
  }, Xt.useRef = function(z) {
    return de.current.useRef(z);
  }, Xt.useState = function(z) {
    return de.current.useState(z);
  }, Xt.useSyncExternalStore = function(z, oe, ke) {
    return de.current.useSyncExternalStore(z, oe, ke);
  }, Xt.useTransition = function() {
    return de.current.useTransition();
  }, Xt.version = "18.2.0", Xt;
}
var Zv = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Zv.exports;
var MO;
function PL() {
  return MO || (MO = 1, function(e, t) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var r = "18.2.0", o = Symbol.for("react.element"), l = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), m = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), w = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), k = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), j = Symbol.iterator, I = "@@iterator";
      function N(A) {
        if (A === null || typeof A != "object")
          return null;
        var G = j && A[j] || A[I];
        return typeof G == "function" ? G : null;
      }
      var L = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, B = {
        transition: null
      }, H = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, V = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, W = {}, Y = null;
      function ce(A) {
        Y = A;
      }
      W.setExtraStackFrame = function(A) {
        Y = A;
      }, W.getCurrentStack = null, W.getStackAddendum = function() {
        var A = "";
        Y && (A += Y);
        var G = W.getCurrentStack;
        return G && (A += G() || ""), A;
      };
      var ve = !1, Se = !1, De = !1, Re = !1, Pe = !1, se = {
        ReactCurrentDispatcher: L,
        ReactCurrentBatchConfig: B,
        ReactCurrentOwner: V
      };
      se.ReactDebugCurrentFrame = W, se.ReactCurrentActQueue = H;
      function ge(A) {
        {
          for (var G = arguments.length, ae = new Array(G > 1 ? G - 1 : 0), he = 1; he < G; he++)
            ae[he - 1] = arguments[he];
          pe("warn", A, ae);
        }
      }
      function de(A) {
        {
          for (var G = arguments.length, ae = new Array(G > 1 ? G - 1 : 0), he = 1; he < G; he++)
            ae[he - 1] = arguments[he];
          pe("error", A, ae);
        }
      }
      function pe(A, G, ae) {
        {
          var he = se.ReactDebugCurrentFrame, Ae = he.getStackAddendum();
          Ae !== "" && (G += "%s", ae = ae.concat([Ae]));
          var yt = ae.map(function(Fe) {
            return String(Fe);
          });
          yt.unshift("Warning: " + G), Function.prototype.apply.call(console[A], console, yt);
        }
      }
      var fe = {};
      function z(A, G) {
        {
          var ae = A.constructor, he = ae && (ae.displayName || ae.name) || "ReactClass", Ae = he + "." + G;
          if (fe[Ae])
            return;
          de("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", G, he), fe[Ae] = !0;
        }
      }
      var oe = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(A) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(A, G, ae) {
          z(A, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(A, G, ae, he) {
          z(A, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(A, G, ae, he) {
          z(A, "setState");
        }
      }, ke = Object.assign, Qe = {};
      Object.freeze(Qe);
      function Xe(A, G, ae) {
        this.props = A, this.context = G, this.refs = Qe, this.updater = ae || oe;
      }
      Xe.prototype.isReactComponent = {}, Xe.prototype.setState = function(A, G) {
        if (typeof A != "object" && typeof A != "function" && A != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, A, G, "setState");
      }, Xe.prototype.forceUpdate = function(A) {
        this.updater.enqueueForceUpdate(this, A, "forceUpdate");
      };
      {
        var bt = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, at = function(A, G) {
          Object.defineProperty(Xe.prototype, A, {
            get: function() {
              ge("%s(...) is deprecated in plain JavaScript React classes. %s", G[0], G[1]);
            }
          });
        };
        for (var ut in bt)
          bt.hasOwnProperty(ut) && at(ut, bt[ut]);
      }
      function wt() {
      }
      wt.prototype = Xe.prototype;
      function pt(A, G, ae) {
        this.props = A, this.context = G, this.refs = Qe, this.updater = ae || oe;
      }
      var Rn = pt.prototype = new wt();
      Rn.constructor = pt, ke(Rn, Xe.prototype), Rn.isPureReactComponent = !0;
      function rr() {
        var A = {
          current: null
        };
        return Object.seal(A), A;
      }
      var Hn = Array.isArray;
      function Vt(A) {
        return Hn(A);
      }
      function xn(A) {
        {
          var G = typeof Symbol == "function" && Symbol.toStringTag, ae = G && A[Symbol.toStringTag] || A.constructor.name || "Object";
          return ae;
        }
      }
      function gn(A) {
        try {
          return An(A), !1;
        } catch {
          return !0;
        }
      }
      function An(A) {
        return "" + A;
      }
      function Vn(A) {
        if (gn(A))
          return de("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xn(A)), An(A);
      }
      function Wr(A, G, ae) {
        var he = A.displayName;
        if (he)
          return he;
        var Ae = G.displayName || G.name || "";
        return Ae !== "" ? ae + "(" + Ae + ")" : ae;
      }
      function Yr(A) {
        return A.displayName || "Context";
      }
      function cr(A) {
        if (A == null)
          return null;
        if (typeof A.tag == "number" && de("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
          return A.displayName || A.name || null;
        if (typeof A == "string")
          return A;
        switch (A) {
          case d:
            return "Fragment";
          case l:
            return "Portal";
          case m:
            return "Profiler";
          case f:
            return "StrictMode";
          case b:
            return "Suspense";
          case k:
            return "SuspenseList";
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case w:
              var G = A;
              return Yr(G) + ".Consumer";
            case v:
              var ae = A;
              return Yr(ae._context) + ".Provider";
            case x:
              return Wr(A, A.render, "ForwardRef");
            case T:
              var he = A.displayName || null;
              return he !== null ? he : cr(A.type) || "Memo";
            case O: {
              var Ae = A, yt = Ae._payload, Fe = Ae._init;
              try {
                return cr(Fe(yt));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var ar = Object.prototype.hasOwnProperty, Ca = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Zr, qa, Ir;
      Ir = {};
      function Ta(A) {
        if (ar.call(A, "ref")) {
          var G = Object.getOwnPropertyDescriptor(A, "ref").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return A.ref !== void 0;
      }
      function Gn(A) {
        if (ar.call(A, "key")) {
          var G = Object.getOwnPropertyDescriptor(A, "key").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return A.key !== void 0;
      }
      function la(A, G) {
        var ae = function() {
          Zr || (Zr = !0, de("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ae.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: ae,
          configurable: !0
        });
      }
      function oo(A, G) {
        var ae = function() {
          qa || (qa = !0, de("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        ae.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: ae,
          configurable: !0
        });
      }
      function Wa(A) {
        if (typeof A.ref == "string" && V.current && A.__self && V.current.stateNode !== A.__self) {
          var G = cr(V.current.type);
          Ir[G] || (de('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G, A.ref), Ir[G] = !0);
        }
      }
      var Me = function(A, G, ae, he, Ae, yt, Fe) {
        var ht = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: o,
          // Built-in properties that belong on the element
          type: A,
          key: G,
          ref: ae,
          props: Fe,
          // Record the component responsible for creating this element.
          _owner: yt
        };
        return ht._store = {}, Object.defineProperty(ht._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ht, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: he
        }), Object.defineProperty(ht, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ae
        }), Object.freeze && (Object.freeze(ht.props), Object.freeze(ht)), ht;
      };
      function ot(A, G, ae) {
        var he, Ae = {}, yt = null, Fe = null, ht = null, Ft = null;
        if (G != null) {
          Ta(G) && (Fe = G.ref, Wa(G)), Gn(G) && (Vn(G.key), yt = "" + G.key), ht = G.__self === void 0 ? null : G.__self, Ft = G.__source === void 0 ? null : G.__source;
          for (he in G)
            ar.call(G, he) && !Ca.hasOwnProperty(he) && (Ae[he] = G[he]);
        }
        var tn = arguments.length - 2;
        if (tn === 1)
          Ae.children = ae;
        else if (tn > 1) {
          for (var Sn = Array(tn), vn = 0; vn < tn; vn++)
            Sn[vn] = arguments[vn + 2];
          Object.freeze && Object.freeze(Sn), Ae.children = Sn;
        }
        if (A && A.defaultProps) {
          var kn = A.defaultProps;
          for (he in kn)
            Ae[he] === void 0 && (Ae[he] = kn[he]);
        }
        if (yt || Fe) {
          var jn = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          yt && la(Ae, jn), Fe && oo(Ae, jn);
        }
        return Me(A, yt, Fe, ht, Ft, V.current, Ae);
      }
      function $t(A, G) {
        var ae = Me(A.type, G, A.ref, A._self, A._source, A._owner, A.props);
        return ae;
      }
      function un(A, G, ae) {
        if (A == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + A + ".");
        var he, Ae = ke({}, A.props), yt = A.key, Fe = A.ref, ht = A._self, Ft = A._source, tn = A._owner;
        if (G != null) {
          Ta(G) && (Fe = G.ref, tn = V.current), Gn(G) && (Vn(G.key), yt = "" + G.key);
          var Sn;
          A.type && A.type.defaultProps && (Sn = A.type.defaultProps);
          for (he in G)
            ar.call(G, he) && !Ca.hasOwnProperty(he) && (G[he] === void 0 && Sn !== void 0 ? Ae[he] = Sn[he] : Ae[he] = G[he]);
        }
        var vn = arguments.length - 2;
        if (vn === 1)
          Ae.children = ae;
        else if (vn > 1) {
          for (var kn = Array(vn), jn = 0; jn < vn; jn++)
            kn[jn] = arguments[jn + 2];
          Ae.children = kn;
        }
        return Me(A.type, yt, Fe, ht, Ft, tn, Ae);
      }
      function cn(A) {
        return typeof A == "object" && A !== null && A.$$typeof === o;
      }
      var ir = ".", qn = ":";
      function Kr(A) {
        var G = /[=:]/g, ae = {
          "=": "=0",
          ":": "=2"
        }, he = A.replace(G, function(Ae) {
          return ae[Ae];
        });
        return "$" + he;
      }
      var yn = !1, ca = /\/+/g;
      function dn(A) {
        return A.replace(ca, "$&/");
      }
      function fn(A, G) {
        return typeof A == "object" && A !== null && A.key != null ? (Vn(A.key), Kr("" + A.key)) : G.toString(36);
      }
      function Bi(A, G, ae, he, Ae) {
        var yt = typeof A;
        (yt === "undefined" || yt === "boolean") && (A = null);
        var Fe = !1;
        if (A === null)
          Fe = !0;
        else
          switch (yt) {
            case "string":
            case "number":
              Fe = !0;
              break;
            case "object":
              switch (A.$$typeof) {
                case o:
                case l:
                  Fe = !0;
              }
          }
        if (Fe) {
          var ht = A, Ft = Ae(ht), tn = he === "" ? ir + fn(ht, 0) : he;
          if (Vt(Ft)) {
            var Sn = "";
            tn != null && (Sn = dn(tn) + "/"), Bi(Ft, G, Sn, "", function(Mm) {
              return Mm;
            });
          } else
            Ft != null && (cn(Ft) && (Ft.key && (!ht || ht.key !== Ft.key) && Vn(Ft.key), Ft = $t(
              Ft,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              ae + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (Ft.key && (!ht || ht.key !== Ft.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                dn("" + Ft.key) + "/"
              ) : "") + tn
            )), G.push(Ft));
          return 1;
        }
        var vn, kn, jn = 0, Wt = he === "" ? ir : he + qn;
        if (Vt(A))
          for (var Go = 0; Go < A.length; Go++)
            vn = A[Go], kn = Wt + fn(vn, Go), jn += Bi(vn, G, ae, kn, Ae);
        else {
          var rc = N(A);
          if (typeof rc == "function") {
            var Od = A;
            rc === Od.entries && (yn || ge("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), yn = !0);
            for (var Im = rc.call(Od), Gi, Pd = 0; !(Gi = Im.next()).done; )
              vn = Gi.value, kn = Wt + fn(vn, Pd++), jn += Bi(vn, G, ae, kn, Ae);
          } else if (yt === "object") {
            var jd = String(A);
            throw new Error("Objects are not valid as a React child (found: " + (jd === "[object Object]" ? "object with keys {" + Object.keys(A).join(", ") + "}" : jd) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return jn;
      }
      function hi(A, G, ae) {
        if (A == null)
          return A;
        var he = [], Ae = 0;
        return Bi(A, he, "", "", function(yt) {
          return G.call(ae, yt, Ae++);
        }), he;
      }
      function As(A) {
        var G = 0;
        return hi(A, function() {
          G++;
        }), G;
      }
      function Mu(A, G, ae) {
        hi(A, function() {
          G.apply(this, arguments);
        }, ae);
      }
      function Gl(A) {
        return hi(A, function(G) {
          return G;
        }) || [];
      }
      function Uo(A) {
        if (!cn(A))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return A;
      }
      function Ds(A) {
        var G = {
          $$typeof: w,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: A,
          _currentValue2: A,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        G.Provider = {
          $$typeof: v,
          _context: G
        };
        var ae = !1, he = !1, Ae = !1;
        {
          var yt = {
            $$typeof: w,
            _context: G
          };
          Object.defineProperties(yt, {
            Provider: {
              get: function() {
                return he || (he = !0, de("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), G.Provider;
              },
              set: function(Fe) {
                G.Provider = Fe;
              }
            },
            _currentValue: {
              get: function() {
                return G._currentValue;
              },
              set: function(Fe) {
                G._currentValue = Fe;
              }
            },
            _currentValue2: {
              get: function() {
                return G._currentValue2;
              },
              set: function(Fe) {
                G._currentValue2 = Fe;
              }
            },
            _threadCount: {
              get: function() {
                return G._threadCount;
              },
              set: function(Fe) {
                G._threadCount = Fe;
              }
            },
            Consumer: {
              get: function() {
                return ae || (ae = !0, de("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), G.Consumer;
              }
            },
            displayName: {
              get: function() {
                return G.displayName;
              },
              set: function(Fe) {
                Ae || (ge("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Fe), Ae = !0);
              }
            }
          }), G.Consumer = yt;
        }
        return G._currentRenderer = null, G._currentRenderer2 = null, G;
      }
      var Ya = -1, so = 0, Za = 1, uo = 2;
      function da(A) {
        if (A._status === Ya) {
          var G = A._result, ae = G();
          if (ae.then(function(yt) {
            if (A._status === so || A._status === Ya) {
              var Fe = A;
              Fe._status = Za, Fe._result = yt;
            }
          }, function(yt) {
            if (A._status === so || A._status === Ya) {
              var Fe = A;
              Fe._status = uo, Fe._result = yt;
            }
          }), A._status === Ya) {
            var he = A;
            he._status = so, he._result = ae;
          }
        }
        if (A._status === Za) {
          var Ae = A._result;
          return Ae === void 0 && de(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Ae), "default" in Ae || de(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Ae), Ae.default;
        } else
          throw A._result;
      }
      function Ka(A) {
        var G = {
          // We use these fields to store the result.
          _status: Ya,
          _result: A
        }, ae = {
          $$typeof: O,
          _payload: G,
          _init: da
        };
        {
          var he, Ae;
          Object.defineProperties(ae, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return he;
              },
              set: function(yt) {
                de("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), he = yt, Object.defineProperty(ae, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Ae;
              },
              set: function(yt) {
                de("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Ae = yt, Object.defineProperty(ae, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return ae;
      }
      function lo(A) {
        A != null && A.$$typeof === T ? de("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof A != "function" ? de("forwardRef requires a render function but was given %s.", A === null ? "null" : typeof A) : A.length !== 0 && A.length !== 2 && de("forwardRef render functions accept exactly two parameters: props and ref. %s", A.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), A != null && (A.defaultProps != null || A.propTypes != null) && de("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var G = {
          $$typeof: x,
          render: A
        };
        {
          var ae;
          Object.defineProperty(G, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return ae;
            },
            set: function(he) {
              ae = he, !A.name && !A.displayName && (A.displayName = he);
            }
          });
        }
        return G;
      }
      var q;
      q = Symbol.for("react.module.reference");
      function Ce(A) {
        return !!(typeof A == "string" || typeof A == "function" || A === d || A === m || Pe || A === f || A === b || A === k || Re || A === R || ve || Se || De || typeof A == "object" && A !== null && (A.$$typeof === O || A.$$typeof === T || A.$$typeof === v || A.$$typeof === w || A.$$typeof === x || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        A.$$typeof === q || A.getModuleId !== void 0));
      }
      function $e(A, G) {
        Ce(A) || de("memo: The first argument must be a component. Instead received: %s", A === null ? "null" : typeof A);
        var ae = {
          $$typeof: T,
          type: A,
          compare: G === void 0 ? null : G
        };
        {
          var he;
          Object.defineProperty(ae, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return he;
            },
            set: function(Ae) {
              he = Ae, !A.name && !A.displayName && (A.displayName = Ae);
            }
          });
        }
        return ae;
      }
      function Ge() {
        var A = L.current;
        return A === null && de(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), A;
      }
      function At(A) {
        var G = Ge();
        if (A._context !== void 0) {
          var ae = A._context;
          ae.Consumer === A ? de("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : ae.Provider === A && de("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return G.useContext(A);
      }
      function Yt(A) {
        var G = Ge();
        return G.useState(A);
      }
      function Dt(A, G, ae) {
        var he = Ge();
        return he.useReducer(A, G, ae);
      }
      function dt(A) {
        var G = Ge();
        return G.useRef(A);
      }
      function dr(A, G) {
        var ae = Ge();
        return ae.useEffect(A, G);
      }
      function On(A, G) {
        var ae = Ge();
        return ae.useInsertionEffect(A, G);
      }
      function Pn(A, G) {
        var ae = Ge();
        return ae.useLayoutEffect(A, G);
      }
      function Mr(A, G) {
        var ae = Ge();
        return ae.useCallback(A, G);
      }
      function co(A, G) {
        var ae = Ge();
        return ae.useMemo(A, G);
      }
      function ql(A, G, ae) {
        var he = Ge();
        return he.useImperativeHandle(A, G, ae);
      }
      function Jt(A, G) {
        {
          var ae = Ge();
          return ae.useDebugValue(A, G);
        }
      }
      function Am() {
        var A = Ge();
        return A.useTransition();
      }
      function Ui(A) {
        var G = Ge();
        return G.useDeferredValue(A);
      }
      function Nt() {
        var A = Ge();
        return A.useId();
      }
      function fo(A, G, ae) {
        var he = Ge();
        return he.useSyncExternalStore(A, G, ae);
      }
      var Is = 0, Wl, Ms, _a, Cd, fa, Td, _d;
      function rp() {
      }
      rp.__reactDisabledLog = !0;
      function Yl() {
        {
          if (Is === 0) {
            Wl = console.log, Ms = console.info, _a = console.warn, Cd = console.error, fa = console.group, Td = console.groupCollapsed, _d = console.groupEnd;
            var A = {
              configurable: !0,
              enumerable: !0,
              value: rp,
              writable: !0
            };
            Object.defineProperties(console, {
              info: A,
              log: A,
              warn: A,
              error: A,
              group: A,
              groupCollapsed: A,
              groupEnd: A
            });
          }
          Is++;
        }
      }
      function $s() {
        {
          if (Is--, Is === 0) {
            var A = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: ke({}, A, {
                value: Wl
              }),
              info: ke({}, A, {
                value: Ms
              }),
              warn: ke({}, A, {
                value: _a
              }),
              error: ke({}, A, {
                value: Cd
              }),
              group: ke({}, A, {
                value: fa
              }),
              groupCollapsed: ke({}, A, {
                value: Td
              }),
              groupEnd: ke({}, A, {
                value: _d
              })
            });
          }
          Is < 0 && de("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Hi = se.ReactCurrentDispatcher, pa;
      function Ls(A, G, ae) {
        {
          if (pa === void 0)
            try {
              throw Error();
            } catch (Ae) {
              var he = Ae.stack.trim().match(/\n( *(at )?)/);
              pa = he && he[1] || "";
            }
          return `
` + pa + A;
        }
      }
      var Ns = !1, Fs;
      {
        var Zl = typeof WeakMap == "function" ? WeakMap : Map;
        Fs = new Zl();
      }
      function Kl(A, G) {
        if (!A || Ns)
          return "";
        {
          var ae = Fs.get(A);
          if (ae !== void 0)
            return ae;
        }
        var he;
        Ns = !0;
        var Ae = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var yt;
        yt = Hi.current, Hi.current = null, Yl();
        try {
          if (G) {
            var Fe = function() {
              throw Error();
            };
            if (Object.defineProperty(Fe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Fe, []);
              } catch (Wt) {
                he = Wt;
              }
              Reflect.construct(A, [], Fe);
            } else {
              try {
                Fe.call();
              } catch (Wt) {
                he = Wt;
              }
              A.call(Fe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Wt) {
              he = Wt;
            }
            A();
          }
        } catch (Wt) {
          if (Wt && he && typeof Wt.stack == "string") {
            for (var ht = Wt.stack.split(`
`), Ft = he.stack.split(`
`), tn = ht.length - 1, Sn = Ft.length - 1; tn >= 1 && Sn >= 0 && ht[tn] !== Ft[Sn]; )
              Sn--;
            for (; tn >= 1 && Sn >= 0; tn--, Sn--)
              if (ht[tn] !== Ft[Sn]) {
                if (tn !== 1 || Sn !== 1)
                  do
                    if (tn--, Sn--, Sn < 0 || ht[tn] !== Ft[Sn]) {
                      var vn = `
` + ht[tn].replace(" at new ", " at ");
                      return A.displayName && vn.includes("<anonymous>") && (vn = vn.replace("<anonymous>", A.displayName)), typeof A == "function" && Fs.set(A, vn), vn;
                    }
                  while (tn >= 1 && Sn >= 0);
                break;
              }
          }
        } finally {
          Ns = !1, Hi.current = yt, $s(), Error.prepareStackTrace = Ae;
        }
        var kn = A ? A.displayName || A.name : "", jn = kn ? Ls(kn) : "";
        return typeof A == "function" && Fs.set(A, jn), jn;
      }
      function Ho(A, G, ae) {
        return Kl(A, !1);
      }
      function Dm(A) {
        var G = A.prototype;
        return !!(G && G.isReactComponent);
      }
      function po(A, G, ae) {
        if (A == null)
          return "";
        if (typeof A == "function")
          return Kl(A, Dm(A));
        if (typeof A == "string")
          return Ls(A);
        switch (A) {
          case b:
            return Ls("Suspense");
          case k:
            return Ls("SuspenseList");
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case x:
              return Ho(A.render);
            case T:
              return po(A.type, G, ae);
            case O: {
              var he = A, Ae = he._payload, yt = he._init;
              try {
                return po(yt(Ae), G, ae);
              } catch {
              }
            }
          }
        return "";
      }
      var rn = {}, Ql = se.ReactDebugCurrentFrame;
      function $u(A) {
        if (A) {
          var G = A._owner, ae = po(A.type, A._source, G ? G.type : null);
          Ql.setExtraStackFrame(ae);
        } else
          Ql.setExtraStackFrame(null);
      }
      function Xl(A, G, ae, he, Ae) {
        {
          var yt = Function.call.bind(ar);
          for (var Fe in A)
            if (yt(A, Fe)) {
              var ht = void 0;
              try {
                if (typeof A[Fe] != "function") {
                  var Ft = Error((he || "React class") + ": " + ae + " type `" + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[Fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ft.name = "Invariant Violation", Ft;
                }
                ht = A[Fe](G, Fe, he, ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (tn) {
                ht = tn;
              }
              ht && !(ht instanceof Error) && ($u(Ae), de("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", he || "React class", ae, Fe, typeof ht), $u(null)), ht instanceof Error && !(ht.message in rn) && (rn[ht.message] = !0, $u(Ae), de("Failed %s type: %s", ae, ht.message), $u(null));
            }
        }
      }
      function en(A) {
        if (A) {
          var G = A._owner, ae = po(A.type, A._source, G ? G.type : null);
          ce(ae);
        } else
          ce(null);
      }
      var Jl;
      Jl = !1;
      function ec() {
        if (V.current) {
          var A = cr(V.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
      function _t(A) {
        if (A !== void 0) {
          var G = A.fileName.replace(/^.*[\\\/]/, ""), ae = A.lineNumber;
          return `

Check your code at ` + G + ":" + ae + ".";
        }
        return "";
      }
      function Lu(A) {
        return A != null ? _t(A.__source) : "";
      }
      var Wn = {};
      function Ra(A) {
        var G = ec();
        if (!G) {
          var ae = typeof A == "string" ? A : A.displayName || A.name;
          ae && (G = `

Check the top-level render call using <` + ae + ">.");
        }
        return G;
      }
      function ha(A, G) {
        if (!(!A._store || A._store.validated || A.key != null)) {
          A._store.validated = !0;
          var ae = Ra(G);
          if (!Wn[ae]) {
            Wn[ae] = !0;
            var he = "";
            A && A._owner && A._owner !== V.current && (he = " It was passed a child from " + cr(A._owner.type) + "."), en(A), de('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ae, he), en(null);
          }
        }
      }
      function zs(A, G) {
        if (typeof A == "object") {
          if (Vt(A))
            for (var ae = 0; ae < A.length; ae++) {
              var he = A[ae];
              cn(he) && ha(he, G);
            }
          else if (cn(A))
            A._store && (A._store.validated = !0);
          else if (A) {
            var Ae = N(A);
            if (typeof Ae == "function" && Ae !== A.entries)
              for (var yt = Ae.call(A), Fe; !(Fe = yt.next()).done; )
                cn(Fe.value) && ha(Fe.value, G);
          }
        }
      }
      function Jn(A) {
        {
          var G = A.type;
          if (G == null || typeof G == "string")
            return;
          var ae;
          if (typeof G == "function")
            ae = G.propTypes;
          else if (typeof G == "object" && (G.$$typeof === x || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          G.$$typeof === T))
            ae = G.propTypes;
          else
            return;
          if (ae) {
            var he = cr(G);
            Xl(ae, A.props, "prop", he, A);
          } else if (G.PropTypes !== void 0 && !Jl) {
            Jl = !0;
            var Ae = cr(G);
            de("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ae || "Unknown");
          }
          typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && de("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function pn(A) {
        {
          for (var G = Object.keys(A.props), ae = 0; ae < G.length; ae++) {
            var he = G[ae];
            if (he !== "children" && he !== "key") {
              en(A), de("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", he), en(null);
              break;
            }
          }
          A.ref !== null && (en(A), de("Invalid attribute `ref` supplied to `React.Fragment`."), en(null));
        }
      }
      function ap(A, G, ae) {
        var he = Ce(A);
        if (!he) {
          var Ae = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (Ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yt = Lu(G);
          yt ? Ae += yt : Ae += ec();
          var Fe;
          A === null ? Fe = "null" : Vt(A) ? Fe = "array" : A !== void 0 && A.$$typeof === o ? (Fe = "<" + (cr(A.type) || "Unknown") + " />", Ae = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof A, de("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, Ae);
        }
        var ht = ot.apply(this, arguments);
        if (ht == null)
          return ht;
        if (he)
          for (var Ft = 2; Ft < arguments.length; Ft++)
            zs(arguments[Ft], A);
        return A === d ? pn(ht) : Jn(ht), ht;
      }
      var Oa = !1;
      function Tr(A) {
        var G = ap.bind(null, A);
        return G.type = A, Oa || (Oa = !0, ge("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(G, "type", {
          enumerable: !1,
          get: function() {
            return ge("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: A
            }), A;
          }
        }), G;
      }
      function ho(A, G, ae) {
        for (var he = un.apply(this, arguments), Ae = 2; Ae < arguments.length; Ae++)
          zs(arguments[Ae], he.type);
        return Jn(he), he;
      }
      function ip(A, G) {
        var ae = B.transition;
        B.transition = {};
        var he = B.transition;
        B.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          A();
        } finally {
          if (B.transition = ae, ae === null && he._updatedFibers) {
            var Ae = he._updatedFibers.size;
            Ae > 10 && ge("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), he._updatedFibers.clear();
          }
        }
      }
      var Vo = !1, Bs = null;
      function op(A) {
        if (Bs === null)
          try {
            var G = ("require" + Math.random()).slice(0, 7), ae = e && e[G];
            Bs = ae.call(e, "timers").setImmediate;
          } catch {
            Bs = function(Ae) {
              Vo === !1 && (Vo = !0, typeof MessageChannel > "u" && de("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var yt = new MessageChannel();
              yt.port1.onmessage = Ae, yt.port2.postMessage(void 0);
            };
          }
        return Bs(A);
      }
      var mi = 0, Us = !1;
      function Hs(A) {
        {
          var G = mi;
          mi++, H.current === null && (H.current = []);
          var ae = H.isBatchingLegacy, he;
          try {
            if (H.isBatchingLegacy = !0, he = A(), !ae && H.didScheduleLegacyUpdate) {
              var Ae = H.current;
              Ae !== null && (H.didScheduleLegacyUpdate = !1, Gs(Ae));
            }
          } catch (kn) {
            throw yi(G), kn;
          } finally {
            H.isBatchingLegacy = ae;
          }
          if (he !== null && typeof he == "object" && typeof he.then == "function") {
            var yt = he, Fe = !1, ht = {
              then: function(kn, jn) {
                Fe = !0, yt.then(function(Wt) {
                  yi(G), mi === 0 ? tc(Wt, kn, jn) : kn(Wt);
                }, function(Wt) {
                  yi(G), jn(Wt);
                });
              }
            };
            return !Us && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              Fe || (Us = !0, de("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), ht;
          } else {
            var Ft = he;
            if (yi(G), mi === 0) {
              var tn = H.current;
              tn !== null && (Gs(tn), H.current = null);
              var Sn = {
                then: function(kn, jn) {
                  H.current === null ? (H.current = [], tc(Ft, kn, jn)) : kn(Ft);
                }
              };
              return Sn;
            } else {
              var vn = {
                then: function(kn, jn) {
                  kn(Ft);
                }
              };
              return vn;
            }
          }
        }
      }
      function yi(A) {
        A !== mi - 1 && de("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), mi = A;
      }
      function tc(A, G, ae) {
        {
          var he = H.current;
          if (he !== null)
            try {
              Gs(he), op(function() {
                he.length === 0 ? (H.current = null, G(A)) : tc(A, G, ae);
              });
            } catch (Ae) {
              ae(Ae);
            }
          else
            G(A);
        }
      }
      var Vs = !1;
      function Gs(A) {
        if (!Vs) {
          Vs = !0;
          var G = 0;
          try {
            for (; G < A.length; G++) {
              var ae = A[G];
              do
                ae = ae(!0);
              while (ae !== null);
            }
            A.length = 0;
          } catch (he) {
            throw A = A.slice(G + 1), he;
          } finally {
            Vs = !1;
          }
        }
      }
      var Nu = ap, nc = ho, Rd = Tr, Vi = {
        map: hi,
        forEach: Mu,
        count: As,
        toArray: Gl,
        only: Uo
      };
      t.Children = Vi, t.Component = Xe, t.Fragment = d, t.Profiler = m, t.PureComponent = pt, t.StrictMode = f, t.Suspense = b, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = se, t.cloneElement = nc, t.createContext = Ds, t.createElement = Nu, t.createFactory = Rd, t.createRef = rr, t.forwardRef = lo, t.isValidElement = cn, t.lazy = Ka, t.memo = $e, t.startTransition = ip, t.unstable_act = Hs, t.useCallback = Mr, t.useContext = At, t.useDebugValue = Jt, t.useDeferredValue = Ui, t.useEffect = dr, t.useId = Nt, t.useImperativeHandle = ql, t.useInsertionEffect = On, t.useLayoutEffect = Pn, t.useMemo = co, t.useReducer = Dt, t.useRef = dt, t.useState = Yt, t.useSyncExternalStore = fo, t.useTransition = Am, t.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Zv, Zv.exports)), Zv.exports;
}
process.env.NODE_ENV === "production" ? XE.exports = OL() : XE.exports = PL();
var $ = XE.exports;
const jo = /* @__PURE__ */ km($), Vj = /* @__PURE__ */ RL({
  __proto__: null,
  default: jo
}, [$]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $O;
function jL() {
  if ($O)
    return Bv;
  $O = 1;
  var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, l = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(m, v, w) {
    var x, b = {}, k = null, T = null;
    w !== void 0 && (k = "" + w), v.key !== void 0 && (k = "" + v.key), v.ref !== void 0 && (T = v.ref);
    for (x in v)
      o.call(v, x) && !d.hasOwnProperty(x) && (b[x] = v[x]);
    if (m && m.defaultProps)
      for (x in v = m.defaultProps, v)
        b[x] === void 0 && (b[x] = v[x]);
    return { $$typeof: t, type: m, key: k, ref: T, props: b, _owner: l.current };
  }
  return Bv.Fragment = r, Bv.jsx = f, Bv.jsxs = f, Bv;
}
var Uv = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LO;
function AL() {
  return LO || (LO = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), m = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), O = Symbol.iterator, R = "@@iterator";
    function j(q) {
      if (q === null || typeof q != "object")
        return null;
      var Ce = O && q[O] || q[R];
      return typeof Ce == "function" ? Ce : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function N(q) {
      {
        for (var Ce = arguments.length, $e = new Array(Ce > 1 ? Ce - 1 : 0), Ge = 1; Ge < Ce; Ge++)
          $e[Ge - 1] = arguments[Ge];
        L("error", q, $e);
      }
    }
    function L(q, Ce, $e) {
      {
        var Ge = I.ReactDebugCurrentFrame, At = Ge.getStackAddendum();
        At !== "" && (Ce += "%s", $e = $e.concat([At]));
        var Yt = $e.map(function(Dt) {
          return String(Dt);
        });
        Yt.unshift("Warning: " + Ce), Function.prototype.apply.call(console[q], console, Yt);
      }
    }
    var B = !1, H = !1, V = !1, W = !1, Y = !1, ce;
    ce = Symbol.for("react.module.reference");
    function ve(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === o || q === d || Y || q === l || q === w || q === x || W || q === T || B || H || V || typeof q == "object" && q !== null && (q.$$typeof === k || q.$$typeof === b || q.$$typeof === f || q.$$typeof === m || q.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === ce || q.getModuleId !== void 0));
    }
    function Se(q, Ce, $e) {
      var Ge = q.displayName;
      if (Ge)
        return Ge;
      var At = Ce.displayName || Ce.name || "";
      return At !== "" ? $e + "(" + At + ")" : $e;
    }
    function De(q) {
      return q.displayName || "Context";
    }
    function Re(q) {
      if (q == null)
        return null;
      if (typeof q.tag == "number" && N("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof q == "function")
        return q.displayName || q.name || null;
      if (typeof q == "string")
        return q;
      switch (q) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case d:
          return "Profiler";
        case l:
          return "StrictMode";
        case w:
          return "Suspense";
        case x:
          return "SuspenseList";
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case m:
            var Ce = q;
            return De(Ce) + ".Consumer";
          case f:
            var $e = q;
            return De($e._context) + ".Provider";
          case v:
            return Se(q, q.render, "ForwardRef");
          case b:
            var Ge = q.displayName || null;
            return Ge !== null ? Ge : Re(q.type) || "Memo";
          case k: {
            var At = q, Yt = At._payload, Dt = At._init;
            try {
              return Re(Dt(Yt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Pe = Object.assign, se = 0, ge, de, pe, fe, z, oe, ke;
    function Qe() {
    }
    Qe.__reactDisabledLog = !0;
    function Xe() {
      {
        if (se === 0) {
          ge = console.log, de = console.info, pe = console.warn, fe = console.error, z = console.group, oe = console.groupCollapsed, ke = console.groupEnd;
          var q = {
            configurable: !0,
            enumerable: !0,
            value: Qe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: q,
            log: q,
            warn: q,
            error: q,
            group: q,
            groupCollapsed: q,
            groupEnd: q
          });
        }
        se++;
      }
    }
    function bt() {
      {
        if (se--, se === 0) {
          var q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Pe({}, q, {
              value: ge
            }),
            info: Pe({}, q, {
              value: de
            }),
            warn: Pe({}, q, {
              value: pe
            }),
            error: Pe({}, q, {
              value: fe
            }),
            group: Pe({}, q, {
              value: z
            }),
            groupCollapsed: Pe({}, q, {
              value: oe
            }),
            groupEnd: Pe({}, q, {
              value: ke
            })
          });
        }
        se < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var at = I.ReactCurrentDispatcher, ut;
    function wt(q, Ce, $e) {
      {
        if (ut === void 0)
          try {
            throw Error();
          } catch (At) {
            var Ge = At.stack.trim().match(/\n( *(at )?)/);
            ut = Ge && Ge[1] || "";
          }
        return `
` + ut + q;
      }
    }
    var pt = !1, Rn;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      Rn = new rr();
    }
    function Hn(q, Ce) {
      if (!q || pt)
        return "";
      {
        var $e = Rn.get(q);
        if ($e !== void 0)
          return $e;
      }
      var Ge;
      pt = !0;
      var At = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Yt;
      Yt = at.current, at.current = null, Xe();
      try {
        if (Ce) {
          var Dt = function() {
            throw Error();
          };
          if (Object.defineProperty(Dt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Dt, []);
            } catch (Jt) {
              Ge = Jt;
            }
            Reflect.construct(q, [], Dt);
          } else {
            try {
              Dt.call();
            } catch (Jt) {
              Ge = Jt;
            }
            q.call(Dt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Jt) {
            Ge = Jt;
          }
          q();
        }
      } catch (Jt) {
        if (Jt && Ge && typeof Jt.stack == "string") {
          for (var dt = Jt.stack.split(`
`), dr = Ge.stack.split(`
`), On = dt.length - 1, Pn = dr.length - 1; On >= 1 && Pn >= 0 && dt[On] !== dr[Pn]; )
            Pn--;
          for (; On >= 1 && Pn >= 0; On--, Pn--)
            if (dt[On] !== dr[Pn]) {
              if (On !== 1 || Pn !== 1)
                do
                  if (On--, Pn--, Pn < 0 || dt[On] !== dr[Pn]) {
                    var Mr = `
` + dt[On].replace(" at new ", " at ");
                    return q.displayName && Mr.includes("<anonymous>") && (Mr = Mr.replace("<anonymous>", q.displayName)), typeof q == "function" && Rn.set(q, Mr), Mr;
                  }
                while (On >= 1 && Pn >= 0);
              break;
            }
        }
      } finally {
        pt = !1, at.current = Yt, bt(), Error.prepareStackTrace = At;
      }
      var co = q ? q.displayName || q.name : "", ql = co ? wt(co) : "";
      return typeof q == "function" && Rn.set(q, ql), ql;
    }
    function Vt(q, Ce, $e) {
      return Hn(q, !1);
    }
    function xn(q) {
      var Ce = q.prototype;
      return !!(Ce && Ce.isReactComponent);
    }
    function gn(q, Ce, $e) {
      if (q == null)
        return "";
      if (typeof q == "function")
        return Hn(q, xn(q));
      if (typeof q == "string")
        return wt(q);
      switch (q) {
        case w:
          return wt("Suspense");
        case x:
          return wt("SuspenseList");
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case v:
            return Vt(q.render);
          case b:
            return gn(q.type, Ce, $e);
          case k: {
            var Ge = q, At = Ge._payload, Yt = Ge._init;
            try {
              return gn(Yt(At), Ce, $e);
            } catch {
            }
          }
        }
      return "";
    }
    var An = Object.prototype.hasOwnProperty, Vn = {}, Wr = I.ReactDebugCurrentFrame;
    function Yr(q) {
      if (q) {
        var Ce = q._owner, $e = gn(q.type, q._source, Ce ? Ce.type : null);
        Wr.setExtraStackFrame($e);
      } else
        Wr.setExtraStackFrame(null);
    }
    function cr(q, Ce, $e, Ge, At) {
      {
        var Yt = Function.call.bind(An);
        for (var Dt in q)
          if (Yt(q, Dt)) {
            var dt = void 0;
            try {
              if (typeof q[Dt] != "function") {
                var dr = Error((Ge || "React class") + ": " + $e + " type `" + Dt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof q[Dt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dr.name = "Invariant Violation", dr;
              }
              dt = q[Dt](Ce, Dt, Ge, $e, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (On) {
              dt = On;
            }
            dt && !(dt instanceof Error) && (Yr(At), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ge || "React class", $e, Dt, typeof dt), Yr(null)), dt instanceof Error && !(dt.message in Vn) && (Vn[dt.message] = !0, Yr(At), N("Failed %s type: %s", $e, dt.message), Yr(null));
          }
      }
    }
    var ar = Array.isArray;
    function Ca(q) {
      return ar(q);
    }
    function Zr(q) {
      {
        var Ce = typeof Symbol == "function" && Symbol.toStringTag, $e = Ce && q[Symbol.toStringTag] || q.constructor.name || "Object";
        return $e;
      }
    }
    function qa(q) {
      try {
        return Ir(q), !1;
      } catch {
        return !0;
      }
    }
    function Ir(q) {
      return "" + q;
    }
    function Ta(q) {
      if (qa(q))
        return N("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Zr(q)), Ir(q);
    }
    var Gn = I.ReactCurrentOwner, la = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, oo, Wa, Me;
    Me = {};
    function ot(q) {
      if (An.call(q, "ref")) {
        var Ce = Object.getOwnPropertyDescriptor(q, "ref").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return q.ref !== void 0;
    }
    function $t(q) {
      if (An.call(q, "key")) {
        var Ce = Object.getOwnPropertyDescriptor(q, "key").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return q.key !== void 0;
    }
    function un(q, Ce) {
      if (typeof q.ref == "string" && Gn.current && Ce && Gn.current.stateNode !== Ce) {
        var $e = Re(Gn.current.type);
        Me[$e] || (N('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Re(Gn.current.type), q.ref), Me[$e] = !0);
      }
    }
    function cn(q, Ce) {
      {
        var $e = function() {
          oo || (oo = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        $e.isReactWarning = !0, Object.defineProperty(q, "key", {
          get: $e,
          configurable: !0
        });
      }
    }
    function ir(q, Ce) {
      {
        var $e = function() {
          Wa || (Wa = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        $e.isReactWarning = !0, Object.defineProperty(q, "ref", {
          get: $e,
          configurable: !0
        });
      }
    }
    var qn = function(q, Ce, $e, Ge, At, Yt, Dt) {
      var dt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: q,
        key: Ce,
        ref: $e,
        props: Dt,
        // Record the component responsible for creating this element.
        _owner: Yt
      };
      return dt._store = {}, Object.defineProperty(dt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(dt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ge
      }), Object.defineProperty(dt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: At
      }), Object.freeze && (Object.freeze(dt.props), Object.freeze(dt)), dt;
    };
    function Kr(q, Ce, $e, Ge, At) {
      {
        var Yt, Dt = {}, dt = null, dr = null;
        $e !== void 0 && (Ta($e), dt = "" + $e), $t(Ce) && (Ta(Ce.key), dt = "" + Ce.key), ot(Ce) && (dr = Ce.ref, un(Ce, At));
        for (Yt in Ce)
          An.call(Ce, Yt) && !la.hasOwnProperty(Yt) && (Dt[Yt] = Ce[Yt]);
        if (q && q.defaultProps) {
          var On = q.defaultProps;
          for (Yt in On)
            Dt[Yt] === void 0 && (Dt[Yt] = On[Yt]);
        }
        if (dt || dr) {
          var Pn = typeof q == "function" ? q.displayName || q.name || "Unknown" : q;
          dt && cn(Dt, Pn), dr && ir(Dt, Pn);
        }
        return qn(q, dt, dr, At, Ge, Gn.current, Dt);
      }
    }
    var yn = I.ReactCurrentOwner, ca = I.ReactDebugCurrentFrame;
    function dn(q) {
      if (q) {
        var Ce = q._owner, $e = gn(q.type, q._source, Ce ? Ce.type : null);
        ca.setExtraStackFrame($e);
      } else
        ca.setExtraStackFrame(null);
    }
    var fn;
    fn = !1;
    function Bi(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function hi() {
      {
        if (yn.current) {
          var q = Re(yn.current.type);
          if (q)
            return `

Check the render method of \`` + q + "`.";
        }
        return "";
      }
    }
    function As(q) {
      {
        if (q !== void 0) {
          var Ce = q.fileName.replace(/^.*[\\\/]/, ""), $e = q.lineNumber;
          return `

Check your code at ` + Ce + ":" + $e + ".";
        }
        return "";
      }
    }
    var Mu = {};
    function Gl(q) {
      {
        var Ce = hi();
        if (!Ce) {
          var $e = typeof q == "string" ? q : q.displayName || q.name;
          $e && (Ce = `

Check the top-level render call using <` + $e + ">.");
        }
        return Ce;
      }
    }
    function Uo(q, Ce) {
      {
        if (!q._store || q._store.validated || q.key != null)
          return;
        q._store.validated = !0;
        var $e = Gl(Ce);
        if (Mu[$e])
          return;
        Mu[$e] = !0;
        var Ge = "";
        q && q._owner && q._owner !== yn.current && (Ge = " It was passed a child from " + Re(q._owner.type) + "."), dn(q), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $e, Ge), dn(null);
      }
    }
    function Ds(q, Ce) {
      {
        if (typeof q != "object")
          return;
        if (Ca(q))
          for (var $e = 0; $e < q.length; $e++) {
            var Ge = q[$e];
            Bi(Ge) && Uo(Ge, Ce);
          }
        else if (Bi(q))
          q._store && (q._store.validated = !0);
        else if (q) {
          var At = j(q);
          if (typeof At == "function" && At !== q.entries)
            for (var Yt = At.call(q), Dt; !(Dt = Yt.next()).done; )
              Bi(Dt.value) && Uo(Dt.value, Ce);
        }
      }
    }
    function Ya(q) {
      {
        var Ce = q.type;
        if (Ce == null || typeof Ce == "string")
          return;
        var $e;
        if (typeof Ce == "function")
          $e = Ce.propTypes;
        else if (typeof Ce == "object" && (Ce.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ce.$$typeof === b))
          $e = Ce.propTypes;
        else
          return;
        if ($e) {
          var Ge = Re(Ce);
          cr($e, q.props, "prop", Ge, q);
        } else if (Ce.PropTypes !== void 0 && !fn) {
          fn = !0;
          var At = Re(Ce);
          N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", At || "Unknown");
        }
        typeof Ce.getDefaultProps == "function" && !Ce.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function so(q) {
      {
        for (var Ce = Object.keys(q.props), $e = 0; $e < Ce.length; $e++) {
          var Ge = Ce[$e];
          if (Ge !== "children" && Ge !== "key") {
            dn(q), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ge), dn(null);
            break;
          }
        }
        q.ref !== null && (dn(q), N("Invalid attribute `ref` supplied to `React.Fragment`."), dn(null));
      }
    }
    function Za(q, Ce, $e, Ge, At, Yt) {
      {
        var Dt = ve(q);
        if (!Dt) {
          var dt = "";
          (q === void 0 || typeof q == "object" && q !== null && Object.keys(q).length === 0) && (dt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dr = As(At);
          dr ? dt += dr : dt += hi();
          var On;
          q === null ? On = "null" : Ca(q) ? On = "array" : q !== void 0 && q.$$typeof === t ? (On = "<" + (Re(q.type) || "Unknown") + " />", dt = " Did you accidentally export a JSX literal instead of a component?") : On = typeof q, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", On, dt);
        }
        var Pn = Kr(q, Ce, $e, At, Yt);
        if (Pn == null)
          return Pn;
        if (Dt) {
          var Mr = Ce.children;
          if (Mr !== void 0)
            if (Ge)
              if (Ca(Mr)) {
                for (var co = 0; co < Mr.length; co++)
                  Ds(Mr[co], q);
                Object.freeze && Object.freeze(Mr);
              } else
                N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ds(Mr, q);
        }
        return q === o ? so(Pn) : Ya(Pn), Pn;
      }
    }
    function uo(q, Ce, $e) {
      return Za(q, Ce, $e, !0);
    }
    function da(q, Ce, $e) {
      return Za(q, Ce, $e, !1);
    }
    var Ka = da, lo = uo;
    Uv.Fragment = o, Uv.jsx = Ka, Uv.jsxs = lo;
  }()), Uv;
}
process.env.NODE_ENV === "production" ? QE.exports = jL() : QE.exports = AL();
var ze = QE.exports;
const DL = `[data-rk] .iekbcc0{border:0;box-sizing:border-box;font-size:100%;line-height:normal;margin:0;padding:0;text-align:left;vertical-align:baseline;-webkit-tap-highlight-color:transparent}[data-rk] .iekbcc1{list-style:none}[data-rk] .iekbcc2{quotes:none}[data-rk] .iekbcc2:before,[data-rk] .iekbcc2:after{content:""}[data-rk] .iekbcc3{border-collapse:collapse;border-spacing:0}[data-rk] .iekbcc4{-webkit-appearance:none;-moz-appearance:none;appearance:none}[data-rk] .iekbcc5{outline:none}[data-rk] .iekbcc5::-moz-placeholder{opacity:1}[data-rk] .iekbcc5::placeholder{opacity:1}[data-rk] .iekbcc6{background-color:transparent;color:inherit}[data-rk] .iekbcc7:disabled{opacity:1}[data-rk] .iekbcc7::-ms-expand{display:none}[data-rk] .iekbcc8::-ms-clear{display:none}[data-rk] .iekbcc8::-webkit-search-cancel-button{-webkit-appearance:none}[data-rk] .iekbcc9{background:none;cursor:pointer;text-align:left}[data-rk] .iekbcca{color:inherit;text-decoration:none}[data-rk] .ju367v0{align-items:flex-start}[data-rk] .ju367v2{align-items:flex-end}[data-rk] .ju367v4{align-items:center}[data-rk] .ju367v6{display:none}[data-rk] .ju367v8{display:block}[data-rk] .ju367va{display:flex}[data-rk] .ju367vc{display:inline}[data-rk] .ju367ve{align-self:flex-start}[data-rk] .ju367vf{align-self:flex-end}[data-rk] .ju367vg{align-self:center}[data-rk] .ju367vh{background-size:cover}[data-rk] .ju367vi{border-radius:1px}[data-rk] .ju367vj{border-radius:6px}[data-rk] .ju367vk{border-radius:10px}[data-rk] .ju367vl{border-radius:13px}[data-rk] .ju367vm{border-radius:var(--rk-radii-actionButton)}[data-rk] .ju367vn{border-radius:var(--rk-radii-connectButton)}[data-rk] .ju367vo{border-radius:var(--rk-radii-menuButton)}[data-rk] .ju367vp{border-radius:var(--rk-radii-modal)}[data-rk] .ju367vq{border-radius:var(--rk-radii-modalMobile)}[data-rk] .ju367vr{border-radius:25%}[data-rk] .ju367vs{border-radius:9999px}[data-rk] .ju367vt{border-style:solid}[data-rk] .ju367vu{border-width:0px}[data-rk] .ju367vv{border-width:1px}[data-rk] .ju367vw{border-width:2px}[data-rk] .ju367vx{border-width:4px}[data-rk] .ju367vy{cursor:pointer}[data-rk] .ju367vz{cursor:none}[data-rk] .ju367v10{pointer-events:none}[data-rk] .ju367v11{pointer-events:all}[data-rk] .ju367v12{min-height:8px}[data-rk] .ju367v13{min-height:44px}[data-rk] .ju367v14{flex-direction:row}[data-rk] .ju367v15{flex-direction:column}[data-rk] .ju367v16{font-family:var(--rk-fonts-body)}[data-rk] .ju367v17{font-size:12px;line-height:18px}[data-rk] .ju367v18{font-size:13px;line-height:18px}[data-rk] .ju367v19{font-size:14px;line-height:18px}[data-rk] .ju367v1a{font-size:16px;line-height:20px}[data-rk] .ju367v1b{font-size:18px;line-height:24px}[data-rk] .ju367v1c{font-size:20px;line-height:24px}[data-rk] .ju367v1d{font-size:23px;line-height:29px}[data-rk] .ju367v1e{font-weight:400}[data-rk] .ju367v1f{font-weight:500}[data-rk] .ju367v1g{font-weight:600}[data-rk] .ju367v1h{font-weight:700}[data-rk] .ju367v1i{font-weight:800}[data-rk] .ju367v1j{gap:0}[data-rk] .ju367v1k{gap:1px}[data-rk] .ju367v1l{gap:2px}[data-rk] .ju367v1m{gap:3px}[data-rk] .ju367v1n{gap:4px}[data-rk] .ju367v1o{gap:5px}[data-rk] .ju367v1p{gap:6px}[data-rk] .ju367v1q{gap:8px}[data-rk] .ju367v1r{gap:10px}[data-rk] .ju367v1s{gap:12px}[data-rk] .ju367v1t{gap:14px}[data-rk] .ju367v1u{gap:16px}[data-rk] .ju367v1v{gap:18px}[data-rk] .ju367v1w{gap:20px}[data-rk] .ju367v1x{gap:24px}[data-rk] .ju367v1y{gap:28px}[data-rk] .ju367v1z{gap:32px}[data-rk] .ju367v20{gap:36px}[data-rk] .ju367v21{gap:44px}[data-rk] .ju367v22{gap:64px}[data-rk] .ju367v23{gap:-1px}[data-rk] .ju367v24{height:1px}[data-rk] .ju367v25{height:2px}[data-rk] .ju367v26{height:4px}[data-rk] .ju367v27{height:8px}[data-rk] .ju367v28{height:12px}[data-rk] .ju367v29{height:20px}[data-rk] .ju367v2a{height:24px}[data-rk] .ju367v2b{height:28px}[data-rk] .ju367v2c{height:30px}[data-rk] .ju367v2d{height:32px}[data-rk] .ju367v2e{height:34px}[data-rk] .ju367v2f{height:36px}[data-rk] .ju367v2g{height:40px}[data-rk] .ju367v2h{height:44px}[data-rk] .ju367v2i{height:48px}[data-rk] .ju367v2j{height:54px}[data-rk] .ju367v2k{height:60px}[data-rk] .ju367v2l{height:200px}[data-rk] .ju367v2m{height:100%}[data-rk] .ju367v2n{height:-moz-max-content;height:max-content}[data-rk] .ju367v2o{justify-content:flex-start}[data-rk] .ju367v2p{justify-content:flex-end}[data-rk] .ju367v2q{justify-content:center}[data-rk] .ju367v2r{justify-content:space-between}[data-rk] .ju367v2s{justify-content:space-around}[data-rk] .ju367v2t{text-align:left}[data-rk] .ju367v2u{text-align:center}[data-rk] .ju367v2v{text-align:inherit}[data-rk] .ju367v2w{margin-bottom:0}[data-rk] .ju367v2x{margin-bottom:1px}[data-rk] .ju367v2y{margin-bottom:2px}[data-rk] .ju367v2z{margin-bottom:3px}[data-rk] .ju367v30{margin-bottom:4px}[data-rk] .ju367v31{margin-bottom:5px}[data-rk] .ju367v32{margin-bottom:6px}[data-rk] .ju367v33{margin-bottom:8px}[data-rk] .ju367v34{margin-bottom:10px}[data-rk] .ju367v35{margin-bottom:12px}[data-rk] .ju367v36{margin-bottom:14px}[data-rk] .ju367v37{margin-bottom:16px}[data-rk] .ju367v38{margin-bottom:18px}[data-rk] .ju367v39{margin-bottom:20px}[data-rk] .ju367v3a{margin-bottom:24px}[data-rk] .ju367v3b{margin-bottom:28px}[data-rk] .ju367v3c{margin-bottom:32px}[data-rk] .ju367v3d{margin-bottom:36px}[data-rk] .ju367v3e{margin-bottom:44px}[data-rk] .ju367v3f{margin-bottom:64px}[data-rk] .ju367v3g{margin-bottom:-1px}[data-rk] .ju367v3h{margin-left:0}[data-rk] .ju367v3i{margin-left:1px}[data-rk] .ju367v3j{margin-left:2px}[data-rk] .ju367v3k{margin-left:3px}[data-rk] .ju367v3l{margin-left:4px}[data-rk] .ju367v3m{margin-left:5px}[data-rk] .ju367v3n{margin-left:6px}[data-rk] .ju367v3o{margin-left:8px}[data-rk] .ju367v3p{margin-left:10px}[data-rk] .ju367v3q{margin-left:12px}[data-rk] .ju367v3r{margin-left:14px}[data-rk] .ju367v3s{margin-left:16px}[data-rk] .ju367v3t{margin-left:18px}[data-rk] .ju367v3u{margin-left:20px}[data-rk] .ju367v3v{margin-left:24px}[data-rk] .ju367v3w{margin-left:28px}[data-rk] .ju367v3x{margin-left:32px}[data-rk] .ju367v3y{margin-left:36px}[data-rk] .ju367v3z{margin-left:44px}[data-rk] .ju367v40{margin-left:64px}[data-rk] .ju367v41{margin-left:-1px}[data-rk] .ju367v42{margin-right:0}[data-rk] .ju367v43{margin-right:1px}[data-rk] .ju367v44{margin-right:2px}[data-rk] .ju367v45{margin-right:3px}[data-rk] .ju367v46{margin-right:4px}[data-rk] .ju367v47{margin-right:5px}[data-rk] .ju367v48{margin-right:6px}[data-rk] .ju367v49{margin-right:8px}[data-rk] .ju367v4a{margin-right:10px}[data-rk] .ju367v4b{margin-right:12px}[data-rk] .ju367v4c{margin-right:14px}[data-rk] .ju367v4d{margin-right:16px}[data-rk] .ju367v4e{margin-right:18px}[data-rk] .ju367v4f{margin-right:20px}[data-rk] .ju367v4g{margin-right:24px}[data-rk] .ju367v4h{margin-right:28px}[data-rk] .ju367v4i{margin-right:32px}[data-rk] .ju367v4j{margin-right:36px}[data-rk] .ju367v4k{margin-right:44px}[data-rk] .ju367v4l{margin-right:64px}[data-rk] .ju367v4m{margin-right:-1px}[data-rk] .ju367v4n{margin-top:0}[data-rk] .ju367v4o{margin-top:1px}[data-rk] .ju367v4p{margin-top:2px}[data-rk] .ju367v4q{margin-top:3px}[data-rk] .ju367v4r{margin-top:4px}[data-rk] .ju367v4s{margin-top:5px}[data-rk] .ju367v4t{margin-top:6px}[data-rk] .ju367v4u{margin-top:8px}[data-rk] .ju367v4v{margin-top:10px}[data-rk] .ju367v4w{margin-top:12px}[data-rk] .ju367v4x{margin-top:14px}[data-rk] .ju367v4y{margin-top:16px}[data-rk] .ju367v4z{margin-top:18px}[data-rk] .ju367v50{margin-top:20px}[data-rk] .ju367v51{margin-top:24px}[data-rk] .ju367v52{margin-top:28px}[data-rk] .ju367v53{margin-top:32px}[data-rk] .ju367v54{margin-top:36px}[data-rk] .ju367v55{margin-top:44px}[data-rk] .ju367v56{margin-top:64px}[data-rk] .ju367v57{margin-top:-1px}[data-rk] .ju367v58{max-width:1px}[data-rk] .ju367v59{max-width:2px}[data-rk] .ju367v5a{max-width:4px}[data-rk] .ju367v5b{max-width:8px}[data-rk] .ju367v5c{max-width:12px}[data-rk] .ju367v5d{max-width:20px}[data-rk] .ju367v5e{max-width:24px}[data-rk] .ju367v5f{max-width:28px}[data-rk] .ju367v5g{max-width:30px}[data-rk] .ju367v5h{max-width:32px}[data-rk] .ju367v5i{max-width:34px}[data-rk] .ju367v5j{max-width:36px}[data-rk] .ju367v5k{max-width:40px}[data-rk] .ju367v5l{max-width:44px}[data-rk] .ju367v5m{max-width:48px}[data-rk] .ju367v5n{max-width:54px}[data-rk] .ju367v5o{max-width:60px}[data-rk] .ju367v5p{max-width:200px}[data-rk] .ju367v5q{max-width:100%}[data-rk] .ju367v5r{max-width:-moz-max-content;max-width:max-content}[data-rk] .ju367v5s{min-width:1px}[data-rk] .ju367v5t{min-width:2px}[data-rk] .ju367v5u{min-width:4px}[data-rk] .ju367v5v{min-width:8px}[data-rk] .ju367v5w{min-width:12px}[data-rk] .ju367v5x{min-width:20px}[data-rk] .ju367v5y{min-width:24px}[data-rk] .ju367v5z{min-width:28px}[data-rk] .ju367v60{min-width:30px}[data-rk] .ju367v61{min-width:32px}[data-rk] .ju367v62{min-width:34px}[data-rk] .ju367v63{min-width:36px}[data-rk] .ju367v64{min-width:40px}[data-rk] .ju367v65{min-width:44px}[data-rk] .ju367v66{min-width:48px}[data-rk] .ju367v67{min-width:54px}[data-rk] .ju367v68{min-width:60px}[data-rk] .ju367v69{min-width:200px}[data-rk] .ju367v6a{min-width:100%}[data-rk] .ju367v6b{min-width:-moz-max-content;min-width:max-content}[data-rk] .ju367v6c{overflow:hidden}[data-rk] .ju367v6d{padding-bottom:0}[data-rk] .ju367v6e{padding-bottom:1px}[data-rk] .ju367v6f{padding-bottom:2px}[data-rk] .ju367v6g{padding-bottom:3px}[data-rk] .ju367v6h{padding-bottom:4px}[data-rk] .ju367v6i{padding-bottom:5px}[data-rk] .ju367v6j{padding-bottom:6px}[data-rk] .ju367v6k{padding-bottom:8px}[data-rk] .ju367v6l{padding-bottom:10px}[data-rk] .ju367v6m{padding-bottom:12px}[data-rk] .ju367v6n{padding-bottom:14px}[data-rk] .ju367v6o{padding-bottom:16px}[data-rk] .ju367v6p{padding-bottom:18px}[data-rk] .ju367v6q{padding-bottom:20px}[data-rk] .ju367v6r{padding-bottom:24px}[data-rk] .ju367v6s{padding-bottom:28px}[data-rk] .ju367v6t{padding-bottom:32px}[data-rk] .ju367v6u{padding-bottom:36px}[data-rk] .ju367v6v{padding-bottom:44px}[data-rk] .ju367v6w{padding-bottom:64px}[data-rk] .ju367v6x{padding-bottom:-1px}[data-rk] .ju367v6y{padding-left:0}[data-rk] .ju367v6z{padding-left:1px}[data-rk] .ju367v70{padding-left:2px}[data-rk] .ju367v71{padding-left:3px}[data-rk] .ju367v72{padding-left:4px}[data-rk] .ju367v73{padding-left:5px}[data-rk] .ju367v74{padding-left:6px}[data-rk] .ju367v75{padding-left:8px}[data-rk] .ju367v76{padding-left:10px}[data-rk] .ju367v77{padding-left:12px}[data-rk] .ju367v78{padding-left:14px}[data-rk] .ju367v79{padding-left:16px}[data-rk] .ju367v7a{padding-left:18px}[data-rk] .ju367v7b{padding-left:20px}[data-rk] .ju367v7c{padding-left:24px}[data-rk] .ju367v7d{padding-left:28px}[data-rk] .ju367v7e{padding-left:32px}[data-rk] .ju367v7f{padding-left:36px}[data-rk] .ju367v7g{padding-left:44px}[data-rk] .ju367v7h{padding-left:64px}[data-rk] .ju367v7i{padding-left:-1px}[data-rk] .ju367v7j{padding-right:0}[data-rk] .ju367v7k{padding-right:1px}[data-rk] .ju367v7l{padding-right:2px}[data-rk] .ju367v7m{padding-right:3px}[data-rk] .ju367v7n{padding-right:4px}[data-rk] .ju367v7o{padding-right:5px}[data-rk] .ju367v7p{padding-right:6px}[data-rk] .ju367v7q{padding-right:8px}[data-rk] .ju367v7r{padding-right:10px}[data-rk] .ju367v7s{padding-right:12px}[data-rk] .ju367v7t{padding-right:14px}[data-rk] .ju367v7u{padding-right:16px}[data-rk] .ju367v7v{padding-right:18px}[data-rk] .ju367v7w{padding-right:20px}[data-rk] .ju367v7x{padding-right:24px}[data-rk] .ju367v7y{padding-right:28px}[data-rk] .ju367v7z{padding-right:32px}[data-rk] .ju367v80{padding-right:36px}[data-rk] .ju367v81{padding-right:44px}[data-rk] .ju367v82{padding-right:64px}[data-rk] .ju367v83{padding-right:-1px}[data-rk] .ju367v84{padding-top:0}[data-rk] .ju367v85{padding-top:1px}[data-rk] .ju367v86{padding-top:2px}[data-rk] .ju367v87{padding-top:3px}[data-rk] .ju367v88{padding-top:4px}[data-rk] .ju367v89{padding-top:5px}[data-rk] .ju367v8a{padding-top:6px}[data-rk] .ju367v8b{padding-top:8px}[data-rk] .ju367v8c{padding-top:10px}[data-rk] .ju367v8d{padding-top:12px}[data-rk] .ju367v8e{padding-top:14px}[data-rk] .ju367v8f{padding-top:16px}[data-rk] .ju367v8g{padding-top:18px}[data-rk] .ju367v8h{padding-top:20px}[data-rk] .ju367v8i{padding-top:24px}[data-rk] .ju367v8j{padding-top:28px}[data-rk] .ju367v8k{padding-top:32px}[data-rk] .ju367v8l{padding-top:36px}[data-rk] .ju367v8m{padding-top:44px}[data-rk] .ju367v8n{padding-top:64px}[data-rk] .ju367v8o{padding-top:-1px}[data-rk] .ju367v8p{position:absolute}[data-rk] .ju367v8q{position:fixed}[data-rk] .ju367v8r{position:relative}[data-rk] .ju367v8s{-webkit-user-select:none}[data-rk] .ju367v8t{right:0}[data-rk] .ju367v8u{transition:.125s ease}[data-rk] .ju367v8v{transition:transform .125s ease}[data-rk] .ju367v8w{-webkit-user-select:none;-moz-user-select:none;user-select:none}[data-rk] .ju367v8x{width:1px}[data-rk] .ju367v8y{width:2px}[data-rk] .ju367v8z{width:4px}[data-rk] .ju367v90{width:8px}[data-rk] .ju367v91{width:12px}[data-rk] .ju367v92{width:20px}[data-rk] .ju367v93{width:24px}[data-rk] .ju367v94{width:28px}[data-rk] .ju367v95{width:30px}[data-rk] .ju367v96{width:32px}[data-rk] .ju367v97{width:34px}[data-rk] .ju367v98{width:36px}[data-rk] .ju367v99{width:40px}[data-rk] .ju367v9a{width:44px}[data-rk] .ju367v9b{width:48px}[data-rk] .ju367v9c{width:54px}[data-rk] .ju367v9d{width:60px}[data-rk] .ju367v9e{width:200px}[data-rk] .ju367v9f{width:100%}[data-rk] .ju367v9g{width:-moz-max-content;width:max-content}[data-rk] .ju367v9h{-webkit-backdrop-filter:var(--rk-blurs-modalOverlay);backdrop-filter:var(--rk-blurs-modalOverlay)}[data-rk] .ju367v9i,[data-rk] .ju367v9j:hover,[data-rk] .ju367v9k:active{background:var(--rk-colors-accentColor)}[data-rk] .ju367v9l,[data-rk] .ju367v9m:hover,[data-rk] .ju367v9n:active{background:var(--rk-colors-accentColorForeground)}[data-rk] .ju367v9o,[data-rk] .ju367v9p:hover,[data-rk] .ju367v9q:active{background:var(--rk-colors-actionButtonBorder)}[data-rk] .ju367v9r,[data-rk] .ju367v9s:hover,[data-rk] .ju367v9t:active{background:var(--rk-colors-actionButtonBorderMobile)}[data-rk] .ju367v9u,[data-rk] .ju367v9v:hover,[data-rk] .ju367v9w:active{background:var(--rk-colors-actionButtonSecondaryBackground)}[data-rk] .ju367v9x,[data-rk] .ju367v9y:hover,[data-rk] .ju367v9z:active{background:var(--rk-colors-closeButton)}[data-rk] .ju367va0,[data-rk] .ju367va1:hover,[data-rk] .ju367va2:active{background:var(--rk-colors-closeButtonBackground)}[data-rk] .ju367va3,[data-rk] .ju367va4:hover,[data-rk] .ju367va5:active{background:var(--rk-colors-connectButtonBackground)}[data-rk] .ju367va6,[data-rk] .ju367va7:hover,[data-rk] .ju367va8:active{background:var(--rk-colors-connectButtonBackgroundError)}[data-rk] .ju367va9,[data-rk] .ju367vaa:hover,[data-rk] .ju367vab:active{background:var(--rk-colors-connectButtonInnerBackground)}[data-rk] .ju367vac,[data-rk] .ju367vad:hover,[data-rk] .ju367vae:active{background:var(--rk-colors-connectButtonText)}[data-rk] .ju367vaf,[data-rk] .ju367vag:hover,[data-rk] .ju367vah:active{background:var(--rk-colors-connectButtonTextError)}[data-rk] .ju367vai,[data-rk] .ju367vaj:hover,[data-rk] .ju367vak:active{background:var(--rk-colors-connectionIndicator)}[data-rk] .ju367val,[data-rk] .ju367vam:hover,[data-rk] .ju367van:active{background:var(--rk-colors-downloadBottomCardBackground)}[data-rk] .ju367vao,[data-rk] .ju367vap:hover,[data-rk] .ju367vaq:active{background:var(--rk-colors-downloadTopCardBackground)}[data-rk] .ju367var,[data-rk] .ju367vas:hover,[data-rk] .ju367vat:active{background:var(--rk-colors-error)}[data-rk] .ju367vau,[data-rk] .ju367vav:hover,[data-rk] .ju367vaw:active{background:var(--rk-colors-generalBorder)}[data-rk] .ju367vax,[data-rk] .ju367vay:hover,[data-rk] .ju367vaz:active{background:var(--rk-colors-generalBorderDim)}[data-rk] .ju367vb0,[data-rk] .ju367vb1:hover,[data-rk] .ju367vb2:active{background:var(--rk-colors-menuItemBackground)}[data-rk] .ju367vb3,[data-rk] .ju367vb4:hover,[data-rk] .ju367vb5:active{background:var(--rk-colors-modalBackdrop)}[data-rk] .ju367vb6,[data-rk] .ju367vb7:hover,[data-rk] .ju367vb8:active{background:var(--rk-colors-modalBackground)}[data-rk] .ju367vb9,[data-rk] .ju367vba:hover,[data-rk] .ju367vbb:active{background:var(--rk-colors-modalBorder)}[data-rk] .ju367vbc,[data-rk] .ju367vbd:hover,[data-rk] .ju367vbe:active{background:var(--rk-colors-modalText)}[data-rk] .ju367vbf,[data-rk] .ju367vbg:hover,[data-rk] .ju367vbh:active{background:var(--rk-colors-modalTextDim)}[data-rk] .ju367vbi,[data-rk] .ju367vbj:hover,[data-rk] .ju367vbk:active{background:var(--rk-colors-modalTextSecondary)}[data-rk] .ju367vbl,[data-rk] .ju367vbm:hover,[data-rk] .ju367vbn:active{background:var(--rk-colors-profileAction)}[data-rk] .ju367vbo,[data-rk] .ju367vbp:hover,[data-rk] .ju367vbq:active{background:var(--rk-colors-profileActionHover)}[data-rk] .ju367vbr,[data-rk] .ju367vbs:hover,[data-rk] .ju367vbt:active{background:var(--rk-colors-profileForeground)}[data-rk] .ju367vbu,[data-rk] .ju367vbv:hover,[data-rk] .ju367vbw:active{background:var(--rk-colors-selectedOptionBorder)}[data-rk] .ju367vbx,[data-rk] .ju367vby:hover,[data-rk] .ju367vbz:active{background:var(--rk-colors-standby)}[data-rk] .ju367vc0,[data-rk] .ju367vc1:hover,[data-rk] .ju367vc2:active{border-color:var(--rk-colors-accentColor)}[data-rk] .ju367vc3,[data-rk] .ju367vc4:hover,[data-rk] .ju367vc5:active{border-color:var(--rk-colors-accentColorForeground)}[data-rk] .ju367vc6,[data-rk] .ju367vc7:hover,[data-rk] .ju367vc8:active{border-color:var(--rk-colors-actionButtonBorder)}[data-rk] .ju367vc9,[data-rk] .ju367vca:hover,[data-rk] .ju367vcb:active{border-color:var(--rk-colors-actionButtonBorderMobile)}[data-rk] .ju367vcc,[data-rk] .ju367vcd:hover,[data-rk] .ju367vce:active{border-color:var(--rk-colors-actionButtonSecondaryBackground)}[data-rk] .ju367vcf,[data-rk] .ju367vcg:hover,[data-rk] .ju367vch:active{border-color:var(--rk-colors-closeButton)}[data-rk] .ju367vci,[data-rk] .ju367vcj:hover,[data-rk] .ju367vck:active{border-color:var(--rk-colors-closeButtonBackground)}[data-rk] .ju367vcl,[data-rk] .ju367vcm:hover,[data-rk] .ju367vcn:active{border-color:var(--rk-colors-connectButtonBackground)}[data-rk] .ju367vco,[data-rk] .ju367vcp:hover,[data-rk] .ju367vcq:active{border-color:var(--rk-colors-connectButtonBackgroundError)}[data-rk] .ju367vcr,[data-rk] .ju367vcs:hover,[data-rk] .ju367vct:active{border-color:var(--rk-colors-connectButtonInnerBackground)}[data-rk] .ju367vcu,[data-rk] .ju367vcv:hover,[data-rk] .ju367vcw:active{border-color:var(--rk-colors-connectButtonText)}[data-rk] .ju367vcx,[data-rk] .ju367vcy:hover,[data-rk] .ju367vcz:active{border-color:var(--rk-colors-connectButtonTextError)}[data-rk] .ju367vd0,[data-rk] .ju367vd1:hover,[data-rk] .ju367vd2:active{border-color:var(--rk-colors-connectionIndicator)}[data-rk] .ju367vd3,[data-rk] .ju367vd4:hover,[data-rk] .ju367vd5:active{border-color:var(--rk-colors-downloadBottomCardBackground)}[data-rk] .ju367vd6,[data-rk] .ju367vd7:hover,[data-rk] .ju367vd8:active{border-color:var(--rk-colors-downloadTopCardBackground)}[data-rk] .ju367vd9,[data-rk] .ju367vda:hover,[data-rk] .ju367vdb:active{border-color:var(--rk-colors-error)}[data-rk] .ju367vdc,[data-rk] .ju367vdd:hover,[data-rk] .ju367vde:active{border-color:var(--rk-colors-generalBorder)}[data-rk] .ju367vdf,[data-rk] .ju367vdg:hover,[data-rk] .ju367vdh:active{border-color:var(--rk-colors-generalBorderDim)}[data-rk] .ju367vdi,[data-rk] .ju367vdj:hover,[data-rk] .ju367vdk:active{border-color:var(--rk-colors-menuItemBackground)}[data-rk] .ju367vdl,[data-rk] .ju367vdm:hover,[data-rk] .ju367vdn:active{border-color:var(--rk-colors-modalBackdrop)}[data-rk] .ju367vdo,[data-rk] .ju367vdp:hover,[data-rk] .ju367vdq:active{border-color:var(--rk-colors-modalBackground)}[data-rk] .ju367vdr,[data-rk] .ju367vds:hover,[data-rk] .ju367vdt:active{border-color:var(--rk-colors-modalBorder)}[data-rk] .ju367vdu,[data-rk] .ju367vdv:hover,[data-rk] .ju367vdw:active{border-color:var(--rk-colors-modalText)}[data-rk] .ju367vdx,[data-rk] .ju367vdy:hover,[data-rk] .ju367vdz:active{border-color:var(--rk-colors-modalTextDim)}[data-rk] .ju367ve0,[data-rk] .ju367ve1:hover,[data-rk] .ju367ve2:active{border-color:var(--rk-colors-modalTextSecondary)}[data-rk] .ju367ve3,[data-rk] .ju367ve4:hover,[data-rk] .ju367ve5:active{border-color:var(--rk-colors-profileAction)}[data-rk] .ju367ve6,[data-rk] .ju367ve7:hover,[data-rk] .ju367ve8:active{border-color:var(--rk-colors-profileActionHover)}[data-rk] .ju367ve9,[data-rk] .ju367vea:hover,[data-rk] .ju367veb:active{border-color:var(--rk-colors-profileForeground)}[data-rk] .ju367vec,[data-rk] .ju367ved:hover,[data-rk] .ju367vee:active{border-color:var(--rk-colors-selectedOptionBorder)}[data-rk] .ju367vef,[data-rk] .ju367veg:hover,[data-rk] .ju367veh:active{border-color:var(--rk-colors-standby)}[data-rk] .ju367vei,[data-rk] .ju367vej:hover,[data-rk] .ju367vek:active{box-shadow:var(--rk-shadows-connectButton)}[data-rk] .ju367vel,[data-rk] .ju367vem:hover,[data-rk] .ju367ven:active{box-shadow:var(--rk-shadows-dialog)}[data-rk] .ju367veo,[data-rk] .ju367vep:hover,[data-rk] .ju367veq:active{box-shadow:var(--rk-shadows-profileDetailsAction)}[data-rk] .ju367ver,[data-rk] .ju367ves:hover,[data-rk] .ju367vet:active{box-shadow:var(--rk-shadows-selectedOption)}[data-rk] .ju367veu,[data-rk] .ju367vev:hover,[data-rk] .ju367vew:active{box-shadow:var(--rk-shadows-selectedWallet)}[data-rk] .ju367vex,[data-rk] .ju367vey:hover,[data-rk] .ju367vez:active{box-shadow:var(--rk-shadows-walletLogo)}[data-rk] .ju367vf0,[data-rk] .ju367vf1:hover,[data-rk] .ju367vf2:active{color:var(--rk-colors-accentColor)}[data-rk] .ju367vf3,[data-rk] .ju367vf4:hover,[data-rk] .ju367vf5:active{color:var(--rk-colors-accentColorForeground)}[data-rk] .ju367vf6,[data-rk] .ju367vf7:hover,[data-rk] .ju367vf8:active{color:var(--rk-colors-actionButtonBorder)}[data-rk] .ju367vf9,[data-rk] .ju367vfa:hover,[data-rk] .ju367vfb:active{color:var(--rk-colors-actionButtonBorderMobile)}[data-rk] .ju367vfc,[data-rk] .ju367vfd:hover,[data-rk] .ju367vfe:active{color:var(--rk-colors-actionButtonSecondaryBackground)}[data-rk] .ju367vff,[data-rk] .ju367vfg:hover,[data-rk] .ju367vfh:active{color:var(--rk-colors-closeButton)}[data-rk] .ju367vfi,[data-rk] .ju367vfj:hover,[data-rk] .ju367vfk:active{color:var(--rk-colors-closeButtonBackground)}[data-rk] .ju367vfl,[data-rk] .ju367vfm:hover,[data-rk] .ju367vfn:active{color:var(--rk-colors-connectButtonBackground)}[data-rk] .ju367vfo,[data-rk] .ju367vfp:hover,[data-rk] .ju367vfq:active{color:var(--rk-colors-connectButtonBackgroundError)}[data-rk] .ju367vfr,[data-rk] .ju367vfs:hover,[data-rk] .ju367vft:active{color:var(--rk-colors-connectButtonInnerBackground)}[data-rk] .ju367vfu,[data-rk] .ju367vfv:hover,[data-rk] .ju367vfw:active{color:var(--rk-colors-connectButtonText)}[data-rk] .ju367vfx,[data-rk] .ju367vfy:hover,[data-rk] .ju367vfz:active{color:var(--rk-colors-connectButtonTextError)}[data-rk] .ju367vg0,[data-rk] .ju367vg1:hover,[data-rk] .ju367vg2:active{color:var(--rk-colors-connectionIndicator)}[data-rk] .ju367vg3,[data-rk] .ju367vg4:hover,[data-rk] .ju367vg5:active{color:var(--rk-colors-downloadBottomCardBackground)}[data-rk] .ju367vg6,[data-rk] .ju367vg7:hover,[data-rk] .ju367vg8:active{color:var(--rk-colors-downloadTopCardBackground)}[data-rk] .ju367vg9,[data-rk] .ju367vga:hover,[data-rk] .ju367vgb:active{color:var(--rk-colors-error)}[data-rk] .ju367vgc,[data-rk] .ju367vgd:hover,[data-rk] .ju367vge:active{color:var(--rk-colors-generalBorder)}[data-rk] .ju367vgf,[data-rk] .ju367vgg:hover,[data-rk] .ju367vgh:active{color:var(--rk-colors-generalBorderDim)}[data-rk] .ju367vgi,[data-rk] .ju367vgj:hover,[data-rk] .ju367vgk:active{color:var(--rk-colors-menuItemBackground)}[data-rk] .ju367vgl,[data-rk] .ju367vgm:hover,[data-rk] .ju367vgn:active{color:var(--rk-colors-modalBackdrop)}[data-rk] .ju367vgo,[data-rk] .ju367vgp:hover,[data-rk] .ju367vgq:active{color:var(--rk-colors-modalBackground)}[data-rk] .ju367vgr,[data-rk] .ju367vgs:hover,[data-rk] .ju367vgt:active{color:var(--rk-colors-modalBorder)}[data-rk] .ju367vgu,[data-rk] .ju367vgv:hover,[data-rk] .ju367vgw:active{color:var(--rk-colors-modalText)}[data-rk] .ju367vgx,[data-rk] .ju367vgy:hover,[data-rk] .ju367vgz:active{color:var(--rk-colors-modalTextDim)}[data-rk] .ju367vh0,[data-rk] .ju367vh1:hover,[data-rk] .ju367vh2:active{color:var(--rk-colors-modalTextSecondary)}[data-rk] .ju367vh3,[data-rk] .ju367vh4:hover,[data-rk] .ju367vh5:active{color:var(--rk-colors-profileAction)}[data-rk] .ju367vh6,[data-rk] .ju367vh7:hover,[data-rk] .ju367vh8:active{color:var(--rk-colors-profileActionHover)}[data-rk] .ju367vh9,[data-rk] .ju367vha:hover,[data-rk] .ju367vhb:active{color:var(--rk-colors-profileForeground)}[data-rk] .ju367vhc,[data-rk] .ju367vhd:hover,[data-rk] .ju367vhe:active{color:var(--rk-colors-selectedOptionBorder)}[data-rk] .ju367vhf,[data-rk] .ju367vhg:hover,[data-rk] .ju367vhh:active{color:var(--rk-colors-standby)}@media screen and (min-width: 768px){[data-rk] .ju367v1{align-items:flex-start}[data-rk] .ju367v3{align-items:flex-end}[data-rk] .ju367v5{align-items:center}[data-rk] .ju367v7{display:none}[data-rk] .ju367v9{display:block}[data-rk] .ju367vb{display:flex}[data-rk] .ju367vd{display:inline}}[data-rk] ._12cbo8i3,[data-rk] ._12cbo8i3:after{--_12cbo8i0: 1;--_12cbo8i1: 1}[data-rk] ._12cbo8i3:hover{transform:scale(var(--_12cbo8i0))}[data-rk] ._12cbo8i3:active{transform:scale(var(--_12cbo8i1))}[data-rk] ._12cbo8i3:active:after{content:"";bottom:-1px;display:block;left:-1px;position:absolute;right:-1px;top:-1px;transform:scale(calc((1 / var(--_12cbo8i1)) * var(--_12cbo8i0)))}[data-rk] ._12cbo8i4,[data-rk] ._12cbo8i4:after{--_12cbo8i0: 1.025}[data-rk] ._12cbo8i5,[data-rk] ._12cbo8i5:after{--_12cbo8i0: 1.1}[data-rk] ._12cbo8i6,[data-rk] ._12cbo8i6:after{--_12cbo8i1: .95}[data-rk] ._12cbo8i7,[data-rk] ._12cbo8i7:after{--_12cbo8i1: .9}@keyframes _1luule41{0%{transform:rotate(0)}to{transform:rotate(360deg)}}[data-rk] ._1luule42{animation:_1luule41 3s infinite linear}[data-rk] ._1luule43{background:conic-gradient(from 180deg at 50% 50%,rgba(72,146,254,0) 0deg,currentColor 282.04deg,rgba(72,146,254,0) 319.86deg,rgba(72,146,254,0) 360deg);height:21px;width:21px}@keyframes _9pm4ki0{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes _9pm4ki1{0%{opacity:0}to{opacity:1}}[data-rk] ._9pm4ki3{animation:_9pm4ki1 .15s ease;bottom:-200px;left:-200px;padding:200px;right:-200px;top:-200px;transform:translateZ(0);z-index:2147483646}[data-rk] ._9pm4ki5{animation:_9pm4ki0 .35s cubic-bezier(.15,1.15,.6,1),_9pm4ki1 .15s ease;max-width:100vw}[data-rk] ._1ckjpok1{box-sizing:content-box;max-width:100vw;width:360px}[data-rk] ._1ckjpok2{width:100vw}[data-rk] ._1ckjpok3{min-width:720px;width:720px}[data-rk] ._1ckjpok4{min-width:368px;width:368px}[data-rk] ._1ckjpok6{border-width:0px;box-sizing:border-box;width:100vw}@media screen and (min-width: 768px){[data-rk] ._1ckjpok1{width:360px}[data-rk] ._1ckjpok2{width:480px}[data-rk] ._1ckjpok4{min-width:368px;width:368px}}@media screen and (max-width: 767px){[data-rk] ._1ckjpok7{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-top:-200px;padding-bottom:200px;top:200px}}[data-rk] .v9horb0:hover{background:unset}[data-rk] ._18dqw9x0{max-height:456px;overflow-y:auto;overflow-x:hidden}[data-rk] ._18dqw9x1{max-height:456px;overflow-y:auto;overflow-x:hidden;scrollbar-width:none}[data-rk] ._18dqw9x1::-webkit-scrollbar{display:none}[data-rk] .g5kl0l0{border-color:transparent}[data-rk] ._1vwt0cg0{background:white}[data-rk] ._1vwt0cg2{max-height:454px;overflow-y:auto}[data-rk] ._1vwt0cg3{min-width:287px}[data-rk] ._1vwt0cg4{min-width:100%}@keyframes _1am14411{0%{stroke-dashoffset:0}to{stroke-dashoffset:-283}}[data-rk] ._1am14410{overflow:auto;scrollbar-width:none;transform:translateZ(0)}[data-rk] ._1am14410::-webkit-scrollbar{display:none}[data-rk] ._1am14412{animation:_1am14411 1s linear infinite;stroke-dasharray:98 196;fill:none;stroke-linecap:round;stroke-width:4}[data-rk] ._1am14413{position:absolute}[data-rk] ._1y2lnfi0{border:1px solid rgba(16,21,31,.06)}[data-rk] ._1y2lnfi1{max-width:-moz-fit-content;max-width:fit-content}
`, NO = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), o = (x, b) => {
    const k = typeof x == "function" ? x(t) : x;
    if (!Object.is(k, t)) {
      const T = t;
      t = b ?? (typeof k != "object" || k === null) ? k : Object.assign({}, t, k), r.forEach((O) => O(t, T));
    }
  }, l = () => t, v = { setState: o, getState: l, getInitialState: () => w, subscribe: (x) => (r.add(x), () => r.delete(x)), destroy: () => {
    r.clear();
  } }, w = t = e(o, l, v);
  return v;
}, e0 = (e) => e ? NO(e) : NO, IL = e0(() => ({
  accountModalOpen: void 0,
  openAccountModal: void 0,
  closeAccountModal: void 0,
  toggleAccountModal: void 0,
  appAccountClient: void 0,
  userAccountClient: void 0,
  userAddress: void 0,
  userChainId: void 0
})), Uf = e0(() => ({
  rootContainer: void 0,
  buttonContainers: []
}));
var JE = { exports: {} }, Ii = {}, c1 = { exports: {} }, oE = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var FO;
function ML() {
  return FO || (FO = 1, function(e) {
    function t(pe, fe) {
      var z = pe.length;
      pe.push(fe);
      e:
        for (; 0 < z; ) {
          var oe = z - 1 >>> 1, ke = pe[oe];
          if (0 < l(ke, fe))
            pe[oe] = fe, pe[z] = ke, z = oe;
          else
            break e;
        }
    }
    function r(pe) {
      return pe.length === 0 ? null : pe[0];
    }
    function o(pe) {
      if (pe.length === 0)
        return null;
      var fe = pe[0], z = pe.pop();
      if (z !== fe) {
        pe[0] = z;
        e:
          for (var oe = 0, ke = pe.length, Qe = ke >>> 1; oe < Qe; ) {
            var Xe = 2 * (oe + 1) - 1, bt = pe[Xe], at = Xe + 1, ut = pe[at];
            if (0 > l(bt, z))
              at < ke && 0 > l(ut, bt) ? (pe[oe] = ut, pe[at] = z, oe = at) : (pe[oe] = bt, pe[Xe] = z, oe = Xe);
            else if (at < ke && 0 > l(ut, z))
              pe[oe] = ut, pe[at] = z, oe = at;
            else
              break e;
          }
      }
      return fe;
    }
    function l(pe, fe) {
      var z = pe.sortIndex - fe.sortIndex;
      return z !== 0 ? z : pe.id - fe.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var d = performance;
      e.unstable_now = function() {
        return d.now();
      };
    } else {
      var f = Date, m = f.now();
      e.unstable_now = function() {
        return f.now() - m;
      };
    }
    var v = [], w = [], x = 1, b = null, k = 3, T = !1, O = !1, R = !1, j = typeof setTimeout == "function" ? setTimeout : null, I = typeof clearTimeout == "function" ? clearTimeout : null, N = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function L(pe) {
      for (var fe = r(w); fe !== null; ) {
        if (fe.callback === null)
          o(w);
        else if (fe.startTime <= pe)
          o(w), fe.sortIndex = fe.expirationTime, t(v, fe);
        else
          break;
        fe = r(w);
      }
    }
    function B(pe) {
      if (R = !1, L(pe), !O)
        if (r(v) !== null)
          O = !0, ge(H);
        else {
          var fe = r(w);
          fe !== null && de(B, fe.startTime - pe);
        }
    }
    function H(pe, fe) {
      O = !1, R && (R = !1, I(Y), Y = -1), T = !0;
      var z = k;
      try {
        for (L(fe), b = r(v); b !== null && (!(b.expirationTime > fe) || pe && !Se()); ) {
          var oe = b.callback;
          if (typeof oe == "function") {
            b.callback = null, k = b.priorityLevel;
            var ke = oe(b.expirationTime <= fe);
            fe = e.unstable_now(), typeof ke == "function" ? b.callback = ke : b === r(v) && o(v), L(fe);
          } else
            o(v);
          b = r(v);
        }
        if (b !== null)
          var Qe = !0;
        else {
          var Xe = r(w);
          Xe !== null && de(B, Xe.startTime - fe), Qe = !1;
        }
        return Qe;
      } finally {
        b = null, k = z, T = !1;
      }
    }
    var V = !1, W = null, Y = -1, ce = 5, ve = -1;
    function Se() {
      return !(e.unstable_now() - ve < ce);
    }
    function De() {
      if (W !== null) {
        var pe = e.unstable_now();
        ve = pe;
        var fe = !0;
        try {
          fe = W(!0, pe);
        } finally {
          fe ? Re() : (V = !1, W = null);
        }
      } else
        V = !1;
    }
    var Re;
    if (typeof N == "function")
      Re = function() {
        N(De);
      };
    else if (typeof MessageChannel < "u") {
      var Pe = new MessageChannel(), se = Pe.port2;
      Pe.port1.onmessage = De, Re = function() {
        se.postMessage(null);
      };
    } else
      Re = function() {
        j(De, 0);
      };
    function ge(pe) {
      W = pe, V || (V = !0, Re());
    }
    function de(pe, fe) {
      Y = j(function() {
        pe(e.unstable_now());
      }, fe);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(pe) {
      pe.callback = null;
    }, e.unstable_continueExecution = function() {
      O || T || (O = !0, ge(H));
    }, e.unstable_forceFrameRate = function(pe) {
      0 > pe || 125 < pe ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : ce = 0 < pe ? Math.floor(1e3 / pe) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return k;
    }, e.unstable_getFirstCallbackNode = function() {
      return r(v);
    }, e.unstable_next = function(pe) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var fe = 3;
          break;
        default:
          fe = k;
      }
      var z = k;
      k = fe;
      try {
        return pe();
      } finally {
        k = z;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(pe, fe) {
      switch (pe) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          pe = 3;
      }
      var z = k;
      k = pe;
      try {
        return fe();
      } finally {
        k = z;
      }
    }, e.unstable_scheduleCallback = function(pe, fe, z) {
      var oe = e.unstable_now();
      switch (typeof z == "object" && z !== null ? (z = z.delay, z = typeof z == "number" && 0 < z ? oe + z : oe) : z = oe, pe) {
        case 1:
          var ke = -1;
          break;
        case 2:
          ke = 250;
          break;
        case 5:
          ke = 1073741823;
          break;
        case 4:
          ke = 1e4;
          break;
        default:
          ke = 5e3;
      }
      return ke = z + ke, pe = { id: x++, callback: fe, priorityLevel: pe, startTime: z, expirationTime: ke, sortIndex: -1 }, z > oe ? (pe.sortIndex = z, t(w, pe), r(v) === null && pe === r(w) && (R ? (I(Y), Y = -1) : R = !0, de(B, z - oe))) : (pe.sortIndex = ke, t(v, pe), O || T || (O = !0, ge(H))), pe;
    }, e.unstable_shouldYield = Se, e.unstable_wrapCallback = function(pe) {
      var fe = k;
      return function() {
        var z = k;
        k = fe;
        try {
          return pe.apply(this, arguments);
        } finally {
          k = z;
        }
      };
    };
  }(oE)), oE;
}
var sE = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zO;
function $L() {
  return zO || (zO = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, r = !1, o = 5;
      function l(Me, ot) {
        var $t = Me.length;
        Me.push(ot), m(Me, ot, $t);
      }
      function d(Me) {
        return Me.length === 0 ? null : Me[0];
      }
      function f(Me) {
        if (Me.length === 0)
          return null;
        var ot = Me[0], $t = Me.pop();
        return $t !== ot && (Me[0] = $t, v(Me, $t, 0)), ot;
      }
      function m(Me, ot, $t) {
        for (var un = $t; un > 0; ) {
          var cn = un - 1 >>> 1, ir = Me[cn];
          if (w(ir, ot) > 0)
            Me[cn] = ot, Me[un] = ir, un = cn;
          else
            return;
        }
      }
      function v(Me, ot, $t) {
        for (var un = $t, cn = Me.length, ir = cn >>> 1; un < ir; ) {
          var qn = (un + 1) * 2 - 1, Kr = Me[qn], yn = qn + 1, ca = Me[yn];
          if (w(Kr, ot) < 0)
            yn < cn && w(ca, Kr) < 0 ? (Me[un] = ca, Me[yn] = ot, un = yn) : (Me[un] = Kr, Me[qn] = ot, un = qn);
          else if (yn < cn && w(ca, ot) < 0)
            Me[un] = ca, Me[yn] = ot, un = yn;
          else
            return;
        }
      }
      function w(Me, ot) {
        var $t = Me.sortIndex - ot.sortIndex;
        return $t !== 0 ? $t : Me.id - ot.id;
      }
      var x = 1, b = 2, k = 3, T = 4, O = 5;
      function R(Me, ot) {
      }
      var j = typeof performance == "object" && typeof performance.now == "function";
      if (j) {
        var I = performance;
        e.unstable_now = function() {
          return I.now();
        };
      } else {
        var N = Date, L = N.now();
        e.unstable_now = function() {
          return N.now() - L;
        };
      }
      var B = 1073741823, H = -1, V = 250, W = 5e3, Y = 1e4, ce = B, ve = [], Se = [], De = 1, Re = null, Pe = k, se = !1, ge = !1, de = !1, pe = typeof setTimeout == "function" ? setTimeout : null, fe = typeof clearTimeout == "function" ? clearTimeout : null, z = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function oe(Me) {
        for (var ot = d(Se); ot !== null; ) {
          if (ot.callback === null)
            f(Se);
          else if (ot.startTime <= Me)
            f(Se), ot.sortIndex = ot.expirationTime, l(ve, ot);
          else
            return;
          ot = d(Se);
        }
      }
      function ke(Me) {
        if (de = !1, oe(Me), !ge)
          if (d(ve) !== null)
            ge = !0, Ta(Qe);
          else {
            var ot = d(Se);
            ot !== null && Gn(ke, ot.startTime - Me);
          }
      }
      function Qe(Me, ot) {
        ge = !1, de && (de = !1, la()), se = !0;
        var $t = Pe;
        try {
          var un;
          if (!r)
            return Xe(Me, ot);
        } finally {
          Re = null, Pe = $t, se = !1;
        }
      }
      function Xe(Me, ot) {
        var $t = ot;
        for (oe($t), Re = d(ve); Re !== null && !t && !(Re.expirationTime > $t && (!Me || Yr())); ) {
          var un = Re.callback;
          if (typeof un == "function") {
            Re.callback = null, Pe = Re.priorityLevel;
            var cn = Re.expirationTime <= $t, ir = un(cn);
            $t = e.unstable_now(), typeof ir == "function" ? Re.callback = ir : Re === d(ve) && f(ve), oe($t);
          } else
            f(ve);
          Re = d(ve);
        }
        if (Re !== null)
          return !0;
        var qn = d(Se);
        return qn !== null && Gn(ke, qn.startTime - $t), !1;
      }
      function bt(Me, ot) {
        switch (Me) {
          case x:
          case b:
          case k:
          case T:
          case O:
            break;
          default:
            Me = k;
        }
        var $t = Pe;
        Pe = Me;
        try {
          return ot();
        } finally {
          Pe = $t;
        }
      }
      function at(Me) {
        var ot;
        switch (Pe) {
          case x:
          case b:
          case k:
            ot = k;
            break;
          default:
            ot = Pe;
            break;
        }
        var $t = Pe;
        Pe = ot;
        try {
          return Me();
        } finally {
          Pe = $t;
        }
      }
      function ut(Me) {
        var ot = Pe;
        return function() {
          var $t = Pe;
          Pe = ot;
          try {
            return Me.apply(this, arguments);
          } finally {
            Pe = $t;
          }
        };
      }
      function wt(Me, ot, $t) {
        var un = e.unstable_now(), cn;
        if (typeof $t == "object" && $t !== null) {
          var ir = $t.delay;
          typeof ir == "number" && ir > 0 ? cn = un + ir : cn = un;
        } else
          cn = un;
        var qn;
        switch (Me) {
          case x:
            qn = H;
            break;
          case b:
            qn = V;
            break;
          case O:
            qn = ce;
            break;
          case T:
            qn = Y;
            break;
          case k:
          default:
            qn = W;
            break;
        }
        var Kr = cn + qn, yn = {
          id: De++,
          callback: ot,
          priorityLevel: Me,
          startTime: cn,
          expirationTime: Kr,
          sortIndex: -1
        };
        return cn > un ? (yn.sortIndex = cn, l(Se, yn), d(ve) === null && yn === d(Se) && (de ? la() : de = !0, Gn(ke, cn - un))) : (yn.sortIndex = Kr, l(ve, yn), !ge && !se && (ge = !0, Ta(Qe))), yn;
      }
      function pt() {
      }
      function Rn() {
        !ge && !se && (ge = !0, Ta(Qe));
      }
      function rr() {
        return d(ve);
      }
      function Hn(Me) {
        Me.callback = null;
      }
      function Vt() {
        return Pe;
      }
      var xn = !1, gn = null, An = -1, Vn = o, Wr = -1;
      function Yr() {
        var Me = e.unstable_now() - Wr;
        return !(Me < Vn);
      }
      function cr() {
      }
      function ar(Me) {
        if (Me < 0 || Me > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Me > 0 ? Vn = Math.floor(1e3 / Me) : Vn = o;
      }
      var Ca = function() {
        if (gn !== null) {
          var Me = e.unstable_now();
          Wr = Me;
          var ot = !0, $t = !0;
          try {
            $t = gn(ot, Me);
          } finally {
            $t ? Zr() : (xn = !1, gn = null);
          }
        } else
          xn = !1;
      }, Zr;
      if (typeof z == "function")
        Zr = function() {
          z(Ca);
        };
      else if (typeof MessageChannel < "u") {
        var qa = new MessageChannel(), Ir = qa.port2;
        qa.port1.onmessage = Ca, Zr = function() {
          Ir.postMessage(null);
        };
      } else
        Zr = function() {
          pe(Ca, 0);
        };
      function Ta(Me) {
        gn = Me, xn || (xn = !0, Zr());
      }
      function Gn(Me, ot) {
        An = pe(function() {
          Me(e.unstable_now());
        }, ot);
      }
      function la() {
        fe(An), An = -1;
      }
      var oo = cr, Wa = null;
      e.unstable_IdlePriority = O, e.unstable_ImmediatePriority = x, e.unstable_LowPriority = T, e.unstable_NormalPriority = k, e.unstable_Profiling = Wa, e.unstable_UserBlockingPriority = b, e.unstable_cancelCallback = Hn, e.unstable_continueExecution = Rn, e.unstable_forceFrameRate = ar, e.unstable_getCurrentPriorityLevel = Vt, e.unstable_getFirstCallbackNode = rr, e.unstable_next = at, e.unstable_pauseExecution = pt, e.unstable_requestPaint = oo, e.unstable_runWithPriority = bt, e.unstable_scheduleCallback = wt, e.unstable_shouldYield = Yr, e.unstable_wrapCallback = ut, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(sE)), sE;
}
var BO;
function Gj() {
  return BO || (BO = 1, process.env.NODE_ENV === "production" ? c1.exports = ML() : c1.exports = $L()), c1.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var UO;
function LL() {
  if (UO)
    return Ii;
  UO = 1;
  var e = $, t = Gj();
  function r(i) {
    for (var s = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, p = 1; p < arguments.length; p++)
      s += "&args[]=" + encodeURIComponent(arguments[p]);
    return "Minified React error #" + i + "; visit " + s + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = /* @__PURE__ */ new Set(), l = {};
  function d(i, s) {
    f(i, s), f(i + "Capture", s);
  }
  function f(i, s) {
    for (l[i] = s, i = 0; i < s.length; i++)
      o.add(s[i]);
  }
  var m = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), v = Object.prototype.hasOwnProperty, w = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, x = {}, b = {};
  function k(i) {
    return v.call(b, i) ? !0 : v.call(x, i) ? !1 : w.test(i) ? b[i] = !0 : (x[i] = !0, !1);
  }
  function T(i, s, p, y) {
    if (p !== null && p.type === 0)
      return !1;
    switch (typeof s) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return y ? !1 : p !== null ? !p.acceptsBooleans : (i = i.toLowerCase().slice(0, 5), i !== "data-" && i !== "aria-");
      default:
        return !1;
    }
  }
  function O(i, s, p, y) {
    if (s === null || typeof s > "u" || T(i, s, p, y))
      return !0;
    if (y)
      return !1;
    if (p !== null)
      switch (p.type) {
        case 3:
          return !s;
        case 4:
          return s === !1;
        case 5:
          return isNaN(s);
        case 6:
          return isNaN(s) || 1 > s;
      }
    return !1;
  }
  function R(i, s, p, y, S, C, D) {
    this.acceptsBooleans = s === 2 || s === 3 || s === 4, this.attributeName = y, this.attributeNamespace = S, this.mustUseProperty = p, this.propertyName = i, this.type = s, this.sanitizeURL = C, this.removeEmptyString = D;
  }
  var j = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    j[i] = new R(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var s = i[0];
    j[s] = new R(s, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    j[i] = new R(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    j[i] = new R(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    j[i] = new R(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    j[i] = new R(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    j[i] = new R(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    j[i] = new R(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    j[i] = new R(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var I = /[\-:]([a-z])/g;
  function N(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var s = i.replace(
      I,
      N
    );
    j[s] = new R(s, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var s = i.replace(I, N);
    j[s] = new R(s, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var s = i.replace(I, N);
    j[s] = new R(s, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    j[i] = new R(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), j.xlinkHref = new R("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    j[i] = new R(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  function L(i, s, p, y) {
    var S = j.hasOwnProperty(s) ? j[s] : null;
    (S !== null ? S.type !== 0 : y || !(2 < s.length) || s[0] !== "o" && s[0] !== "O" || s[1] !== "n" && s[1] !== "N") && (O(s, p, S, y) && (p = null), y || S === null ? k(s) && (p === null ? i.removeAttribute(s) : i.setAttribute(s, "" + p)) : S.mustUseProperty ? i[S.propertyName] = p === null ? S.type === 3 ? !1 : "" : p : (s = S.attributeName, y = S.attributeNamespace, p === null ? i.removeAttribute(s) : (S = S.type, p = S === 3 || S === 4 && p === !0 ? "" : "" + p, y ? i.setAttributeNS(y, s, p) : i.setAttribute(s, p))));
  }
  var B = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, H = Symbol.for("react.element"), V = Symbol.for("react.portal"), W = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), ce = Symbol.for("react.profiler"), ve = Symbol.for("react.provider"), Se = Symbol.for("react.context"), De = Symbol.for("react.forward_ref"), Re = Symbol.for("react.suspense"), Pe = Symbol.for("react.suspense_list"), se = Symbol.for("react.memo"), ge = Symbol.for("react.lazy"), de = Symbol.for("react.offscreen"), pe = Symbol.iterator;
  function fe(i) {
    return i === null || typeof i != "object" ? null : (i = pe && i[pe] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var z = Object.assign, oe;
  function ke(i) {
    if (oe === void 0)
      try {
        throw Error();
      } catch (p) {
        var s = p.stack.trim().match(/\n( *(at )?)/);
        oe = s && s[1] || "";
      }
    return `
` + oe + i;
  }
  var Qe = !1;
  function Xe(i, s) {
    if (!i || Qe)
      return "";
    Qe = !0;
    var p = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (s)
        if (s = function() {
          throw Error();
        }, Object.defineProperty(s.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(s, []);
          } catch (ue) {
            var y = ue;
          }
          Reflect.construct(i, [], s);
        } else {
          try {
            s.call();
          } catch (ue) {
            y = ue;
          }
          i.call(s.prototype);
        }
      else {
        try {
          throw Error();
        } catch (ue) {
          y = ue;
        }
        i();
      }
    } catch (ue) {
      if (ue && y && typeof ue.stack == "string") {
        for (var S = ue.stack.split(`
`), C = y.stack.split(`
`), D = S.length - 1, U = C.length - 1; 1 <= D && 0 <= U && S[D] !== C[U]; )
          U--;
        for (; 1 <= D && 0 <= U; D--, U--)
          if (S[D] !== C[U]) {
            if (D !== 1 || U !== 1)
              do
                if (D--, U--, 0 > U || S[D] !== C[U]) {
                  var Z = `
` + S[D].replace(" at new ", " at ");
                  return i.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", i.displayName)), Z;
                }
              while (1 <= D && 0 <= U);
            break;
          }
      }
    } finally {
      Qe = !1, Error.prepareStackTrace = p;
    }
    return (i = i ? i.displayName || i.name : "") ? ke(i) : "";
  }
  function bt(i) {
    switch (i.tag) {
      case 5:
        return ke(i.type);
      case 16:
        return ke("Lazy");
      case 13:
        return ke("Suspense");
      case 19:
        return ke("SuspenseList");
      case 0:
      case 2:
      case 15:
        return i = Xe(i.type, !1), i;
      case 11:
        return i = Xe(i.type.render, !1), i;
      case 1:
        return i = Xe(i.type, !0), i;
      default:
        return "";
    }
  }
  function at(i) {
    if (i == null)
      return null;
    if (typeof i == "function")
      return i.displayName || i.name || null;
    if (typeof i == "string")
      return i;
    switch (i) {
      case W:
        return "Fragment";
      case V:
        return "Portal";
      case ce:
        return "Profiler";
      case Y:
        return "StrictMode";
      case Re:
        return "Suspense";
      case Pe:
        return "SuspenseList";
    }
    if (typeof i == "object")
      switch (i.$$typeof) {
        case Se:
          return (i.displayName || "Context") + ".Consumer";
        case ve:
          return (i._context.displayName || "Context") + ".Provider";
        case De:
          var s = i.render;
          return i = i.displayName, i || (i = s.displayName || s.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
        case se:
          return s = i.displayName || null, s !== null ? s : at(i.type) || "Memo";
        case ge:
          s = i._payload, i = i._init;
          try {
            return at(i(s));
          } catch {
          }
      }
    return null;
  }
  function ut(i) {
    var s = i.type;
    switch (i.tag) {
      case 24:
        return "Cache";
      case 9:
        return (s.displayName || "Context") + ".Consumer";
      case 10:
        return (s._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return i = s.render, i = i.displayName || i.name || "", s.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return s;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return at(s);
      case 8:
        return s === Y ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof s == "function")
          return s.displayName || s.name || null;
        if (typeof s == "string")
          return s;
    }
    return null;
  }
  function wt(i) {
    switch (typeof i) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return i;
      case "object":
        return i;
      default:
        return "";
    }
  }
  function pt(i) {
    var s = i.type;
    return (i = i.nodeName) && i.toLowerCase() === "input" && (s === "checkbox" || s === "radio");
  }
  function Rn(i) {
    var s = pt(i) ? "checked" : "value", p = Object.getOwnPropertyDescriptor(i.constructor.prototype, s), y = "" + i[s];
    if (!i.hasOwnProperty(s) && typeof p < "u" && typeof p.get == "function" && typeof p.set == "function") {
      var S = p.get, C = p.set;
      return Object.defineProperty(i, s, { configurable: !0, get: function() {
        return S.call(this);
      }, set: function(D) {
        y = "" + D, C.call(this, D);
      } }), Object.defineProperty(i, s, { enumerable: p.enumerable }), { getValue: function() {
        return y;
      }, setValue: function(D) {
        y = "" + D;
      }, stopTracking: function() {
        i._valueTracker = null, delete i[s];
      } };
    }
  }
  function rr(i) {
    i._valueTracker || (i._valueTracker = Rn(i));
  }
  function Hn(i) {
    if (!i)
      return !1;
    var s = i._valueTracker;
    if (!s)
      return !0;
    var p = s.getValue(), y = "";
    return i && (y = pt(i) ? i.checked ? "true" : "false" : i.value), i = y, i !== p ? (s.setValue(i), !0) : !1;
  }
  function Vt(i) {
    if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u")
      return null;
    try {
      return i.activeElement || i.body;
    } catch {
      return i.body;
    }
  }
  function xn(i, s) {
    var p = s.checked;
    return z({}, s, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: p ?? i._wrapperState.initialChecked });
  }
  function gn(i, s) {
    var p = s.defaultValue == null ? "" : s.defaultValue, y = s.checked != null ? s.checked : s.defaultChecked;
    p = wt(s.value != null ? s.value : p), i._wrapperState = { initialChecked: y, initialValue: p, controlled: s.type === "checkbox" || s.type === "radio" ? s.checked != null : s.value != null };
  }
  function An(i, s) {
    s = s.checked, s != null && L(i, "checked", s, !1);
  }
  function Vn(i, s) {
    An(i, s);
    var p = wt(s.value), y = s.type;
    if (p != null)
      y === "number" ? (p === 0 && i.value === "" || i.value != p) && (i.value = "" + p) : i.value !== "" + p && (i.value = "" + p);
    else if (y === "submit" || y === "reset") {
      i.removeAttribute("value");
      return;
    }
    s.hasOwnProperty("value") ? Yr(i, s.type, p) : s.hasOwnProperty("defaultValue") && Yr(i, s.type, wt(s.defaultValue)), s.checked == null && s.defaultChecked != null && (i.defaultChecked = !!s.defaultChecked);
  }
  function Wr(i, s, p) {
    if (s.hasOwnProperty("value") || s.hasOwnProperty("defaultValue")) {
      var y = s.type;
      if (!(y !== "submit" && y !== "reset" || s.value !== void 0 && s.value !== null))
        return;
      s = "" + i._wrapperState.initialValue, p || s === i.value || (i.value = s), i.defaultValue = s;
    }
    p = i.name, p !== "" && (i.name = ""), i.defaultChecked = !!i._wrapperState.initialChecked, p !== "" && (i.name = p);
  }
  function Yr(i, s, p) {
    (s !== "number" || Vt(i.ownerDocument) !== i) && (p == null ? i.defaultValue = "" + i._wrapperState.initialValue : i.defaultValue !== "" + p && (i.defaultValue = "" + p));
  }
  var cr = Array.isArray;
  function ar(i, s, p, y) {
    if (i = i.options, s) {
      s = {};
      for (var S = 0; S < p.length; S++)
        s["$" + p[S]] = !0;
      for (p = 0; p < i.length; p++)
        S = s.hasOwnProperty("$" + i[p].value), i[p].selected !== S && (i[p].selected = S), S && y && (i[p].defaultSelected = !0);
    } else {
      for (p = "" + wt(p), s = null, S = 0; S < i.length; S++) {
        if (i[S].value === p) {
          i[S].selected = !0, y && (i[S].defaultSelected = !0);
          return;
        }
        s !== null || i[S].disabled || (s = i[S]);
      }
      s !== null && (s.selected = !0);
    }
  }
  function Ca(i, s) {
    if (s.dangerouslySetInnerHTML != null)
      throw Error(r(91));
    return z({}, s, { value: void 0, defaultValue: void 0, children: "" + i._wrapperState.initialValue });
  }
  function Zr(i, s) {
    var p = s.value;
    if (p == null) {
      if (p = s.children, s = s.defaultValue, p != null) {
        if (s != null)
          throw Error(r(92));
        if (cr(p)) {
          if (1 < p.length)
            throw Error(r(93));
          p = p[0];
        }
        s = p;
      }
      s == null && (s = ""), p = s;
    }
    i._wrapperState = { initialValue: wt(p) };
  }
  function qa(i, s) {
    var p = wt(s.value), y = wt(s.defaultValue);
    p != null && (p = "" + p, p !== i.value && (i.value = p), s.defaultValue == null && i.defaultValue !== p && (i.defaultValue = p)), y != null && (i.defaultValue = "" + y);
  }
  function Ir(i) {
    var s = i.textContent;
    s === i._wrapperState.initialValue && s !== "" && s !== null && (i.value = s);
  }
  function Ta(i) {
    switch (i) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Gn(i, s) {
    return i == null || i === "http://www.w3.org/1999/xhtml" ? Ta(s) : i === "http://www.w3.org/2000/svg" && s === "foreignObject" ? "http://www.w3.org/1999/xhtml" : i;
  }
  var la, oo = function(i) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(s, p, y, S) {
      MSApp.execUnsafeLocalFunction(function() {
        return i(s, p, y, S);
      });
    } : i;
  }(function(i, s) {
    if (i.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in i)
      i.innerHTML = s;
    else {
      for (la = la || document.createElement("div"), la.innerHTML = "<svg>" + s.valueOf().toString() + "</svg>", s = la.firstChild; i.firstChild; )
        i.removeChild(i.firstChild);
      for (; s.firstChild; )
        i.appendChild(s.firstChild);
    }
  });
  function Wa(i, s) {
    if (s) {
      var p = i.firstChild;
      if (p && p === i.lastChild && p.nodeType === 3) {
        p.nodeValue = s;
        return;
      }
    }
    i.textContent = s;
  }
  var Me = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ot = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Me).forEach(function(i) {
    ot.forEach(function(s) {
      s = s + i.charAt(0).toUpperCase() + i.substring(1), Me[s] = Me[i];
    });
  });
  function $t(i, s, p) {
    return s == null || typeof s == "boolean" || s === "" ? "" : p || typeof s != "number" || s === 0 || Me.hasOwnProperty(i) && Me[i] ? ("" + s).trim() : s + "px";
  }
  function un(i, s) {
    i = i.style;
    for (var p in s)
      if (s.hasOwnProperty(p)) {
        var y = p.indexOf("--") === 0, S = $t(p, s[p], y);
        p === "float" && (p = "cssFloat"), y ? i.setProperty(p, S) : i[p] = S;
      }
  }
  var cn = z({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function ir(i, s) {
    if (s) {
      if (cn[i] && (s.children != null || s.dangerouslySetInnerHTML != null))
        throw Error(r(137, i));
      if (s.dangerouslySetInnerHTML != null) {
        if (s.children != null)
          throw Error(r(60));
        if (typeof s.dangerouslySetInnerHTML != "object" || !("__html" in s.dangerouslySetInnerHTML))
          throw Error(r(61));
      }
      if (s.style != null && typeof s.style != "object")
        throw Error(r(62));
    }
  }
  function qn(i, s) {
    if (i.indexOf("-") === -1)
      return typeof s.is == "string";
    switch (i) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Kr = null;
  function yn(i) {
    return i = i.target || i.srcElement || window, i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === 3 ? i.parentNode : i;
  }
  var ca = null, dn = null, fn = null;
  function Bi(i) {
    if (i = Ud(i)) {
      if (typeof ca != "function")
        throw Error(r(280));
      var s = i.stateNode;
      s && (s = lt(s), ca(i.stateNode, i.type, s));
    }
  }
  function hi(i) {
    dn ? fn ? fn.push(i) : fn = [i] : dn = i;
  }
  function As() {
    if (dn) {
      var i = dn, s = fn;
      if (fn = dn = null, Bi(i), s)
        for (i = 0; i < s.length; i++)
          Bi(s[i]);
    }
  }
  function Mu(i, s) {
    return i(s);
  }
  function Gl() {
  }
  var Uo = !1;
  function Ds(i, s, p) {
    if (Uo)
      return i(s, p);
    Uo = !0;
    try {
      return Mu(i, s, p);
    } finally {
      Uo = !1, (dn !== null || fn !== null) && (Gl(), As());
    }
  }
  function Ya(i, s) {
    var p = i.stateNode;
    if (p === null)
      return null;
    var y = lt(p);
    if (y === null)
      return null;
    p = y[s];
    e:
      switch (s) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (y = !y.disabled) || (i = i.type, y = !(i === "button" || i === "input" || i === "select" || i === "textarea")), i = !y;
          break e;
        default:
          i = !1;
      }
    if (i)
      return null;
    if (p && typeof p != "function")
      throw Error(r(231, s, typeof p));
    return p;
  }
  var so = !1;
  if (m)
    try {
      var Za = {};
      Object.defineProperty(Za, "passive", { get: function() {
        so = !0;
      } }), window.addEventListener("test", Za, Za), window.removeEventListener("test", Za, Za);
    } catch {
      so = !1;
    }
  function uo(i, s, p, y, S, C, D, U, Z) {
    var ue = Array.prototype.slice.call(arguments, 3);
    try {
      s.apply(p, ue);
    } catch (_e) {
      this.onError(_e);
    }
  }
  var da = !1, Ka = null, lo = !1, q = null, Ce = { onError: function(i) {
    da = !0, Ka = i;
  } };
  function $e(i, s, p, y, S, C, D, U, Z) {
    da = !1, Ka = null, uo.apply(Ce, arguments);
  }
  function Ge(i, s, p, y, S, C, D, U, Z) {
    if ($e.apply(this, arguments), da) {
      if (da) {
        var ue = Ka;
        da = !1, Ka = null;
      } else
        throw Error(r(198));
      lo || (lo = !0, q = ue);
    }
  }
  function At(i) {
    var s = i, p = i;
    if (i.alternate)
      for (; s.return; )
        s = s.return;
    else {
      i = s;
      do
        s = i, s.flags & 4098 && (p = s.return), i = s.return;
      while (i);
    }
    return s.tag === 3 ? p : null;
  }
  function Yt(i) {
    if (i.tag === 13) {
      var s = i.memoizedState;
      if (s === null && (i = i.alternate, i !== null && (s = i.memoizedState)), s !== null)
        return s.dehydrated;
    }
    return null;
  }
  function Dt(i) {
    if (At(i) !== i)
      throw Error(r(188));
  }
  function dt(i) {
    var s = i.alternate;
    if (!s) {
      if (s = At(i), s === null)
        throw Error(r(188));
      return s !== i ? null : i;
    }
    for (var p = i, y = s; ; ) {
      var S = p.return;
      if (S === null)
        break;
      var C = S.alternate;
      if (C === null) {
        if (y = S.return, y !== null) {
          p = y;
          continue;
        }
        break;
      }
      if (S.child === C.child) {
        for (C = S.child; C; ) {
          if (C === p)
            return Dt(S), i;
          if (C === y)
            return Dt(S), s;
          C = C.sibling;
        }
        throw Error(r(188));
      }
      if (p.return !== y.return)
        p = S, y = C;
      else {
        for (var D = !1, U = S.child; U; ) {
          if (U === p) {
            D = !0, p = S, y = C;
            break;
          }
          if (U === y) {
            D = !0, y = S, p = C;
            break;
          }
          U = U.sibling;
        }
        if (!D) {
          for (U = C.child; U; ) {
            if (U === p) {
              D = !0, p = C, y = S;
              break;
            }
            if (U === y) {
              D = !0, y = C, p = S;
              break;
            }
            U = U.sibling;
          }
          if (!D)
            throw Error(r(189));
        }
      }
      if (p.alternate !== y)
        throw Error(r(190));
    }
    if (p.tag !== 3)
      throw Error(r(188));
    return p.stateNode.current === p ? i : s;
  }
  function dr(i) {
    return i = dt(i), i !== null ? On(i) : null;
  }
  function On(i) {
    if (i.tag === 5 || i.tag === 6)
      return i;
    for (i = i.child; i !== null; ) {
      var s = On(i);
      if (s !== null)
        return s;
      i = i.sibling;
    }
    return null;
  }
  var Pn = t.unstable_scheduleCallback, Mr = t.unstable_cancelCallback, co = t.unstable_shouldYield, ql = t.unstable_requestPaint, Jt = t.unstable_now, Am = t.unstable_getCurrentPriorityLevel, Ui = t.unstable_ImmediatePriority, Nt = t.unstable_UserBlockingPriority, fo = t.unstable_NormalPriority, Is = t.unstable_LowPriority, Wl = t.unstable_IdlePriority, Ms = null, _a = null;
  function Cd(i) {
    if (_a && typeof _a.onCommitFiberRoot == "function")
      try {
        _a.onCommitFiberRoot(Ms, i, void 0, (i.current.flags & 128) === 128);
      } catch {
      }
  }
  var fa = Math.clz32 ? Math.clz32 : rp, Td = Math.log, _d = Math.LN2;
  function rp(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (Td(i) / _d | 0) | 0;
  }
  var Yl = 64, $s = 4194304;
  function Hi(i) {
    switch (i & -i) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return i & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return i;
    }
  }
  function pa(i, s) {
    var p = i.pendingLanes;
    if (p === 0)
      return 0;
    var y = 0, S = i.suspendedLanes, C = i.pingedLanes, D = p & 268435455;
    if (D !== 0) {
      var U = D & ~S;
      U !== 0 ? y = Hi(U) : (C &= D, C !== 0 && (y = Hi(C)));
    } else
      D = p & ~S, D !== 0 ? y = Hi(D) : C !== 0 && (y = Hi(C));
    if (y === 0)
      return 0;
    if (s !== 0 && s !== y && !(s & S) && (S = y & -y, C = s & -s, S >= C || S === 16 && (C & 4194240) !== 0))
      return s;
    if (y & 4 && (y |= p & 16), s = i.entangledLanes, s !== 0)
      for (i = i.entanglements, s &= y; 0 < s; )
        p = 31 - fa(s), S = 1 << p, y |= i[p], s &= ~S;
    return y;
  }
  function Ls(i, s) {
    switch (i) {
      case 1:
      case 2:
      case 4:
        return s + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return s + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Ns(i, s) {
    for (var p = i.suspendedLanes, y = i.pingedLanes, S = i.expirationTimes, C = i.pendingLanes; 0 < C; ) {
      var D = 31 - fa(C), U = 1 << D, Z = S[D];
      Z === -1 ? (!(U & p) || U & y) && (S[D] = Ls(U, s)) : Z <= s && (i.expiredLanes |= U), C &= ~U;
    }
  }
  function Fs(i) {
    return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
  }
  function Zl() {
    var i = Yl;
    return Yl <<= 1, !(Yl & 4194240) && (Yl = 64), i;
  }
  function Kl(i) {
    for (var s = [], p = 0; 31 > p; p++)
      s.push(i);
    return s;
  }
  function Ho(i, s, p) {
    i.pendingLanes |= s, s !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, s = 31 - fa(s), i[s] = p;
  }
  function Dm(i, s) {
    var p = i.pendingLanes & ~s;
    i.pendingLanes = s, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= s, i.mutableReadLanes &= s, i.entangledLanes &= s, s = i.entanglements;
    var y = i.eventTimes;
    for (i = i.expirationTimes; 0 < p; ) {
      var S = 31 - fa(p), C = 1 << S;
      s[S] = 0, y[S] = -1, i[S] = -1, p &= ~C;
    }
  }
  function po(i, s) {
    var p = i.entangledLanes |= s;
    for (i = i.entanglements; p; ) {
      var y = 31 - fa(p), S = 1 << y;
      S & s | i[y] & s && (i[y] |= s), p &= ~S;
    }
  }
  var rn = 0;
  function Ql(i) {
    return i &= -i, 1 < i ? 4 < i ? i & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var $u, Xl, en, Jl, ec, _t = !1, Lu = [], Wn = null, Ra = null, ha = null, zs = /* @__PURE__ */ new Map(), Jn = /* @__PURE__ */ new Map(), pn = [], ap = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Oa(i, s) {
    switch (i) {
      case "focusin":
      case "focusout":
        Wn = null;
        break;
      case "dragenter":
      case "dragleave":
        Ra = null;
        break;
      case "mouseover":
      case "mouseout":
        ha = null;
        break;
      case "pointerover":
      case "pointerout":
        zs.delete(s.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Jn.delete(s.pointerId);
    }
  }
  function Tr(i, s, p, y, S, C) {
    return i === null || i.nativeEvent !== C ? (i = { blockedOn: s, domEventName: p, eventSystemFlags: y, nativeEvent: C, targetContainers: [S] }, s !== null && (s = Ud(s), s !== null && Xl(s)), i) : (i.eventSystemFlags |= y, s = i.targetContainers, S !== null && s.indexOf(S) === -1 && s.push(S), i);
  }
  function ho(i, s, p, y, S) {
    switch (s) {
      case "focusin":
        return Wn = Tr(Wn, i, s, p, y, S), !0;
      case "dragenter":
        return Ra = Tr(Ra, i, s, p, y, S), !0;
      case "mouseover":
        return ha = Tr(ha, i, s, p, y, S), !0;
      case "pointerover":
        var C = S.pointerId;
        return zs.set(C, Tr(zs.get(C) || null, i, s, p, y, S)), !0;
      case "gotpointercapture":
        return C = S.pointerId, Jn.set(C, Tr(Jn.get(C) || null, i, s, p, y, S)), !0;
    }
    return !1;
  }
  function ip(i) {
    var s = gi(i.target);
    if (s !== null) {
      var p = At(s);
      if (p !== null) {
        if (s = p.tag, s === 13) {
          if (s = Yt(p), s !== null) {
            i.blockedOn = s, ec(i.priority, function() {
              en(p);
            });
            return;
          }
        } else if (s === 3 && p.stateNode.current.memoizedState.isDehydrated) {
          i.blockedOn = p.tag === 3 ? p.stateNode.containerInfo : null;
          return;
        }
      }
    }
    i.blockedOn = null;
  }
  function Vo(i) {
    if (i.blockedOn !== null)
      return !1;
    for (var s = i.targetContainers; 0 < s.length; ) {
      var p = nc(i.domEventName, i.eventSystemFlags, s[0], i.nativeEvent);
      if (p === null) {
        p = i.nativeEvent;
        var y = new p.constructor(p.type, p);
        Kr = y, p.target.dispatchEvent(y), Kr = null;
      } else
        return s = Ud(p), s !== null && Xl(s), i.blockedOn = p, !1;
      s.shift();
    }
    return !0;
  }
  function Bs(i, s, p) {
    Vo(i) && p.delete(s);
  }
  function op() {
    _t = !1, Wn !== null && Vo(Wn) && (Wn = null), Ra !== null && Vo(Ra) && (Ra = null), ha !== null && Vo(ha) && (ha = null), zs.forEach(Bs), Jn.forEach(Bs);
  }
  function mi(i, s) {
    i.blockedOn === s && (i.blockedOn = null, _t || (_t = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, op)));
  }
  function Us(i) {
    function s(S) {
      return mi(S, i);
    }
    if (0 < Lu.length) {
      mi(Lu[0], i);
      for (var p = 1; p < Lu.length; p++) {
        var y = Lu[p];
        y.blockedOn === i && (y.blockedOn = null);
      }
    }
    for (Wn !== null && mi(Wn, i), Ra !== null && mi(Ra, i), ha !== null && mi(ha, i), zs.forEach(s), Jn.forEach(s), p = 0; p < pn.length; p++)
      y = pn[p], y.blockedOn === i && (y.blockedOn = null);
    for (; 0 < pn.length && (p = pn[0], p.blockedOn === null); )
      ip(p), p.blockedOn === null && pn.shift();
  }
  var Hs = B.ReactCurrentBatchConfig, yi = !0;
  function tc(i, s, p, y) {
    var S = rn, C = Hs.transition;
    Hs.transition = null;
    try {
      rn = 1, Gs(i, s, p, y);
    } finally {
      rn = S, Hs.transition = C;
    }
  }
  function Vs(i, s, p, y) {
    var S = rn, C = Hs.transition;
    Hs.transition = null;
    try {
      rn = 4, Gs(i, s, p, y);
    } finally {
      rn = S, Hs.transition = C;
    }
  }
  function Gs(i, s, p, y) {
    if (yi) {
      var S = nc(i, s, p, y);
      if (S === null)
        mp(i, s, y, Nu, p), Oa(i, y);
      else if (ho(S, i, s, p, y))
        y.stopPropagation();
      else if (Oa(i, y), s & 4 && -1 < ap.indexOf(i)) {
        for (; S !== null; ) {
          var C = Ud(S);
          if (C !== null && $u(C), C = nc(i, s, p, y), C === null && mp(i, s, y, Nu, p), C === S)
            break;
          S = C;
        }
        S !== null && y.stopPropagation();
      } else
        mp(i, s, y, null, p);
    }
  }
  var Nu = null;
  function nc(i, s, p, y) {
    if (Nu = null, i = yn(y), i = gi(i), i !== null)
      if (s = At(i), s === null)
        i = null;
      else if (p = s.tag, p === 13) {
        if (i = Yt(s), i !== null)
          return i;
        i = null;
      } else if (p === 3) {
        if (s.stateNode.current.memoizedState.isDehydrated)
          return s.tag === 3 ? s.stateNode.containerInfo : null;
        i = null;
      } else
        s !== i && (i = null);
    return Nu = i, null;
  }
  function Rd(i) {
    switch (i) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Am()) {
          case Ui:
            return 1;
          case Nt:
            return 4;
          case fo:
          case Is:
            return 16;
          case Wl:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Vi = null, A = null, G = null;
  function ae() {
    if (G)
      return G;
    var i, s = A, p = s.length, y, S = "value" in Vi ? Vi.value : Vi.textContent, C = S.length;
    for (i = 0; i < p && s[i] === S[i]; i++)
      ;
    var D = p - i;
    for (y = 1; y <= D && s[p - y] === S[C - y]; y++)
      ;
    return G = S.slice(i, 1 < y ? 1 - y : void 0);
  }
  function he(i) {
    var s = i.keyCode;
    return "charCode" in i ? (i = i.charCode, i === 0 && s === 13 && (i = 13)) : i = s, i === 10 && (i = 13), 32 <= i || i === 13 ? i : 0;
  }
  function Ae() {
    return !0;
  }
  function yt() {
    return !1;
  }
  function Fe(i) {
    function s(p, y, S, C, D) {
      this._reactName = p, this._targetInst = S, this.type = y, this.nativeEvent = C, this.target = D, this.currentTarget = null;
      for (var U in i)
        i.hasOwnProperty(U) && (p = i[U], this[U] = p ? p(C) : C[U]);
      return this.isDefaultPrevented = (C.defaultPrevented != null ? C.defaultPrevented : C.returnValue === !1) ? Ae : yt, this.isPropagationStopped = yt, this;
    }
    return z(s.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var p = this.nativeEvent;
      p && (p.preventDefault ? p.preventDefault() : typeof p.returnValue != "unknown" && (p.returnValue = !1), this.isDefaultPrevented = Ae);
    }, stopPropagation: function() {
      var p = this.nativeEvent;
      p && (p.stopPropagation ? p.stopPropagation() : typeof p.cancelBubble != "unknown" && (p.cancelBubble = !0), this.isPropagationStopped = Ae);
    }, persist: function() {
    }, isPersistent: Ae }), s;
  }
  var ht = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(i) {
    return i.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Ft = Fe(ht), tn = z({}, ht, { view: 0, detail: 0 }), Sn = Fe(tn), vn, kn, jn, Wt = z({}, tn, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Nm, button: 0, buttons: 0, relatedTarget: function(i) {
    return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
  }, movementX: function(i) {
    return "movementX" in i ? i.movementX : (i !== jn && (jn && i.type === "mousemove" ? (vn = i.screenX - jn.screenX, kn = i.screenY - jn.screenY) : kn = vn = 0, jn = i), vn);
  }, movementY: function(i) {
    return "movementY" in i ? i.movementY : kn;
  } }), Go = Fe(Wt), rc = z({}, Wt, { dataTransfer: 0 }), Od = Fe(rc), Im = z({}, tn, { relatedTarget: 0 }), Gi = Fe(Im), Pd = z({}, ht, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), jd = Fe(Pd), Mm = z({}, ht, { clipboardData: function(i) {
    return "clipboardData" in i ? i.clipboardData : window.clipboardData;
  } }), Ix = Fe(Mm), Mx = z({}, ht, { data: 0 }), $m = Fe(Mx), Lm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, E0 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, C0 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function T0(i) {
    var s = this.nativeEvent;
    return s.getModifierState ? s.getModifierState(i) : (i = C0[i]) ? !!s[i] : !1;
  }
  function Nm() {
    return T0;
  }
  var qo = z({}, tn, { key: function(i) {
    if (i.key) {
      var s = Lm[i.key] || i.key;
      if (s !== "Unidentified")
        return s;
    }
    return i.type === "keypress" ? (i = he(i), i === 13 ? "Enter" : String.fromCharCode(i)) : i.type === "keydown" || i.type === "keyup" ? E0[i.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Nm, charCode: function(i) {
    return i.type === "keypress" ? he(i) : 0;
  }, keyCode: function(i) {
    return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  }, which: function(i) {
    return i.type === "keypress" ? he(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  } }), $x = Fe(qo), Fm = z({}, Wt, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), sp = Fe(Fm), zm = z({}, tn, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Nm }), Lx = Fe(zm), up = z({}, ht, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), _0 = Fe(up), Pa = z({}, Wt, {
    deltaX: function(i) {
      return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
    },
    deltaY: function(i) {
      return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Wo = Fe(Pa), fr = [9, 13, 27, 32], qi = m && "CompositionEvent" in window, Fu = null;
  m && "documentMode" in document && (Fu = document.documentMode);
  var lp = m && "TextEvent" in window && !Fu, R0 = m && (!qi || Fu && 8 < Fu && 11 >= Fu), ac = String.fromCharCode(32), O0 = !1;
  function P0(i, s) {
    switch (i) {
      case "keyup":
        return fr.indexOf(s.keyCode) !== -1;
      case "keydown":
        return s.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function cp(i) {
    return i = i.detail, typeof i == "object" && "data" in i ? i.data : null;
  }
  var ic = !1;
  function Nx(i, s) {
    switch (i) {
      case "compositionend":
        return cp(s);
      case "keypress":
        return s.which !== 32 ? null : (O0 = !0, ac);
      case "textInput":
        return i = s.data, i === ac && O0 ? null : i;
      default:
        return null;
    }
  }
  function Fx(i, s) {
    if (ic)
      return i === "compositionend" || !qi && P0(i, s) ? (i = ae(), G = A = Vi = null, ic = !1, i) : null;
    switch (i) {
      case "paste":
        return null;
      case "keypress":
        if (!(s.ctrlKey || s.altKey || s.metaKey) || s.ctrlKey && s.altKey) {
          if (s.char && 1 < s.char.length)
            return s.char;
          if (s.which)
            return String.fromCharCode(s.which);
        }
        return null;
      case "compositionend":
        return R0 && s.locale !== "ko" ? null : s.data;
      default:
        return null;
    }
  }
  var j0 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function A0(i) {
    var s = i && i.nodeName && i.nodeName.toLowerCase();
    return s === "input" ? !!j0[i.type] : s === "textarea";
  }
  function D0(i, s, p, y) {
    hi(y), s = Fd(s, "onChange"), 0 < s.length && (p = new Ft("onChange", "change", null, p, y), i.push({ event: p, listeners: s }));
  }
  var Ad = null, oc = null;
  function sc(i) {
    hp(i, 0);
  }
  function uc(i) {
    var s = cc(i);
    if (Hn(s))
      return i;
  }
  function I0(i, s) {
    if (i === "change")
      return s;
  }
  var Bm = !1;
  if (m) {
    var Um;
    if (m) {
      var Hm = "oninput" in document;
      if (!Hm) {
        var M0 = document.createElement("div");
        M0.setAttribute("oninput", "return;"), Hm = typeof M0.oninput == "function";
      }
      Um = Hm;
    } else
      Um = !1;
    Bm = Um && (!document.documentMode || 9 < document.documentMode);
  }
  function $0() {
    Ad && (Ad.detachEvent("onpropertychange", L0), oc = Ad = null);
  }
  function L0(i) {
    if (i.propertyName === "value" && uc(oc)) {
      var s = [];
      D0(s, oc, i, yn(i)), Ds(sc, s);
    }
  }
  function zx(i, s, p) {
    i === "focusin" ? ($0(), Ad = s, oc = p, Ad.attachEvent("onpropertychange", L0)) : i === "focusout" && $0();
  }
  function Bx(i) {
    if (i === "selectionchange" || i === "keyup" || i === "keydown")
      return uc(oc);
  }
  function Ux(i, s) {
    if (i === "click")
      return uc(s);
  }
  function N0(i, s) {
    if (i === "input" || i === "change")
      return uc(s);
  }
  function Hx(i, s) {
    return i === s && (i !== 0 || 1 / i === 1 / s) || i !== i && s !== s;
  }
  var vi = typeof Object.is == "function" ? Object.is : Hx;
  function Dd(i, s) {
    if (vi(i, s))
      return !0;
    if (typeof i != "object" || i === null || typeof s != "object" || s === null)
      return !1;
    var p = Object.keys(i), y = Object.keys(s);
    if (p.length !== y.length)
      return !1;
    for (y = 0; y < p.length; y++) {
      var S = p[y];
      if (!v.call(s, S) || !vi(i[S], s[S]))
        return !1;
    }
    return !0;
  }
  function F0(i) {
    for (; i && i.firstChild; )
      i = i.firstChild;
    return i;
  }
  function z0(i, s) {
    var p = F0(i);
    i = 0;
    for (var y; p; ) {
      if (p.nodeType === 3) {
        if (y = i + p.textContent.length, i <= s && y >= s)
          return { node: p, offset: s - i };
        i = y;
      }
      e: {
        for (; p; ) {
          if (p.nextSibling) {
            p = p.nextSibling;
            break e;
          }
          p = p.parentNode;
        }
        p = void 0;
      }
      p = F0(p);
    }
  }
  function B0(i, s) {
    return i && s ? i === s ? !0 : i && i.nodeType === 3 ? !1 : s && s.nodeType === 3 ? B0(i, s.parentNode) : "contains" in i ? i.contains(s) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(s) & 16) : !1 : !1;
  }
  function dp() {
    for (var i = window, s = Vt(); s instanceof i.HTMLIFrameElement; ) {
      try {
        var p = typeof s.contentWindow.location.href == "string";
      } catch {
        p = !1;
      }
      if (p)
        i = s.contentWindow;
      else
        break;
      s = Vt(i.document);
    }
    return s;
  }
  function Yo(i) {
    var s = i && i.nodeName && i.nodeName.toLowerCase();
    return s && (s === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || s === "textarea" || i.contentEditable === "true");
  }
  function fp(i) {
    var s = dp(), p = i.focusedElem, y = i.selectionRange;
    if (s !== p && p && p.ownerDocument && B0(p.ownerDocument.documentElement, p)) {
      if (y !== null && Yo(p)) {
        if (s = y.start, i = y.end, i === void 0 && (i = s), "selectionStart" in p)
          p.selectionStart = s, p.selectionEnd = Math.min(i, p.value.length);
        else if (i = (s = p.ownerDocument || document) && s.defaultView || window, i.getSelection) {
          i = i.getSelection();
          var S = p.textContent.length, C = Math.min(y.start, S);
          y = y.end === void 0 ? C : Math.min(y.end, S), !i.extend && C > y && (S = y, y = C, C = S), S = z0(p, C);
          var D = z0(
            p,
            y
          );
          S && D && (i.rangeCount !== 1 || i.anchorNode !== S.node || i.anchorOffset !== S.offset || i.focusNode !== D.node || i.focusOffset !== D.offset) && (s = s.createRange(), s.setStart(S.node, S.offset), i.removeAllRanges(), C > y ? (i.addRange(s), i.extend(D.node, D.offset)) : (s.setEnd(D.node, D.offset), i.addRange(s)));
        }
      }
      for (s = [], i = p; i = i.parentNode; )
        i.nodeType === 1 && s.push({ element: i, left: i.scrollLeft, top: i.scrollTop });
      for (typeof p.focus == "function" && p.focus(), p = 0; p < s.length; p++)
        i = s[p], i.element.scrollLeft = i.left, i.element.scrollTop = i.top;
    }
  }
  var U0 = m && "documentMode" in document && 11 >= document.documentMode, Wi = null, Vm = null, Id = null, Gm = !1;
  function H0(i, s, p) {
    var y = p.window === p ? p.document : p.nodeType === 9 ? p : p.ownerDocument;
    Gm || Wi == null || Wi !== Vt(y) || (y = Wi, "selectionStart" in y && Yo(y) ? y = { start: y.selectionStart, end: y.selectionEnd } : (y = (y.ownerDocument && y.ownerDocument.defaultView || window).getSelection(), y = { anchorNode: y.anchorNode, anchorOffset: y.anchorOffset, focusNode: y.focusNode, focusOffset: y.focusOffset }), Id && Dd(Id, y) || (Id = y, y = Fd(Vm, "onSelect"), 0 < y.length && (s = new Ft("onSelect", "select", null, s, p), i.push({ event: s, listeners: y }), s.target = Wi)));
  }
  function pp(i, s) {
    var p = {};
    return p[i.toLowerCase()] = s.toLowerCase(), p["Webkit" + i] = "webkit" + s, p["Moz" + i] = "moz" + s, p;
  }
  var zu = { animationend: pp("Animation", "AnimationEnd"), animationiteration: pp("Animation", "AnimationIteration"), animationstart: pp("Animation", "AnimationStart"), transitionend: pp("Transition", "TransitionEnd") }, qm = {}, Wm = {};
  m && (Wm = document.createElement("div").style, "AnimationEvent" in window || (delete zu.animationend.animation, delete zu.animationiteration.animation, delete zu.animationstart.animation), "TransitionEvent" in window || delete zu.transitionend.transition);
  function _r(i) {
    if (qm[i])
      return qm[i];
    if (!zu[i])
      return i;
    var s = zu[i], p;
    for (p in s)
      if (s.hasOwnProperty(p) && p in Wm)
        return qm[i] = s[p];
    return i;
  }
  var Ym = _r("animationend"), V0 = _r("animationiteration"), G0 = _r("animationstart"), q0 = _r("transitionend"), W0 = /* @__PURE__ */ new Map(), Y0 = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Zo(i, s) {
    W0.set(i, s), d(s, [i]);
  }
  for (var Md = 0; Md < Y0.length; Md++) {
    var Bu = Y0[Md], Vx = Bu.toLowerCase(), $d = Bu[0].toUpperCase() + Bu.slice(1);
    Zo(Vx, "on" + $d);
  }
  Zo(Ym, "onAnimationEnd"), Zo(V0, "onAnimationIteration"), Zo(G0, "onAnimationStart"), Zo("dblclick", "onDoubleClick"), Zo("focusin", "onFocus"), Zo("focusout", "onBlur"), Zo(q0, "onTransitionEnd"), f("onMouseEnter", ["mouseout", "mouseover"]), f("onMouseLeave", ["mouseout", "mouseover"]), f("onPointerEnter", ["pointerout", "pointerover"]), f("onPointerLeave", ["pointerout", "pointerover"]), d("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), d("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), d("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), d("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), d("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), d("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Ld = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Gx = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ld));
  function Z0(i, s, p) {
    var y = i.type || "unknown-event";
    i.currentTarget = p, Ge(y, s, void 0, i), i.currentTarget = null;
  }
  function hp(i, s) {
    s = (s & 4) !== 0;
    for (var p = 0; p < i.length; p++) {
      var y = i[p], S = y.event;
      y = y.listeners;
      e: {
        var C = void 0;
        if (s)
          for (var D = y.length - 1; 0 <= D; D--) {
            var U = y[D], Z = U.instance, ue = U.currentTarget;
            if (U = U.listener, Z !== C && S.isPropagationStopped())
              break e;
            Z0(S, U, ue), C = Z;
          }
        else
          for (D = 0; D < y.length; D++) {
            if (U = y[D], Z = U.instance, ue = U.currentTarget, U = U.listener, Z !== C && S.isPropagationStopped())
              break e;
            Z0(S, U, ue), C = Z;
          }
      }
    }
    if (lo)
      throw i = q, lo = !1, q = null, i;
  }
  function En(i, s) {
    var p = s[ty];
    p === void 0 && (p = s[ty] = /* @__PURE__ */ new Set());
    var y = i + "__bubble";
    p.has(y) || (K0(s, i, 2, !1), p.add(y));
  }
  function qs(i, s, p) {
    var y = 0;
    s && (y |= 4), K0(p, i, y, s);
  }
  var Ko = "_reactListening" + Math.random().toString(36).slice(2);
  function lc(i) {
    if (!i[Ko]) {
      i[Ko] = !0, o.forEach(function(p) {
        p !== "selectionchange" && (Gx.has(p) || qs(p, !1, i), qs(p, !0, i));
      });
      var s = i.nodeType === 9 ? i : i.ownerDocument;
      s === null || s[Ko] || (s[Ko] = !0, qs("selectionchange", !1, s));
    }
  }
  function K0(i, s, p, y) {
    switch (Rd(s)) {
      case 1:
        var S = tc;
        break;
      case 4:
        S = Vs;
        break;
      default:
        S = Gs;
    }
    p = S.bind(null, s, p, i), S = void 0, !so || s !== "touchstart" && s !== "touchmove" && s !== "wheel" || (S = !0), y ? S !== void 0 ? i.addEventListener(s, p, { capture: !0, passive: S }) : i.addEventListener(s, p, !0) : S !== void 0 ? i.addEventListener(s, p, { passive: S }) : i.addEventListener(s, p, !1);
  }
  function mp(i, s, p, y, S) {
    var C = y;
    if (!(s & 1) && !(s & 2) && y !== null)
      e:
        for (; ; ) {
          if (y === null)
            return;
          var D = y.tag;
          if (D === 3 || D === 4) {
            var U = y.stateNode.containerInfo;
            if (U === S || U.nodeType === 8 && U.parentNode === S)
              break;
            if (D === 4)
              for (D = y.return; D !== null; ) {
                var Z = D.tag;
                if ((Z === 3 || Z === 4) && (Z = D.stateNode.containerInfo, Z === S || Z.nodeType === 8 && Z.parentNode === S))
                  return;
                D = D.return;
              }
            for (; U !== null; ) {
              if (D = gi(U), D === null)
                return;
              if (Z = D.tag, Z === 5 || Z === 6) {
                y = C = D;
                continue e;
              }
              U = U.parentNode;
            }
          }
          y = y.return;
        }
    Ds(function() {
      var ue = C, _e = yn(p), Oe = [];
      e: {
        var Te = W0.get(i);
        if (Te !== void 0) {
          var Ue = Ft, Je = i;
          switch (i) {
            case "keypress":
              if (he(p) === 0)
                break e;
            case "keydown":
            case "keyup":
              Ue = $x;
              break;
            case "focusin":
              Je = "focus", Ue = Gi;
              break;
            case "focusout":
              Je = "blur", Ue = Gi;
              break;
            case "beforeblur":
            case "afterblur":
              Ue = Gi;
              break;
            case "click":
              if (p.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ue = Go;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ue = Od;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ue = Lx;
              break;
            case Ym:
            case V0:
            case G0:
              Ue = jd;
              break;
            case q0:
              Ue = _0;
              break;
            case "scroll":
              Ue = Sn;
              break;
            case "wheel":
              Ue = Wo;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ue = Ix;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ue = sp;
          }
          var nt = (s & 4) !== 0, sr = !nt && i === "scroll", J = nt ? Te !== null ? Te + "Capture" : null : Te;
          nt = [];
          for (var Q = ue, ne; Q !== null; ) {
            ne = Q;
            var Ie = ne.stateNode;
            if (ne.tag === 5 && Ie !== null && (ne = Ie, J !== null && (Ie = Ya(Q, J), Ie != null && nt.push(Nd(Q, Ie, ne)))), sr)
              break;
            Q = Q.return;
          }
          0 < nt.length && (Te = new Ue(Te, Je, null, p, _e), Oe.push({ event: Te, listeners: nt }));
        }
      }
      if (!(s & 7)) {
        e: {
          if (Te = i === "mouseover" || i === "pointerover", Ue = i === "mouseout" || i === "pointerout", Te && p !== Kr && (Je = p.relatedTarget || p.fromElement) && (gi(Je) || Je[Qo]))
            break e;
          if ((Ue || Te) && (Te = _e.window === _e ? _e : (Te = _e.ownerDocument) ? Te.defaultView || Te.parentWindow : window, Ue ? (Je = p.relatedTarget || p.toElement, Ue = ue, Je = Je ? gi(Je) : null, Je !== null && (sr = At(Je), Je !== sr || Je.tag !== 5 && Je.tag !== 6) && (Je = null)) : (Ue = null, Je = ue), Ue !== Je)) {
            if (nt = Go, Ie = "onMouseLeave", J = "onMouseEnter", Q = "mouse", (i === "pointerout" || i === "pointerover") && (nt = sp, Ie = "onPointerLeave", J = "onPointerEnter", Q = "pointer"), sr = Ue == null ? Te : cc(Ue), ne = Je == null ? Te : cc(Je), Te = new nt(Ie, Q + "leave", Ue, p, _e), Te.target = sr, Te.relatedTarget = ne, Ie = null, gi(_e) === ue && (nt = new nt(J, Q + "enter", Je, p, _e), nt.target = ne, nt.relatedTarget = sr, Ie = nt), sr = Ie, Ue && Je)
              t: {
                for (nt = Ue, J = Je, Q = 0, ne = nt; ne; ne = Uu(ne))
                  Q++;
                for (ne = 0, Ie = J; Ie; Ie = Uu(Ie))
                  ne++;
                for (; 0 < Q - ne; )
                  nt = Uu(nt), Q--;
                for (; 0 < ne - Q; )
                  J = Uu(J), ne--;
                for (; Q--; ) {
                  if (nt === J || J !== null && nt === J.alternate)
                    break t;
                  nt = Uu(nt), J = Uu(J);
                }
                nt = null;
              }
            else
              nt = null;
            Ue !== null && Zm(Oe, Te, Ue, nt, !1), Je !== null && sr !== null && Zm(Oe, sr, Je, nt, !0);
          }
        }
        e: {
          if (Te = ue ? cc(ue) : window, Ue = Te.nodeName && Te.nodeName.toLowerCase(), Ue === "select" || Ue === "input" && Te.type === "file")
            var rt = I0;
          else if (A0(Te))
            if (Bm)
              rt = N0;
            else {
              rt = Bx;
              var et = zx;
            }
          else
            (Ue = Te.nodeName) && Ue.toLowerCase() === "input" && (Te.type === "checkbox" || Te.type === "radio") && (rt = Ux);
          if (rt && (rt = rt(i, ue))) {
            D0(Oe, rt, p, _e);
            break e;
          }
          et && et(i, Te, ue), i === "focusout" && (et = Te._wrapperState) && et.controlled && Te.type === "number" && Yr(Te, "number", Te.value);
        }
        switch (et = ue ? cc(ue) : window, i) {
          case "focusin":
            (A0(et) || et.contentEditable === "true") && (Wi = et, Vm = ue, Id = null);
            break;
          case "focusout":
            Id = Vm = Wi = null;
            break;
          case "mousedown":
            Gm = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Gm = !1, H0(Oe, p, _e);
            break;
          case "selectionchange":
            if (U0)
              break;
          case "keydown":
          case "keyup":
            H0(Oe, p, _e);
        }
        var st;
        if (qi)
          e: {
            switch (i) {
              case "compositionstart":
                var Ct = "onCompositionStart";
                break e;
              case "compositionend":
                Ct = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Ct = "onCompositionUpdate";
                break e;
            }
            Ct = void 0;
          }
        else
          ic ? P0(i, p) && (Ct = "onCompositionEnd") : i === "keydown" && p.keyCode === 229 && (Ct = "onCompositionStart");
        Ct && (R0 && p.locale !== "ko" && (ic || Ct !== "onCompositionStart" ? Ct === "onCompositionEnd" && ic && (st = ae()) : (Vi = _e, A = "value" in Vi ? Vi.value : Vi.textContent, ic = !0)), et = Fd(ue, Ct), 0 < et.length && (Ct = new $m(Ct, i, null, p, _e), Oe.push({ event: Ct, listeners: et }), st ? Ct.data = st : (st = cp(p), st !== null && (Ct.data = st)))), (st = lp ? Nx(i, p) : Fx(i, p)) && (ue = Fd(ue, "onBeforeInput"), 0 < ue.length && (_e = new $m("onBeforeInput", "beforeinput", null, p, _e), Oe.push({ event: _e, listeners: ue }), _e.data = st));
      }
      hp(Oe, s);
    });
  }
  function Nd(i, s, p) {
    return { instance: i, listener: s, currentTarget: p };
  }
  function Fd(i, s) {
    for (var p = s + "Capture", y = []; i !== null; ) {
      var S = i, C = S.stateNode;
      S.tag === 5 && C !== null && (S = C, C = Ya(i, p), C != null && y.unshift(Nd(i, C, S)), C = Ya(i, s), C != null && y.push(Nd(i, C, S))), i = i.return;
    }
    return y;
  }
  function Uu(i) {
    if (i === null)
      return null;
    do
      i = i.return;
    while (i && i.tag !== 5);
    return i || null;
  }
  function Zm(i, s, p, y, S) {
    for (var C = s._reactName, D = []; p !== null && p !== y; ) {
      var U = p, Z = U.alternate, ue = U.stateNode;
      if (Z !== null && Z === y)
        break;
      U.tag === 5 && ue !== null && (U = ue, S ? (Z = Ya(p, C), Z != null && D.unshift(Nd(p, Z, U))) : S || (Z = Ya(p, C), Z != null && D.push(Nd(p, Z, U)))), p = p.return;
    }
    D.length !== 0 && i.push({ event: s, listeners: D });
  }
  var Km = /\r\n?/g, qx = /\u0000|\uFFFD/g;
  function Qm(i) {
    return (typeof i == "string" ? i : "" + i).replace(Km, `
`).replace(qx, "");
  }
  function yp(i, s, p) {
    if (s = Qm(s), Qm(i) !== s && p)
      throw Error(r(425));
  }
  function vp() {
  }
  var Xm = null, Hu = null;
  function zd(i, s) {
    return i === "textarea" || i === "noscript" || typeof s.children == "string" || typeof s.children == "number" || typeof s.dangerouslySetInnerHTML == "object" && s.dangerouslySetInnerHTML !== null && s.dangerouslySetInnerHTML.__html != null;
  }
  var Vu = typeof setTimeout == "function" ? setTimeout : void 0, Q0 = typeof clearTimeout == "function" ? clearTimeout : void 0, Jm = typeof Promise == "function" ? Promise : void 0, ey = typeof queueMicrotask == "function" ? queueMicrotask : typeof Jm < "u" ? function(i) {
    return Jm.resolve(null).then(i).catch(Wx);
  } : Vu;
  function Wx(i) {
    setTimeout(function() {
      throw i;
    });
  }
  function Ws(i, s) {
    var p = s, y = 0;
    do {
      var S = p.nextSibling;
      if (i.removeChild(p), S && S.nodeType === 8)
        if (p = S.data, p === "/$") {
          if (y === 0) {
            i.removeChild(S), Us(s);
            return;
          }
          y--;
        } else
          p !== "$" && p !== "$?" && p !== "$!" || y++;
      p = S;
    } while (p);
    Us(s);
  }
  function Yi(i) {
    for (; i != null; i = i.nextSibling) {
      var s = i.nodeType;
      if (s === 1 || s === 3)
        break;
      if (s === 8) {
        if (s = i.data, s === "$" || s === "$!" || s === "$?")
          break;
        if (s === "/$")
          return null;
      }
    }
    return i;
  }
  function Bd(i) {
    i = i.previousSibling;
    for (var s = 0; i; ) {
      if (i.nodeType === 8) {
        var p = i.data;
        if (p === "$" || p === "$!" || p === "$?") {
          if (s === 0)
            return i;
          s--;
        } else
          p === "/$" && s++;
      }
      i = i.previousSibling;
    }
    return null;
  }
  var Ys = Math.random().toString(36).slice(2), mo = "__reactFiber$" + Ys, Gu = "__reactProps$" + Ys, Qo = "__reactContainer$" + Ys, ty = "__reactEvents$" + Ys, Yx = "__reactListeners$" + Ys, ny = "__reactHandles$" + Ys;
  function gi(i) {
    var s = i[mo];
    if (s)
      return s;
    for (var p = i.parentNode; p; ) {
      if (s = p[Qo] || p[mo]) {
        if (p = s.alternate, s.child !== null || p !== null && p.child !== null)
          for (i = Bd(i); i !== null; ) {
            if (p = i[mo])
              return p;
            i = Bd(i);
          }
        return s;
      }
      i = p, p = i.parentNode;
    }
    return null;
  }
  function Ud(i) {
    return i = i[mo] || i[Qo], !i || i.tag !== 5 && i.tag !== 6 && i.tag !== 13 && i.tag !== 3 ? null : i;
  }
  function cc(i) {
    if (i.tag === 5 || i.tag === 6)
      return i.stateNode;
    throw Error(r(33));
  }
  function lt(i) {
    return i[Gu] || null;
  }
  var Zs = [], Dn = -1;
  function It(i) {
    return { current: i };
  }
  function ln(i) {
    0 > Dn || (i.current = Zs[Dn], Zs[Dn] = null, Dn--);
  }
  function hn(i, s) {
    Dn++, Zs[Dn] = i.current, i.current = s;
  }
  var yo = {}, Et = It(yo), er = It(!1), ja = yo;
  function bi(i, s) {
    var p = i.type.contextTypes;
    if (!p)
      return yo;
    var y = i.stateNode;
    if (y && y.__reactInternalMemoizedUnmaskedChildContext === s)
      return y.__reactInternalMemoizedMaskedChildContext;
    var S = {}, C;
    for (C in p)
      S[C] = s[C];
    return y && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = s, i.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function Fn(i) {
    return i = i.childContextTypes, i != null;
  }
  function wi() {
    ln(er), ln(Et);
  }
  function Ks(i, s, p) {
    if (Et.current !== yo)
      throw Error(r(168));
    hn(Et, s), hn(er, p);
  }
  function Hd(i, s, p) {
    var y = i.stateNode;
    if (s = s.childContextTypes, typeof y.getChildContext != "function")
      return p;
    y = y.getChildContext();
    for (var S in y)
      if (!(S in s))
        throw Error(r(108, ut(i) || "Unknown", S));
    return z({}, p, y);
  }
  function gp(i) {
    return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || yo, ja = Et.current, hn(Et, i), hn(er, er.current), !0;
  }
  function X0(i, s, p) {
    var y = i.stateNode;
    if (!y)
      throw Error(r(169));
    p ? (i = Hd(i, s, ja), y.__reactInternalMemoizedMergedChildContext = i, ln(er), ln(Et), hn(Et, i)) : ln(er), hn(er, p);
  }
  var Qa = null, Rr = !1, Vd = !1;
  function ry(i) {
    Qa === null ? Qa = [i] : Qa.push(i);
  }
  function ay(i) {
    Rr = !0, ry(i);
  }
  function Aa() {
    if (!Vd && Qa !== null) {
      Vd = !0;
      var i = 0, s = rn;
      try {
        var p = Qa;
        for (rn = 1; i < p.length; i++) {
          var y = p[i];
          do
            y = y(!0);
          while (y !== null);
        }
        Qa = null, Rr = !1;
      } catch (S) {
        throw Qa !== null && (Qa = Qa.slice(i + 1)), Pn(Ui, Aa), S;
      } finally {
        rn = s, Vd = !1;
      }
    }
    return null;
  }
  var Qs = [], Da = 0, qu = null, dc = 0, Ia = [], Qr = 0, xi = null, $r = 1, Xo = "";
  function Xa(i, s) {
    Qs[Da++] = dc, Qs[Da++] = qu, qu = i, dc = s;
  }
  function iy(i, s, p) {
    Ia[Qr++] = $r, Ia[Qr++] = Xo, Ia[Qr++] = xi, xi = i;
    var y = $r;
    i = Xo;
    var S = 32 - fa(y) - 1;
    y &= ~(1 << S), p += 1;
    var C = 32 - fa(s) + S;
    if (30 < C) {
      var D = S - S % 5;
      C = (y & (1 << D) - 1).toString(32), y >>= D, S -= D, $r = 1 << 32 - fa(s) + S | p << S | y, Xo = C + i;
    } else
      $r = 1 << C | p << S | y, Xo = i;
  }
  function bp(i) {
    i.return !== null && (Xa(i, 1), iy(i, 1, 0));
  }
  function oy(i) {
    for (; i === qu; )
      qu = Qs[--Da], Qs[Da] = null, dc = Qs[--Da], Qs[Da] = null;
    for (; i === xi; )
      xi = Ia[--Qr], Ia[Qr] = null, Xo = Ia[--Qr], Ia[Qr] = null, $r = Ia[--Qr], Ia[Qr] = null;
  }
  var Ja = null, Ma = null, In = !1, Si = null;
  function sy(i, s) {
    var p = Ri(5, null, null, 0);
    p.elementType = "DELETED", p.stateNode = s, p.return = i, s = i.deletions, s === null ? (i.deletions = [p], i.flags |= 16) : s.push(p);
  }
  function J0(i, s) {
    switch (i.tag) {
      case 5:
        var p = i.type;
        return s = s.nodeType !== 1 || p.toLowerCase() !== s.nodeName.toLowerCase() ? null : s, s !== null ? (i.stateNode = s, Ja = i, Ma = Yi(s.firstChild), !0) : !1;
      case 6:
        return s = i.pendingProps === "" || s.nodeType !== 3 ? null : s, s !== null ? (i.stateNode = s, Ja = i, Ma = null, !0) : !1;
      case 13:
        return s = s.nodeType !== 8 ? null : s, s !== null ? (p = xi !== null ? { id: $r, overflow: Xo } : null, i.memoizedState = { dehydrated: s, treeContext: p, retryLane: 1073741824 }, p = Ri(18, null, null, 0), p.stateNode = s, p.return = i, i.child = p, Ja = i, Ma = null, !0) : !1;
      default:
        return !1;
    }
  }
  function wp(i) {
    return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
  }
  function xp(i) {
    if (In) {
      var s = Ma;
      if (s) {
        var p = s;
        if (!J0(i, s)) {
          if (wp(i))
            throw Error(r(418));
          s = Yi(p.nextSibling);
          var y = Ja;
          s && J0(i, s) ? sy(y, p) : (i.flags = i.flags & -4097 | 2, In = !1, Ja = i);
        }
      } else {
        if (wp(i))
          throw Error(r(418));
        i.flags = i.flags & -4097 | 2, In = !1, Ja = i;
      }
    }
  }
  function eb(i) {
    for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; )
      i = i.return;
    Ja = i;
  }
  function Sp(i) {
    if (i !== Ja)
      return !1;
    if (!In)
      return eb(i), In = !0, !1;
    var s;
    if ((s = i.tag !== 3) && !(s = i.tag !== 5) && (s = i.type, s = s !== "head" && s !== "body" && !zd(i.type, i.memoizedProps)), s && (s = Ma)) {
      if (wp(i))
        throw tb(), Error(r(418));
      for (; s; )
        sy(i, s), s = Yi(s.nextSibling);
    }
    if (eb(i), i.tag === 13) {
      if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i)
        throw Error(r(317));
      e: {
        for (i = i.nextSibling, s = 0; i; ) {
          if (i.nodeType === 8) {
            var p = i.data;
            if (p === "/$") {
              if (s === 0) {
                Ma = Yi(i.nextSibling);
                break e;
              }
              s--;
            } else
              p !== "$" && p !== "$!" && p !== "$?" || s++;
          }
          i = i.nextSibling;
        }
        Ma = null;
      }
    } else
      Ma = Ja ? Yi(i.stateNode.nextSibling) : null;
    return !0;
  }
  function tb() {
    for (var i = Ma; i; )
      i = Yi(i.nextSibling);
  }
  function Yn() {
    Ma = Ja = null, In = !1;
  }
  function uy(i) {
    Si === null ? Si = [i] : Si.push(i);
  }
  var kp = B.ReactCurrentBatchConfig;
  function ei(i, s) {
    if (i && i.defaultProps) {
      s = z({}, s), i = i.defaultProps;
      for (var p in i)
        s[p] === void 0 && (s[p] = i[p]);
      return s;
    }
    return s;
  }
  var vo = It(null), Ep = null, Xs = null, ly = null;
  function cy() {
    ly = Xs = Ep = null;
  }
  function Js(i) {
    var s = vo.current;
    ln(vo), i._currentValue = s;
  }
  function Or(i, s, p) {
    for (; i !== null; ) {
      var y = i.alternate;
      if ((i.childLanes & s) !== s ? (i.childLanes |= s, y !== null && (y.childLanes |= s)) : y !== null && (y.childLanes & s) !== s && (y.childLanes |= s), i === p)
        break;
      i = i.return;
    }
  }
  function Le(i, s) {
    Ep = i, ly = Xs = null, i = i.dependencies, i !== null && i.firstContext !== null && (i.lanes & s && (pr = !0), i.firstContext = null);
  }
  function or(i) {
    var s = i._currentValue;
    if (ly !== i)
      if (i = { context: i, memoizedValue: s, next: null }, Xs === null) {
        if (Ep === null)
          throw Error(r(308));
        Xs = i, Ep.dependencies = { lanes: 0, firstContext: i };
      } else
        Xs = Xs.next = i;
    return s;
  }
  var Lr = null;
  function dy(i) {
    Lr === null ? Lr = [i] : Lr.push(i);
  }
  function nb(i, s, p, y) {
    var S = s.interleaved;
    return S === null ? (p.next = p, dy(s)) : (p.next = S.next, S.next = p), s.interleaved = p, Jo(i, y);
  }
  function Jo(i, s) {
    i.lanes |= s;
    var p = i.alternate;
    for (p !== null && (p.lanes |= s), p = i, i = i.return; i !== null; )
      i.childLanes |= s, p = i.alternate, p !== null && (p.childLanes |= s), p = i, i = i.return;
    return p.tag === 3 ? p.stateNode : null;
  }
  var eu = !1;
  function fy(i) {
    i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function yr(i, s) {
    i = i.updateQueue, s.updateQueue === i && (s.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
  }
  function es(i, s) {
    return { eventTime: i, lane: s, tag: 0, payload: null, callback: null, next: null };
  }
  function tu(i, s, p) {
    var y = i.updateQueue;
    if (y === null)
      return null;
    if (y = y.shared, Gt & 2) {
      var S = y.pending;
      return S === null ? s.next = s : (s.next = S.next, S.next = s), y.pending = s, Jo(i, p);
    }
    return S = y.interleaved, S === null ? (s.next = s, dy(y)) : (s.next = S.next, S.next = s), y.interleaved = s, Jo(i, p);
  }
  function Cp(i, s, p) {
    if (s = s.updateQueue, s !== null && (s = s.shared, (p & 4194240) !== 0)) {
      var y = s.lanes;
      y &= i.pendingLanes, p |= y, s.lanes = p, po(i, p);
    }
  }
  function py(i, s) {
    var p = i.updateQueue, y = i.alternate;
    if (y !== null && (y = y.updateQueue, p === y)) {
      var S = null, C = null;
      if (p = p.firstBaseUpdate, p !== null) {
        do {
          var D = { eventTime: p.eventTime, lane: p.lane, tag: p.tag, payload: p.payload, callback: p.callback, next: null };
          C === null ? S = C = D : C = C.next = D, p = p.next;
        } while (p !== null);
        C === null ? S = C = s : C = C.next = s;
      } else
        S = C = s;
      p = { baseState: y.baseState, firstBaseUpdate: S, lastBaseUpdate: C, shared: y.shared, effects: y.effects }, i.updateQueue = p;
      return;
    }
    i = p.lastBaseUpdate, i === null ? p.firstBaseUpdate = s : i.next = s, p.lastBaseUpdate = s;
  }
  function nu(i, s, p, y) {
    var S = i.updateQueue;
    eu = !1;
    var C = S.firstBaseUpdate, D = S.lastBaseUpdate, U = S.shared.pending;
    if (U !== null) {
      S.shared.pending = null;
      var Z = U, ue = Z.next;
      Z.next = null, D === null ? C = ue : D.next = ue, D = Z;
      var _e = i.alternate;
      _e !== null && (_e = _e.updateQueue, U = _e.lastBaseUpdate, U !== D && (U === null ? _e.firstBaseUpdate = ue : U.next = ue, _e.lastBaseUpdate = Z));
    }
    if (C !== null) {
      var Oe = S.baseState;
      D = 0, _e = ue = Z = null, U = C;
      do {
        var Te = U.lane, Ue = U.eventTime;
        if ((y & Te) === Te) {
          _e !== null && (_e = _e.next = {
            eventTime: Ue,
            lane: 0,
            tag: U.tag,
            payload: U.payload,
            callback: U.callback,
            next: null
          });
          e: {
            var Je = i, nt = U;
            switch (Te = s, Ue = p, nt.tag) {
              case 1:
                if (Je = nt.payload, typeof Je == "function") {
                  Oe = Je.call(Ue, Oe, Te);
                  break e;
                }
                Oe = Je;
                break e;
              case 3:
                Je.flags = Je.flags & -65537 | 128;
              case 0:
                if (Je = nt.payload, Te = typeof Je == "function" ? Je.call(Ue, Oe, Te) : Je, Te == null)
                  break e;
                Oe = z({}, Oe, Te);
                break e;
              case 2:
                eu = !0;
            }
          }
          U.callback !== null && U.lane !== 0 && (i.flags |= 64, Te = S.effects, Te === null ? S.effects = [U] : Te.push(U));
        } else
          Ue = { eventTime: Ue, lane: Te, tag: U.tag, payload: U.payload, callback: U.callback, next: null }, _e === null ? (ue = _e = Ue, Z = Oe) : _e = _e.next = Ue, D |= Te;
        if (U = U.next, U === null) {
          if (U = S.shared.pending, U === null)
            break;
          Te = U, U = Te.next, Te.next = null, S.lastBaseUpdate = Te, S.shared.pending = null;
        }
      } while (1);
      if (_e === null && (Z = Oe), S.baseState = Z, S.firstBaseUpdate = ue, S.lastBaseUpdate = _e, s = S.shared.interleaved, s !== null) {
        S = s;
        do
          D |= S.lane, S = S.next;
        while (S !== s);
      } else
        C === null && (S.shared.lanes = 0);
      as |= D, i.lanes = D, i.memoizedState = Oe;
    }
  }
  function Wu(i, s, p) {
    if (i = s.effects, s.effects = null, i !== null)
      for (s = 0; s < i.length; s++) {
        var y = i[s], S = y.callback;
        if (S !== null) {
          if (y.callback = null, y = p, typeof S != "function")
            throw Error(r(191, S));
          S.call(y);
        }
      }
  }
  var rb = new e.Component().refs;
  function hy(i, s, p, y) {
    s = i.memoizedState, p = p(y, s), p = p == null ? s : z({}, s, p), i.memoizedState = p, i.lanes === 0 && (i.updateQueue.baseState = p);
  }
  var Tp = { isMounted: function(i) {
    return (i = i._reactInternals) ? At(i) === i : !1;
  }, enqueueSetState: function(i, s, p) {
    i = i._reactInternals;
    var y = ta(), S = hr(i), C = es(y, S);
    C.payload = s, p != null && (C.callback = p), s = tu(i, C, S), s !== null && (na(s, i, S, y), Cp(s, i, S));
  }, enqueueReplaceState: function(i, s, p) {
    i = i._reactInternals;
    var y = ta(), S = hr(i), C = es(y, S);
    C.tag = 1, C.payload = s, p != null && (C.callback = p), s = tu(i, C, S), s !== null && (na(s, i, S, y), Cp(s, i, S));
  }, enqueueForceUpdate: function(i, s) {
    i = i._reactInternals;
    var p = ta(), y = hr(i), S = es(p, y);
    S.tag = 2, s != null && (S.callback = s), s = tu(i, S, y), s !== null && (na(s, i, y, p), Cp(s, i, y));
  } };
  function ab(i, s, p, y, S, C, D) {
    return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(y, C, D) : s.prototype && s.prototype.isPureReactComponent ? !Dd(p, y) || !Dd(S, C) : !0;
  }
  function ib(i, s, p) {
    var y = !1, S = yo, C = s.contextType;
    return typeof C == "object" && C !== null ? C = or(C) : (S = Fn(s) ? ja : Et.current, y = s.contextTypes, C = (y = y != null) ? bi(i, S) : yo), s = new s(p, C), i.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = Tp, i.stateNode = s, s._reactInternals = i, y && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = S, i.__reactInternalMemoizedMaskedChildContext = C), s;
  }
  function ob(i, s, p, y) {
    i = s.state, typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps(p, y), typeof s.UNSAFE_componentWillReceiveProps == "function" && s.UNSAFE_componentWillReceiveProps(p, y), s.state !== i && Tp.enqueueReplaceState(s, s.state, null);
  }
  function _p(i, s, p, y) {
    var S = i.stateNode;
    S.props = p, S.state = i.memoizedState, S.refs = rb, fy(i);
    var C = s.contextType;
    typeof C == "object" && C !== null ? S.context = or(C) : (C = Fn(s) ? ja : Et.current, S.context = bi(i, C)), S.state = i.memoizedState, C = s.getDerivedStateFromProps, typeof C == "function" && (hy(i, s, C, p), S.state = i.memoizedState), typeof s.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (s = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), s !== S.state && Tp.enqueueReplaceState(S, S.state, null), nu(i, p, S, y), S.state = i.memoizedState), typeof S.componentDidMount == "function" && (i.flags |= 4194308);
  }
  function fc(i, s, p) {
    if (i = p.ref, i !== null && typeof i != "function" && typeof i != "object") {
      if (p._owner) {
        if (p = p._owner, p) {
          if (p.tag !== 1)
            throw Error(r(309));
          var y = p.stateNode;
        }
        if (!y)
          throw Error(r(147, i));
        var S = y, C = "" + i;
        return s !== null && s.ref !== null && typeof s.ref == "function" && s.ref._stringRef === C ? s.ref : (s = function(D) {
          var U = S.refs;
          U === rb && (U = S.refs = {}), D === null ? delete U[C] : U[C] = D;
        }, s._stringRef = C, s);
      }
      if (typeof i != "string")
        throw Error(r(284));
      if (!p._owner)
        throw Error(r(290, i));
    }
    return i;
  }
  function Rp(i, s) {
    throw i = Object.prototype.toString.call(s), Error(r(31, i === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : i));
  }
  function sb(i) {
    var s = i._init;
    return s(i._payload);
  }
  function ub(i) {
    function s(J, Q) {
      if (i) {
        var ne = J.deletions;
        ne === null ? (J.deletions = [Q], J.flags |= 16) : ne.push(Q);
      }
    }
    function p(J, Q) {
      if (!i)
        return null;
      for (; Q !== null; )
        s(J, Q), Q = Q.sibling;
      return null;
    }
    function y(J, Q) {
      for (J = /* @__PURE__ */ new Map(); Q !== null; )
        Q.key !== null ? J.set(Q.key, Q) : J.set(Q.index, Q), Q = Q.sibling;
      return J;
    }
    function S(J, Q) {
      return J = cu(J, Q), J.index = 0, J.sibling = null, J;
    }
    function C(J, Q, ne) {
      return J.index = ne, i ? (ne = J.alternate, ne !== null ? (ne = ne.index, ne < Q ? (J.flags |= 2, Q) : ne) : (J.flags |= 2, Q)) : (J.flags |= 1048576, Q);
    }
    function D(J) {
      return i && J.alternate === null && (J.flags |= 2), J;
    }
    function U(J, Q, ne, Ie) {
      return Q === null || Q.tag !== 6 ? (Q = cf(ne, J.mode, Ie), Q.return = J, Q) : (Q = S(Q, ne), Q.return = J, Q);
    }
    function Z(J, Q, ne, Ie) {
      var rt = ne.type;
      return rt === W ? _e(J, Q, ne.props.children, Ie, ne.key) : Q !== null && (Q.elementType === rt || typeof rt == "object" && rt !== null && rt.$$typeof === ge && sb(rt) === Q.type) ? (Ie = S(Q, ne.props), Ie.ref = fc(J, Q, ne), Ie.return = J, Ie) : (Ie = oh(ne.type, ne.key, ne.props, null, J.mode, Ie), Ie.ref = fc(J, Q, ne), Ie.return = J, Ie);
    }
    function ue(J, Q, ne, Ie) {
      return Q === null || Q.tag !== 4 || Q.stateNode.containerInfo !== ne.containerInfo || Q.stateNode.implementation !== ne.implementation ? (Q = fl(ne, J.mode, Ie), Q.return = J, Q) : (Q = S(Q, ne.children || []), Q.return = J, Q);
    }
    function _e(J, Q, ne, Ie, rt) {
      return Q === null || Q.tag !== 7 ? (Q = dl(ne, J.mode, Ie, rt), Q.return = J, Q) : (Q = S(Q, ne), Q.return = J, Q);
    }
    function Oe(J, Q, ne) {
      if (typeof Q == "string" && Q !== "" || typeof Q == "number")
        return Q = cf("" + Q, J.mode, ne), Q.return = J, Q;
      if (typeof Q == "object" && Q !== null) {
        switch (Q.$$typeof) {
          case H:
            return ne = oh(Q.type, Q.key, Q.props, null, J.mode, ne), ne.ref = fc(J, null, Q), ne.return = J, ne;
          case V:
            return Q = fl(Q, J.mode, ne), Q.return = J, Q;
          case ge:
            var Ie = Q._init;
            return Oe(J, Ie(Q._payload), ne);
        }
        if (cr(Q) || fe(Q))
          return Q = dl(Q, J.mode, ne, null), Q.return = J, Q;
        Rp(J, Q);
      }
      return null;
    }
    function Te(J, Q, ne, Ie) {
      var rt = Q !== null ? Q.key : null;
      if (typeof ne == "string" && ne !== "" || typeof ne == "number")
        return rt !== null ? null : U(J, Q, "" + ne, Ie);
      if (typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case H:
            return ne.key === rt ? Z(J, Q, ne, Ie) : null;
          case V:
            return ne.key === rt ? ue(J, Q, ne, Ie) : null;
          case ge:
            return rt = ne._init, Te(
              J,
              Q,
              rt(ne._payload),
              Ie
            );
        }
        if (cr(ne) || fe(ne))
          return rt !== null ? null : _e(J, Q, ne, Ie, null);
        Rp(J, ne);
      }
      return null;
    }
    function Ue(J, Q, ne, Ie, rt) {
      if (typeof Ie == "string" && Ie !== "" || typeof Ie == "number")
        return J = J.get(ne) || null, U(Q, J, "" + Ie, rt);
      if (typeof Ie == "object" && Ie !== null) {
        switch (Ie.$$typeof) {
          case H:
            return J = J.get(Ie.key === null ? ne : Ie.key) || null, Z(Q, J, Ie, rt);
          case V:
            return J = J.get(Ie.key === null ? ne : Ie.key) || null, ue(Q, J, Ie, rt);
          case ge:
            var et = Ie._init;
            return Ue(J, Q, ne, et(Ie._payload), rt);
        }
        if (cr(Ie) || fe(Ie))
          return J = J.get(ne) || null, _e(Q, J, Ie, rt, null);
        Rp(Q, Ie);
      }
      return null;
    }
    function Je(J, Q, ne, Ie) {
      for (var rt = null, et = null, st = Q, Ct = Q = 0, Ar = null; st !== null && Ct < ne.length; Ct++) {
        st.index > Ct ? (Ar = st, st = null) : Ar = st.sibling;
        var nn = Te(J, st, ne[Ct], Ie);
        if (nn === null) {
          st === null && (st = Ar);
          break;
        }
        i && st && nn.alternate === null && s(J, st), Q = C(nn, Q, Ct), et === null ? rt = nn : et.sibling = nn, et = nn, st = Ar;
      }
      if (Ct === ne.length)
        return p(J, st), In && Xa(J, Ct), rt;
      if (st === null) {
        for (; Ct < ne.length; Ct++)
          st = Oe(J, ne[Ct], Ie), st !== null && (Q = C(st, Q, Ct), et === null ? rt = st : et.sibling = st, et = st);
        return In && Xa(J, Ct), rt;
      }
      for (st = y(J, st); Ct < ne.length; Ct++)
        Ar = Ue(st, J, Ct, ne[Ct], Ie), Ar !== null && (i && Ar.alternate !== null && st.delete(Ar.key === null ? Ct : Ar.key), Q = C(Ar, Q, Ct), et === null ? rt = Ar : et.sibling = Ar, et = Ar);
      return i && st.forEach(function(du) {
        return s(J, du);
      }), In && Xa(J, Ct), rt;
    }
    function nt(J, Q, ne, Ie) {
      var rt = fe(ne);
      if (typeof rt != "function")
        throw Error(r(150));
      if (ne = rt.call(ne), ne == null)
        throw Error(r(151));
      for (var et = rt = null, st = Q, Ct = Q = 0, Ar = null, nn = ne.next(); st !== null && !nn.done; Ct++, nn = ne.next()) {
        st.index > Ct ? (Ar = st, st = null) : Ar = st.sibling;
        var du = Te(J, st, nn.value, Ie);
        if (du === null) {
          st === null && (st = Ar);
          break;
        }
        i && st && du.alternate === null && s(J, st), Q = C(du, Q, Ct), et === null ? rt = du : et.sibling = du, et = du, st = Ar;
      }
      if (nn.done)
        return p(
          J,
          st
        ), In && Xa(J, Ct), rt;
      if (st === null) {
        for (; !nn.done; Ct++, nn = ne.next())
          nn = Oe(J, nn.value, Ie), nn !== null && (Q = C(nn, Q, Ct), et === null ? rt = nn : et.sibling = nn, et = nn);
        return In && Xa(J, Ct), rt;
      }
      for (st = y(J, st); !nn.done; Ct++, nn = ne.next())
        nn = Ue(st, J, Ct, nn.value, Ie), nn !== null && (i && nn.alternate !== null && st.delete(nn.key === null ? Ct : nn.key), Q = C(nn, Q, Ct), et === null ? rt = nn : et.sibling = nn, et = nn);
      return i && st.forEach(function(h2) {
        return s(J, h2);
      }), In && Xa(J, Ct), rt;
    }
    function sr(J, Q, ne, Ie) {
      if (typeof ne == "object" && ne !== null && ne.type === W && ne.key === null && (ne = ne.props.children), typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case H:
            e: {
              for (var rt = ne.key, et = Q; et !== null; ) {
                if (et.key === rt) {
                  if (rt = ne.type, rt === W) {
                    if (et.tag === 7) {
                      p(J, et.sibling), Q = S(et, ne.props.children), Q.return = J, J = Q;
                      break e;
                    }
                  } else if (et.elementType === rt || typeof rt == "object" && rt !== null && rt.$$typeof === ge && sb(rt) === et.type) {
                    p(J, et.sibling), Q = S(et, ne.props), Q.ref = fc(J, et, ne), Q.return = J, J = Q;
                    break e;
                  }
                  p(J, et);
                  break;
                } else
                  s(J, et);
                et = et.sibling;
              }
              ne.type === W ? (Q = dl(ne.props.children, J.mode, Ie, ne.key), Q.return = J, J = Q) : (Ie = oh(ne.type, ne.key, ne.props, null, J.mode, Ie), Ie.ref = fc(J, Q, ne), Ie.return = J, J = Ie);
            }
            return D(J);
          case V:
            e: {
              for (et = ne.key; Q !== null; ) {
                if (Q.key === et)
                  if (Q.tag === 4 && Q.stateNode.containerInfo === ne.containerInfo && Q.stateNode.implementation === ne.implementation) {
                    p(J, Q.sibling), Q = S(Q, ne.children || []), Q.return = J, J = Q;
                    break e;
                  } else {
                    p(J, Q);
                    break;
                  }
                else
                  s(J, Q);
                Q = Q.sibling;
              }
              Q = fl(ne, J.mode, Ie), Q.return = J, J = Q;
            }
            return D(J);
          case ge:
            return et = ne._init, sr(J, Q, et(ne._payload), Ie);
        }
        if (cr(ne))
          return Je(J, Q, ne, Ie);
        if (fe(ne))
          return nt(J, Q, ne, Ie);
        Rp(J, ne);
      }
      return typeof ne == "string" && ne !== "" || typeof ne == "number" ? (ne = "" + ne, Q !== null && Q.tag === 6 ? (p(J, Q.sibling), Q = S(Q, ne), Q.return = J, J = Q) : (p(J, Q), Q = cf(ne, J.mode, Ie), Q.return = J, J = Q), D(J)) : p(J, Q);
    }
    return sr;
  }
  var pc = ub(!0), lb = ub(!1), Gd = {}, Zi = It(Gd), qd = It(Gd), hc = It(Gd);
  function Yu(i) {
    if (i === Gd)
      throw Error(r(174));
    return i;
  }
  function my(i, s) {
    switch (hn(hc, s), hn(qd, i), hn(Zi, Gd), i = s.nodeType, i) {
      case 9:
      case 11:
        s = (s = s.documentElement) ? s.namespaceURI : Gn(null, "");
        break;
      default:
        i = i === 8 ? s.parentNode : s, s = i.namespaceURI || null, i = i.tagName, s = Gn(s, i);
    }
    ln(Zi), hn(Zi, s);
  }
  function ru() {
    ln(Zi), ln(qd), ln(hc);
  }
  function mt(i) {
    Yu(hc.current);
    var s = Yu(Zi.current), p = Gn(s, i.type);
    s !== p && (hn(qd, i), hn(Zi, p));
  }
  function zt(i) {
    qd.current === i && (ln(Zi), ln(qd));
  }
  var vt = It(0);
  function Zn(i) {
    for (var s = i; s !== null; ) {
      if (s.tag === 13) {
        var p = s.memoizedState;
        if (p !== null && (p = p.dehydrated, p === null || p.data === "$?" || p.data === "$!"))
          return s;
      } else if (s.tag === 19 && s.memoizedProps.revealOrder !== void 0) {
        if (s.flags & 128)
          return s;
      } else if (s.child !== null) {
        s.child.return = s, s = s.child;
        continue;
      }
      if (s === i)
        break;
      for (; s.sibling === null; ) {
        if (s.return === null || s.return === i)
          return null;
        s = s.return;
      }
      s.sibling.return = s.return, s = s.sibling;
    }
    return null;
  }
  var ki = [];
  function Op() {
    for (var i = 0; i < ki.length; i++)
      ki[i]._workInProgressVersionPrimary = null;
    ki.length = 0;
  }
  var Pp = B.ReactCurrentDispatcher, yy = B.ReactCurrentBatchConfig, Zu = 0, Mn = null, be = null, Zt = null, gt = !1, go = !1, ti = 0, Ku = 0;
  function $n() {
    throw Error(r(321));
  }
  function Qu(i, s) {
    if (s === null)
      return !1;
    for (var p = 0; p < s.length && p < i.length; p++)
      if (!vi(i[p], s[p]))
        return !1;
    return !0;
  }
  function au(i, s, p, y, S, C) {
    if (Zu = C, Mn = s, s.memoizedState = null, s.updateQueue = null, s.lanes = 0, Pp.current = i === null || i.memoizedState === null ? Kx : Qx, i = p(y, S), go) {
      C = 0;
      do {
        if (go = !1, ti = 0, 25 <= C)
          throw Error(r(301));
        C += 1, Zt = be = null, s.updateQueue = null, Pp.current = gy, i = p(y, S);
      } while (go);
    }
    if (Pp.current = qp, s = be !== null && be.next !== null, Zu = 0, Zt = be = Mn = null, gt = !1, s)
      throw Error(r(300));
    return i;
  }
  function Xu() {
    var i = ti !== 0;
    return ti = 0, i;
  }
  function Ei() {
    var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Zt === null ? Mn.memoizedState = Zt = i : Zt = Zt.next = i, Zt;
  }
  function $a() {
    if (be === null) {
      var i = Mn.alternate;
      i = i !== null ? i.memoizedState : null;
    } else
      i = be.next;
    var s = Zt === null ? Mn.memoizedState : Zt.next;
    if (s !== null)
      Zt = s, be = i;
    else {
      if (i === null)
        throw Error(r(310));
      be = i, i = { memoizedState: be.memoizedState, baseState: be.baseState, baseQueue: be.baseQueue, queue: be.queue, next: null }, Zt === null ? Mn.memoizedState = Zt = i : Zt = Zt.next = i;
    }
    return Zt;
  }
  function Ju(i, s) {
    return typeof s == "function" ? s(i) : s;
  }
  function Wd(i) {
    var s = $a(), p = s.queue;
    if (p === null)
      throw Error(r(311));
    p.lastRenderedReducer = i;
    var y = be, S = y.baseQueue, C = p.pending;
    if (C !== null) {
      if (S !== null) {
        var D = S.next;
        S.next = C.next, C.next = D;
      }
      y.baseQueue = S = C, p.pending = null;
    }
    if (S !== null) {
      C = S.next, y = y.baseState;
      var U = D = null, Z = null, ue = C;
      do {
        var _e = ue.lane;
        if ((Zu & _e) === _e)
          Z !== null && (Z = Z.next = { lane: 0, action: ue.action, hasEagerState: ue.hasEagerState, eagerState: ue.eagerState, next: null }), y = ue.hasEagerState ? ue.eagerState : i(y, ue.action);
        else {
          var Oe = {
            lane: _e,
            action: ue.action,
            hasEagerState: ue.hasEagerState,
            eagerState: ue.eagerState,
            next: null
          };
          Z === null ? (U = Z = Oe, D = y) : Z = Z.next = Oe, Mn.lanes |= _e, as |= _e;
        }
        ue = ue.next;
      } while (ue !== null && ue !== C);
      Z === null ? D = y : Z.next = U, vi(y, s.memoizedState) || (pr = !0), s.memoizedState = y, s.baseState = D, s.baseQueue = Z, p.lastRenderedState = y;
    }
    if (i = p.interleaved, i !== null) {
      S = i;
      do
        C = S.lane, Mn.lanes |= C, as |= C, S = S.next;
      while (S !== i);
    } else
      S === null && (p.lanes = 0);
    return [s.memoizedState, p.dispatch];
  }
  function Yd(i) {
    var s = $a(), p = s.queue;
    if (p === null)
      throw Error(r(311));
    p.lastRenderedReducer = i;
    var y = p.dispatch, S = p.pending, C = s.memoizedState;
    if (S !== null) {
      p.pending = null;
      var D = S = S.next;
      do
        C = i(C, D.action), D = D.next;
      while (D !== S);
      vi(C, s.memoizedState) || (pr = !0), s.memoizedState = C, s.baseQueue === null && (s.baseState = C), p.lastRenderedState = C;
    }
    return [C, y];
  }
  function jp() {
  }
  function Ap(i, s) {
    var p = Mn, y = $a(), S = s(), C = !vi(y.memoizedState, S);
    if (C && (y.memoizedState = S, pr = !0), y = y.queue, Zd(Mp.bind(null, p, y, i), [i]), y.getSnapshot !== s || C || Zt !== null && Zt.memoizedState.tag & 1) {
      if (p.flags |= 2048, el(9, Ip.bind(null, p, y, S, s), void 0, null), Kn === null)
        throw Error(r(349));
      Zu & 30 || Dp(p, s, S);
    }
    return S;
  }
  function Dp(i, s, p) {
    i.flags |= 16384, i = { getSnapshot: s, value: p }, s = Mn.updateQueue, s === null ? (s = { lastEffect: null, stores: null }, Mn.updateQueue = s, s.stores = [i]) : (p = s.stores, p === null ? s.stores = [i] : p.push(i));
  }
  function Ip(i, s, p, y) {
    s.value = p, s.getSnapshot = y, $p(s) && Lp(i);
  }
  function Mp(i, s, p) {
    return p(function() {
      $p(s) && Lp(i);
    });
  }
  function $p(i) {
    var s = i.getSnapshot;
    i = i.value;
    try {
      var p = s();
      return !vi(i, p);
    } catch {
      return !0;
    }
  }
  function Lp(i) {
    var s = Jo(i, 1);
    s !== null && na(s, i, 1, -1);
  }
  function Np(i) {
    var s = Ei();
    return typeof i == "function" && (i = i()), s.memoizedState = s.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ju, lastRenderedState: i }, s.queue = i, i = i.dispatch = Gp.bind(null, Mn, i), [s.memoizedState, i];
  }
  function el(i, s, p, y) {
    return i = { tag: i, create: s, destroy: p, deps: y, next: null }, s = Mn.updateQueue, s === null ? (s = { lastEffect: null, stores: null }, Mn.updateQueue = s, s.lastEffect = i.next = i) : (p = s.lastEffect, p === null ? s.lastEffect = i.next = i : (y = p.next, p.next = i, i.next = y, s.lastEffect = i)), i;
  }
  function Fp() {
    return $a().memoizedState;
  }
  function tl(i, s, p, y) {
    var S = Ei();
    Mn.flags |= i, S.memoizedState = el(1 | s, p, void 0, y === void 0 ? null : y);
  }
  function ts(i, s, p, y) {
    var S = $a();
    y = y === void 0 ? null : y;
    var C = void 0;
    if (be !== null) {
      var D = be.memoizedState;
      if (C = D.destroy, y !== null && Qu(y, D.deps)) {
        S.memoizedState = el(s, p, C, y);
        return;
      }
    }
    Mn.flags |= i, S.memoizedState = el(1 | s, p, C, y);
  }
  function zp(i, s) {
    return tl(8390656, 8, i, s);
  }
  function Zd(i, s) {
    return ts(2048, 8, i, s);
  }
  function Bp(i, s) {
    return ts(4, 2, i, s);
  }
  function Up(i, s) {
    return ts(4, 4, i, s);
  }
  function vy(i, s) {
    if (typeof s == "function")
      return i = i(), s(i), function() {
        s(null);
      };
    if (s != null)
      return i = i(), s.current = i, function() {
        s.current = null;
      };
  }
  function mc(i, s, p) {
    return p = p != null ? p.concat([i]) : null, ts(4, 4, vy.bind(null, s, i), p);
  }
  function Hp() {
  }
  function yc(i, s) {
    var p = $a();
    s = s === void 0 ? null : s;
    var y = p.memoizedState;
    return y !== null && s !== null && Qu(s, y[1]) ? y[0] : (p.memoizedState = [i, s], i);
  }
  function iu(i, s) {
    var p = $a();
    s = s === void 0 ? null : s;
    var y = p.memoizedState;
    return y !== null && s !== null && Qu(s, y[1]) ? y[0] : (i = i(), p.memoizedState = [i, s], i);
  }
  function La(i, s, p) {
    return Zu & 21 ? (vi(p, s) || (p = Zl(), Mn.lanes |= p, as |= p, i.baseState = !0), s) : (i.baseState && (i.baseState = !1, pr = !0), i.memoizedState = p);
  }
  function Zx(i, s) {
    var p = rn;
    rn = p !== 0 && 4 > p ? p : 4, i(!0);
    var y = yy.transition;
    yy.transition = {};
    try {
      i(!1), s();
    } finally {
      rn = p, yy.transition = y;
    }
  }
  function Cn() {
    return $a().memoizedState;
  }
  function Vp(i, s, p) {
    var y = hr(i);
    if (p = { lane: y, action: p, hasEagerState: !1, eagerState: null, next: null }, vc(i))
      Kd(s, p);
    else if (p = nb(i, s, p, y), p !== null) {
      var S = ta();
      na(p, i, y, S), cb(p, s, y);
    }
  }
  function Gp(i, s, p) {
    var y = hr(i), S = { lane: y, action: p, hasEagerState: !1, eagerState: null, next: null };
    if (vc(i))
      Kd(s, S);
    else {
      var C = i.alternate;
      if (i.lanes === 0 && (C === null || C.lanes === 0) && (C = s.lastRenderedReducer, C !== null))
        try {
          var D = s.lastRenderedState, U = C(D, p);
          if (S.hasEagerState = !0, S.eagerState = U, vi(U, D)) {
            var Z = s.interleaved;
            Z === null ? (S.next = S, dy(s)) : (S.next = Z.next, Z.next = S), s.interleaved = S;
            return;
          }
        } catch {
        } finally {
        }
      p = nb(i, s, S, y), p !== null && (S = ta(), na(p, i, y, S), cb(p, s, y));
    }
  }
  function vc(i) {
    var s = i.alternate;
    return i === Mn || s !== null && s === Mn;
  }
  function Kd(i, s) {
    go = gt = !0;
    var p = i.pending;
    p === null ? s.next = s : (s.next = p.next, p.next = s), i.pending = s;
  }
  function cb(i, s, p) {
    if (p & 4194240) {
      var y = s.lanes;
      y &= i.pendingLanes, p |= y, s.lanes = p, po(i, p);
    }
  }
  var qp = { readContext: or, useCallback: $n, useContext: $n, useEffect: $n, useImperativeHandle: $n, useInsertionEffect: $n, useLayoutEffect: $n, useMemo: $n, useReducer: $n, useRef: $n, useState: $n, useDebugValue: $n, useDeferredValue: $n, useTransition: $n, useMutableSource: $n, useSyncExternalStore: $n, useId: $n, unstable_isNewReconciler: !1 }, Kx = { readContext: or, useCallback: function(i, s) {
    return Ei().memoizedState = [i, s === void 0 ? null : s], i;
  }, useContext: or, useEffect: zp, useImperativeHandle: function(i, s, p) {
    return p = p != null ? p.concat([i]) : null, tl(
      4194308,
      4,
      vy.bind(null, s, i),
      p
    );
  }, useLayoutEffect: function(i, s) {
    return tl(4194308, 4, i, s);
  }, useInsertionEffect: function(i, s) {
    return tl(4, 2, i, s);
  }, useMemo: function(i, s) {
    var p = Ei();
    return s = s === void 0 ? null : s, i = i(), p.memoizedState = [i, s], i;
  }, useReducer: function(i, s, p) {
    var y = Ei();
    return s = p !== void 0 ? p(s) : s, y.memoizedState = y.baseState = s, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: s }, y.queue = i, i = i.dispatch = Vp.bind(null, Mn, i), [y.memoizedState, i];
  }, useRef: function(i) {
    var s = Ei();
    return i = { current: i }, s.memoizedState = i;
  }, useState: Np, useDebugValue: Hp, useDeferredValue: function(i) {
    return Ei().memoizedState = i;
  }, useTransition: function() {
    var i = Np(!1), s = i[0];
    return i = Zx.bind(null, i[1]), Ei().memoizedState = i, [s, i];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(i, s, p) {
    var y = Mn, S = Ei();
    if (In) {
      if (p === void 0)
        throw Error(r(407));
      p = p();
    } else {
      if (p = s(), Kn === null)
        throw Error(r(349));
      Zu & 30 || Dp(y, s, p);
    }
    S.memoizedState = p;
    var C = { value: p, getSnapshot: s };
    return S.queue = C, zp(Mp.bind(
      null,
      y,
      C,
      i
    ), [i]), y.flags |= 2048, el(9, Ip.bind(null, y, C, p, s), void 0, null), p;
  }, useId: function() {
    var i = Ei(), s = Kn.identifierPrefix;
    if (In) {
      var p = Xo, y = $r;
      p = (y & ~(1 << 32 - fa(y) - 1)).toString(32) + p, s = ":" + s + "R" + p, p = ti++, 0 < p && (s += "H" + p.toString(32)), s += ":";
    } else
      p = Ku++, s = ":" + s + "r" + p.toString(32) + ":";
    return i.memoizedState = s;
  }, unstable_isNewReconciler: !1 }, Qx = {
    readContext: or,
    useCallback: yc,
    useContext: or,
    useEffect: Zd,
    useImperativeHandle: mc,
    useInsertionEffect: Bp,
    useLayoutEffect: Up,
    useMemo: iu,
    useReducer: Wd,
    useRef: Fp,
    useState: function() {
      return Wd(Ju);
    },
    useDebugValue: Hp,
    useDeferredValue: function(i) {
      var s = $a();
      return La(s, be.memoizedState, i);
    },
    useTransition: function() {
      var i = Wd(Ju)[0], s = $a().memoizedState;
      return [i, s];
    },
    useMutableSource: jp,
    useSyncExternalStore: Ap,
    useId: Cn,
    unstable_isNewReconciler: !1
  }, gy = { readContext: or, useCallback: yc, useContext: or, useEffect: Zd, useImperativeHandle: mc, useInsertionEffect: Bp, useLayoutEffect: Up, useMemo: iu, useReducer: Yd, useRef: Fp, useState: function() {
    return Yd(Ju);
  }, useDebugValue: Hp, useDeferredValue: function(i) {
    var s = $a();
    return be === null ? s.memoizedState = i : La(s, be.memoizedState, i);
  }, useTransition: function() {
    var i = Yd(Ju)[0], s = $a().memoizedState;
    return [i, s];
  }, useMutableSource: jp, useSyncExternalStore: Ap, useId: Cn, unstable_isNewReconciler: !1 };
  function gc(i, s) {
    try {
      var p = "", y = s;
      do
        p += bt(y), y = y.return;
      while (y);
      var S = p;
    } catch (C) {
      S = `
Error generating stack: ` + C.message + `
` + C.stack;
    }
    return { value: i, source: s, stack: S, digest: null };
  }
  function Qd(i, s, p) {
    return { value: i, source: null, stack: p ?? null, digest: s ?? null };
  }
  function Wp(i, s) {
    try {
      console.error(s.value);
    } catch (p) {
      setTimeout(function() {
        throw p;
      });
    }
  }
  var Xx = typeof WeakMap == "function" ? WeakMap : Map;
  function db(i, s, p) {
    p = es(-1, p), p.tag = 3, p.payload = { element: null };
    var y = s.value;
    return p.callback = function() {
      eh || (eh = !0, ol = y), Wp(i, s);
    }, p;
  }
  function Xd(i, s, p) {
    p = es(-1, p), p.tag = 3;
    var y = i.type.getDerivedStateFromError;
    if (typeof y == "function") {
      var S = s.value;
      p.payload = function() {
        return y(S);
      }, p.callback = function() {
        Wp(i, s);
      };
    }
    var C = i.stateNode;
    return C !== null && typeof C.componentDidCatch == "function" && (p.callback = function() {
      Wp(i, s), typeof y != "function" && (xo === null ? xo = /* @__PURE__ */ new Set([this]) : xo.add(this));
      var D = s.stack;
      this.componentDidCatch(s.value, { componentStack: D !== null ? D : "" });
    }), p;
  }
  function fb(i, s, p) {
    var y = i.pingCache;
    if (y === null) {
      y = i.pingCache = new Xx();
      var S = /* @__PURE__ */ new Set();
      y.set(s, S);
    } else
      S = y.get(s), S === void 0 && (S = /* @__PURE__ */ new Set(), y.set(s, S));
    S.has(p) || (S.add(p), i = i2.bind(null, i, s, p), s.then(i, i));
  }
  function by(i) {
    do {
      var s;
      if ((s = i.tag === 13) && (s = i.memoizedState, s = s !== null ? s.dehydrated !== null : !0), s)
        return i;
      i = i.return;
    } while (i !== null);
    return null;
  }
  function wy(i, s, p, y, S) {
    return i.mode & 1 ? (i.flags |= 65536, i.lanes = S, i) : (i === s ? i.flags |= 65536 : (i.flags |= 128, p.flags |= 131072, p.flags &= -52805, p.tag === 1 && (p.alternate === null ? p.tag = 17 : (s = es(-1, 1), s.tag = 2, tu(p, s, 1))), p.lanes |= 1), i);
  }
  var Jx = B.ReactCurrentOwner, pr = !1;
  function vr(i, s, p, y) {
    s.child = i === null ? lb(s, null, p, y) : pc(s, i.child, p, y);
  }
  function ou(i, s, p, y, S) {
    p = p.render;
    var C = s.ref;
    return Le(s, S), y = au(i, s, p, y, C, S), p = Xu(), i !== null && !pr ? (s.updateQueue = i.updateQueue, s.flags &= -2053, i.lanes &= ~S, Nr(i, s, S)) : (In && p && bp(s), s.flags |= 1, vr(i, s, y, S), s.child);
  }
  function Yp(i, s, p, y, S) {
    if (i === null) {
      var C = p.type;
      return typeof C == "function" && !Fy(C) && C.defaultProps === void 0 && p.compare === null && p.defaultProps === void 0 ? (s.tag = 15, s.type = C, Na(i, s, C, y, S)) : (i = oh(p.type, null, y, s, s.mode, S), i.ref = s.ref, i.return = s, s.child = i);
    }
    if (C = i.child, !(i.lanes & S)) {
      var D = C.memoizedProps;
      if (p = p.compare, p = p !== null ? p : Dd, p(D, y) && i.ref === s.ref)
        return Nr(i, s, S);
    }
    return s.flags |= 1, i = cu(C, y), i.ref = s.ref, i.return = s, s.child = i;
  }
  function Na(i, s, p, y, S) {
    if (i !== null) {
      var C = i.memoizedProps;
      if (Dd(C, y) && i.ref === s.ref)
        if (pr = !1, s.pendingProps = y = C, (i.lanes & S) !== 0)
          i.flags & 131072 && (pr = !0);
        else
          return s.lanes = i.lanes, Nr(i, s, S);
    }
    return bc(i, s, p, y, S);
  }
  function nl(i, s, p) {
    var y = s.pendingProps, S = y.children, C = i !== null ? i.memoizedState : null;
    if (y.mode === "hidden")
      if (!(s.mode & 1))
        s.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, hn(Cc, ni), ni |= p;
      else {
        if (!(p & 1073741824))
          return i = C !== null ? C.baseLanes | p : p, s.lanes = s.childLanes = 1073741824, s.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, s.updateQueue = null, hn(Cc, ni), ni |= i, null;
        s.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, y = C !== null ? C.baseLanes : p, hn(Cc, ni), ni |= y;
      }
    else
      C !== null ? (y = C.baseLanes | p, s.memoizedState = null) : y = p, hn(Cc, ni), ni |= y;
    return vr(i, s, S, p), s.child;
  }
  function Mt(i, s) {
    var p = s.ref;
    (i === null && p !== null || i !== null && i.ref !== p) && (s.flags |= 512, s.flags |= 2097152);
  }
  function bc(i, s, p, y, S) {
    var C = Fn(p) ? ja : Et.current;
    return C = bi(s, C), Le(s, S), p = au(i, s, p, y, C, S), y = Xu(), i !== null && !pr ? (s.updateQueue = i.updateQueue, s.flags &= -2053, i.lanes &= ~S, Nr(i, s, S)) : (In && y && bp(s), s.flags |= 1, vr(i, s, p, S), s.child);
  }
  function xy(i, s, p, y, S) {
    if (Fn(p)) {
      var C = !0;
      gp(s);
    } else
      C = !1;
    if (Le(s, S), s.stateNode === null)
      Xr(i, s), ib(s, p, y), _p(s, p, y, S), y = !0;
    else if (i === null) {
      var D = s.stateNode, U = s.memoizedProps;
      D.props = U;
      var Z = D.context, ue = p.contextType;
      typeof ue == "object" && ue !== null ? ue = or(ue) : (ue = Fn(p) ? ja : Et.current, ue = bi(s, ue));
      var _e = p.getDerivedStateFromProps, Oe = typeof _e == "function" || typeof D.getSnapshotBeforeUpdate == "function";
      Oe || typeof D.UNSAFE_componentWillReceiveProps != "function" && typeof D.componentWillReceiveProps != "function" || (U !== y || Z !== ue) && ob(s, D, y, ue), eu = !1;
      var Te = s.memoizedState;
      D.state = Te, nu(s, y, D, S), Z = s.memoizedState, U !== y || Te !== Z || er.current || eu ? (typeof _e == "function" && (hy(s, p, _e, y), Z = s.memoizedState), (U = eu || ab(s, p, U, y, Te, Z, ue)) ? (Oe || typeof D.UNSAFE_componentWillMount != "function" && typeof D.componentWillMount != "function" || (typeof D.componentWillMount == "function" && D.componentWillMount(), typeof D.UNSAFE_componentWillMount == "function" && D.UNSAFE_componentWillMount()), typeof D.componentDidMount == "function" && (s.flags |= 4194308)) : (typeof D.componentDidMount == "function" && (s.flags |= 4194308), s.memoizedProps = y, s.memoizedState = Z), D.props = y, D.state = Z, D.context = ue, y = U) : (typeof D.componentDidMount == "function" && (s.flags |= 4194308), y = !1);
    } else {
      D = s.stateNode, yr(i, s), U = s.memoizedProps, ue = s.type === s.elementType ? U : ei(s.type, U), D.props = ue, Oe = s.pendingProps, Te = D.context, Z = p.contextType, typeof Z == "object" && Z !== null ? Z = or(Z) : (Z = Fn(p) ? ja : Et.current, Z = bi(s, Z));
      var Ue = p.getDerivedStateFromProps;
      (_e = typeof Ue == "function" || typeof D.getSnapshotBeforeUpdate == "function") || typeof D.UNSAFE_componentWillReceiveProps != "function" && typeof D.componentWillReceiveProps != "function" || (U !== Oe || Te !== Z) && ob(s, D, y, Z), eu = !1, Te = s.memoizedState, D.state = Te, nu(s, y, D, S);
      var Je = s.memoizedState;
      U !== Oe || Te !== Je || er.current || eu ? (typeof Ue == "function" && (hy(s, p, Ue, y), Je = s.memoizedState), (ue = eu || ab(s, p, ue, y, Te, Je, Z) || !1) ? (_e || typeof D.UNSAFE_componentWillUpdate != "function" && typeof D.componentWillUpdate != "function" || (typeof D.componentWillUpdate == "function" && D.componentWillUpdate(y, Je, Z), typeof D.UNSAFE_componentWillUpdate == "function" && D.UNSAFE_componentWillUpdate(y, Je, Z)), typeof D.componentDidUpdate == "function" && (s.flags |= 4), typeof D.getSnapshotBeforeUpdate == "function" && (s.flags |= 1024)) : (typeof D.componentDidUpdate != "function" || U === i.memoizedProps && Te === i.memoizedState || (s.flags |= 4), typeof D.getSnapshotBeforeUpdate != "function" || U === i.memoizedProps && Te === i.memoizedState || (s.flags |= 1024), s.memoizedProps = y, s.memoizedState = Je), D.props = y, D.state = Je, D.context = Z, y = ue) : (typeof D.componentDidUpdate != "function" || U === i.memoizedProps && Te === i.memoizedState || (s.flags |= 4), typeof D.getSnapshotBeforeUpdate != "function" || U === i.memoizedProps && Te === i.memoizedState || (s.flags |= 1024), y = !1);
    }
    return pb(i, s, p, y, C, S);
  }
  function pb(i, s, p, y, S, C) {
    Mt(i, s);
    var D = (s.flags & 128) !== 0;
    if (!y && !D)
      return S && X0(s, p, !1), Nr(i, s, C);
    y = s.stateNode, Jx.current = s;
    var U = D && typeof p.getDerivedStateFromError != "function" ? null : y.render();
    return s.flags |= 1, i !== null && D ? (s.child = pc(s, i.child, null, C), s.child = pc(s, null, U, C)) : vr(i, s, U, C), s.memoizedState = y.state, S && X0(s, p, !0), s.child;
  }
  function hb(i) {
    var s = i.stateNode;
    s.pendingContext ? Ks(i, s.pendingContext, s.pendingContext !== s.context) : s.context && Ks(i, s.context, !1), my(i, s.containerInfo);
  }
  function Zp(i, s, p, y, S) {
    return Yn(), uy(S), s.flags |= 256, vr(i, s, p, y), s.child;
  }
  var rl = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Sy(i) {
    return { baseLanes: i, cachePool: null, transitions: null };
  }
  function ky(i, s, p) {
    var y = s.pendingProps, S = vt.current, C = !1, D = (s.flags & 128) !== 0, U;
    if ((U = D) || (U = i !== null && i.memoizedState === null ? !1 : (S & 2) !== 0), U ? (C = !0, s.flags &= -129) : (i === null || i.memoizedState !== null) && (S |= 1), hn(vt, S & 1), i === null)
      return xp(s), i = s.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? (s.mode & 1 ? i.data === "$!" ? s.lanes = 8 : s.lanes = 1073741824 : s.lanes = 1, null) : (D = y.children, i = y.fallback, C ? (y = s.mode, C = s.child, D = { mode: "hidden", children: D }, !(y & 1) && C !== null ? (C.childLanes = 0, C.pendingProps = D) : C = lf(D, y, 0, null), i = dl(i, y, p, null), C.return = s, i.return = s, C.sibling = i, s.child = C, s.child.memoizedState = Sy(p), s.memoizedState = rl, i) : Ey(s, D));
    if (S = i.memoizedState, S !== null && (U = S.dehydrated, U !== null))
      return e2(i, s, D, y, U, S, p);
    if (C) {
      C = y.fallback, D = s.mode, S = i.child, U = S.sibling;
      var Z = { mode: "hidden", children: y.children };
      return !(D & 1) && s.child !== S ? (y = s.child, y.childLanes = 0, y.pendingProps = Z, s.deletions = null) : (y = cu(S, Z), y.subtreeFlags = S.subtreeFlags & 14680064), U !== null ? C = cu(U, C) : (C = dl(C, D, p, null), C.flags |= 2), C.return = s, y.return = s, y.sibling = C, s.child = y, y = C, C = s.child, D = i.child.memoizedState, D = D === null ? Sy(p) : { baseLanes: D.baseLanes | p, cachePool: null, transitions: D.transitions }, C.memoizedState = D, C.childLanes = i.childLanes & ~p, s.memoizedState = rl, y;
    }
    return C = i.child, i = C.sibling, y = cu(C, { mode: "visible", children: y.children }), !(s.mode & 1) && (y.lanes = p), y.return = s, y.sibling = null, i !== null && (p = s.deletions, p === null ? (s.deletions = [i], s.flags |= 16) : p.push(i)), s.child = y, s.memoizedState = null, y;
  }
  function Ey(i, s) {
    return s = lf({ mode: "visible", children: s }, i.mode, 0, null), s.return = i, i.child = s;
  }
  function wc(i, s, p, y) {
    return y !== null && uy(y), pc(s, i.child, null, p), i = Ey(s, s.pendingProps.children), i.flags |= 2, s.memoizedState = null, i;
  }
  function e2(i, s, p, y, S, C, D) {
    if (p)
      return s.flags & 256 ? (s.flags &= -257, y = Qd(Error(r(422))), wc(i, s, D, y)) : s.memoizedState !== null ? (s.child = i.child, s.flags |= 128, null) : (C = y.fallback, S = s.mode, y = lf({ mode: "visible", children: y.children }, S, 0, null), C = dl(C, S, D, null), C.flags |= 2, y.return = s, C.return = s, y.sibling = C, s.child = y, s.mode & 1 && pc(s, i.child, null, D), s.child.memoizedState = Sy(D), s.memoizedState = rl, C);
    if (!(s.mode & 1))
      return wc(i, s, D, null);
    if (S.data === "$!") {
      if (y = S.nextSibling && S.nextSibling.dataset, y)
        var U = y.dgst;
      return y = U, C = Error(r(419)), y = Qd(C, y, void 0), wc(i, s, D, y);
    }
    if (U = (D & i.childLanes) !== 0, pr || U) {
      if (y = Kn, y !== null) {
        switch (D & -D) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = S & (y.suspendedLanes | D) ? 0 : S, S !== 0 && S !== C.retryLane && (C.retryLane = S, Jo(i, S), na(y, i, S, -1));
      }
      return $y(), y = Qd(Error(r(421))), wc(i, s, D, y);
    }
    return S.data === "$?" ? (s.flags |= 128, s.child = i.child, s = o2.bind(null, i), S._reactRetry = s, null) : (i = C.treeContext, Ma = Yi(S.nextSibling), Ja = s, In = !0, Si = null, i !== null && (Ia[Qr++] = $r, Ia[Qr++] = Xo, Ia[Qr++] = xi, $r = i.id, Xo = i.overflow, xi = s), s = Ey(s, y.children), s.flags |= 4096, s);
  }
  function Cy(i, s, p) {
    i.lanes |= s;
    var y = i.alternate;
    y !== null && (y.lanes |= s), Or(i.return, s, p);
  }
  function Kp(i, s, p, y, S) {
    var C = i.memoizedState;
    C === null ? i.memoizedState = { isBackwards: s, rendering: null, renderingStartTime: 0, last: y, tail: p, tailMode: S } : (C.isBackwards = s, C.rendering = null, C.renderingStartTime = 0, C.last = y, C.tail = p, C.tailMode = S);
  }
  function Ty(i, s, p) {
    var y = s.pendingProps, S = y.revealOrder, C = y.tail;
    if (vr(i, s, y.children, p), y = vt.current, y & 2)
      y = y & 1 | 2, s.flags |= 128;
    else {
      if (i !== null && i.flags & 128)
        e:
          for (i = s.child; i !== null; ) {
            if (i.tag === 13)
              i.memoizedState !== null && Cy(i, p, s);
            else if (i.tag === 19)
              Cy(i, p, s);
            else if (i.child !== null) {
              i.child.return = i, i = i.child;
              continue;
            }
            if (i === s)
              break e;
            for (; i.sibling === null; ) {
              if (i.return === null || i.return === s)
                break e;
              i = i.return;
            }
            i.sibling.return = i.return, i = i.sibling;
          }
      y &= 1;
    }
    if (hn(vt, y), !(s.mode & 1))
      s.memoizedState = null;
    else
      switch (S) {
        case "forwards":
          for (p = s.child, S = null; p !== null; )
            i = p.alternate, i !== null && Zn(i) === null && (S = p), p = p.sibling;
          p = S, p === null ? (S = s.child, s.child = null) : (S = p.sibling, p.sibling = null), Kp(s, !1, S, p, C);
          break;
        case "backwards":
          for (p = null, S = s.child, s.child = null; S !== null; ) {
            if (i = S.alternate, i !== null && Zn(i) === null) {
              s.child = S;
              break;
            }
            i = S.sibling, S.sibling = p, p = S, S = i;
          }
          Kp(s, !0, p, null, C);
          break;
        case "together":
          Kp(s, !1, null, null, void 0);
          break;
        default:
          s.memoizedState = null;
      }
    return s.child;
  }
  function Xr(i, s) {
    !(s.mode & 1) && i !== null && (i.alternate = null, s.alternate = null, s.flags |= 2);
  }
  function Nr(i, s, p) {
    if (i !== null && (s.dependencies = i.dependencies), as |= s.lanes, !(p & s.childLanes))
      return null;
    if (i !== null && s.child !== i.child)
      throw Error(r(153));
    if (s.child !== null) {
      for (i = s.child, p = cu(i, i.pendingProps), s.child = p, p.return = s; i.sibling !== null; )
        i = i.sibling, p = p.sibling = cu(i, i.pendingProps), p.return = s;
      p.sibling = null;
    }
    return s.child;
  }
  function ns(i, s, p) {
    switch (s.tag) {
      case 3:
        hb(s), Yn();
        break;
      case 5:
        mt(s);
        break;
      case 1:
        Fn(s.type) && gp(s);
        break;
      case 4:
        my(s, s.stateNode.containerInfo);
        break;
      case 10:
        var y = s.type._context, S = s.memoizedProps.value;
        hn(vo, y._currentValue), y._currentValue = S;
        break;
      case 13:
        if (y = s.memoizedState, y !== null)
          return y.dehydrated !== null ? (hn(vt, vt.current & 1), s.flags |= 128, null) : p & s.child.childLanes ? ky(i, s, p) : (hn(vt, vt.current & 1), i = Nr(i, s, p), i !== null ? i.sibling : null);
        hn(vt, vt.current & 1);
        break;
      case 19:
        if (y = (p & s.childLanes) !== 0, i.flags & 128) {
          if (y)
            return Ty(i, s, p);
          s.flags |= 128;
        }
        if (S = s.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), hn(vt, vt.current), y)
          break;
        return null;
      case 22:
      case 23:
        return s.lanes = 0, nl(i, s, p);
    }
    return Nr(i, s, p);
  }
  var Jd, al, Ci, gr;
  Jd = function(i, s) {
    for (var p = s.child; p !== null; ) {
      if (p.tag === 5 || p.tag === 6)
        i.appendChild(p.stateNode);
      else if (p.tag !== 4 && p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === s)
        break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === s)
          return;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
  }, al = function() {
  }, Ci = function(i, s, p, y) {
    var S = i.memoizedProps;
    if (S !== y) {
      i = s.stateNode, Yu(Zi.current);
      var C = null;
      switch (p) {
        case "input":
          S = xn(i, S), y = xn(i, y), C = [];
          break;
        case "select":
          S = z({}, S, { value: void 0 }), y = z({}, y, { value: void 0 }), C = [];
          break;
        case "textarea":
          S = Ca(i, S), y = Ca(i, y), C = [];
          break;
        default:
          typeof S.onClick != "function" && typeof y.onClick == "function" && (i.onclick = vp);
      }
      ir(p, y);
      var D;
      p = null;
      for (ue in S)
        if (!y.hasOwnProperty(ue) && S.hasOwnProperty(ue) && S[ue] != null)
          if (ue === "style") {
            var U = S[ue];
            for (D in U)
              U.hasOwnProperty(D) && (p || (p = {}), p[D] = "");
          } else
            ue !== "dangerouslySetInnerHTML" && ue !== "children" && ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && ue !== "autoFocus" && (l.hasOwnProperty(ue) ? C || (C = []) : (C = C || []).push(ue, null));
      for (ue in y) {
        var Z = y[ue];
        if (U = S != null ? S[ue] : void 0, y.hasOwnProperty(ue) && Z !== U && (Z != null || U != null))
          if (ue === "style")
            if (U) {
              for (D in U)
                !U.hasOwnProperty(D) || Z && Z.hasOwnProperty(D) || (p || (p = {}), p[D] = "");
              for (D in Z)
                Z.hasOwnProperty(D) && U[D] !== Z[D] && (p || (p = {}), p[D] = Z[D]);
            } else
              p || (C || (C = []), C.push(
                ue,
                p
              )), p = Z;
          else
            ue === "dangerouslySetInnerHTML" ? (Z = Z ? Z.__html : void 0, U = U ? U.__html : void 0, Z != null && U !== Z && (C = C || []).push(ue, Z)) : ue === "children" ? typeof Z != "string" && typeof Z != "number" || (C = C || []).push(ue, "" + Z) : ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && (l.hasOwnProperty(ue) ? (Z != null && ue === "onScroll" && En("scroll", i), C || U === Z || (C = [])) : (C = C || []).push(ue, Z));
      }
      p && (C = C || []).push("style", p);
      var ue = C;
      (s.updateQueue = ue) && (s.flags |= 4);
    }
  }, gr = function(i, s, p, y) {
    p !== y && (s.flags |= 4);
  };
  function ef(i, s) {
    if (!In)
      switch (i.tailMode) {
        case "hidden":
          s = i.tail;
          for (var p = null; s !== null; )
            s.alternate !== null && (p = s), s = s.sibling;
          p === null ? i.tail = null : p.sibling = null;
          break;
        case "collapsed":
          p = i.tail;
          for (var y = null; p !== null; )
            p.alternate !== null && (y = p), p = p.sibling;
          y === null ? s || i.tail === null ? i.tail = null : i.tail.sibling = null : y.sibling = null;
      }
  }
  function Jr(i) {
    var s = i.alternate !== null && i.alternate.child === i.child, p = 0, y = 0;
    if (s)
      for (var S = i.child; S !== null; )
        p |= S.lanes | S.childLanes, y |= S.subtreeFlags & 14680064, y |= S.flags & 14680064, S.return = i, S = S.sibling;
    else
      for (S = i.child; S !== null; )
        p |= S.lanes | S.childLanes, y |= S.subtreeFlags, y |= S.flags, S.return = i, S = S.sibling;
    return i.subtreeFlags |= y, i.childLanes = p, s;
  }
  function t2(i, s, p) {
    var y = s.pendingProps;
    switch (oy(s), s.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Jr(s), null;
      case 1:
        return Fn(s.type) && wi(), Jr(s), null;
      case 3:
        return y = s.stateNode, ru(), ln(er), ln(Et), Op(), y.pendingContext && (y.context = y.pendingContext, y.pendingContext = null), (i === null || i.child === null) && (Sp(s) ? s.flags |= 4 : i === null || i.memoizedState.isDehydrated && !(s.flags & 256) || (s.flags |= 1024, Si !== null && (uf(Si), Si = null))), al(i, s), Jr(s), null;
      case 5:
        zt(s);
        var S = Yu(hc.current);
        if (p = s.type, i !== null && s.stateNode != null)
          Ci(i, s, p, y, S), i.ref !== s.ref && (s.flags |= 512, s.flags |= 2097152);
        else {
          if (!y) {
            if (s.stateNode === null)
              throw Error(r(166));
            return Jr(s), null;
          }
          if (i = Yu(Zi.current), Sp(s)) {
            y = s.stateNode, p = s.type;
            var C = s.memoizedProps;
            switch (y[mo] = s, y[Gu] = C, i = (s.mode & 1) !== 0, p) {
              case "dialog":
                En("cancel", y), En("close", y);
                break;
              case "iframe":
              case "object":
              case "embed":
                En("load", y);
                break;
              case "video":
              case "audio":
                for (S = 0; S < Ld.length; S++)
                  En(Ld[S], y);
                break;
              case "source":
                En("error", y);
                break;
              case "img":
              case "image":
              case "link":
                En(
                  "error",
                  y
                ), En("load", y);
                break;
              case "details":
                En("toggle", y);
                break;
              case "input":
                gn(y, C), En("invalid", y);
                break;
              case "select":
                y._wrapperState = { wasMultiple: !!C.multiple }, En("invalid", y);
                break;
              case "textarea":
                Zr(y, C), En("invalid", y);
            }
            ir(p, C), S = null;
            for (var D in C)
              if (C.hasOwnProperty(D)) {
                var U = C[D];
                D === "children" ? typeof U == "string" ? y.textContent !== U && (C.suppressHydrationWarning !== !0 && yp(y.textContent, U, i), S = ["children", U]) : typeof U == "number" && y.textContent !== "" + U && (C.suppressHydrationWarning !== !0 && yp(
                  y.textContent,
                  U,
                  i
                ), S = ["children", "" + U]) : l.hasOwnProperty(D) && U != null && D === "onScroll" && En("scroll", y);
              }
            switch (p) {
              case "input":
                rr(y), Wr(y, C, !0);
                break;
              case "textarea":
                rr(y), Ir(y);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof C.onClick == "function" && (y.onclick = vp);
            }
            y = S, s.updateQueue = y, y !== null && (s.flags |= 4);
          } else {
            D = S.nodeType === 9 ? S : S.ownerDocument, i === "http://www.w3.org/1999/xhtml" && (i = Ta(p)), i === "http://www.w3.org/1999/xhtml" ? p === "script" ? (i = D.createElement("div"), i.innerHTML = "<script><\/script>", i = i.removeChild(i.firstChild)) : typeof y.is == "string" ? i = D.createElement(p, { is: y.is }) : (i = D.createElement(p), p === "select" && (D = i, y.multiple ? D.multiple = !0 : y.size && (D.size = y.size))) : i = D.createElementNS(i, p), i[mo] = s, i[Gu] = y, Jd(i, s, !1, !1), s.stateNode = i;
            e: {
              switch (D = qn(p, y), p) {
                case "dialog":
                  En("cancel", i), En("close", i), S = y;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  En("load", i), S = y;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < Ld.length; S++)
                    En(Ld[S], i);
                  S = y;
                  break;
                case "source":
                  En("error", i), S = y;
                  break;
                case "img":
                case "image":
                case "link":
                  En(
                    "error",
                    i
                  ), En("load", i), S = y;
                  break;
                case "details":
                  En("toggle", i), S = y;
                  break;
                case "input":
                  gn(i, y), S = xn(i, y), En("invalid", i);
                  break;
                case "option":
                  S = y;
                  break;
                case "select":
                  i._wrapperState = { wasMultiple: !!y.multiple }, S = z({}, y, { value: void 0 }), En("invalid", i);
                  break;
                case "textarea":
                  Zr(i, y), S = Ca(i, y), En("invalid", i);
                  break;
                default:
                  S = y;
              }
              ir(p, S), U = S;
              for (C in U)
                if (U.hasOwnProperty(C)) {
                  var Z = U[C];
                  C === "style" ? un(i, Z) : C === "dangerouslySetInnerHTML" ? (Z = Z ? Z.__html : void 0, Z != null && oo(i, Z)) : C === "children" ? typeof Z == "string" ? (p !== "textarea" || Z !== "") && Wa(i, Z) : typeof Z == "number" && Wa(i, "" + Z) : C !== "suppressContentEditableWarning" && C !== "suppressHydrationWarning" && C !== "autoFocus" && (l.hasOwnProperty(C) ? Z != null && C === "onScroll" && En("scroll", i) : Z != null && L(i, C, Z, D));
                }
              switch (p) {
                case "input":
                  rr(i), Wr(i, y, !1);
                  break;
                case "textarea":
                  rr(i), Ir(i);
                  break;
                case "option":
                  y.value != null && i.setAttribute("value", "" + wt(y.value));
                  break;
                case "select":
                  i.multiple = !!y.multiple, C = y.value, C != null ? ar(i, !!y.multiple, C, !1) : y.defaultValue != null && ar(
                    i,
                    !!y.multiple,
                    y.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof S.onClick == "function" && (i.onclick = vp);
              }
              switch (p) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  y = !!y.autoFocus;
                  break e;
                case "img":
                  y = !0;
                  break e;
                default:
                  y = !1;
              }
            }
            y && (s.flags |= 4);
          }
          s.ref !== null && (s.flags |= 512, s.flags |= 2097152);
        }
        return Jr(s), null;
      case 6:
        if (i && s.stateNode != null)
          gr(i, s, i.memoizedProps, y);
        else {
          if (typeof y != "string" && s.stateNode === null)
            throw Error(r(166));
          if (p = Yu(hc.current), Yu(Zi.current), Sp(s)) {
            if (y = s.stateNode, p = s.memoizedProps, y[mo] = s, (C = y.nodeValue !== p) && (i = Ja, i !== null))
              switch (i.tag) {
                case 3:
                  yp(y.nodeValue, p, (i.mode & 1) !== 0);
                  break;
                case 5:
                  i.memoizedProps.suppressHydrationWarning !== !0 && yp(y.nodeValue, p, (i.mode & 1) !== 0);
              }
            C && (s.flags |= 4);
          } else
            y = (p.nodeType === 9 ? p : p.ownerDocument).createTextNode(y), y[mo] = s, s.stateNode = y;
        }
        return Jr(s), null;
      case 13:
        if (ln(vt), y = s.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
          if (In && Ma !== null && s.mode & 1 && !(s.flags & 128))
            tb(), Yn(), s.flags |= 98560, C = !1;
          else if (C = Sp(s), y !== null && y.dehydrated !== null) {
            if (i === null) {
              if (!C)
                throw Error(r(318));
              if (C = s.memoizedState, C = C !== null ? C.dehydrated : null, !C)
                throw Error(r(317));
              C[mo] = s;
            } else
              Yn(), !(s.flags & 128) && (s.memoizedState = null), s.flags |= 4;
            Jr(s), C = !1;
          } else
            Si !== null && (uf(Si), Si = null), C = !0;
          if (!C)
            return s.flags & 65536 ? s : null;
        }
        return s.flags & 128 ? (s.lanes = p, s) : (y = y !== null, y !== (i !== null && i.memoizedState !== null) && y && (s.child.flags |= 8192, s.mode & 1 && (i === null || vt.current & 1 ? wr === 0 && (wr = 3) : $y())), s.updateQueue !== null && (s.flags |= 4), Jr(s), null);
      case 4:
        return ru(), al(i, s), i === null && lc(s.stateNode.containerInfo), Jr(s), null;
      case 10:
        return Js(s.type._context), Jr(s), null;
      case 17:
        return Fn(s.type) && wi(), Jr(s), null;
      case 19:
        if (ln(vt), C = s.memoizedState, C === null)
          return Jr(s), null;
        if (y = (s.flags & 128) !== 0, D = C.rendering, D === null)
          if (y)
            ef(C, !1);
          else {
            if (wr !== 0 || i !== null && i.flags & 128)
              for (i = s.child; i !== null; ) {
                if (D = Zn(i), D !== null) {
                  for (s.flags |= 128, ef(C, !1), y = D.updateQueue, y !== null && (s.updateQueue = y, s.flags |= 4), s.subtreeFlags = 0, y = p, p = s.child; p !== null; )
                    C = p, i = y, C.flags &= 14680066, D = C.alternate, D === null ? (C.childLanes = 0, C.lanes = i, C.child = null, C.subtreeFlags = 0, C.memoizedProps = null, C.memoizedState = null, C.updateQueue = null, C.dependencies = null, C.stateNode = null) : (C.childLanes = D.childLanes, C.lanes = D.lanes, C.child = D.child, C.subtreeFlags = 0, C.deletions = null, C.memoizedProps = D.memoizedProps, C.memoizedState = D.memoizedState, C.updateQueue = D.updateQueue, C.type = D.type, i = D.dependencies, C.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }), p = p.sibling;
                  return hn(vt, vt.current & 1 | 2), s.child;
                }
                i = i.sibling;
              }
            C.tail !== null && Jt() > _c && (s.flags |= 128, y = !0, ef(C, !1), s.lanes = 4194304);
          }
        else {
          if (!y)
            if (i = Zn(D), i !== null) {
              if (s.flags |= 128, y = !0, p = i.updateQueue, p !== null && (s.updateQueue = p, s.flags |= 4), ef(C, !0), C.tail === null && C.tailMode === "hidden" && !D.alternate && !In)
                return Jr(s), null;
            } else
              2 * Jt() - C.renderingStartTime > _c && p !== 1073741824 && (s.flags |= 128, y = !0, ef(C, !1), s.lanes = 4194304);
          C.isBackwards ? (D.sibling = s.child, s.child = D) : (p = C.last, p !== null ? p.sibling = D : s.child = D, C.last = D);
        }
        return C.tail !== null ? (s = C.tail, C.rendering = s, C.tail = s.sibling, C.renderingStartTime = Jt(), s.sibling = null, p = vt.current, hn(vt, y ? p & 1 | 2 : p & 1), s) : (Jr(s), null);
      case 22:
      case 23:
        return My(), y = s.memoizedState !== null, i !== null && i.memoizedState !== null !== y && (s.flags |= 8192), y && s.mode & 1 ? ni & 1073741824 && (Jr(s), s.subtreeFlags & 6 && (s.flags |= 8192)) : Jr(s), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(r(156, s.tag));
  }
  function _y(i, s) {
    switch (oy(s), s.tag) {
      case 1:
        return Fn(s.type) && wi(), i = s.flags, i & 65536 ? (s.flags = i & -65537 | 128, s) : null;
      case 3:
        return ru(), ln(er), ln(Et), Op(), i = s.flags, i & 65536 && !(i & 128) ? (s.flags = i & -65537 | 128, s) : null;
      case 5:
        return zt(s), null;
      case 13:
        if (ln(vt), i = s.memoizedState, i !== null && i.dehydrated !== null) {
          if (s.alternate === null)
            throw Error(r(340));
          Yn();
        }
        return i = s.flags, i & 65536 ? (s.flags = i & -65537 | 128, s) : null;
      case 19:
        return ln(vt), null;
      case 4:
        return ru(), null;
      case 10:
        return Js(s.type._context), null;
      case 22:
      case 23:
        return My(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var tf = !1, br = !1, mb = typeof WeakSet == "function" ? WeakSet : Set, Ze = null;
  function xc(i, s) {
    var p = i.ref;
    if (p !== null)
      if (typeof p == "function")
        try {
          p(null);
        } catch (y) {
          nr(i, s, y);
        }
      else
        p.current = null;
  }
  function nf(i, s, p) {
    try {
      p();
    } catch (y) {
      nr(i, s, y);
    }
  }
  var yb = !1;
  function vb(i, s) {
    if (Xm = yi, i = dp(), Yo(i)) {
      if ("selectionStart" in i)
        var p = { start: i.selectionStart, end: i.selectionEnd };
      else
        e: {
          p = (p = i.ownerDocument) && p.defaultView || window;
          var y = p.getSelection && p.getSelection();
          if (y && y.rangeCount !== 0) {
            p = y.anchorNode;
            var S = y.anchorOffset, C = y.focusNode;
            y = y.focusOffset;
            try {
              p.nodeType, C.nodeType;
            } catch {
              p = null;
              break e;
            }
            var D = 0, U = -1, Z = -1, ue = 0, _e = 0, Oe = i, Te = null;
            t:
              for (; ; ) {
                for (var Ue; Oe !== p || S !== 0 && Oe.nodeType !== 3 || (U = D + S), Oe !== C || y !== 0 && Oe.nodeType !== 3 || (Z = D + y), Oe.nodeType === 3 && (D += Oe.nodeValue.length), (Ue = Oe.firstChild) !== null; )
                  Te = Oe, Oe = Ue;
                for (; ; ) {
                  if (Oe === i)
                    break t;
                  if (Te === p && ++ue === S && (U = D), Te === C && ++_e === y && (Z = D), (Ue = Oe.nextSibling) !== null)
                    break;
                  Oe = Te, Te = Oe.parentNode;
                }
                Oe = Ue;
              }
            p = U === -1 || Z === -1 ? null : { start: U, end: Z };
          } else
            p = null;
        }
      p = p || { start: 0, end: 0 };
    } else
      p = null;
    for (Hu = { focusedElem: i, selectionRange: p }, yi = !1, Ze = s; Ze !== null; )
      if (s = Ze, i = s.child, (s.subtreeFlags & 1028) !== 0 && i !== null)
        i.return = s, Ze = i;
      else
        for (; Ze !== null; ) {
          s = Ze;
          try {
            var Je = s.alternate;
            if (s.flags & 1024)
              switch (s.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Je !== null) {
                    var nt = Je.memoizedProps, sr = Je.memoizedState, J = s.stateNode, Q = J.getSnapshotBeforeUpdate(s.elementType === s.type ? nt : ei(s.type, nt), sr);
                    J.__reactInternalSnapshotBeforeUpdate = Q;
                  }
                  break;
                case 3:
                  var ne = s.stateNode.containerInfo;
                  ne.nodeType === 1 ? ne.textContent = "" : ne.nodeType === 9 && ne.documentElement && ne.removeChild(ne.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(r(163));
              }
          } catch (Ie) {
            nr(s, s.return, Ie);
          }
          if (i = s.sibling, i !== null) {
            i.return = s.return, Ze = i;
            break;
          }
          Ze = s.return;
        }
    return Je = yb, yb = !1, Je;
  }
  function rf(i, s, p) {
    var y = s.updateQueue;
    if (y = y !== null ? y.lastEffect : null, y !== null) {
      var S = y = y.next;
      do {
        if ((S.tag & i) === i) {
          var C = S.destroy;
          S.destroy = void 0, C !== void 0 && nf(s, p, C);
        }
        S = S.next;
      } while (S !== y);
    }
  }
  function af(i, s) {
    if (s = s.updateQueue, s = s !== null ? s.lastEffect : null, s !== null) {
      var p = s = s.next;
      do {
        if ((p.tag & i) === i) {
          var y = p.create;
          p.destroy = y();
        }
        p = p.next;
      } while (p !== s);
    }
  }
  function Ry(i) {
    var s = i.ref;
    if (s !== null) {
      var p = i.stateNode;
      switch (i.tag) {
        case 5:
          i = p;
          break;
        default:
          i = p;
      }
      typeof s == "function" ? s(i) : s.current = i;
    }
  }
  function Oy(i) {
    var s = i.alternate;
    s !== null && (i.alternate = null, Oy(s)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (s = i.stateNode, s !== null && (delete s[mo], delete s[Gu], delete s[ty], delete s[Yx], delete s[ny])), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
  }
  function gb(i) {
    return i.tag === 5 || i.tag === 3 || i.tag === 4;
  }
  function Qp(i) {
    e:
      for (; ; ) {
        for (; i.sibling === null; ) {
          if (i.return === null || gb(i.return))
            return null;
          i = i.return;
        }
        for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
          if (i.flags & 2 || i.child === null || i.tag === 4)
            continue e;
          i.child.return = i, i = i.child;
        }
        if (!(i.flags & 2))
          return i.stateNode;
      }
  }
  function Sc(i, s, p) {
    var y = i.tag;
    if (y === 5 || y === 6)
      i = i.stateNode, s ? p.nodeType === 8 ? p.parentNode.insertBefore(i, s) : p.insertBefore(i, s) : (p.nodeType === 8 ? (s = p.parentNode, s.insertBefore(i, p)) : (s = p, s.appendChild(i)), p = p._reactRootContainer, p != null || s.onclick !== null || (s.onclick = vp));
    else if (y !== 4 && (i = i.child, i !== null))
      for (Sc(i, s, p), i = i.sibling; i !== null; )
        Sc(i, s, p), i = i.sibling;
  }
  function bo(i, s, p) {
    var y = i.tag;
    if (y === 5 || y === 6)
      i = i.stateNode, s ? p.insertBefore(i, s) : p.appendChild(i);
    else if (y !== 4 && (i = i.child, i !== null))
      for (bo(i, s, p), i = i.sibling; i !== null; )
        bo(i, s, p), i = i.sibling;
  }
  var zn = null, Pr = !1;
  function Ti(i, s, p) {
    for (p = p.child; p !== null; )
      kc(i, s, p), p = p.sibling;
  }
  function kc(i, s, p) {
    if (_a && typeof _a.onCommitFiberUnmount == "function")
      try {
        _a.onCommitFiberUnmount(Ms, p);
      } catch {
      }
    switch (p.tag) {
      case 5:
        br || xc(p, s);
      case 6:
        var y = zn, S = Pr;
        zn = null, Ti(i, s, p), zn = y, Pr = S, zn !== null && (Pr ? (i = zn, p = p.stateNode, i.nodeType === 8 ? i.parentNode.removeChild(p) : i.removeChild(p)) : zn.removeChild(p.stateNode));
        break;
      case 18:
        zn !== null && (Pr ? (i = zn, p = p.stateNode, i.nodeType === 8 ? Ws(i.parentNode, p) : i.nodeType === 1 && Ws(i, p), Us(i)) : Ws(zn, p.stateNode));
        break;
      case 4:
        y = zn, S = Pr, zn = p.stateNode.containerInfo, Pr = !0, Ti(i, s, p), zn = y, Pr = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!br && (y = p.updateQueue, y !== null && (y = y.lastEffect, y !== null))) {
          S = y = y.next;
          do {
            var C = S, D = C.destroy;
            C = C.tag, D !== void 0 && (C & 2 || C & 4) && nf(p, s, D), S = S.next;
          } while (S !== y);
        }
        Ti(i, s, p);
        break;
      case 1:
        if (!br && (xc(p, s), y = p.stateNode, typeof y.componentWillUnmount == "function"))
          try {
            y.props = p.memoizedProps, y.state = p.memoizedState, y.componentWillUnmount();
          } catch (U) {
            nr(p, s, U);
          }
        Ti(i, s, p);
        break;
      case 21:
        Ti(i, s, p);
        break;
      case 22:
        p.mode & 1 ? (br = (y = br) || p.memoizedState !== null, Ti(i, s, p), br = y) : Ti(i, s, p);
        break;
      default:
        Ti(i, s, p);
    }
  }
  function rs(i) {
    var s = i.updateQueue;
    if (s !== null) {
      i.updateQueue = null;
      var p = i.stateNode;
      p === null && (p = i.stateNode = new mb()), s.forEach(function(y) {
        var S = s2.bind(null, i, y);
        p.has(y) || (p.add(y), y.then(S, S));
      });
    }
  }
  function Ki(i, s) {
    var p = s.deletions;
    if (p !== null)
      for (var y = 0; y < p.length; y++) {
        var S = p[y];
        try {
          var C = i, D = s, U = D;
          e:
            for (; U !== null; ) {
              switch (U.tag) {
                case 5:
                  zn = U.stateNode, Pr = !1;
                  break e;
                case 3:
                  zn = U.stateNode.containerInfo, Pr = !0;
                  break e;
                case 4:
                  zn = U.stateNode.containerInfo, Pr = !0;
                  break e;
              }
              U = U.return;
            }
          if (zn === null)
            throw Error(r(160));
          kc(C, D, S), zn = null, Pr = !1;
          var Z = S.alternate;
          Z !== null && (Z.return = null), S.return = null;
        } catch (ue) {
          nr(S, s, ue);
        }
      }
    if (s.subtreeFlags & 12854)
      for (s = s.child; s !== null; )
        bb(s, i), s = s.sibling;
  }
  function bb(i, s) {
    var p = i.alternate, y = i.flags;
    switch (i.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Ki(s, i), wo(i), y & 4) {
          try {
            rf(3, i, i.return), af(3, i);
          } catch (nt) {
            nr(i, i.return, nt);
          }
          try {
            rf(5, i, i.return);
          } catch (nt) {
            nr(i, i.return, nt);
          }
        }
        break;
      case 1:
        Ki(s, i), wo(i), y & 512 && p !== null && xc(p, p.return);
        break;
      case 5:
        if (Ki(s, i), wo(i), y & 512 && p !== null && xc(p, p.return), i.flags & 32) {
          var S = i.stateNode;
          try {
            Wa(S, "");
          } catch (nt) {
            nr(i, i.return, nt);
          }
        }
        if (y & 4 && (S = i.stateNode, S != null)) {
          var C = i.memoizedProps, D = p !== null ? p.memoizedProps : C, U = i.type, Z = i.updateQueue;
          if (i.updateQueue = null, Z !== null)
            try {
              U === "input" && C.type === "radio" && C.name != null && An(S, C), qn(U, D);
              var ue = qn(U, C);
              for (D = 0; D < Z.length; D += 2) {
                var _e = Z[D], Oe = Z[D + 1];
                _e === "style" ? un(S, Oe) : _e === "dangerouslySetInnerHTML" ? oo(S, Oe) : _e === "children" ? Wa(S, Oe) : L(S, _e, Oe, ue);
              }
              switch (U) {
                case "input":
                  Vn(S, C);
                  break;
                case "textarea":
                  qa(S, C);
                  break;
                case "select":
                  var Te = S._wrapperState.wasMultiple;
                  S._wrapperState.wasMultiple = !!C.multiple;
                  var Ue = C.value;
                  Ue != null ? ar(S, !!C.multiple, Ue, !1) : Te !== !!C.multiple && (C.defaultValue != null ? ar(
                    S,
                    !!C.multiple,
                    C.defaultValue,
                    !0
                  ) : ar(S, !!C.multiple, C.multiple ? [] : "", !1));
              }
              S[Gu] = C;
            } catch (nt) {
              nr(i, i.return, nt);
            }
        }
        break;
      case 6:
        if (Ki(s, i), wo(i), y & 4) {
          if (i.stateNode === null)
            throw Error(r(162));
          S = i.stateNode, C = i.memoizedProps;
          try {
            S.nodeValue = C;
          } catch (nt) {
            nr(i, i.return, nt);
          }
        }
        break;
      case 3:
        if (Ki(s, i), wo(i), y & 4 && p !== null && p.memoizedState.isDehydrated)
          try {
            Us(s.containerInfo);
          } catch (nt) {
            nr(i, i.return, nt);
          }
        break;
      case 4:
        Ki(s, i), wo(i);
        break;
      case 13:
        Ki(s, i), wo(i), S = i.child, S.flags & 8192 && (C = S.memoizedState !== null, S.stateNode.isHidden = C, !C || S.alternate !== null && S.alternate.memoizedState !== null || (Ay = Jt())), y & 4 && rs(i);
        break;
      case 22:
        if (_e = p !== null && p.memoizedState !== null, i.mode & 1 ? (br = (ue = br) || _e, Ki(s, i), br = ue) : Ki(s, i), wo(i), y & 8192) {
          if (ue = i.memoizedState !== null, (i.stateNode.isHidden = ue) && !_e && i.mode & 1)
            for (Ze = i, _e = i.child; _e !== null; ) {
              for (Oe = Ze = _e; Ze !== null; ) {
                switch (Te = Ze, Ue = Te.child, Te.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    rf(4, Te, Te.return);
                    break;
                  case 1:
                    xc(Te, Te.return);
                    var Je = Te.stateNode;
                    if (typeof Je.componentWillUnmount == "function") {
                      y = Te, p = Te.return;
                      try {
                        s = y, Je.props = s.memoizedProps, Je.state = s.memoizedState, Je.componentWillUnmount();
                      } catch (nt) {
                        nr(y, p, nt);
                      }
                    }
                    break;
                  case 5:
                    xc(Te, Te.return);
                    break;
                  case 22:
                    if (Te.memoizedState !== null) {
                      Py(Oe);
                      continue;
                    }
                }
                Ue !== null ? (Ue.return = Te, Ze = Ue) : Py(Oe);
              }
              _e = _e.sibling;
            }
          e:
            for (_e = null, Oe = i; ; ) {
              if (Oe.tag === 5) {
                if (_e === null) {
                  _e = Oe;
                  try {
                    S = Oe.stateNode, ue ? (C = S.style, typeof C.setProperty == "function" ? C.setProperty("display", "none", "important") : C.display = "none") : (U = Oe.stateNode, Z = Oe.memoizedProps.style, D = Z != null && Z.hasOwnProperty("display") ? Z.display : null, U.style.display = $t("display", D));
                  } catch (nt) {
                    nr(i, i.return, nt);
                  }
                }
              } else if (Oe.tag === 6) {
                if (_e === null)
                  try {
                    Oe.stateNode.nodeValue = ue ? "" : Oe.memoizedProps;
                  } catch (nt) {
                    nr(i, i.return, nt);
                  }
              } else if ((Oe.tag !== 22 && Oe.tag !== 23 || Oe.memoizedState === null || Oe === i) && Oe.child !== null) {
                Oe.child.return = Oe, Oe = Oe.child;
                continue;
              }
              if (Oe === i)
                break e;
              for (; Oe.sibling === null; ) {
                if (Oe.return === null || Oe.return === i)
                  break e;
                _e === Oe && (_e = null), Oe = Oe.return;
              }
              _e === Oe && (_e = null), Oe.sibling.return = Oe.return, Oe = Oe.sibling;
            }
        }
        break;
      case 19:
        Ki(s, i), wo(i), y & 4 && rs(i);
        break;
      case 21:
        break;
      default:
        Ki(
          s,
          i
        ), wo(i);
    }
  }
  function wo(i) {
    var s = i.flags;
    if (s & 2) {
      try {
        e: {
          for (var p = i.return; p !== null; ) {
            if (gb(p)) {
              var y = p;
              break e;
            }
            p = p.return;
          }
          throw Error(r(160));
        }
        switch (y.tag) {
          case 5:
            var S = y.stateNode;
            y.flags & 32 && (Wa(S, ""), y.flags &= -33);
            var C = Qp(i);
            bo(i, C, S);
            break;
          case 3:
          case 4:
            var D = y.stateNode.containerInfo, U = Qp(i);
            Sc(i, U, D);
            break;
          default:
            throw Error(r(161));
        }
      } catch (Z) {
        nr(i, i.return, Z);
      }
      i.flags &= -3;
    }
    s & 4096 && (i.flags &= -4097);
  }
  function wb(i, s, p) {
    Ze = i, Ec(i);
  }
  function Ec(i, s, p) {
    for (var y = (i.mode & 1) !== 0; Ze !== null; ) {
      var S = Ze, C = S.child;
      if (S.tag === 22 && y) {
        var D = S.memoizedState !== null || tf;
        if (!D) {
          var U = S.alternate, Z = U !== null && U.memoizedState !== null || br;
          U = tf;
          var ue = br;
          if (tf = D, (br = Z) && !ue)
            for (Ze = S; Ze !== null; )
              D = Ze, Z = D.child, D.tag === 22 && D.memoizedState !== null ? Sb(S) : Z !== null ? (Z.return = D, Ze = Z) : Sb(S);
          for (; C !== null; )
            Ze = C, Ec(C), C = C.sibling;
          Ze = S, tf = U, br = ue;
        }
        xb(i);
      } else
        S.subtreeFlags & 8772 && C !== null ? (C.return = S, Ze = C) : xb(i);
    }
  }
  function xb(i) {
    for (; Ze !== null; ) {
      var s = Ze;
      if (s.flags & 8772) {
        var p = s.alternate;
        try {
          if (s.flags & 8772)
            switch (s.tag) {
              case 0:
              case 11:
              case 15:
                br || af(5, s);
                break;
              case 1:
                var y = s.stateNode;
                if (s.flags & 4 && !br)
                  if (p === null)
                    y.componentDidMount();
                  else {
                    var S = s.elementType === s.type ? p.memoizedProps : ei(s.type, p.memoizedProps);
                    y.componentDidUpdate(S, p.memoizedState, y.__reactInternalSnapshotBeforeUpdate);
                  }
                var C = s.updateQueue;
                C !== null && Wu(s, C, y);
                break;
              case 3:
                var D = s.updateQueue;
                if (D !== null) {
                  if (p = null, s.child !== null)
                    switch (s.child.tag) {
                      case 5:
                        p = s.child.stateNode;
                        break;
                      case 1:
                        p = s.child.stateNode;
                    }
                  Wu(s, D, p);
                }
                break;
              case 5:
                var U = s.stateNode;
                if (p === null && s.flags & 4) {
                  p = U;
                  var Z = s.memoizedProps;
                  switch (s.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      Z.autoFocus && p.focus();
                      break;
                    case "img":
                      Z.src && (p.src = Z.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (s.memoizedState === null) {
                  var ue = s.alternate;
                  if (ue !== null) {
                    var _e = ue.memoizedState;
                    if (_e !== null) {
                      var Oe = _e.dehydrated;
                      Oe !== null && Us(Oe);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(r(163));
            }
          br || s.flags & 512 && Ry(s);
        } catch (Te) {
          nr(s, s.return, Te);
        }
      }
      if (s === i) {
        Ze = null;
        break;
      }
      if (p = s.sibling, p !== null) {
        p.return = s.return, Ze = p;
        break;
      }
      Ze = s.return;
    }
  }
  function Py(i) {
    for (; Ze !== null; ) {
      var s = Ze;
      if (s === i) {
        Ze = null;
        break;
      }
      var p = s.sibling;
      if (p !== null) {
        p.return = s.return, Ze = p;
        break;
      }
      Ze = s.return;
    }
  }
  function Sb(i) {
    for (; Ze !== null; ) {
      var s = Ze;
      try {
        switch (s.tag) {
          case 0:
          case 11:
          case 15:
            var p = s.return;
            try {
              af(4, s);
            } catch (Z) {
              nr(s, p, Z);
            }
            break;
          case 1:
            var y = s.stateNode;
            if (typeof y.componentDidMount == "function") {
              var S = s.return;
              try {
                y.componentDidMount();
              } catch (Z) {
                nr(s, S, Z);
              }
            }
            var C = s.return;
            try {
              Ry(s);
            } catch (Z) {
              nr(s, C, Z);
            }
            break;
          case 5:
            var D = s.return;
            try {
              Ry(s);
            } catch (Z) {
              nr(s, D, Z);
            }
        }
      } catch (Z) {
        nr(s, s.return, Z);
      }
      if (s === i) {
        Ze = null;
        break;
      }
      var U = s.sibling;
      if (U !== null) {
        U.return = s.return, Ze = U;
        break;
      }
      Ze = s.return;
    }
  }
  var Xp = Math.ceil, of = B.ReactCurrentDispatcher, jy = B.ReactCurrentOwner, ea = B.ReactCurrentBatchConfig, Gt = 0, Kn = null, tr = null, jr = 0, ni = 0, Cc = It(0), wr = 0, sf = null, as = 0, Jp = 0, Tc = 0, il = null, ma = null, Ay = 0, _c = 1 / 0, is = null, eh = !1, ol = null, xo = null, su = !1, uu = null, th = 0, Rc = 0, nh = null, sl = -1, ul = 0;
  function ta() {
    return Gt & 6 ? Jt() : sl !== -1 ? sl : sl = Jt();
  }
  function hr(i) {
    return i.mode & 1 ? Gt & 2 && jr !== 0 ? jr & -jr : kp.transition !== null ? (ul === 0 && (ul = Zl()), ul) : (i = rn, i !== 0 || (i = window.event, i = i === void 0 ? 16 : Rd(i.type)), i) : 1;
  }
  function na(i, s, p, y) {
    if (50 < Rc)
      throw Rc = 0, nh = null, Error(r(185));
    Ho(i, p, y), (!(Gt & 2) || i !== Kn) && (i === Kn && (!(Gt & 2) && (Jp |= p), wr === 4 && _i(i, jr)), ra(i, y), p === 1 && Gt === 0 && !(s.mode & 1) && (_c = Jt() + 500, Rr && Aa()));
  }
  function ra(i, s) {
    var p = i.callbackNode;
    Ns(i, s);
    var y = pa(i, i === Kn ? jr : 0);
    if (y === 0)
      p !== null && Mr(p), i.callbackNode = null, i.callbackPriority = 0;
    else if (s = y & -y, i.callbackPriority !== s) {
      if (p != null && Mr(p), s === 1)
        i.tag === 0 ? ay(kb.bind(null, i)) : ry(kb.bind(null, i)), ey(function() {
          !(Gt & 6) && Aa();
        }), p = null;
      else {
        switch (Ql(y)) {
          case 1:
            p = Ui;
            break;
          case 4:
            p = Nt;
            break;
          case 16:
            p = fo;
            break;
          case 536870912:
            p = Wl;
            break;
          default:
            p = fo;
        }
        p = Ny(p, Oc.bind(null, i));
      }
      i.callbackPriority = s, i.callbackNode = p;
    }
  }
  function Oc(i, s) {
    if (sl = -1, ul = 0, Gt & 6)
      throw Error(r(327));
    var p = i.callbackNode;
    if (jc() && i.callbackNode !== p)
      return null;
    var y = pa(i, i === Kn ? jr : 0);
    if (y === 0)
      return null;
    if (y & 30 || y & i.expiredLanes || s)
      s = ah(i, y);
    else {
      s = y;
      var S = Gt;
      Gt |= 2;
      var C = rh();
      (Kn !== i || jr !== s) && (is = null, _c = Jt() + 500, ll(i, s));
      do
        try {
          r2();
          break;
        } catch (U) {
          Eb(i, U);
        }
      while (1);
      cy(), of.current = C, Gt = S, tr !== null ? s = 0 : (Kn = null, jr = 0, s = wr);
    }
    if (s !== 0) {
      if (s === 2 && (S = Fs(i), S !== 0 && (y = S, s = Dy(i, S))), s === 1)
        throw p = sf, ll(i, 0), _i(i, y), ra(i, Jt()), p;
      if (s === 6)
        _i(i, y);
      else {
        if (S = i.current.alternate, !(y & 30) && !Iy(S) && (s = ah(i, y), s === 2 && (C = Fs(i), C !== 0 && (y = C, s = Dy(i, C))), s === 1))
          throw p = sf, ll(i, 0), _i(i, y), ra(i, Jt()), p;
        switch (i.finishedWork = S, i.finishedLanes = y, s) {
          case 0:
          case 1:
            throw Error(r(345));
          case 2:
            cl(i, ma, is);
            break;
          case 3:
            if (_i(i, y), (y & 130023424) === y && (s = Ay + 500 - Jt(), 10 < s)) {
              if (pa(i, 0) !== 0)
                break;
              if (S = i.suspendedLanes, (S & y) !== y) {
                ta(), i.pingedLanes |= i.suspendedLanes & S;
                break;
              }
              i.timeoutHandle = Vu(cl.bind(null, i, ma, is), s);
              break;
            }
            cl(i, ma, is);
            break;
          case 4:
            if (_i(i, y), (y & 4194240) === y)
              break;
            for (s = i.eventTimes, S = -1; 0 < y; ) {
              var D = 31 - fa(y);
              C = 1 << D, D = s[D], D > S && (S = D), y &= ~C;
            }
            if (y = S, y = Jt() - y, y = (120 > y ? 120 : 480 > y ? 480 : 1080 > y ? 1080 : 1920 > y ? 1920 : 3e3 > y ? 3e3 : 4320 > y ? 4320 : 1960 * Xp(y / 1960)) - y, 10 < y) {
              i.timeoutHandle = Vu(cl.bind(null, i, ma, is), y);
              break;
            }
            cl(i, ma, is);
            break;
          case 5:
            cl(i, ma, is);
            break;
          default:
            throw Error(r(329));
        }
      }
    }
    return ra(i, Jt()), i.callbackNode === p ? Oc.bind(null, i) : null;
  }
  function Dy(i, s) {
    var p = il;
    return i.current.memoizedState.isDehydrated && (ll(i, s).flags |= 256), i = ah(i, s), i !== 2 && (s = ma, ma = p, s !== null && uf(s)), i;
  }
  function uf(i) {
    ma === null ? ma = i : ma.push.apply(ma, i);
  }
  function Iy(i) {
    for (var s = i; ; ) {
      if (s.flags & 16384) {
        var p = s.updateQueue;
        if (p !== null && (p = p.stores, p !== null))
          for (var y = 0; y < p.length; y++) {
            var S = p[y], C = S.getSnapshot;
            S = S.value;
            try {
              if (!vi(C(), S))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (p = s.child, s.subtreeFlags & 16384 && p !== null)
        p.return = s, s = p;
      else {
        if (s === i)
          break;
        for (; s.sibling === null; ) {
          if (s.return === null || s.return === i)
            return !0;
          s = s.return;
        }
        s.sibling.return = s.return, s = s.sibling;
      }
    }
    return !0;
  }
  function _i(i, s) {
    for (s &= ~Tc, s &= ~Jp, i.suspendedLanes |= s, i.pingedLanes &= ~s, i = i.expirationTimes; 0 < s; ) {
      var p = 31 - fa(s), y = 1 << p;
      i[p] = -1, s &= ~y;
    }
  }
  function kb(i) {
    if (Gt & 6)
      throw Error(r(327));
    jc();
    var s = pa(i, 0);
    if (!(s & 1))
      return ra(i, Jt()), null;
    var p = ah(i, s);
    if (i.tag !== 0 && p === 2) {
      var y = Fs(i);
      y !== 0 && (s = y, p = Dy(i, y));
    }
    if (p === 1)
      throw p = sf, ll(i, 0), _i(i, s), ra(i, Jt()), p;
    if (p === 6)
      throw Error(r(345));
    return i.finishedWork = i.current.alternate, i.finishedLanes = s, cl(i, ma, is), ra(i, Jt()), null;
  }
  function Pc(i, s) {
    var p = Gt;
    Gt |= 1;
    try {
      return i(s);
    } finally {
      Gt = p, Gt === 0 && (_c = Jt() + 500, Rr && Aa());
    }
  }
  function lu(i) {
    uu !== null && uu.tag === 0 && !(Gt & 6) && jc();
    var s = Gt;
    Gt |= 1;
    var p = ea.transition, y = rn;
    try {
      if (ea.transition = null, rn = 1, i)
        return i();
    } finally {
      rn = y, ea.transition = p, Gt = s, !(Gt & 6) && Aa();
    }
  }
  function My() {
    ni = Cc.current, ln(Cc);
  }
  function ll(i, s) {
    i.finishedWork = null, i.finishedLanes = 0;
    var p = i.timeoutHandle;
    if (p !== -1 && (i.timeoutHandle = -1, Q0(p)), tr !== null)
      for (p = tr.return; p !== null; ) {
        var y = p;
        switch (oy(y), y.tag) {
          case 1:
            y = y.type.childContextTypes, y != null && wi();
            break;
          case 3:
            ru(), ln(er), ln(Et), Op();
            break;
          case 5:
            zt(y);
            break;
          case 4:
            ru();
            break;
          case 13:
            ln(vt);
            break;
          case 19:
            ln(vt);
            break;
          case 10:
            Js(y.type._context);
            break;
          case 22:
          case 23:
            My();
        }
        p = p.return;
      }
    if (Kn = i, tr = i = cu(i.current, null), jr = ni = s, wr = 0, sf = null, Tc = Jp = as = 0, ma = il = null, Lr !== null) {
      for (s = 0; s < Lr.length; s++)
        if (p = Lr[s], y = p.interleaved, y !== null) {
          p.interleaved = null;
          var S = y.next, C = p.pending;
          if (C !== null) {
            var D = C.next;
            C.next = S, y.next = D;
          }
          p.pending = y;
        }
      Lr = null;
    }
    return i;
  }
  function Eb(i, s) {
    do {
      var p = tr;
      try {
        if (cy(), Pp.current = qp, gt) {
          for (var y = Mn.memoizedState; y !== null; ) {
            var S = y.queue;
            S !== null && (S.pending = null), y = y.next;
          }
          gt = !1;
        }
        if (Zu = 0, Zt = be = Mn = null, go = !1, ti = 0, jy.current = null, p === null || p.return === null) {
          wr = 1, sf = s, tr = null;
          break;
        }
        e: {
          var C = i, D = p.return, U = p, Z = s;
          if (s = jr, U.flags |= 32768, Z !== null && typeof Z == "object" && typeof Z.then == "function") {
            var ue = Z, _e = U, Oe = _e.tag;
            if (!(_e.mode & 1) && (Oe === 0 || Oe === 11 || Oe === 15)) {
              var Te = _e.alternate;
              Te ? (_e.updateQueue = Te.updateQueue, _e.memoizedState = Te.memoizedState, _e.lanes = Te.lanes) : (_e.updateQueue = null, _e.memoizedState = null);
            }
            var Ue = by(D);
            if (Ue !== null) {
              Ue.flags &= -257, wy(Ue, D, U, C, s), Ue.mode & 1 && fb(C, ue, s), s = Ue, Z = ue;
              var Je = s.updateQueue;
              if (Je === null) {
                var nt = /* @__PURE__ */ new Set();
                nt.add(Z), s.updateQueue = nt;
              } else
                Je.add(Z);
              break e;
            } else {
              if (!(s & 1)) {
                fb(C, ue, s), $y();
                break e;
              }
              Z = Error(r(426));
            }
          } else if (In && U.mode & 1) {
            var sr = by(D);
            if (sr !== null) {
              !(sr.flags & 65536) && (sr.flags |= 256), wy(sr, D, U, C, s), uy(gc(Z, U));
              break e;
            }
          }
          C = Z = gc(Z, U), wr !== 4 && (wr = 2), il === null ? il = [C] : il.push(C), C = D;
          do {
            switch (C.tag) {
              case 3:
                C.flags |= 65536, s &= -s, C.lanes |= s;
                var J = db(C, Z, s);
                py(C, J);
                break e;
              case 1:
                U = Z;
                var Q = C.type, ne = C.stateNode;
                if (!(C.flags & 128) && (typeof Q.getDerivedStateFromError == "function" || ne !== null && typeof ne.componentDidCatch == "function" && (xo === null || !xo.has(ne)))) {
                  C.flags |= 65536, s &= -s, C.lanes |= s;
                  var Ie = Xd(C, U, s);
                  py(C, Ie);
                  break e;
                }
            }
            C = C.return;
          } while (C !== null);
        }
        Ly(p);
      } catch (rt) {
        s = rt, tr === p && p !== null && (tr = p = p.return);
        continue;
      }
      break;
    } while (1);
  }
  function rh() {
    var i = of.current;
    return of.current = qp, i === null ? qp : i;
  }
  function $y() {
    (wr === 0 || wr === 3 || wr === 2) && (wr = 4), Kn === null || !(as & 268435455) && !(Jp & 268435455) || _i(Kn, jr);
  }
  function ah(i, s) {
    var p = Gt;
    Gt |= 2;
    var y = rh();
    (Kn !== i || jr !== s) && (is = null, ll(i, s));
    do
      try {
        n2();
        break;
      } catch (S) {
        Eb(i, S);
      }
    while (1);
    if (cy(), Gt = p, of.current = y, tr !== null)
      throw Error(r(261));
    return Kn = null, jr = 0, wr;
  }
  function n2() {
    for (; tr !== null; )
      Cb(tr);
  }
  function r2() {
    for (; tr !== null && !co(); )
      Cb(tr);
  }
  function Cb(i) {
    var s = _b(i.alternate, i, ni);
    i.memoizedProps = i.pendingProps, s === null ? Ly(i) : tr = s, jy.current = null;
  }
  function Ly(i) {
    var s = i;
    do {
      var p = s.alternate;
      if (i = s.return, s.flags & 32768) {
        if (p = _y(p, s), p !== null) {
          p.flags &= 32767, tr = p;
          return;
        }
        if (i !== null)
          i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
        else {
          wr = 6, tr = null;
          return;
        }
      } else if (p = t2(p, s, ni), p !== null) {
        tr = p;
        return;
      }
      if (s = s.sibling, s !== null) {
        tr = s;
        return;
      }
      tr = s = i;
    } while (s !== null);
    wr === 0 && (wr = 5);
  }
  function cl(i, s, p) {
    var y = rn, S = ea.transition;
    try {
      ea.transition = null, rn = 1, a2(i, s, p, y);
    } finally {
      ea.transition = S, rn = y;
    }
    return null;
  }
  function a2(i, s, p, y) {
    do
      jc();
    while (uu !== null);
    if (Gt & 6)
      throw Error(r(327));
    p = i.finishedWork;
    var S = i.finishedLanes;
    if (p === null)
      return null;
    if (i.finishedWork = null, i.finishedLanes = 0, p === i.current)
      throw Error(r(177));
    i.callbackNode = null, i.callbackPriority = 0;
    var C = p.lanes | p.childLanes;
    if (Dm(i, C), i === Kn && (tr = Kn = null, jr = 0), !(p.subtreeFlags & 2064) && !(p.flags & 2064) || su || (su = !0, Ny(fo, function() {
      return jc(), null;
    })), C = (p.flags & 15990) !== 0, p.subtreeFlags & 15990 || C) {
      C = ea.transition, ea.transition = null;
      var D = rn;
      rn = 1;
      var U = Gt;
      Gt |= 4, jy.current = null, vb(i, p), bb(p, i), fp(Hu), yi = !!Xm, Hu = Xm = null, i.current = p, wb(p), ql(), Gt = U, rn = D, ea.transition = C;
    } else
      i.current = p;
    if (su && (su = !1, uu = i, th = S), C = i.pendingLanes, C === 0 && (xo = null), Cd(p.stateNode), ra(i, Jt()), s !== null)
      for (y = i.onRecoverableError, p = 0; p < s.length; p++)
        S = s[p], y(S.value, { componentStack: S.stack, digest: S.digest });
    if (eh)
      throw eh = !1, i = ol, ol = null, i;
    return th & 1 && i.tag !== 0 && jc(), C = i.pendingLanes, C & 1 ? i === nh ? Rc++ : (Rc = 0, nh = i) : Rc = 0, Aa(), null;
  }
  function jc() {
    if (uu !== null) {
      var i = Ql(th), s = ea.transition, p = rn;
      try {
        if (ea.transition = null, rn = 16 > i ? 16 : i, uu === null)
          var y = !1;
        else {
          if (i = uu, uu = null, th = 0, Gt & 6)
            throw Error(r(331));
          var S = Gt;
          for (Gt |= 4, Ze = i.current; Ze !== null; ) {
            var C = Ze, D = C.child;
            if (Ze.flags & 16) {
              var U = C.deletions;
              if (U !== null) {
                for (var Z = 0; Z < U.length; Z++) {
                  var ue = U[Z];
                  for (Ze = ue; Ze !== null; ) {
                    var _e = Ze;
                    switch (_e.tag) {
                      case 0:
                      case 11:
                      case 15:
                        rf(8, _e, C);
                    }
                    var Oe = _e.child;
                    if (Oe !== null)
                      Oe.return = _e, Ze = Oe;
                    else
                      for (; Ze !== null; ) {
                        _e = Ze;
                        var Te = _e.sibling, Ue = _e.return;
                        if (Oy(_e), _e === ue) {
                          Ze = null;
                          break;
                        }
                        if (Te !== null) {
                          Te.return = Ue, Ze = Te;
                          break;
                        }
                        Ze = Ue;
                      }
                  }
                }
                var Je = C.alternate;
                if (Je !== null) {
                  var nt = Je.child;
                  if (nt !== null) {
                    Je.child = null;
                    do {
                      var sr = nt.sibling;
                      nt.sibling = null, nt = sr;
                    } while (nt !== null);
                  }
                }
                Ze = C;
              }
            }
            if (C.subtreeFlags & 2064 && D !== null)
              D.return = C, Ze = D;
            else
              e:
                for (; Ze !== null; ) {
                  if (C = Ze, C.flags & 2048)
                    switch (C.tag) {
                      case 0:
                      case 11:
                      case 15:
                        rf(9, C, C.return);
                    }
                  var J = C.sibling;
                  if (J !== null) {
                    J.return = C.return, Ze = J;
                    break e;
                  }
                  Ze = C.return;
                }
          }
          var Q = i.current;
          for (Ze = Q; Ze !== null; ) {
            D = Ze;
            var ne = D.child;
            if (D.subtreeFlags & 2064 && ne !== null)
              ne.return = D, Ze = ne;
            else
              e:
                for (D = Q; Ze !== null; ) {
                  if (U = Ze, U.flags & 2048)
                    try {
                      switch (U.tag) {
                        case 0:
                        case 11:
                        case 15:
                          af(9, U);
                      }
                    } catch (rt) {
                      nr(U, U.return, rt);
                    }
                  if (U === D) {
                    Ze = null;
                    break e;
                  }
                  var Ie = U.sibling;
                  if (Ie !== null) {
                    Ie.return = U.return, Ze = Ie;
                    break e;
                  }
                  Ze = U.return;
                }
          }
          if (Gt = S, Aa(), _a && typeof _a.onPostCommitFiberRoot == "function")
            try {
              _a.onPostCommitFiberRoot(Ms, i);
            } catch {
            }
          y = !0;
        }
        return y;
      } finally {
        rn = p, ea.transition = s;
      }
    }
    return !1;
  }
  function Tb(i, s, p) {
    s = gc(p, s), s = db(i, s, 1), i = tu(i, s, 1), s = ta(), i !== null && (Ho(i, 1, s), ra(i, s));
  }
  function nr(i, s, p) {
    if (i.tag === 3)
      Tb(i, i, p);
    else
      for (; s !== null; ) {
        if (s.tag === 3) {
          Tb(s, i, p);
          break;
        } else if (s.tag === 1) {
          var y = s.stateNode;
          if (typeof s.type.getDerivedStateFromError == "function" || typeof y.componentDidCatch == "function" && (xo === null || !xo.has(y))) {
            i = gc(p, i), i = Xd(s, i, 1), s = tu(s, i, 1), i = ta(), s !== null && (Ho(s, 1, i), ra(s, i));
            break;
          }
        }
        s = s.return;
      }
  }
  function i2(i, s, p) {
    var y = i.pingCache;
    y !== null && y.delete(s), s = ta(), i.pingedLanes |= i.suspendedLanes & p, Kn === i && (jr & p) === p && (wr === 4 || wr === 3 && (jr & 130023424) === jr && 500 > Jt() - Ay ? ll(i, 0) : Tc |= p), ra(i, s);
  }
  function ih(i, s) {
    s === 0 && (i.mode & 1 ? (s = $s, $s <<= 1, !($s & 130023424) && ($s = 4194304)) : s = 1);
    var p = ta();
    i = Jo(i, s), i !== null && (Ho(i, s, p), ra(i, p));
  }
  function o2(i) {
    var s = i.memoizedState, p = 0;
    s !== null && (p = s.retryLane), ih(i, p);
  }
  function s2(i, s) {
    var p = 0;
    switch (i.tag) {
      case 13:
        var y = i.stateNode, S = i.memoizedState;
        S !== null && (p = S.retryLane);
        break;
      case 19:
        y = i.stateNode;
        break;
      default:
        throw Error(r(314));
    }
    y !== null && y.delete(s), ih(i, p);
  }
  var _b;
  _b = function(i, s, p) {
    if (i !== null)
      if (i.memoizedProps !== s.pendingProps || er.current)
        pr = !0;
      else {
        if (!(i.lanes & p) && !(s.flags & 128))
          return pr = !1, ns(i, s, p);
        pr = !!(i.flags & 131072);
      }
    else
      pr = !1, In && s.flags & 1048576 && iy(s, dc, s.index);
    switch (s.lanes = 0, s.tag) {
      case 2:
        var y = s.type;
        Xr(i, s), i = s.pendingProps;
        var S = bi(s, Et.current);
        Le(s, p), S = au(null, s, y, i, S, p);
        var C = Xu();
        return s.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (s.tag = 1, s.memoizedState = null, s.updateQueue = null, Fn(y) ? (C = !0, gp(s)) : C = !1, s.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, fy(s), S.updater = Tp, s.stateNode = S, S._reactInternals = s, _p(s, y, i, p), s = pb(null, s, y, !0, C, p)) : (s.tag = 0, In && C && bp(s), vr(null, s, S, p), s = s.child), s;
      case 16:
        y = s.elementType;
        e: {
          switch (Xr(i, s), i = s.pendingProps, S = y._init, y = S(y._payload), s.type = y, S = s.tag = l2(y), i = ei(y, i), S) {
            case 0:
              s = bc(null, s, y, i, p);
              break e;
            case 1:
              s = xy(null, s, y, i, p);
              break e;
            case 11:
              s = ou(null, s, y, i, p);
              break e;
            case 14:
              s = Yp(null, s, y, ei(y.type, i), p);
              break e;
          }
          throw Error(r(
            306,
            y,
            ""
          ));
        }
        return s;
      case 0:
        return y = s.type, S = s.pendingProps, S = s.elementType === y ? S : ei(y, S), bc(i, s, y, S, p);
      case 1:
        return y = s.type, S = s.pendingProps, S = s.elementType === y ? S : ei(y, S), xy(i, s, y, S, p);
      case 3:
        e: {
          if (hb(s), i === null)
            throw Error(r(387));
          y = s.pendingProps, C = s.memoizedState, S = C.element, yr(i, s), nu(s, y, null, p);
          var D = s.memoizedState;
          if (y = D.element, C.isDehydrated)
            if (C = { element: y, isDehydrated: !1, cache: D.cache, pendingSuspenseBoundaries: D.pendingSuspenseBoundaries, transitions: D.transitions }, s.updateQueue.baseState = C, s.memoizedState = C, s.flags & 256) {
              S = gc(Error(r(423)), s), s = Zp(i, s, y, p, S);
              break e;
            } else if (y !== S) {
              S = gc(Error(r(424)), s), s = Zp(i, s, y, p, S);
              break e;
            } else
              for (Ma = Yi(s.stateNode.containerInfo.firstChild), Ja = s, In = !0, Si = null, p = lb(s, null, y, p), s.child = p; p; )
                p.flags = p.flags & -3 | 4096, p = p.sibling;
          else {
            if (Yn(), y === S) {
              s = Nr(i, s, p);
              break e;
            }
            vr(i, s, y, p);
          }
          s = s.child;
        }
        return s;
      case 5:
        return mt(s), i === null && xp(s), y = s.type, S = s.pendingProps, C = i !== null ? i.memoizedProps : null, D = S.children, zd(y, S) ? D = null : C !== null && zd(y, C) && (s.flags |= 32), Mt(i, s), vr(i, s, D, p), s.child;
      case 6:
        return i === null && xp(s), null;
      case 13:
        return ky(i, s, p);
      case 4:
        return my(s, s.stateNode.containerInfo), y = s.pendingProps, i === null ? s.child = pc(s, null, y, p) : vr(i, s, y, p), s.child;
      case 11:
        return y = s.type, S = s.pendingProps, S = s.elementType === y ? S : ei(y, S), ou(i, s, y, S, p);
      case 7:
        return vr(i, s, s.pendingProps, p), s.child;
      case 8:
        return vr(i, s, s.pendingProps.children, p), s.child;
      case 12:
        return vr(i, s, s.pendingProps.children, p), s.child;
      case 10:
        e: {
          if (y = s.type._context, S = s.pendingProps, C = s.memoizedProps, D = S.value, hn(vo, y._currentValue), y._currentValue = D, C !== null)
            if (vi(C.value, D)) {
              if (C.children === S.children && !er.current) {
                s = Nr(i, s, p);
                break e;
              }
            } else
              for (C = s.child, C !== null && (C.return = s); C !== null; ) {
                var U = C.dependencies;
                if (U !== null) {
                  D = C.child;
                  for (var Z = U.firstContext; Z !== null; ) {
                    if (Z.context === y) {
                      if (C.tag === 1) {
                        Z = es(-1, p & -p), Z.tag = 2;
                        var ue = C.updateQueue;
                        if (ue !== null) {
                          ue = ue.shared;
                          var _e = ue.pending;
                          _e === null ? Z.next = Z : (Z.next = _e.next, _e.next = Z), ue.pending = Z;
                        }
                      }
                      C.lanes |= p, Z = C.alternate, Z !== null && (Z.lanes |= p), Or(
                        C.return,
                        p,
                        s
                      ), U.lanes |= p;
                      break;
                    }
                    Z = Z.next;
                  }
                } else if (C.tag === 10)
                  D = C.type === s.type ? null : C.child;
                else if (C.tag === 18) {
                  if (D = C.return, D === null)
                    throw Error(r(341));
                  D.lanes |= p, U = D.alternate, U !== null && (U.lanes |= p), Or(D, p, s), D = C.sibling;
                } else
                  D = C.child;
                if (D !== null)
                  D.return = C;
                else
                  for (D = C; D !== null; ) {
                    if (D === s) {
                      D = null;
                      break;
                    }
                    if (C = D.sibling, C !== null) {
                      C.return = D.return, D = C;
                      break;
                    }
                    D = D.return;
                  }
                C = D;
              }
          vr(i, s, S.children, p), s = s.child;
        }
        return s;
      case 9:
        return S = s.type, y = s.pendingProps.children, Le(s, p), S = or(S), y = y(S), s.flags |= 1, vr(i, s, y, p), s.child;
      case 14:
        return y = s.type, S = ei(y, s.pendingProps), S = ei(y.type, S), Yp(i, s, y, S, p);
      case 15:
        return Na(i, s, s.type, s.pendingProps, p);
      case 17:
        return y = s.type, S = s.pendingProps, S = s.elementType === y ? S : ei(y, S), Xr(i, s), s.tag = 1, Fn(y) ? (i = !0, gp(s)) : i = !1, Le(s, p), ib(s, y, S), _p(s, y, S, p), pb(null, s, y, !0, i, p);
      case 19:
        return Ty(i, s, p);
      case 22:
        return nl(i, s, p);
    }
    throw Error(r(156, s.tag));
  };
  function Ny(i, s) {
    return Pn(i, s);
  }
  function u2(i, s, p, y) {
    this.tag = i, this.key = p, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = s, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = y, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ri(i, s, p, y) {
    return new u2(i, s, p, y);
  }
  function Fy(i) {
    return i = i.prototype, !(!i || !i.isReactComponent);
  }
  function l2(i) {
    if (typeof i == "function")
      return Fy(i) ? 1 : 0;
    if (i != null) {
      if (i = i.$$typeof, i === De)
        return 11;
      if (i === se)
        return 14;
    }
    return 2;
  }
  function cu(i, s) {
    var p = i.alternate;
    return p === null ? (p = Ri(i.tag, s, i.key, i.mode), p.elementType = i.elementType, p.type = i.type, p.stateNode = i.stateNode, p.alternate = i, i.alternate = p) : (p.pendingProps = s, p.type = i.type, p.flags = 0, p.subtreeFlags = 0, p.deletions = null), p.flags = i.flags & 14680064, p.childLanes = i.childLanes, p.lanes = i.lanes, p.child = i.child, p.memoizedProps = i.memoizedProps, p.memoizedState = i.memoizedState, p.updateQueue = i.updateQueue, s = i.dependencies, p.dependencies = s === null ? null : { lanes: s.lanes, firstContext: s.firstContext }, p.sibling = i.sibling, p.index = i.index, p.ref = i.ref, p;
  }
  function oh(i, s, p, y, S, C) {
    var D = 2;
    if (y = i, typeof i == "function")
      Fy(i) && (D = 1);
    else if (typeof i == "string")
      D = 5;
    else
      e:
        switch (i) {
          case W:
            return dl(p.children, S, C, s);
          case Y:
            D = 8, S |= 8;
            break;
          case ce:
            return i = Ri(12, p, s, S | 2), i.elementType = ce, i.lanes = C, i;
          case Re:
            return i = Ri(13, p, s, S), i.elementType = Re, i.lanes = C, i;
          case Pe:
            return i = Ri(19, p, s, S), i.elementType = Pe, i.lanes = C, i;
          case de:
            return lf(p, S, C, s);
          default:
            if (typeof i == "object" && i !== null)
              switch (i.$$typeof) {
                case ve:
                  D = 10;
                  break e;
                case Se:
                  D = 9;
                  break e;
                case De:
                  D = 11;
                  break e;
                case se:
                  D = 14;
                  break e;
                case ge:
                  D = 16, y = null;
                  break e;
              }
            throw Error(r(130, i == null ? i : typeof i, ""));
        }
    return s = Ri(D, p, s, S), s.elementType = i, s.type = y, s.lanes = C, s;
  }
  function dl(i, s, p, y) {
    return i = Ri(7, i, y, s), i.lanes = p, i;
  }
  function lf(i, s, p, y) {
    return i = Ri(22, i, y, s), i.elementType = de, i.lanes = p, i.stateNode = { isHidden: !1 }, i;
  }
  function cf(i, s, p) {
    return i = Ri(6, i, null, s), i.lanes = p, i;
  }
  function fl(i, s, p) {
    return s = Ri(4, i.children !== null ? i.children : [], i.key, s), s.lanes = p, s.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, s;
  }
  function c2(i, s, p, y, S) {
    this.tag = s, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Kl(0), this.expirationTimes = Kl(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kl(0), this.identifierPrefix = y, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function sh(i, s, p, y, S, C, D, U, Z) {
    return i = new c2(i, s, p, U, Z), s === 1 ? (s = 1, C === !0 && (s |= 8)) : s = 0, C = Ri(3, null, null, s), i.current = C, C.stateNode = i, C.memoizedState = { element: y, isDehydrated: p, cache: null, transitions: null, pendingSuspenseBoundaries: null }, fy(C), i;
  }
  function Rb(i, s, p) {
    var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: V, key: y == null ? null : "" + y, children: i, containerInfo: s, implementation: p };
  }
  function zy(i) {
    if (!i)
      return yo;
    i = i._reactInternals;
    e: {
      if (At(i) !== i || i.tag !== 1)
        throw Error(r(170));
      var s = i;
      do {
        switch (s.tag) {
          case 3:
            s = s.stateNode.context;
            break e;
          case 1:
            if (Fn(s.type)) {
              s = s.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        s = s.return;
      } while (s !== null);
      throw Error(r(171));
    }
    if (i.tag === 1) {
      var p = i.type;
      if (Fn(p))
        return Hd(i, p, s);
    }
    return s;
  }
  function Ob(i, s, p, y, S, C, D, U, Z) {
    return i = sh(p, y, !0, i, S, C, D, U, Z), i.context = zy(null), p = i.current, y = ta(), S = hr(p), C = es(y, S), C.callback = s ?? null, tu(p, C, S), i.current.lanes = S, Ho(i, S, y), ra(i, y), i;
  }
  function df(i, s, p, y) {
    var S = s.current, C = ta(), D = hr(S);
    return p = zy(p), s.context === null ? s.context = p : s.pendingContext = p, s = es(C, D), s.payload = { element: i }, y = y === void 0 ? null : y, y !== null && (s.callback = y), i = tu(S, s, D), i !== null && (na(i, S, D, C), Cp(i, S, D)), D;
  }
  function uh(i) {
    if (i = i.current, !i.child)
      return null;
    switch (i.child.tag) {
      case 5:
        return i.child.stateNode;
      default:
        return i.child.stateNode;
    }
  }
  function Pb(i, s) {
    if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
      var p = i.retryLane;
      i.retryLane = p !== 0 && p < s ? p : s;
    }
  }
  function By(i, s) {
    Pb(i, s), (i = i.alternate) && Pb(i, s);
  }
  function jb() {
    return null;
  }
  var Uy = typeof reportError == "function" ? reportError : function(i) {
    console.error(i);
  };
  function lh(i) {
    this._internalRoot = i;
  }
  os.prototype.render = lh.prototype.render = function(i) {
    var s = this._internalRoot;
    if (s === null)
      throw Error(r(409));
    df(i, s, null, null);
  }, os.prototype.unmount = lh.prototype.unmount = function() {
    var i = this._internalRoot;
    if (i !== null) {
      this._internalRoot = null;
      var s = i.containerInfo;
      lu(function() {
        df(null, i, null, null);
      }), s[Qo] = null;
    }
  };
  function os(i) {
    this._internalRoot = i;
  }
  os.prototype.unstable_scheduleHydration = function(i) {
    if (i) {
      var s = Jl();
      i = { blockedOn: null, target: i, priority: s };
      for (var p = 0; p < pn.length && s !== 0 && s < pn[p].priority; p++)
        ;
      pn.splice(p, 0, i), p === 0 && ip(i);
    }
  };
  function Hy(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11);
  }
  function ch(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11 && (i.nodeType !== 8 || i.nodeValue !== " react-mount-point-unstable "));
  }
  function Ab() {
  }
  function d2(i, s, p, y, S) {
    if (S) {
      if (typeof y == "function") {
        var C = y;
        y = function() {
          var ue = uh(D);
          C.call(ue);
        };
      }
      var D = Ob(s, y, i, 0, null, !1, !1, "", Ab);
      return i._reactRootContainer = D, i[Qo] = D.current, lc(i.nodeType === 8 ? i.parentNode : i), lu(), D;
    }
    for (; S = i.lastChild; )
      i.removeChild(S);
    if (typeof y == "function") {
      var U = y;
      y = function() {
        var ue = uh(Z);
        U.call(ue);
      };
    }
    var Z = sh(i, 0, !1, null, null, !1, !1, "", Ab);
    return i._reactRootContainer = Z, i[Qo] = Z.current, lc(i.nodeType === 8 ? i.parentNode : i), lu(function() {
      df(s, Z, p, y);
    }), Z;
  }
  function dh(i, s, p, y, S) {
    var C = p._reactRootContainer;
    if (C) {
      var D = C;
      if (typeof S == "function") {
        var U = S;
        S = function() {
          var Z = uh(D);
          U.call(Z);
        };
      }
      df(s, D, i, S);
    } else
      D = d2(p, s, i, S, y);
    return uh(D);
  }
  $u = function(i) {
    switch (i.tag) {
      case 3:
        var s = i.stateNode;
        if (s.current.memoizedState.isDehydrated) {
          var p = Hi(s.pendingLanes);
          p !== 0 && (po(s, p | 1), ra(s, Jt()), !(Gt & 6) && (_c = Jt() + 500, Aa()));
        }
        break;
      case 13:
        lu(function() {
          var y = Jo(i, 1);
          if (y !== null) {
            var S = ta();
            na(y, i, 1, S);
          }
        }), By(i, 1);
    }
  }, Xl = function(i) {
    if (i.tag === 13) {
      var s = Jo(i, 134217728);
      if (s !== null) {
        var p = ta();
        na(s, i, 134217728, p);
      }
      By(i, 134217728);
    }
  }, en = function(i) {
    if (i.tag === 13) {
      var s = hr(i), p = Jo(i, s);
      if (p !== null) {
        var y = ta();
        na(p, i, s, y);
      }
      By(i, s);
    }
  }, Jl = function() {
    return rn;
  }, ec = function(i, s) {
    var p = rn;
    try {
      return rn = i, s();
    } finally {
      rn = p;
    }
  }, ca = function(i, s, p) {
    switch (s) {
      case "input":
        if (Vn(i, p), s = p.name, p.type === "radio" && s != null) {
          for (p = i; p.parentNode; )
            p = p.parentNode;
          for (p = p.querySelectorAll("input[name=" + JSON.stringify("" + s) + '][type="radio"]'), s = 0; s < p.length; s++) {
            var y = p[s];
            if (y !== i && y.form === i.form) {
              var S = lt(y);
              if (!S)
                throw Error(r(90));
              Hn(y), Vn(y, S);
            }
          }
        }
        break;
      case "textarea":
        qa(i, p);
        break;
      case "select":
        s = p.value, s != null && ar(i, !!p.multiple, s, !1);
    }
  }, Mu = Pc, Gl = lu;
  var f2 = { usingClientEntryPoint: !1, Events: [Ud, cc, lt, hi, As, Pc] }, Ac = { findFiberByHostInstance: gi, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, p2 = { bundleType: Ac.bundleType, version: Ac.version, rendererPackageName: Ac.rendererPackageName, rendererConfig: Ac.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: B.ReactCurrentDispatcher, findHostInstanceByFiber: function(i) {
    return i = dr(i), i === null ? null : i.stateNode;
  }, findFiberByHostInstance: Ac.findFiberByHostInstance || jb, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var fh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!fh.isDisabled && fh.supportsFiber)
      try {
        Ms = fh.inject(p2), _a = fh;
      } catch {
      }
  }
  return Ii.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = f2, Ii.createPortal = function(i, s) {
    var p = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Hy(s))
      throw Error(r(200));
    return Rb(i, s, null, p);
  }, Ii.createRoot = function(i, s) {
    if (!Hy(i))
      throw Error(r(299));
    var p = !1, y = "", S = Uy;
    return s != null && (s.unstable_strictMode === !0 && (p = !0), s.identifierPrefix !== void 0 && (y = s.identifierPrefix), s.onRecoverableError !== void 0 && (S = s.onRecoverableError)), s = sh(i, 1, !1, null, null, p, !1, y, S), i[Qo] = s.current, lc(i.nodeType === 8 ? i.parentNode : i), new lh(s);
  }, Ii.findDOMNode = function(i) {
    if (i == null)
      return null;
    if (i.nodeType === 1)
      return i;
    var s = i._reactInternals;
    if (s === void 0)
      throw typeof i.render == "function" ? Error(r(188)) : (i = Object.keys(i).join(","), Error(r(268, i)));
    return i = dr(s), i = i === null ? null : i.stateNode, i;
  }, Ii.flushSync = function(i) {
    return lu(i);
  }, Ii.hydrate = function(i, s, p) {
    if (!ch(s))
      throw Error(r(200));
    return dh(null, i, s, !0, p);
  }, Ii.hydrateRoot = function(i, s, p) {
    if (!Hy(i))
      throw Error(r(405));
    var y = p != null && p.hydratedSources || null, S = !1, C = "", D = Uy;
    if (p != null && (p.unstable_strictMode === !0 && (S = !0), p.identifierPrefix !== void 0 && (C = p.identifierPrefix), p.onRecoverableError !== void 0 && (D = p.onRecoverableError)), s = Ob(s, null, i, 1, p ?? null, S, !1, C, D), i[Qo] = s.current, lc(i), y)
      for (i = 0; i < y.length; i++)
        p = y[i], S = p._getVersion, S = S(p._source), s.mutableSourceEagerHydrationData == null ? s.mutableSourceEagerHydrationData = [p, S] : s.mutableSourceEagerHydrationData.push(
          p,
          S
        );
    return new os(s);
  }, Ii.render = function(i, s, p) {
    if (!ch(s))
      throw Error(r(200));
    return dh(null, i, s, !1, p);
  }, Ii.unmountComponentAtNode = function(i) {
    if (!ch(i))
      throw Error(r(40));
    return i._reactRootContainer ? (lu(function() {
      dh(null, null, i, !1, function() {
        i._reactRootContainer = null, i[Qo] = null;
      });
    }), !0) : !1;
  }, Ii.unstable_batchedUpdates = Pc, Ii.unstable_renderSubtreeIntoContainer = function(i, s, p, y) {
    if (!ch(p))
      throw Error(r(200));
    if (i == null || i._reactInternals === void 0)
      throw Error(r(38));
    return dh(i, s, p, !1, y);
  }, Ii.version = "18.2.0-next-9e3b772b8-20220608", Ii;
}
var Mi = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var HO;
function NL() {
  return HO || (HO = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = $, t = Gj(), r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
    function l(n) {
      o = n;
    }
    function d(n) {
      if (!o) {
        for (var a = arguments.length, u = new Array(a > 1 ? a - 1 : 0), c = 1; c < a; c++)
          u[c - 1] = arguments[c];
        m("warn", n, u);
      }
    }
    function f(n) {
      if (!o) {
        for (var a = arguments.length, u = new Array(a > 1 ? a - 1 : 0), c = 1; c < a; c++)
          u[c - 1] = arguments[c];
        m("error", n, u);
      }
    }
    function m(n, a, u) {
      {
        var c = r.ReactDebugCurrentFrame, h = c.getStackAddendum();
        h !== "" && (a += "%s", u = u.concat([h]));
        var g = u.map(function(E) {
          return String(E);
        });
        g.unshift("Warning: " + a), Function.prototype.apply.call(console[n], console, g);
      }
    }
    var v = 0, w = 1, x = 2, b = 3, k = 4, T = 5, O = 6, R = 7, j = 8, I = 9, N = 10, L = 11, B = 12, H = 13, V = 14, W = 15, Y = 16, ce = 17, ve = 18, Se = 19, De = 21, Re = 22, Pe = 23, se = 24, ge = 25, de = !0, pe = !1, fe = !1, z = !1, oe = !1, ke = !0, Qe = !1, Xe = !1, bt = !0, at = !0, ut = !0, wt = /* @__PURE__ */ new Set(), pt = {}, Rn = {};
    function rr(n, a) {
      Hn(n, a), Hn(n + "Capture", a);
    }
    function Hn(n, a) {
      pt[n] && f("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", n), pt[n] = a;
      {
        var u = n.toLowerCase();
        Rn[u] = n, n === "onDoubleClick" && (Rn.ondblclick = n);
      }
      for (var c = 0; c < a.length; c++)
        wt.add(a[c]);
    }
    var Vt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", xn = Object.prototype.hasOwnProperty;
    function gn(n) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, u = a && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function An(n) {
      try {
        return Vn(n), !1;
      } catch {
        return !0;
      }
    }
    function Vn(n) {
      return "" + n;
    }
    function Wr(n, a) {
      if (An(n))
        return f("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", a, gn(n)), Vn(n);
    }
    function Yr(n) {
      if (An(n))
        return f("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gn(n)), Vn(n);
    }
    function cr(n, a) {
      if (An(n))
        return f("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, gn(n)), Vn(n);
    }
    function ar(n, a) {
      if (An(n))
        return f("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", a, gn(n)), Vn(n);
    }
    function Ca(n) {
      if (An(n))
        return f("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", gn(n)), Vn(n);
    }
    function Zr(n) {
      if (An(n))
        return f("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", gn(n)), Vn(n);
    }
    var qa = 0, Ir = 1, Ta = 2, Gn = 3, la = 4, oo = 5, Wa = 6, Me = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ot = Me + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", $t = new RegExp("^[" + Me + "][" + ot + "]*$"), un = {}, cn = {};
    function ir(n) {
      return xn.call(cn, n) ? !0 : xn.call(un, n) ? !1 : $t.test(n) ? (cn[n] = !0, !0) : (un[n] = !0, f("Invalid attribute name: `%s`", n), !1);
    }
    function qn(n, a, u) {
      return a !== null ? a.type === qa : u ? !1 : n.length > 2 && (n[0] === "o" || n[0] === "O") && (n[1] === "n" || n[1] === "N");
    }
    function Kr(n, a, u, c) {
      if (u !== null && u.type === qa)
        return !1;
      switch (typeof a) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (c)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var h = n.toLowerCase().slice(0, 5);
          return h !== "data-" && h !== "aria-";
        }
        default:
          return !1;
      }
    }
    function yn(n, a, u, c) {
      if (a === null || typeof a > "u" || Kr(n, a, u, c))
        return !0;
      if (c)
        return !1;
      if (u !== null)
        switch (u.type) {
          case Gn:
            return !a;
          case la:
            return a === !1;
          case oo:
            return isNaN(a);
          case Wa:
            return isNaN(a) || a < 1;
        }
      return !1;
    }
    function ca(n) {
      return fn.hasOwnProperty(n) ? fn[n] : null;
    }
    function dn(n, a, u, c, h, g, E) {
      this.acceptsBooleans = a === Ta || a === Gn || a === la, this.attributeName = c, this.attributeNamespace = h, this.mustUseProperty = u, this.propertyName = n, this.type = a, this.sanitizeURL = g, this.removeEmptyString = E;
    }
    var fn = {}, Bi = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Bi.forEach(function(n) {
      fn[n] = new dn(
        n,
        qa,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
      var a = n[0], u = n[1];
      fn[a] = new dn(
        a,
        Ir,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
      fn[n] = new dn(
        n,
        Ta,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
      fn[n] = new dn(
        n,
        Ta,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(n) {
      fn[n] = new dn(
        n,
        Gn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      fn[n] = new dn(
        n,
        Gn,
        !0,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      fn[n] = new dn(
        n,
        la,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      fn[n] = new dn(
        n,
        Wa,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(n) {
      fn[n] = new dn(
        n,
        oo,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var hi = /[\-\:]([a-z])/g, As = function(n) {
      return n[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var a = n.replace(hi, As);
      fn[a] = new dn(
        a,
        Ir,
        !1,
        // mustUseProperty
        n,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var a = n.replace(hi, As);
      fn[a] = new dn(
        a,
        Ir,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var a = n.replace(hi, As);
      fn[a] = new dn(
        a,
        Ir,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(n) {
      fn[n] = new dn(
        n,
        Ir,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Mu = "xlinkHref";
    fn[Mu] = new dn(
      "xlinkHref",
      Ir,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(n) {
      fn[n] = new dn(
        n,
        Ir,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Gl = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Uo = !1;
    function Ds(n) {
      !Uo && Gl.test(n) && (Uo = !0, f("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    function Ya(n, a, u, c) {
      if (c.mustUseProperty) {
        var h = c.propertyName;
        return n[h];
      } else {
        Wr(u, a), c.sanitizeURL && Ds("" + u);
        var g = c.attributeName, E = null;
        if (c.type === la) {
          if (n.hasAttribute(g)) {
            var _ = n.getAttribute(g);
            return _ === "" ? !0 : yn(a, u, c, !1) ? _ : _ === "" + u ? u : _;
          }
        } else if (n.hasAttribute(g)) {
          if (yn(a, u, c, !1))
            return n.getAttribute(g);
          if (c.type === Gn)
            return u;
          E = n.getAttribute(g);
        }
        return yn(a, u, c, !1) ? E === null ? u : E : E === "" + u ? u : E;
      }
    }
    function so(n, a, u, c) {
      {
        if (!ir(a))
          return;
        if (!n.hasAttribute(a))
          return u === void 0 ? void 0 : null;
        var h = n.getAttribute(a);
        return Wr(u, a), h === "" + u ? u : h;
      }
    }
    function Za(n, a, u, c) {
      var h = ca(a);
      if (!qn(a, h, c)) {
        if (yn(a, u, h, c) && (u = null), c || h === null) {
          if (ir(a)) {
            var g = a;
            u === null ? n.removeAttribute(g) : (Wr(u, a), n.setAttribute(g, "" + u));
          }
          return;
        }
        var E = h.mustUseProperty;
        if (E) {
          var _ = h.propertyName;
          if (u === null) {
            var P = h.type;
            n[_] = P === Gn ? !1 : "";
          } else
            n[_] = u;
          return;
        }
        var M = h.attributeName, F = h.attributeNamespace;
        if (u === null)
          n.removeAttribute(M);
        else {
          var X = h.type, K;
          X === Gn || X === la && u === !0 ? K = "" : (Wr(u, M), K = "" + u, h.sanitizeURL && Ds(K.toString())), F ? n.setAttributeNS(F, M, K) : n.setAttribute(M, K);
        }
      }
    }
    var uo = Symbol.for("react.element"), da = Symbol.for("react.portal"), Ka = Symbol.for("react.fragment"), lo = Symbol.for("react.strict_mode"), q = Symbol.for("react.profiler"), Ce = Symbol.for("react.provider"), $e = Symbol.for("react.context"), Ge = Symbol.for("react.forward_ref"), At = Symbol.for("react.suspense"), Yt = Symbol.for("react.suspense_list"), Dt = Symbol.for("react.memo"), dt = Symbol.for("react.lazy"), dr = Symbol.for("react.scope"), On = Symbol.for("react.debug_trace_mode"), Pn = Symbol.for("react.offscreen"), Mr = Symbol.for("react.legacy_hidden"), co = Symbol.for("react.cache"), ql = Symbol.for("react.tracing_marker"), Jt = Symbol.iterator, Am = "@@iterator";
    function Ui(n) {
      if (n === null || typeof n != "object")
        return null;
      var a = Jt && n[Jt] || n[Am];
      return typeof a == "function" ? a : null;
    }
    var Nt = Object.assign, fo = 0, Is, Wl, Ms, _a, Cd, fa, Td;
    function _d() {
    }
    _d.__reactDisabledLog = !0;
    function rp() {
      {
        if (fo === 0) {
          Is = console.log, Wl = console.info, Ms = console.warn, _a = console.error, Cd = console.group, fa = console.groupCollapsed, Td = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: _d,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        fo++;
      }
    }
    function Yl() {
      {
        if (fo--, fo === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Nt({}, n, {
              value: Is
            }),
            info: Nt({}, n, {
              value: Wl
            }),
            warn: Nt({}, n, {
              value: Ms
            }),
            error: Nt({}, n, {
              value: _a
            }),
            group: Nt({}, n, {
              value: Cd
            }),
            groupCollapsed: Nt({}, n, {
              value: fa
            }),
            groupEnd: Nt({}, n, {
              value: Td
            })
          });
        }
        fo < 0 && f("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $s = r.ReactCurrentDispatcher, Hi;
    function pa(n, a, u) {
      {
        if (Hi === void 0)
          try {
            throw Error();
          } catch (h) {
            var c = h.stack.trim().match(/\n( *(at )?)/);
            Hi = c && c[1] || "";
          }
        return `
` + Hi + n;
      }
    }
    var Ls = !1, Ns;
    {
      var Fs = typeof WeakMap == "function" ? WeakMap : Map;
      Ns = new Fs();
    }
    function Zl(n, a) {
      if (!n || Ls)
        return "";
      {
        var u = Ns.get(n);
        if (u !== void 0)
          return u;
      }
      var c;
      Ls = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var g;
      g = $s.current, $s.current = null, rp();
      try {
        if (a) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (ie) {
              c = ie;
            }
            Reflect.construct(n, [], E);
          } else {
            try {
              E.call();
            } catch (ie) {
              c = ie;
            }
            n.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            c = ie;
          }
          n();
        }
      } catch (ie) {
        if (ie && c && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), P = c.stack.split(`
`), M = _.length - 1, F = P.length - 1; M >= 1 && F >= 0 && _[M] !== P[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (_[M] !== P[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || _[M] !== P[F]) {
                    var X = `
` + _[M].replace(" at new ", " at ");
                    return n.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", n.displayName)), typeof n == "function" && Ns.set(n, X), X;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        Ls = !1, $s.current = g, Yl(), Error.prepareStackTrace = h;
      }
      var K = n ? n.displayName || n.name : "", re = K ? pa(K) : "";
      return typeof n == "function" && Ns.set(n, re), re;
    }
    function Kl(n, a, u) {
      return Zl(n, !0);
    }
    function Ho(n, a, u) {
      return Zl(n, !1);
    }
    function Dm(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function po(n, a, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Zl(n, Dm(n));
      if (typeof n == "string")
        return pa(n);
      switch (n) {
        case At:
          return pa("Suspense");
        case Yt:
          return pa("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case Ge:
            return Ho(n.render);
          case Dt:
            return po(n.type, a, u);
          case dt: {
            var c = n, h = c._payload, g = c._init;
            try {
              return po(g(h), a, u);
            } catch {
            }
          }
        }
      return "";
    }
    function rn(n) {
      switch (n._debugOwner && n._debugOwner.type, n._debugSource, n.tag) {
        case T:
          return pa(n.type);
        case Y:
          return pa("Lazy");
        case H:
          return pa("Suspense");
        case Se:
          return pa("SuspenseList");
        case v:
        case x:
        case W:
          return Ho(n.type);
        case L:
          return Ho(n.type.render);
        case w:
          return Kl(n.type);
        default:
          return "";
      }
    }
    function Ql(n) {
      try {
        var a = "", u = n;
        do
          a += rn(u), u = u.return;
        while (u);
        return a;
      } catch (c) {
        return `
Error generating stack: ` + c.message + `
` + c.stack;
      }
    }
    function $u(n, a, u) {
      var c = n.displayName;
      if (c)
        return c;
      var h = a.displayName || a.name || "";
      return h !== "" ? u + "(" + h + ")" : u;
    }
    function Xl(n) {
      return n.displayName || "Context";
    }
    function en(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && f("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case Ka:
          return "Fragment";
        case da:
          return "Portal";
        case q:
          return "Profiler";
        case lo:
          return "StrictMode";
        case At:
          return "Suspense";
        case Yt:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case $e:
            var a = n;
            return Xl(a) + ".Consumer";
          case Ce:
            var u = n;
            return Xl(u._context) + ".Provider";
          case Ge:
            return $u(n, n.render, "ForwardRef");
          case Dt:
            var c = n.displayName || null;
            return c !== null ? c : en(n.type) || "Memo";
          case dt: {
            var h = n, g = h._payload, E = h._init;
            try {
              return en(E(g));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Jl(n, a, u) {
      var c = a.displayName || a.name || "";
      return n.displayName || (c !== "" ? u + "(" + c + ")" : u);
    }
    function ec(n) {
      return n.displayName || "Context";
    }
    function _t(n) {
      var a = n.tag, u = n.type;
      switch (a) {
        case se:
          return "Cache";
        case I:
          var c = u;
          return ec(c) + ".Consumer";
        case N:
          var h = u;
          return ec(h._context) + ".Provider";
        case ve:
          return "DehydratedFragment";
        case L:
          return Jl(u, u.render, "ForwardRef");
        case R:
          return "Fragment";
        case T:
          return u;
        case k:
          return "Portal";
        case b:
          return "Root";
        case O:
          return "Text";
        case Y:
          return en(u);
        case j:
          return u === lo ? "StrictMode" : "Mode";
        case Re:
          return "Offscreen";
        case B:
          return "Profiler";
        case De:
          return "Scope";
        case H:
          return "Suspense";
        case Se:
          return "SuspenseList";
        case ge:
          return "TracingMarker";
        case w:
        case v:
        case ce:
        case x:
        case V:
        case W:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var Lu = r.ReactDebugCurrentFrame, Wn = null, Ra = !1;
    function ha() {
      {
        if (Wn === null)
          return null;
        var n = Wn._debugOwner;
        if (n !== null && typeof n < "u")
          return _t(n);
      }
      return null;
    }
    function zs() {
      return Wn === null ? "" : Ql(Wn);
    }
    function Jn() {
      Lu.getCurrentStack = null, Wn = null, Ra = !1;
    }
    function pn(n) {
      Lu.getCurrentStack = n === null ? null : zs, Wn = n, Ra = !1;
    }
    function ap() {
      return Wn;
    }
    function Oa(n) {
      Ra = n;
    }
    function Tr(n) {
      return "" + n;
    }
    function ho(n) {
      switch (typeof n) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return Zr(n), n;
        default:
          return "";
      }
    }
    var ip = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Vo(n, a) {
      ip[a.type] || a.onChange || a.onInput || a.readOnly || a.disabled || a.value == null || f("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), a.onChange || a.readOnly || a.disabled || a.checked == null || f("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Bs(n) {
      var a = n.type, u = n.nodeName;
      return u && u.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
    }
    function op(n) {
      return n._valueTracker;
    }
    function mi(n) {
      n._valueTracker = null;
    }
    function Us(n) {
      var a = "";
      return n && (Bs(n) ? a = n.checked ? "true" : "false" : a = n.value), a;
    }
    function Hs(n) {
      var a = Bs(n) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(n.constructor.prototype, a);
      Zr(n[a]);
      var c = "" + n[a];
      if (!(n.hasOwnProperty(a) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var h = u.get, g = u.set;
        Object.defineProperty(n, a, {
          configurable: !0,
          get: function() {
            return h.call(this);
          },
          set: function(_) {
            Zr(_), c = "" + _, g.call(this, _);
          }
        }), Object.defineProperty(n, a, {
          enumerable: u.enumerable
        });
        var E = {
          getValue: function() {
            return c;
          },
          setValue: function(_) {
            Zr(_), c = "" + _;
          },
          stopTracking: function() {
            mi(n), delete n[a];
          }
        };
        return E;
      }
    }
    function yi(n) {
      op(n) || (n._valueTracker = Hs(n));
    }
    function tc(n) {
      if (!n)
        return !1;
      var a = op(n);
      if (!a)
        return !0;
      var u = a.getValue(), c = Us(n);
      return c !== u ? (a.setValue(c), !0) : !1;
    }
    function Vs(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u")
        return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    var Gs = !1, Nu = !1, nc = !1, Rd = !1;
    function Vi(n) {
      var a = n.type === "checkbox" || n.type === "radio";
      return a ? n.checked != null : n.value != null;
    }
    function A(n, a) {
      var u = n, c = a.checked, h = Nt({}, a, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: c ?? u._wrapperState.initialChecked
      });
      return h;
    }
    function G(n, a) {
      Vo("input", a), a.checked !== void 0 && a.defaultChecked !== void 0 && !Nu && (f("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ha() || "A component", a.type), Nu = !0), a.value !== void 0 && a.defaultValue !== void 0 && !Gs && (f("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ha() || "A component", a.type), Gs = !0);
      var u = n, c = a.defaultValue == null ? "" : a.defaultValue;
      u._wrapperState = {
        initialChecked: a.checked != null ? a.checked : a.defaultChecked,
        initialValue: ho(a.value != null ? a.value : c),
        controlled: Vi(a)
      };
    }
    function ae(n, a) {
      var u = n, c = a.checked;
      c != null && Za(u, "checked", c, !1);
    }
    function he(n, a) {
      var u = n;
      {
        var c = Vi(a);
        !u._wrapperState.controlled && c && !Rd && (f("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Rd = !0), u._wrapperState.controlled && !c && !nc && (f("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), nc = !0);
      }
      ae(n, a);
      var h = ho(a.value), g = a.type;
      if (h != null)
        g === "number" ? (h === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != h) && (u.value = Tr(h)) : u.value !== Tr(h) && (u.value = Tr(h));
      else if (g === "submit" || g === "reset") {
        u.removeAttribute("value");
        return;
      }
      a.hasOwnProperty("value") ? ht(u, a.type, h) : a.hasOwnProperty("defaultValue") && ht(u, a.type, ho(a.defaultValue)), a.checked == null && a.defaultChecked != null && (u.defaultChecked = !!a.defaultChecked);
    }
    function Ae(n, a, u) {
      var c = n;
      if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
        var h = a.type, g = h === "submit" || h === "reset";
        if (g && (a.value === void 0 || a.value === null))
          return;
        var E = Tr(c._wrapperState.initialValue);
        u || E !== c.value && (c.value = E), c.defaultValue = E;
      }
      var _ = c.name;
      _ !== "" && (c.name = ""), c.defaultChecked = !c.defaultChecked, c.defaultChecked = !!c._wrapperState.initialChecked, _ !== "" && (c.name = _);
    }
    function yt(n, a) {
      var u = n;
      he(u, a), Fe(u, a);
    }
    function Fe(n, a) {
      var u = a.name;
      if (a.type === "radio" && u != null) {
        for (var c = n; c.parentNode; )
          c = c.parentNode;
        Wr(u, "name");
        for (var h = c.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), g = 0; g < h.length; g++) {
          var E = h[g];
          if (!(E === n || E.form !== n.form)) {
            var _ = Zb(E);
            if (!_)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            tc(E), he(E, _);
          }
        }
      }
    }
    function ht(n, a, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (a !== "number" || Vs(n.ownerDocument) !== n) && (u == null ? n.defaultValue = Tr(n._wrapperState.initialValue) : n.defaultValue !== Tr(u) && (n.defaultValue = Tr(u)));
    }
    var Ft = !1, tn = !1, Sn = !1;
    function vn(n, a) {
      a.value == null && (typeof a.children == "object" && a.children !== null ? e.Children.forEach(a.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || tn || (tn = !0, f("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : a.dangerouslySetInnerHTML != null && (Sn || (Sn = !0, f("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), a.selected != null && !Ft && (f("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Ft = !0);
    }
    function kn(n, a) {
      a.value != null && n.setAttribute("value", Tr(ho(a.value)));
    }
    var jn = Array.isArray;
    function Wt(n) {
      return jn(n);
    }
    var Go;
    Go = !1;
    function rc() {
      var n = ha();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    var Od = ["value", "defaultValue"];
    function Im(n) {
      {
        Vo("select", n);
        for (var a = 0; a < Od.length; a++) {
          var u = Od[a];
          if (n[u] != null) {
            var c = Wt(n[u]);
            n.multiple && !c ? f("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, rc()) : !n.multiple && c && f("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, rc());
          }
        }
      }
    }
    function Gi(n, a, u, c) {
      var h = n.options;
      if (a) {
        for (var g = u, E = {}, _ = 0; _ < g.length; _++)
          E["$" + g[_]] = !0;
        for (var P = 0; P < h.length; P++) {
          var M = E.hasOwnProperty("$" + h[P].value);
          h[P].selected !== M && (h[P].selected = M), M && c && (h[P].defaultSelected = !0);
        }
      } else {
        for (var F = Tr(ho(u)), X = null, K = 0; K < h.length; K++) {
          if (h[K].value === F) {
            h[K].selected = !0, c && (h[K].defaultSelected = !0);
            return;
          }
          X === null && !h[K].disabled && (X = h[K]);
        }
        X !== null && (X.selected = !0);
      }
    }
    function Pd(n, a) {
      return Nt({}, a, {
        value: void 0
      });
    }
    function jd(n, a) {
      var u = n;
      Im(a), u._wrapperState = {
        wasMultiple: !!a.multiple
      }, a.value !== void 0 && a.defaultValue !== void 0 && !Go && (f("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Go = !0);
    }
    function Mm(n, a) {
      var u = n;
      u.multiple = !!a.multiple;
      var c = a.value;
      c != null ? Gi(u, !!a.multiple, c, !1) : a.defaultValue != null && Gi(u, !!a.multiple, a.defaultValue, !0);
    }
    function Ix(n, a) {
      var u = n, c = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!a.multiple;
      var h = a.value;
      h != null ? Gi(u, !!a.multiple, h, !1) : c !== !!a.multiple && (a.defaultValue != null ? Gi(u, !!a.multiple, a.defaultValue, !0) : Gi(u, !!a.multiple, a.multiple ? [] : "", !1));
    }
    function Mx(n, a) {
      var u = n, c = a.value;
      c != null && Gi(u, !!a.multiple, c, !1);
    }
    var $m = !1;
    function Lm(n, a) {
      var u = n;
      if (a.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var c = Nt({}, a, {
        value: void 0,
        defaultValue: void 0,
        children: Tr(u._wrapperState.initialValue)
      });
      return c;
    }
    function E0(n, a) {
      var u = n;
      Vo("textarea", a), a.value !== void 0 && a.defaultValue !== void 0 && !$m && (f("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", ha() || "A component"), $m = !0);
      var c = a.value;
      if (c == null) {
        var h = a.children, g = a.defaultValue;
        if (h != null) {
          f("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (g != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Wt(h)) {
              if (h.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              h = h[0];
            }
            g = h;
          }
        }
        g == null && (g = ""), c = g;
      }
      u._wrapperState = {
        initialValue: ho(c)
      };
    }
    function C0(n, a) {
      var u = n, c = ho(a.value), h = ho(a.defaultValue);
      if (c != null) {
        var g = Tr(c);
        g !== u.value && (u.value = g), a.defaultValue == null && u.defaultValue !== g && (u.defaultValue = g);
      }
      h != null && (u.defaultValue = Tr(h));
    }
    function T0(n, a) {
      var u = n, c = u.textContent;
      c === u._wrapperState.initialValue && c !== "" && c !== null && (u.value = c);
    }
    function Nm(n, a) {
      C0(n, a);
    }
    var qo = "http://www.w3.org/1999/xhtml", $x = "http://www.w3.org/1998/Math/MathML", Fm = "http://www.w3.org/2000/svg";
    function sp(n) {
      switch (n) {
        case "svg":
          return Fm;
        case "math":
          return $x;
        default:
          return qo;
      }
    }
    function zm(n, a) {
      return n == null || n === qo ? sp(a) : n === Fm && a === "foreignObject" ? qo : n;
    }
    var Lx = function(n) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(a, u, c, h) {
        MSApp.execUnsafeLocalFunction(function() {
          return n(a, u, c, h);
        });
      } : n;
    }, up, _0 = Lx(function(n, a) {
      if (n.namespaceURI === Fm && !("innerHTML" in n)) {
        up = up || document.createElement("div"), up.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>";
        for (var u = up.firstChild; n.firstChild; )
          n.removeChild(n.firstChild);
        for (; u.firstChild; )
          n.appendChild(u.firstChild);
        return;
      }
      n.innerHTML = a;
    }), Pa = 1, Wo = 3, fr = 8, qi = 9, Fu = 11, lp = function(n, a) {
      if (a) {
        var u = n.firstChild;
        if (u && u === n.lastChild && u.nodeType === Wo) {
          u.nodeValue = a;
          return;
        }
      }
      n.textContent = a;
    }, R0 = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, ac = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function O0(n, a) {
      return n + a.charAt(0).toUpperCase() + a.substring(1);
    }
    var P0 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ac).forEach(function(n) {
      P0.forEach(function(a) {
        ac[O0(a, n)] = ac[n];
      });
    });
    function cp(n, a, u) {
      var c = a == null || typeof a == "boolean" || a === "";
      return c ? "" : !u && typeof a == "number" && a !== 0 && !(ac.hasOwnProperty(n) && ac[n]) ? a + "px" : (ar(a, n), ("" + a).trim());
    }
    var ic = /([A-Z])/g, Nx = /^ms-/;
    function Fx(n) {
      return n.replace(ic, "-$1").toLowerCase().replace(Nx, "-ms-");
    }
    var j0 = function() {
    };
    {
      var A0 = /^(?:webkit|moz|o)[A-Z]/, D0 = /^-ms-/, Ad = /-(.)/g, oc = /;\s*$/, sc = {}, uc = {}, I0 = !1, Bm = !1, Um = function(n) {
        return n.replace(Ad, function(a, u) {
          return u.toUpperCase();
        });
      }, Hm = function(n) {
        sc.hasOwnProperty(n) && sc[n] || (sc[n] = !0, f(
          "Unsupported style property %s. Did you mean %s?",
          n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Um(n.replace(D0, "ms-"))
        ));
      }, M0 = function(n) {
        sc.hasOwnProperty(n) && sc[n] || (sc[n] = !0, f("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
      }, $0 = function(n, a) {
        uc.hasOwnProperty(a) && uc[a] || (uc[a] = !0, f(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, a.replace(oc, "")));
      }, L0 = function(n, a) {
        I0 || (I0 = !0, f("`NaN` is an invalid value for the `%s` css style property.", n));
      }, zx = function(n, a) {
        Bm || (Bm = !0, f("`Infinity` is an invalid value for the `%s` css style property.", n));
      };
      j0 = function(n, a) {
        n.indexOf("-") > -1 ? Hm(n) : A0.test(n) ? M0(n) : oc.test(a) && $0(n, a), typeof a == "number" && (isNaN(a) ? L0(n, a) : isFinite(a) || zx(n, a));
      };
    }
    var Bx = j0;
    function Ux(n) {
      {
        var a = "", u = "";
        for (var c in n)
          if (n.hasOwnProperty(c)) {
            var h = n[c];
            if (h != null) {
              var g = c.indexOf("--") === 0;
              a += u + (g ? c : Fx(c)) + ":", a += cp(c, h, g), u = ";";
            }
          }
        return a || null;
      }
    }
    function N0(n, a) {
      var u = n.style;
      for (var c in a)
        if (a.hasOwnProperty(c)) {
          var h = c.indexOf("--") === 0;
          h || Bx(c, a[c]);
          var g = cp(c, a[c], h);
          c === "float" && (c = "cssFloat"), h ? u.setProperty(c, g) : u[c] = g;
        }
    }
    function Hx(n) {
      return n == null || typeof n == "boolean" || n === "";
    }
    function vi(n) {
      var a = {};
      for (var u in n)
        for (var c = R0[u] || [u], h = 0; h < c.length; h++)
          a[c[h]] = u;
      return a;
    }
    function Dd(n, a) {
      {
        if (!a)
          return;
        var u = vi(n), c = vi(a), h = {};
        for (var g in u) {
          var E = u[g], _ = c[g];
          if (_ && E !== _) {
            var P = E + "," + _;
            if (h[P])
              continue;
            h[P] = !0, f("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Hx(n[E]) ? "Removing" : "Updating", E, _);
          }
        }
      }
    }
    var F0 = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, z0 = Nt({
      menuitem: !0
    }, F0), B0 = "__html";
    function dp(n, a) {
      if (a) {
        if (z0[n] && (a.children != null || a.dangerouslySetInnerHTML != null))
          throw new Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (a.dangerouslySetInnerHTML != null) {
          if (a.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof a.dangerouslySetInnerHTML != "object" || !(B0 in a.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!a.suppressContentEditableWarning && a.contentEditable && a.children != null && f("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), a.style != null && typeof a.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Yo(n, a) {
      if (n.indexOf("-") === -1)
        return typeof a.is == "string";
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var fp = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, U0 = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Wi = {}, Vm = new RegExp("^(aria)-[" + ot + "]*$"), Id = new RegExp("^(aria)[A-Z][" + ot + "]*$");
    function Gm(n, a) {
      {
        if (xn.call(Wi, a) && Wi[a])
          return !0;
        if (Id.test(a)) {
          var u = "aria-" + a.slice(4).toLowerCase(), c = U0.hasOwnProperty(u) ? u : null;
          if (c == null)
            return f("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", a), Wi[a] = !0, !0;
          if (a !== c)
            return f("Invalid ARIA attribute `%s`. Did you mean `%s`?", a, c), Wi[a] = !0, !0;
        }
        if (Vm.test(a)) {
          var h = a.toLowerCase(), g = U0.hasOwnProperty(h) ? h : null;
          if (g == null)
            return Wi[a] = !0, !1;
          if (a !== g)
            return f("Unknown ARIA attribute `%s`. Did you mean `%s`?", a, g), Wi[a] = !0, !0;
        }
      }
      return !0;
    }
    function H0(n, a) {
      {
        var u = [];
        for (var c in a) {
          var h = Gm(n, c);
          h || u.push(c);
        }
        var g = u.map(function(E) {
          return "`" + E + "`";
        }).join(", ");
        u.length === 1 ? f("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", g, n) : u.length > 1 && f("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", g, n);
      }
    }
    function pp(n, a) {
      Yo(n, a) || H0(n, a);
    }
    var zu = !1;
    function qm(n, a) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select")
          return;
        a != null && a.value === null && !zu && (zu = !0, n === "select" && a.multiple ? f("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : f("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Wm = function() {
    };
    {
      var _r = {}, Ym = /^on./, V0 = /^on[^A-Z]/, G0 = new RegExp("^(aria)-[" + ot + "]*$"), q0 = new RegExp("^(aria)[A-Z][" + ot + "]*$");
      Wm = function(n, a, u, c) {
        if (xn.call(_r, a) && _r[a])
          return !0;
        var h = a.toLowerCase();
        if (h === "onfocusin" || h === "onfocusout")
          return f("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), _r[a] = !0, !0;
        if (c != null) {
          var g = c.registrationNameDependencies, E = c.possibleRegistrationNames;
          if (g.hasOwnProperty(a))
            return !0;
          var _ = E.hasOwnProperty(h) ? E[h] : null;
          if (_ != null)
            return f("Invalid event handler property `%s`. Did you mean `%s`?", a, _), _r[a] = !0, !0;
          if (Ym.test(a))
            return f("Unknown event handler property `%s`. It will be ignored.", a), _r[a] = !0, !0;
        } else if (Ym.test(a))
          return V0.test(a) && f("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", a), _r[a] = !0, !0;
        if (G0.test(a) || q0.test(a))
          return !0;
        if (h === "innerhtml")
          return f("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), _r[a] = !0, !0;
        if (h === "aria")
          return f("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), _r[a] = !0, !0;
        if (h === "is" && u !== null && u !== void 0 && typeof u != "string")
          return f("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), _r[a] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return f("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", a), _r[a] = !0, !0;
        var P = ca(a), M = P !== null && P.type === qa;
        if (fp.hasOwnProperty(h)) {
          var F = fp[h];
          if (F !== a)
            return f("Invalid DOM property `%s`. Did you mean `%s`?", a, F), _r[a] = !0, !0;
        } else if (!M && a !== h)
          return f("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", a, h), _r[a] = !0, !0;
        return typeof u == "boolean" && Kr(a, u, P, !1) ? (u ? f('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, a, a, u, a) : f('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, a, a, u, a, a, a), _r[a] = !0, !0) : M ? !0 : Kr(a, u, P, !1) ? (_r[a] = !0, !1) : ((u === "false" || u === "true") && P !== null && P.type === Gn && (f("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, a, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', a, u), _r[a] = !0), !0);
      };
    }
    var W0 = function(n, a, u) {
      {
        var c = [];
        for (var h in a) {
          var g = Wm(n, h, a[h], u);
          g || c.push(h);
        }
        var E = c.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        c.length === 1 ? f("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", E, n) : c.length > 1 && f("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", E, n);
      }
    };
    function Y0(n, a, u) {
      Yo(n, a) || W0(n, a, u);
    }
    var Zo = 1, Md = 1 << 1, Bu = 1 << 2, Vx = Zo | Md | Bu, $d = null;
    function Ld(n) {
      $d !== null && f("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), $d = n;
    }
    function Gx() {
      $d === null && f("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), $d = null;
    }
    function Z0(n) {
      return n === $d;
    }
    function hp(n) {
      var a = n.target || n.srcElement || window;
      return a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === Wo ? a.parentNode : a;
    }
    var En = null, qs = null, Ko = null;
    function lc(n) {
      var a = Mc(n);
      if (a) {
        if (typeof En != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = a.stateNode;
        if (u) {
          var c = Zb(u);
          En(a.stateNode, a.type, c);
        }
      }
    }
    function K0(n) {
      En = n;
    }
    function mp(n) {
      qs ? Ko ? Ko.push(n) : Ko = [n] : qs = n;
    }
    function Nd() {
      return qs !== null || Ko !== null;
    }
    function Fd() {
      if (qs) {
        var n = qs, a = Ko;
        if (qs = null, Ko = null, lc(n), a)
          for (var u = 0; u < a.length; u++)
            lc(a[u]);
      }
    }
    var Uu = function(n, a) {
      return n(a);
    }, Zm = function() {
    }, Km = !1;
    function qx() {
      var n = Nd();
      n && (Zm(), Fd());
    }
    function Qm(n, a, u) {
      if (Km)
        return n(a, u);
      Km = !0;
      try {
        return Uu(n, a, u);
      } finally {
        Km = !1, qx();
      }
    }
    function yp(n, a, u) {
      Uu = n, Zm = u;
    }
    function vp(n) {
      return n === "button" || n === "input" || n === "select" || n === "textarea";
    }
    function Xm(n, a, u) {
      switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && vp(a));
        default:
          return !1;
      }
    }
    function Hu(n, a) {
      var u = n.stateNode;
      if (u === null)
        return null;
      var c = Zb(u);
      if (c === null)
        return null;
      var h = c[a];
      if (Xm(a, n.type, c))
        return null;
      if (h && typeof h != "function")
        throw new Error("Expected `" + a + "` listener to be a function, instead got a value of `" + typeof h + "` type.");
      return h;
    }
    var zd = !1;
    if (Vt)
      try {
        var Vu = {};
        Object.defineProperty(Vu, "passive", {
          get: function() {
            zd = !0;
          }
        }), window.addEventListener("test", Vu, Vu), window.removeEventListener("test", Vu, Vu);
      } catch {
        zd = !1;
      }
    function Q0(n, a, u, c, h, g, E, _, P) {
      var M = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(u, M);
      } catch (F) {
        this.onError(F);
      }
    }
    var Jm = Q0;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var ey = document.createElement("react");
      Jm = function(a, u, c, h, g, E, _, P, M) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var F = document.createEvent("Event"), X = !1, K = !0, re = window.event, ie = Object.getOwnPropertyDescriptor(window, "event");
        function me() {
          ey.removeEventListener(ye, ft, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = re);
        }
        var qe = Array.prototype.slice.call(arguments, 3);
        function ft() {
          X = !0, me(), u.apply(c, qe), K = !1;
        }
        var it, Qt = !1, qt = !1;
        function ee(te) {
          if (it = te.error, Qt = !0, it === null && te.colno === 0 && te.lineno === 0 && (qt = !0), te.defaultPrevented && it != null && typeof it == "object")
            try {
              it._suppressLogging = !0;
            } catch {
            }
        }
        var ye = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", ee), ey.addEventListener(ye, ft, !1), F.initEvent(ye, !1, !1), ey.dispatchEvent(F), ie && Object.defineProperty(window, "event", ie), X && K && (Qt ? qt && (it = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : it = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(it)), window.removeEventListener("error", ee), !X)
          return me(), Q0.apply(this, arguments);
      };
    }
    var Wx = Jm, Ws = !1, Yi = null, Bd = !1, Ys = null, mo = {
      onError: function(n) {
        Ws = !0, Yi = n;
      }
    };
    function Gu(n, a, u, c, h, g, E, _, P) {
      Ws = !1, Yi = null, Wx.apply(mo, arguments);
    }
    function Qo(n, a, u, c, h, g, E, _, P) {
      if (Gu.apply(this, arguments), Ws) {
        var M = ny();
        Bd || (Bd = !0, Ys = M);
      }
    }
    function ty() {
      if (Bd) {
        var n = Ys;
        throw Bd = !1, Ys = null, n;
      }
    }
    function Yx() {
      return Ws;
    }
    function ny() {
      if (Ws) {
        var n = Yi;
        return Ws = !1, Yi = null, n;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function gi(n) {
      return n._reactInternals;
    }
    function Ud(n) {
      return n._reactInternals !== void 0;
    }
    function cc(n, a) {
      n._reactInternals = a;
    }
    var lt = (
      /*                      */
      0
    ), Zs = (
      /*                */
      1
    ), Dn = (
      /*                    */
      2
    ), It = (
      /*                       */
      4
    ), ln = (
      /*                */
      16
    ), hn = (
      /*                 */
      32
    ), yo = (
      /*                     */
      64
    ), Et = (
      /*                   */
      128
    ), er = (
      /*            */
      256
    ), ja = (
      /*                          */
      512
    ), bi = (
      /*                     */
      1024
    ), Fn = (
      /*                      */
      2048
    ), wi = (
      /*                    */
      4096
    ), Ks = (
      /*                   */
      8192
    ), Hd = (
      /*             */
      16384
    ), gp = Fn | It | yo | ja | bi | Hd, X0 = (
      /*               */
      32767
    ), Qa = (
      /*                   */
      32768
    ), Rr = (
      /*                */
      65536
    ), Vd = (
      /* */
      131072
    ), ry = (
      /*                       */
      1048576
    ), ay = (
      /*                    */
      2097152
    ), Aa = (
      /*                 */
      4194304
    ), Qs = (
      /*                */
      8388608
    ), Da = (
      /*               */
      16777216
    ), qu = (
      /*              */
      33554432
    ), dc = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      It | bi | 0
    ), Ia = Dn | It | ln | hn | ja | wi | Ks, Qr = It | yo | ja | Ks, xi = Fn | ln, $r = Aa | Qs | ay, Xo = r.ReactCurrentOwner;
    function Xa(n) {
      var a = n, u = n;
      if (n.alternate)
        for (; a.return; )
          a = a.return;
      else {
        var c = a;
        do
          a = c, (a.flags & (Dn | wi)) !== lt && (u = a.return), c = a.return;
        while (c);
      }
      return a.tag === b ? u : null;
    }
    function iy(n) {
      if (n.tag === H) {
        var a = n.memoizedState;
        if (a === null) {
          var u = n.alternate;
          u !== null && (a = u.memoizedState);
        }
        if (a !== null)
          return a.dehydrated;
      }
      return null;
    }
    function bp(n) {
      return n.tag === b ? n.stateNode.containerInfo : null;
    }
    function oy(n) {
      return Xa(n) === n;
    }
    function Ja(n) {
      {
        var a = Xo.current;
        if (a !== null && a.tag === w) {
          var u = a, c = u.stateNode;
          c._warnedAboutRefsInRender || f("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", _t(u) || "A component"), c._warnedAboutRefsInRender = !0;
        }
      }
      var h = gi(n);
      return h ? Xa(h) === h : !1;
    }
    function Ma(n) {
      if (Xa(n) !== n)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function In(n) {
      var a = n.alternate;
      if (!a) {
        var u = Xa(n);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== n ? null : n;
      }
      for (var c = n, h = a; ; ) {
        var g = c.return;
        if (g === null)
          break;
        var E = g.alternate;
        if (E === null) {
          var _ = g.return;
          if (_ !== null) {
            c = h = _;
            continue;
          }
          break;
        }
        if (g.child === E.child) {
          for (var P = g.child; P; ) {
            if (P === c)
              return Ma(g), n;
            if (P === h)
              return Ma(g), a;
            P = P.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== h.return)
          c = g, h = E;
        else {
          for (var M = !1, F = g.child; F; ) {
            if (F === c) {
              M = !0, c = g, h = E;
              break;
            }
            if (F === h) {
              M = !0, h = g, c = E;
              break;
            }
            F = F.sibling;
          }
          if (!M) {
            for (F = E.child; F; ) {
              if (F === c) {
                M = !0, c = E, h = g;
                break;
              }
              if (F === h) {
                M = !0, h = E, c = g;
                break;
              }
              F = F.sibling;
            }
            if (!M)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (c.alternate !== h)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (c.tag !== b)
        throw new Error("Unable to find node on an unmounted component.");
      return c.stateNode.current === c ? n : a;
    }
    function Si(n) {
      var a = In(n);
      return a !== null ? sy(a) : null;
    }
    function sy(n) {
      if (n.tag === T || n.tag === O)
        return n;
      for (var a = n.child; a !== null; ) {
        var u = sy(a);
        if (u !== null)
          return u;
        a = a.sibling;
      }
      return null;
    }
    function J0(n) {
      var a = In(n);
      return a !== null ? wp(a) : null;
    }
    function wp(n) {
      if (n.tag === T || n.tag === O)
        return n;
      for (var a = n.child; a !== null; ) {
        if (a.tag !== k) {
          var u = wp(a);
          if (u !== null)
            return u;
        }
        a = a.sibling;
      }
      return null;
    }
    var xp = t.unstable_scheduleCallback, eb = t.unstable_cancelCallback, Sp = t.unstable_shouldYield, tb = t.unstable_requestPaint, Yn = t.unstable_now, uy = t.unstable_getCurrentPriorityLevel, kp = t.unstable_ImmediatePriority, ei = t.unstable_UserBlockingPriority, vo = t.unstable_NormalPriority, Ep = t.unstable_LowPriority, Xs = t.unstable_IdlePriority, ly = t.unstable_yieldValue, cy = t.unstable_setDisableYieldValue, Js = null, Or = null, Le = null, or = !1, Lr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function dy(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled)
        return !0;
      if (!a.supportsFiber)
        return f("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        bt && (n = Nt({}, n, {
          getLaneLabelMap: tu,
          injectProfilingHooks: es
        })), Js = a.inject(n), Or = a;
      } catch (u) {
        f("React instrumentation encountered an error: %s.", u);
      }
      return !!a.checkDCE;
    }
    function nb(n, a) {
      if (Or && typeof Or.onScheduleFiberRoot == "function")
        try {
          Or.onScheduleFiberRoot(Js, n, a);
        } catch (u) {
          or || (or = !0, f("React instrumentation encountered an error: %s", u));
        }
    }
    function Jo(n, a) {
      if (Or && typeof Or.onCommitFiberRoot == "function")
        try {
          var u = (n.current.flags & Et) === Et;
          if (at) {
            var c;
            switch (a) {
              case Xr:
                c = kp;
                break;
              case Nr:
                c = ei;
                break;
              case ns:
                c = vo;
                break;
              case Jd:
                c = Xs;
                break;
              default:
                c = vo;
                break;
            }
            Or.onCommitFiberRoot(Js, n, c, u);
          }
        } catch (h) {
          or || (or = !0, f("React instrumentation encountered an error: %s", h));
        }
    }
    function eu(n) {
      if (Or && typeof Or.onPostCommitFiberRoot == "function")
        try {
          Or.onPostCommitFiberRoot(Js, n);
        } catch (a) {
          or || (or = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function fy(n) {
      if (Or && typeof Or.onCommitFiberUnmount == "function")
        try {
          Or.onCommitFiberUnmount(Js, n);
        } catch (a) {
          or || (or = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function yr(n) {
      if (typeof ly == "function" && (cy(n), l(n)), Or && typeof Or.setStrictMode == "function")
        try {
          Or.setStrictMode(Js, n);
        } catch (a) {
          or || (or = !0, f("React instrumentation encountered an error: %s", a));
        }
    }
    function es(n) {
      Le = n;
    }
    function tu() {
      {
        for (var n = /* @__PURE__ */ new Map(), a = 1, u = 0; u < Mn; u++) {
          var c = Zx(a);
          n.set(a, c), a *= 2;
        }
        return n;
      }
    }
    function Cp(n) {
      Le !== null && typeof Le.markCommitStarted == "function" && Le.markCommitStarted(n);
    }
    function py() {
      Le !== null && typeof Le.markCommitStopped == "function" && Le.markCommitStopped();
    }
    function nu(n) {
      Le !== null && typeof Le.markComponentRenderStarted == "function" && Le.markComponentRenderStarted(n);
    }
    function Wu() {
      Le !== null && typeof Le.markComponentRenderStopped == "function" && Le.markComponentRenderStopped();
    }
    function rb(n) {
      Le !== null && typeof Le.markComponentPassiveEffectMountStarted == "function" && Le.markComponentPassiveEffectMountStarted(n);
    }
    function hy() {
      Le !== null && typeof Le.markComponentPassiveEffectMountStopped == "function" && Le.markComponentPassiveEffectMountStopped();
    }
    function Tp(n) {
      Le !== null && typeof Le.markComponentPassiveEffectUnmountStarted == "function" && Le.markComponentPassiveEffectUnmountStarted(n);
    }
    function ab() {
      Le !== null && typeof Le.markComponentPassiveEffectUnmountStopped == "function" && Le.markComponentPassiveEffectUnmountStopped();
    }
    function ib(n) {
      Le !== null && typeof Le.markComponentLayoutEffectMountStarted == "function" && Le.markComponentLayoutEffectMountStarted(n);
    }
    function ob() {
      Le !== null && typeof Le.markComponentLayoutEffectMountStopped == "function" && Le.markComponentLayoutEffectMountStopped();
    }
    function _p(n) {
      Le !== null && typeof Le.markComponentLayoutEffectUnmountStarted == "function" && Le.markComponentLayoutEffectUnmountStarted(n);
    }
    function fc() {
      Le !== null && typeof Le.markComponentLayoutEffectUnmountStopped == "function" && Le.markComponentLayoutEffectUnmountStopped();
    }
    function Rp(n, a, u) {
      Le !== null && typeof Le.markComponentErrored == "function" && Le.markComponentErrored(n, a, u);
    }
    function sb(n, a, u) {
      Le !== null && typeof Le.markComponentSuspended == "function" && Le.markComponentSuspended(n, a, u);
    }
    function ub(n) {
      Le !== null && typeof Le.markLayoutEffectsStarted == "function" && Le.markLayoutEffectsStarted(n);
    }
    function pc() {
      Le !== null && typeof Le.markLayoutEffectsStopped == "function" && Le.markLayoutEffectsStopped();
    }
    function lb(n) {
      Le !== null && typeof Le.markPassiveEffectsStarted == "function" && Le.markPassiveEffectsStarted(n);
    }
    function Gd() {
      Le !== null && typeof Le.markPassiveEffectsStopped == "function" && Le.markPassiveEffectsStopped();
    }
    function Zi(n) {
      Le !== null && typeof Le.markRenderStarted == "function" && Le.markRenderStarted(n);
    }
    function qd() {
      Le !== null && typeof Le.markRenderYielded == "function" && Le.markRenderYielded();
    }
    function hc() {
      Le !== null && typeof Le.markRenderStopped == "function" && Le.markRenderStopped();
    }
    function Yu(n) {
      Le !== null && typeof Le.markRenderScheduled == "function" && Le.markRenderScheduled(n);
    }
    function my(n, a) {
      Le !== null && typeof Le.markForceUpdateScheduled == "function" && Le.markForceUpdateScheduled(n, a);
    }
    function ru(n, a) {
      Le !== null && typeof Le.markStateUpdateScheduled == "function" && Le.markStateUpdateScheduled(n, a);
    }
    var mt = (
      /*                         */
      0
    ), zt = (
      /*                 */
      1
    ), vt = (
      /*                    */
      2
    ), Zn = (
      /*               */
      8
    ), ki = (
      /*              */
      16
    ), Op = Math.clz32 ? Math.clz32 : Zu, Pp = Math.log, yy = Math.LN2;
    function Zu(n) {
      var a = n >>> 0;
      return a === 0 ? 32 : 31 - (Pp(a) / yy | 0) | 0;
    }
    var Mn = 31, be = (
      /*                        */
      0
    ), Zt = (
      /*                          */
      0
    ), gt = (
      /*                        */
      1
    ), go = (
      /*    */
      2
    ), ti = (
      /*             */
      4
    ), Ku = (
      /*            */
      8
    ), $n = (
      /*                     */
      16
    ), Qu = (
      /*                */
      32
    ), au = (
      /*                       */
      4194240
    ), Xu = (
      /*                        */
      64
    ), Ei = (
      /*                        */
      128
    ), $a = (
      /*                        */
      256
    ), Ju = (
      /*                        */
      512
    ), Wd = (
      /*                        */
      1024
    ), Yd = (
      /*                        */
      2048
    ), jp = (
      /*                        */
      4096
    ), Ap = (
      /*                        */
      8192
    ), Dp = (
      /*                        */
      16384
    ), Ip = (
      /*                       */
      32768
    ), Mp = (
      /*                       */
      65536
    ), $p = (
      /*                       */
      131072
    ), Lp = (
      /*                       */
      262144
    ), Np = (
      /*                       */
      524288
    ), el = (
      /*                       */
      1048576
    ), Fp = (
      /*                       */
      2097152
    ), tl = (
      /*                            */
      130023424
    ), ts = (
      /*                             */
      4194304
    ), zp = (
      /*                             */
      8388608
    ), Zd = (
      /*                             */
      16777216
    ), Bp = (
      /*                             */
      33554432
    ), Up = (
      /*                             */
      67108864
    ), vy = ts, mc = (
      /*          */
      134217728
    ), Hp = (
      /*                          */
      268435455
    ), yc = (
      /*               */
      268435456
    ), iu = (
      /*                        */
      536870912
    ), La = (
      /*                   */
      1073741824
    );
    function Zx(n) {
      {
        if (n & gt)
          return "Sync";
        if (n & go)
          return "InputContinuousHydration";
        if (n & ti)
          return "InputContinuous";
        if (n & Ku)
          return "DefaultHydration";
        if (n & $n)
          return "Default";
        if (n & Qu)
          return "TransitionHydration";
        if (n & au)
          return "Transition";
        if (n & tl)
          return "Retry";
        if (n & mc)
          return "SelectiveHydration";
        if (n & yc)
          return "IdleHydration";
        if (n & iu)
          return "Idle";
        if (n & La)
          return "Offscreen";
      }
    }
    var Cn = -1, Vp = Xu, Gp = ts;
    function vc(n) {
      switch (pr(n)) {
        case gt:
          return gt;
        case go:
          return go;
        case ti:
          return ti;
        case Ku:
          return Ku;
        case $n:
          return $n;
        case Qu:
          return Qu;
        case Xu:
        case Ei:
        case $a:
        case Ju:
        case Wd:
        case Yd:
        case jp:
        case Ap:
        case Dp:
        case Ip:
        case Mp:
        case $p:
        case Lp:
        case Np:
        case el:
        case Fp:
          return n & au;
        case ts:
        case zp:
        case Zd:
        case Bp:
        case Up:
          return n & tl;
        case mc:
          return mc;
        case yc:
          return yc;
        case iu:
          return iu;
        case La:
          return La;
        default:
          return f("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function Kd(n, a) {
      var u = n.pendingLanes;
      if (u === be)
        return be;
      var c = be, h = n.suspendedLanes, g = n.pingedLanes, E = u & Hp;
      if (E !== be) {
        var _ = E & ~h;
        if (_ !== be)
          c = vc(_);
        else {
          var P = E & g;
          P !== be && (c = vc(P));
        }
      } else {
        var M = u & ~h;
        M !== be ? c = vc(M) : g !== be && (c = vc(g));
      }
      if (c === be)
        return be;
      if (a !== be && a !== c && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & h) === be) {
        var F = pr(c), X = pr(a);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          F >= X || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          F === $n && (X & au) !== be
        )
          return a;
      }
      (c & ti) !== be && (c |= u & $n);
      var K = n.entangledLanes;
      if (K !== be)
        for (var re = n.entanglements, ie = c & K; ie > 0; ) {
          var me = ou(ie), qe = 1 << me;
          c |= re[me], ie &= ~qe;
        }
      return c;
    }
    function cb(n, a) {
      for (var u = n.eventTimes, c = Cn; a > 0; ) {
        var h = ou(a), g = 1 << h, E = u[h];
        E > c && (c = E), a &= ~g;
      }
      return c;
    }
    function qp(n, a) {
      switch (n) {
        case gt:
        case go:
        case ti:
          return a + 250;
        case Ku:
        case $n:
        case Qu:
        case Xu:
        case Ei:
        case $a:
        case Ju:
        case Wd:
        case Yd:
        case jp:
        case Ap:
        case Dp:
        case Ip:
        case Mp:
        case $p:
        case Lp:
        case Np:
        case el:
        case Fp:
          return a + 5e3;
        case ts:
        case zp:
        case Zd:
        case Bp:
        case Up:
          return Cn;
        case mc:
        case yc:
        case iu:
        case La:
          return Cn;
        default:
          return f("Should have found matching lanes. This is a bug in React."), Cn;
      }
    }
    function Kx(n, a) {
      for (var u = n.pendingLanes, c = n.suspendedLanes, h = n.pingedLanes, g = n.expirationTimes, E = u; E > 0; ) {
        var _ = ou(E), P = 1 << _, M = g[_];
        M === Cn ? ((P & c) === be || (P & h) !== be) && (g[_] = qp(P, a)) : M <= a && (n.expiredLanes |= P), E &= ~P;
      }
    }
    function Qx(n) {
      return vc(n.pendingLanes);
    }
    function gy(n) {
      var a = n.pendingLanes & ~La;
      return a !== be ? a : a & La ? La : be;
    }
    function gc(n) {
      return (n & gt) !== be;
    }
    function Qd(n) {
      return (n & Hp) !== be;
    }
    function Wp(n) {
      return (n & tl) === n;
    }
    function Xx(n) {
      var a = gt | ti | $n;
      return (n & a) === be;
    }
    function db(n) {
      return (n & au) === n;
    }
    function Xd(n, a) {
      var u = go | ti | Ku | $n;
      return (a & u) !== be;
    }
    function fb(n, a) {
      return (a & n.expiredLanes) !== be;
    }
    function by(n) {
      return (n & au) !== be;
    }
    function wy() {
      var n = Vp;
      return Vp <<= 1, (Vp & au) === be && (Vp = Xu), n;
    }
    function Jx() {
      var n = Gp;
      return Gp <<= 1, (Gp & tl) === be && (Gp = ts), n;
    }
    function pr(n) {
      return n & -n;
    }
    function vr(n) {
      return pr(n);
    }
    function ou(n) {
      return 31 - Op(n);
    }
    function Yp(n) {
      return ou(n);
    }
    function Na(n, a) {
      return (n & a) !== be;
    }
    function nl(n, a) {
      return (n & a) === a;
    }
    function Mt(n, a) {
      return n | a;
    }
    function bc(n, a) {
      return n & ~a;
    }
    function xy(n, a) {
      return n & a;
    }
    function pb(n) {
      return n;
    }
    function hb(n, a) {
      return n !== Zt && n < a ? n : a;
    }
    function Zp(n) {
      for (var a = [], u = 0; u < Mn; u++)
        a.push(n);
      return a;
    }
    function rl(n, a, u) {
      n.pendingLanes |= a, a !== iu && (n.suspendedLanes = be, n.pingedLanes = be);
      var c = n.eventTimes, h = Yp(a);
      c[h] = u;
    }
    function Sy(n, a) {
      n.suspendedLanes |= a, n.pingedLanes &= ~a;
      for (var u = n.expirationTimes, c = a; c > 0; ) {
        var h = ou(c), g = 1 << h;
        u[h] = Cn, c &= ~g;
      }
    }
    function ky(n, a, u) {
      n.pingedLanes |= n.suspendedLanes & a;
    }
    function Ey(n, a) {
      var u = n.pendingLanes & ~a;
      n.pendingLanes = a, n.suspendedLanes = be, n.pingedLanes = be, n.expiredLanes &= a, n.mutableReadLanes &= a, n.entangledLanes &= a;
      for (var c = n.entanglements, h = n.eventTimes, g = n.expirationTimes, E = u; E > 0; ) {
        var _ = ou(E), P = 1 << _;
        c[_] = be, h[_] = Cn, g[_] = Cn, E &= ~P;
      }
    }
    function wc(n, a) {
      for (var u = n.entangledLanes |= a, c = n.entanglements, h = u; h; ) {
        var g = ou(h), E = 1 << g;
        // Is this one of the newly entangled lanes?
        E & a | // Is this lane transitively entangled with the newly entangled lanes?
        c[g] & a && (c[g] |= a), h &= ~E;
      }
    }
    function e2(n, a) {
      var u = pr(a), c;
      switch (u) {
        case ti:
          c = go;
          break;
        case $n:
          c = Ku;
          break;
        case Xu:
        case Ei:
        case $a:
        case Ju:
        case Wd:
        case Yd:
        case jp:
        case Ap:
        case Dp:
        case Ip:
        case Mp:
        case $p:
        case Lp:
        case Np:
        case el:
        case Fp:
        case ts:
        case zp:
        case Zd:
        case Bp:
        case Up:
          c = Qu;
          break;
        case iu:
          c = yc;
          break;
        default:
          c = Zt;
          break;
      }
      return (c & (n.suspendedLanes | a)) !== Zt ? Zt : c;
    }
    function Cy(n, a, u) {
      if (Lr)
        for (var c = n.pendingUpdatersLaneMap; u > 0; ) {
          var h = Yp(u), g = 1 << h, E = c[h];
          E.add(a), u &= ~g;
        }
    }
    function Kp(n, a) {
      if (Lr)
        for (var u = n.pendingUpdatersLaneMap, c = n.memoizedUpdaters; a > 0; ) {
          var h = Yp(a), g = 1 << h, E = u[h];
          E.size > 0 && (E.forEach(function(_) {
            var P = _.alternate;
            (P === null || !c.has(P)) && c.add(_);
          }), E.clear()), a &= ~g;
        }
    }
    function Ty(n, a) {
      return null;
    }
    var Xr = gt, Nr = ti, ns = $n, Jd = iu, al = Zt;
    function Ci() {
      return al;
    }
    function gr(n) {
      al = n;
    }
    function ef(n, a) {
      var u = al;
      try {
        return al = n, a();
      } finally {
        al = u;
      }
    }
    function Jr(n, a) {
      return n !== 0 && n < a ? n : a;
    }
    function t2(n, a) {
      return n === 0 || n > a ? n : a;
    }
    function _y(n, a) {
      return n !== 0 && n < a;
    }
    function tf(n) {
      var a = pr(n);
      return _y(Xr, a) ? _y(Nr, a) ? Qd(a) ? ns : Jd : Nr : Xr;
    }
    function br(n) {
      var a = n.current.memoizedState;
      return a.isDehydrated;
    }
    var mb;
    function Ze(n) {
      mb = n;
    }
    function xc(n) {
      mb(n);
    }
    var nf;
    function yb(n) {
      nf = n;
    }
    var vb;
    function rf(n) {
      vb = n;
    }
    var af;
    function Ry(n) {
      af = n;
    }
    var Oy;
    function gb(n) {
      Oy = n;
    }
    var Qp = !1, Sc = [], bo = null, zn = null, Pr = null, Ti = /* @__PURE__ */ new Map(), kc = /* @__PURE__ */ new Map(), rs = [], Ki = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function bb(n) {
      return Ki.indexOf(n) > -1;
    }
    function wo(n, a, u, c, h) {
      return {
        blockedOn: n,
        domEventName: a,
        eventSystemFlags: u,
        nativeEvent: h,
        targetContainers: [c]
      };
    }
    function wb(n, a) {
      switch (n) {
        case "focusin":
        case "focusout":
          bo = null;
          break;
        case "dragenter":
        case "dragleave":
          zn = null;
          break;
        case "mouseover":
        case "mouseout":
          Pr = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = a.pointerId;
          Ti.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var c = a.pointerId;
          kc.delete(c);
          break;
        }
      }
    }
    function Ec(n, a, u, c, h, g) {
      if (n === null || n.nativeEvent !== g) {
        var E = wo(a, u, c, h, g);
        if (a !== null) {
          var _ = Mc(a);
          _ !== null && nf(_);
        }
        return E;
      }
      n.eventSystemFlags |= c;
      var P = n.targetContainers;
      return h !== null && P.indexOf(h) === -1 && P.push(h), n;
    }
    function xb(n, a, u, c, h) {
      switch (a) {
        case "focusin": {
          var g = h;
          return bo = Ec(bo, n, a, u, c, g), !0;
        }
        case "dragenter": {
          var E = h;
          return zn = Ec(zn, n, a, u, c, E), !0;
        }
        case "mouseover": {
          var _ = h;
          return Pr = Ec(Pr, n, a, u, c, _), !0;
        }
        case "pointerover": {
          var P = h, M = P.pointerId;
          return Ti.set(M, Ec(Ti.get(M) || null, n, a, u, c, P)), !0;
        }
        case "gotpointercapture": {
          var F = h, X = F.pointerId;
          return kc.set(X, Ec(kc.get(X) || null, n, a, u, c, F)), !0;
        }
      }
      return !1;
    }
    function Py(n) {
      var a = hf(n.target);
      if (a !== null) {
        var u = Xa(a);
        if (u !== null) {
          var c = u.tag;
          if (c === H) {
            var h = iy(u);
            if (h !== null) {
              n.blockedOn = h, Oy(n.priority, function() {
                vb(u);
              });
              return;
            }
          } else if (c === b) {
            var g = u.stateNode;
            if (br(g)) {
              n.blockedOn = bp(u);
              return;
            }
          }
        }
      }
      n.blockedOn = null;
    }
    function Sb(n) {
      for (var a = af(), u = {
        blockedOn: null,
        target: n,
        priority: a
      }, c = 0; c < rs.length && _y(a, rs[c].priority); c++)
        ;
      rs.splice(c, 0, u), c === 0 && Py(u);
    }
    function Xp(n) {
      if (n.blockedOn !== null)
        return !1;
      for (var a = n.targetContainers; a.length > 0; ) {
        var u = a[0], c = il(n.domEventName, n.eventSystemFlags, u, n.nativeEvent);
        if (c === null) {
          var h = n.nativeEvent, g = new h.constructor(h.type, h);
          Ld(g), h.target.dispatchEvent(g), Gx();
        } else {
          var E = Mc(c);
          return E !== null && nf(E), n.blockedOn = c, !1;
        }
        a.shift();
      }
      return !0;
    }
    function of(n, a, u) {
      Xp(n) && u.delete(a);
    }
    function jy() {
      Qp = !1, bo !== null && Xp(bo) && (bo = null), zn !== null && Xp(zn) && (zn = null), Pr !== null && Xp(Pr) && (Pr = null), Ti.forEach(of), kc.forEach(of);
    }
    function ea(n, a) {
      n.blockedOn === a && (n.blockedOn = null, Qp || (Qp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, jy)));
    }
    function Gt(n) {
      if (Sc.length > 0) {
        ea(Sc[0], n);
        for (var a = 1; a < Sc.length; a++) {
          var u = Sc[a];
          u.blockedOn === n && (u.blockedOn = null);
        }
      }
      bo !== null && ea(bo, n), zn !== null && ea(zn, n), Pr !== null && ea(Pr, n);
      var c = function(_) {
        return ea(_, n);
      };
      Ti.forEach(c), kc.forEach(c);
      for (var h = 0; h < rs.length; h++) {
        var g = rs[h];
        g.blockedOn === n && (g.blockedOn = null);
      }
      for (; rs.length > 0; ) {
        var E = rs[0];
        if (E.blockedOn !== null)
          break;
        Py(E), E.blockedOn === null && rs.shift();
      }
    }
    var Kn = r.ReactCurrentBatchConfig, tr = !0;
    function jr(n) {
      tr = !!n;
    }
    function ni() {
      return tr;
    }
    function Cc(n, a, u) {
      var c = ma(a), h;
      switch (c) {
        case Xr:
          h = wr;
          break;
        case Nr:
          h = sf;
          break;
        case ns:
        default:
          h = as;
          break;
      }
      return h.bind(null, a, u, n);
    }
    function wr(n, a, u, c) {
      var h = Ci(), g = Kn.transition;
      Kn.transition = null;
      try {
        gr(Xr), as(n, a, u, c);
      } finally {
        gr(h), Kn.transition = g;
      }
    }
    function sf(n, a, u, c) {
      var h = Ci(), g = Kn.transition;
      Kn.transition = null;
      try {
        gr(Nr), as(n, a, u, c);
      } finally {
        gr(h), Kn.transition = g;
      }
    }
    function as(n, a, u, c) {
      tr && Jp(n, a, u, c);
    }
    function Jp(n, a, u, c) {
      var h = il(n, a, u, c);
      if (h === null) {
        x2(n, a, c, Tc, u), wb(n, c);
        return;
      }
      if (xb(h, n, a, u, c)) {
        c.stopPropagation();
        return;
      }
      if (wb(n, c), a & Bu && bb(n)) {
        for (; h !== null; ) {
          var g = Mc(h);
          g !== null && xc(g);
          var E = il(n, a, u, c);
          if (E === null && x2(n, a, c, Tc, u), E === h)
            break;
          h = E;
        }
        h !== null && c.stopPropagation();
        return;
      }
      x2(n, a, c, null, u);
    }
    var Tc = null;
    function il(n, a, u, c) {
      Tc = null;
      var h = hp(c), g = hf(h);
      if (g !== null) {
        var E = Xa(g);
        if (E === null)
          g = null;
        else {
          var _ = E.tag;
          if (_ === H) {
            var P = iy(E);
            if (P !== null)
              return P;
            g = null;
          } else if (_ === b) {
            var M = E.stateNode;
            if (br(M))
              return bp(E);
            g = null;
          } else
            E !== g && (g = null);
        }
      }
      return Tc = g, null;
    }
    function ma(n) {
      switch (n) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Xr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Nr;
        case "message": {
          var a = uy();
          switch (a) {
            case kp:
              return Xr;
            case ei:
              return Nr;
            case vo:
            case Ep:
              return ns;
            case Xs:
              return Jd;
            default:
              return ns;
          }
        }
        default:
          return ns;
      }
    }
    function Ay(n, a, u) {
      return n.addEventListener(a, u, !1), u;
    }
    function _c(n, a, u) {
      return n.addEventListener(a, u, !0), u;
    }
    function is(n, a, u, c) {
      return n.addEventListener(a, u, {
        capture: !0,
        passive: c
      }), u;
    }
    function eh(n, a, u, c) {
      return n.addEventListener(a, u, {
        passive: c
      }), u;
    }
    var ol = null, xo = null, su = null;
    function uu(n) {
      return ol = n, xo = nh(), !0;
    }
    function th() {
      ol = null, xo = null, su = null;
    }
    function Rc() {
      if (su)
        return su;
      var n, a = xo, u = a.length, c, h = nh(), g = h.length;
      for (n = 0; n < u && a[n] === h[n]; n++)
        ;
      var E = u - n;
      for (c = 1; c <= E && a[u - c] === h[g - c]; c++)
        ;
      var _ = c > 1 ? 1 - c : void 0;
      return su = h.slice(n, _), su;
    }
    function nh() {
      return "value" in ol ? ol.value : ol.textContent;
    }
    function sl(n) {
      var a, u = n.keyCode;
      return "charCode" in n ? (a = n.charCode, a === 0 && u === 13 && (a = 13)) : a = u, a === 10 && (a = 13), a >= 32 || a === 13 ? a : 0;
    }
    function ul() {
      return !0;
    }
    function ta() {
      return !1;
    }
    function hr(n) {
      function a(u, c, h, g, E) {
        this._reactName = u, this._targetInst = h, this.type = c, this.nativeEvent = g, this.target = E, this.currentTarget = null;
        for (var _ in n)
          if (n.hasOwnProperty(_)) {
            var P = n[_];
            P ? this[_] = P(g) : this[_] = g[_];
          }
        var M = g.defaultPrevented != null ? g.defaultPrevented : g.returnValue === !1;
        return M ? this.isDefaultPrevented = ul : this.isDefaultPrevented = ta, this.isPropagationStopped = ta, this;
      }
      return Nt(a.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = ul);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = ul);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: ul
      }), a;
    }
    var na = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(n) {
        return n.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, ra = hr(na), Oc = Nt({}, na, {
      view: 0,
      detail: 0
    }), Dy = hr(Oc), uf, Iy, _i;
    function kb(n) {
      n !== _i && (_i && n.type === "mousemove" ? (uf = n.screenX - _i.screenX, Iy = n.screenY - _i.screenY) : (uf = 0, Iy = 0), _i = n);
    }
    var Pc = Nt({}, Oc, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: ih,
      button: 0,
      buttons: 0,
      relatedTarget: function(n) {
        return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
      },
      movementX: function(n) {
        return "movementX" in n ? n.movementX : (kb(n), uf);
      },
      movementY: function(n) {
        return "movementY" in n ? n.movementY : Iy;
      }
    }), lu = hr(Pc), My = Nt({}, Pc, {
      dataTransfer: 0
    }), ll = hr(My), Eb = Nt({}, Oc, {
      relatedTarget: 0
    }), rh = hr(Eb), $y = Nt({}, na, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), ah = hr($y), n2 = Nt({}, na, {
      clipboardData: function(n) {
        return "clipboardData" in n ? n.clipboardData : window.clipboardData;
      }
    }), r2 = hr(n2), Cb = Nt({}, na, {
      data: 0
    }), Ly = hr(Cb), cl = Ly, a2 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, jc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Tb(n) {
      if (n.key) {
        var a = a2[n.key] || n.key;
        if (a !== "Unidentified")
          return a;
      }
      if (n.type === "keypress") {
        var u = sl(n);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return n.type === "keydown" || n.type === "keyup" ? jc[n.keyCode] || "Unidentified" : "";
    }
    var nr = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function i2(n) {
      var a = this, u = a.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(n);
      var c = nr[n];
      return c ? !!u[c] : !1;
    }
    function ih(n) {
      return i2;
    }
    var o2 = Nt({}, Oc, {
      key: Tb,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: ih,
      // Legacy Interface
      charCode: function(n) {
        return n.type === "keypress" ? sl(n) : 0;
      },
      keyCode: function(n) {
        return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      },
      which: function(n) {
        return n.type === "keypress" ? sl(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      }
    }), s2 = hr(o2), _b = Nt({}, Pc, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Ny = hr(_b), u2 = Nt({}, Oc, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: ih
    }), Ri = hr(u2), Fy = Nt({}, na, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), l2 = hr(Fy), cu = Nt({}, Pc, {
      deltaX: function(n) {
        return "deltaX" in n ? n.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in n ? -n.wheelDeltaX : 0
        );
      },
      deltaY: function(n) {
        return "deltaY" in n ? n.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in n ? -n.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in n ? -n.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), oh = hr(cu), dl = [9, 13, 27, 32], lf = 229, cf = Vt && "CompositionEvent" in window, fl = null;
    Vt && "documentMode" in document && (fl = document.documentMode);
    var c2 = Vt && "TextEvent" in window && !fl, sh = Vt && (!cf || fl && fl > 8 && fl <= 11), Rb = 32, zy = String.fromCharCode(Rb);
    function Ob() {
      rr("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), rr("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), rr("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), rr("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var df = !1;
    function uh(n) {
      return (n.ctrlKey || n.altKey || n.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(n.ctrlKey && n.altKey);
    }
    function Pb(n) {
      switch (n) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function By(n, a) {
      return n === "keydown" && a.keyCode === lf;
    }
    function jb(n, a) {
      switch (n) {
        case "keyup":
          return dl.indexOf(a.keyCode) !== -1;
        case "keydown":
          return a.keyCode !== lf;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Uy(n) {
      var a = n.detail;
      return typeof a == "object" && "data" in a ? a.data : null;
    }
    function lh(n) {
      return n.locale === "ko";
    }
    var os = !1;
    function Hy(n, a, u, c, h) {
      var g, E;
      if (cf ? g = Pb(a) : os ? jb(a, c) && (g = "onCompositionEnd") : By(a, c) && (g = "onCompositionStart"), !g)
        return null;
      sh && !lh(c) && (!os && g === "onCompositionStart" ? os = uu(h) : g === "onCompositionEnd" && os && (E = Rc()));
      var _ = $b(u, g);
      if (_.length > 0) {
        var P = new Ly(g, a, null, c, h);
        if (n.push({
          event: P,
          listeners: _
        }), E)
          P.data = E;
        else {
          var M = Uy(c);
          M !== null && (P.data = M);
        }
      }
    }
    function ch(n, a) {
      switch (n) {
        case "compositionend":
          return Uy(a);
        case "keypress":
          var u = a.which;
          return u !== Rb ? null : (df = !0, zy);
        case "textInput":
          var c = a.data;
          return c === zy && df ? null : c;
        default:
          return null;
      }
    }
    function Ab(n, a) {
      if (os) {
        if (n === "compositionend" || !cf && jb(n, a)) {
          var u = Rc();
          return th(), os = !1, u;
        }
        return null;
      }
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!uh(a)) {
            if (a.char && a.char.length > 1)
              return a.char;
            if (a.which)
              return String.fromCharCode(a.which);
          }
          return null;
        case "compositionend":
          return sh && !lh(a) ? null : a.data;
        default:
          return null;
      }
    }
    function d2(n, a, u, c, h) {
      var g;
      if (c2 ? g = ch(a, c) : g = Ab(a, c), !g)
        return null;
      var E = $b(u, "onBeforeInput");
      if (E.length > 0) {
        var _ = new cl("onBeforeInput", "beforeinput", null, c, h);
        n.push({
          event: _,
          listeners: E
        }), _.data = g;
      }
    }
    function dh(n, a, u, c, h, g, E) {
      Hy(n, a, u, c, h), d2(n, a, u, c, h);
    }
    var f2 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Ac(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a === "input" ? !!f2[n.type] : a === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function p2(n) {
      if (!Vt)
        return !1;
      var a = "on" + n, u = a in document;
      if (!u) {
        var c = document.createElement("div");
        c.setAttribute(a, "return;"), u = typeof c[a] == "function";
      }
      return u;
    }
    function fh() {
      rr("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function i(n, a, u, c) {
      mp(c);
      var h = $b(a, "onChange");
      if (h.length > 0) {
        var g = new ra("onChange", "change", null, u, c);
        n.push({
          event: g,
          listeners: h
        });
      }
    }
    var s = null, p = null;
    function y(n) {
      var a = n.nodeName && n.nodeName.toLowerCase();
      return a === "select" || a === "input" && n.type === "file";
    }
    function S(n) {
      var a = [];
      i(a, p, n, hp(n)), Qm(C, a);
    }
    function C(n) {
      f6(n, 0);
    }
    function D(n) {
      var a = gh(n);
      if (tc(a))
        return n;
    }
    function U(n, a) {
      if (n === "change")
        return a;
    }
    var Z = !1;
    Vt && (Z = p2("input") && (!document.documentMode || document.documentMode > 9));
    function ue(n, a) {
      s = n, p = a, s.attachEvent("onpropertychange", Oe);
    }
    function _e() {
      s && (s.detachEvent("onpropertychange", Oe), s = null, p = null);
    }
    function Oe(n) {
      n.propertyName === "value" && D(p) && S(n);
    }
    function Te(n, a, u) {
      n === "focusin" ? (_e(), ue(a, u)) : n === "focusout" && _e();
    }
    function Ue(n, a) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown")
        return D(p);
    }
    function Je(n) {
      var a = n.nodeName;
      return a && a.toLowerCase() === "input" && (n.type === "checkbox" || n.type === "radio");
    }
    function nt(n, a) {
      if (n === "click")
        return D(a);
    }
    function sr(n, a) {
      if (n === "input" || n === "change")
        return D(a);
    }
    function J(n) {
      var a = n._wrapperState;
      !a || !a.controlled || n.type !== "number" || ht(n, "number", n.value);
    }
    function Q(n, a, u, c, h, g, E) {
      var _ = u ? gh(u) : window, P, M;
      if (y(_) ? P = U : Ac(_) ? Z ? P = sr : (P = Ue, M = Te) : Je(_) && (P = nt), P) {
        var F = P(a, u);
        if (F) {
          i(n, F, c, h);
          return;
        }
      }
      M && M(a, _, u), a === "focusout" && J(_);
    }
    function ne() {
      Hn("onMouseEnter", ["mouseout", "mouseover"]), Hn("onMouseLeave", ["mouseout", "mouseover"]), Hn("onPointerEnter", ["pointerout", "pointerover"]), Hn("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Ie(n, a, u, c, h, g, E) {
      var _ = a === "mouseover" || a === "pointerover", P = a === "mouseout" || a === "pointerout";
      if (_ && !Z0(c)) {
        var M = c.relatedTarget || c.fromElement;
        if (M && (hf(M) || rv(M)))
          return;
      }
      if (!(!P && !_)) {
        var F;
        if (h.window === h)
          F = h;
        else {
          var X = h.ownerDocument;
          X ? F = X.defaultView || X.parentWindow : F = window;
        }
        var K, re;
        if (P) {
          var ie = c.relatedTarget || c.toElement;
          if (K = u, re = ie ? hf(ie) : null, re !== null) {
            var me = Xa(re);
            (re !== me || re.tag !== T && re.tag !== O) && (re = null);
          }
        } else
          K = null, re = u;
        if (K !== re) {
          var qe = lu, ft = "onMouseLeave", it = "onMouseEnter", Qt = "mouse";
          (a === "pointerout" || a === "pointerover") && (qe = Ny, ft = "onPointerLeave", it = "onPointerEnter", Qt = "pointer");
          var qt = K == null ? F : gh(K), ee = re == null ? F : gh(re), ye = new qe(ft, Qt + "leave", K, c, h);
          ye.target = qt, ye.relatedTarget = ee;
          var te = null, je = hf(h);
          if (je === u) {
            var We = new qe(it, Qt + "enter", re, c, h);
            We.target = ee, We.relatedTarget = qt, te = We;
          }
          i7(n, ye, te, K, re);
        }
      }
    }
    function rt(n, a) {
      return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
    }
    var et = typeof Object.is == "function" ? Object.is : rt;
    function st(n, a) {
      if (et(n, a))
        return !0;
      if (typeof n != "object" || n === null || typeof a != "object" || a === null)
        return !1;
      var u = Object.keys(n), c = Object.keys(a);
      if (u.length !== c.length)
        return !1;
      for (var h = 0; h < u.length; h++) {
        var g = u[h];
        if (!xn.call(a, g) || !et(n[g], a[g]))
          return !1;
      }
      return !0;
    }
    function Ct(n) {
      for (; n && n.firstChild; )
        n = n.firstChild;
      return n;
    }
    function Ar(n) {
      for (; n; ) {
        if (n.nextSibling)
          return n.nextSibling;
        n = n.parentNode;
      }
    }
    function nn(n, a) {
      for (var u = Ct(n), c = 0, h = 0; u; ) {
        if (u.nodeType === Wo) {
          if (h = c + u.textContent.length, c <= a && h >= a)
            return {
              node: u,
              offset: a - c
            };
          c = h;
        }
        u = Ct(Ar(u));
      }
    }
    function du(n) {
      var a = n.ownerDocument, u = a && a.defaultView || window, c = u.getSelection && u.getSelection();
      if (!c || c.rangeCount === 0)
        return null;
      var h = c.anchorNode, g = c.anchorOffset, E = c.focusNode, _ = c.focusOffset;
      try {
        h.nodeType, E.nodeType;
      } catch {
        return null;
      }
      return h2(n, h, g, E, _);
    }
    function h2(n, a, u, c, h) {
      var g = 0, E = -1, _ = -1, P = 0, M = 0, F = n, X = null;
      e:
        for (; ; ) {
          for (var K = null; F === a && (u === 0 || F.nodeType === Wo) && (E = g + u), F === c && (h === 0 || F.nodeType === Wo) && (_ = g + h), F.nodeType === Wo && (g += F.nodeValue.length), (K = F.firstChild) !== null; )
            X = F, F = K;
          for (; ; ) {
            if (F === n)
              break e;
            if (X === a && ++P === u && (E = g), X === c && ++M === h && (_ = g), (K = F.nextSibling) !== null)
              break;
            F = X, X = F.parentNode;
          }
          F = K;
        }
      return E === -1 || _ === -1 ? null : {
        start: E,
        end: _
      };
    }
    function zI(n, a) {
      var u = n.ownerDocument || document, c = u && u.defaultView || window;
      if (c.getSelection) {
        var h = c.getSelection(), g = n.textContent.length, E = Math.min(a.start, g), _ = a.end === void 0 ? E : Math.min(a.end, g);
        if (!h.extend && E > _) {
          var P = _;
          _ = E, E = P;
        }
        var M = nn(n, E), F = nn(n, _);
        if (M && F) {
          if (h.rangeCount === 1 && h.anchorNode === M.node && h.anchorOffset === M.offset && h.focusNode === F.node && h.focusOffset === F.offset)
            return;
          var X = u.createRange();
          X.setStart(M.node, M.offset), h.removeAllRanges(), E > _ ? (h.addRange(X), h.extend(F.node, F.offset)) : (X.setEnd(F.node, F.offset), h.addRange(X));
        }
      }
    }
    function e6(n) {
      return n && n.nodeType === Wo;
    }
    function t6(n, a) {
      return !n || !a ? !1 : n === a ? !0 : e6(n) ? !1 : e6(a) ? t6(n, a.parentNode) : "contains" in n ? n.contains(a) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(a) & 16) : !1;
    }
    function BI(n) {
      return n && n.ownerDocument && t6(n.ownerDocument.documentElement, n);
    }
    function UI(n) {
      try {
        return typeof n.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function n6() {
      for (var n = window, a = Vs(); a instanceof n.HTMLIFrameElement; ) {
        if (UI(a))
          n = a.contentWindow;
        else
          return a;
        a = Vs(n.document);
      }
      return a;
    }
    function m2(n) {
      var a = n && n.nodeName && n.nodeName.toLowerCase();
      return a && (a === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || a === "textarea" || n.contentEditable === "true");
    }
    function HI() {
      var n = n6();
      return {
        focusedElem: n,
        selectionRange: m2(n) ? GI(n) : null
      };
    }
    function VI(n) {
      var a = n6(), u = n.focusedElem, c = n.selectionRange;
      if (a !== u && BI(u)) {
        c !== null && m2(u) && qI(u, c);
        for (var h = [], g = u; g = g.parentNode; )
          g.nodeType === Pa && h.push({
            element: g,
            left: g.scrollLeft,
            top: g.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var E = 0; E < h.length; E++) {
          var _ = h[E];
          _.element.scrollLeft = _.left, _.element.scrollTop = _.top;
        }
      }
    }
    function GI(n) {
      var a;
      return "selectionStart" in n ? a = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : a = du(n), a || {
        start: 0,
        end: 0
      };
    }
    function qI(n, a) {
      var u = a.start, c = a.end;
      c === void 0 && (c = u), "selectionStart" in n ? (n.selectionStart = u, n.selectionEnd = Math.min(c, n.value.length)) : zI(n, a);
    }
    var WI = Vt && "documentMode" in document && document.documentMode <= 11;
    function YI() {
      rr("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var ph = null, y2 = null, Vy = null, v2 = !1;
    function ZI(n) {
      if ("selectionStart" in n && m2(n))
        return {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      var a = n.ownerDocument && n.ownerDocument.defaultView || window, u = a.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function KI(n) {
      return n.window === n ? n.document : n.nodeType === qi ? n : n.ownerDocument;
    }
    function r6(n, a, u) {
      var c = KI(u);
      if (!(v2 || ph == null || ph !== Vs(c))) {
        var h = ZI(ph);
        if (!Vy || !st(Vy, h)) {
          Vy = h;
          var g = $b(y2, "onSelect");
          if (g.length > 0) {
            var E = new ra("onSelect", "select", null, a, u);
            n.push({
              event: E,
              listeners: g
            }), E.target = ph;
          }
        }
      }
    }
    function QI(n, a, u, c, h, g, E) {
      var _ = u ? gh(u) : window;
      switch (a) {
        case "focusin":
          (Ac(_) || _.contentEditable === "true") && (ph = _, y2 = u, Vy = null);
          break;
        case "focusout":
          ph = null, y2 = null, Vy = null;
          break;
        case "mousedown":
          v2 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          v2 = !1, r6(n, c, h);
          break;
        case "selectionchange":
          if (WI)
            break;
        case "keydown":
        case "keyup":
          r6(n, c, h);
      }
    }
    function Db(n, a) {
      var u = {};
      return u[n.toLowerCase()] = a.toLowerCase(), u["Webkit" + n] = "webkit" + a, u["Moz" + n] = "moz" + a, u;
    }
    var hh = {
      animationend: Db("Animation", "AnimationEnd"),
      animationiteration: Db("Animation", "AnimationIteration"),
      animationstart: Db("Animation", "AnimationStart"),
      transitionend: Db("Transition", "TransitionEnd")
    }, g2 = {}, a6 = {};
    Vt && (a6 = document.createElement("div").style, "AnimationEvent" in window || (delete hh.animationend.animation, delete hh.animationiteration.animation, delete hh.animationstart.animation), "TransitionEvent" in window || delete hh.transitionend.transition);
    function Ib(n) {
      if (g2[n])
        return g2[n];
      if (!hh[n])
        return n;
      var a = hh[n];
      for (var u in a)
        if (a.hasOwnProperty(u) && u in a6)
          return g2[n] = a[u];
      return n;
    }
    var i6 = Ib("animationend"), o6 = Ib("animationiteration"), s6 = Ib("animationstart"), u6 = Ib("transitionend"), l6 = /* @__PURE__ */ new Map(), c6 = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Dc(n, a) {
      l6.set(n, a), rr(a, [n]);
    }
    function XI() {
      for (var n = 0; n < c6.length; n++) {
        var a = c6[n], u = a.toLowerCase(), c = a[0].toUpperCase() + a.slice(1);
        Dc(u, "on" + c);
      }
      Dc(i6, "onAnimationEnd"), Dc(o6, "onAnimationIteration"), Dc(s6, "onAnimationStart"), Dc("dblclick", "onDoubleClick"), Dc("focusin", "onFocus"), Dc("focusout", "onBlur"), Dc(u6, "onTransitionEnd");
    }
    function JI(n, a, u, c, h, g, E) {
      var _ = l6.get(a);
      if (_ !== void 0) {
        var P = ra, M = a;
        switch (a) {
          case "keypress":
            if (sl(c) === 0)
              return;
          case "keydown":
          case "keyup":
            P = s2;
            break;
          case "focusin":
            M = "focus", P = rh;
            break;
          case "focusout":
            M = "blur", P = rh;
            break;
          case "beforeblur":
          case "afterblur":
            P = rh;
            break;
          case "click":
            if (c.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            P = lu;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            P = ll;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            P = Ri;
            break;
          case i6:
          case o6:
          case s6:
            P = ah;
            break;
          case u6:
            P = l2;
            break;
          case "scroll":
            P = Dy;
            break;
          case "wheel":
            P = oh;
            break;
          case "copy":
          case "cut":
          case "paste":
            P = r2;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            P = Ny;
            break;
        }
        var F = (g & Bu) !== 0;
        {
          var X = !F && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          a === "scroll", K = r7(u, _, c.type, F, X);
          if (K.length > 0) {
            var re = new P(_, M, null, c, h);
            n.push({
              event: re,
              listeners: K
            });
          }
        }
      }
    }
    XI(), ne(), fh(), YI(), Ob();
    function e7(n, a, u, c, h, g, E) {
      JI(n, a, u, c, h, g);
      var _ = (g & Vx) === 0;
      _ && (Ie(n, a, u, c, h), Q(n, a, u, c, h), QI(n, a, u, c, h), dh(n, a, u, c, h));
    }
    var Gy = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], b2 = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Gy));
    function d6(n, a, u) {
      var c = n.type || "unknown-event";
      n.currentTarget = u, Qo(c, a, void 0, n), n.currentTarget = null;
    }
    function t7(n, a, u) {
      var c;
      if (u)
        for (var h = a.length - 1; h >= 0; h--) {
          var g = a[h], E = g.instance, _ = g.currentTarget, P = g.listener;
          if (E !== c && n.isPropagationStopped())
            return;
          d6(n, P, _), c = E;
        }
      else
        for (var M = 0; M < a.length; M++) {
          var F = a[M], X = F.instance, K = F.currentTarget, re = F.listener;
          if (X !== c && n.isPropagationStopped())
            return;
          d6(n, re, K), c = X;
        }
    }
    function f6(n, a) {
      for (var u = (a & Bu) !== 0, c = 0; c < n.length; c++) {
        var h = n[c], g = h.event, E = h.listeners;
        t7(g, E, u);
      }
      ty();
    }
    function n7(n, a, u, c, h) {
      var g = hp(u), E = [];
      e7(E, n, c, u, g, a), f6(E, a);
    }
    function Qn(n, a) {
      b2.has(n) || f('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', n);
      var u = !1, c = AM(a), h = o7(n, u);
      c.has(h) || (p6(a, n, Md, u), c.add(h));
    }
    function w2(n, a, u) {
      b2.has(n) && !a && f('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', n);
      var c = 0;
      a && (c |= Bu), p6(u, n, c, a);
    }
    var Mb = "_reactListening" + Math.random().toString(36).slice(2);
    function qy(n) {
      if (!n[Mb]) {
        n[Mb] = !0, wt.forEach(function(u) {
          u !== "selectionchange" && (b2.has(u) || w2(u, !1, n), w2(u, !0, n));
        });
        var a = n.nodeType === qi ? n : n.ownerDocument;
        a !== null && (a[Mb] || (a[Mb] = !0, w2("selectionchange", !1, a)));
      }
    }
    function p6(n, a, u, c, h) {
      var g = Cc(n, a, u), E = void 0;
      zd && (a === "touchstart" || a === "touchmove" || a === "wheel") && (E = !0), n = n, c ? E !== void 0 ? is(n, a, g, E) : _c(n, a, g) : E !== void 0 ? eh(n, a, g, E) : Ay(n, a, g);
    }
    function h6(n, a) {
      return n === a || n.nodeType === fr && n.parentNode === a;
    }
    function x2(n, a, u, c, h) {
      var g = c;
      if (!(a & Zo) && !(a & Md)) {
        var E = h;
        if (c !== null) {
          var _ = c;
          e:
            for (; ; ) {
              if (_ === null)
                return;
              var P = _.tag;
              if (P === b || P === k) {
                var M = _.stateNode.containerInfo;
                if (h6(M, E))
                  break;
                if (P === k)
                  for (var F = _.return; F !== null; ) {
                    var X = F.tag;
                    if (X === b || X === k) {
                      var K = F.stateNode.containerInfo;
                      if (h6(K, E))
                        return;
                    }
                    F = F.return;
                  }
                for (; M !== null; ) {
                  var re = hf(M);
                  if (re === null)
                    return;
                  var ie = re.tag;
                  if (ie === T || ie === O) {
                    _ = g = re;
                    continue e;
                  }
                  M = M.parentNode;
                }
              }
              _ = _.return;
            }
        }
      }
      Qm(function() {
        return n7(n, a, u, g);
      });
    }
    function Wy(n, a, u) {
      return {
        instance: n,
        listener: a,
        currentTarget: u
      };
    }
    function r7(n, a, u, c, h, g) {
      for (var E = a !== null ? a + "Capture" : null, _ = c ? E : a, P = [], M = n, F = null; M !== null; ) {
        var X = M, K = X.stateNode, re = X.tag;
        if (re === T && K !== null && (F = K, _ !== null)) {
          var ie = Hu(M, _);
          ie != null && P.push(Wy(M, ie, F));
        }
        if (h)
          break;
        M = M.return;
      }
      return P;
    }
    function $b(n, a) {
      for (var u = a + "Capture", c = [], h = n; h !== null; ) {
        var g = h, E = g.stateNode, _ = g.tag;
        if (_ === T && E !== null) {
          var P = E, M = Hu(h, u);
          M != null && c.unshift(Wy(h, M, P));
          var F = Hu(h, a);
          F != null && c.push(Wy(h, F, P));
        }
        h = h.return;
      }
      return c;
    }
    function mh(n) {
      if (n === null)
        return null;
      do
        n = n.return;
      while (n && n.tag !== T);
      return n || null;
    }
    function a7(n, a) {
      for (var u = n, c = a, h = 0, g = u; g; g = mh(g))
        h++;
      for (var E = 0, _ = c; _; _ = mh(_))
        E++;
      for (; h - E > 0; )
        u = mh(u), h--;
      for (; E - h > 0; )
        c = mh(c), E--;
      for (var P = h; P--; ) {
        if (u === c || c !== null && u === c.alternate)
          return u;
        u = mh(u), c = mh(c);
      }
      return null;
    }
    function m6(n, a, u, c, h) {
      for (var g = a._reactName, E = [], _ = u; _ !== null && _ !== c; ) {
        var P = _, M = P.alternate, F = P.stateNode, X = P.tag;
        if (M !== null && M === c)
          break;
        if (X === T && F !== null) {
          var K = F;
          if (h) {
            var re = Hu(_, g);
            re != null && E.unshift(Wy(_, re, K));
          } else if (!h) {
            var ie = Hu(_, g);
            ie != null && E.push(Wy(_, ie, K));
          }
        }
        _ = _.return;
      }
      E.length !== 0 && n.push({
        event: a,
        listeners: E
      });
    }
    function i7(n, a, u, c, h) {
      var g = c && h ? a7(c, h) : null;
      c !== null && m6(n, a, c, g, !1), h !== null && u !== null && m6(n, u, h, g, !0);
    }
    function o7(n, a) {
      return n + "__" + (a ? "capture" : "bubble");
    }
    var Oi = !1, Yy = "dangerouslySetInnerHTML", Lb = "suppressContentEditableWarning", Ic = "suppressHydrationWarning", y6 = "autoFocus", ff = "children", pf = "style", Nb = "__html", S2, Fb, Zy, v6, zb, g6, b6;
    S2 = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Fb = function(n, a) {
      pp(n, a), qm(n, a), Y0(n, a, {
        registrationNameDependencies: pt,
        possibleRegistrationNames: Rn
      });
    }, g6 = Vt && !document.documentMode, Zy = function(n, a, u) {
      if (!Oi) {
        var c = Bb(u), h = Bb(a);
        h !== c && (Oi = !0, f("Prop `%s` did not match. Server: %s Client: %s", n, JSON.stringify(h), JSON.stringify(c)));
      }
    }, v6 = function(n) {
      if (!Oi) {
        Oi = !0;
        var a = [];
        n.forEach(function(u) {
          a.push(u);
        }), f("Extra attributes from the server: %s", a);
      }
    }, zb = function(n, a) {
      a === !1 ? f("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, n, n) : f("Expected `%s` listener to be a function, instead got a value of `%s` type.", n, typeof a);
    }, b6 = function(n, a) {
      var u = n.namespaceURI === qo ? n.ownerDocument.createElement(n.tagName) : n.ownerDocument.createElementNS(n.namespaceURI, n.tagName);
      return u.innerHTML = a, u.innerHTML;
    };
    var s7 = /\r\n?/g, u7 = /\u0000|\uFFFD/g;
    function Bb(n) {
      Ca(n);
      var a = typeof n == "string" ? n : "" + n;
      return a.replace(s7, `
`).replace(u7, "");
    }
    function Ub(n, a, u, c) {
      var h = Bb(a), g = Bb(n);
      if (g !== h && (c && (Oi || (Oi = !0, f('Text content did not match. Server: "%s" Client: "%s"', g, h))), u && de))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function w6(n) {
      return n.nodeType === qi ? n : n.ownerDocument;
    }
    function l7() {
    }
    function Hb(n) {
      n.onclick = l7;
    }
    function c7(n, a, u, c, h) {
      for (var g in c)
        if (c.hasOwnProperty(g)) {
          var E = c[g];
          if (g === pf)
            E && Object.freeze(E), N0(a, E);
          else if (g === Yy) {
            var _ = E ? E[Nb] : void 0;
            _ != null && _0(a, _);
          } else if (g === ff)
            if (typeof E == "string") {
              var P = n !== "textarea" || E !== "";
              P && lp(a, E);
            } else
              typeof E == "number" && lp(a, "" + E);
          else
            g === Lb || g === Ic || g === y6 || (pt.hasOwnProperty(g) ? E != null && (typeof E != "function" && zb(g, E), g === "onScroll" && Qn("scroll", a)) : E != null && Za(a, g, E, h));
        }
    }
    function d7(n, a, u, c) {
      for (var h = 0; h < a.length; h += 2) {
        var g = a[h], E = a[h + 1];
        g === pf ? N0(n, E) : g === Yy ? _0(n, E) : g === ff ? lp(n, E) : Za(n, g, E, c);
      }
    }
    function f7(n, a, u, c) {
      var h, g = w6(u), E, _ = c;
      if (_ === qo && (_ = sp(n)), _ === qo) {
        if (h = Yo(n, a), !h && n !== n.toLowerCase() && f("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", n), n === "script") {
          var P = g.createElement("div");
          P.innerHTML = "<script><\/script>";
          var M = P.firstChild;
          E = P.removeChild(M);
        } else if (typeof a.is == "string")
          E = g.createElement(n, {
            is: a.is
          });
        else if (E = g.createElement(n), n === "select") {
          var F = E;
          a.multiple ? F.multiple = !0 : a.size && (F.size = a.size);
        }
      } else
        E = g.createElementNS(_, n);
      return _ === qo && !h && Object.prototype.toString.call(E) === "[object HTMLUnknownElement]" && !xn.call(S2, n) && (S2[n] = !0, f("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", n)), E;
    }
    function p7(n, a) {
      return w6(a).createTextNode(n);
    }
    function h7(n, a, u, c) {
      var h = Yo(a, u);
      Fb(a, u);
      var g;
      switch (a) {
        case "dialog":
          Qn("cancel", n), Qn("close", n), g = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          Qn("load", n), g = u;
          break;
        case "video":
        case "audio":
          for (var E = 0; E < Gy.length; E++)
            Qn(Gy[E], n);
          g = u;
          break;
        case "source":
          Qn("error", n), g = u;
          break;
        case "img":
        case "image":
        case "link":
          Qn("error", n), Qn("load", n), g = u;
          break;
        case "details":
          Qn("toggle", n), g = u;
          break;
        case "input":
          G(n, u), g = A(n, u), Qn("invalid", n);
          break;
        case "option":
          vn(n, u), g = u;
          break;
        case "select":
          jd(n, u), g = Pd(n, u), Qn("invalid", n);
          break;
        case "textarea":
          E0(n, u), g = Lm(n, u), Qn("invalid", n);
          break;
        default:
          g = u;
      }
      switch (dp(a, g), c7(a, n, c, g, h), a) {
        case "input":
          yi(n), Ae(n, u, !1);
          break;
        case "textarea":
          yi(n), T0(n);
          break;
        case "option":
          kn(n, u);
          break;
        case "select":
          Mm(n, u);
          break;
        default:
          typeof g.onClick == "function" && Hb(n);
          break;
      }
    }
    function m7(n, a, u, c, h) {
      Fb(a, c);
      var g = null, E, _;
      switch (a) {
        case "input":
          E = A(n, u), _ = A(n, c), g = [];
          break;
        case "select":
          E = Pd(n, u), _ = Pd(n, c), g = [];
          break;
        case "textarea":
          E = Lm(n, u), _ = Lm(n, c), g = [];
          break;
        default:
          E = u, _ = c, typeof E.onClick != "function" && typeof _.onClick == "function" && Hb(n);
          break;
      }
      dp(a, _);
      var P, M, F = null;
      for (P in E)
        if (!(_.hasOwnProperty(P) || !E.hasOwnProperty(P) || E[P] == null))
          if (P === pf) {
            var X = E[P];
            for (M in X)
              X.hasOwnProperty(M) && (F || (F = {}), F[M] = "");
          } else
            P === Yy || P === ff || P === Lb || P === Ic || P === y6 || (pt.hasOwnProperty(P) ? g || (g = []) : (g = g || []).push(P, null));
      for (P in _) {
        var K = _[P], re = E != null ? E[P] : void 0;
        if (!(!_.hasOwnProperty(P) || K === re || K == null && re == null))
          if (P === pf)
            if (K && Object.freeze(K), re) {
              for (M in re)
                re.hasOwnProperty(M) && (!K || !K.hasOwnProperty(M)) && (F || (F = {}), F[M] = "");
              for (M in K)
                K.hasOwnProperty(M) && re[M] !== K[M] && (F || (F = {}), F[M] = K[M]);
            } else
              F || (g || (g = []), g.push(P, F)), F = K;
          else if (P === Yy) {
            var ie = K ? K[Nb] : void 0, me = re ? re[Nb] : void 0;
            ie != null && me !== ie && (g = g || []).push(P, ie);
          } else
            P === ff ? (typeof K == "string" || typeof K == "number") && (g = g || []).push(P, "" + K) : P === Lb || P === Ic || (pt.hasOwnProperty(P) ? (K != null && (typeof K != "function" && zb(P, K), P === "onScroll" && Qn("scroll", n)), !g && re !== K && (g = [])) : (g = g || []).push(P, K));
      }
      return F && (Dd(F, _[pf]), (g = g || []).push(pf, F)), g;
    }
    function y7(n, a, u, c, h) {
      u === "input" && h.type === "radio" && h.name != null && ae(n, h);
      var g = Yo(u, c), E = Yo(u, h);
      switch (d7(n, a, g, E), u) {
        case "input":
          he(n, h);
          break;
        case "textarea":
          C0(n, h);
          break;
        case "select":
          Ix(n, h);
          break;
      }
    }
    function v7(n) {
      {
        var a = n.toLowerCase();
        return fp.hasOwnProperty(a) && fp[a] || null;
      }
    }
    function g7(n, a, u, c, h, g, E) {
      var _, P;
      switch (_ = Yo(a, u), Fb(a, u), a) {
        case "dialog":
          Qn("cancel", n), Qn("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Qn("load", n);
          break;
        case "video":
        case "audio":
          for (var M = 0; M < Gy.length; M++)
            Qn(Gy[M], n);
          break;
        case "source":
          Qn("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Qn("error", n), Qn("load", n);
          break;
        case "details":
          Qn("toggle", n);
          break;
        case "input":
          G(n, u), Qn("invalid", n);
          break;
        case "option":
          vn(n, u);
          break;
        case "select":
          jd(n, u), Qn("invalid", n);
          break;
        case "textarea":
          E0(n, u), Qn("invalid", n);
          break;
      }
      dp(a, u);
      {
        P = /* @__PURE__ */ new Set();
        for (var F = n.attributes, X = 0; X < F.length; X++) {
          var K = F[X].name.toLowerCase();
          switch (K) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              P.add(F[X].name);
          }
        }
      }
      var re = null;
      for (var ie in u)
        if (u.hasOwnProperty(ie)) {
          var me = u[ie];
          if (ie === ff)
            typeof me == "string" ? n.textContent !== me && (u[Ic] !== !0 && Ub(n.textContent, me, g, E), re = [ff, me]) : typeof me == "number" && n.textContent !== "" + me && (u[Ic] !== !0 && Ub(n.textContent, me, g, E), re = [ff, "" + me]);
          else if (pt.hasOwnProperty(ie))
            me != null && (typeof me != "function" && zb(ie, me), ie === "onScroll" && Qn("scroll", n));
          else if (E && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof _ == "boolean") {
            var qe = void 0, ft = _ && Qe ? null : ca(ie);
            if (u[Ic] !== !0) {
              if (!(ie === Lb || ie === Ic || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              ie === "value" || ie === "checked" || ie === "selected")) {
                if (ie === Yy) {
                  var it = n.innerHTML, Qt = me ? me[Nb] : void 0;
                  if (Qt != null) {
                    var qt = b6(n, Qt);
                    qt !== it && Zy(ie, it, qt);
                  }
                } else if (ie === pf) {
                  if (P.delete(ie), g6) {
                    var ee = Ux(me);
                    qe = n.getAttribute("style"), ee !== qe && Zy(ie, qe, ee);
                  }
                } else if (_ && !Qe)
                  P.delete(ie.toLowerCase()), qe = so(n, ie, me), me !== qe && Zy(ie, qe, me);
                else if (!qn(ie, ft, _) && !yn(ie, me, ft, _)) {
                  var ye = !1;
                  if (ft !== null)
                    P.delete(ft.attributeName), qe = Ya(n, ie, me, ft);
                  else {
                    var te = c;
                    if (te === qo && (te = sp(a)), te === qo)
                      P.delete(ie.toLowerCase());
                    else {
                      var je = v7(ie);
                      je !== null && je !== ie && (ye = !0, P.delete(je)), P.delete(ie);
                    }
                    qe = so(n, ie, me);
                  }
                  var We = Qe;
                  !We && me !== qe && !ye && Zy(ie, qe, me);
                }
              }
            }
          }
        }
      switch (E && // $FlowFixMe - Should be inferred as not undefined.
      P.size > 0 && u[Ic] !== !0 && v6(P), a) {
        case "input":
          yi(n), Ae(n, u, !0);
          break;
        case "textarea":
          yi(n), T0(n);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && Hb(n);
          break;
      }
      return re;
    }
    function b7(n, a, u) {
      var c = n.nodeValue !== a;
      return c;
    }
    function k2(n, a) {
      {
        if (Oi)
          return;
        Oi = !0, f("Did not expect server HTML to contain a <%s> in <%s>.", a.nodeName.toLowerCase(), n.nodeName.toLowerCase());
      }
    }
    function E2(n, a) {
      {
        if (Oi)
          return;
        Oi = !0, f('Did not expect server HTML to contain the text node "%s" in <%s>.', a.nodeValue, n.nodeName.toLowerCase());
      }
    }
    function C2(n, a, u) {
      {
        if (Oi)
          return;
        Oi = !0, f("Expected server HTML to contain a matching <%s> in <%s>.", a, n.nodeName.toLowerCase());
      }
    }
    function T2(n, a) {
      {
        if (a === "" || Oi)
          return;
        Oi = !0, f('Expected server HTML to contain a matching text node for "%s" in <%s>.', a, n.nodeName.toLowerCase());
      }
    }
    function w7(n, a, u) {
      switch (a) {
        case "input":
          yt(n, u);
          return;
        case "textarea":
          Nm(n, u);
          return;
        case "select":
          Mx(n, u);
          return;
      }
    }
    var Ky = function() {
    }, Qy = function() {
    };
    {
      var x7 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], x6 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], S7 = x6.concat(["button"]), k7 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], S6 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Qy = function(n, a) {
        var u = Nt({}, n || S6), c = {
          tag: a
        };
        return x6.indexOf(a) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), S7.indexOf(a) !== -1 && (u.pTagInButtonScope = null), x7.indexOf(a) !== -1 && a !== "address" && a !== "div" && a !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = c, a === "form" && (u.formTag = c), a === "a" && (u.aTagInScope = c), a === "button" && (u.buttonTagInScope = c), a === "nobr" && (u.nobrTagInScope = c), a === "p" && (u.pTagInButtonScope = c), a === "li" && (u.listItemTagAutoclosing = c), (a === "dd" || a === "dt") && (u.dlItemTagAutoclosing = c), u;
      };
      var E7 = function(n, a) {
        switch (a) {
          case "select":
            return n === "option" || n === "optgroup" || n === "#text";
          case "optgroup":
            return n === "option" || n === "#text";
          case "option":
            return n === "#text";
          case "tr":
            return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return n === "tr" || n === "style" || n === "script" || n === "template";
          case "colgroup":
            return n === "col" || n === "template";
          case "table":
            return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
          case "head":
            return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
          case "html":
            return n === "head" || n === "body" || n === "frameset";
          case "frameset":
            return n === "frame";
          case "#document":
            return n === "html";
        }
        switch (n) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a !== "h1" && a !== "h2" && a !== "h3" && a !== "h4" && a !== "h5" && a !== "h6";
          case "rp":
          case "rt":
            return k7.indexOf(a) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return a == null;
        }
        return !0;
      }, C7 = function(n, a) {
        switch (n) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return a.pTagInButtonScope;
          case "form":
            return a.formTag || a.pTagInButtonScope;
          case "li":
            return a.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return a.dlItemTagAutoclosing;
          case "button":
            return a.buttonTagInScope;
          case "a":
            return a.aTagInScope;
          case "nobr":
            return a.nobrTagInScope;
        }
        return null;
      }, k6 = {};
      Ky = function(n, a, u) {
        u = u || S6;
        var c = u.current, h = c && c.tag;
        a != null && (n != null && f("validateDOMNesting: when childText is passed, childTag should be null"), n = "#text");
        var g = E7(n, h) ? null : c, E = g ? null : C7(n, u), _ = g || E;
        if (_) {
          var P = _.tag, M = !!g + "|" + n + "|" + P;
          if (!k6[M]) {
            k6[M] = !0;
            var F = n, X = "";
            if (n === "#text" ? /\S/.test(a) ? F = "Text nodes" : (F = "Whitespace text nodes", X = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : F = "<" + n + ">", g) {
              var K = "";
              P === "table" && n === "tr" && (K += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), f("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", F, P, X, K);
            } else
              f("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", F, P);
          }
        }
      };
    }
    var Vb = "suppressHydrationWarning", Gb = "$", qb = "/$", Xy = "$?", Jy = "$!", T7 = "style", _2 = null, R2 = null;
    function _7(n) {
      var a, u, c = n.nodeType;
      switch (c) {
        case qi:
        case Fu: {
          a = c === qi ? "#document" : "#fragment";
          var h = n.documentElement;
          u = h ? h.namespaceURI : zm(null, "");
          break;
        }
        default: {
          var g = c === fr ? n.parentNode : n, E = g.namespaceURI || null;
          a = g.tagName, u = zm(E, a);
          break;
        }
      }
      {
        var _ = a.toLowerCase(), P = Qy(null, _);
        return {
          namespace: u,
          ancestorInfo: P
        };
      }
    }
    function R7(n, a, u) {
      {
        var c = n, h = zm(c.namespace, a), g = Qy(c.ancestorInfo, a);
        return {
          namespace: h,
          ancestorInfo: g
        };
      }
    }
    function nX(n) {
      return n;
    }
    function O7(n) {
      _2 = ni(), R2 = HI();
      var a = null;
      return jr(!1), a;
    }
    function P7(n) {
      VI(R2), jr(_2), _2 = null, R2 = null;
    }
    function j7(n, a, u, c, h) {
      var g;
      {
        var E = c;
        if (Ky(n, null, E.ancestorInfo), typeof a.children == "string" || typeof a.children == "number") {
          var _ = "" + a.children, P = Qy(E.ancestorInfo, n);
          Ky(null, _, P);
        }
        g = E.namespace;
      }
      var M = f7(n, a, u, g);
      return nv(h, M), $2(M, a), M;
    }
    function A7(n, a) {
      n.appendChild(a);
    }
    function D7(n, a, u, c, h) {
      switch (h7(n, a, u, c), a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function I7(n, a, u, c, h, g) {
      {
        var E = g;
        if (typeof c.children != typeof u.children && (typeof c.children == "string" || typeof c.children == "number")) {
          var _ = "" + c.children, P = Qy(E.ancestorInfo, a);
          Ky(null, _, P);
        }
      }
      return m7(n, a, u, c);
    }
    function O2(n, a) {
      return n === "textarea" || n === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
    }
    function M7(n, a, u, c) {
      {
        var h = u;
        Ky(null, n, h.ancestorInfo);
      }
      var g = p7(n, a);
      return nv(c, g), g;
    }
    function $7() {
      var n = window.event;
      return n === void 0 ? ns : ma(n.type);
    }
    var P2 = typeof setTimeout == "function" ? setTimeout : void 0, L7 = typeof clearTimeout == "function" ? clearTimeout : void 0, j2 = -1, E6 = typeof Promise == "function" ? Promise : void 0, N7 = typeof queueMicrotask == "function" ? queueMicrotask : typeof E6 < "u" ? function(n) {
      return E6.resolve(null).then(n).catch(F7);
    } : P2;
    function F7(n) {
      setTimeout(function() {
        throw n;
      });
    }
    function z7(n, a, u, c) {
      switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && n.focus();
          return;
        case "img": {
          u.src && (n.src = u.src);
          return;
        }
      }
    }
    function B7(n, a, u, c, h, g) {
      y7(n, a, u, c, h), $2(n, h);
    }
    function C6(n) {
      lp(n, "");
    }
    function U7(n, a, u) {
      n.nodeValue = u;
    }
    function H7(n, a) {
      n.appendChild(a);
    }
    function V7(n, a) {
      var u;
      n.nodeType === fr ? (u = n.parentNode, u.insertBefore(a, n)) : (u = n, u.appendChild(a));
      var c = n._reactRootContainer;
      c == null && u.onclick === null && Hb(u);
    }
    function G7(n, a, u) {
      n.insertBefore(a, u);
    }
    function q7(n, a, u) {
      n.nodeType === fr ? n.parentNode.insertBefore(a, u) : n.insertBefore(a, u);
    }
    function W7(n, a) {
      n.removeChild(a);
    }
    function Y7(n, a) {
      n.nodeType === fr ? n.parentNode.removeChild(a) : n.removeChild(a);
    }
    function A2(n, a) {
      var u = a, c = 0;
      do {
        var h = u.nextSibling;
        if (n.removeChild(u), h && h.nodeType === fr) {
          var g = h.data;
          if (g === qb)
            if (c === 0) {
              n.removeChild(h), Gt(a);
              return;
            } else
              c--;
          else
            (g === Gb || g === Xy || g === Jy) && c++;
        }
        u = h;
      } while (u);
      Gt(a);
    }
    function Z7(n, a) {
      n.nodeType === fr ? A2(n.parentNode, a) : n.nodeType === Pa && A2(n, a), Gt(n);
    }
    function K7(n) {
      n = n;
      var a = n.style;
      typeof a.setProperty == "function" ? a.setProperty("display", "none", "important") : a.display = "none";
    }
    function Q7(n) {
      n.nodeValue = "";
    }
    function X7(n, a) {
      n = n;
      var u = a[T7], c = u != null && u.hasOwnProperty("display") ? u.display : null;
      n.style.display = cp("display", c);
    }
    function J7(n, a) {
      n.nodeValue = a;
    }
    function eM(n) {
      n.nodeType === Pa ? n.textContent = "" : n.nodeType === qi && n.documentElement && n.removeChild(n.documentElement);
    }
    function tM(n, a, u) {
      return n.nodeType !== Pa || a.toLowerCase() !== n.nodeName.toLowerCase() ? null : n;
    }
    function nM(n, a) {
      return a === "" || n.nodeType !== Wo ? null : n;
    }
    function rM(n) {
      return n.nodeType !== fr ? null : n;
    }
    function T6(n) {
      return n.data === Xy;
    }
    function D2(n) {
      return n.data === Jy;
    }
    function aM(n) {
      var a = n.nextSibling && n.nextSibling.dataset, u, c, h;
      return a && (u = a.dgst, c = a.msg, h = a.stck), {
        message: c,
        digest: u,
        stack: h
      };
    }
    function iM(n, a) {
      n._reactRetry = a;
    }
    function Wb(n) {
      for (; n != null; n = n.nextSibling) {
        var a = n.nodeType;
        if (a === Pa || a === Wo)
          break;
        if (a === fr) {
          var u = n.data;
          if (u === Gb || u === Jy || u === Xy)
            break;
          if (u === qb)
            return null;
        }
      }
      return n;
    }
    function ev(n) {
      return Wb(n.nextSibling);
    }
    function oM(n) {
      return Wb(n.firstChild);
    }
    function sM(n) {
      return Wb(n.firstChild);
    }
    function uM(n) {
      return Wb(n.nextSibling);
    }
    function lM(n, a, u, c, h, g, E) {
      nv(g, n), $2(n, u);
      var _;
      {
        var P = h;
        _ = P.namespace;
      }
      var M = (g.mode & zt) !== mt;
      return g7(n, a, u, _, c, M, E);
    }
    function cM(n, a, u, c) {
      return nv(u, n), u.mode & zt, b7(n, a);
    }
    function dM(n, a) {
      nv(a, n);
    }
    function fM(n) {
      for (var a = n.nextSibling, u = 0; a; ) {
        if (a.nodeType === fr) {
          var c = a.data;
          if (c === qb) {
            if (u === 0)
              return ev(a);
            u--;
          } else
            (c === Gb || c === Jy || c === Xy) && u++;
        }
        a = a.nextSibling;
      }
      return null;
    }
    function _6(n) {
      for (var a = n.previousSibling, u = 0; a; ) {
        if (a.nodeType === fr) {
          var c = a.data;
          if (c === Gb || c === Jy || c === Xy) {
            if (u === 0)
              return a;
            u--;
          } else
            c === qb && u++;
        }
        a = a.previousSibling;
      }
      return null;
    }
    function pM(n) {
      Gt(n);
    }
    function hM(n) {
      Gt(n);
    }
    function mM(n) {
      return n !== "head" && n !== "body";
    }
    function yM(n, a, u, c) {
      var h = !0;
      Ub(a.nodeValue, u, c, h);
    }
    function vM(n, a, u, c, h, g) {
      if (a[Vb] !== !0) {
        var E = !0;
        Ub(c.nodeValue, h, g, E);
      }
    }
    function gM(n, a) {
      a.nodeType === Pa ? k2(n, a) : a.nodeType === fr || E2(n, a);
    }
    function bM(n, a) {
      {
        var u = n.parentNode;
        u !== null && (a.nodeType === Pa ? k2(u, a) : a.nodeType === fr || E2(u, a));
      }
    }
    function wM(n, a, u, c, h) {
      (h || a[Vb] !== !0) && (c.nodeType === Pa ? k2(u, c) : c.nodeType === fr || E2(u, c));
    }
    function xM(n, a, u) {
      C2(n, a);
    }
    function SM(n, a) {
      T2(n, a);
    }
    function kM(n, a, u) {
      {
        var c = n.parentNode;
        c !== null && C2(c, a);
      }
    }
    function EM(n, a) {
      {
        var u = n.parentNode;
        u !== null && T2(u, a);
      }
    }
    function CM(n, a, u, c, h, g) {
      (g || a[Vb] !== !0) && C2(u, c);
    }
    function TM(n, a, u, c, h) {
      (h || a[Vb] !== !0) && T2(u, c);
    }
    function _M(n) {
      f("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", n.nodeName.toLowerCase());
    }
    function RM(n) {
      qy(n);
    }
    var yh = Math.random().toString(36).slice(2), vh = "__reactFiber$" + yh, I2 = "__reactProps$" + yh, tv = "__reactContainer$" + yh, M2 = "__reactEvents$" + yh, OM = "__reactListeners$" + yh, PM = "__reactHandles$" + yh;
    function jM(n) {
      delete n[vh], delete n[I2], delete n[M2], delete n[OM], delete n[PM];
    }
    function nv(n, a) {
      a[vh] = n;
    }
    function Yb(n, a) {
      a[tv] = n;
    }
    function R6(n) {
      n[tv] = null;
    }
    function rv(n) {
      return !!n[tv];
    }
    function hf(n) {
      var a = n[vh];
      if (a)
        return a;
      for (var u = n.parentNode; u; ) {
        if (a = u[tv] || u[vh], a) {
          var c = a.alternate;
          if (a.child !== null || c !== null && c.child !== null)
            for (var h = _6(n); h !== null; ) {
              var g = h[vh];
              if (g)
                return g;
              h = _6(h);
            }
          return a;
        }
        n = u, u = n.parentNode;
      }
      return null;
    }
    function Mc(n) {
      var a = n[vh] || n[tv];
      return a && (a.tag === T || a.tag === O || a.tag === H || a.tag === b) ? a : null;
    }
    function gh(n) {
      if (n.tag === T || n.tag === O)
        return n.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Zb(n) {
      return n[I2] || null;
    }
    function $2(n, a) {
      n[I2] = a;
    }
    function AM(n) {
      var a = n[M2];
      return a === void 0 && (a = n[M2] = /* @__PURE__ */ new Set()), a;
    }
    var O6 = {}, P6 = r.ReactDebugCurrentFrame;
    function Kb(n) {
      if (n) {
        var a = n._owner, u = po(n.type, n._source, a ? a.type : null);
        P6.setExtraStackFrame(u);
      } else
        P6.setExtraStackFrame(null);
    }
    function ss(n, a, u, c, h) {
      {
        var g = Function.call.bind(xn);
        for (var E in n)
          if (g(n, E)) {
            var _ = void 0;
            try {
              if (typeof n[E] != "function") {
                var P = Error((c || "React class") + ": " + u + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              _ = n[E](a, E, c, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              _ = M;
            }
            _ && !(_ instanceof Error) && (Kb(h), f("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", u, E, typeof _), Kb(null)), _ instanceof Error && !(_.message in O6) && (O6[_.message] = !0, Kb(h), f("Failed %s type: %s", u, _.message), Kb(null));
          }
      }
    }
    var L2 = [], Qb;
    Qb = [];
    var pl = -1;
    function $c(n) {
      return {
        current: n
      };
    }
    function Fa(n, a) {
      if (pl < 0) {
        f("Unexpected pop.");
        return;
      }
      a !== Qb[pl] && f("Unexpected Fiber popped."), n.current = L2[pl], L2[pl] = null, Qb[pl] = null, pl--;
    }
    function za(n, a, u) {
      pl++, L2[pl] = n.current, Qb[pl] = u, n.current = a;
    }
    var N2;
    N2 = {};
    var Qi = {};
    Object.freeze(Qi);
    var hl = $c(Qi), fu = $c(!1), F2 = Qi;
    function bh(n, a, u) {
      return u && pu(a) ? F2 : hl.current;
    }
    function j6(n, a, u) {
      {
        var c = n.stateNode;
        c.__reactInternalMemoizedUnmaskedChildContext = a, c.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function wh(n, a) {
      {
        var u = n.type, c = u.contextTypes;
        if (!c)
          return Qi;
        var h = n.stateNode;
        if (h && h.__reactInternalMemoizedUnmaskedChildContext === a)
          return h.__reactInternalMemoizedMaskedChildContext;
        var g = {};
        for (var E in c)
          g[E] = a[E];
        {
          var _ = _t(n) || "Unknown";
          ss(c, g, "context", _);
        }
        return h && j6(n, a, g), g;
      }
    }
    function Xb() {
      return fu.current;
    }
    function pu(n) {
      {
        var a = n.childContextTypes;
        return a != null;
      }
    }
    function Jb(n) {
      Fa(fu, n), Fa(hl, n);
    }
    function z2(n) {
      Fa(fu, n), Fa(hl, n);
    }
    function A6(n, a, u) {
      {
        if (hl.current !== Qi)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        za(hl, a, n), za(fu, u, n);
      }
    }
    function D6(n, a, u) {
      {
        var c = n.stateNode, h = a.childContextTypes;
        if (typeof c.getChildContext != "function") {
          {
            var g = _t(n) || "Unknown";
            N2[g] || (N2[g] = !0, f("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", g, g));
          }
          return u;
        }
        var E = c.getChildContext();
        for (var _ in E)
          if (!(_ in h))
            throw new Error((_t(n) || "Unknown") + '.getChildContext(): key "' + _ + '" is not defined in childContextTypes.');
        {
          var P = _t(n) || "Unknown";
          ss(h, E, "child context", P);
        }
        return Nt({}, u, E);
      }
    }
    function ew(n) {
      {
        var a = n.stateNode, u = a && a.__reactInternalMemoizedMergedChildContext || Qi;
        return F2 = hl.current, za(hl, u, n), za(fu, fu.current, n), !0;
      }
    }
    function I6(n, a, u) {
      {
        var c = n.stateNode;
        if (!c)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var h = D6(n, a, F2);
          c.__reactInternalMemoizedMergedChildContext = h, Fa(fu, n), Fa(hl, n), za(hl, h, n), za(fu, u, n);
        } else
          Fa(fu, n), za(fu, u, n);
      }
    }
    function DM(n) {
      {
        if (!oy(n) || n.tag !== w)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = n;
        do {
          switch (a.tag) {
            case b:
              return a.stateNode.context;
            case w: {
              var u = a.type;
              if (pu(u))
                return a.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Lc = 0, tw = 1, ml = null, B2 = !1, U2 = !1;
    function M6(n) {
      ml === null ? ml = [n] : ml.push(n);
    }
    function IM(n) {
      B2 = !0, M6(n);
    }
    function $6() {
      B2 && Nc();
    }
    function Nc() {
      if (!U2 && ml !== null) {
        U2 = !0;
        var n = 0, a = Ci();
        try {
          var u = !0, c = ml;
          for (gr(Xr); n < c.length; n++) {
            var h = c[n];
            do
              h = h(u);
            while (h !== null);
          }
          ml = null, B2 = !1;
        } catch (g) {
          throw ml !== null && (ml = ml.slice(n + 1)), xp(kp, Nc), g;
        } finally {
          gr(a), U2 = !1;
        }
      }
      return null;
    }
    var xh = [], Sh = 0, nw = null, rw = 0, So = [], ko = 0, mf = null, yl = 1, vl = "";
    function MM(n) {
      return vf(), (n.flags & ry) !== lt;
    }
    function $M(n) {
      return vf(), rw;
    }
    function LM() {
      var n = vl, a = yl, u = a & ~NM(a);
      return u.toString(32) + n;
    }
    function yf(n, a) {
      vf(), xh[Sh++] = rw, xh[Sh++] = nw, nw = n, rw = a;
    }
    function L6(n, a, u) {
      vf(), So[ko++] = yl, So[ko++] = vl, So[ko++] = mf, mf = n;
      var c = yl, h = vl, g = aw(c) - 1, E = c & ~(1 << g), _ = u + 1, P = aw(a) + g;
      if (P > 30) {
        var M = g - g % 5, F = (1 << M) - 1, X = (E & F).toString(32), K = E >> M, re = g - M, ie = aw(a) + re, me = _ << re, qe = me | K, ft = X + h;
        yl = 1 << ie | qe, vl = ft;
      } else {
        var it = _ << g, Qt = it | E, qt = h;
        yl = 1 << P | Qt, vl = qt;
      }
    }
    function H2(n) {
      vf();
      var a = n.return;
      if (a !== null) {
        var u = 1, c = 0;
        yf(n, u), L6(n, u, c);
      }
    }
    function aw(n) {
      return 32 - Op(n);
    }
    function NM(n) {
      return 1 << aw(n) - 1;
    }
    function V2(n) {
      for (; n === nw; )
        nw = xh[--Sh], xh[Sh] = null, rw = xh[--Sh], xh[Sh] = null;
      for (; n === mf; )
        mf = So[--ko], So[ko] = null, vl = So[--ko], So[ko] = null, yl = So[--ko], So[ko] = null;
    }
    function FM() {
      return vf(), mf !== null ? {
        id: yl,
        overflow: vl
      } : null;
    }
    function zM(n, a) {
      vf(), So[ko++] = yl, So[ko++] = vl, So[ko++] = mf, yl = a.id, vl = a.overflow, mf = n;
    }
    function vf() {
      va() || f("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var ya = null, Eo = null, us = !1, gf = !1, Fc = null;
    function BM() {
      us && f("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function N6() {
      gf = !0;
    }
    function UM() {
      return gf;
    }
    function HM(n) {
      var a = n.stateNode.containerInfo;
      return Eo = sM(a), ya = n, us = !0, Fc = null, gf = !1, !0;
    }
    function VM(n, a, u) {
      return Eo = uM(a), ya = n, us = !0, Fc = null, gf = !1, u !== null && zM(n, u), !0;
    }
    function F6(n, a) {
      switch (n.tag) {
        case b: {
          gM(n.stateNode.containerInfo, a);
          break;
        }
        case T: {
          var u = (n.mode & zt) !== mt;
          wM(
            n.type,
            n.memoizedProps,
            n.stateNode,
            a,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case H: {
          var c = n.memoizedState;
          c.dehydrated !== null && bM(c.dehydrated, a);
          break;
        }
      }
    }
    function z6(n, a) {
      F6(n, a);
      var u = W8();
      u.stateNode = a, u.return = n;
      var c = n.deletions;
      c === null ? (n.deletions = [u], n.flags |= ln) : c.push(u);
    }
    function G2(n, a) {
      {
        if (gf)
          return;
        switch (n.tag) {
          case b: {
            var u = n.stateNode.containerInfo;
            switch (a.tag) {
              case T:
                var c = a.type;
                a.pendingProps, xM(u, c);
                break;
              case O:
                var h = a.pendingProps;
                SM(u, h);
                break;
            }
            break;
          }
          case T: {
            var g = n.type, E = n.memoizedProps, _ = n.stateNode;
            switch (a.tag) {
              case T: {
                var P = a.type, M = a.pendingProps, F = (n.mode & zt) !== mt;
                CM(
                  g,
                  E,
                  _,
                  P,
                  M,
                  // TODO: Delete this argument when we remove the legacy root API.
                  F
                );
                break;
              }
              case O: {
                var X = a.pendingProps, K = (n.mode & zt) !== mt;
                TM(
                  g,
                  E,
                  _,
                  X,
                  // TODO: Delete this argument when we remove the legacy root API.
                  K
                );
                break;
              }
            }
            break;
          }
          case H: {
            var re = n.memoizedState, ie = re.dehydrated;
            if (ie !== null)
              switch (a.tag) {
                case T:
                  var me = a.type;
                  a.pendingProps, kM(ie, me);
                  break;
                case O:
                  var qe = a.pendingProps;
                  EM(ie, qe);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function B6(n, a) {
      a.flags = a.flags & ~wi | Dn, G2(n, a);
    }
    function U6(n, a) {
      switch (n.tag) {
        case T: {
          var u = n.type;
          n.pendingProps;
          var c = tM(a, u);
          return c !== null ? (n.stateNode = c, ya = n, Eo = oM(c), !0) : !1;
        }
        case O: {
          var h = n.pendingProps, g = nM(a, h);
          return g !== null ? (n.stateNode = g, ya = n, Eo = null, !0) : !1;
        }
        case H: {
          var E = rM(a);
          if (E !== null) {
            var _ = {
              dehydrated: E,
              treeContext: FM(),
              retryLane: La
            };
            n.memoizedState = _;
            var P = Y8(E);
            return P.return = n, n.child = P, ya = n, Eo = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function q2(n) {
      return (n.mode & zt) !== mt && (n.flags & Et) === lt;
    }
    function W2(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function Y2(n) {
      if (us) {
        var a = Eo;
        if (!a) {
          q2(n) && (G2(ya, n), W2()), B6(ya, n), us = !1, ya = n;
          return;
        }
        var u = a;
        if (!U6(n, a)) {
          q2(n) && (G2(ya, n), W2()), a = ev(u);
          var c = ya;
          if (!a || !U6(n, a)) {
            B6(ya, n), us = !1, ya = n;
            return;
          }
          z6(c, u);
        }
      }
    }
    function GM(n, a, u) {
      var c = n.stateNode, h = !gf, g = lM(c, n.type, n.memoizedProps, a, u, n, h);
      return n.updateQueue = g, g !== null;
    }
    function qM(n) {
      var a = n.stateNode, u = n.memoizedProps, c = cM(a, u, n);
      if (c) {
        var h = ya;
        if (h !== null)
          switch (h.tag) {
            case b: {
              var g = h.stateNode.containerInfo, E = (h.mode & zt) !== mt;
              yM(
                g,
                a,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                E
              );
              break;
            }
            case T: {
              var _ = h.type, P = h.memoizedProps, M = h.stateNode, F = (h.mode & zt) !== mt;
              vM(
                _,
                P,
                M,
                a,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                F
              );
              break;
            }
          }
      }
      return c;
    }
    function WM(n) {
      var a = n.memoizedState, u = a !== null ? a.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      dM(u, n);
    }
    function YM(n) {
      var a = n.memoizedState, u = a !== null ? a.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return fM(u);
    }
    function H6(n) {
      for (var a = n.return; a !== null && a.tag !== T && a.tag !== b && a.tag !== H; )
        a = a.return;
      ya = a;
    }
    function iw(n) {
      if (n !== ya)
        return !1;
      if (!us)
        return H6(n), us = !0, !1;
      if (n.tag !== b && (n.tag !== T || mM(n.type) && !O2(n.type, n.memoizedProps))) {
        var a = Eo;
        if (a)
          if (q2(n))
            V6(n), W2();
          else
            for (; a; )
              z6(n, a), a = ev(a);
      }
      return H6(n), n.tag === H ? Eo = YM(n) : Eo = ya ? ev(n.stateNode) : null, !0;
    }
    function ZM() {
      return us && Eo !== null;
    }
    function V6(n) {
      for (var a = Eo; a; )
        F6(n, a), a = ev(a);
    }
    function kh() {
      ya = null, Eo = null, us = !1, gf = !1;
    }
    function G6() {
      Fc !== null && (FR(Fc), Fc = null);
    }
    function va() {
      return us;
    }
    function Z2(n) {
      Fc === null ? Fc = [n] : Fc.push(n);
    }
    var KM = r.ReactCurrentBatchConfig, QM = null;
    function XM() {
      return KM.transition;
    }
    var ls = {
      recordUnsafeLifecycleWarnings: function(n, a) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(n, a) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var JM = function(n) {
        for (var a = null, u = n; u !== null; )
          u.mode & Zn && (a = u), u = u.return;
        return a;
      }, bf = function(n) {
        var a = [];
        return n.forEach(function(u) {
          a.push(u);
        }), a.sort().join(", ");
      }, av = [], iv = [], ov = [], sv = [], uv = [], lv = [], wf = /* @__PURE__ */ new Set();
      ls.recordUnsafeLifecycleWarnings = function(n, a) {
        wf.has(n.type) || (typeof a.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && av.push(n), n.mode & Zn && typeof a.UNSAFE_componentWillMount == "function" && iv.push(n), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && ov.push(n), n.mode & Zn && typeof a.UNSAFE_componentWillReceiveProps == "function" && sv.push(n), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && uv.push(n), n.mode & Zn && typeof a.UNSAFE_componentWillUpdate == "function" && lv.push(n));
      }, ls.flushPendingUnsafeLifecycleWarnings = function() {
        var n = /* @__PURE__ */ new Set();
        av.length > 0 && (av.forEach(function(K) {
          n.add(_t(K) || "Component"), wf.add(K.type);
        }), av = []);
        var a = /* @__PURE__ */ new Set();
        iv.length > 0 && (iv.forEach(function(K) {
          a.add(_t(K) || "Component"), wf.add(K.type);
        }), iv = []);
        var u = /* @__PURE__ */ new Set();
        ov.length > 0 && (ov.forEach(function(K) {
          u.add(_t(K) || "Component"), wf.add(K.type);
        }), ov = []);
        var c = /* @__PURE__ */ new Set();
        sv.length > 0 && (sv.forEach(function(K) {
          c.add(_t(K) || "Component"), wf.add(K.type);
        }), sv = []);
        var h = /* @__PURE__ */ new Set();
        uv.length > 0 && (uv.forEach(function(K) {
          h.add(_t(K) || "Component"), wf.add(K.type);
        }), uv = []);
        var g = /* @__PURE__ */ new Set();
        if (lv.length > 0 && (lv.forEach(function(K) {
          g.add(_t(K) || "Component"), wf.add(K.type);
        }), lv = []), a.size > 0) {
          var E = bf(a);
          f(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, E);
        }
        if (c.size > 0) {
          var _ = bf(c);
          f(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, _);
        }
        if (g.size > 0) {
          var P = bf(g);
          f(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, P);
        }
        if (n.size > 0) {
          var M = bf(n);
          d(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (u.size > 0) {
          var F = bf(u);
          d(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, F);
        }
        if (h.size > 0) {
          var X = bf(h);
          d(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, X);
        }
      };
      var ow = /* @__PURE__ */ new Map(), q6 = /* @__PURE__ */ new Set();
      ls.recordLegacyContextWarning = function(n, a) {
        var u = JM(n);
        if (u === null) {
          f("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!q6.has(n.type)) {
          var c = ow.get(u);
          (n.type.contextTypes != null || n.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (c === void 0 && (c = [], ow.set(u, c)), c.push(n));
        }
      }, ls.flushLegacyContextWarning = function() {
        ow.forEach(function(n, a) {
          if (n.length !== 0) {
            var u = n[0], c = /* @__PURE__ */ new Set();
            n.forEach(function(g) {
              c.add(_t(g) || "Component"), q6.add(g.type);
            });
            var h = bf(c);
            try {
              pn(u), f(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, h);
            } finally {
              Jn();
            }
          }
        });
      }, ls.discardPendingWarnings = function() {
        av = [], iv = [], ov = [], sv = [], uv = [], lv = [], ow = /* @__PURE__ */ new Map();
      };
    }
    function cs(n, a) {
      if (n && n.defaultProps) {
        var u = Nt({}, a), c = n.defaultProps;
        for (var h in c)
          u[h] === void 0 && (u[h] = c[h]);
        return u;
      }
      return a;
    }
    var K2 = $c(null), Q2;
    Q2 = {};
    var sw = null, Eh = null, X2 = null, uw = !1;
    function lw() {
      sw = null, Eh = null, X2 = null, uw = !1;
    }
    function W6() {
      uw = !0;
    }
    function Y6() {
      uw = !1;
    }
    function Z6(n, a, u) {
      za(K2, a._currentValue, n), a._currentValue = u, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== Q2 && f("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = Q2;
    }
    function J2(n, a) {
      var u = K2.current;
      Fa(K2, a), n._currentValue = u;
    }
    function eS(n, a, u) {
      for (var c = n; c !== null; ) {
        var h = c.alternate;
        if (nl(c.childLanes, a) ? h !== null && !nl(h.childLanes, a) && (h.childLanes = Mt(h.childLanes, a)) : (c.childLanes = Mt(c.childLanes, a), h !== null && (h.childLanes = Mt(h.childLanes, a))), c === u)
          break;
        c = c.return;
      }
      c !== u && f("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function e4(n, a, u) {
      t4(n, a, u);
    }
    function t4(n, a, u) {
      var c = n.child;
      for (c !== null && (c.return = n); c !== null; ) {
        var h = void 0, g = c.dependencies;
        if (g !== null) {
          h = c.child;
          for (var E = g.firstContext; E !== null; ) {
            if (E.context === a) {
              if (c.tag === w) {
                var _ = vr(u), P = gl(Cn, _);
                P.tag = dw;
                var M = c.updateQueue;
                if (M !== null) {
                  var F = M.shared, X = F.pending;
                  X === null ? P.next = P : (P.next = X.next, X.next = P), F.pending = P;
                }
              }
              c.lanes = Mt(c.lanes, u);
              var K = c.alternate;
              K !== null && (K.lanes = Mt(K.lanes, u)), eS(c.return, u, n), g.lanes = Mt(g.lanes, u);
              break;
            }
            E = E.next;
          }
        } else if (c.tag === N)
          h = c.type === n.type ? null : c.child;
        else if (c.tag === ve) {
          var re = c.return;
          if (re === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          re.lanes = Mt(re.lanes, u);
          var ie = re.alternate;
          ie !== null && (ie.lanes = Mt(ie.lanes, u)), eS(re, u, n), h = c.sibling;
        } else
          h = c.child;
        if (h !== null)
          h.return = c;
        else
          for (h = c; h !== null; ) {
            if (h === n) {
              h = null;
              break;
            }
            var me = h.sibling;
            if (me !== null) {
              me.return = h.return, h = me;
              break;
            }
            h = h.return;
          }
        c = h;
      }
    }
    function Ch(n, a) {
      sw = n, Eh = null, X2 = null;
      var u = n.dependencies;
      if (u !== null) {
        var c = u.firstContext;
        c !== null && (Na(u.lanes, a) && kv(), u.firstContext = null);
      }
    }
    function Dr(n) {
      uw && f("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = n._currentValue;
      if (X2 !== n) {
        var u = {
          context: n,
          memoizedValue: a,
          next: null
        };
        if (Eh === null) {
          if (sw === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Eh = u, sw.dependencies = {
            lanes: be,
            firstContext: u
          };
        } else
          Eh = Eh.next = u;
      }
      return a;
    }
    var xf = null;
    function tS(n) {
      xf === null ? xf = [n] : xf.push(n);
    }
    function n4() {
      if (xf !== null) {
        for (var n = 0; n < xf.length; n++) {
          var a = xf[n], u = a.interleaved;
          if (u !== null) {
            a.interleaved = null;
            var c = u.next, h = a.pending;
            if (h !== null) {
              var g = h.next;
              h.next = c, u.next = g;
            }
            a.pending = u;
          }
        }
        xf = null;
      }
    }
    function K6(n, a, u, c) {
      var h = a.interleaved;
      return h === null ? (u.next = u, tS(a)) : (u.next = h.next, h.next = u), a.interleaved = u, cw(n, c);
    }
    function r4(n, a, u, c) {
      var h = a.interleaved;
      h === null ? (u.next = u, tS(a)) : (u.next = h.next, h.next = u), a.interleaved = u;
    }
    function a4(n, a, u, c) {
      var h = a.interleaved;
      return h === null ? (u.next = u, tS(a)) : (u.next = h.next, h.next = u), a.interleaved = u, cw(n, c);
    }
    function Pi(n, a) {
      return cw(n, a);
    }
    var i4 = cw;
    function cw(n, a) {
      n.lanes = Mt(n.lanes, a);
      var u = n.alternate;
      u !== null && (u.lanes = Mt(u.lanes, a)), u === null && (n.flags & (Dn | wi)) !== lt && QR(n);
      for (var c = n, h = n.return; h !== null; )
        h.childLanes = Mt(h.childLanes, a), u = h.alternate, u !== null ? u.childLanes = Mt(u.childLanes, a) : (h.flags & (Dn | wi)) !== lt && QR(n), c = h, h = h.return;
      if (c.tag === b) {
        var g = c.stateNode;
        return g;
      } else
        return null;
    }
    var Q6 = 0, X6 = 1, dw = 2, nS = 3, fw = !1, rS, pw;
    rS = !1, pw = null;
    function aS(n) {
      var a = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: be
        },
        effects: null
      };
      n.updateQueue = a;
    }
    function J6(n, a) {
      var u = a.updateQueue, c = n.updateQueue;
      if (u === c) {
        var h = {
          baseState: c.baseState,
          firstBaseUpdate: c.firstBaseUpdate,
          lastBaseUpdate: c.lastBaseUpdate,
          shared: c.shared,
          effects: c.effects
        };
        a.updateQueue = h;
      }
    }
    function gl(n, a) {
      var u = {
        eventTime: n,
        lane: a,
        tag: Q6,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function zc(n, a, u) {
      var c = n.updateQueue;
      if (c === null)
        return null;
      var h = c.shared;
      if (pw === h && !rS && (f("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), rS = !0), i8()) {
        var g = h.pending;
        return g === null ? a.next = a : (a.next = g.next, g.next = a), h.pending = a, i4(n, u);
      } else
        return a4(n, h, a, u);
    }
    function hw(n, a, u) {
      var c = a.updateQueue;
      if (c !== null) {
        var h = c.shared;
        if (by(u)) {
          var g = h.lanes;
          g = xy(g, n.pendingLanes);
          var E = Mt(g, u);
          h.lanes = E, wc(n, E);
        }
      }
    }
    function iS(n, a) {
      var u = n.updateQueue, c = n.alternate;
      if (c !== null) {
        var h = c.updateQueue;
        if (u === h) {
          var g = null, E = null, _ = u.firstBaseUpdate;
          if (_ !== null) {
            var P = _;
            do {
              var M = {
                eventTime: P.eventTime,
                lane: P.lane,
                tag: P.tag,
                payload: P.payload,
                callback: P.callback,
                next: null
              };
              E === null ? g = E = M : (E.next = M, E = M), P = P.next;
            } while (P !== null);
            E === null ? g = E = a : (E.next = a, E = a);
          } else
            g = E = a;
          u = {
            baseState: h.baseState,
            firstBaseUpdate: g,
            lastBaseUpdate: E,
            shared: h.shared,
            effects: h.effects
          }, n.updateQueue = u;
          return;
        }
      }
      var F = u.lastBaseUpdate;
      F === null ? u.firstBaseUpdate = a : F.next = a, u.lastBaseUpdate = a;
    }
    function o4(n, a, u, c, h, g) {
      switch (u.tag) {
        case X6: {
          var E = u.payload;
          if (typeof E == "function") {
            W6();
            var _ = E.call(g, c, h);
            {
              if (n.mode & Zn) {
                yr(!0);
                try {
                  E.call(g, c, h);
                } finally {
                  yr(!1);
                }
              }
              Y6();
            }
            return _;
          }
          return E;
        }
        case nS:
          n.flags = n.flags & ~Rr | Et;
        case Q6: {
          var P = u.payload, M;
          if (typeof P == "function") {
            W6(), M = P.call(g, c, h);
            {
              if (n.mode & Zn) {
                yr(!0);
                try {
                  P.call(g, c, h);
                } finally {
                  yr(!1);
                }
              }
              Y6();
            }
          } else
            M = P;
          return M == null ? c : Nt({}, c, M);
        }
        case dw:
          return fw = !0, c;
      }
      return c;
    }
    function mw(n, a, u, c) {
      var h = n.updateQueue;
      fw = !1, pw = h.shared;
      var g = h.firstBaseUpdate, E = h.lastBaseUpdate, _ = h.shared.pending;
      if (_ !== null) {
        h.shared.pending = null;
        var P = _, M = P.next;
        P.next = null, E === null ? g = M : E.next = M, E = P;
        var F = n.alternate;
        if (F !== null) {
          var X = F.updateQueue, K = X.lastBaseUpdate;
          K !== E && (K === null ? X.firstBaseUpdate = M : K.next = M, X.lastBaseUpdate = P);
        }
      }
      if (g !== null) {
        var re = h.baseState, ie = be, me = null, qe = null, ft = null, it = g;
        do {
          var Qt = it.lane, qt = it.eventTime;
          if (nl(c, Qt)) {
            if (ft !== null) {
              var ye = {
                eventTime: qt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Zt,
                tag: it.tag,
                payload: it.payload,
                callback: it.callback,
                next: null
              };
              ft = ft.next = ye;
            }
            re = o4(n, h, it, re, a, u);
            var te = it.callback;
            if (te !== null && // If the update was already committed, we should not queue its
            // callback again.
            it.lane !== Zt) {
              n.flags |= yo;
              var je = h.effects;
              je === null ? h.effects = [it] : je.push(it);
            }
          } else {
            var ee = {
              eventTime: qt,
              lane: Qt,
              tag: it.tag,
              payload: it.payload,
              callback: it.callback,
              next: null
            };
            ft === null ? (qe = ft = ee, me = re) : ft = ft.next = ee, ie = Mt(ie, Qt);
          }
          if (it = it.next, it === null) {
            if (_ = h.shared.pending, _ === null)
              break;
            var We = _, Be = We.next;
            We.next = null, it = Be, h.lastBaseUpdate = We, h.shared.pending = null;
          }
        } while (!0);
        ft === null && (me = re), h.baseState = me, h.firstBaseUpdate = qe, h.lastBaseUpdate = ft;
        var kt = h.shared.interleaved;
        if (kt !== null) {
          var jt = kt;
          do
            ie = Mt(ie, jt.lane), jt = jt.next;
          while (jt !== kt);
        } else
          g === null && (h.shared.lanes = be);
        Mv(ie), n.lanes = ie, n.memoizedState = re;
      }
      pw = null;
    }
    function s4(n, a) {
      if (typeof n != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(a);
    }
    function e_() {
      fw = !1;
    }
    function yw() {
      return fw;
    }
    function t_(n, a, u) {
      var c = a.effects;
      if (a.effects = null, c !== null)
        for (var h = 0; h < c.length; h++) {
          var g = c[h], E = g.callback;
          E !== null && (g.callback = null, s4(E, u));
        }
    }
    var oS = {}, n_ = new e.Component().refs, sS, uS, lS, cS, dS, r_, vw, fS, pS, hS;
    {
      sS = /* @__PURE__ */ new Set(), uS = /* @__PURE__ */ new Set(), lS = /* @__PURE__ */ new Set(), cS = /* @__PURE__ */ new Set(), fS = /* @__PURE__ */ new Set(), dS = /* @__PURE__ */ new Set(), pS = /* @__PURE__ */ new Set(), hS = /* @__PURE__ */ new Set();
      var a_ = /* @__PURE__ */ new Set();
      vw = function(n, a) {
        if (!(n === null || typeof n == "function")) {
          var u = a + "_" + n;
          a_.has(u) || (a_.add(u), f("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n));
        }
      }, r_ = function(n, a) {
        if (a === void 0) {
          var u = en(n) || "Component";
          dS.has(u) || (dS.add(u), f("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(oS, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(oS);
    }
    function mS(n, a, u, c) {
      var h = n.memoizedState, g = u(c, h);
      {
        if (n.mode & Zn) {
          yr(!0);
          try {
            g = u(c, h);
          } finally {
            yr(!1);
          }
        }
        r_(a, g);
      }
      var E = g == null ? h : Nt({}, h, g);
      if (n.memoizedState = E, n.lanes === be) {
        var _ = n.updateQueue;
        _.baseState = E;
      }
    }
    var yS = {
      isMounted: Ja,
      enqueueSetState: function(n, a, u) {
        var c = gi(n), h = ii(), g = Yc(c), E = gl(h, g);
        E.payload = a, u != null && (vw(u, "setState"), E.callback = u);
        var _ = zc(c, E, g);
        _ !== null && (qr(_, c, g, h), hw(_, c, g)), ru(c, g);
      },
      enqueueReplaceState: function(n, a, u) {
        var c = gi(n), h = ii(), g = Yc(c), E = gl(h, g);
        E.tag = X6, E.payload = a, u != null && (vw(u, "replaceState"), E.callback = u);
        var _ = zc(c, E, g);
        _ !== null && (qr(_, c, g, h), hw(_, c, g)), ru(c, g);
      },
      enqueueForceUpdate: function(n, a) {
        var u = gi(n), c = ii(), h = Yc(u), g = gl(c, h);
        g.tag = dw, a != null && (vw(a, "forceUpdate"), g.callback = a);
        var E = zc(u, g, h);
        E !== null && (qr(E, u, h, c), hw(E, u, h)), my(u, h);
      }
    };
    function i_(n, a, u, c, h, g, E) {
      var _ = n.stateNode;
      if (typeof _.shouldComponentUpdate == "function") {
        var P = _.shouldComponentUpdate(c, g, E);
        {
          if (n.mode & Zn) {
            yr(!0);
            try {
              P = _.shouldComponentUpdate(c, g, E);
            } finally {
              yr(!1);
            }
          }
          P === void 0 && f("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", en(a) || "Component");
        }
        return P;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !st(u, c) || !st(h, g) : !0;
    }
    function u4(n, a, u) {
      var c = n.stateNode;
      {
        var h = en(a) || "Component", g = c.render;
        g || (a.prototype && typeof a.prototype.render == "function" ? f("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", h) : f("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", h)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && f("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", h), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && f("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", h), c.propTypes && f("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", h), c.contextType && f("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", h), c.contextTypes && f("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", h), a.contextType && a.contextTypes && !pS.has(a) && (pS.add(a), f("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", h)), typeof c.componentShouldUpdate == "function" && f("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", h), a.prototype && a.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && f("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", en(a) || "A pure component"), typeof c.componentDidUnmount == "function" && f("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", h), typeof c.componentDidReceiveProps == "function" && f("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", h), typeof c.componentWillRecieveProps == "function" && f("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", h), typeof c.UNSAFE_componentWillRecieveProps == "function" && f("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", h);
        var E = c.props !== u;
        c.props !== void 0 && E && f("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", h, h), c.defaultProps && f("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", h, h), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !lS.has(a) && (lS.add(a), f("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", en(a))), typeof c.getDerivedStateFromProps == "function" && f("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof c.getDerivedStateFromError == "function" && f("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof a.getSnapshotBeforeUpdate == "function" && f("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", h);
        var _ = c.state;
        _ && (typeof _ != "object" || Wt(_)) && f("%s.state: must be set to an object or null", h), typeof c.getChildContext == "function" && typeof a.childContextTypes != "object" && f("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", h);
      }
    }
    function o_(n, a) {
      a.updater = yS, n.stateNode = a, cc(a, n), a._reactInternalInstance = oS;
    }
    function s_(n, a, u) {
      var c = !1, h = Qi, g = Qi, E = a.contextType;
      if ("contextType" in a) {
        var _ = (
          // Allow null for conditional declaration
          E === null || E !== void 0 && E.$$typeof === $e && E._context === void 0
        );
        if (!_ && !hS.has(a)) {
          hS.add(a);
          var P = "";
          E === void 0 ? P = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof E != "object" ? P = " However, it is set to a " + typeof E + "." : E.$$typeof === Ce ? P = " Did you accidentally pass the Context.Provider instead?" : E._context !== void 0 ? P = " Did you accidentally pass the Context.Consumer instead?" : P = " However, it is set to an object with keys {" + Object.keys(E).join(", ") + "}.", f("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", en(a) || "Component", P);
        }
      }
      if (typeof E == "object" && E !== null)
        g = Dr(E);
      else {
        h = bh(n, a, !0);
        var M = a.contextTypes;
        c = M != null, g = c ? wh(n, h) : Qi;
      }
      var F = new a(u, g);
      if (n.mode & Zn) {
        yr(!0);
        try {
          F = new a(u, g);
        } finally {
          yr(!1);
        }
      }
      var X = n.memoizedState = F.state !== null && F.state !== void 0 ? F.state : null;
      o_(n, F);
      {
        if (typeof a.getDerivedStateFromProps == "function" && X === null) {
          var K = en(a) || "Component";
          uS.has(K) || (uS.add(K), f("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", K, F.state === null ? "null" : "undefined", K));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof F.getSnapshotBeforeUpdate == "function") {
          var re = null, ie = null, me = null;
          if (typeof F.componentWillMount == "function" && F.componentWillMount.__suppressDeprecationWarning !== !0 ? re = "componentWillMount" : typeof F.UNSAFE_componentWillMount == "function" && (re = "UNSAFE_componentWillMount"), typeof F.componentWillReceiveProps == "function" && F.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? ie = "componentWillReceiveProps" : typeof F.UNSAFE_componentWillReceiveProps == "function" && (ie = "UNSAFE_componentWillReceiveProps"), typeof F.componentWillUpdate == "function" && F.componentWillUpdate.__suppressDeprecationWarning !== !0 ? me = "componentWillUpdate" : typeof F.UNSAFE_componentWillUpdate == "function" && (me = "UNSAFE_componentWillUpdate"), re !== null || ie !== null || me !== null) {
            var qe = en(a) || "Component", ft = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            cS.has(qe) || (cS.add(qe), f(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, qe, ft, re !== null ? `
  ` + re : "", ie !== null ? `
  ` + ie : "", me !== null ? `
  ` + me : ""));
          }
        }
      }
      return c && j6(n, h, g), F;
    }
    function l4(n, a) {
      var u = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), u !== a.state && (f("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", _t(n) || "Component"), yS.enqueueReplaceState(a, a.state, null));
    }
    function u_(n, a, u, c) {
      var h = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(u, c), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(u, c), a.state !== h) {
        {
          var g = _t(n) || "Component";
          sS.has(g) || (sS.add(g), f("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", g));
        }
        yS.enqueueReplaceState(a, a.state, null);
      }
    }
    function vS(n, a, u, c) {
      u4(n, a, u);
      var h = n.stateNode;
      h.props = u, h.state = n.memoizedState, h.refs = n_, aS(n);
      var g = a.contextType;
      if (typeof g == "object" && g !== null)
        h.context = Dr(g);
      else {
        var E = bh(n, a, !0);
        h.context = wh(n, E);
      }
      {
        if (h.state === u) {
          var _ = en(a) || "Component";
          fS.has(_) || (fS.add(_), f("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", _));
        }
        n.mode & Zn && ls.recordLegacyContextWarning(n, h), ls.recordUnsafeLifecycleWarnings(n, h);
      }
      h.state = n.memoizedState;
      var P = a.getDerivedStateFromProps;
      if (typeof P == "function" && (mS(n, a, P, u), h.state = n.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof h.getSnapshotBeforeUpdate != "function" && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (l4(n, h), mw(n, u, h, c), h.state = n.memoizedState), typeof h.componentDidMount == "function") {
        var M = It;
        M |= Aa, (n.mode & ki) !== mt && (M |= Da), n.flags |= M;
      }
    }
    function c4(n, a, u, c) {
      var h = n.stateNode, g = n.memoizedProps;
      h.props = g;
      var E = h.context, _ = a.contextType, P = Qi;
      if (typeof _ == "object" && _ !== null)
        P = Dr(_);
      else {
        var M = bh(n, a, !0);
        P = wh(n, M);
      }
      var F = a.getDerivedStateFromProps, X = typeof F == "function" || typeof h.getSnapshotBeforeUpdate == "function";
      !X && (typeof h.UNSAFE_componentWillReceiveProps == "function" || typeof h.componentWillReceiveProps == "function") && (g !== u || E !== P) && u_(n, h, u, P), e_();
      var K = n.memoizedState, re = h.state = K;
      if (mw(n, u, h, c), re = n.memoizedState, g === u && K === re && !Xb() && !yw()) {
        if (typeof h.componentDidMount == "function") {
          var ie = It;
          ie |= Aa, (n.mode & ki) !== mt && (ie |= Da), n.flags |= ie;
        }
        return !1;
      }
      typeof F == "function" && (mS(n, a, F, u), re = n.memoizedState);
      var me = yw() || i_(n, a, g, u, K, re, P);
      if (me) {
        if (!X && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount == "function") {
          var qe = It;
          qe |= Aa, (n.mode & ki) !== mt && (qe |= Da), n.flags |= qe;
        }
      } else {
        if (typeof h.componentDidMount == "function") {
          var ft = It;
          ft |= Aa, (n.mode & ki) !== mt && (ft |= Da), n.flags |= ft;
        }
        n.memoizedProps = u, n.memoizedState = re;
      }
      return h.props = u, h.state = re, h.context = P, me;
    }
    function d4(n, a, u, c, h) {
      var g = a.stateNode;
      J6(n, a);
      var E = a.memoizedProps, _ = a.type === a.elementType ? E : cs(a.type, E);
      g.props = _;
      var P = a.pendingProps, M = g.context, F = u.contextType, X = Qi;
      if (typeof F == "object" && F !== null)
        X = Dr(F);
      else {
        var K = bh(a, u, !0);
        X = wh(a, K);
      }
      var re = u.getDerivedStateFromProps, ie = typeof re == "function" || typeof g.getSnapshotBeforeUpdate == "function";
      !ie && (typeof g.UNSAFE_componentWillReceiveProps == "function" || typeof g.componentWillReceiveProps == "function") && (E !== P || M !== X) && u_(a, g, c, X), e_();
      var me = a.memoizedState, qe = g.state = me;
      if (mw(a, c, g, h), qe = a.memoizedState, E === P && me === qe && !Xb() && !yw() && !fe)
        return typeof g.componentDidUpdate == "function" && (E !== n.memoizedProps || me !== n.memoizedState) && (a.flags |= It), typeof g.getSnapshotBeforeUpdate == "function" && (E !== n.memoizedProps || me !== n.memoizedState) && (a.flags |= bi), !1;
      typeof re == "function" && (mS(a, u, re, c), qe = a.memoizedState);
      var ft = yw() || i_(a, u, _, c, me, qe, X) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      fe;
      return ft ? (!ie && (typeof g.UNSAFE_componentWillUpdate == "function" || typeof g.componentWillUpdate == "function") && (typeof g.componentWillUpdate == "function" && g.componentWillUpdate(c, qe, X), typeof g.UNSAFE_componentWillUpdate == "function" && g.UNSAFE_componentWillUpdate(c, qe, X)), typeof g.componentDidUpdate == "function" && (a.flags |= It), typeof g.getSnapshotBeforeUpdate == "function" && (a.flags |= bi)) : (typeof g.componentDidUpdate == "function" && (E !== n.memoizedProps || me !== n.memoizedState) && (a.flags |= It), typeof g.getSnapshotBeforeUpdate == "function" && (E !== n.memoizedProps || me !== n.memoizedState) && (a.flags |= bi), a.memoizedProps = c, a.memoizedState = qe), g.props = c, g.state = qe, g.context = X, ft;
    }
    var gS, bS, wS, xS, SS, l_ = function(n, a) {
    };
    gS = !1, bS = !1, wS = {}, xS = {}, SS = {}, l_ = function(n, a) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var u = _t(a) || "Component";
        xS[u] || (xS[u] = !0, f('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function cv(n, a, u) {
      var c = u.ref;
      if (c !== null && typeof c != "function" && typeof c != "object") {
        if ((n.mode & Zn || Xe) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self)) {
          var h = _t(n) || "Component";
          wS[h] || (f('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', c), wS[h] = !0);
        }
        if (u._owner) {
          var g = u._owner, E;
          if (g) {
            var _ = g;
            if (_.tag !== w)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            E = _.stateNode;
          }
          if (!E)
            throw new Error("Missing owner for string ref " + c + ". This error is likely caused by a bug in React. Please file an issue.");
          var P = E;
          cr(c, "ref");
          var M = "" + c;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === M)
            return a.ref;
          var F = function(X) {
            var K = P.refs;
            K === n_ && (K = P.refs = {}), X === null ? delete K[M] : K[M] = X;
          };
          return F._stringRef = M, F;
        } else {
          if (typeof c != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + c + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return c;
    }
    function gw(n, a) {
      var u = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function bw(n) {
      {
        var a = _t(n) || "Component";
        if (SS[a])
          return;
        SS[a] = !0, f("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function c_(n) {
      var a = n._payload, u = n._init;
      return u(a);
    }
    function d_(n) {
      function a(ee, ye) {
        if (n) {
          var te = ee.deletions;
          te === null ? (ee.deletions = [ye], ee.flags |= ln) : te.push(ye);
        }
      }
      function u(ee, ye) {
        if (!n)
          return null;
        for (var te = ye; te !== null; )
          a(ee, te), te = te.sibling;
        return null;
      }
      function c(ee, ye) {
        for (var te = /* @__PURE__ */ new Map(), je = ye; je !== null; )
          je.key !== null ? te.set(je.key, je) : te.set(je.index, je), je = je.sibling;
        return te;
      }
      function h(ee, ye) {
        var te = Of(ee, ye);
        return te.index = 0, te.sibling = null, te;
      }
      function g(ee, ye, te) {
        if (ee.index = te, !n)
          return ee.flags |= ry, ye;
        var je = ee.alternate;
        if (je !== null) {
          var We = je.index;
          return We < ye ? (ee.flags |= Dn, ye) : We;
        } else
          return ee.flags |= Dn, ye;
      }
      function E(ee) {
        return n && ee.alternate === null && (ee.flags |= Dn), ee;
      }
      function _(ee, ye, te, je) {
        if (ye === null || ye.tag !== O) {
          var We = Zk(te, ee.mode, je);
          return We.return = ee, We;
        } else {
          var Be = h(ye, te);
          return Be.return = ee, Be;
        }
      }
      function P(ee, ye, te, je) {
        var We = te.type;
        if (We === Ka)
          return F(ee, ye, te.props.children, je, te.key);
        if (ye !== null && (ye.elementType === We || // Keep this check inline so it only runs on the false path:
        tO(ye, te) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof We == "object" && We !== null && We.$$typeof === dt && c_(We) === ye.type)) {
          var Be = h(ye, te.props);
          return Be.ref = cv(ee, ye, te), Be.return = ee, Be._debugSource = te._source, Be._debugOwner = te._owner, Be;
        }
        var kt = Yk(te, ee.mode, je);
        return kt.ref = cv(ee, ye, te), kt.return = ee, kt;
      }
      function M(ee, ye, te, je) {
        if (ye === null || ye.tag !== k || ye.stateNode.containerInfo !== te.containerInfo || ye.stateNode.implementation !== te.implementation) {
          var We = Kk(te, ee.mode, je);
          return We.return = ee, We;
        } else {
          var Be = h(ye, te.children || []);
          return Be.return = ee, Be;
        }
      }
      function F(ee, ye, te, je, We) {
        if (ye === null || ye.tag !== R) {
          var Be = Kc(te, ee.mode, je, We);
          return Be.return = ee, Be;
        } else {
          var kt = h(ye, te);
          return kt.return = ee, kt;
        }
      }
      function X(ee, ye, te) {
        if (typeof ye == "string" && ye !== "" || typeof ye == "number") {
          var je = Zk("" + ye, ee.mode, te);
          return je.return = ee, je;
        }
        if (typeof ye == "object" && ye !== null) {
          switch (ye.$$typeof) {
            case uo: {
              var We = Yk(ye, ee.mode, te);
              return We.ref = cv(ee, null, ye), We.return = ee, We;
            }
            case da: {
              var Be = Kk(ye, ee.mode, te);
              return Be.return = ee, Be;
            }
            case dt: {
              var kt = ye._payload, jt = ye._init;
              return X(ee, jt(kt), te);
            }
          }
          if (Wt(ye) || Ui(ye)) {
            var wn = Kc(ye, ee.mode, te, null);
            return wn.return = ee, wn;
          }
          gw(ee, ye);
        }
        return typeof ye == "function" && bw(ee), null;
      }
      function K(ee, ye, te, je) {
        var We = ye !== null ? ye.key : null;
        if (typeof te == "string" && te !== "" || typeof te == "number")
          return We !== null ? null : _(ee, ye, "" + te, je);
        if (typeof te == "object" && te !== null) {
          switch (te.$$typeof) {
            case uo:
              return te.key === We ? P(ee, ye, te, je) : null;
            case da:
              return te.key === We ? M(ee, ye, te, je) : null;
            case dt: {
              var Be = te._payload, kt = te._init;
              return K(ee, ye, kt(Be), je);
            }
          }
          if (Wt(te) || Ui(te))
            return We !== null ? null : F(ee, ye, te, je, null);
          gw(ee, te);
        }
        return typeof te == "function" && bw(ee), null;
      }
      function re(ee, ye, te, je, We) {
        if (typeof je == "string" && je !== "" || typeof je == "number") {
          var Be = ee.get(te) || null;
          return _(ye, Be, "" + je, We);
        }
        if (typeof je == "object" && je !== null) {
          switch (je.$$typeof) {
            case uo: {
              var kt = ee.get(je.key === null ? te : je.key) || null;
              return P(ye, kt, je, We);
            }
            case da: {
              var jt = ee.get(je.key === null ? te : je.key) || null;
              return M(ye, jt, je, We);
            }
            case dt:
              var wn = je._payload, an = je._init;
              return re(ee, ye, te, an(wn), We);
          }
          if (Wt(je) || Ui(je)) {
            var xr = ee.get(te) || null;
            return F(ye, xr, je, We, null);
          }
          gw(ye, je);
        }
        return typeof je == "function" && bw(ye), null;
      }
      function ie(ee, ye, te) {
        {
          if (typeof ee != "object" || ee === null)
            return ye;
          switch (ee.$$typeof) {
            case uo:
            case da:
              l_(ee, te);
              var je = ee.key;
              if (typeof je != "string")
                break;
              if (ye === null) {
                ye = /* @__PURE__ */ new Set(), ye.add(je);
                break;
              }
              if (!ye.has(je)) {
                ye.add(je);
                break;
              }
              f("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", je);
              break;
            case dt:
              var We = ee._payload, Be = ee._init;
              ie(Be(We), ye, te);
              break;
          }
        }
        return ye;
      }
      function me(ee, ye, te, je) {
        for (var We = null, Be = 0; Be < te.length; Be++) {
          var kt = te[Be];
          We = ie(kt, We, ee);
        }
        for (var jt = null, wn = null, an = ye, xr = 0, on = 0, mr = null; an !== null && on < te.length; on++) {
          an.index > on ? (mr = an, an = null) : mr = an.sibling;
          var Ua = K(ee, an, te[on], je);
          if (Ua === null) {
            an === null && (an = mr);
            break;
          }
          n && an && Ua.alternate === null && a(ee, an), xr = g(Ua, xr, on), wn === null ? jt = Ua : wn.sibling = Ua, wn = Ua, an = mr;
        }
        if (on === te.length) {
          if (u(ee, an), va()) {
            var Ea = on;
            yf(ee, Ea);
          }
          return jt;
        }
        if (an === null) {
          for (; on < te.length; on++) {
            var Ji = X(ee, te[on], je);
            Ji !== null && (xr = g(Ji, xr, on), wn === null ? jt = Ji : wn.sibling = Ji, wn = Ji);
          }
          if (va()) {
            var oi = on;
            yf(ee, oi);
          }
          return jt;
        }
        for (var si = c(ee, an); on < te.length; on++) {
          var Ha = re(si, ee, on, te[on], je);
          Ha !== null && (n && Ha.alternate !== null && si.delete(Ha.key === null ? on : Ha.key), xr = g(Ha, xr, on), wn === null ? jt = Ha : wn.sibling = Ha, wn = Ha);
        }
        if (n && si.forEach(function(Uh) {
          return a(ee, Uh);
        }), va()) {
          var El = on;
          yf(ee, El);
        }
        return jt;
      }
      function qe(ee, ye, te, je) {
        var We = Ui(te);
        if (typeof We != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          te[Symbol.toStringTag] === "Generator" && (bS || f("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), bS = !0), te.entries === We && (gS || f("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), gS = !0);
          var Be = We.call(te);
          if (Be)
            for (var kt = null, jt = Be.next(); !jt.done; jt = Be.next()) {
              var wn = jt.value;
              kt = ie(wn, kt, ee);
            }
        }
        var an = We.call(te);
        if (an == null)
          throw new Error("An iterable object provided no iterator.");
        for (var xr = null, on = null, mr = ye, Ua = 0, Ea = 0, Ji = null, oi = an.next(); mr !== null && !oi.done; Ea++, oi = an.next()) {
          mr.index > Ea ? (Ji = mr, mr = null) : Ji = mr.sibling;
          var si = K(ee, mr, oi.value, je);
          if (si === null) {
            mr === null && (mr = Ji);
            break;
          }
          n && mr && si.alternate === null && a(ee, mr), Ua = g(si, Ua, Ea), on === null ? xr = si : on.sibling = si, on = si, mr = Ji;
        }
        if (oi.done) {
          if (u(ee, mr), va()) {
            var Ha = Ea;
            yf(ee, Ha);
          }
          return xr;
        }
        if (mr === null) {
          for (; !oi.done; Ea++, oi = an.next()) {
            var El = X(ee, oi.value, je);
            El !== null && (Ua = g(El, Ua, Ea), on === null ? xr = El : on.sibling = El, on = El);
          }
          if (va()) {
            var Uh = Ea;
            yf(ee, Uh);
          }
          return xr;
        }
        for (var zv = c(ee, mr); !oi.done; Ea++, oi = an.next()) {
          var xu = re(zv, ee, Ea, oi.value, je);
          xu !== null && (n && xu.alternate !== null && zv.delete(xu.key === null ? Ea : xu.key), Ua = g(xu, Ua, Ea), on === null ? xr = xu : on.sibling = xu, on = xu);
        }
        if (n && zv.forEach(function(CL) {
          return a(ee, CL);
        }), va()) {
          var EL = Ea;
          yf(ee, EL);
        }
        return xr;
      }
      function ft(ee, ye, te, je) {
        if (ye !== null && ye.tag === O) {
          u(ee, ye.sibling);
          var We = h(ye, te);
          return We.return = ee, We;
        }
        u(ee, ye);
        var Be = Zk(te, ee.mode, je);
        return Be.return = ee, Be;
      }
      function it(ee, ye, te, je) {
        for (var We = te.key, Be = ye; Be !== null; ) {
          if (Be.key === We) {
            var kt = te.type;
            if (kt === Ka) {
              if (Be.tag === R) {
                u(ee, Be.sibling);
                var jt = h(Be, te.props.children);
                return jt.return = ee, jt._debugSource = te._source, jt._debugOwner = te._owner, jt;
              }
            } else if (Be.elementType === kt || // Keep this check inline so it only runs on the false path:
            tO(Be, te) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof kt == "object" && kt !== null && kt.$$typeof === dt && c_(kt) === Be.type) {
              u(ee, Be.sibling);
              var wn = h(Be, te.props);
              return wn.ref = cv(ee, Be, te), wn.return = ee, wn._debugSource = te._source, wn._debugOwner = te._owner, wn;
            }
            u(ee, Be);
            break;
          } else
            a(ee, Be);
          Be = Be.sibling;
        }
        if (te.type === Ka) {
          var an = Kc(te.props.children, ee.mode, je, te.key);
          return an.return = ee, an;
        } else {
          var xr = Yk(te, ee.mode, je);
          return xr.ref = cv(ee, ye, te), xr.return = ee, xr;
        }
      }
      function Qt(ee, ye, te, je) {
        for (var We = te.key, Be = ye; Be !== null; ) {
          if (Be.key === We)
            if (Be.tag === k && Be.stateNode.containerInfo === te.containerInfo && Be.stateNode.implementation === te.implementation) {
              u(ee, Be.sibling);
              var kt = h(Be, te.children || []);
              return kt.return = ee, kt;
            } else {
              u(ee, Be);
              break;
            }
          else
            a(ee, Be);
          Be = Be.sibling;
        }
        var jt = Kk(te, ee.mode, je);
        return jt.return = ee, jt;
      }
      function qt(ee, ye, te, je) {
        var We = typeof te == "object" && te !== null && te.type === Ka && te.key === null;
        if (We && (te = te.props.children), typeof te == "object" && te !== null) {
          switch (te.$$typeof) {
            case uo:
              return E(it(ee, ye, te, je));
            case da:
              return E(Qt(ee, ye, te, je));
            case dt:
              var Be = te._payload, kt = te._init;
              return qt(ee, ye, kt(Be), je);
          }
          if (Wt(te))
            return me(ee, ye, te, je);
          if (Ui(te))
            return qe(ee, ye, te, je);
          gw(ee, te);
        }
        return typeof te == "string" && te !== "" || typeof te == "number" ? E(ft(ee, ye, "" + te, je)) : (typeof te == "function" && bw(ee), u(ee, ye));
      }
      return qt;
    }
    var Th = d_(!0), f_ = d_(!1);
    function f4(n, a) {
      if (n !== null && a.child !== n.child)
        throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var u = a.child, c = Of(u, u.pendingProps);
        for (a.child = c, c.return = a; u.sibling !== null; )
          u = u.sibling, c = c.sibling = Of(u, u.pendingProps), c.return = a;
        c.sibling = null;
      }
    }
    function p4(n, a) {
      for (var u = n.child; u !== null; )
        U8(u, a), u = u.sibling;
    }
    var dv = {}, Bc = $c(dv), fv = $c(dv), ww = $c(dv);
    function xw(n) {
      if (n === dv)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function p_() {
      var n = xw(ww.current);
      return n;
    }
    function kS(n, a) {
      za(ww, a, n), za(fv, n, n), za(Bc, dv, n);
      var u = _7(a);
      Fa(Bc, n), za(Bc, u, n);
    }
    function _h(n) {
      Fa(Bc, n), Fa(fv, n), Fa(ww, n);
    }
    function ES() {
      var n = xw(Bc.current);
      return n;
    }
    function h_(n) {
      xw(ww.current);
      var a = xw(Bc.current), u = R7(a, n.type);
      a !== u && (za(fv, n, n), za(Bc, u, n));
    }
    function CS(n) {
      fv.current === n && (Fa(Bc, n), Fa(fv, n));
    }
    var h4 = 0, m_ = 1, y_ = 1, pv = 2, ds = $c(h4);
    function TS(n, a) {
      return (n & a) !== 0;
    }
    function Rh(n) {
      return n & m_;
    }
    function _S(n, a) {
      return n & m_ | a;
    }
    function m4(n, a) {
      return n | a;
    }
    function Uc(n, a) {
      za(ds, a, n);
    }
    function Oh(n) {
      Fa(ds, n);
    }
    function y4(n, a) {
      var u = n.memoizedState;
      return u !== null ? u.dehydrated !== null : (n.memoizedProps, !0);
    }
    function Sw(n) {
      for (var a = n; a !== null; ) {
        if (a.tag === H) {
          var u = a.memoizedState;
          if (u !== null) {
            var c = u.dehydrated;
            if (c === null || T6(c) || D2(c))
              return a;
          }
        } else if (a.tag === Se && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var h = (a.flags & Et) !== lt;
          if (h)
            return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === n)
          return null;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n)
            return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var ji = (
      /*   */
      0
    ), Fr = (
      /* */
      1
    ), hu = (
      /*  */
      2
    ), zr = (
      /*    */
      4
    ), ga = (
      /*   */
      8
    ), RS = [];
    function OS() {
      for (var n = 0; n < RS.length; n++) {
        var a = RS[n];
        a._workInProgressVersionPrimary = null;
      }
      RS.length = 0;
    }
    function v4(n, a) {
      var u = a._getVersion, c = u(a._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [a, c] : n.mutableSourceEagerHydrationData.push(a, c);
    }
    var He = r.ReactCurrentDispatcher, hv = r.ReactCurrentBatchConfig, PS, Ph;
    PS = /* @__PURE__ */ new Set();
    var Sf = be, bn = null, Br = null, Ur = null, kw = !1, mv = !1, yv = 0, g4 = 0, b4 = 25, xe = null, Co = null, Hc = -1, jS = !1;
    function mn() {
      {
        var n = xe;
        Co === null ? Co = [n] : Co.push(n);
      }
    }
    function Ne() {
      {
        var n = xe;
        Co !== null && (Hc++, Co[Hc] !== n && w4(n));
      }
    }
    function jh(n) {
      n != null && !Wt(n) && f("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", xe, typeof n);
    }
    function w4(n) {
      {
        var a = _t(bn);
        if (!PS.has(a) && (PS.add(a), Co !== null)) {
          for (var u = "", c = 30, h = 0; h <= Hc; h++) {
            for (var g = Co[h], E = h === Hc ? n : g, _ = h + 1 + ". " + g; _.length < c; )
              _ += " ";
            _ += E + `
`, u += _;
          }
          f(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, u);
        }
      }
    }
    function Ba() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function AS(n, a) {
      if (jS)
        return !1;
      if (a === null)
        return f("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", xe), !1;
      n.length !== a.length && f(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, xe, "[" + a.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var u = 0; u < a.length && u < n.length; u++)
        if (!et(n[u], a[u]))
          return !1;
      return !0;
    }
    function Ah(n, a, u, c, h, g) {
      Sf = g, bn = a, Co = n !== null ? n._debugHookTypes : null, Hc = -1, jS = n !== null && n.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = be, n !== null && n.memoizedState !== null ? He.current = N_ : Co !== null ? He.current = L_ : He.current = $_;
      var E = u(c, h);
      if (mv) {
        var _ = 0;
        do {
          if (mv = !1, yv = 0, _ >= b4)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          _ += 1, jS = !1, Br = null, Ur = null, a.updateQueue = null, Hc = -1, He.current = F_, E = u(c, h);
        } while (mv);
      }
      He.current = $w, a._debugHookTypes = Co;
      var P = Br !== null && Br.next !== null;
      if (Sf = be, bn = null, Br = null, Ur = null, xe = null, Co = null, Hc = -1, n !== null && (n.flags & $r) !== (a.flags & $r) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & zt) !== mt && f("Internal React error: Expected static flag was missing. Please notify the React team."), kw = !1, P)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return E;
    }
    function Dh() {
      var n = yv !== 0;
      return yv = 0, n;
    }
    function v_(n, a, u) {
      a.updateQueue = n.updateQueue, (a.mode & ki) !== mt ? a.flags &= ~(qu | Da | Fn | It) : a.flags &= ~(Fn | It), n.lanes = bc(n.lanes, u);
    }
    function g_() {
      if (He.current = $w, kw) {
        for (var n = bn.memoizedState; n !== null; ) {
          var a = n.queue;
          a !== null && (a.pending = null), n = n.next;
        }
        kw = !1;
      }
      Sf = be, bn = null, Br = null, Ur = null, Co = null, Hc = -1, xe = null, j_ = !1, mv = !1, yv = 0;
    }
    function mu() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ur === null ? bn.memoizedState = Ur = n : Ur = Ur.next = n, Ur;
    }
    function To() {
      var n;
      if (Br === null) {
        var a = bn.alternate;
        a !== null ? n = a.memoizedState : n = null;
      } else
        n = Br.next;
      var u;
      if (Ur === null ? u = bn.memoizedState : u = Ur.next, u !== null)
        Ur = u, u = Ur.next, Br = n;
      else {
        if (n === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Br = n;
        var c = {
          memoizedState: Br.memoizedState,
          baseState: Br.baseState,
          baseQueue: Br.baseQueue,
          queue: Br.queue,
          next: null
        };
        Ur === null ? bn.memoizedState = Ur = c : Ur = Ur.next = c;
      }
      return Ur;
    }
    function b_() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function DS(n, a) {
      return typeof a == "function" ? a(n) : a;
    }
    function IS(n, a, u) {
      var c = mu(), h;
      u !== void 0 ? h = u(a) : h = a, c.memoizedState = c.baseState = h;
      var g = {
        pending: null,
        interleaved: null,
        lanes: be,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: h
      };
      c.queue = g;
      var E = g.dispatch = E4.bind(null, bn, g);
      return [c.memoizedState, E];
    }
    function MS(n, a, u) {
      var c = To(), h = c.queue;
      if (h === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = n;
      var g = Br, E = g.baseQueue, _ = h.pending;
      if (_ !== null) {
        if (E !== null) {
          var P = E.next, M = _.next;
          E.next = M, _.next = P;
        }
        g.baseQueue !== E && f("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), g.baseQueue = E = _, h.pending = null;
      }
      if (E !== null) {
        var F = E.next, X = g.baseState, K = null, re = null, ie = null, me = F;
        do {
          var qe = me.lane;
          if (nl(Sf, qe)) {
            if (ie !== null) {
              var it = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Zt,
                action: me.action,
                hasEagerState: me.hasEagerState,
                eagerState: me.eagerState,
                next: null
              };
              ie = ie.next = it;
            }
            if (me.hasEagerState)
              X = me.eagerState;
            else {
              var Qt = me.action;
              X = n(X, Qt);
            }
          } else {
            var ft = {
              lane: qe,
              action: me.action,
              hasEagerState: me.hasEagerState,
              eagerState: me.eagerState,
              next: null
            };
            ie === null ? (re = ie = ft, K = X) : ie = ie.next = ft, bn.lanes = Mt(bn.lanes, qe), Mv(qe);
          }
          me = me.next;
        } while (me !== null && me !== F);
        ie === null ? K = X : ie.next = re, et(X, c.memoizedState) || kv(), c.memoizedState = X, c.baseState = K, c.baseQueue = ie, h.lastRenderedState = X;
      }
      var qt = h.interleaved;
      if (qt !== null) {
        var ee = qt;
        do {
          var ye = ee.lane;
          bn.lanes = Mt(bn.lanes, ye), Mv(ye), ee = ee.next;
        } while (ee !== qt);
      } else
        E === null && (h.lanes = be);
      var te = h.dispatch;
      return [c.memoizedState, te];
    }
    function $S(n, a, u) {
      var c = To(), h = c.queue;
      if (h === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = n;
      var g = h.dispatch, E = h.pending, _ = c.memoizedState;
      if (E !== null) {
        h.pending = null;
        var P = E.next, M = P;
        do {
          var F = M.action;
          _ = n(_, F), M = M.next;
        } while (M !== P);
        et(_, c.memoizedState) || kv(), c.memoizedState = _, c.baseQueue === null && (c.baseState = _), h.lastRenderedState = _;
      }
      return [_, g];
    }
    function rX(n, a, u) {
    }
    function aX(n, a, u) {
    }
    function LS(n, a, u) {
      var c = bn, h = mu(), g, E = va();
      if (E) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        g = u(), Ph || g !== u() && (f("The result of getServerSnapshot should be cached to avoid an infinite loop"), Ph = !0);
      } else {
        if (g = a(), !Ph) {
          var _ = a();
          et(g, _) || (f("The result of getSnapshot should be cached to avoid an infinite loop"), Ph = !0);
        }
        var P = e1();
        if (P === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Xd(P, Sf) || w_(c, a, g);
      }
      h.memoizedState = g;
      var M = {
        value: g,
        getSnapshot: a
      };
      return h.queue = M, Rw(S_.bind(null, c, M, n), [n]), c.flags |= Fn, vv(Fr | ga, x_.bind(null, c, M, g, a), void 0, null), g;
    }
    function Ew(n, a, u) {
      var c = bn, h = To(), g = a();
      if (!Ph) {
        var E = a();
        et(g, E) || (f("The result of getSnapshot should be cached to avoid an infinite loop"), Ph = !0);
      }
      var _ = h.memoizedState, P = !et(_, g);
      P && (h.memoizedState = g, kv());
      var M = h.queue;
      if (bv(S_.bind(null, c, M, n), [n]), M.getSnapshot !== a || P || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ur !== null && Ur.memoizedState.tag & Fr) {
        c.flags |= Fn, vv(Fr | ga, x_.bind(null, c, M, g, a), void 0, null);
        var F = e1();
        if (F === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Xd(F, Sf) || w_(c, a, g);
      }
      return g;
    }
    function w_(n, a, u) {
      n.flags |= Hd;
      var c = {
        getSnapshot: a,
        value: u
      }, h = bn.updateQueue;
      if (h === null)
        h = b_(), bn.updateQueue = h, h.stores = [c];
      else {
        var g = h.stores;
        g === null ? h.stores = [c] : g.push(c);
      }
    }
    function x_(n, a, u, c) {
      a.value = u, a.getSnapshot = c, k_(a) && E_(n);
    }
    function S_(n, a, u) {
      var c = function() {
        k_(a) && E_(n);
      };
      return u(c);
    }
    function k_(n) {
      var a = n.getSnapshot, u = n.value;
      try {
        var c = a();
        return !et(u, c);
      } catch {
        return !0;
      }
    }
    function E_(n) {
      var a = Pi(n, gt);
      a !== null && qr(a, n, gt, Cn);
    }
    function Cw(n) {
      var a = mu();
      typeof n == "function" && (n = n()), a.memoizedState = a.baseState = n;
      var u = {
        pending: null,
        interleaved: null,
        lanes: be,
        dispatch: null,
        lastRenderedReducer: DS,
        lastRenderedState: n
      };
      a.queue = u;
      var c = u.dispatch = C4.bind(null, bn, u);
      return [a.memoizedState, c];
    }
    function NS(n) {
      return MS(DS);
    }
    function FS(n) {
      return $S(DS);
    }
    function vv(n, a, u, c) {
      var h = {
        tag: n,
        create: a,
        destroy: u,
        deps: c,
        // Circular
        next: null
      }, g = bn.updateQueue;
      if (g === null)
        g = b_(), bn.updateQueue = g, g.lastEffect = h.next = h;
      else {
        var E = g.lastEffect;
        if (E === null)
          g.lastEffect = h.next = h;
        else {
          var _ = E.next;
          E.next = h, h.next = _, g.lastEffect = h;
        }
      }
      return h;
    }
    function zS(n) {
      var a = mu();
      {
        var u = {
          current: n
        };
        return a.memoizedState = u, u;
      }
    }
    function Tw(n) {
      var a = To();
      return a.memoizedState;
    }
    function gv(n, a, u, c) {
      var h = mu(), g = c === void 0 ? null : c;
      bn.flags |= n, h.memoizedState = vv(Fr | a, u, void 0, g);
    }
    function _w(n, a, u, c) {
      var h = To(), g = c === void 0 ? null : c, E = void 0;
      if (Br !== null) {
        var _ = Br.memoizedState;
        if (E = _.destroy, g !== null) {
          var P = _.deps;
          if (AS(g, P)) {
            h.memoizedState = vv(a, u, E, g);
            return;
          }
        }
      }
      bn.flags |= n, h.memoizedState = vv(Fr | a, u, E, g);
    }
    function Rw(n, a) {
      return (bn.mode & ki) !== mt ? gv(qu | Fn | Qs, ga, n, a) : gv(Fn | Qs, ga, n, a);
    }
    function bv(n, a) {
      return _w(Fn, ga, n, a);
    }
    function BS(n, a) {
      return gv(It, hu, n, a);
    }
    function Ow(n, a) {
      return _w(It, hu, n, a);
    }
    function US(n, a) {
      var u = It;
      return u |= Aa, (bn.mode & ki) !== mt && (u |= Da), gv(u, zr, n, a);
    }
    function Pw(n, a) {
      return _w(It, zr, n, a);
    }
    function C_(n, a) {
      if (typeof a == "function") {
        var u = a, c = n();
        return u(c), function() {
          u(null);
        };
      } else if (a != null) {
        var h = a;
        h.hasOwnProperty("current") || f("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(h).join(", ") + "}");
        var g = n();
        return h.current = g, function() {
          h.current = null;
        };
      }
    }
    function HS(n, a, u) {
      typeof a != "function" && f("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var c = u != null ? u.concat([n]) : null, h = It;
      return h |= Aa, (bn.mode & ki) !== mt && (h |= Da), gv(h, zr, C_.bind(null, a, n), c);
    }
    function jw(n, a, u) {
      typeof a != "function" && f("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var c = u != null ? u.concat([n]) : null;
      return _w(It, zr, C_.bind(null, a, n), c);
    }
    function x4(n, a) {
    }
    var Aw = x4;
    function VS(n, a) {
      var u = mu(), c = a === void 0 ? null : a;
      return u.memoizedState = [n, c], n;
    }
    function Dw(n, a) {
      var u = To(), c = a === void 0 ? null : a, h = u.memoizedState;
      if (h !== null && c !== null) {
        var g = h[1];
        if (AS(c, g))
          return h[0];
      }
      return u.memoizedState = [n, c], n;
    }
    function GS(n, a) {
      var u = mu(), c = a === void 0 ? null : a, h = n();
      return u.memoizedState = [h, c], h;
    }
    function Iw(n, a) {
      var u = To(), c = a === void 0 ? null : a, h = u.memoizedState;
      if (h !== null && c !== null) {
        var g = h[1];
        if (AS(c, g))
          return h[0];
      }
      var E = n();
      return u.memoizedState = [E, c], E;
    }
    function qS(n) {
      var a = mu();
      return a.memoizedState = n, n;
    }
    function T_(n) {
      var a = To(), u = Br, c = u.memoizedState;
      return R_(a, c, n);
    }
    function __(n) {
      var a = To();
      if (Br === null)
        return a.memoizedState = n, n;
      var u = Br.memoizedState;
      return R_(a, u, n);
    }
    function R_(n, a, u) {
      var c = !Xx(Sf);
      if (c) {
        if (!et(u, a)) {
          var h = wy();
          bn.lanes = Mt(bn.lanes, h), Mv(h), n.baseState = !0;
        }
        return a;
      } else
        return n.baseState && (n.baseState = !1, kv()), n.memoizedState = u, u;
    }
    function S4(n, a, u) {
      var c = Ci();
      gr(Jr(c, Nr)), n(!0);
      var h = hv.transition;
      hv.transition = {};
      var g = hv.transition;
      hv.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        n(!1), a();
      } finally {
        if (gr(c), hv.transition = h, h === null && g._updatedFibers) {
          var E = g._updatedFibers.size;
          E > 10 && d("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), g._updatedFibers.clear();
        }
      }
    }
    function WS() {
      var n = Cw(!1), a = n[0], u = n[1], c = S4.bind(null, u), h = mu();
      return h.memoizedState = c, [a, c];
    }
    function O_() {
      var n = NS(), a = n[0], u = To(), c = u.memoizedState;
      return [a, c];
    }
    function P_() {
      var n = FS(), a = n[0], u = To(), c = u.memoizedState;
      return [a, c];
    }
    var j_ = !1;
    function k4() {
      return j_;
    }
    function YS() {
      var n = mu(), a = e1(), u = a.identifierPrefix, c;
      if (va()) {
        var h = LM();
        c = ":" + u + "R" + h;
        var g = yv++;
        g > 0 && (c += "H" + g.toString(32)), c += ":";
      } else {
        var E = g4++;
        c = ":" + u + "r" + E.toString(32) + ":";
      }
      return n.memoizedState = c, c;
    }
    function Mw() {
      var n = To(), a = n.memoizedState;
      return a;
    }
    function E4(n, a, u) {
      typeof arguments[3] == "function" && f("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Yc(n), h = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (A_(n))
        D_(a, h);
      else {
        var g = K6(n, a, h, c);
        if (g !== null) {
          var E = ii();
          qr(g, n, c, E), I_(g, a, c);
        }
      }
      M_(n, c);
    }
    function C4(n, a, u) {
      typeof arguments[3] == "function" && f("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Yc(n), h = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (A_(n))
        D_(a, h);
      else {
        var g = n.alternate;
        if (n.lanes === be && (g === null || g.lanes === be)) {
          var E = a.lastRenderedReducer;
          if (E !== null) {
            var _;
            _ = He.current, He.current = fs;
            try {
              var P = a.lastRenderedState, M = E(P, u);
              if (h.hasEagerState = !0, h.eagerState = M, et(M, P)) {
                r4(n, a, h, c);
                return;
              }
            } catch {
            } finally {
              He.current = _;
            }
          }
        }
        var F = K6(n, a, h, c);
        if (F !== null) {
          var X = ii();
          qr(F, n, c, X), I_(F, a, c);
        }
      }
      M_(n, c);
    }
    function A_(n) {
      var a = n.alternate;
      return n === bn || a !== null && a === bn;
    }
    function D_(n, a) {
      mv = kw = !0;
      var u = n.pending;
      u === null ? a.next = a : (a.next = u.next, u.next = a), n.pending = a;
    }
    function I_(n, a, u) {
      if (by(u)) {
        var c = a.lanes;
        c = xy(c, n.pendingLanes);
        var h = Mt(c, u);
        a.lanes = h, wc(n, h);
      }
    }
    function M_(n, a, u) {
      ru(n, a);
    }
    var $w = {
      readContext: Dr,
      useCallback: Ba,
      useContext: Ba,
      useEffect: Ba,
      useImperativeHandle: Ba,
      useInsertionEffect: Ba,
      useLayoutEffect: Ba,
      useMemo: Ba,
      useReducer: Ba,
      useRef: Ba,
      useState: Ba,
      useDebugValue: Ba,
      useDeferredValue: Ba,
      useTransition: Ba,
      useMutableSource: Ba,
      useSyncExternalStore: Ba,
      useId: Ba,
      unstable_isNewReconciler: pe
    }, $_ = null, L_ = null, N_ = null, F_ = null, yu = null, fs = null, Lw = null;
    {
      var ZS = function() {
        f("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Rt = function() {
        f("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      $_ = {
        readContext: function(n) {
          return Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", mn(), jh(a), VS(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", mn(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", mn(), jh(a), Rw(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", mn(), jh(u), HS(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", mn(), jh(a), BS(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", mn(), jh(a), US(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", mn(), jh(a);
          var u = He.current;
          He.current = yu;
          try {
            return GS(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", mn();
          var c = He.current;
          He.current = yu;
          try {
            return IS(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", mn(), zS(n);
        },
        useState: function(n) {
          xe = "useState", mn();
          var a = He.current;
          He.current = yu;
          try {
            return Cw(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", mn(), void 0;
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", mn(), qS(n);
        },
        useTransition: function() {
          return xe = "useTransition", mn(), WS();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", mn(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", mn(), LS(n, a, u);
        },
        useId: function() {
          return xe = "useId", mn(), YS();
        },
        unstable_isNewReconciler: pe
      }, L_ = {
        readContext: function(n) {
          return Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Ne(), VS(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Ne(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Ne(), Rw(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Ne(), HS(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Ne(), BS(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Ne(), US(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Ne();
          var u = He.current;
          He.current = yu;
          try {
            return GS(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Ne();
          var c = He.current;
          He.current = yu;
          try {
            return IS(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Ne(), zS(n);
        },
        useState: function(n) {
          xe = "useState", Ne();
          var a = He.current;
          He.current = yu;
          try {
            return Cw(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Ne(), void 0;
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Ne(), qS(n);
        },
        useTransition: function() {
          return xe = "useTransition", Ne(), WS();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Ne(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Ne(), LS(n, a, u);
        },
        useId: function() {
          return xe = "useId", Ne(), YS();
        },
        unstable_isNewReconciler: pe
      }, N_ = {
        readContext: function(n) {
          return Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Ne(), Dw(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Ne(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Ne(), bv(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Ne(), jw(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Ne(), Ow(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Ne(), Pw(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Ne();
          var u = He.current;
          He.current = fs;
          try {
            return Iw(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Ne();
          var c = He.current;
          He.current = fs;
          try {
            return MS(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Ne(), Tw();
        },
        useState: function(n) {
          xe = "useState", Ne();
          var a = He.current;
          He.current = fs;
          try {
            return NS(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Ne(), Aw();
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Ne(), T_(n);
        },
        useTransition: function() {
          return xe = "useTransition", Ne(), O_();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Ne(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Ne(), Ew(n, a);
        },
        useId: function() {
          return xe = "useId", Ne(), Mw();
        },
        unstable_isNewReconciler: pe
      }, F_ = {
        readContext: function(n) {
          return Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Ne(), Dw(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Ne(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Ne(), bv(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Ne(), jw(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Ne(), Ow(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Ne(), Pw(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Ne();
          var u = He.current;
          He.current = Lw;
          try {
            return Iw(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Ne();
          var c = He.current;
          He.current = Lw;
          try {
            return $S(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Ne(), Tw();
        },
        useState: function(n) {
          xe = "useState", Ne();
          var a = He.current;
          He.current = Lw;
          try {
            return FS(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Ne(), Aw();
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Ne(), __(n);
        },
        useTransition: function() {
          return xe = "useTransition", Ne(), P_();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Ne(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Ne(), Ew(n, a);
        },
        useId: function() {
          return xe = "useId", Ne(), Mw();
        },
        unstable_isNewReconciler: pe
      }, yu = {
        readContext: function(n) {
          return ZS(), Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Rt(), mn(), VS(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Rt(), mn(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Rt(), mn(), Rw(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Rt(), mn(), HS(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Rt(), mn(), BS(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Rt(), mn(), US(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Rt(), mn();
          var u = He.current;
          He.current = yu;
          try {
            return GS(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Rt(), mn();
          var c = He.current;
          He.current = yu;
          try {
            return IS(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Rt(), mn(), zS(n);
        },
        useState: function(n) {
          xe = "useState", Rt(), mn();
          var a = He.current;
          He.current = yu;
          try {
            return Cw(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Rt(), mn(), void 0;
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Rt(), mn(), qS(n);
        },
        useTransition: function() {
          return xe = "useTransition", Rt(), mn(), WS();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Rt(), mn(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Rt(), mn(), LS(n, a, u);
        },
        useId: function() {
          return xe = "useId", Rt(), mn(), YS();
        },
        unstable_isNewReconciler: pe
      }, fs = {
        readContext: function(n) {
          return ZS(), Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Rt(), Ne(), Dw(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Rt(), Ne(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Rt(), Ne(), bv(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Rt(), Ne(), jw(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Rt(), Ne(), Ow(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Rt(), Ne(), Pw(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Rt(), Ne();
          var u = He.current;
          He.current = fs;
          try {
            return Iw(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Rt(), Ne();
          var c = He.current;
          He.current = fs;
          try {
            return MS(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Rt(), Ne(), Tw();
        },
        useState: function(n) {
          xe = "useState", Rt(), Ne();
          var a = He.current;
          He.current = fs;
          try {
            return NS(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Rt(), Ne(), Aw();
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Rt(), Ne(), T_(n);
        },
        useTransition: function() {
          return xe = "useTransition", Rt(), Ne(), O_();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Rt(), Ne(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Rt(), Ne(), Ew(n, a);
        },
        useId: function() {
          return xe = "useId", Rt(), Ne(), Mw();
        },
        unstable_isNewReconciler: pe
      }, Lw = {
        readContext: function(n) {
          return ZS(), Dr(n);
        },
        useCallback: function(n, a) {
          return xe = "useCallback", Rt(), Ne(), Dw(n, a);
        },
        useContext: function(n) {
          return xe = "useContext", Rt(), Ne(), Dr(n);
        },
        useEffect: function(n, a) {
          return xe = "useEffect", Rt(), Ne(), bv(n, a);
        },
        useImperativeHandle: function(n, a, u) {
          return xe = "useImperativeHandle", Rt(), Ne(), jw(n, a, u);
        },
        useInsertionEffect: function(n, a) {
          return xe = "useInsertionEffect", Rt(), Ne(), Ow(n, a);
        },
        useLayoutEffect: function(n, a) {
          return xe = "useLayoutEffect", Rt(), Ne(), Pw(n, a);
        },
        useMemo: function(n, a) {
          xe = "useMemo", Rt(), Ne();
          var u = He.current;
          He.current = fs;
          try {
            return Iw(n, a);
          } finally {
            He.current = u;
          }
        },
        useReducer: function(n, a, u) {
          xe = "useReducer", Rt(), Ne();
          var c = He.current;
          He.current = fs;
          try {
            return $S(n, a, u);
          } finally {
            He.current = c;
          }
        },
        useRef: function(n) {
          return xe = "useRef", Rt(), Ne(), Tw();
        },
        useState: function(n) {
          xe = "useState", Rt(), Ne();
          var a = He.current;
          He.current = fs;
          try {
            return FS(n);
          } finally {
            He.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return xe = "useDebugValue", Rt(), Ne(), Aw();
        },
        useDeferredValue: function(n) {
          return xe = "useDeferredValue", Rt(), Ne(), __(n);
        },
        useTransition: function() {
          return xe = "useTransition", Rt(), Ne(), P_();
        },
        useMutableSource: function(n, a, u) {
          return xe = "useMutableSource", Rt(), Ne(), void 0;
        },
        useSyncExternalStore: function(n, a, u) {
          return xe = "useSyncExternalStore", Rt(), Ne(), Ew(n, a);
        },
        useId: function() {
          return xe = "useId", Rt(), Ne(), Mw();
        },
        unstable_isNewReconciler: pe
      };
    }
    var Vc = t.unstable_now, z_ = 0, Nw = -1, wv = -1, Fw = -1, KS = !1, zw = !1;
    function B_() {
      return KS;
    }
    function T4() {
      zw = !0;
    }
    function _4() {
      KS = !1, zw = !1;
    }
    function R4() {
      KS = zw, zw = !1;
    }
    function U_() {
      return z_;
    }
    function H_() {
      z_ = Vc();
    }
    function QS(n) {
      wv = Vc(), n.actualStartTime < 0 && (n.actualStartTime = Vc());
    }
    function V_(n) {
      wv = -1;
    }
    function Bw(n, a) {
      if (wv >= 0) {
        var u = Vc() - wv;
        n.actualDuration += u, a && (n.selfBaseDuration = u), wv = -1;
      }
    }
    function vu(n) {
      if (Nw >= 0) {
        var a = Vc() - Nw;
        Nw = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case b:
              var c = u.stateNode;
              c.effectDuration += a;
              return;
            case B:
              var h = u.stateNode;
              h.effectDuration += a;
              return;
          }
          u = u.return;
        }
      }
    }
    function XS(n) {
      if (Fw >= 0) {
        var a = Vc() - Fw;
        Fw = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case b:
              var c = u.stateNode;
              c !== null && (c.passiveEffectDuration += a);
              return;
            case B:
              var h = u.stateNode;
              h !== null && (h.passiveEffectDuration += a);
              return;
          }
          u = u.return;
        }
      }
    }
    function gu() {
      Nw = Vc();
    }
    function JS() {
      Fw = Vc();
    }
    function ek(n) {
      for (var a = n.child; a; )
        n.actualDuration += a.actualDuration, a = a.sibling;
    }
    function kf(n, a) {
      return {
        value: n,
        source: a,
        stack: Ql(a),
        digest: null
      };
    }
    function tk(n, a, u) {
      return {
        value: n,
        source: null,
        stack: u ?? null,
        digest: a ?? null
      };
    }
    function O4(n, a) {
      return !0;
    }
    function nk(n, a) {
      try {
        var u = O4(n, a);
        if (u === !1)
          return;
        var c = a.value, h = a.source, g = a.stack, E = g !== null ? g : "";
        if (c != null && c._suppressLogging) {
          if (n.tag === w)
            return;
          console.error(c);
        }
        var _ = h ? _t(h) : null, P = _ ? "The above error occurred in the <" + _ + "> component:" : "The above error occurred in one of your React components:", M;
        if (n.tag === b)
          M = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var F = _t(n) || "Anonymous";
          M = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + F + ".");
        }
        var X = P + `
` + E + `

` + ("" + M);
        console.error(X);
      } catch (K) {
        setTimeout(function() {
          throw K;
        });
      }
    }
    var P4 = typeof WeakMap == "function" ? WeakMap : Map;
    function G_(n, a, u) {
      var c = gl(Cn, u);
      c.tag = nS, c.payload = {
        element: null
      };
      var h = a.value;
      return c.callback = function() {
        S8(h), nk(n, a);
      }, c;
    }
    function rk(n, a, u) {
      var c = gl(Cn, u);
      c.tag = nS;
      var h = n.type.getDerivedStateFromError;
      if (typeof h == "function") {
        var g = a.value;
        c.payload = function() {
          return h(g);
        }, c.callback = function() {
          nO(n), nk(n, a);
        };
      }
      var E = n.stateNode;
      return E !== null && typeof E.componentDidCatch == "function" && (c.callback = function() {
        nO(n), nk(n, a), typeof h != "function" && w8(this);
        var P = a.value, M = a.stack;
        this.componentDidCatch(P, {
          componentStack: M !== null ? M : ""
        }), typeof h != "function" && (Na(n.lanes, gt) || f("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", _t(n) || "Unknown"));
      }), c;
    }
    function q_(n, a, u) {
      var c = n.pingCache, h;
      if (c === null ? (c = n.pingCache = new P4(), h = /* @__PURE__ */ new Set(), c.set(a, h)) : (h = c.get(a), h === void 0 && (h = /* @__PURE__ */ new Set(), c.set(a, h))), !h.has(u)) {
        h.add(u);
        var g = k8.bind(null, n, a, u);
        Lr && $v(n, u), a.then(g, g);
      }
    }
    function j4(n, a, u, c) {
      var h = n.updateQueue;
      if (h === null) {
        var g = /* @__PURE__ */ new Set();
        g.add(u), n.updateQueue = g;
      } else
        h.add(u);
    }
    function A4(n, a) {
      var u = n.tag;
      if ((n.mode & zt) === mt && (u === v || u === L || u === W)) {
        var c = n.alternate;
        c ? (n.updateQueue = c.updateQueue, n.memoizedState = c.memoizedState, n.lanes = c.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function W_(n) {
      var a = n;
      do {
        if (a.tag === H && y4(a))
          return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function Y_(n, a, u, c, h) {
      if ((n.mode & zt) === mt) {
        if (n === a)
          n.flags |= Rr;
        else {
          if (n.flags |= Et, u.flags |= Vd, u.flags &= ~(gp | Qa), u.tag === w) {
            var g = u.alternate;
            if (g === null)
              u.tag = ce;
            else {
              var E = gl(Cn, gt);
              E.tag = dw, zc(u, E, gt);
            }
          }
          u.lanes = Mt(u.lanes, gt);
        }
        return n;
      }
      return n.flags |= Rr, n.lanes = h, n;
    }
    function D4(n, a, u, c, h) {
      if (u.flags |= Qa, Lr && $v(n, h), c !== null && typeof c == "object" && typeof c.then == "function") {
        var g = c;
        A4(u), va() && u.mode & zt && N6();
        var E = W_(a);
        if (E !== null) {
          E.flags &= ~er, Y_(E, a, u, n, h), E.mode & zt && q_(n, g, h), j4(E, n, g);
          return;
        } else {
          if (!gc(h)) {
            q_(n, g, h), $k();
            return;
          }
          var _ = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          c = _;
        }
      } else if (va() && u.mode & zt) {
        N6();
        var P = W_(a);
        if (P !== null) {
          (P.flags & Rr) === lt && (P.flags |= er), Y_(P, a, u, n, h), Z2(kf(c, u));
          return;
        }
      }
      c = kf(c, u), f8(c);
      var M = a;
      do {
        switch (M.tag) {
          case b: {
            var F = c;
            M.flags |= Rr;
            var X = vr(h);
            M.lanes = Mt(M.lanes, X);
            var K = G_(M, F, X);
            iS(M, K);
            return;
          }
          case w:
            var re = c, ie = M.type, me = M.stateNode;
            if ((M.flags & Et) === lt && (typeof ie.getDerivedStateFromError == "function" || me !== null && typeof me.componentDidCatch == "function" && !WR(me))) {
              M.flags |= Rr;
              var qe = vr(h);
              M.lanes = Mt(M.lanes, qe);
              var ft = rk(M, re, qe);
              iS(M, ft);
              return;
            }
            break;
        }
        M = M.return;
      } while (M !== null);
    }
    function I4() {
      return null;
    }
    var xv = r.ReactCurrentOwner, ps = !1, ak, Sv, ik, ok, sk, Ef, uk, Uw;
    ak = {}, Sv = {}, ik = {}, ok = {}, sk = {}, Ef = !1, uk = {}, Uw = {};
    function ri(n, a, u, c) {
      n === null ? a.child = f_(a, null, u, c) : a.child = Th(a, n.child, u, c);
    }
    function M4(n, a, u, c) {
      a.child = Th(a, n.child, null, c), a.child = Th(a, null, u, c);
    }
    function Z_(n, a, u, c, h) {
      if (a.type !== a.elementType) {
        var g = u.propTypes;
        g && ss(
          g,
          c,
          // Resolved props
          "prop",
          en(u)
        );
      }
      var E = u.render, _ = a.ref, P, M;
      Ch(a, h), nu(a);
      {
        if (xv.current = a, Oa(!0), P = Ah(n, a, E, c, _, h), M = Dh(), a.mode & Zn) {
          yr(!0);
          try {
            P = Ah(n, a, E, c, _, h), M = Dh();
          } finally {
            yr(!1);
          }
        }
        Oa(!1);
      }
      return Wu(), n !== null && !ps ? (v_(n, a, h), bl(n, a, h)) : (va() && M && H2(a), a.flags |= Zs, ri(n, a, P, h), a.child);
    }
    function K_(n, a, u, c, h) {
      if (n === null) {
        var g = u.type;
        if (z8(g) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var E = g;
          return E = Bh(g), a.tag = W, a.type = E, dk(a, g), Q_(n, a, E, c, h);
        }
        {
          var _ = g.propTypes;
          _ && ss(
            _,
            c,
            // Resolved props
            "prop",
            en(g)
          );
        }
        var P = Wk(u.type, null, c, a, a.mode, h);
        return P.ref = a.ref, P.return = a, a.child = P, P;
      }
      {
        var M = u.type, F = M.propTypes;
        F && ss(
          F,
          c,
          // Resolved props
          "prop",
          en(M)
        );
      }
      var X = n.child, K = vk(n, h);
      if (!K) {
        var re = X.memoizedProps, ie = u.compare;
        if (ie = ie !== null ? ie : st, ie(re, c) && n.ref === a.ref)
          return bl(n, a, h);
      }
      a.flags |= Zs;
      var me = Of(X, c);
      return me.ref = a.ref, me.return = a, a.child = me, me;
    }
    function Q_(n, a, u, c, h) {
      if (a.type !== a.elementType) {
        var g = a.elementType;
        if (g.$$typeof === dt) {
          var E = g, _ = E._payload, P = E._init;
          try {
            g = P(_);
          } catch {
            g = null;
          }
          var M = g && g.propTypes;
          M && ss(
            M,
            c,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            en(g)
          );
        }
      }
      if (n !== null) {
        var F = n.memoizedProps;
        if (st(F, c) && n.ref === a.ref && // Prevent bailout if the implementation changed due to hot reload.
        a.type === n.type)
          if (ps = !1, a.pendingProps = c = F, vk(n, h))
            (n.flags & Vd) !== lt && (ps = !0);
          else
            return a.lanes = n.lanes, bl(n, a, h);
      }
      return lk(n, a, u, c, h);
    }
    function X_(n, a, u) {
      var c = a.pendingProps, h = c.children, g = n !== null ? n.memoizedState : null;
      if (c.mode === "hidden" || z)
        if ((a.mode & zt) === mt) {
          var E = {
            baseLanes: be,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = E, t1(a, u);
        } else if (Na(u, La)) {
          var X = {
            baseLanes: be,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = X;
          var K = g !== null ? g.baseLanes : u;
          t1(a, K);
        } else {
          var _ = null, P;
          if (g !== null) {
            var M = g.baseLanes;
            P = Mt(M, u);
          } else
            P = u;
          a.lanes = a.childLanes = La;
          var F = {
            baseLanes: P,
            cachePool: _,
            transitions: null
          };
          return a.memoizedState = F, a.updateQueue = null, t1(a, P), null;
        }
      else {
        var re;
        g !== null ? (re = Mt(g.baseLanes, u), a.memoizedState = null) : re = u, t1(a, re);
      }
      return ri(n, a, h, u), a.child;
    }
    function $4(n, a, u) {
      var c = a.pendingProps;
      return ri(n, a, c, u), a.child;
    }
    function L4(n, a, u) {
      var c = a.pendingProps.children;
      return ri(n, a, c, u), a.child;
    }
    function N4(n, a, u) {
      {
        a.flags |= It;
        {
          var c = a.stateNode;
          c.effectDuration = 0, c.passiveEffectDuration = 0;
        }
      }
      var h = a.pendingProps, g = h.children;
      return ri(n, a, g, u), a.child;
    }
    function J_(n, a) {
      var u = a.ref;
      (n === null && u !== null || n !== null && n.ref !== u) && (a.flags |= ja, a.flags |= ay);
    }
    function lk(n, a, u, c, h) {
      if (a.type !== a.elementType) {
        var g = u.propTypes;
        g && ss(
          g,
          c,
          // Resolved props
          "prop",
          en(u)
        );
      }
      var E;
      {
        var _ = bh(a, u, !0);
        E = wh(a, _);
      }
      var P, M;
      Ch(a, h), nu(a);
      {
        if (xv.current = a, Oa(!0), P = Ah(n, a, u, c, E, h), M = Dh(), a.mode & Zn) {
          yr(!0);
          try {
            P = Ah(n, a, u, c, E, h), M = Dh();
          } finally {
            yr(!1);
          }
        }
        Oa(!1);
      }
      return Wu(), n !== null && !ps ? (v_(n, a, h), bl(n, a, h)) : (va() && M && H2(a), a.flags |= Zs, ri(n, a, P, h), a.child);
    }
    function eR(n, a, u, c, h) {
      {
        switch (tL(a)) {
          case !1: {
            var g = a.stateNode, E = a.type, _ = new E(a.memoizedProps, g.context), P = _.state;
            g.updater.enqueueSetState(g, P, null);
            break;
          }
          case !0: {
            a.flags |= Et, a.flags |= Rr;
            var M = new Error("Simulated error coming from DevTools"), F = vr(h);
            a.lanes = Mt(a.lanes, F);
            var X = rk(a, kf(M, a), F);
            iS(a, X);
            break;
          }
        }
        if (a.type !== a.elementType) {
          var K = u.propTypes;
          K && ss(
            K,
            c,
            // Resolved props
            "prop",
            en(u)
          );
        }
      }
      var re;
      pu(u) ? (re = !0, ew(a)) : re = !1, Ch(a, h);
      var ie = a.stateNode, me;
      ie === null ? (Vw(n, a), s_(a, u, c), vS(a, u, c, h), me = !0) : n === null ? me = c4(a, u, c, h) : me = d4(n, a, u, c, h);
      var qe = ck(n, a, u, me, re, h);
      {
        var ft = a.stateNode;
        me && ft.props !== c && (Ef || f("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", _t(a) || "a component"), Ef = !0);
      }
      return qe;
    }
    function ck(n, a, u, c, h, g) {
      J_(n, a);
      var E = (a.flags & Et) !== lt;
      if (!c && !E)
        return h && I6(a, u, !1), bl(n, a, g);
      var _ = a.stateNode;
      xv.current = a;
      var P;
      if (E && typeof u.getDerivedStateFromError != "function")
        P = null, V_();
      else {
        nu(a);
        {
          if (Oa(!0), P = _.render(), a.mode & Zn) {
            yr(!0);
            try {
              _.render();
            } finally {
              yr(!1);
            }
          }
          Oa(!1);
        }
        Wu();
      }
      return a.flags |= Zs, n !== null && E ? M4(n, a, P, g) : ri(n, a, P, g), a.memoizedState = _.state, h && I6(a, u, !0), a.child;
    }
    function tR(n) {
      var a = n.stateNode;
      a.pendingContext ? A6(n, a.pendingContext, a.pendingContext !== a.context) : a.context && A6(n, a.context, !1), kS(n, a.containerInfo);
    }
    function F4(n, a, u) {
      if (tR(a), n === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var c = a.pendingProps, h = a.memoizedState, g = h.element;
      J6(n, a), mw(a, c, null, u);
      var E = a.memoizedState;
      a.stateNode;
      var _ = E.element;
      if (h.isDehydrated) {
        var P = {
          element: _,
          isDehydrated: !1,
          cache: E.cache,
          pendingSuspenseBoundaries: E.pendingSuspenseBoundaries,
          transitions: E.transitions
        }, M = a.updateQueue;
        if (M.baseState = P, a.memoizedState = P, a.flags & er) {
          var F = kf(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return nR(n, a, _, u, F);
        } else if (_ !== g) {
          var X = kf(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return nR(n, a, _, u, X);
        } else {
          HM(a);
          var K = f_(a, null, _, u);
          a.child = K;
          for (var re = K; re; )
            re.flags = re.flags & ~Dn | wi, re = re.sibling;
        }
      } else {
        if (kh(), _ === g)
          return bl(n, a, u);
        ri(n, a, _, u);
      }
      return a.child;
    }
    function nR(n, a, u, c, h) {
      return kh(), Z2(h), a.flags |= er, ri(n, a, u, c), a.child;
    }
    function z4(n, a, u) {
      h_(a), n === null && Y2(a);
      var c = a.type, h = a.pendingProps, g = n !== null ? n.memoizedProps : null, E = h.children, _ = O2(c, h);
      return _ ? E = null : g !== null && O2(c, g) && (a.flags |= hn), J_(n, a), ri(n, a, E, u), a.child;
    }
    function B4(n, a) {
      return n === null && Y2(a), null;
    }
    function U4(n, a, u, c) {
      Vw(n, a);
      var h = a.pendingProps, g = u, E = g._payload, _ = g._init, P = _(E);
      a.type = P;
      var M = a.tag = B8(P), F = cs(P, h), X;
      switch (M) {
        case v:
          return dk(a, P), a.type = P = Bh(P), X = lk(null, a, P, F, c), X;
        case w:
          return a.type = P = Bk(P), X = eR(null, a, P, F, c), X;
        case L:
          return a.type = P = Uk(P), X = Z_(null, a, P, F, c), X;
        case V: {
          if (a.type !== a.elementType) {
            var K = P.propTypes;
            K && ss(
              K,
              F,
              // Resolved for outer only
              "prop",
              en(P)
            );
          }
          return X = K_(
            null,
            a,
            P,
            cs(P.type, F),
            // The inner type can have defaults too
            c
          ), X;
        }
      }
      var re = "";
      throw P !== null && typeof P == "object" && P.$$typeof === dt && (re = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + P + ". " + ("Lazy element type must resolve to a class or function." + re));
    }
    function H4(n, a, u, c, h) {
      Vw(n, a), a.tag = w;
      var g;
      return pu(u) ? (g = !0, ew(a)) : g = !1, Ch(a, h), s_(a, u, c), vS(a, u, c, h), ck(null, a, u, !0, g, h);
    }
    function V4(n, a, u, c) {
      Vw(n, a);
      var h = a.pendingProps, g;
      {
        var E = bh(a, u, !1);
        g = wh(a, E);
      }
      Ch(a, c);
      var _, P;
      nu(a);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var M = en(u) || "Unknown";
          ak[M] || (f("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", M, M), ak[M] = !0);
        }
        a.mode & Zn && ls.recordLegacyContextWarning(a, null), Oa(!0), xv.current = a, _ = Ah(null, a, u, h, g, c), P = Dh(), Oa(!1);
      }
      if (Wu(), a.flags |= Zs, typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0) {
        var F = en(u) || "Unknown";
        Sv[F] || (f("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", F, F, F), Sv[F] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof _ == "object" && _ !== null && typeof _.render == "function" && _.$$typeof === void 0
      ) {
        {
          var X = en(u) || "Unknown";
          Sv[X] || (f("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", X, X, X), Sv[X] = !0);
        }
        a.tag = w, a.memoizedState = null, a.updateQueue = null;
        var K = !1;
        return pu(u) ? (K = !0, ew(a)) : K = !1, a.memoizedState = _.state !== null && _.state !== void 0 ? _.state : null, aS(a), o_(a, _), vS(a, u, h, c), ck(null, a, u, !0, K, c);
      } else {
        if (a.tag = v, a.mode & Zn) {
          yr(!0);
          try {
            _ = Ah(null, a, u, h, g, c), P = Dh();
          } finally {
            yr(!1);
          }
        }
        return va() && P && H2(a), ri(null, a, _, c), dk(a, u), a.child;
      }
    }
    function dk(n, a) {
      {
        if (a && a.childContextTypes && f("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), n.ref !== null) {
          var u = "", c = ha();
          c && (u += `

Check the render method of \`` + c + "`.");
          var h = c || "", g = n._debugSource;
          g && (h = g.fileName + ":" + g.lineNumber), sk[h] || (sk[h] = !0, f("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var E = en(a) || "Unknown";
          ok[E] || (f("%s: Function components do not support getDerivedStateFromProps.", E), ok[E] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var _ = en(a) || "Unknown";
          ik[_] || (f("%s: Function components do not support contextType.", _), ik[_] = !0);
        }
      }
    }
    var fk = {
      dehydrated: null,
      treeContext: null,
      retryLane: Zt
    };
    function pk(n) {
      return {
        baseLanes: n,
        cachePool: I4(),
        transitions: null
      };
    }
    function G4(n, a) {
      var u = null;
      return {
        baseLanes: Mt(n.baseLanes, a),
        cachePool: u,
        transitions: n.transitions
      };
    }
    function q4(n, a, u, c) {
      if (a !== null) {
        var h = a.memoizedState;
        if (h === null)
          return !1;
      }
      return TS(n, pv);
    }
    function W4(n, a) {
      return bc(n.childLanes, a);
    }
    function rR(n, a, u) {
      var c = a.pendingProps;
      nL(a) && (a.flags |= Et);
      var h = ds.current, g = !1, E = (a.flags & Et) !== lt;
      if (E || q4(h, n) ? (g = !0, a.flags &= ~Et) : (n === null || n.memoizedState !== null) && (h = m4(h, y_)), h = Rh(h), Uc(a, h), n === null) {
        Y2(a);
        var _ = a.memoizedState;
        if (_ !== null) {
          var P = _.dehydrated;
          if (P !== null)
            return X4(a, P);
        }
        var M = c.children, F = c.fallback;
        if (g) {
          var X = Y4(a, M, F, u), K = a.child;
          return K.memoizedState = pk(u), a.memoizedState = fk, X;
        } else
          return hk(a, M);
      } else {
        var re = n.memoizedState;
        if (re !== null) {
          var ie = re.dehydrated;
          if (ie !== null)
            return J4(n, a, E, c, ie, re, u);
        }
        if (g) {
          var me = c.fallback, qe = c.children, ft = K4(n, a, qe, me, u), it = a.child, Qt = n.child.memoizedState;
          return it.memoizedState = Qt === null ? pk(u) : G4(Qt, u), it.childLanes = W4(n, u), a.memoizedState = fk, ft;
        } else {
          var qt = c.children, ee = Z4(n, a, qt, u);
          return a.memoizedState = null, ee;
        }
      }
    }
    function hk(n, a, u) {
      var c = n.mode, h = {
        mode: "visible",
        children: a
      }, g = mk(h, c);
      return g.return = n, n.child = g, g;
    }
    function Y4(n, a, u, c) {
      var h = n.mode, g = n.child, E = {
        mode: "hidden",
        children: a
      }, _, P;
      return (h & zt) === mt && g !== null ? (_ = g, _.childLanes = be, _.pendingProps = E, n.mode & vt && (_.actualDuration = 0, _.actualStartTime = -1, _.selfBaseDuration = 0, _.treeBaseDuration = 0), P = Kc(u, h, c, null)) : (_ = mk(E, h), P = Kc(u, h, c, null)), _.return = n, P.return = n, _.sibling = P, n.child = _, P;
    }
    function mk(n, a, u) {
      return aO(n, a, be, null);
    }
    function aR(n, a) {
      return Of(n, a);
    }
    function Z4(n, a, u, c) {
      var h = n.child, g = h.sibling, E = aR(h, {
        mode: "visible",
        children: u
      });
      if ((a.mode & zt) === mt && (E.lanes = c), E.return = a, E.sibling = null, g !== null) {
        var _ = a.deletions;
        _ === null ? (a.deletions = [g], a.flags |= ln) : _.push(g);
      }
      return a.child = E, E;
    }
    function K4(n, a, u, c, h) {
      var g = a.mode, E = n.child, _ = E.sibling, P = {
        mode: "hidden",
        children: u
      }, M;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (g & zt) === mt && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        a.child !== E
      ) {
        var F = a.child;
        M = F, M.childLanes = be, M.pendingProps = P, a.mode & vt && (M.actualDuration = 0, M.actualStartTime = -1, M.selfBaseDuration = E.selfBaseDuration, M.treeBaseDuration = E.treeBaseDuration), a.deletions = null;
      } else
        M = aR(E, P), M.subtreeFlags = E.subtreeFlags & $r;
      var X;
      return _ !== null ? X = Of(_, c) : (X = Kc(c, g, h, null), X.flags |= Dn), X.return = a, M.return = a, M.sibling = X, a.child = M, X;
    }
    function Hw(n, a, u, c) {
      c !== null && Z2(c), Th(a, n.child, null, u);
      var h = a.pendingProps, g = h.children, E = hk(a, g);
      return E.flags |= Dn, a.memoizedState = null, E;
    }
    function Q4(n, a, u, c, h) {
      var g = a.mode, E = {
        mode: "visible",
        children: u
      }, _ = mk(E, g), P = Kc(c, g, h, null);
      return P.flags |= Dn, _.return = a, P.return = a, _.sibling = P, a.child = _, (a.mode & zt) !== mt && Th(a, n.child, null, h), P;
    }
    function X4(n, a, u) {
      return (n.mode & zt) === mt ? (f("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = gt) : D2(a) ? n.lanes = Ku : n.lanes = La, null;
    }
    function J4(n, a, u, c, h, g, E) {
      if (u)
        if (a.flags & er) {
          a.flags &= ~er;
          var ee = tk(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Hw(n, a, E, ee);
        } else {
          if (a.memoizedState !== null)
            return a.child = n.child, a.flags |= Et, null;
          var ye = c.children, te = c.fallback, je = Q4(n, a, ye, te, E), We = a.child;
          return We.memoizedState = pk(E), a.memoizedState = fk, je;
        }
      else {
        if (BM(), (a.mode & zt) === mt)
          return Hw(
            n,
            a,
            E,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (D2(h)) {
          var _, P, M;
          {
            var F = aM(h);
            _ = F.digest, P = F.message, M = F.stack;
          }
          var X;
          P ? X = new Error(P) : X = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var K = tk(X, _, M);
          return Hw(n, a, E, K);
        }
        var re = Na(E, n.childLanes);
        if (ps || re) {
          var ie = e1();
          if (ie !== null) {
            var me = e2(ie, E);
            if (me !== Zt && me !== g.retryLane) {
              g.retryLane = me;
              var qe = Cn;
              Pi(n, me), qr(ie, n, me, qe);
            }
          }
          $k();
          var ft = tk(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Hw(n, a, E, ft);
        } else if (T6(h)) {
          a.flags |= Et, a.child = n.child;
          var it = E8.bind(null, n);
          return iM(h, it), null;
        } else {
          VM(a, h, g.treeContext);
          var Qt = c.children, qt = hk(a, Qt);
          return qt.flags |= wi, qt;
        }
      }
    }
    function iR(n, a, u) {
      n.lanes = Mt(n.lanes, a);
      var c = n.alternate;
      c !== null && (c.lanes = Mt(c.lanes, a)), eS(n.return, a, u);
    }
    function e$(n, a, u) {
      for (var c = a; c !== null; ) {
        if (c.tag === H) {
          var h = c.memoizedState;
          h !== null && iR(c, u, n);
        } else if (c.tag === Se)
          iR(c, u, n);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function t$(n) {
      for (var a = n, u = null; a !== null; ) {
        var c = a.alternate;
        c !== null && Sw(c) === null && (u = a), a = a.sibling;
      }
      return u;
    }
    function n$(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !uk[n])
        if (uk[n] = !0, typeof n == "string")
          switch (n.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              f('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              f('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
              break;
            }
            default:
              f('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
              break;
          }
        else
          f('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function r$(n, a) {
      n !== void 0 && !Uw[n] && (n !== "collapsed" && n !== "hidden" ? (Uw[n] = !0, f('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : a !== "forwards" && a !== "backwards" && (Uw[n] = !0, f('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function oR(n, a) {
      {
        var u = Wt(n), c = !u && typeof Ui(n) == "function";
        if (u || c) {
          var h = u ? "array" : "iterable";
          return f("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", h, a, h), !1;
        }
      }
      return !0;
    }
    function a$(n, a) {
      if ((a === "forwards" || a === "backwards") && n !== void 0 && n !== null && n !== !1)
        if (Wt(n)) {
          for (var u = 0; u < n.length; u++)
            if (!oR(n[u], u))
              return;
        } else {
          var c = Ui(n);
          if (typeof c == "function") {
            var h = c.call(n);
            if (h)
              for (var g = h.next(), E = 0; !g.done; g = h.next()) {
                if (!oR(g.value, E))
                  return;
                E++;
              }
          } else
            f('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
        }
    }
    function yk(n, a, u, c, h) {
      var g = n.memoizedState;
      g === null ? n.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: c,
        tail: u,
        tailMode: h
      } : (g.isBackwards = a, g.rendering = null, g.renderingStartTime = 0, g.last = c, g.tail = u, g.tailMode = h);
    }
    function sR(n, a, u) {
      var c = a.pendingProps, h = c.revealOrder, g = c.tail, E = c.children;
      n$(h), r$(g, h), a$(E, h), ri(n, a, E, u);
      var _ = ds.current, P = TS(_, pv);
      if (P)
        _ = _S(_, pv), a.flags |= Et;
      else {
        var M = n !== null && (n.flags & Et) !== lt;
        M && e$(a, a.child, u), _ = Rh(_);
      }
      if (Uc(a, _), (a.mode & zt) === mt)
        a.memoizedState = null;
      else
        switch (h) {
          case "forwards": {
            var F = t$(a.child), X;
            F === null ? (X = a.child, a.child = null) : (X = F.sibling, F.sibling = null), yk(
              a,
              !1,
              // isBackwards
              X,
              F,
              g
            );
            break;
          }
          case "backwards": {
            var K = null, re = a.child;
            for (a.child = null; re !== null; ) {
              var ie = re.alternate;
              if (ie !== null && Sw(ie) === null) {
                a.child = re;
                break;
              }
              var me = re.sibling;
              re.sibling = K, K = re, re = me;
            }
            yk(
              a,
              !0,
              // isBackwards
              K,
              null,
              // last
              g
            );
            break;
          }
          case "together": {
            yk(
              a,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            a.memoizedState = null;
        }
      return a.child;
    }
    function i$(n, a, u) {
      kS(a, a.stateNode.containerInfo);
      var c = a.pendingProps;
      return n === null ? a.child = Th(a, null, c, u) : ri(n, a, c, u), a.child;
    }
    var uR = !1;
    function o$(n, a, u) {
      var c = a.type, h = c._context, g = a.pendingProps, E = a.memoizedProps, _ = g.value;
      {
        "value" in g || uR || (uR = !0, f("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var P = a.type.propTypes;
        P && ss(P, g, "prop", "Context.Provider");
      }
      if (Z6(a, h, _), E !== null) {
        var M = E.value;
        if (et(M, _)) {
          if (E.children === g.children && !Xb())
            return bl(n, a, u);
        } else
          e4(a, h, u);
      }
      var F = g.children;
      return ri(n, a, F, u), a.child;
    }
    var lR = !1;
    function s$(n, a, u) {
      var c = a.type;
      c._context === void 0 ? c !== c.Consumer && (lR || (lR = !0, f("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : c = c._context;
      var h = a.pendingProps, g = h.children;
      typeof g != "function" && f("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Ch(a, u);
      var E = Dr(c);
      nu(a);
      var _;
      return xv.current = a, Oa(!0), _ = g(E), Oa(!1), Wu(), a.flags |= Zs, ri(n, a, _, u), a.child;
    }
    function kv() {
      ps = !0;
    }
    function Vw(n, a) {
      (a.mode & zt) === mt && n !== null && (n.alternate = null, a.alternate = null, a.flags |= Dn);
    }
    function bl(n, a, u) {
      return n !== null && (a.dependencies = n.dependencies), V_(), Mv(a.lanes), Na(u, a.childLanes) ? (f4(n, a), a.child) : null;
    }
    function u$(n, a, u) {
      {
        var c = a.return;
        if (c === null)
          throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, a.alternate = null, u.index = a.index, u.sibling = a.sibling, u.return = a.return, u.ref = a.ref, a === c.child)
          c.child = u;
        else {
          var h = c.child;
          if (h === null)
            throw new Error("Expected parent to have a child.");
          for (; h.sibling !== a; )
            if (h = h.sibling, h === null)
              throw new Error("Expected to find the previous sibling.");
          h.sibling = u;
        }
        var g = c.deletions;
        return g === null ? (c.deletions = [n], c.flags |= ln) : g.push(n), u.flags |= Dn, u;
      }
    }
    function vk(n, a) {
      var u = n.lanes;
      return !!Na(u, a);
    }
    function l$(n, a, u) {
      switch (a.tag) {
        case b:
          tR(a), a.stateNode, kh();
          break;
        case T:
          h_(a);
          break;
        case w: {
          var c = a.type;
          pu(c) && ew(a);
          break;
        }
        case k:
          kS(a, a.stateNode.containerInfo);
          break;
        case N: {
          var h = a.memoizedProps.value, g = a.type._context;
          Z6(a, g, h);
          break;
        }
        case B:
          {
            var E = Na(u, a.childLanes);
            E && (a.flags |= It);
            {
              var _ = a.stateNode;
              _.effectDuration = 0, _.passiveEffectDuration = 0;
            }
          }
          break;
        case H: {
          var P = a.memoizedState;
          if (P !== null) {
            if (P.dehydrated !== null)
              return Uc(a, Rh(ds.current)), a.flags |= Et, null;
            var M = a.child, F = M.childLanes;
            if (Na(u, F))
              return rR(n, a, u);
            Uc(a, Rh(ds.current));
            var X = bl(n, a, u);
            return X !== null ? X.sibling : null;
          } else
            Uc(a, Rh(ds.current));
          break;
        }
        case Se: {
          var K = (n.flags & Et) !== lt, re = Na(u, a.childLanes);
          if (K) {
            if (re)
              return sR(n, a, u);
            a.flags |= Et;
          }
          var ie = a.memoizedState;
          if (ie !== null && (ie.rendering = null, ie.tail = null, ie.lastEffect = null), Uc(a, ds.current), re)
            break;
          return null;
        }
        case Re:
        case Pe:
          return a.lanes = be, X_(n, a, u);
      }
      return bl(n, a, u);
    }
    function cR(n, a, u) {
      if (a._debugNeedsRemount && n !== null)
        return u$(n, a, Wk(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (n !== null) {
        var c = n.memoizedProps, h = a.pendingProps;
        if (c !== h || Xb() || // Force a re-render if the implementation changed due to hot reload:
        a.type !== n.type)
          ps = !0;
        else {
          var g = vk(n, u);
          if (!g && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & Et) === lt)
            return ps = !1, l$(n, a, u);
          (n.flags & Vd) !== lt ? ps = !0 : ps = !1;
        }
      } else if (ps = !1, va() && MM(a)) {
        var E = a.index, _ = $M();
        L6(a, _, E);
      }
      switch (a.lanes = be, a.tag) {
        case x:
          return V4(n, a, a.type, u);
        case Y: {
          var P = a.elementType;
          return U4(n, a, P, u);
        }
        case v: {
          var M = a.type, F = a.pendingProps, X = a.elementType === M ? F : cs(M, F);
          return lk(n, a, M, X, u);
        }
        case w: {
          var K = a.type, re = a.pendingProps, ie = a.elementType === K ? re : cs(K, re);
          return eR(n, a, K, ie, u);
        }
        case b:
          return F4(n, a, u);
        case T:
          return z4(n, a, u);
        case O:
          return B4(n, a);
        case H:
          return rR(n, a, u);
        case k:
          return i$(n, a, u);
        case L: {
          var me = a.type, qe = a.pendingProps, ft = a.elementType === me ? qe : cs(me, qe);
          return Z_(n, a, me, ft, u);
        }
        case R:
          return $4(n, a, u);
        case j:
          return L4(n, a, u);
        case B:
          return N4(n, a, u);
        case N:
          return o$(n, a, u);
        case I:
          return s$(n, a, u);
        case V: {
          var it = a.type, Qt = a.pendingProps, qt = cs(it, Qt);
          if (a.type !== a.elementType) {
            var ee = it.propTypes;
            ee && ss(
              ee,
              qt,
              // Resolved for outer only
              "prop",
              en(it)
            );
          }
          return qt = cs(it.type, qt), K_(n, a, it, qt, u);
        }
        case W:
          return Q_(n, a, a.type, a.pendingProps, u);
        case ce: {
          var ye = a.type, te = a.pendingProps, je = a.elementType === ye ? te : cs(ye, te);
          return H4(n, a, ye, je, u);
        }
        case Se:
          return sR(n, a, u);
        case De:
          break;
        case Re:
          return X_(n, a, u);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ih(n) {
      n.flags |= It;
    }
    function dR(n) {
      n.flags |= ja, n.flags |= ay;
    }
    var fR, gk, pR, hR;
    fR = function(n, a, u, c) {
      for (var h = a.child; h !== null; ) {
        if (h.tag === T || h.tag === O)
          A7(n, h.stateNode);
        else if (h.tag !== k) {
          if (h.child !== null) {
            h.child.return = h, h = h.child;
            continue;
          }
        }
        if (h === a)
          return;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === a)
            return;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
    }, gk = function(n, a) {
    }, pR = function(n, a, u, c, h) {
      var g = n.memoizedProps;
      if (g !== c) {
        var E = a.stateNode, _ = ES(), P = I7(E, u, g, c, h, _);
        a.updateQueue = P, P && Ih(a);
      }
    }, hR = function(n, a, u, c) {
      u !== c && Ih(a);
    };
    function Ev(n, a) {
      if (!va())
        switch (n.tailMode) {
          case "hidden": {
            for (var u = n.tail, c = null; u !== null; )
              u.alternate !== null && (c = u), u = u.sibling;
            c === null ? n.tail = null : c.sibling = null;
            break;
          }
          case "collapsed": {
            for (var h = n.tail, g = null; h !== null; )
              h.alternate !== null && (g = h), h = h.sibling;
            g === null ? !a && n.tail !== null ? n.tail.sibling = null : n.tail = null : g.sibling = null;
            break;
          }
        }
    }
    function ba(n) {
      var a = n.alternate !== null && n.alternate.child === n.child, u = be, c = lt;
      if (a) {
        if ((n.mode & vt) !== mt) {
          for (var P = n.selfBaseDuration, M = n.child; M !== null; )
            u = Mt(u, Mt(M.lanes, M.childLanes)), c |= M.subtreeFlags & $r, c |= M.flags & $r, P += M.treeBaseDuration, M = M.sibling;
          n.treeBaseDuration = P;
        } else
          for (var F = n.child; F !== null; )
            u = Mt(u, Mt(F.lanes, F.childLanes)), c |= F.subtreeFlags & $r, c |= F.flags & $r, F.return = n, F = F.sibling;
        n.subtreeFlags |= c;
      } else {
        if ((n.mode & vt) !== mt) {
          for (var h = n.actualDuration, g = n.selfBaseDuration, E = n.child; E !== null; )
            u = Mt(u, Mt(E.lanes, E.childLanes)), c |= E.subtreeFlags, c |= E.flags, h += E.actualDuration, g += E.treeBaseDuration, E = E.sibling;
          n.actualDuration = h, n.treeBaseDuration = g;
        } else
          for (var _ = n.child; _ !== null; )
            u = Mt(u, Mt(_.lanes, _.childLanes)), c |= _.subtreeFlags, c |= _.flags, _.return = n, _ = _.sibling;
        n.subtreeFlags |= c;
      }
      return n.childLanes = u, a;
    }
    function c$(n, a, u) {
      if (ZM() && (a.mode & zt) !== mt && (a.flags & Et) === lt)
        return V6(a), kh(), a.flags |= er | Qa | Rr, !1;
      var c = iw(a);
      if (u !== null && u.dehydrated !== null)
        if (n === null) {
          if (!c)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (WM(a), ba(a), (a.mode & vt) !== mt) {
            var h = u !== null;
            if (h) {
              var g = a.child;
              g !== null && (a.treeBaseDuration -= g.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (kh(), (a.flags & Et) === lt && (a.memoizedState = null), a.flags |= It, ba(a), (a.mode & vt) !== mt) {
            var E = u !== null;
            if (E) {
              var _ = a.child;
              _ !== null && (a.treeBaseDuration -= _.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return G6(), !0;
    }
    function mR(n, a, u) {
      var c = a.pendingProps;
      switch (V2(a), a.tag) {
        case x:
        case Y:
        case W:
        case v:
        case L:
        case R:
        case j:
        case B:
        case I:
        case V:
          return ba(a), null;
        case w: {
          var h = a.type;
          return pu(h) && Jb(a), ba(a), null;
        }
        case b: {
          var g = a.stateNode;
          if (_h(a), z2(a), OS(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), n === null || n.child === null) {
            var E = iw(a);
            if (E)
              Ih(a);
            else if (n !== null) {
              var _ = n.memoizedState;
              // Check if this is a client root
              (!_.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (a.flags & er) !== lt) && (a.flags |= bi, G6());
            }
          }
          return gk(n, a), ba(a), null;
        }
        case T: {
          CS(a);
          var P = p_(), M = a.type;
          if (n !== null && a.stateNode != null)
            pR(n, a, M, c, P), n.ref !== a.ref && dR(a);
          else {
            if (!c) {
              if (a.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return ba(a), null;
            }
            var F = ES(), X = iw(a);
            if (X)
              GM(a, P, F) && Ih(a);
            else {
              var K = j7(M, c, P, F, a);
              fR(K, a, !1, !1), a.stateNode = K, D7(K, M, c, P) && Ih(a);
            }
            a.ref !== null && dR(a);
          }
          return ba(a), null;
        }
        case O: {
          var re = c;
          if (n && a.stateNode != null) {
            var ie = n.memoizedProps;
            hR(n, a, ie, re);
          } else {
            if (typeof re != "string" && a.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var me = p_(), qe = ES(), ft = iw(a);
            ft ? qM(a) && Ih(a) : a.stateNode = M7(re, me, qe, a);
          }
          return ba(a), null;
        }
        case H: {
          Oh(a);
          var it = a.memoizedState;
          if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            var Qt = c$(n, a, it);
            if (!Qt)
              return a.flags & Rr ? a : null;
          }
          if ((a.flags & Et) !== lt)
            return a.lanes = u, (a.mode & vt) !== mt && ek(a), a;
          var qt = it !== null, ee = n !== null && n.memoizedState !== null;
          if (qt !== ee && qt) {
            var ye = a.child;
            if (ye.flags |= Ks, (a.mode & zt) !== mt) {
              var te = n === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !oe);
              te || TS(ds.current, y_) ? d8() : $k();
            }
          }
          var je = a.updateQueue;
          if (je !== null && (a.flags |= It), ba(a), (a.mode & vt) !== mt && qt) {
            var We = a.child;
            We !== null && (a.treeBaseDuration -= We.treeBaseDuration);
          }
          return null;
        }
        case k:
          return _h(a), gk(n, a), n === null && RM(a.stateNode.containerInfo), ba(a), null;
        case N:
          var Be = a.type._context;
          return J2(Be, a), ba(a), null;
        case ce: {
          var kt = a.type;
          return pu(kt) && Jb(a), ba(a), null;
        }
        case Se: {
          Oh(a);
          var jt = a.memoizedState;
          if (jt === null)
            return ba(a), null;
          var wn = (a.flags & Et) !== lt, an = jt.rendering;
          if (an === null)
            if (wn)
              Ev(jt, !1);
            else {
              var xr = p8() && (n === null || (n.flags & Et) === lt);
              if (!xr)
                for (var on = a.child; on !== null; ) {
                  var mr = Sw(on);
                  if (mr !== null) {
                    wn = !0, a.flags |= Et, Ev(jt, !1);
                    var Ua = mr.updateQueue;
                    return Ua !== null && (a.updateQueue = Ua, a.flags |= It), a.subtreeFlags = lt, p4(a, u), Uc(a, _S(ds.current, pv)), a.child;
                  }
                  on = on.sibling;
                }
              jt.tail !== null && Yn() > $R() && (a.flags |= Et, wn = !0, Ev(jt, !1), a.lanes = vy);
            }
          else {
            if (!wn) {
              var Ea = Sw(an);
              if (Ea !== null) {
                a.flags |= Et, wn = !0;
                var Ji = Ea.updateQueue;
                if (Ji !== null && (a.updateQueue = Ji, a.flags |= It), Ev(jt, !0), jt.tail === null && jt.tailMode === "hidden" && !an.alternate && !va())
                  return ba(a), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                Yn() * 2 - jt.renderingStartTime > $R() && u !== La && (a.flags |= Et, wn = !0, Ev(jt, !1), a.lanes = vy);
            }
            if (jt.isBackwards)
              an.sibling = a.child, a.child = an;
            else {
              var oi = jt.last;
              oi !== null ? oi.sibling = an : a.child = an, jt.last = an;
            }
          }
          if (jt.tail !== null) {
            var si = jt.tail;
            jt.rendering = si, jt.tail = si.sibling, jt.renderingStartTime = Yn(), si.sibling = null;
            var Ha = ds.current;
            return wn ? Ha = _S(Ha, pv) : Ha = Rh(Ha), Uc(a, Ha), si;
          }
          return ba(a), null;
        }
        case De:
          break;
        case Re:
        case Pe: {
          Mk(a);
          var El = a.memoizedState, Uh = El !== null;
          if (n !== null) {
            var zv = n.memoizedState, xu = zv !== null;
            xu !== Uh && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !z && (a.flags |= Ks);
          }
          return !Uh || (a.mode & zt) === mt ? ba(a) : Na(wu, La) && (ba(a), a.subtreeFlags & (Dn | It) && (a.flags |= Ks)), null;
        }
        case se:
          return null;
        case ge:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function d$(n, a, u) {
      switch (V2(a), a.tag) {
        case w: {
          var c = a.type;
          pu(c) && Jb(a);
          var h = a.flags;
          return h & Rr ? (a.flags = h & ~Rr | Et, (a.mode & vt) !== mt && ek(a), a) : null;
        }
        case b: {
          a.stateNode, _h(a), z2(a), OS();
          var g = a.flags;
          return (g & Rr) !== lt && (g & Et) === lt ? (a.flags = g & ~Rr | Et, a) : null;
        }
        case T:
          return CS(a), null;
        case H: {
          Oh(a);
          var E = a.memoizedState;
          if (E !== null && E.dehydrated !== null) {
            if (a.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            kh();
          }
          var _ = a.flags;
          return _ & Rr ? (a.flags = _ & ~Rr | Et, (a.mode & vt) !== mt && ek(a), a) : null;
        }
        case Se:
          return Oh(a), null;
        case k:
          return _h(a), null;
        case N:
          var P = a.type._context;
          return J2(P, a), null;
        case Re:
        case Pe:
          return Mk(a), null;
        case se:
          return null;
        default:
          return null;
      }
    }
    function yR(n, a, u) {
      switch (V2(a), a.tag) {
        case w: {
          var c = a.type.childContextTypes;
          c != null && Jb(a);
          break;
        }
        case b: {
          a.stateNode, _h(a), z2(a), OS();
          break;
        }
        case T: {
          CS(a);
          break;
        }
        case k:
          _h(a);
          break;
        case H:
          Oh(a);
          break;
        case Se:
          Oh(a);
          break;
        case N:
          var h = a.type._context;
          J2(h, a);
          break;
        case Re:
        case Pe:
          Mk(a);
          break;
      }
    }
    var vR = null;
    vR = /* @__PURE__ */ new Set();
    var Gw = !1, wa = !1, f$ = typeof WeakSet == "function" ? WeakSet : Set, tt = null, Mh = null, $h = null;
    function p$(n) {
      Gu(null, function() {
        throw n;
      }), ny();
    }
    var h$ = function(n, a) {
      if (a.props = n.memoizedProps, a.state = n.memoizedState, n.mode & vt)
        try {
          gu(), a.componentWillUnmount();
        } finally {
          vu(n);
        }
      else
        a.componentWillUnmount();
    };
    function gR(n, a) {
      try {
        Gc(zr, n);
      } catch (u) {
        Ln(n, a, u);
      }
    }
    function bk(n, a, u) {
      try {
        h$(n, u);
      } catch (c) {
        Ln(n, a, c);
      }
    }
    function m$(n, a, u) {
      try {
        u.componentDidMount();
      } catch (c) {
        Ln(n, a, c);
      }
    }
    function bR(n, a) {
      try {
        xR(n);
      } catch (u) {
        Ln(n, a, u);
      }
    }
    function Lh(n, a) {
      var u = n.ref;
      if (u !== null)
        if (typeof u == "function") {
          var c;
          try {
            if (at && ut && n.mode & vt)
              try {
                gu(), c = u(null);
              } finally {
                vu(n);
              }
            else
              c = u(null);
          } catch (h) {
            Ln(n, a, h);
          }
          typeof c == "function" && f("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", _t(n));
        } else
          u.current = null;
    }
    function qw(n, a, u) {
      try {
        u();
      } catch (c) {
        Ln(n, a, c);
      }
    }
    var wR = !1;
    function y$(n, a) {
      O7(n.containerInfo), tt = a, v$();
      var u = wR;
      return wR = !1, u;
    }
    function v$() {
      for (; tt !== null; ) {
        var n = tt, a = n.child;
        (n.subtreeFlags & dc) !== lt && a !== null ? (a.return = n, tt = a) : g$();
      }
    }
    function g$() {
      for (; tt !== null; ) {
        var n = tt;
        pn(n);
        try {
          b$(n);
        } catch (u) {
          Ln(n, n.return, u);
        }
        Jn();
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, tt = a;
          return;
        }
        tt = n.return;
      }
    }
    function b$(n) {
      var a = n.alternate, u = n.flags;
      if ((u & bi) !== lt) {
        switch (pn(n), n.tag) {
          case v:
          case L:
          case W:
            break;
          case w: {
            if (a !== null) {
              var c = a.memoizedProps, h = a.memoizedState, g = n.stateNode;
              n.type === n.elementType && !Ef && (g.props !== n.memoizedProps && f("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", _t(n) || "instance"), g.state !== n.memoizedState && f("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", _t(n) || "instance"));
              var E = g.getSnapshotBeforeUpdate(n.elementType === n.type ? c : cs(n.type, c), h);
              {
                var _ = vR;
                E === void 0 && !_.has(n.type) && (_.add(n.type), f("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", _t(n)));
              }
              g.__reactInternalSnapshotBeforeUpdate = E;
            }
            break;
          }
          case b: {
            {
              var P = n.stateNode;
              eM(P.containerInfo);
            }
            break;
          }
          case T:
          case O:
          case k:
          case ce:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Jn();
      }
    }
    function hs(n, a, u) {
      var c = a.updateQueue, h = c !== null ? c.lastEffect : null;
      if (h !== null) {
        var g = h.next, E = g;
        do {
          if ((E.tag & n) === n) {
            var _ = E.destroy;
            E.destroy = void 0, _ !== void 0 && ((n & ga) !== ji ? Tp(a) : (n & zr) !== ji && _p(a), (n & hu) !== ji && Lv(!0), qw(a, u, _), (n & hu) !== ji && Lv(!1), (n & ga) !== ji ? ab() : (n & zr) !== ji && fc());
          }
          E = E.next;
        } while (E !== g);
      }
    }
    function Gc(n, a) {
      var u = a.updateQueue, c = u !== null ? u.lastEffect : null;
      if (c !== null) {
        var h = c.next, g = h;
        do {
          if ((g.tag & n) === n) {
            (n & ga) !== ji ? rb(a) : (n & zr) !== ji && ib(a);
            var E = g.create;
            (n & hu) !== ji && Lv(!0), g.destroy = E(), (n & hu) !== ji && Lv(!1), (n & ga) !== ji ? hy() : (n & zr) !== ji && ob();
            {
              var _ = g.destroy;
              if (_ !== void 0 && typeof _ != "function") {
                var P = void 0;
                (g.tag & zr) !== lt ? P = "useLayoutEffect" : (g.tag & hu) !== lt ? P = "useInsertionEffect" : P = "useEffect";
                var M = void 0;
                _ === null ? M = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof _.then == "function" ? M = `

It looks like you wrote ` + P + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + P + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : M = " You returned: " + _, f("%s must not return anything besides a function, which is used for clean-up.%s", P, M);
              }
            }
          }
          g = g.next;
        } while (g !== h);
      }
    }
    function w$(n, a) {
      if ((a.flags & It) !== lt)
        switch (a.tag) {
          case B: {
            var u = a.stateNode.passiveEffectDuration, c = a.memoizedProps, h = c.id, g = c.onPostCommit, E = U_(), _ = a.alternate === null ? "mount" : "update";
            B_() && (_ = "nested-update"), typeof g == "function" && g(h, _, u, E);
            var P = a.return;
            e:
              for (; P !== null; ) {
                switch (P.tag) {
                  case b:
                    var M = P.stateNode;
                    M.passiveEffectDuration += u;
                    break e;
                  case B:
                    var F = P.stateNode;
                    F.passiveEffectDuration += u;
                    break e;
                }
                P = P.return;
              }
            break;
          }
        }
    }
    function x$(n, a, u, c) {
      if ((u.flags & Qr) !== lt)
        switch (u.tag) {
          case v:
          case L:
          case W: {
            if (!wa)
              if (u.mode & vt)
                try {
                  gu(), Gc(zr | Fr, u);
                } finally {
                  vu(u);
                }
              else
                Gc(zr | Fr, u);
            break;
          }
          case w: {
            var h = u.stateNode;
            if (u.flags & It && !wa)
              if (a === null)
                if (u.type === u.elementType && !Ef && (h.props !== u.memoizedProps && f("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", _t(u) || "instance"), h.state !== u.memoizedState && f("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", _t(u) || "instance")), u.mode & vt)
                  try {
                    gu(), h.componentDidMount();
                  } finally {
                    vu(u);
                  }
                else
                  h.componentDidMount();
              else {
                var g = u.elementType === u.type ? a.memoizedProps : cs(u.type, a.memoizedProps), E = a.memoizedState;
                if (u.type === u.elementType && !Ef && (h.props !== u.memoizedProps && f("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", _t(u) || "instance"), h.state !== u.memoizedState && f("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", _t(u) || "instance")), u.mode & vt)
                  try {
                    gu(), h.componentDidUpdate(g, E, h.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    vu(u);
                  }
                else
                  h.componentDidUpdate(g, E, h.__reactInternalSnapshotBeforeUpdate);
              }
            var _ = u.updateQueue;
            _ !== null && (u.type === u.elementType && !Ef && (h.props !== u.memoizedProps && f("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", _t(u) || "instance"), h.state !== u.memoizedState && f("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", _t(u) || "instance")), t_(u, _, h));
            break;
          }
          case b: {
            var P = u.updateQueue;
            if (P !== null) {
              var M = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case T:
                    M = u.child.stateNode;
                    break;
                  case w:
                    M = u.child.stateNode;
                    break;
                }
              t_(u, P, M);
            }
            break;
          }
          case T: {
            var F = u.stateNode;
            if (a === null && u.flags & It) {
              var X = u.type, K = u.memoizedProps;
              z7(F, X, K);
            }
            break;
          }
          case O:
            break;
          case k:
            break;
          case B: {
            {
              var re = u.memoizedProps, ie = re.onCommit, me = re.onRender, qe = u.stateNode.effectDuration, ft = U_(), it = a === null ? "mount" : "update";
              B_() && (it = "nested-update"), typeof me == "function" && me(u.memoizedProps.id, it, u.actualDuration, u.treeBaseDuration, u.actualStartTime, ft);
              {
                typeof ie == "function" && ie(u.memoizedProps.id, it, qe, ft), g8(u);
                var Qt = u.return;
                e:
                  for (; Qt !== null; ) {
                    switch (Qt.tag) {
                      case b:
                        var qt = Qt.stateNode;
                        qt.effectDuration += qe;
                        break e;
                      case B:
                        var ee = Qt.stateNode;
                        ee.effectDuration += qe;
                        break e;
                    }
                    Qt = Qt.return;
                  }
              }
            }
            break;
          }
          case H: {
            O$(n, u);
            break;
          }
          case Se:
          case ce:
          case De:
          case Re:
          case Pe:
          case ge:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      wa || u.flags & ja && xR(u);
    }
    function S$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          if (n.mode & vt)
            try {
              gu(), gR(n, n.return);
            } finally {
              vu(n);
            }
          else
            gR(n, n.return);
          break;
        }
        case w: {
          var a = n.stateNode;
          typeof a.componentDidMount == "function" && m$(n, n.return, a), bR(n, n.return);
          break;
        }
        case T: {
          bR(n, n.return);
          break;
        }
      }
    }
    function k$(n, a) {
      for (var u = null, c = n; ; ) {
        if (c.tag === T) {
          if (u === null) {
            u = c;
            try {
              var h = c.stateNode;
              a ? K7(h) : X7(c.stateNode, c.memoizedProps);
            } catch (E) {
              Ln(n, n.return, E);
            }
          }
        } else if (c.tag === O) {
          if (u === null)
            try {
              var g = c.stateNode;
              a ? Q7(g) : J7(g, c.memoizedProps);
            } catch (E) {
              Ln(n, n.return, E);
            }
        } else if (!((c.tag === Re || c.tag === Pe) && c.memoizedState !== null && c !== n)) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          u === c && (u = null), c = c.return;
        }
        u === c && (u = null), c.sibling.return = c.return, c = c.sibling;
      }
    }
    function xR(n) {
      var a = n.ref;
      if (a !== null) {
        var u = n.stateNode, c;
        switch (n.tag) {
          case T:
            c = u;
            break;
          default:
            c = u;
        }
        if (typeof a == "function") {
          var h;
          if (n.mode & vt)
            try {
              gu(), h = a(c);
            } finally {
              vu(n);
            }
          else
            h = a(c);
          typeof h == "function" && f("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", _t(n));
        } else
          a.hasOwnProperty("current") || f("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", _t(n)), a.current = c;
      }
    }
    function E$(n) {
      var a = n.alternate;
      a !== null && (a.return = null), n.return = null;
    }
    function SR(n) {
      var a = n.alternate;
      a !== null && (n.alternate = null, SR(a));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === T) {
          var u = n.stateNode;
          u !== null && jM(u);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function C$(n) {
      for (var a = n.return; a !== null; ) {
        if (kR(a))
          return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function kR(n) {
      return n.tag === T || n.tag === b || n.tag === k;
    }
    function ER(n) {
      var a = n;
      e:
        for (; ; ) {
          for (; a.sibling === null; ) {
            if (a.return === null || kR(a.return))
              return null;
            a = a.return;
          }
          for (a.sibling.return = a.return, a = a.sibling; a.tag !== T && a.tag !== O && a.tag !== ve; ) {
            if (a.flags & Dn || a.child === null || a.tag === k)
              continue e;
            a.child.return = a, a = a.child;
          }
          if (!(a.flags & Dn))
            return a.stateNode;
        }
    }
    function T$(n) {
      var a = C$(n);
      switch (a.tag) {
        case T: {
          var u = a.stateNode;
          a.flags & hn && (C6(u), a.flags &= ~hn);
          var c = ER(n);
          xk(n, c, u);
          break;
        }
        case b:
        case k: {
          var h = a.stateNode.containerInfo, g = ER(n);
          wk(n, g, h);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function wk(n, a, u) {
      var c = n.tag, h = c === T || c === O;
      if (h) {
        var g = n.stateNode;
        a ? q7(u, g, a) : V7(u, g);
      } else if (c !== k) {
        var E = n.child;
        if (E !== null) {
          wk(E, a, u);
          for (var _ = E.sibling; _ !== null; )
            wk(_, a, u), _ = _.sibling;
        }
      }
    }
    function xk(n, a, u) {
      var c = n.tag, h = c === T || c === O;
      if (h) {
        var g = n.stateNode;
        a ? G7(u, g, a) : H7(u, g);
      } else if (c !== k) {
        var E = n.child;
        if (E !== null) {
          xk(E, a, u);
          for (var _ = E.sibling; _ !== null; )
            xk(_, a, u), _ = _.sibling;
        }
      }
    }
    var xa = null, ms = !1;
    function _$(n, a, u) {
      {
        var c = a;
        e:
          for (; c !== null; ) {
            switch (c.tag) {
              case T: {
                xa = c.stateNode, ms = !1;
                break e;
              }
              case b: {
                xa = c.stateNode.containerInfo, ms = !0;
                break e;
              }
              case k: {
                xa = c.stateNode.containerInfo, ms = !0;
                break e;
              }
            }
            c = c.return;
          }
        if (xa === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        CR(n, a, u), xa = null, ms = !1;
      }
      E$(u);
    }
    function qc(n, a, u) {
      for (var c = u.child; c !== null; )
        CR(n, a, c), c = c.sibling;
    }
    function CR(n, a, u) {
      switch (fy(u), u.tag) {
        case T:
          wa || Lh(u, a);
        case O: {
          {
            var c = xa, h = ms;
            xa = null, qc(n, a, u), xa = c, ms = h, xa !== null && (ms ? Y7(xa, u.stateNode) : W7(xa, u.stateNode));
          }
          return;
        }
        case ve: {
          xa !== null && (ms ? Z7(xa, u.stateNode) : A2(xa, u.stateNode));
          return;
        }
        case k: {
          {
            var g = xa, E = ms;
            xa = u.stateNode.containerInfo, ms = !0, qc(n, a, u), xa = g, ms = E;
          }
          return;
        }
        case v:
        case L:
        case V:
        case W: {
          if (!wa) {
            var _ = u.updateQueue;
            if (_ !== null) {
              var P = _.lastEffect;
              if (P !== null) {
                var M = P.next, F = M;
                do {
                  var X = F, K = X.destroy, re = X.tag;
                  K !== void 0 && ((re & hu) !== ji ? qw(u, a, K) : (re & zr) !== ji && (_p(u), u.mode & vt ? (gu(), qw(u, a, K), vu(u)) : qw(u, a, K), fc())), F = F.next;
                } while (F !== M);
              }
            }
          }
          qc(n, a, u);
          return;
        }
        case w: {
          if (!wa) {
            Lh(u, a);
            var ie = u.stateNode;
            typeof ie.componentWillUnmount == "function" && bk(u, a, ie);
          }
          qc(n, a, u);
          return;
        }
        case De: {
          qc(n, a, u);
          return;
        }
        case Re: {
          if (
            // TODO: Remove this dead flag
            u.mode & zt
          ) {
            var me = wa;
            wa = me || u.memoizedState !== null, qc(n, a, u), wa = me;
          } else
            qc(n, a, u);
          break;
        }
        default: {
          qc(n, a, u);
          return;
        }
      }
    }
    function R$(n) {
      n.memoizedState;
    }
    function O$(n, a) {
      var u = a.memoizedState;
      if (u === null) {
        var c = a.alternate;
        if (c !== null) {
          var h = c.memoizedState;
          if (h !== null) {
            var g = h.dehydrated;
            g !== null && hM(g);
          }
        }
      }
    }
    function TR(n) {
      var a = n.updateQueue;
      if (a !== null) {
        n.updateQueue = null;
        var u = n.stateNode;
        u === null && (u = n.stateNode = new f$()), a.forEach(function(c) {
          var h = C8.bind(null, n, c);
          if (!u.has(c)) {
            if (u.add(c), Lr)
              if (Mh !== null && $h !== null)
                $v($h, Mh);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            c.then(h, h);
          }
        });
      }
    }
    function P$(n, a, u) {
      Mh = u, $h = n, pn(a), _R(a, n), pn(a), Mh = null, $h = null;
    }
    function ys(n, a, u) {
      var c = a.deletions;
      if (c !== null)
        for (var h = 0; h < c.length; h++) {
          var g = c[h];
          try {
            _$(n, a, g);
          } catch (P) {
            Ln(g, a, P);
          }
        }
      var E = ap();
      if (a.subtreeFlags & Ia)
        for (var _ = a.child; _ !== null; )
          pn(_), _R(_, n), _ = _.sibling;
      pn(E);
    }
    function _R(n, a, u) {
      var c = n.alternate, h = n.flags;
      switch (n.tag) {
        case v:
        case L:
        case V:
        case W: {
          if (ys(a, n), bu(n), h & It) {
            try {
              hs(hu | Fr, n, n.return), Gc(hu | Fr, n);
            } catch (kt) {
              Ln(n, n.return, kt);
            }
            if (n.mode & vt) {
              try {
                gu(), hs(zr | Fr, n, n.return);
              } catch (kt) {
                Ln(n, n.return, kt);
              }
              vu(n);
            } else
              try {
                hs(zr | Fr, n, n.return);
              } catch (kt) {
                Ln(n, n.return, kt);
              }
          }
          return;
        }
        case w: {
          ys(a, n), bu(n), h & ja && c !== null && Lh(c, c.return);
          return;
        }
        case T: {
          ys(a, n), bu(n), h & ja && c !== null && Lh(c, c.return);
          {
            if (n.flags & hn) {
              var g = n.stateNode;
              try {
                C6(g);
              } catch (kt) {
                Ln(n, n.return, kt);
              }
            }
            if (h & It) {
              var E = n.stateNode;
              if (E != null) {
                var _ = n.memoizedProps, P = c !== null ? c.memoizedProps : _, M = n.type, F = n.updateQueue;
                if (n.updateQueue = null, F !== null)
                  try {
                    B7(E, F, M, P, _, n);
                  } catch (kt) {
                    Ln(n, n.return, kt);
                  }
              }
            }
          }
          return;
        }
        case O: {
          if (ys(a, n), bu(n), h & It) {
            if (n.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var X = n.stateNode, K = n.memoizedProps, re = c !== null ? c.memoizedProps : K;
            try {
              U7(X, re, K);
            } catch (kt) {
              Ln(n, n.return, kt);
            }
          }
          return;
        }
        case b: {
          if (ys(a, n), bu(n), h & It && c !== null) {
            var ie = c.memoizedState;
            if (ie.isDehydrated)
              try {
                pM(a.containerInfo);
              } catch (kt) {
                Ln(n, n.return, kt);
              }
          }
          return;
        }
        case k: {
          ys(a, n), bu(n);
          return;
        }
        case H: {
          ys(a, n), bu(n);
          var me = n.child;
          if (me.flags & Ks) {
            var qe = me.stateNode, ft = me.memoizedState, it = ft !== null;
            if (qe.isHidden = it, it) {
              var Qt = me.alternate !== null && me.alternate.memoizedState !== null;
              Qt || c8();
            }
          }
          if (h & It) {
            try {
              R$(n);
            } catch (kt) {
              Ln(n, n.return, kt);
            }
            TR(n);
          }
          return;
        }
        case Re: {
          var qt = c !== null && c.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            n.mode & zt
          ) {
            var ee = wa;
            wa = ee || qt, ys(a, n), wa = ee;
          } else
            ys(a, n);
          if (bu(n), h & Ks) {
            var ye = n.stateNode, te = n.memoizedState, je = te !== null, We = n;
            if (ye.isHidden = je, je && !qt && (We.mode & zt) !== mt) {
              tt = We;
              for (var Be = We.child; Be !== null; )
                tt = Be, A$(Be), Be = Be.sibling;
            }
            k$(We, je);
          }
          return;
        }
        case Se: {
          ys(a, n), bu(n), h & It && TR(n);
          return;
        }
        case De:
          return;
        default: {
          ys(a, n), bu(n);
          return;
        }
      }
    }
    function bu(n) {
      var a = n.flags;
      if (a & Dn) {
        try {
          T$(n);
        } catch (u) {
          Ln(n, n.return, u);
        }
        n.flags &= ~Dn;
      }
      a & wi && (n.flags &= ~wi);
    }
    function j$(n, a, u) {
      Mh = u, $h = a, tt = n, RR(n, a, u), Mh = null, $h = null;
    }
    function RR(n, a, u) {
      for (var c = (n.mode & zt) !== mt; tt !== null; ) {
        var h = tt, g = h.child;
        if (h.tag === Re && c) {
          var E = h.memoizedState !== null, _ = E || Gw;
          if (_) {
            Sk(n, a, u);
            continue;
          } else {
            var P = h.alternate, M = P !== null && P.memoizedState !== null, F = M || wa, X = Gw, K = wa;
            Gw = _, wa = F, wa && !K && (tt = h, D$(h));
            for (var re = g; re !== null; )
              tt = re, RR(
                re,
                // New root; bubble back up to here and stop.
                a,
                u
              ), re = re.sibling;
            tt = h, Gw = X, wa = K, Sk(n, a, u);
            continue;
          }
        }
        (h.subtreeFlags & Qr) !== lt && g !== null ? (g.return = h, tt = g) : Sk(n, a, u);
      }
    }
    function Sk(n, a, u) {
      for (; tt !== null; ) {
        var c = tt;
        if ((c.flags & Qr) !== lt) {
          var h = c.alternate;
          pn(c);
          try {
            x$(a, h, c, u);
          } catch (E) {
            Ln(c, c.return, E);
          }
          Jn();
        }
        if (c === n) {
          tt = null;
          return;
        }
        var g = c.sibling;
        if (g !== null) {
          g.return = c.return, tt = g;
          return;
        }
        tt = c.return;
      }
    }
    function A$(n) {
      for (; tt !== null; ) {
        var a = tt, u = a.child;
        switch (a.tag) {
          case v:
          case L:
          case V:
          case W: {
            if (a.mode & vt)
              try {
                gu(), hs(zr, a, a.return);
              } finally {
                vu(a);
              }
            else
              hs(zr, a, a.return);
            break;
          }
          case w: {
            Lh(a, a.return);
            var c = a.stateNode;
            typeof c.componentWillUnmount == "function" && bk(a, a.return, c);
            break;
          }
          case T: {
            Lh(a, a.return);
            break;
          }
          case Re: {
            var h = a.memoizedState !== null;
            if (h) {
              OR(n);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = a, tt = u) : OR(n);
      }
    }
    function OR(n) {
      for (; tt !== null; ) {
        var a = tt;
        if (a === n) {
          tt = null;
          return;
        }
        var u = a.sibling;
        if (u !== null) {
          u.return = a.return, tt = u;
          return;
        }
        tt = a.return;
      }
    }
    function D$(n) {
      for (; tt !== null; ) {
        var a = tt, u = a.child;
        if (a.tag === Re) {
          var c = a.memoizedState !== null;
          if (c) {
            PR(n);
            continue;
          }
        }
        u !== null ? (u.return = a, tt = u) : PR(n);
      }
    }
    function PR(n) {
      for (; tt !== null; ) {
        var a = tt;
        pn(a);
        try {
          S$(a);
        } catch (c) {
          Ln(a, a.return, c);
        }
        if (Jn(), a === n) {
          tt = null;
          return;
        }
        var u = a.sibling;
        if (u !== null) {
          u.return = a.return, tt = u;
          return;
        }
        tt = a.return;
      }
    }
    function I$(n, a, u, c) {
      tt = a, M$(a, n, u, c);
    }
    function M$(n, a, u, c) {
      for (; tt !== null; ) {
        var h = tt, g = h.child;
        (h.subtreeFlags & xi) !== lt && g !== null ? (g.return = h, tt = g) : $$(n, a, u, c);
      }
    }
    function $$(n, a, u, c) {
      for (; tt !== null; ) {
        var h = tt;
        if ((h.flags & Fn) !== lt) {
          pn(h);
          try {
            L$(a, h, u, c);
          } catch (E) {
            Ln(h, h.return, E);
          }
          Jn();
        }
        if (h === n) {
          tt = null;
          return;
        }
        var g = h.sibling;
        if (g !== null) {
          g.return = h.return, tt = g;
          return;
        }
        tt = h.return;
      }
    }
    function L$(n, a, u, c) {
      switch (a.tag) {
        case v:
        case L:
        case W: {
          if (a.mode & vt) {
            JS();
            try {
              Gc(ga | Fr, a);
            } finally {
              XS(a);
            }
          } else
            Gc(ga | Fr, a);
          break;
        }
      }
    }
    function N$(n) {
      tt = n, F$();
    }
    function F$() {
      for (; tt !== null; ) {
        var n = tt, a = n.child;
        if ((tt.flags & ln) !== lt) {
          var u = n.deletions;
          if (u !== null) {
            for (var c = 0; c < u.length; c++) {
              var h = u[c];
              tt = h, U$(h, n);
            }
            {
              var g = n.alternate;
              if (g !== null) {
                var E = g.child;
                if (E !== null) {
                  g.child = null;
                  do {
                    var _ = E.sibling;
                    E.sibling = null, E = _;
                  } while (E !== null);
                }
              }
            }
            tt = n;
          }
        }
        (n.subtreeFlags & xi) !== lt && a !== null ? (a.return = n, tt = a) : z$();
      }
    }
    function z$() {
      for (; tt !== null; ) {
        var n = tt;
        (n.flags & Fn) !== lt && (pn(n), B$(n), Jn());
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, tt = a;
          return;
        }
        tt = n.return;
      }
    }
    function B$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          n.mode & vt ? (JS(), hs(ga | Fr, n, n.return), XS(n)) : hs(ga | Fr, n, n.return);
          break;
        }
      }
    }
    function U$(n, a) {
      for (; tt !== null; ) {
        var u = tt;
        pn(u), V$(u, a), Jn();
        var c = u.child;
        c !== null ? (c.return = u, tt = c) : H$(n);
      }
    }
    function H$(n) {
      for (; tt !== null; ) {
        var a = tt, u = a.sibling, c = a.return;
        if (SR(a), a === n) {
          tt = null;
          return;
        }
        if (u !== null) {
          u.return = c, tt = u;
          return;
        }
        tt = c;
      }
    }
    function V$(n, a) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          n.mode & vt ? (JS(), hs(ga, n, a), XS(n)) : hs(ga, n, a);
          break;
        }
      }
    }
    function G$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          try {
            Gc(zr | Fr, n);
          } catch (u) {
            Ln(n, n.return, u);
          }
          break;
        }
        case w: {
          var a = n.stateNode;
          try {
            a.componentDidMount();
          } catch (u) {
            Ln(n, n.return, u);
          }
          break;
        }
      }
    }
    function q$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          try {
            Gc(ga | Fr, n);
          } catch (a) {
            Ln(n, n.return, a);
          }
          break;
        }
      }
    }
    function W$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W: {
          try {
            hs(zr | Fr, n, n.return);
          } catch (u) {
            Ln(n, n.return, u);
          }
          break;
        }
        case w: {
          var a = n.stateNode;
          typeof a.componentWillUnmount == "function" && bk(n, n.return, a);
          break;
        }
      }
    }
    function Y$(n) {
      switch (n.tag) {
        case v:
        case L:
        case W:
          try {
            hs(ga | Fr, n, n.return);
          } catch (a) {
            Ln(n, n.return, a);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Cv = Symbol.for;
      Cv("selector.component"), Cv("selector.has_pseudo_class"), Cv("selector.role"), Cv("selector.test_id"), Cv("selector.text");
    }
    var Z$ = [];
    function K$() {
      Z$.forEach(function(n) {
        return n();
      });
    }
    var Q$ = r.ReactCurrentActQueue;
    function X$(n) {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && a !== !1;
      }
    }
    function jR() {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !n && Q$.current !== null && f("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var J$ = Math.ceil, kk = r.ReactCurrentDispatcher, Ek = r.ReactCurrentOwner, Sa = r.ReactCurrentBatchConfig, vs = r.ReactCurrentActQueue, Hr = (
      /*             */
      0
    ), AR = (
      /*               */
      1
    ), ka = (
      /*                */
      2
    ), _o = (
      /*                */
      4
    ), wl = 0, Tv = 1, Cf = 2, Ww = 3, _v = 4, DR = 5, Ck = 6, Kt = Hr, ai = null, ur = null, Vr = be, wu = be, Tk = $c(be), Gr = wl, Rv = null, Yw = be, Ov = be, Zw = be, Pv = null, Ai = null, _k = 0, IR = 500, MR = 1 / 0, e8 = 500, xl = null;
    function jv() {
      MR = Yn() + e8;
    }
    function $R() {
      return MR;
    }
    var Kw = !1, Rk = null, Nh = null, Tf = !1, Wc = null, Av = be, Ok = [], Pk = null, t8 = 50, Dv = 0, jk = null, Ak = !1, Qw = !1, n8 = 50, Fh = 0, Xw = null, Iv = Cn, Jw = be, LR = !1;
    function e1() {
      return ai;
    }
    function ii() {
      return (Kt & (ka | _o)) !== Hr ? Yn() : (Iv !== Cn || (Iv = Yn()), Iv);
    }
    function Yc(n) {
      var a = n.mode;
      if ((a & zt) === mt)
        return gt;
      if ((Kt & ka) !== Hr && Vr !== be)
        return vr(Vr);
      var u = XM() !== QM;
      if (u) {
        if (Sa.transition !== null) {
          var c = Sa.transition;
          c._updatedFibers || (c._updatedFibers = /* @__PURE__ */ new Set()), c._updatedFibers.add(n);
        }
        return Jw === Zt && (Jw = wy()), Jw;
      }
      var h = Ci();
      if (h !== Zt)
        return h;
      var g = $7();
      return g;
    }
    function r8(n) {
      var a = n.mode;
      return (a & zt) === mt ? gt : Jx();
    }
    function qr(n, a, u, c) {
      _8(), LR && f("useInsertionEffect must not schedule updates."), Ak && (Qw = !0), rl(n, u, c), (Kt & ka) !== be && n === ai ? P8(a) : (Lr && Cy(n, a, u), j8(a), n === ai && ((Kt & ka) === Hr && (Ov = Mt(Ov, u)), Gr === _v && Zc(n, Vr)), Di(n, c), u === gt && Kt === Hr && (a.mode & zt) === mt && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !vs.isBatchingLegacy && (jv(), $6()));
    }
    function a8(n, a, u) {
      var c = n.current;
      c.lanes = a, rl(n, a, u), Di(n, u);
    }
    function i8(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Kt & ka) !== Hr
      );
    }
    function Di(n, a) {
      var u = n.callbackNode;
      Kx(n, a);
      var c = Kd(n, n === ai ? Vr : be);
      if (c === be) {
        u !== null && JR(u), n.callbackNode = null, n.callbackPriority = Zt;
        return;
      }
      var h = pr(c), g = n.callbackPriority;
      if (g === h && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(vs.current !== null && u !== Fk)) {
        u == null && g !== gt && f("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && JR(u);
      var E;
      if (h === gt)
        n.tag === Lc ? (vs.isBatchingLegacy !== null && (vs.didScheduleLegacyUpdate = !0), IM(zR.bind(null, n))) : M6(zR.bind(null, n)), vs.current !== null ? vs.current.push(Nc) : N7(function() {
          (Kt & (ka | _o)) === Hr && Nc();
        }), E = null;
      else {
        var _;
        switch (tf(c)) {
          case Xr:
            _ = kp;
            break;
          case Nr:
            _ = ei;
            break;
          case ns:
            _ = vo;
            break;
          case Jd:
            _ = Xs;
            break;
          default:
            _ = vo;
            break;
        }
        E = zk(_, NR.bind(null, n));
      }
      n.callbackPriority = h, n.callbackNode = E;
    }
    function NR(n, a) {
      if (_4(), Iv = Cn, Jw = be, (Kt & (ka | _o)) !== Hr)
        throw new Error("Should not already be working.");
      var u = n.callbackNode, c = kl();
      if (c && n.callbackNode !== u)
        return null;
      var h = Kd(n, n === ai ? Vr : be);
      if (h === be)
        return null;
      var g = !Xd(n, h) && !fb(n, h) && !a, E = g ? m8(n, h) : n1(n, h);
      if (E !== wl) {
        if (E === Cf) {
          var _ = gy(n);
          _ !== be && (h = _, E = Dk(n, _));
        }
        if (E === Tv) {
          var P = Rv;
          throw _f(n, be), Zc(n, h), Di(n, Yn()), P;
        }
        if (E === Ck)
          Zc(n, h);
        else {
          var M = !Xd(n, h), F = n.current.alternate;
          if (M && !s8(F)) {
            if (E = n1(n, h), E === Cf) {
              var X = gy(n);
              X !== be && (h = X, E = Dk(n, X));
            }
            if (E === Tv) {
              var K = Rv;
              throw _f(n, be), Zc(n, h), Di(n, Yn()), K;
            }
          }
          n.finishedWork = F, n.finishedLanes = h, o8(n, E, h);
        }
      }
      return Di(n, Yn()), n.callbackNode === u ? NR.bind(null, n) : null;
    }
    function Dk(n, a) {
      var u = Pv;
      if (br(n)) {
        var c = _f(n, a);
        c.flags |= er, _M(n.containerInfo);
      }
      var h = n1(n, a);
      if (h !== Cf) {
        var g = Ai;
        Ai = u, g !== null && FR(g);
      }
      return h;
    }
    function FR(n) {
      Ai === null ? Ai = n : Ai.push.apply(Ai, n);
    }
    function o8(n, a, u) {
      switch (a) {
        case wl:
        case Tv:
          throw new Error("Root did not complete. This is a bug in React.");
        case Cf: {
          Rf(n, Ai, xl);
          break;
        }
        case Ww: {
          if (Zc(n, u), Wp(u) && // do not delay if we're inside an act() scope
          !eO()) {
            var c = _k + IR - Yn();
            if (c > 10) {
              var h = Kd(n, be);
              if (h !== be)
                break;
              var g = n.suspendedLanes;
              if (!nl(g, u)) {
                ii(), ky(n, g);
                break;
              }
              n.timeoutHandle = P2(Rf.bind(null, n, Ai, xl), c);
              break;
            }
          }
          Rf(n, Ai, xl);
          break;
        }
        case _v: {
          if (Zc(n, u), db(u))
            break;
          if (!eO()) {
            var E = cb(n, u), _ = E, P = Yn() - _, M = T8(P) - P;
            if (M > 10) {
              n.timeoutHandle = P2(Rf.bind(null, n, Ai, xl), M);
              break;
            }
          }
          Rf(n, Ai, xl);
          break;
        }
        case DR: {
          Rf(n, Ai, xl);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function s8(n) {
      for (var a = n; ; ) {
        if (a.flags & Hd) {
          var u = a.updateQueue;
          if (u !== null) {
            var c = u.stores;
            if (c !== null)
              for (var h = 0; h < c.length; h++) {
                var g = c[h], E = g.getSnapshot, _ = g.value;
                try {
                  if (!et(E(), _))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var P = a.child;
        if (a.subtreeFlags & Hd && P !== null) {
          P.return = a, a = P;
          continue;
        }
        if (a === n)
          return !0;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n)
            return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function Zc(n, a) {
      a = bc(a, Zw), a = bc(a, Ov), Sy(n, a);
    }
    function zR(n) {
      if (R4(), (Kt & (ka | _o)) !== Hr)
        throw new Error("Should not already be working.");
      kl();
      var a = Kd(n, be);
      if (!Na(a, gt))
        return Di(n, Yn()), null;
      var u = n1(n, a);
      if (n.tag !== Lc && u === Cf) {
        var c = gy(n);
        c !== be && (a = c, u = Dk(n, c));
      }
      if (u === Tv) {
        var h = Rv;
        throw _f(n, be), Zc(n, a), Di(n, Yn()), h;
      }
      if (u === Ck)
        throw new Error("Root did not complete. This is a bug in React.");
      var g = n.current.alternate;
      return n.finishedWork = g, n.finishedLanes = a, Rf(n, Ai, xl), Di(n, Yn()), null;
    }
    function u8(n, a) {
      a !== be && (wc(n, Mt(a, gt)), Di(n, Yn()), (Kt & (ka | _o)) === Hr && (jv(), Nc()));
    }
    function Ik(n, a) {
      var u = Kt;
      Kt |= AR;
      try {
        return n(a);
      } finally {
        Kt = u, Kt === Hr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !vs.isBatchingLegacy && (jv(), $6());
      }
    }
    function l8(n, a, u, c, h) {
      var g = Ci(), E = Sa.transition;
      try {
        return Sa.transition = null, gr(Xr), n(a, u, c, h);
      } finally {
        gr(g), Sa.transition = E, Kt === Hr && jv();
      }
    }
    function Sl(n) {
      Wc !== null && Wc.tag === Lc && (Kt & (ka | _o)) === Hr && kl();
      var a = Kt;
      Kt |= AR;
      var u = Sa.transition, c = Ci();
      try {
        return Sa.transition = null, gr(Xr), n ? n() : void 0;
      } finally {
        gr(c), Sa.transition = u, Kt = a, (Kt & (ka | _o)) === Hr && Nc();
      }
    }
    function BR() {
      return (Kt & (ka | _o)) !== Hr;
    }
    function t1(n, a) {
      za(Tk, wu, n), wu = Mt(wu, a);
    }
    function Mk(n) {
      wu = Tk.current, Fa(Tk, n);
    }
    function _f(n, a) {
      n.finishedWork = null, n.finishedLanes = be;
      var u = n.timeoutHandle;
      if (u !== j2 && (n.timeoutHandle = j2, L7(u)), ur !== null)
        for (var c = ur.return; c !== null; ) {
          var h = c.alternate;
          yR(h, c), c = c.return;
        }
      ai = n;
      var g = Of(n.current, null);
      return ur = g, Vr = wu = a, Gr = wl, Rv = null, Yw = be, Ov = be, Zw = be, Pv = null, Ai = null, n4(), ls.discardPendingWarnings(), g;
    }
    function UR(n, a) {
      do {
        var u = ur;
        try {
          if (lw(), g_(), Jn(), Ek.current = null, u === null || u.return === null) {
            Gr = Tv, Rv = a, ur = null;
            return;
          }
          if (at && u.mode & vt && Bw(u, !0), bt)
            if (Wu(), a !== null && typeof a == "object" && typeof a.then == "function") {
              var c = a;
              sb(u, c, Vr);
            } else
              Rp(u, a, Vr);
          D4(n, u.return, u, a, Vr), qR(u);
        } catch (h) {
          a = h, ur === u && u !== null ? (u = u.return, ur = u) : u = ur;
          continue;
        }
        return;
      } while (!0);
    }
    function HR() {
      var n = kk.current;
      return kk.current = $w, n === null ? $w : n;
    }
    function VR(n) {
      kk.current = n;
    }
    function c8() {
      _k = Yn();
    }
    function Mv(n) {
      Yw = Mt(n, Yw);
    }
    function d8() {
      Gr === wl && (Gr = Ww);
    }
    function $k() {
      (Gr === wl || Gr === Ww || Gr === Cf) && (Gr = _v), ai !== null && (Qd(Yw) || Qd(Ov)) && Zc(ai, Vr);
    }
    function f8(n) {
      Gr !== _v && (Gr = Cf), Pv === null ? Pv = [n] : Pv.push(n);
    }
    function p8() {
      return Gr === wl;
    }
    function n1(n, a) {
      var u = Kt;
      Kt |= ka;
      var c = HR();
      if (ai !== n || Vr !== a) {
        if (Lr) {
          var h = n.memoizedUpdaters;
          h.size > 0 && ($v(n, Vr), h.clear()), Kp(n, a);
        }
        xl = Ty(), _f(n, a);
      }
      Zi(a);
      do
        try {
          h8();
          break;
        } catch (g) {
          UR(n, g);
        }
      while (!0);
      if (lw(), Kt = u, VR(c), ur !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return hc(), ai = null, Vr = be, Gr;
    }
    function h8() {
      for (; ur !== null; )
        GR(ur);
    }
    function m8(n, a) {
      var u = Kt;
      Kt |= ka;
      var c = HR();
      if (ai !== n || Vr !== a) {
        if (Lr) {
          var h = n.memoizedUpdaters;
          h.size > 0 && ($v(n, Vr), h.clear()), Kp(n, a);
        }
        xl = Ty(), jv(), _f(n, a);
      }
      Zi(a);
      do
        try {
          y8();
          break;
        } catch (g) {
          UR(n, g);
        }
      while (!0);
      return lw(), VR(c), Kt = u, ur !== null ? (qd(), wl) : (hc(), ai = null, Vr = be, Gr);
    }
    function y8() {
      for (; ur !== null && !Sp(); )
        GR(ur);
    }
    function GR(n) {
      var a = n.alternate;
      pn(n);
      var u;
      (n.mode & vt) !== mt ? (QS(n), u = Lk(a, n, wu), Bw(n, !0)) : u = Lk(a, n, wu), Jn(), n.memoizedProps = n.pendingProps, u === null ? qR(n) : ur = u, Ek.current = null;
    }
    function qR(n) {
      var a = n;
      do {
        var u = a.alternate, c = a.return;
        if ((a.flags & Qa) === lt) {
          pn(a);
          var h = void 0;
          if ((a.mode & vt) === mt ? h = mR(u, a, wu) : (QS(a), h = mR(u, a, wu), Bw(a, !1)), Jn(), h !== null) {
            ur = h;
            return;
          }
        } else {
          var g = d$(u, a);
          if (g !== null) {
            g.flags &= X0, ur = g;
            return;
          }
          if ((a.mode & vt) !== mt) {
            Bw(a, !1);
            for (var E = a.actualDuration, _ = a.child; _ !== null; )
              E += _.actualDuration, _ = _.sibling;
            a.actualDuration = E;
          }
          if (c !== null)
            c.flags |= Qa, c.subtreeFlags = lt, c.deletions = null;
          else {
            Gr = Ck, ur = null;
            return;
          }
        }
        var P = a.sibling;
        if (P !== null) {
          ur = P;
          return;
        }
        a = c, ur = a;
      } while (a !== null);
      Gr === wl && (Gr = DR);
    }
    function Rf(n, a, u) {
      var c = Ci(), h = Sa.transition;
      try {
        Sa.transition = null, gr(Xr), v8(n, a, u, c);
      } finally {
        Sa.transition = h, gr(c);
      }
      return null;
    }
    function v8(n, a, u, c) {
      do
        kl();
      while (Wc !== null);
      if (R8(), (Kt & (ka | _o)) !== Hr)
        throw new Error("Should not already be working.");
      var h = n.finishedWork, g = n.finishedLanes;
      if (Cp(g), h === null)
        return py(), null;
      if (g === be && f("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = be, h === n.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = Zt;
      var E = Mt(h.lanes, h.childLanes);
      Ey(n, E), n === ai && (ai = null, ur = null, Vr = be), ((h.subtreeFlags & xi) !== lt || (h.flags & xi) !== lt) && (Tf || (Tf = !0, Pk = u, zk(vo, function() {
        return kl(), null;
      })));
      var _ = (h.subtreeFlags & (dc | Ia | Qr | xi)) !== lt, P = (h.flags & (dc | Ia | Qr | xi)) !== lt;
      if (_ || P) {
        var M = Sa.transition;
        Sa.transition = null;
        var F = Ci();
        gr(Xr);
        var X = Kt;
        Kt |= _o, Ek.current = null, y$(n, h), H_(), P$(n, h, g), P7(n.containerInfo), n.current = h, ub(g), j$(h, n, g), pc(), tb(), Kt = X, gr(F), Sa.transition = M;
      } else
        n.current = h, H_();
      var K = Tf;
      if (Tf ? (Tf = !1, Wc = n, Av = g) : (Fh = 0, Xw = null), E = n.pendingLanes, E === be && (Nh = null), K || KR(n.current, !1), Jo(h.stateNode, c), Lr && n.memoizedUpdaters.clear(), K$(), Di(n, Yn()), a !== null)
        for (var re = n.onRecoverableError, ie = 0; ie < a.length; ie++) {
          var me = a[ie], qe = me.stack, ft = me.digest;
          re(me.value, {
            componentStack: qe,
            digest: ft
          });
        }
      if (Kw) {
        Kw = !1;
        var it = Rk;
        throw Rk = null, it;
      }
      return Na(Av, gt) && n.tag !== Lc && kl(), E = n.pendingLanes, Na(E, gt) ? (T4(), n === jk ? Dv++ : (Dv = 0, jk = n)) : Dv = 0, Nc(), py(), null;
    }
    function kl() {
      if (Wc !== null) {
        var n = tf(Av), a = t2(ns, n), u = Sa.transition, c = Ci();
        try {
          return Sa.transition = null, gr(a), b8();
        } finally {
          gr(c), Sa.transition = u;
        }
      }
      return !1;
    }
    function g8(n) {
      Ok.push(n), Tf || (Tf = !0, zk(vo, function() {
        return kl(), null;
      }));
    }
    function b8() {
      if (Wc === null)
        return !1;
      var n = Pk;
      Pk = null;
      var a = Wc, u = Av;
      if (Wc = null, Av = be, (Kt & (ka | _o)) !== Hr)
        throw new Error("Cannot flush passive effects while already rendering.");
      Ak = !0, Qw = !1, lb(u);
      var c = Kt;
      Kt |= _o, N$(a.current), I$(a, a.current, u, n);
      {
        var h = Ok;
        Ok = [];
        for (var g = 0; g < h.length; g++) {
          var E = h[g];
          w$(a, E);
        }
      }
      Gd(), KR(a.current, !0), Kt = c, Nc(), Qw ? a === Xw ? Fh++ : (Fh = 0, Xw = a) : Fh = 0, Ak = !1, Qw = !1, eu(a);
      {
        var _ = a.current.stateNode;
        _.effectDuration = 0, _.passiveEffectDuration = 0;
      }
      return !0;
    }
    function WR(n) {
      return Nh !== null && Nh.has(n);
    }
    function w8(n) {
      Nh === null ? Nh = /* @__PURE__ */ new Set([n]) : Nh.add(n);
    }
    function x8(n) {
      Kw || (Kw = !0, Rk = n);
    }
    var S8 = x8;
    function YR(n, a, u) {
      var c = kf(u, a), h = G_(n, c, gt), g = zc(n, h, gt), E = ii();
      g !== null && (rl(g, gt, E), Di(g, E));
    }
    function Ln(n, a, u) {
      if (p$(u), Lv(!1), n.tag === b) {
        YR(n, n, u);
        return;
      }
      var c = null;
      for (c = a; c !== null; ) {
        if (c.tag === b) {
          YR(c, n, u);
          return;
        } else if (c.tag === w) {
          var h = c.type, g = c.stateNode;
          if (typeof h.getDerivedStateFromError == "function" || typeof g.componentDidCatch == "function" && !WR(g)) {
            var E = kf(u, n), _ = rk(c, E, gt), P = zc(c, _, gt), M = ii();
            P !== null && (rl(P, gt, M), Di(P, M));
            return;
          }
        }
        c = c.return;
      }
      f(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function k8(n, a, u) {
      var c = n.pingCache;
      c !== null && c.delete(a);
      var h = ii();
      ky(n, u), A8(n), ai === n && nl(Vr, u) && (Gr === _v || Gr === Ww && Wp(Vr) && Yn() - _k < IR ? _f(n, be) : Zw = Mt(Zw, u)), Di(n, h);
    }
    function ZR(n, a) {
      a === Zt && (a = r8(n));
      var u = ii(), c = Pi(n, a);
      c !== null && (rl(c, a, u), Di(c, u));
    }
    function E8(n) {
      var a = n.memoizedState, u = Zt;
      a !== null && (u = a.retryLane), ZR(n, u);
    }
    function C8(n, a) {
      var u = Zt, c;
      switch (n.tag) {
        case H:
          c = n.stateNode;
          var h = n.memoizedState;
          h !== null && (u = h.retryLane);
          break;
        case Se:
          c = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      c !== null && c.delete(a), ZR(n, u);
    }
    function T8(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : J$(n / 1960) * 1960;
    }
    function _8() {
      if (Dv > t8)
        throw Dv = 0, jk = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Fh > n8 && (Fh = 0, Xw = null, f("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function R8() {
      ls.flushLegacyContextWarning(), ls.flushPendingUnsafeLifecycleWarnings();
    }
    function KR(n, a) {
      pn(n), r1(n, Da, W$), a && r1(n, qu, Y$), r1(n, Da, G$), a && r1(n, qu, q$), Jn();
    }
    function r1(n, a, u) {
      for (var c = n, h = null; c !== null; ) {
        var g = c.subtreeFlags & a;
        c !== h && c.child !== null && g !== lt ? c = c.child : ((c.flags & a) !== lt && u(c), c.sibling !== null ? c = c.sibling : c = h = c.return);
      }
    }
    var a1 = null;
    function QR(n) {
      {
        if ((Kt & ka) !== Hr || !(n.mode & zt))
          return;
        var a = n.tag;
        if (a !== x && a !== b && a !== w && a !== v && a !== L && a !== V && a !== W)
          return;
        var u = _t(n) || "ReactComponent";
        if (a1 !== null) {
          if (a1.has(u))
            return;
          a1.add(u);
        } else
          a1 = /* @__PURE__ */ new Set([u]);
        var c = Wn;
        try {
          pn(n), f("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          c ? pn(n) : Jn();
        }
      }
    }
    var Lk;
    {
      var O8 = null;
      Lk = function(n, a, u) {
        var c = iO(O8, a);
        try {
          return cR(n, a, u);
        } catch (g) {
          if (UM() || g !== null && typeof g == "object" && typeof g.then == "function")
            throw g;
          if (lw(), g_(), yR(n, a), iO(a, c), a.mode & vt && QS(a), Gu(null, cR, null, n, a, u), Yx()) {
            var h = ny();
            typeof h == "object" && h !== null && h._suppressLogging && typeof g == "object" && g !== null && !g._suppressLogging && (g._suppressLogging = !0);
          }
          throw g;
        }
      };
    }
    var XR = !1, Nk;
    Nk = /* @__PURE__ */ new Set();
    function P8(n) {
      if (Ra && !k4())
        switch (n.tag) {
          case v:
          case L:
          case W: {
            var a = ur && _t(ur) || "Unknown", u = a;
            if (!Nk.has(u)) {
              Nk.add(u);
              var c = _t(n) || "Unknown";
              f("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", c, a, a);
            }
            break;
          }
          case w: {
            XR || (f("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), XR = !0);
            break;
          }
        }
    }
    function $v(n, a) {
      if (Lr) {
        var u = n.memoizedUpdaters;
        u.forEach(function(c) {
          Cy(n, c, a);
        });
      }
    }
    var Fk = {};
    function zk(n, a) {
      {
        var u = vs.current;
        return u !== null ? (u.push(a), Fk) : xp(n, a);
      }
    }
    function JR(n) {
      if (n !== Fk)
        return eb(n);
    }
    function eO() {
      return vs.current !== null;
    }
    function j8(n) {
      {
        if (n.mode & zt) {
          if (!jR())
            return;
        } else if (!X$() || Kt !== Hr || n.tag !== v && n.tag !== L && n.tag !== W)
          return;
        if (vs.current === null) {
          var a = Wn;
          try {
            pn(n), f(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, _t(n));
          } finally {
            a ? pn(n) : Jn();
          }
        }
      }
    }
    function A8(n) {
      n.tag !== Lc && jR() && vs.current === null && f(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Lv(n) {
      LR = n;
    }
    var Ro = null, zh = null, D8 = function(n) {
      Ro = n;
    };
    function Bh(n) {
      {
        if (Ro === null)
          return n;
        var a = Ro(n);
        return a === void 0 ? n : a.current;
      }
    }
    function Bk(n) {
      return Bh(n);
    }
    function Uk(n) {
      {
        if (Ro === null)
          return n;
        var a = Ro(n);
        if (a === void 0) {
          if (n != null && typeof n.render == "function") {
            var u = Bh(n.render);
            if (n.render !== u) {
              var c = {
                $$typeof: Ge,
                render: u
              };
              return n.displayName !== void 0 && (c.displayName = n.displayName), c;
            }
          }
          return n;
        }
        return a.current;
      }
    }
    function tO(n, a) {
      {
        if (Ro === null)
          return !1;
        var u = n.elementType, c = a.type, h = !1, g = typeof c == "object" && c !== null ? c.$$typeof : null;
        switch (n.tag) {
          case w: {
            typeof c == "function" && (h = !0);
            break;
          }
          case v: {
            (typeof c == "function" || g === dt) && (h = !0);
            break;
          }
          case L: {
            (g === Ge || g === dt) && (h = !0);
            break;
          }
          case V:
          case W: {
            (g === Dt || g === dt) && (h = !0);
            break;
          }
          default:
            return !1;
        }
        if (h) {
          var E = Ro(u);
          if (E !== void 0 && E === Ro(c))
            return !0;
        }
        return !1;
      }
    }
    function nO(n) {
      {
        if (Ro === null || typeof WeakSet != "function")
          return;
        zh === null && (zh = /* @__PURE__ */ new WeakSet()), zh.add(n);
      }
    }
    var I8 = function(n, a) {
      {
        if (Ro === null)
          return;
        var u = a.staleFamilies, c = a.updatedFamilies;
        kl(), Sl(function() {
          Hk(n.current, c, u);
        });
      }
    }, M8 = function(n, a) {
      {
        if (n.context !== Qi)
          return;
        kl(), Sl(function() {
          Nv(a, n, null, null);
        });
      }
    };
    function Hk(n, a, u) {
      {
        var c = n.alternate, h = n.child, g = n.sibling, E = n.tag, _ = n.type, P = null;
        switch (E) {
          case v:
          case W:
          case w:
            P = _;
            break;
          case L:
            P = _.render;
            break;
        }
        if (Ro === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var M = !1, F = !1;
        if (P !== null) {
          var X = Ro(P);
          X !== void 0 && (u.has(X) ? F = !0 : a.has(X) && (E === w ? F = !0 : M = !0));
        }
        if (zh !== null && (zh.has(n) || c !== null && zh.has(c)) && (F = !0), F && (n._debugNeedsRemount = !0), F || M) {
          var K = Pi(n, gt);
          K !== null && qr(K, n, gt, Cn);
        }
        h !== null && !F && Hk(h, a, u), g !== null && Hk(g, a, u);
      }
    }
    var $8 = function(n, a) {
      {
        var u = /* @__PURE__ */ new Set(), c = new Set(a.map(function(h) {
          return h.current;
        }));
        return Vk(n.current, c, u), u;
      }
    };
    function Vk(n, a, u) {
      {
        var c = n.child, h = n.sibling, g = n.tag, E = n.type, _ = null;
        switch (g) {
          case v:
          case W:
          case w:
            _ = E;
            break;
          case L:
            _ = E.render;
            break;
        }
        var P = !1;
        _ !== null && a.has(_) && (P = !0), P ? L8(n, u) : c !== null && Vk(c, a, u), h !== null && Vk(h, a, u);
      }
    }
    function L8(n, a) {
      {
        var u = N8(n, a);
        if (u)
          return;
        for (var c = n; ; ) {
          switch (c.tag) {
            case T:
              a.add(c.stateNode);
              return;
            case k:
              a.add(c.stateNode.containerInfo);
              return;
            case b:
              a.add(c.stateNode.containerInfo);
              return;
          }
          if (c.return === null)
            throw new Error("Expected to reach root first.");
          c = c.return;
        }
      }
    }
    function N8(n, a) {
      for (var u = n, c = !1; ; ) {
        if (u.tag === T)
          c = !0, a.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === n)
          return c;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === n)
            return c;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var Gk;
    {
      Gk = !1;
      try {
        var rO = Object.preventExtensions({});
      } catch {
        Gk = !0;
      }
    }
    function F8(n, a, u, c) {
      this.tag = n, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = c, this.flags = lt, this.subtreeFlags = lt, this.deletions = null, this.lanes = be, this.childLanes = be, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Gk && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Xi = function(n, a, u, c) {
      return new F8(n, a, u, c);
    };
    function qk(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function z8(n) {
      return typeof n == "function" && !qk(n) && n.defaultProps === void 0;
    }
    function B8(n) {
      if (typeof n == "function")
        return qk(n) ? w : v;
      if (n != null) {
        var a = n.$$typeof;
        if (a === Ge)
          return L;
        if (a === Dt)
          return V;
      }
      return x;
    }
    function Of(n, a) {
      var u = n.alternate;
      u === null ? (u = Xi(n.tag, a, n.key, n.mode), u.elementType = n.elementType, u.type = n.type, u.stateNode = n.stateNode, u._debugSource = n._debugSource, u._debugOwner = n._debugOwner, u._debugHookTypes = n._debugHookTypes, u.alternate = n, n.alternate = u) : (u.pendingProps = a, u.type = n.type, u.flags = lt, u.subtreeFlags = lt, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = n.flags & $r, u.childLanes = n.childLanes, u.lanes = n.lanes, u.child = n.child, u.memoizedProps = n.memoizedProps, u.memoizedState = n.memoizedState, u.updateQueue = n.updateQueue;
      var c = n.dependencies;
      switch (u.dependencies = c === null ? null : {
        lanes: c.lanes,
        firstContext: c.firstContext
      }, u.sibling = n.sibling, u.index = n.index, u.ref = n.ref, u.selfBaseDuration = n.selfBaseDuration, u.treeBaseDuration = n.treeBaseDuration, u._debugNeedsRemount = n._debugNeedsRemount, u.tag) {
        case x:
        case v:
        case W:
          u.type = Bh(n.type);
          break;
        case w:
          u.type = Bk(n.type);
          break;
        case L:
          u.type = Uk(n.type);
          break;
      }
      return u;
    }
    function U8(n, a) {
      n.flags &= $r | Dn;
      var u = n.alternate;
      if (u === null)
        n.childLanes = be, n.lanes = a, n.child = null, n.subtreeFlags = lt, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;
      else {
        n.childLanes = u.childLanes, n.lanes = u.lanes, n.child = u.child, n.subtreeFlags = lt, n.deletions = null, n.memoizedProps = u.memoizedProps, n.memoizedState = u.memoizedState, n.updateQueue = u.updateQueue, n.type = u.type;
        var c = u.dependencies;
        n.dependencies = c === null ? null : {
          lanes: c.lanes,
          firstContext: c.firstContext
        }, n.selfBaseDuration = u.selfBaseDuration, n.treeBaseDuration = u.treeBaseDuration;
      }
      return n;
    }
    function H8(n, a, u) {
      var c;
      return n === tw ? (c = zt, a === !0 && (c |= Zn, c |= ki)) : c = mt, Lr && (c |= vt), Xi(b, null, null, c);
    }
    function Wk(n, a, u, c, h, g) {
      var E = x, _ = n;
      if (typeof n == "function")
        qk(n) ? (E = w, _ = Bk(_)) : _ = Bh(_);
      else if (typeof n == "string")
        E = T;
      else
        e:
          switch (n) {
            case Ka:
              return Kc(u.children, h, g, a);
            case lo:
              E = j, h |= Zn, (h & zt) !== mt && (h |= ki);
              break;
            case q:
              return V8(u, h, g, a);
            case At:
              return G8(u, h, g, a);
            case Yt:
              return q8(u, h, g, a);
            case Pn:
              return aO(u, h, g, a);
            case Mr:
            case dr:
            case co:
            case ql:
            case On:
            default: {
              if (typeof n == "object" && n !== null)
                switch (n.$$typeof) {
                  case Ce:
                    E = N;
                    break e;
                  case $e:
                    E = I;
                    break e;
                  case Ge:
                    E = L, _ = Uk(_);
                    break e;
                  case Dt:
                    E = V;
                    break e;
                  case dt:
                    E = Y, _ = null;
                    break e;
                }
              var P = "";
              {
                (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (P += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var M = c ? _t(c) : null;
                M && (P += `

Check the render method of \`` + M + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + P));
            }
          }
      var F = Xi(E, u, a, h);
      return F.elementType = n, F.type = _, F.lanes = g, F._debugOwner = c, F;
    }
    function Yk(n, a, u) {
      var c = null;
      c = n._owner;
      var h = n.type, g = n.key, E = n.props, _ = Wk(h, g, E, c, a, u);
      return _._debugSource = n._source, _._debugOwner = n._owner, _;
    }
    function Kc(n, a, u, c) {
      var h = Xi(R, n, c, a);
      return h.lanes = u, h;
    }
    function V8(n, a, u, c) {
      typeof n.id != "string" && f('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var h = Xi(B, n, c, a | vt);
      return h.elementType = q, h.lanes = u, h.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, h;
    }
    function G8(n, a, u, c) {
      var h = Xi(H, n, c, a);
      return h.elementType = At, h.lanes = u, h;
    }
    function q8(n, a, u, c) {
      var h = Xi(Se, n, c, a);
      return h.elementType = Yt, h.lanes = u, h;
    }
    function aO(n, a, u, c) {
      var h = Xi(Re, n, c, a);
      h.elementType = Pn, h.lanes = u;
      var g = {
        isHidden: !1
      };
      return h.stateNode = g, h;
    }
    function Zk(n, a, u) {
      var c = Xi(O, n, null, a);
      return c.lanes = u, c;
    }
    function W8() {
      var n = Xi(T, null, null, mt);
      return n.elementType = "DELETED", n;
    }
    function Y8(n) {
      var a = Xi(ve, null, null, mt);
      return a.stateNode = n, a;
    }
    function Kk(n, a, u) {
      var c = n.children !== null ? n.children : [], h = Xi(k, c, n.key, a);
      return h.lanes = u, h.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, h;
    }
    function iO(n, a) {
      return n === null && (n = Xi(x, null, null, mt)), n.tag = a.tag, n.key = a.key, n.elementType = a.elementType, n.type = a.type, n.stateNode = a.stateNode, n.return = a.return, n.child = a.child, n.sibling = a.sibling, n.index = a.index, n.ref = a.ref, n.pendingProps = a.pendingProps, n.memoizedProps = a.memoizedProps, n.updateQueue = a.updateQueue, n.memoizedState = a.memoizedState, n.dependencies = a.dependencies, n.mode = a.mode, n.flags = a.flags, n.subtreeFlags = a.subtreeFlags, n.deletions = a.deletions, n.lanes = a.lanes, n.childLanes = a.childLanes, n.alternate = a.alternate, n.actualDuration = a.actualDuration, n.actualStartTime = a.actualStartTime, n.selfBaseDuration = a.selfBaseDuration, n.treeBaseDuration = a.treeBaseDuration, n._debugSource = a._debugSource, n._debugOwner = a._debugOwner, n._debugNeedsRemount = a._debugNeedsRemount, n._debugHookTypes = a._debugHookTypes, n;
    }
    function Z8(n, a, u, c, h) {
      this.tag = a, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = j2, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Zt, this.eventTimes = Zp(be), this.expirationTimes = Zp(Cn), this.pendingLanes = be, this.suspendedLanes = be, this.pingedLanes = be, this.expiredLanes = be, this.mutableReadLanes = be, this.finishedLanes = be, this.entangledLanes = be, this.entanglements = Zp(be), this.identifierPrefix = c, this.onRecoverableError = h, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var g = this.pendingUpdatersLaneMap = [], E = 0; E < Mn; E++)
          g.push(/* @__PURE__ */ new Set());
      }
      switch (a) {
        case tw:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case Lc:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function oO(n, a, u, c, h, g, E, _, P, M) {
      var F = new Z8(n, a, u, _, P), X = H8(a, g);
      F.current = X, X.stateNode = F;
      {
        var K = {
          element: c,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        X.memoizedState = K;
      }
      return aS(X), F;
    }
    var Qk = "18.2.0";
    function K8(n, a, u) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Yr(c), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: da,
        key: c == null ? null : "" + c,
        children: n,
        containerInfo: a,
        implementation: u
      };
    }
    var Xk, Jk;
    Xk = !1, Jk = {};
    function sO(n) {
      if (!n)
        return Qi;
      var a = gi(n), u = DM(a);
      if (a.tag === w) {
        var c = a.type;
        if (pu(c))
          return D6(a, c, u);
      }
      return u;
    }
    function Q8(n, a) {
      {
        var u = gi(n);
        if (u === void 0) {
          if (typeof n.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var c = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + c);
        }
        var h = Si(u);
        if (h === null)
          return null;
        if (h.mode & Zn) {
          var g = _t(u) || "Component";
          if (!Jk[g]) {
            Jk[g] = !0;
            var E = Wn;
            try {
              pn(h), u.mode & Zn ? f("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, g) : f("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, g);
            } finally {
              E ? pn(E) : Jn();
            }
          }
        }
        return h.stateNode;
      }
    }
    function uO(n, a, u, c, h, g, E, _) {
      var P = !1, M = null;
      return oO(n, a, P, M, u, c, h, g, E);
    }
    function lO(n, a, u, c, h, g, E, _, P, M) {
      var F = !0, X = oO(u, c, F, n, h, g, E, _, P);
      X.context = sO(null);
      var K = X.current, re = ii(), ie = Yc(K), me = gl(re, ie);
      return me.callback = a ?? null, zc(K, me, ie), a8(X, ie, re), X;
    }
    function Nv(n, a, u, c) {
      nb(a, n);
      var h = a.current, g = ii(), E = Yc(h);
      Yu(E);
      var _ = sO(u);
      a.context === null ? a.context = _ : a.pendingContext = _, Ra && Wn !== null && !Xk && (Xk = !0, f(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, _t(Wn) || "Unknown"));
      var P = gl(g, E);
      P.payload = {
        element: n
      }, c = c === void 0 ? null : c, c !== null && (typeof c != "function" && f("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c), P.callback = c);
      var M = zc(h, P, E);
      return M !== null && (qr(M, h, E, g), hw(M, h, E)), E;
    }
    function i1(n) {
      var a = n.current;
      if (!a.child)
        return null;
      switch (a.child.tag) {
        case T:
          return a.child.stateNode;
        default:
          return a.child.stateNode;
      }
    }
    function X8(n) {
      switch (n.tag) {
        case b: {
          var a = n.stateNode;
          if (br(a)) {
            var u = Qx(a);
            u8(a, u);
          }
          break;
        }
        case H: {
          Sl(function() {
            var h = Pi(n, gt);
            if (h !== null) {
              var g = ii();
              qr(h, n, gt, g);
            }
          });
          var c = gt;
          eE(n, c);
          break;
        }
      }
    }
    function cO(n, a) {
      var u = n.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = hb(u.retryLane, a));
    }
    function eE(n, a) {
      cO(n, a);
      var u = n.alternate;
      u && cO(u, a);
    }
    function J8(n) {
      if (n.tag === H) {
        var a = mc, u = Pi(n, a);
        if (u !== null) {
          var c = ii();
          qr(u, n, a, c);
        }
        eE(n, a);
      }
    }
    function eL(n) {
      if (n.tag === H) {
        var a = Yc(n), u = Pi(n, a);
        if (u !== null) {
          var c = ii();
          qr(u, n, a, c);
        }
        eE(n, a);
      }
    }
    function dO(n) {
      var a = J0(n);
      return a === null ? null : a.stateNode;
    }
    var fO = function(n) {
      return null;
    };
    function tL(n) {
      return fO(n);
    }
    var pO = function(n) {
      return !1;
    };
    function nL(n) {
      return pO(n);
    }
    var hO = null, mO = null, yO = null, vO = null, gO = null, bO = null, wO = null, xO = null, SO = null;
    {
      var kO = function(n, a, u) {
        var c = a[u], h = Wt(n) ? n.slice() : Nt({}, n);
        return u + 1 === a.length ? (Wt(h) ? h.splice(c, 1) : delete h[c], h) : (h[c] = kO(n[c], a, u + 1), h);
      }, EO = function(n, a) {
        return kO(n, a, 0);
      }, CO = function(n, a, u, c) {
        var h = a[c], g = Wt(n) ? n.slice() : Nt({}, n);
        if (c + 1 === a.length) {
          var E = u[c];
          g[E] = g[h], Wt(g) ? g.splice(h, 1) : delete g[h];
        } else
          g[h] = CO(
            // $FlowFixMe number or string is fine here
            n[h],
            a,
            u,
            c + 1
          );
        return g;
      }, TO = function(n, a, u) {
        if (a.length !== u.length) {
          d("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var c = 0; c < u.length - 1; c++)
            if (a[c] !== u[c]) {
              d("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return CO(n, a, u, 0);
      }, _O = function(n, a, u, c) {
        if (u >= a.length)
          return c;
        var h = a[u], g = Wt(n) ? n.slice() : Nt({}, n);
        return g[h] = _O(n[h], a, u + 1, c), g;
      }, RO = function(n, a, u) {
        return _O(n, a, 0, u);
      }, tE = function(n, a) {
        for (var u = n.memoizedState; u !== null && a > 0; )
          u = u.next, a--;
        return u;
      };
      hO = function(n, a, u, c) {
        var h = tE(n, a);
        if (h !== null) {
          var g = RO(h.memoizedState, u, c);
          h.memoizedState = g, h.baseState = g, n.memoizedProps = Nt({}, n.memoizedProps);
          var E = Pi(n, gt);
          E !== null && qr(E, n, gt, Cn);
        }
      }, mO = function(n, a, u) {
        var c = tE(n, a);
        if (c !== null) {
          var h = EO(c.memoizedState, u);
          c.memoizedState = h, c.baseState = h, n.memoizedProps = Nt({}, n.memoizedProps);
          var g = Pi(n, gt);
          g !== null && qr(g, n, gt, Cn);
        }
      }, yO = function(n, a, u, c) {
        var h = tE(n, a);
        if (h !== null) {
          var g = TO(h.memoizedState, u, c);
          h.memoizedState = g, h.baseState = g, n.memoizedProps = Nt({}, n.memoizedProps);
          var E = Pi(n, gt);
          E !== null && qr(E, n, gt, Cn);
        }
      }, vO = function(n, a, u) {
        n.pendingProps = RO(n.memoizedProps, a, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = Pi(n, gt);
        c !== null && qr(c, n, gt, Cn);
      }, gO = function(n, a) {
        n.pendingProps = EO(n.memoizedProps, a), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var u = Pi(n, gt);
        u !== null && qr(u, n, gt, Cn);
      }, bO = function(n, a, u) {
        n.pendingProps = TO(n.memoizedProps, a, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = Pi(n, gt);
        c !== null && qr(c, n, gt, Cn);
      }, wO = function(n) {
        var a = Pi(n, gt);
        a !== null && qr(a, n, gt, Cn);
      }, xO = function(n) {
        fO = n;
      }, SO = function(n) {
        pO = n;
      };
    }
    function rL(n) {
      var a = Si(n);
      return a === null ? null : a.stateNode;
    }
    function aL(n) {
      return null;
    }
    function iL() {
      return Wn;
    }
    function oL(n) {
      var a = n.findFiberByHostInstance, u = r.ReactCurrentDispatcher;
      return dy({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: hO,
        overrideHookStateDeletePath: mO,
        overrideHookStateRenamePath: yO,
        overrideProps: vO,
        overridePropsDeletePath: gO,
        overridePropsRenamePath: bO,
        setErrorHandler: xO,
        setSuspenseHandler: SO,
        scheduleUpdate: wO,
        currentDispatcherRef: u,
        findHostInstanceByFiber: rL,
        findFiberByHostInstance: a || aL,
        // React Refresh
        findHostInstancesForRefresh: $8,
        scheduleRefresh: I8,
        scheduleRoot: M8,
        setRefreshHandler: D8,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: iL,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: Qk
      });
    }
    var OO = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(n) {
      console.error(n);
    };
    function nE(n) {
      this._internalRoot = n;
    }
    o1.prototype.render = nE.prototype.render = function(n) {
      var a = this._internalRoot;
      if (a === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? f("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : s1(arguments[1]) ? f("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && f("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = a.containerInfo;
        if (u.nodeType !== fr) {
          var c = dO(a.current);
          c && c.parentNode !== u && f("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      Nv(n, a, null, null);
    }, o1.prototype.unmount = nE.prototype.unmount = function() {
      typeof arguments[0] == "function" && f("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var n = this._internalRoot;
      if (n !== null) {
        this._internalRoot = null;
        var a = n.containerInfo;
        BR() && f("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Sl(function() {
          Nv(null, n, null, null);
        }), R6(a);
      }
    };
    function sL(n, a) {
      if (!s1(n))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      PO(n);
      var u = !1, c = !1, h = "", g = OO;
      a != null && (a.hydrate ? d("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof a == "object" && a !== null && a.$$typeof === uo && f(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), a.unstable_strictMode === !0 && (u = !0), a.identifierPrefix !== void 0 && (h = a.identifierPrefix), a.onRecoverableError !== void 0 && (g = a.onRecoverableError), a.transitionCallbacks !== void 0 && a.transitionCallbacks);
      var E = uO(n, tw, null, u, c, h, g);
      Yb(E.current, n);
      var _ = n.nodeType === fr ? n.parentNode : n;
      return qy(_), new nE(E);
    }
    function o1(n) {
      this._internalRoot = n;
    }
    function uL(n) {
      n && Sb(n);
    }
    o1.prototype.unstable_scheduleHydration = uL;
    function lL(n, a, u) {
      if (!s1(n))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      PO(n), a === void 0 && f("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var c = u ?? null, h = u != null && u.hydratedSources || null, g = !1, E = !1, _ = "", P = OO;
      u != null && (u.unstable_strictMode === !0 && (g = !0), u.identifierPrefix !== void 0 && (_ = u.identifierPrefix), u.onRecoverableError !== void 0 && (P = u.onRecoverableError));
      var M = lO(a, null, n, tw, c, g, E, _, P);
      if (Yb(M.current, n), qy(n), h)
        for (var F = 0; F < h.length; F++) {
          var X = h[F];
          v4(M, X);
        }
      return new o1(M);
    }
    function s1(n) {
      return !!(n && (n.nodeType === Pa || n.nodeType === qi || n.nodeType === Fu || !ke));
    }
    function Fv(n) {
      return !!(n && (n.nodeType === Pa || n.nodeType === qi || n.nodeType === Fu || n.nodeType === fr && n.nodeValue === " react-mount-point-unstable "));
    }
    function PO(n) {
      n.nodeType === Pa && n.tagName && n.tagName.toUpperCase() === "BODY" && f("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), rv(n) && (n._reactRootContainer ? f("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : f("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var cL = r.ReactCurrentOwner, jO;
    jO = function(n) {
      if (n._reactRootContainer && n.nodeType !== fr) {
        var a = dO(n._reactRootContainer.current);
        a && a.parentNode !== n && f("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!n._reactRootContainer, c = rE(n), h = !!(c && Mc(c));
      h && !u && f("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), n.nodeType === Pa && n.tagName && n.tagName.toUpperCase() === "BODY" && f("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function rE(n) {
      return n ? n.nodeType === qi ? n.documentElement : n.firstChild : null;
    }
    function AO() {
    }
    function dL(n, a, u, c, h) {
      if (h) {
        if (typeof c == "function") {
          var g = c;
          c = function() {
            var K = i1(E);
            g.call(K);
          };
        }
        var E = lO(
          a,
          c,
          n,
          Lc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          AO
        );
        n._reactRootContainer = E, Yb(E.current, n);
        var _ = n.nodeType === fr ? n.parentNode : n;
        return qy(_), Sl(), E;
      } else {
        for (var P; P = n.lastChild; )
          n.removeChild(P);
        if (typeof c == "function") {
          var M = c;
          c = function() {
            var K = i1(F);
            M.call(K);
          };
        }
        var F = uO(
          n,
          Lc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          AO
        );
        n._reactRootContainer = F, Yb(F.current, n);
        var X = n.nodeType === fr ? n.parentNode : n;
        return qy(X), Sl(function() {
          Nv(a, F, u, c);
        }), F;
      }
    }
    function fL(n, a) {
      n !== null && typeof n != "function" && f("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n);
    }
    function u1(n, a, u, c, h) {
      jO(u), fL(h === void 0 ? null : h, "render");
      var g = u._reactRootContainer, E;
      if (!g)
        E = dL(u, a, n, h, c);
      else {
        if (E = g, typeof h == "function") {
          var _ = h;
          h = function() {
            var P = i1(E);
            _.call(P);
          };
        }
        Nv(a, E, n, h);
      }
      return i1(E);
    }
    function pL(n) {
      {
        var a = cL.current;
        if (a !== null && a.stateNode !== null) {
          var u = a.stateNode._warnedAboutRefsInRender;
          u || f("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", en(a.type) || "A component"), a.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return n == null ? null : n.nodeType === Pa ? n : Q8(n, "findDOMNode");
    }
    function hL(n, a, u) {
      if (f("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Fv(a))
        throw new Error("Target container is not a DOM element.");
      {
        var c = rv(a) && a._reactRootContainer === void 0;
        c && f("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return u1(null, n, a, !0, u);
    }
    function mL(n, a, u) {
      if (f("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Fv(a))
        throw new Error("Target container is not a DOM element.");
      {
        var c = rv(a) && a._reactRootContainer === void 0;
        c && f("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return u1(null, n, a, !1, u);
    }
    function yL(n, a, u, c) {
      if (f("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Fv(u))
        throw new Error("Target container is not a DOM element.");
      if (n == null || !Ud(n))
        throw new Error("parentComponent must be a valid React Component");
      return u1(n, a, u, !1, c);
    }
    function vL(n) {
      if (!Fv(n))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var a = rv(n) && n._reactRootContainer === void 0;
        a && f("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (n._reactRootContainer) {
        {
          var u = rE(n), c = u && !Mc(u);
          c && f("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Sl(function() {
          u1(null, null, n, !1, function() {
            n._reactRootContainer = null, R6(n);
          });
        }), !0;
      } else {
        {
          var h = rE(n), g = !!(h && Mc(h)), E = n.nodeType === Pa && Fv(n.parentNode) && !!n.parentNode._reactRootContainer;
          g && f("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", E ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Ze(X8), yb(J8), rf(eL), Ry(Ci), gb(ef), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && f("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), K0(w7), yp(Ik, l8, Sl);
    function gL(n, a) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!s1(a))
        throw new Error("Target container is not a DOM element.");
      return K8(n, a, null, u);
    }
    function bL(n, a, u, c) {
      return yL(n, a, u, c);
    }
    var aE = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Mc, gh, Zb, mp, Fd, Ik]
    };
    function wL(n, a) {
      return aE.usingClientEntryPoint || f('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), sL(n, a);
    }
    function xL(n, a, u) {
      return aE.usingClientEntryPoint || f('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), lL(n, a, u);
    }
    function SL(n) {
      return BR() && f("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Sl(n);
    }
    var kL = oL({
      findFiberByHostInstance: hf,
      bundleType: 1,
      version: Qk,
      rendererPackageName: "react-dom"
    });
    if (!kL && Vt && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var DO = window.location.protocol;
      /^(https?|file):$/.test(DO) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (DO === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Mi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = aE, Mi.createPortal = gL, Mi.createRoot = wL, Mi.findDOMNode = pL, Mi.flushSync = SL, Mi.hydrate = hL, Mi.hydrateRoot = xL, Mi.render = mL, Mi.unmountComponentAtNode = vL, Mi.unstable_batchedUpdates = Ik, Mi.unstable_renderSubtreeIntoContainer = bL, Mi.version = Qk, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Mi;
}
function qj() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(qj);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (qj(), JE.exports = LL()) : JE.exports = NL();
var X1 = JE.exports;
const IT = /* @__PURE__ */ km(X1);
var eC = { exports: {} }, uE = {}, d1 = { exports: {} }, lE = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VO;
function FL() {
  if (VO)
    return lE;
  VO = 1;
  var e = $;
  function t(b, k) {
    return b === k && (b !== 0 || 1 / b === 1 / k) || b !== b && k !== k;
  }
  var r = typeof Object.is == "function" ? Object.is : t, o = e.useState, l = e.useEffect, d = e.useLayoutEffect, f = e.useDebugValue;
  function m(b, k) {
    var T = k(), O = o({ inst: { value: T, getSnapshot: k } }), R = O[0].inst, j = O[1];
    return d(function() {
      R.value = T, R.getSnapshot = k, v(R) && j({ inst: R });
    }, [b, T, k]), l(function() {
      return v(R) && j({ inst: R }), b(function() {
        v(R) && j({ inst: R });
      });
    }, [b]), f(T), T;
  }
  function v(b) {
    var k = b.getSnapshot;
    b = b.value;
    try {
      var T = k();
      return !r(b, T);
    } catch {
      return !0;
    }
  }
  function w(b, k) {
    return k();
  }
  var x = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? w : m;
  return lE.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : x, lE;
}
var cE = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GO;
function zL() {
  return GO || (GO = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = $, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(L) {
      {
        for (var B = arguments.length, H = new Array(B > 1 ? B - 1 : 0), V = 1; V < B; V++)
          H[V - 1] = arguments[V];
        o("error", L, H);
      }
    }
    function o(L, B, H) {
      {
        var V = t.ReactDebugCurrentFrame, W = V.getStackAddendum();
        W !== "" && (B += "%s", H = H.concat([W]));
        var Y = H.map(function(ce) {
          return String(ce);
        });
        Y.unshift("Warning: " + B), Function.prototype.apply.call(console[L], console, Y);
      }
    }
    function l(L, B) {
      return L === B && (L !== 0 || 1 / L === 1 / B) || L !== L && B !== B;
    }
    var d = typeof Object.is == "function" ? Object.is : l, f = e.useState, m = e.useEffect, v = e.useLayoutEffect, w = e.useDebugValue, x = !1, b = !1;
    function k(L, B, H) {
      x || e.startTransition !== void 0 && (x = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var V = B();
      if (!b) {
        var W = B();
        d(V, W) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), b = !0);
      }
      var Y = f({
        inst: {
          value: V,
          getSnapshot: B
        }
      }), ce = Y[0].inst, ve = Y[1];
      return v(function() {
        ce.value = V, ce.getSnapshot = B, T(ce) && ve({
          inst: ce
        });
      }, [L, V, B]), m(function() {
        T(ce) && ve({
          inst: ce
        });
        var Se = function() {
          T(ce) && ve({
            inst: ce
          });
        };
        return L(Se);
      }, [L]), w(V), V;
    }
    function T(L) {
      var B = L.getSnapshot, H = L.value;
      try {
        var V = B();
        return !d(H, V);
      } catch {
        return !0;
      }
    }
    function O(L, B, H) {
      return B();
    }
    var R = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", j = !R, I = j ? O : k, N = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : I;
    cE.useSyncExternalStore = N, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), cE;
}
var qO;
function Wj() {
  return qO || (qO = 1, process.env.NODE_ENV === "production" ? d1.exports = FL() : d1.exports = zL()), d1.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var WO;
function BL() {
  if (WO)
    return uE;
  WO = 1;
  var e = $, t = Wj();
  function r(w, x) {
    return w === x && (w !== 0 || 1 / w === 1 / x) || w !== w && x !== x;
  }
  var o = typeof Object.is == "function" ? Object.is : r, l = t.useSyncExternalStore, d = e.useRef, f = e.useEffect, m = e.useMemo, v = e.useDebugValue;
  return uE.useSyncExternalStoreWithSelector = function(w, x, b, k, T) {
    var O = d(null);
    if (O.current === null) {
      var R = { hasValue: !1, value: null };
      O.current = R;
    } else
      R = O.current;
    O = m(function() {
      function I(V) {
        if (!N) {
          if (N = !0, L = V, V = k(V), T !== void 0 && R.hasValue) {
            var W = R.value;
            if (T(W, V))
              return B = W;
          }
          return B = V;
        }
        if (W = B, o(L, V))
          return W;
        var Y = k(V);
        return T !== void 0 && T(W, Y) ? W : (L = V, B = Y);
      }
      var N = !1, L, B, H = b === void 0 ? null : b;
      return [function() {
        return I(x());
      }, H === null ? void 0 : function() {
        return I(H());
      }];
    }, [x, b, k, T]);
    var j = l(w, O[0], O[1]);
    return f(function() {
      R.hasValue = !0, R.value = j;
    }, [j]), v(j), j;
  }, uE;
}
var dE = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YO;
function UL() {
  return YO || (YO = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = $, t = Wj();
    function r(x, b) {
      return x === b && (x !== 0 || 1 / x === 1 / b) || x !== x && b !== b;
    }
    var o = typeof Object.is == "function" ? Object.is : r, l = t.useSyncExternalStore, d = e.useRef, f = e.useEffect, m = e.useMemo, v = e.useDebugValue;
    function w(x, b, k, T, O) {
      var R = d(null), j;
      R.current === null ? (j = {
        hasValue: !1,
        value: null
      }, R.current = j) : j = R.current;
      var I = m(function() {
        var H = !1, V, W, Y = function(De) {
          if (!H) {
            H = !0, V = De;
            var Re = T(De);
            if (O !== void 0 && j.hasValue) {
              var Pe = j.value;
              if (O(Pe, Re))
                return W = Pe, Pe;
            }
            return W = Re, Re;
          }
          var se = V, ge = W;
          if (o(se, De))
            return ge;
          var de = T(De);
          return O !== void 0 && O(ge, de) ? ge : (V = De, W = de, de);
        }, ce = k === void 0 ? null : k, ve = function() {
          return Y(b());
        }, Se = ce === null ? void 0 : function() {
          return Y(ce());
        };
        return [ve, Se];
      }, [b, k, T, O]), N = I[0], L = I[1], B = l(x, N, L);
      return f(function() {
        j.hasValue = !0, j.value = B;
      }, [B]), v(B), B;
    }
    dE.useSyncExternalStoreWithSelector = w, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), dE;
}
process.env.NODE_ENV === "production" ? eC.exports = BL() : eC.exports = UL();
var MT = eC.exports;
const HL = /* @__PURE__ */ km(MT), { useDebugValue: VL } = jo, { useSyncExternalStoreWithSelector: GL } = HL;
const qL = (e) => e;
function J1(e, t = qL, r) {
  const o = GL(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    r
  );
  return VL(o), o;
}
const f1 = e0(() => ({ open: !1 }));
function Yj() {
  const e = J1(f1, (l) => l.open), t = $.useCallback(() => {
    f1.setState({ open: !0 });
  }, []), r = $.useCallback(() => {
    f1.setState({ open: !1 });
  }, []), o = $.useCallback((l) => {
    f1.setState({ open: l });
  }, []);
  return $.useMemo(
    () => ({
      accountModalOpen: e,
      openAccountModal: t,
      closeAccountModal: r,
      toggleAccountModal: o
    }),
    [e, t, r, o]
  );
}
const WL = "2.9.20", YL = (e) => e, $T = (e) => e, ZL = () => `viem@${WL}`;
let we = class tC extends Error {
  constructor(t, r = {}) {
    var d;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: ZL()
    });
    const o = r.cause instanceof tC ? r.cause.details : (d = r.cause) != null && d.message ? r.cause.message : r.details, l = r.cause instanceof tC && r.cause.docsPath || r.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...l ? [
        `Docs: https://viem.sh${l}${r.docsSlug ? `#${r.docsSlug}` : ""}`
      ] : [],
      ...o ? [`Details: ${o}`] : [],
      `Version: ${this.version}`
    ].join(`
`), r.cause && (this.cause = r.cause), this.details = o, this.docsPath = l, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return Zj(this, t);
  }
};
function Zj(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e ? Zj(e.cause, t) : t ? null : e;
}
class KL extends we {
  constructor({ max: t, min: r, signed: o, size: l, value: d }) {
    super(`Number "${d}" is not in safe ${l ? `${l * 8}-bit ${o ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${r} to ${t})` : `(above ${r})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class QL extends we {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesBooleanError"
    });
  }
}
class XL extends we {
  constructor(t) {
    super(`Hex value "${t}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidHexBooleanError"
    });
  }
}
class oX extends we {
  constructor(t) {
    super(`Hex value "${t}" is an odd length (${t.length}). It must be an even length.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidHexValueError"
    });
  }
}
class JL extends we {
  constructor({ givenSize: t, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${t} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
class Kj extends we {
  constructor({ offset: t, position: r, size: o }) {
    super(`Slice ${r === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${o}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class Qj extends we {
  constructor({ size: t, targetSize: r, type: o }) {
    super(`${o.charAt(0).toUpperCase()}${o.slice(1).toLowerCase()} size (${t}) exceeds padding size (${r}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
class ZO extends we {
  constructor({ size: t, targetSize: r, type: o }) {
    super(`${o.charAt(0).toUpperCase()}${o.slice(1).toLowerCase()} is expected to be ${r} ${o} long, but is ${t} ${o} long.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesLengthError"
    });
  }
}
function Io(e, { dir: t, size: r = 32 } = {}) {
  return typeof e == "string" ? dd(e, { dir: t, size: r }) : eN(e, { dir: t, size: r });
}
function dd(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  const o = e.replace("0x", "");
  if (o.length > r * 2)
    throw new Qj({
      size: Math.ceil(o.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${o[t === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function eN(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  if (e.length > r)
    throw new Qj({
      size: e.length,
      targetSize: r,
      type: "bytes"
    });
  const o = new Uint8Array(r);
  for (let l = 0; l < r; l++) {
    const d = t === "right";
    o[d ? l : r - l - 1] = e[d ? l : e.length - l - 1];
  }
  return o;
}
function Cs(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function Cr(e) {
  return Cs(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function ks(e, { dir: t = "left" } = {}) {
  let r = typeof e == "string" ? e.replace("0x", "") : e, o = 0;
  for (let l = 0; l < r.length - 1 && r[t === "left" ? l : r.length - l - 1].toString() === "0"; l++)
    o++;
  return r = t === "left" ? r.slice(o) : r.slice(0, r.length - o), typeof e == "string" ? (r.length === 1 && t === "right" && (r = `${r}0`), `0x${r.length % 2 === 1 ? `0${r}` : r}`) : r;
}
const tN = /* @__PURE__ */ new TextEncoder();
function Dl(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? rN(e, t) : typeof e == "boolean" ? nN(e, t) : Cs(e) ? Il(e, t) : Pl(e, t);
}
function nN(e, t = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(e), typeof t.size == "number" ? (zo(r, { size: t.size }), Io(r, { size: t.size })) : r;
}
const Cl = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function KO(e) {
  if (e >= Cl.zero && e <= Cl.nine)
    return e - Cl.zero;
  if (e >= Cl.A && e <= Cl.F)
    return e - (Cl.A - 10);
  if (e >= Cl.a && e <= Cl.f)
    return e - (Cl.a - 10);
}
function Il(e, t = {}) {
  let r = e;
  t.size && (zo(r, { size: t.size }), r = Io(r, { dir: "right", size: t.size }));
  let o = r.slice(2);
  o.length % 2 && (o = `0${o}`);
  const l = o.length / 2, d = new Uint8Array(l);
  for (let f = 0, m = 0; f < l; f++) {
    const v = KO(o.charCodeAt(m++)), w = KO(o.charCodeAt(m++));
    if (v === void 0 || w === void 0)
      throw new we(`Invalid byte sequence ("${o[m - 2]}${o[m - 1]}" in "${o}").`);
    d[f] = v * 16 + w;
  }
  return d;
}
function rN(e, t) {
  const r = Bt(e, t);
  return Il(r);
}
function Pl(e, t = {}) {
  const r = tN.encode(e);
  return typeof t.size == "number" ? (zo(r, { size: t.size }), Io(r, { dir: "right", size: t.size })) : r;
}
function zo(e, { size: t }) {
  if (Cr(e) > t)
    throw new JL({
      givenSize: Cr(e),
      maxSize: t
    });
}
function Ml(e, t = {}) {
  const { signed: r } = t;
  t.size && zo(e, { size: t.size });
  const o = BigInt(e);
  if (!r)
    return o;
  const l = (e.length - 2) / 2, d = (1n << BigInt(l) * 8n - 1n) - 1n;
  return o <= d ? o : o - BigInt(`0x${"f".padStart(l * 2, "f")}`) - 1n;
}
function aN(e, t = {}) {
  let r = e;
  if (t.size && (zo(r, { size: t.size }), r = ks(r)), ks(r) === "0x00")
    return !1;
  if (ks(r) === "0x01")
    return !0;
  throw new XL(r);
}
function $l(e, t = {}) {
  return Number(Ml(e, t));
}
function eg(e, t = {}) {
  let r = Il(e);
  return t.size && (zo(r, { size: t.size }), r = ks(r, { dir: "right" })), new TextDecoder().decode(r);
}
const iN = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function St(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Bt(e, t) : typeof e == "string" ? Zh(e, t) : typeof e == "boolean" ? Xj(e, t) : ua(e, t);
}
function Xj(e, t = {}) {
  const r = `0x${Number(e)}`;
  return typeof t.size == "number" ? (zo(r, { size: t.size }), Io(r, { size: t.size })) : r;
}
function ua(e, t = {}) {
  let r = "";
  for (let l = 0; l < e.length; l++)
    r += iN[e[l]];
  const o = `0x${r}`;
  return typeof t.size == "number" ? (zo(o, { size: t.size }), Io(o, { dir: "right", size: t.size })) : o;
}
function Bt(e, t = {}) {
  const { signed: r, size: o } = t, l = BigInt(e);
  let d;
  o ? r ? d = (1n << BigInt(o) * 8n - 1n) - 1n : d = 2n ** (BigInt(o) * 8n) - 1n : typeof e == "number" && (d = BigInt(Number.MAX_SAFE_INTEGER));
  const f = typeof d == "bigint" && r ? -d - 1n : 0;
  if (d && l > d || l < f) {
    const v = typeof e == "bigint" ? "n" : "";
    throw new KL({
      max: d ? `${d}${v}` : void 0,
      min: `${f}${v}`,
      signed: r,
      size: o,
      value: `${e}${v}`
    });
  }
  const m = `0x${(r && l < 0 ? (1n << BigInt(o * 8)) + BigInt(l) : l).toString(16)}`;
  return o ? Io(m, { size: o }) : m;
}
const oN = /* @__PURE__ */ new TextEncoder();
function Zh(e, t = {}) {
  const r = oN.encode(e);
  return ua(r, t);
}
async function sN(e, { chain: t }) {
  const { id: r, name: o, nativeCurrency: l, rpcUrls: d, blockExplorers: f } = t;
  await e.request({
    method: "wallet_addEthereumChain",
    params: [
      {
        chainId: Bt(r),
        chainName: o,
        nativeCurrency: l,
        rpcUrls: d.default.http,
        blockExplorerUrls: f ? Object.values(f).map(({ url: m }) => m) : void 0
      }
    ]
  }, { retryCount: 0 });
}
function Ll(e, { includeName: t = !1 } = {}) {
  if (e.type !== "function" && e.type !== "event" && e.type !== "error")
    throw new wN(e.type);
  return `${e.name}(${ex(e.inputs, { includeName: t })})`;
}
function ex(e, { includeName: t = !1 } = {}) {
  return e ? e.map((r) => uN(r, { includeName: t })).join(t ? ", " : ",") : "";
}
function uN(e, { includeName: t }) {
  return e.type.startsWith("tuple") ? `(${ex(e.components, { includeName: t })})${e.type.slice(5)}` : e.type + (t && e.name ? ` ${e.name}` : "");
}
class lN extends we {
  constructor({ docsPath: t }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorNotFoundError"
    });
  }
}
class QO extends we {
  constructor({ docsPath: t }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorParamsNotFoundError"
    });
  }
}
class Jj extends we {
  constructor({ data: t, params: r, size: o }) {
    super([`Data size of ${o} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${ex(r, { includeName: !0 })})`,
        `Data:   ${t} (${o} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t, this.params = r, this.size = o;
  }
}
class tx extends we {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.'), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingZeroDataError"
    });
  }
}
class cN extends we {
  constructor({ expectedLength: t, givenLength: r, type: o }) {
    super([
      `ABI encoding array length mismatch for type ${o}.`,
      `Expected length: ${t}`,
      `Given length: ${r}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingArrayLengthMismatchError"
    });
  }
}
class dN extends we {
  constructor({ expectedSize: t, value: r }) {
    super(`Size of bytes "${r}" (bytes${Cr(r)}) does not match expected size (bytes${t}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingBytesSizeMismatchError"
    });
  }
}
class fN extends we {
  constructor({ expectedLength: t, givenLength: r }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${t}`,
      `Given length (values): ${r}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingLengthMismatchError"
    });
  }
}
class eA extends we {
  constructor(t, { docsPath: r }) {
    super([
      `Encoded error signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: r
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = t;
  }
}
class pN extends we {
  constructor({ docsPath: t }) {
    super("Cannot extract event signature from empty topics.", {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureEmptyTopicsError"
    });
  }
}
class tA extends we {
  constructor(t, { docsPath: r }) {
    super([
      `Encoded event signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it.",
      `You can look up the signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: r
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureNotFoundError"
    });
  }
}
class XO extends we {
  constructor(t, { docsPath: r } = {}) {
    super([
      `Event ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it."
    ].join(`
`), {
      docsPath: r
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventNotFoundError"
    });
  }
}
class P1 extends we {
  constructor(t, { docsPath: r } = {}) {
    super([
      `Function ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: r
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionNotFoundError"
    });
  }
}
class hN extends we {
  constructor(t, { docsPath: r }) {
    super([
      `Function "${t}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: r
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class mN extends we {
  constructor(t, r) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${t.type}\` in \`${Ll(t.abiItem)}\`, and`,
        `\`${r.type}\` in \`${Ll(r.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiItemAmbiguityError"
    });
  }
}
class yN extends we {
  constructor({ expectedSize: t, givenSize: r }) {
    super(`Expected bytes${t}, got bytes${r}.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BytesSizeMismatchError"
    });
  }
}
class rg extends we {
  constructor({ abiItem: t, data: r, params: o, size: l }) {
    super([
      `Data size of ${l} bytes is too small for non-indexed event parameters.`
    ].join(`
`), {
      metaMessages: [
        `Params: (${ex(o, { includeName: !0 })})`,
        `Data:   ${r} (${l} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogDataMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = t, this.data = r, this.params = o, this.size = l;
  }
}
class nx extends we {
  constructor({ abiItem: t, param: r }) {
    super([
      `Expected a topic for indexed event parameter${r.name ? ` "${r.name}"` : ""} on event "${Ll(t, { includeName: !0 })}".`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogTopicsMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = t;
  }
}
class vN extends we {
  constructor(t, { docsPath: r }) {
    super([
      `Type "${t}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: r }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiEncodingType"
    });
  }
}
class gN extends we {
  constructor(t, { docsPath: r }) {
    super([
      `Type "${t}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: r }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiDecodingType"
    });
  }
}
class bN extends we {
  constructor(t) {
    super([`Value "${t}" is not a valid array.`].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidArrayError"
    });
  }
}
class wN extends we {
  constructor(t) {
    super([
      `"${t}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidDefinitionTypeError"
    });
  }
}
function ia(e) {
  return typeof e[0] == "string" ? Ps(e) : xN(e);
}
function xN(e) {
  let t = 0;
  for (const l of e)
    t += l.length;
  const r = new Uint8Array(t);
  let o = 0;
  for (const l of e)
    r.set(l, o), o += l.length;
  return r;
}
function Ps(e) {
  return `0x${e.reduce((t, r) => t + r.replace("0x", ""), "")}`;
}
class Lo extends we {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class SN extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  set(t, r) {
    return super.set(t, r), this.maxSize && this.size > this.maxSize && this.delete(this.keys().next().value), this;
  }
}
function j1(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function LT(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function kN(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  j1(e.outputLen), j1(e.blockLen);
}
function dm(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function nA(e, t) {
  LT(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const p1 = /* @__PURE__ */ BigInt(2 ** 32 - 1), JO = /* @__PURE__ */ BigInt(32);
function EN(e, t = !1) {
  return t ? { h: Number(e & p1), l: Number(e >> JO & p1) } : { h: Number(e >> JO & p1) | 0, l: Number(e & p1) | 0 };
}
function CN(e, t = !1) {
  let r = new Uint32Array(e.length), o = new Uint32Array(e.length);
  for (let l = 0; l < e.length; l++) {
    const { h: d, l: f } = EN(e[l], t);
    [r[l], o[l]] = [d, f];
  }
  return [r, o];
}
const TN = (e, t, r) => e << r | t >>> 32 - r, _N = (e, t, r) => t << r | e >>> 32 - r, RN = (e, t, r) => t << r - 32 | e >>> 64 - r, ON = (e, t, r) => e << r - 32 | t >>> 64 - r, fE = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const rA = (e) => e instanceof Uint8Array, PN = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), pE = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Su = (e, t) => e << 32 - t | e >>> t, jN = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!jN)
  throw new Error("Non little-endian hardware is not supported");
function AN(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function rx(e) {
  if (typeof e == "string" && (e = AN(e)), !rA(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
function DN(...e) {
  const t = new Uint8Array(e.reduce((o, l) => o + l.length, 0));
  let r = 0;
  return e.forEach((o) => {
    if (!rA(o))
      throw new Error("Uint8Array expected");
    t.set(o, r), r += o.length;
  }), t;
}
class NT {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function aA(e) {
  const t = (o) => e().update(rx(o)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function IN(e = 32) {
  if (fE && typeof fE.getRandomValues == "function")
    return fE.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
const [iA, oA, sA] = [[], [], []], MN = /* @__PURE__ */ BigInt(0), Hv = /* @__PURE__ */ BigInt(1), $N = /* @__PURE__ */ BigInt(2), LN = /* @__PURE__ */ BigInt(7), NN = /* @__PURE__ */ BigInt(256), FN = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = Hv, r = 1, o = 0; e < 24; e++) {
  [r, o] = [o, (2 * r + 3 * o) % 5], iA.push(2 * (5 * o + r)), oA.push((e + 1) * (e + 2) / 2 % 64);
  let l = MN;
  for (let d = 0; d < 7; d++)
    t = (t << Hv ^ (t >> LN) * FN) % NN, t & $N && (l ^= Hv << (Hv << /* @__PURE__ */ BigInt(d)) - Hv);
  sA.push(l);
}
const [zN, BN] = /* @__PURE__ */ CN(sA, !0), eP = (e, t, r) => r > 32 ? RN(e, t, r) : TN(e, t, r), tP = (e, t, r) => r > 32 ? ON(e, t, r) : _N(e, t, r);
function UN(e, t = 24) {
  const r = new Uint32Array(10);
  for (let o = 24 - t; o < 24; o++) {
    for (let f = 0; f < 10; f++)
      r[f] = e[f] ^ e[f + 10] ^ e[f + 20] ^ e[f + 30] ^ e[f + 40];
    for (let f = 0; f < 10; f += 2) {
      const m = (f + 8) % 10, v = (f + 2) % 10, w = r[v], x = r[v + 1], b = eP(w, x, 1) ^ r[m], k = tP(w, x, 1) ^ r[m + 1];
      for (let T = 0; T < 50; T += 10)
        e[f + T] ^= b, e[f + T + 1] ^= k;
    }
    let l = e[2], d = e[3];
    for (let f = 0; f < 24; f++) {
      const m = oA[f], v = eP(l, d, m), w = tP(l, d, m), x = iA[f];
      l = e[x], d = e[x + 1], e[x] = v, e[x + 1] = w;
    }
    for (let f = 0; f < 50; f += 10) {
      for (let m = 0; m < 10; m++)
        r[m] = e[f + m];
      for (let m = 0; m < 10; m++)
        e[f + m] ^= ~r[(m + 2) % 10] & r[(m + 4) % 10];
    }
    e[0] ^= zN[o], e[1] ^= BN[o];
  }
  r.fill(0);
}
class FT extends NT {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, r, o, l = !1, d = 24) {
    if (super(), this.blockLen = t, this.suffix = r, this.outputLen = o, this.enableXOF = l, this.rounds = d, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, j1(o), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = PN(this.state);
  }
  keccak() {
    UN(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    dm(this);
    const { blockLen: r, state: o } = this;
    t = rx(t);
    const l = t.length;
    for (let d = 0; d < l; ) {
      const f = Math.min(r - this.pos, l - d);
      for (let m = 0; m < f; m++)
        o[this.pos++] ^= t[d++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: r, pos: o, blockLen: l } = this;
    t[o] ^= r, r & 128 && o === l - 1 && this.keccak(), t[l - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    dm(this, !1), LT(t), this.finish();
    const r = this.state, { blockLen: o } = this;
    for (let l = 0, d = t.length; l < d; ) {
      this.posOut >= o && this.keccak();
      const f = Math.min(o - this.posOut, d - l);
      t.set(r.subarray(this.posOut, this.posOut + f), l), this.posOut += f, l += f;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return j1(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (nA(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: r, suffix: o, outputLen: l, rounds: d, enableXOF: f } = this;
    return t || (t = new FT(r, o, l, f, d)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = d, t.suffix = o, t.outputLen = l, t.enableXOF = f, t.destroyed = this.destroyed, t;
  }
}
const HN = (e, t, r) => aA(() => new FT(t, e, r)), VN = /* @__PURE__ */ HN(1, 136, 256 / 8);
function Nn(e, t) {
  const r = t || "hex", o = VN(Cs(e, { strict: !1 }) ? Dl(e) : e);
  return r === "bytes" ? o : St(o);
}
function t0(e, t) {
  const r = t ? `${t}${e.toLowerCase()}` : e.substring(2).toLowerCase(), o = Nn(Pl(r), "bytes"), l = (t ? r.substring(`${t}0x`.length) : r).split("");
  for (let d = 0; d < 40; d += 2)
    o[d >> 1] >> 4 >= 8 && l[d] && (l[d] = l[d].toUpperCase()), (o[d >> 1] & 15) >= 8 && l[d + 1] && (l[d + 1] = l[d + 1].toUpperCase());
  return `0x${l.join("")}`;
}
function ax(e, t) {
  if (!Va(e, { strict: !1 }))
    throw new Lo({ address: e });
  return t0(e, t);
}
const GN = /^0x[a-fA-F0-9]{40}$/, hE = /* @__PURE__ */ new SN(8192);
function Va(e, t) {
  const { strict: r = !0 } = t ?? {};
  if (hE.has(e))
    return hE.get(e);
  const o = (() => GN.test(e) ? e.toLowerCase() === e ? !0 : r ? t0(e) === e : !0 : !1)();
  return hE.set(e, o), o;
}
function fm(e, t, r, { strict: o } = {}) {
  return Cs(e, { strict: !1 }) ? tg(e, t, r, {
    strict: o
  }) : cA(e, t, r, {
    strict: o
  });
}
function uA(e, t) {
  if (typeof t == "number" && t > 0 && t > Cr(e) - 1)
    throw new Kj({
      offset: t,
      position: "start",
      size: Cr(e)
    });
}
function lA(e, t, r) {
  if (typeof t == "number" && typeof r == "number" && Cr(e) !== r - t)
    throw new Kj({
      offset: r,
      position: "end",
      size: Cr(e)
    });
}
function cA(e, t, r, { strict: o } = {}) {
  uA(e, t);
  const l = e.slice(t, r);
  return o && lA(l, t, r), l;
}
function tg(e, t, r, { strict: o } = {}) {
  uA(e, t);
  const l = `0x${e.replace("0x", "").slice((t ?? 0) * 2, (r ?? e.length) * 2)}`;
  return o && lA(l, t, r), l;
}
function ro(e, t) {
  if (e.length !== t.length)
    throw new fN({
      expectedLength: e.length,
      givenLength: t.length
    });
  const r = qN({
    params: e,
    values: t
  }), o = BT(r);
  return o.length === 0 ? "0x" : o;
}
function qN({ params: e, values: t }) {
  const r = [];
  for (let o = 0; o < e.length; o++)
    r.push(zT({ param: e[o], value: t[o] }));
  return r;
}
function zT({ param: e, value: t }) {
  const r = UT(e.type);
  if (r) {
    const [o, l] = r;
    return YN(t, { length: o, param: { ...e, type: l } });
  }
  if (e.type === "tuple")
    return JN(t, {
      param: e
    });
  if (e.type === "address")
    return WN(t);
  if (e.type === "bool")
    return KN(t);
  if (e.type.startsWith("uint") || e.type.startsWith("int")) {
    const o = e.type.startsWith("int");
    return QN(t, { signed: o });
  }
  if (e.type.startsWith("bytes"))
    return ZN(t, { param: e });
  if (e.type === "string")
    return XN(t);
  throw new vN(e.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function BT(e) {
  let t = 0;
  for (let d = 0; d < e.length; d++) {
    const { dynamic: f, encoded: m } = e[d];
    f ? t += 32 : t += Cr(m);
  }
  const r = [], o = [];
  let l = 0;
  for (let d = 0; d < e.length; d++) {
    const { dynamic: f, encoded: m } = e[d];
    f ? (r.push(Bt(t + l, { size: 32 })), o.push(m), l += Cr(m)) : r.push(m);
  }
  return ia([...r, ...o]);
}
function WN(e) {
  if (!Va(e))
    throw new Lo({ address: e });
  return { dynamic: !1, encoded: dd(e.toLowerCase()) };
}
function YN(e, { length: t, param: r }) {
  const o = t === null;
  if (!Array.isArray(e))
    throw new bN(e);
  if (!o && e.length !== t)
    throw new cN({
      expectedLength: t,
      givenLength: e.length,
      type: `${r.type}[${t}]`
    });
  let l = !1;
  const d = [];
  for (let f = 0; f < e.length; f++) {
    const m = zT({ param: r, value: e[f] });
    m.dynamic && (l = !0), d.push(m);
  }
  if (o || l) {
    const f = BT(d);
    if (o) {
      const m = Bt(d.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: d.length > 0 ? ia([m, f]) : m
      };
    }
    if (l)
      return { dynamic: !0, encoded: f };
  }
  return {
    dynamic: !1,
    encoded: ia(d.map(({ encoded: f }) => f))
  };
}
function ZN(e, { param: t }) {
  const [, r] = t.type.split("bytes"), o = Cr(e);
  if (!r) {
    let l = e;
    return o % 32 !== 0 && (l = dd(l, {
      dir: "right",
      size: Math.ceil((e.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: ia([dd(Bt(o, { size: 32 })), l])
    };
  }
  if (o !== parseInt(r))
    throw new dN({
      expectedSize: parseInt(r),
      value: e
    });
  return { dynamic: !1, encoded: dd(e, { dir: "right" }) };
}
function KN(e) {
  if (typeof e != "boolean")
    throw new we(`Invalid boolean value: "${e}" (type: ${typeof e}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: dd(Xj(e)) };
}
function QN(e, { signed: t }) {
  return {
    dynamic: !1,
    encoded: Bt(e, {
      size: 32,
      signed: t
    })
  };
}
function XN(e) {
  const t = Zh(e), r = Math.ceil(Cr(t) / 32), o = [];
  for (let l = 0; l < r; l++)
    o.push(dd(fm(t, l * 32, (l + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: ia([
      dd(Bt(Cr(t), { size: 32 })),
      ...o
    ])
  };
}
function JN(e, { param: t }) {
  let r = !1;
  const o = [];
  for (let l = 0; l < t.components.length; l++) {
    const d = t.components[l], f = Array.isArray(e) ? l : d.name, m = zT({
      param: d,
      value: e[f]
    });
    o.push(m), m.dynamic && (r = !0);
  }
  return {
    dynamic: r,
    encoded: r ? BT(o) : ia(o.map(({ encoded: l }) => l))
  };
}
function UT(e) {
  const t = e.match(/^(.*)\[(\d+)?\]$/);
  return t ? (
    // Return `null` if the array is dynamic.
    [t[2] ? Number(t[2]) : null, t[1]]
  ) : void 0;
}
const mE = "/docs/contract/encodeDeployData";
function dA(e) {
  const { abi: t, args: r, bytecode: o } = e;
  if (!r || r.length === 0)
    return o;
  const l = t.find((f) => "type" in f && f.type === "constructor");
  if (!l)
    throw new lN({ docsPath: mE });
  if (!("inputs" in l))
    throw new QO({ docsPath: mE });
  if (!l.inputs || l.inputs.length === 0)
    throw new QO({ docsPath: mE });
  const d = ro(l.inputs, r);
  return Ps([o, d]);
}
function fi(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class ix extends we {
  constructor({ docsPath: t } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
    ].join(`
`), {
      docsPath: t,
      docsSlug: "account"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountNotFoundError"
    });
  }
}
class nC extends we {
  constructor({ blockNumber: t, chain: r, contract: o }) {
    super(`Chain "${r.name}" does not support contract "${o.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...t && o.blockCreated && o.blockCreated > t ? [
          `- The contract "${o.name}" was not deployed until block ${o.blockCreated} (current block ${t}).`
        ] : [
          `- The chain does not have the contract "${o.name}" configured.`
        ]
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDoesNotSupportContract"
    });
  }
}
class eF extends we {
  constructor({ chain: t, currentChainId: r }) {
    super(`The current chain of the wallet (id: ${r}) does not match the target chain for the transaction (id: ${t.id} – ${t.name}).`, {
      metaMessages: [
        `Current Chain ID:  ${r}`,
        `Expected Chain ID: ${t.id} – ${t.name}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainMismatchError"
    });
  }
}
class tF extends we {
  constructor() {
    super([
      "No chain was provided to the request.",
      "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotFoundError"
    });
  }
}
class fA extends we {
  constructor() {
    super("No chain was provided to the Client."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ClientChainNotConfiguredError"
    });
  }
}
class HT extends we {
  constructor({ chainId: t }) {
    super(typeof t == "number" ? `Chain ID "${t}" is invalid.` : "Chain ID is invalid."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidChainIdError"
    });
  }
}
function pA({ chain: e, currentChainId: t }) {
  if (!e)
    throw new tF();
  if (t !== e.id)
    throw new eF({ chain: e, currentChainId: t });
}
const nF = {
  gwei: 9,
  wei: 18
}, rF = {
  ether: -9,
  wei: 9
}, aF = {
  ether: -18,
  gwei: -9
};
function ox(e, t) {
  let r = e.toString();
  const o = r.startsWith("-");
  o && (r = r.slice(1)), r = r.padStart(t, "0");
  let [l, d] = [
    r.slice(0, r.length - t),
    r.slice(r.length - t)
  ];
  return d = d.replace(/(0+)$/, ""), `${o ? "-" : ""}${l || "0"}${d ? `.${d}` : ""}`;
}
function Fi(e, t = "wei") {
  return ox(e, rF[t]);
}
class cd extends we {
  constructor({ cause: t, message: r } = {}) {
    var l;
    const o = (l = r == null ? void 0 : r.replace("execution reverted: ", "")) == null ? void 0 : l.replace("execution reverted", "");
    super(`Execution reverted ${o ? `with reason: ${o}` : "for an unknown reason"}.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(cd, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(cd, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class Wf extends we {
  constructor({ cause: t, maxFeePerGas: r } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${r ? ` = ${Fi(r)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(Wf, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class rC extends we {
  constructor({ cause: t, maxFeePerGas: r } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${r ? ` = ${Fi(r)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooLow"
    });
  }
}
Object.defineProperty(rC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class aC extends we {
  constructor({ cause: t, nonce: r } = {}) {
    super(`Nonce provided for the transaction ${r ? `(${r}) ` : ""}is higher than the next one expected.`, { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooHighError"
    });
  }
}
Object.defineProperty(aC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class iC extends we {
  constructor({ cause: t, nonce: r } = {}) {
    super([
      `Nonce provided for the transaction ${r ? `(${r}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooLowError"
    });
  }
}
Object.defineProperty(iC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class oC extends we {
  constructor({ cause: t, nonce: r } = {}) {
    super(`Nonce provided for the transaction ${r ? `(${r}) ` : ""}exceeds the maximum allowed nonce.`, { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceMaxValueError"
    });
  }
}
Object.defineProperty(oC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class sC extends we {
  constructor({ cause: t } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: t,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(sC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds/
});
class uC extends we {
  constructor({ cause: t, gas: r } = {}) {
    super(`The amount of gas ${r ? `(${r}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(uC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class lC extends we {
  constructor({ cause: t, gas: r } = {}) {
    super(`The amount of gas ${r ? `(${r}) ` : ""}provided for the transaction is too low.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(lC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class cC extends we {
  constructor({ cause: t }) {
    super("The transaction type is not supported for this chain.", {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(cC, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class ag extends we {
  constructor({ cause: t, maxPriorityFeePerGas: r, maxFeePerGas: o } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${r ? ` = ${Fi(r)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${o ? ` = ${Fi(o)} gwei` : ""}).`
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(ag, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class jl extends we {
  constructor({ cause: t }) {
    super(`An error occurred while executing: ${t == null ? void 0 : t.shortMessage}`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownNodeError"
    });
  }
}
function VT(e, t = "wei") {
  return ox(e, nF[t]);
}
function n0(e) {
  const t = Object.entries(e).map(([o, l]) => l === void 0 || l === !1 ? null : [o, l]).filter(Boolean), r = t.reduce((o, [l]) => Math.max(o, l.length), 0);
  return t.map(([o, l]) => `  ${`${o}:`.padEnd(r + 1)}  ${l}`).join(`
`);
}
class iF extends we {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeConflictError"
    });
  }
}
class oF extends we {
  constructor({ v: t }) {
    super(`Invalid \`v\` value "${t}". Expected 27 or 28.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidLegacyVError"
    });
  }
}
class sF extends we {
  constructor({ transaction: t }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        n0(t),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class uF extends we {
  constructor({ storageKey: t }) {
    super(`Size for storage key "${t}" is invalid. Expected 32 bytes. Got ${Math.floor((t.length - 2) / 2)} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStorageKeySizeError"
    });
  }
}
class lF extends we {
  constructor(t, { account: r, docsPath: o, chain: l, data: d, gas: f, gasPrice: m, maxFeePerGas: v, maxPriorityFeePerGas: w, nonce: x, to: b, value: k }) {
    var O;
    const T = n0({
      chain: l && `${l == null ? void 0 : l.name} (id: ${l == null ? void 0 : l.id})`,
      from: r == null ? void 0 : r.address,
      to: b,
      value: typeof k < "u" && `${VT(k)} ${((O = l == null ? void 0 : l.nativeCurrency) == null ? void 0 : O.symbol) || "ETH"}`,
      data: d,
      gas: f,
      gasPrice: typeof m < "u" && `${Fi(m)} gwei`,
      maxFeePerGas: typeof v < "u" && `${Fi(v)} gwei`,
      maxPriorityFeePerGas: typeof w < "u" && `${Fi(w)} gwei`,
      nonce: x
    });
    super(t.shortMessage, {
      cause: t,
      docsPath: o,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Request Arguments:",
        T
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionExecutionError"
    }), this.cause = t;
  }
}
class hA extends we {
  constructor({ blockHash: t, blockNumber: r, blockTag: o, hash: l, index: d }) {
    let f = "Transaction";
    o && d !== void 0 && (f = `Transaction at block time "${o}" at index "${d}"`), t && d !== void 0 && (f = `Transaction at block hash "${t}" at index "${d}"`), r && d !== void 0 && (f = `Transaction at block number "${r}" at index "${d}"`), l && (f = `Transaction with hash "${l}"`), super(`${f} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionNotFoundError"
    });
  }
}
class mA extends we {
  constructor({ hash: t }) {
    super(`Transaction receipt with hash "${t}" could not be found. The Transaction may not be processed on a block yet.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionReceiptNotFoundError"
    });
  }
}
class cF extends we {
  constructor({ hash: t }) {
    super(`Timed out while waiting for transaction with hash "${t}" to be confirmed.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WaitForTransactionReceiptTimeoutError"
    });
  }
}
const sa = (e, t, r) => JSON.stringify(e, (o, l) => {
  const d = typeof l == "bigint" ? l.toString() : l;
  return typeof t == "function" ? t(o, d) : d;
}, r);
class ng extends we {
  constructor({ body: t, details: r, headers: o, status: l, url: d }) {
    super("HTTP request failed.", {
      details: r,
      metaMessages: [
        l && `Status: ${l}`,
        `URL: ${$T(d)}`,
        t && `Request body: ${sa(t)}`
      ].filter(Boolean)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = o, this.status = l, this.url = d;
  }
}
class yA extends we {
  constructor({ body: t, error: r, url: o }) {
    super("RPC Request failed.", {
      cause: r,
      details: r.message,
      metaMessages: [`URL: ${$T(o)}`, `Request body: ${sa(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = r.code;
  }
}
class nP extends we {
  constructor({ body: t, url: r }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${$T(r)}`, `Request body: ${sa(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TimeoutError"
    });
  }
}
const dF = -1;
class zi extends we {
  constructor(t, { code: r, docsPath: o, metaMessages: l, shortMessage: d }) {
    super(d, {
      cause: t,
      docsPath: o,
      metaMessages: l || (t == null ? void 0 : t.metaMessages)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = t.name, this.code = t instanceof yA ? t.code : r ?? dF;
  }
}
class Em extends zi {
  constructor(t, r) {
    super(t, r), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderRpcError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = r.data;
  }
}
class ig extends zi {
  constructor(t) {
    super(t, {
      code: ig.code,
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ParseRpcError"
    });
  }
}
Object.defineProperty(ig, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class og extends zi {
  constructor(t) {
    super(t, {
      code: og.code,
      shortMessage: "JSON is not a valid request object."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidRequestRpcError"
    });
  }
}
Object.defineProperty(og, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class sg extends zi {
  constructor(t) {
    super(t, {
      code: sg.code,
      shortMessage: "The method does not exist / is not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotFoundRpcError"
    });
  }
}
Object.defineProperty(sg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class ug extends zi {
  constructor(t) {
    super(t, {
      code: ug.code,
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParamsRpcError"
    });
  }
}
Object.defineProperty(ug, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class Yf extends zi {
  constructor(t) {
    super(t, {
      code: Yf.code,
      shortMessage: "An internal error was received."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InternalRpcError"
    });
  }
}
Object.defineProperty(Yf, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class Zf extends zi {
  constructor(t) {
    super(t, {
      code: Zf.code,
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidInputRpcError"
    });
  }
}
Object.defineProperty(Zf, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class lg extends zi {
  constructor(t) {
    super(t, {
      code: lg.code,
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(lg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class cg extends zi {
  constructor(t) {
    super(t, {
      code: cg.code,
      shortMessage: "Requested resource not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceUnavailableRpcError"
    });
  }
}
Object.defineProperty(cg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class dg extends zi {
  constructor(t) {
    super(t, {
      code: dg.code,
      shortMessage: "Transaction creation failed."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionRejectedRpcError"
    });
  }
}
Object.defineProperty(dg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class fg extends zi {
  constructor(t) {
    super(t, {
      code: fg.code,
      shortMessage: "Method is not implemented."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotSupportedRpcError"
    });
  }
}
Object.defineProperty(fg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class pm extends zi {
  constructor(t) {
    super(t, {
      code: pm.code,
      shortMessage: "Request exceeds defined limit."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "LimitExceededRpcError"
    });
  }
}
Object.defineProperty(pm, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class pg extends zi {
  constructor(t) {
    super(t, {
      code: pg.code,
      shortMessage: "Version of JSON-RPC protocol is not supported."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "JsonRpcVersionUnsupportedError"
    });
  }
}
Object.defineProperty(pg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Kh extends Em {
  constructor(t) {
    super(t, {
      code: Kh.code,
      shortMessage: "User rejected the request."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UserRejectedRequestError"
    });
  }
}
Object.defineProperty(Kh, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class hg extends Em {
  constructor(t) {
    super(t, {
      code: hg.code,
      shortMessage: "The requested method and/or account has not been authorized by the user."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnauthorizedProviderError"
    });
  }
}
Object.defineProperty(hg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class mg extends Em {
  constructor(t) {
    super(t, {
      code: mg.code,
      shortMessage: "The Provider does not support the requested method."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnsupportedProviderMethodError"
    });
  }
}
Object.defineProperty(mg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class yg extends Em {
  constructor(t) {
    super(t, {
      code: yg.code,
      shortMessage: "The Provider is disconnected from all chains."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderDisconnectedError"
    });
  }
}
Object.defineProperty(yg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class vg extends Em {
  constructor(t) {
    super(t, {
      code: vg.code,
      shortMessage: "The Provider is not connected to the requested chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDisconnectedError"
    });
  }
}
Object.defineProperty(vg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class gg extends Em {
  constructor(t) {
    super(t, {
      code: gg.code,
      shortMessage: "An error occurred when attempting to switch chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainError"
    });
  }
}
Object.defineProperty(gg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class fF extends zi {
  constructor(t) {
    super(t, {
      shortMessage: "An unknown RPC error occurred."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownRpcError"
    });
  }
}
function GT(e, t) {
  const r = (e.details || "").toLowerCase(), o = e instanceof we ? e.walk((l) => l.code === cd.code) : e;
  return o instanceof we ? new cd({
    cause: e,
    message: o.details
  }) : cd.nodeMessage.test(r) ? new cd({
    cause: e,
    message: e.details
  }) : Wf.nodeMessage.test(r) ? new Wf({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : rC.nodeMessage.test(r) ? new rC({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : aC.nodeMessage.test(r) ? new aC({ cause: e, nonce: t == null ? void 0 : t.nonce }) : iC.nodeMessage.test(r) ? new iC({ cause: e, nonce: t == null ? void 0 : t.nonce }) : oC.nodeMessage.test(r) ? new oC({ cause: e, nonce: t == null ? void 0 : t.nonce }) : sC.nodeMessage.test(r) ? new sC({ cause: e }) : uC.nodeMessage.test(r) ? new uC({ cause: e, gas: t == null ? void 0 : t.gas }) : lC.nodeMessage.test(r) ? new lC({ cause: e, gas: t == null ? void 0 : t.gas }) : cC.nodeMessage.test(r) ? new cC({ cause: e }) : ag.nodeMessage.test(r) ? new ag({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas,
    maxPriorityFeePerGas: t == null ? void 0 : t.maxPriorityFeePerGas
  }) : new jl({
    cause: e
  });
}
function pF(e, { docsPath: t, ...r }) {
  const o = (() => {
    const l = GT(e, r);
    return l instanceof jl ? e : l;
  })();
  return new lF(o, {
    docsPath: t,
    ...r
  });
}
function qT(e, { format: t }) {
  if (!t)
    return {};
  const r = {};
  function o(d) {
    const f = Object.keys(d);
    for (const m of f)
      m in e && (r[m] = e[m]), d[m] && typeof d[m] == "object" && !Array.isArray(d[m]) && o(d[m]);
  }
  const l = t(e || {});
  return o(l), r;
}
function sx(e, t) {
  return ({ exclude: r, format: o }) => ({
    exclude: r,
    format: (l) => {
      const d = t(l);
      if (r)
        for (const f of r)
          delete d[f];
      return {
        ...d,
        ...o(l)
      };
    },
    type: e
  });
}
const hF = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3"
};
function r0(e) {
  const t = {};
  return typeof e.accessList < "u" && (t.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (t.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? t.blobs = e.blobs.map((r) => ua(r)) : t.blobs = e.blobs), typeof e.data < "u" && (t.data = e.data), typeof e.from < "u" && (t.from = e.from), typeof e.gas < "u" && (t.gas = Bt(e.gas)), typeof e.gasPrice < "u" && (t.gasPrice = Bt(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (t.maxFeePerBlobGas = Bt(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (t.maxFeePerGas = Bt(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (t.maxPriorityFeePerGas = Bt(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (t.nonce = Bt(e.nonce)), typeof e.to < "u" && (t.to = e.to), typeof e.type < "u" && (t.type = hF[e.type]), typeof e.value < "u" && (t.value = Bt(e.value)), t;
}
const sX = /* @__PURE__ */ sx("transactionRequest", r0);
function Ke(e, t, r) {
  return (o) => {
    var l, d;
    return ((l = e[t.name]) == null ? void 0 : l.call(e, o)) ?? ((d = e[r]) == null ? void 0 : d.call(e, o)) ?? t(e, o);
  };
}
function a0(e) {
  const { account: t, gasPrice: r, maxFeePerGas: o, maxPriorityFeePerGas: l, to: d } = e, f = t ? fi(t) : void 0;
  if (f && !Va(f.address))
    throw new Lo({ address: f.address });
  if (d && !Va(d))
    throw new Lo({ address: d });
  if (typeof r < "u" && (typeof o < "u" || typeof l < "u"))
    throw new iF();
  if (o && o > 2n ** 256n - 1n)
    throw new Wf({ maxFeePerGas: o });
  if (l && o && l > o)
    throw new ag({ maxFeePerGas: o, maxPriorityFeePerGas: l });
}
async function Jf(e) {
  const t = await e.request({
    method: "eth_chainId"
  });
  return $l(t);
}
class mF extends we {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseFeeScalarError"
    });
  }
}
class WT extends we {
  constructor() {
    super("Chain does not support EIP-1559 fees."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Eip1559FeesNotSupportedError"
    });
  }
}
class yF extends we {
  constructor({ maxPriorityFeePerGas: t }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${Fi(t)} gwei).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MaxFeePerGasTooLowError"
    });
  }
}
class vA extends we {
  constructor({ blockHash: t, blockNumber: r }) {
    let o = "Block";
    t && (o = `Block at hash "${t}"`), r && (o = `Block at number "${r}"`), super(`${o} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlockNotFoundError"
    });
  }
}
const gA = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844"
};
function YT(e) {
  const t = {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    chainId: e.chainId ? $l(e.chainId) : void 0,
    gas: e.gas ? BigInt(e.gas) : void 0,
    gasPrice: e.gasPrice ? BigInt(e.gasPrice) : void 0,
    maxFeePerBlobGas: e.maxFeePerBlobGas ? BigInt(e.maxFeePerBlobGas) : void 0,
    maxFeePerGas: e.maxFeePerGas ? BigInt(e.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: e.maxPriorityFeePerGas ? BigInt(e.maxPriorityFeePerGas) : void 0,
    nonce: e.nonce ? $l(e.nonce) : void 0,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    type: e.type ? gA[e.type] : void 0,
    typeHex: e.type ? e.type : void 0,
    value: e.value ? BigInt(e.value) : void 0,
    v: e.v ? BigInt(e.v) : void 0
  };
  return t.yParity = (() => {
    if (e.yParity)
      return Number(e.yParity);
    if (typeof t.v == "bigint") {
      if (t.v === 0n || t.v === 27n)
        return 0;
      if (t.v === 1n || t.v === 28n)
        return 1;
      if (t.v >= 35n)
        return t.v % 2n === 0n ? 1 : 0;
    }
  })(), t.type === "legacy" && (delete t.accessList, delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas, delete t.yParity), t.type === "eip2930" && (delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas), t.type === "eip1559" && delete t.maxFeePerBlobGas, t;
}
const uX = /* @__PURE__ */ sx("transaction", YT);
function ZT(e) {
  var r;
  const t = (r = e.transactions) == null ? void 0 : r.map((o) => typeof o == "string" ? o : YT(o));
  return {
    ...e,
    baseFeePerGas: e.baseFeePerGas ? BigInt(e.baseFeePerGas) : null,
    blobGasUsed: e.blobGasUsed ? BigInt(e.blobGasUsed) : void 0,
    difficulty: e.difficulty ? BigInt(e.difficulty) : void 0,
    excessBlobGas: e.excessBlobGas ? BigInt(e.excessBlobGas) : void 0,
    gasLimit: e.gasLimit ? BigInt(e.gasLimit) : void 0,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : void 0,
    hash: e.hash ? e.hash : null,
    logsBloom: e.logsBloom ? e.logsBloom : null,
    nonce: e.nonce ? e.nonce : null,
    number: e.number ? BigInt(e.number) : null,
    size: e.size ? BigInt(e.size) : void 0,
    timestamp: e.timestamp ? BigInt(e.timestamp) : void 0,
    transactions: t,
    totalDifficulty: e.totalDifficulty ? BigInt(e.totalDifficulty) : null
  };
}
const lX = /* @__PURE__ */ sx("block", ZT);
async function Nl(e, { blockHash: t, blockNumber: r, blockTag: o, includeTransactions: l } = {}) {
  var x, b, k;
  const d = o ?? "latest", f = l ?? !1, m = r !== void 0 ? Bt(r) : void 0;
  let v = null;
  if (t ? v = await e.request({
    method: "eth_getBlockByHash",
    params: [t, f]
  }) : v = await e.request({
    method: "eth_getBlockByNumber",
    params: [m || d, f]
  }), !v)
    throw new vA({ blockHash: t, blockNumber: r });
  return (((k = (b = (x = e.chain) == null ? void 0 : x.formatters) == null ? void 0 : b.block) == null ? void 0 : k.format) || ZT)(v);
}
async function KT(e) {
  const t = await e.request({
    method: "eth_gasPrice"
  });
  return BigInt(t);
}
async function vF(e, t) {
  return bA(e, t);
}
async function bA(e, t) {
  var d, f, m;
  const { block: r, chain: o = e.chain, request: l } = t || {};
  if (typeof ((d = o == null ? void 0 : o.fees) == null ? void 0 : d.defaultPriorityFee) == "function") {
    const v = r || await Ke(e, Nl, "getBlock")({});
    return o.fees.defaultPriorityFee({
      block: v,
      client: e,
      request: l
    });
  }
  if (typeof ((f = o == null ? void 0 : o.fees) == null ? void 0 : f.defaultPriorityFee) < "u")
    return (m = o == null ? void 0 : o.fees) == null ? void 0 : m.defaultPriorityFee;
  try {
    const v = await e.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return Ml(v);
  } catch {
    const [v, w] = await Promise.all([
      r ? Promise.resolve(r) : Ke(e, Nl, "getBlock")({}),
      Ke(e, KT, "getGasPrice")({})
    ]);
    if (typeof v.baseFeePerGas != "bigint")
      throw new WT();
    const x = w - v.baseFeePerGas;
    return x < 0n ? 0n : x;
  }
}
async function bg(e, t) {
  return dC(e, t);
}
async function dC(e, t) {
  var k, T;
  const { block: r, chain: o = e.chain, request: l, type: d = "eip1559" } = t || {}, f = await (async () => {
    var O, R;
    return typeof ((O = o == null ? void 0 : o.fees) == null ? void 0 : O.baseFeeMultiplier) == "function" ? o.fees.baseFeeMultiplier({
      block: r,
      client: e,
      request: l
    }) : ((R = o == null ? void 0 : o.fees) == null ? void 0 : R.baseFeeMultiplier) ?? 1.2;
  })();
  if (f < 1)
    throw new mF();
  const v = 10 ** (((k = f.toString().split(".")[1]) == null ? void 0 : k.length) ?? 0), w = (O) => O * BigInt(Math.ceil(f * v)) / BigInt(v), x = r || await Ke(e, Nl, "getBlock")({});
  if (typeof ((T = o == null ? void 0 : o.fees) == null ? void 0 : T.estimateFeesPerGas) == "function") {
    const O = await o.fees.estimateFeesPerGas({
      block: r,
      client: e,
      multiply: w,
      request: l,
      type: d
    });
    if (O !== null)
      return O;
  }
  if (d === "eip1559") {
    if (typeof x.baseFeePerGas != "bigint")
      throw new WT();
    const O = typeof (l == null ? void 0 : l.maxPriorityFeePerGas) == "bigint" ? l.maxPriorityFeePerGas : await bA(e, {
      block: x,
      chain: o,
      request: l
    }), R = w(x.baseFeePerGas);
    return {
      maxFeePerGas: (l == null ? void 0 : l.maxFeePerGas) ?? R + O,
      maxPriorityFeePerGas: O
    };
  }
  return {
    gasPrice: (l == null ? void 0 : l.gasPrice) ?? w(await Ke(e, KT, "getGasPrice")({}))
  };
}
class gF extends we {
  constructor(t, { account: r, docsPath: o, chain: l, data: d, gas: f, gasPrice: m, maxFeePerGas: v, maxPriorityFeePerGas: w, nonce: x, to: b, value: k }) {
    var O;
    const T = n0({
      from: r == null ? void 0 : r.address,
      to: b,
      value: typeof k < "u" && `${VT(k)} ${((O = l == null ? void 0 : l.nativeCurrency) == null ? void 0 : O.symbol) || "ETH"}`,
      data: d,
      gas: f,
      gasPrice: typeof m < "u" && `${Fi(m)} gwei`,
      maxFeePerGas: typeof v < "u" && `${Fi(v)} gwei`,
      maxPriorityFeePerGas: typeof w < "u" && `${Fi(w)} gwei`,
      nonce: x
    });
    super(t.shortMessage, {
      cause: t,
      docsPath: o,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        T
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EstimateGasExecutionError"
    }), this.cause = t;
  }
}
function bF(e, { docsPath: t, ...r }) {
  const o = (() => {
    const l = GT(e, r);
    return l instanceof jl ? e : l;
  })();
  return new gF(o, {
    docsPath: t,
    ...r
  });
}
async function QT(e, t) {
  var l, d, f;
  const r = t.account ?? e.account, o = r ? fi(r) : void 0;
  try {
    const { accessList: m, blobs: v, blobVersionedHashes: w, blockNumber: x, blockTag: b, data: k, gas: T, gasPrice: O, maxFeePerBlobGas: R, maxFeePerGas: j, maxPriorityFeePerGas: I, nonce: N, to: L, value: B, ...H } = await ux(e, {
      ...t,
      parameters: (
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        (o == null ? void 0 : o.type) === "local" ? void 0 : ["blobVersionedHashes"]
      )
    }), W = (x ? Bt(x) : void 0) || b;
    a0(t);
    const Y = (f = (d = (l = e.chain) == null ? void 0 : l.formatters) == null ? void 0 : d.transactionRequest) == null ? void 0 : f.format, ve = (Y || r0)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...qT(H, { format: Y }),
      from: o == null ? void 0 : o.address,
      accessList: m,
      blobs: v,
      blobVersionedHashes: w,
      data: k,
      gas: T,
      gasPrice: O,
      maxFeePerBlobGas: R,
      maxFeePerGas: j,
      maxPriorityFeePerGas: I,
      nonce: N,
      to: L,
      value: B
    }), Se = await e.request({
      method: "eth_estimateGas",
      params: W ? [ve, W] : [ve]
    });
    return BigInt(Se);
  } catch (m) {
    throw bF(m, {
      ...t,
      account: o,
      chain: e.chain
    });
  }
}
async function wA(e, { address: t, blockTag: r = "latest", blockNumber: o }) {
  const l = await e.request({
    method: "eth_getTransactionCount",
    params: [t, o ? Bt(o) : r]
  });
  return $l(l);
}
function XT(e) {
  const { kzg: t } = e, r = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), o = typeof e.blobs[0] == "string" ? e.blobs.map((d) => Il(d)) : e.blobs, l = [];
  for (const d of o)
    l.push(Uint8Array.from(t.blobToKzgCommitment(d)));
  return r === "bytes" ? l : l.map((d) => ua(d));
}
function JT(e) {
  const { kzg: t } = e, r = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), o = typeof e.blobs[0] == "string" ? e.blobs.map((f) => Il(f)) : e.blobs, l = typeof e.commitments[0] == "string" ? e.commitments.map((f) => Il(f)) : e.commitments, d = [];
  for (let f = 0; f < o.length; f++) {
    const m = o[f], v = l[f];
    d.push(Uint8Array.from(t.computeBlobKzgProof(m, v)));
  }
  return r === "bytes" ? d : d.map((f) => ua(f));
}
function wF(e, t, r, o) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, o);
  const l = BigInt(32), d = BigInt(4294967295), f = Number(r >> l & d), m = Number(r & d), v = o ? 4 : 0, w = o ? 0 : 4;
  e.setUint32(t + v, f, o), e.setUint32(t + w, m, o);
}
class xF extends NT {
  constructor(t, r, o, l) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = o, this.isLE = l, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = pE(this.buffer);
  }
  update(t) {
    dm(this);
    const { view: r, buffer: o, blockLen: l } = this;
    t = rx(t);
    const d = t.length;
    for (let f = 0; f < d; ) {
      const m = Math.min(l - this.pos, d - f);
      if (m === l) {
        const v = pE(t);
        for (; l <= d - f; f += l)
          this.process(v, f);
        continue;
      }
      o.set(t.subarray(f, f + m), this.pos), this.pos += m, f += m, this.pos === l && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    dm(this), nA(t, this), this.finished = !0;
    const { buffer: r, view: o, blockLen: l, isLE: d } = this;
    let { pos: f } = this;
    r[f++] = 128, this.buffer.subarray(f).fill(0), this.padOffset > l - f && (this.process(o, 0), f = 0);
    for (let b = f; b < l; b++)
      r[b] = 0;
    wF(o, l - 8, BigInt(this.length * 8), d), this.process(o, 0);
    const m = pE(t), v = this.outputLen;
    if (v % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const w = v / 4, x = this.get();
    if (w > x.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let b = 0; b < w; b++)
      m.setUint32(4 * b, x[b], d);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const o = t.slice(0, r);
    return this.destroy(), o;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: o, length: l, finished: d, destroyed: f, pos: m } = this;
    return t.length = l, t.pos = m, t.finished = d, t.destroyed = f, l % r && t.buffer.set(o), t;
  }
}
const SF = (e, t, r) => e & t ^ ~e & r, kF = (e, t, r) => e & t ^ e & r ^ t & r, EF = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Qc = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Xc = /* @__PURE__ */ new Uint32Array(64);
class CF extends xF {
  constructor() {
    super(64, 32, 8, !1), this.A = Qc[0] | 0, this.B = Qc[1] | 0, this.C = Qc[2] | 0, this.D = Qc[3] | 0, this.E = Qc[4] | 0, this.F = Qc[5] | 0, this.G = Qc[6] | 0, this.H = Qc[7] | 0;
  }
  get() {
    const { A: t, B: r, C: o, D: l, E: d, F: f, G: m, H: v } = this;
    return [t, r, o, l, d, f, m, v];
  }
  // prettier-ignore
  set(t, r, o, l, d, f, m, v) {
    this.A = t | 0, this.B = r | 0, this.C = o | 0, this.D = l | 0, this.E = d | 0, this.F = f | 0, this.G = m | 0, this.H = v | 0;
  }
  process(t, r) {
    for (let b = 0; b < 16; b++, r += 4)
      Xc[b] = t.getUint32(r, !1);
    for (let b = 16; b < 64; b++) {
      const k = Xc[b - 15], T = Xc[b - 2], O = Su(k, 7) ^ Su(k, 18) ^ k >>> 3, R = Su(T, 17) ^ Su(T, 19) ^ T >>> 10;
      Xc[b] = R + Xc[b - 7] + O + Xc[b - 16] | 0;
    }
    let { A: o, B: l, C: d, D: f, E: m, F: v, G: w, H: x } = this;
    for (let b = 0; b < 64; b++) {
      const k = Su(m, 6) ^ Su(m, 11) ^ Su(m, 25), T = x + k + SF(m, v, w) + EF[b] + Xc[b] | 0, R = (Su(o, 2) ^ Su(o, 13) ^ Su(o, 22)) + kF(o, l, d) | 0;
      x = w, w = v, v = m, m = f + T | 0, f = d, d = l, l = o, o = T + R | 0;
    }
    o = o + this.A | 0, l = l + this.B | 0, d = d + this.C | 0, f = f + this.D | 0, m = m + this.E | 0, v = v + this.F | 0, w = w + this.G | 0, x = x + this.H | 0, this.set(o, l, d, f, m, v, w, x);
  }
  roundClean() {
    Xc.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const xA = /* @__PURE__ */ aA(() => new CF());
function TF(e, t) {
  const r = t || "hex", o = xA(Cs(e, { strict: !1 }) ? Dl(e) : e);
  return r === "bytes" ? o : St(o);
}
function _F(e) {
  const { commitment: t, version: r = 1 } = e, o = e.to ?? (typeof t == "string" ? "hex" : "bytes"), l = TF(t, "bytes");
  return l.set([r], 0), o === "bytes" ? l : ua(l);
}
function SA(e) {
  const { commitments: t, version: r } = e, o = e.to ?? (typeof t[0] == "string" ? "hex" : "bytes"), l = [];
  for (const d of t)
    l.push(_F({
      commitment: d,
      to: o,
      version: r
    }));
  return l;
}
const rP = 6, kA = 32, e3 = 4096, EA = kA * e3, aP = EA * rP - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * e3 * rP, CA = 1;
class RF extends we {
  constructor({ maxSize: t, size: r }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${t} bytes`, `Given: ${r} bytes`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlobSizeTooLargeError"
    });
  }
}
class TA extends we {
  constructor() {
    super("Blob data must not be empty."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EmptyBlobError"
    });
  }
}
class OF extends we {
  constructor({ hash: t, size: r }) {
    super(`Versioned hash "${t}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${r}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashSizeError"
    });
  }
}
class PF extends we {
  constructor({ hash: t, version: r }) {
    super(`Versioned hash "${t}" version is invalid.`, {
      metaMessages: [
        `Expected: ${CA}`,
        `Received: ${r}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashVersionError"
    });
  }
}
class iP extends we {
  constructor({ offset: t }) {
    super(`Offset \`${t}\` cannot be negative.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NegativeOffsetError"
    });
  }
}
class _A extends we {
  constructor({ length: t, position: r }) {
    super(`Position \`${r}\` is out of bounds (\`0 < position < ${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PositionOutOfBoundsError"
    });
  }
}
class jF extends we {
  constructor({ count: t, limit: r }) {
    super(`Recursive read limit of \`${r}\` exceeded (recursive read count: \`${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RecursiveReadLimitExceededError"
    });
  }
}
const AF = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: 1 / 0,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new jF({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new _A({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new iP({ offset: e });
    const t = this.position - e;
    this.assertPosition(t), this.position = t;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new iP({ offset: e });
    const t = this.position + e;
    this.assertPosition(t), this.position = t;
  },
  inspectByte(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectBytes(e, t) {
    const r = t ?? this.position;
    return this.assertPosition(r + e - 1), this.bytes.subarray(r, r + e);
  },
  inspectUint8(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectUint16(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 1), this.dataView.getUint16(t);
  },
  inspectUint24(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 2), (this.dataView.getUint16(t) << 8) + this.dataView.getUint8(t + 2);
  },
  inspectUint32(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 3), this.dataView.getUint32(t);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, t) {
    this.assertReadLimit(), this._touch();
    const r = this.inspectBytes(e);
    return this.position += t ?? e, r;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const t = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = t;
  },
  _touch() {
    if (this.recursiveReadLimit === 1 / 0)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function t3(e, { recursiveReadLimit: t = 8192 } = {}) {
  const r = Object.create(AF);
  return r.bytes = e, r.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), r.positionReadCount = /* @__PURE__ */ new Map(), r.recursiveReadLimit = t, r;
}
function DF(e) {
  const t = e.to ?? (typeof e.data == "string" ? "hex" : "bytes"), r = typeof e.data == "string" ? Il(e.data) : e.data, o = Cr(r);
  if (!o)
    throw new TA();
  if (o > aP)
    throw new RF({
      maxSize: aP,
      size: o
    });
  const l = [];
  let d = !0, f = 0;
  for (; d; ) {
    const m = t3(new Uint8Array(EA));
    let v = 0;
    for (; v < e3; ) {
      const w = r.slice(f, f + (kA - 1));
      if (m.pushByte(0), m.pushBytes(w), w.length < 31) {
        m.pushByte(128), d = !1;
        break;
      }
      v++, f += 31;
    }
    l.push(m);
  }
  return t === "bytes" ? l.map((m) => m.bytes) : l.map((m) => ua(m.bytes));
}
function RA(e) {
  const { data: t, kzg: r, to: o } = e, l = e.blobs ?? DF({ data: t, to: o }), d = e.commitments ?? XT({ blobs: l, kzg: r, to: o }), f = e.proofs ?? JT({ blobs: l, commitments: d, kzg: r, to: o }), m = [];
  for (let v = 0; v < l.length; v++)
    m.push({
      blob: l[v],
      commitment: d[v],
      proof: f[v]
    });
  return m;
}
function OA(e) {
  if (e.type)
    return e.type;
  if (typeof e.blobs < "u" || typeof e.blobVersionedHashes < "u" || typeof e.maxFeePerBlobGas < "u" || typeof e.sidecars < "u")
    return "eip4844";
  if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof e.gasPrice < "u")
    return typeof e.accessList < "u" ? "eip2930" : "legacy";
  throw new sF({ transaction: e });
}
const PA = [
  "blobVersionedHashes",
  "chainId",
  "fees",
  "gas",
  "nonce",
  "type"
];
async function ux(e, t) {
  const { account: r = e.account, blobs: o, chain: l, chainId: d, gas: f, kzg: m, nonce: v, parameters: w = PA, type: x } = t, b = r ? fi(r) : void 0, k = { ...t, ...b ? { from: b == null ? void 0 : b.address } : {} };
  let T;
  async function O() {
    return T || (T = await Ke(e, Nl, "getBlock")({ blockTag: "latest" }), T);
  }
  if ((w.includes("blobVersionedHashes") || w.includes("sidecars")) && o && m) {
    const R = XT({ blobs: o, kzg: m });
    if (w.includes("blobVersionedHashes")) {
      const j = SA({
        commitments: R,
        to: "hex"
      });
      k.blobVersionedHashes = j;
    }
    if (w.includes("sidecars")) {
      const j = JT({ blobs: o, commitments: R, kzg: m }), I = RA({
        blobs: o,
        commitments: R,
        proofs: j,
        to: "hex"
      });
      k.sidecars = I;
    }
  }
  if (w.includes("chainId") && (l ? k.chainId = l.id : typeof d < "u" ? k.chainId = d : k.chainId = await Ke(e, Jf, "getChainId")({})), w.includes("nonce") && typeof v > "u" && b && (k.nonce = await Ke(e, wA, "getTransactionCount")({
    address: b.address,
    blockTag: "pending"
  })), (w.includes("fees") || w.includes("type")) && typeof x > "u")
    try {
      k.type = OA(k);
    } catch {
      const R = await O();
      k.type = typeof (R == null ? void 0 : R.baseFeePerGas) == "bigint" ? "eip1559" : "legacy";
    }
  if (w.includes("fees"))
    if (k.type === "eip1559" || k.type === "eip4844") {
      if (typeof k.maxFeePerGas > "u" || typeof k.maxPriorityFeePerGas > "u") {
        const R = await O(), { maxFeePerGas: j, maxPriorityFeePerGas: I } = await dC(e, {
          block: R,
          chain: l,
          request: k
        });
        if (typeof t.maxPriorityFeePerGas > "u" && t.maxFeePerGas && t.maxFeePerGas < I)
          throw new yF({
            maxPriorityFeePerGas: I
          });
        k.maxPriorityFeePerGas = I, k.maxFeePerGas = j;
      }
    } else {
      if (typeof t.maxFeePerGas < "u" || typeof t.maxPriorityFeePerGas < "u")
        throw new WT();
      const R = await O(), { gasPrice: j } = await dC(e, {
        block: R,
        chain: l,
        request: k,
        type: "legacy"
      });
      k.gasPrice = j;
    }
  return w.includes("gas") && typeof f > "u" && (k.gas = await Ke(e, QT, "estimateGas")({
    ...k,
    account: b ? { address: b.address, type: "json-rpc" } : void 0
  })), a0(k), delete k.parameters, k;
}
async function n3(e, { serializedTransaction: t }) {
  return e.request({
    method: "eth_sendRawTransaction",
    params: [t]
  }, { retryCount: 0 });
}
async function r3(e, t) {
  var I, N, L, B;
  const { account: r = e.account, chain: o = e.chain, accessList: l, blobs: d, data: f, gas: m, gasPrice: v, maxFeePerBlobGas: w, maxFeePerGas: x, maxPriorityFeePerGas: b, nonce: k, to: T, value: O, ...R } = t;
  if (!r)
    throw new ix({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const j = fi(r);
  try {
    a0(t);
    let H;
    if (o !== null && (H = await Ke(e, Jf, "getChainId")({}), pA({
      currentChainId: H,
      chain: o
    })), j.type === "local") {
      const ce = await Ke(e, ux, "prepareTransactionRequest")({
        account: j,
        accessList: l,
        blobs: d,
        chain: o,
        chainId: H,
        data: f,
        gas: m,
        gasPrice: v,
        maxFeePerBlobGas: w,
        maxFeePerGas: x,
        maxPriorityFeePerGas: b,
        nonce: k,
        parameters: [...PA, "sidecars"],
        to: T,
        value: O,
        ...R
      }), ve = (I = o == null ? void 0 : o.serializers) == null ? void 0 : I.transaction, Se = await j.signTransaction(ce, {
        serializer: ve
      });
      return await Ke(e, n3, "sendRawTransaction")({
        serializedTransaction: Se
      });
    }
    const V = (B = (L = (N = e.chain) == null ? void 0 : N.formatters) == null ? void 0 : L.transactionRequest) == null ? void 0 : B.format, Y = (V || r0)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...qT(R, { format: V }),
      accessList: l,
      blobs: d,
      data: f,
      from: j.address,
      gas: m,
      gasPrice: v,
      maxFeePerBlobGas: w,
      maxFeePerGas: x,
      maxPriorityFeePerGas: b,
      nonce: k,
      to: T,
      value: O
    });
    return await e.request({
      method: "eth_sendTransaction",
      params: [Y]
    }, { retryCount: 0 });
  } catch (H) {
    throw pF(H, {
      ...t,
      account: j,
      chain: t.chain || void 0
    });
  }
}
function IF(e, t) {
  const { abi: r, args: o, bytecode: l, ...d } = t, f = dA({ abi: r, args: o, bytecode: l });
  return r3(e, {
    ...d,
    data: f
  });
}
const fC = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], jA = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverNotContract",
    type: "error"
  },
  {
    inputs: [
      {
        name: "returnData",
        type: "bytes"
      }
    ],
    name: "ResolverError",
    type: "error"
  },
  {
    inputs: [
      {
        components: [
          {
            name: "status",
            type: "uint16"
          },
          {
            name: "message",
            type: "string"
          }
        ],
        name: "errors",
        type: "tuple[]"
      }
    ],
    name: "HttpError",
    type: "error"
  }
], AA = [
  ...jA,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  },
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" },
      { name: "gateways", type: "string[]" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], MF = [
  ...jA,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  },
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [
      { type: "bytes", name: "reverseName" },
      { type: "string[]", name: "gateways" }
    ],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], oP = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
], sP = [
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "name", type: "bytes32" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "coinType", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bytes" }]
  }
], $F = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  }
];
function LF(e, t = {}) {
  typeof t.size < "u" && zo(e, { size: t.size });
  const r = ua(e, t);
  return Ml(r, t);
}
function NF(e, t = {}) {
  let r = e;
  if (typeof t.size < "u" && (zo(r, { size: t.size }), r = ks(r)), r.length > 1 || r[0] > 1)
    throw new QL(r);
  return !!r[0];
}
function Al(e, t = {}) {
  typeof t.size < "u" && zo(e, { size: t.size });
  const r = ua(e, t);
  return $l(r, t);
}
function FF(e, t = {}) {
  let r = e;
  return typeof t.size < "u" && (zo(r, { size: t.size }), r = ks(r, { dir: "right" })), new TextDecoder().decode(r);
}
function lx(e, t) {
  const r = typeof t == "string" ? Il(t) : t, o = t3(r);
  if (Cr(r) === 0 && e.length > 0)
    throw new tx();
  if (Cr(t) && Cr(t) < 32)
    throw new Jj({
      data: typeof t == "string" ? t : ua(t),
      params: e,
      size: Cr(t)
    });
  let l = 0;
  const d = [];
  for (let f = 0; f < e.length; ++f) {
    const m = e[f];
    o.setPosition(l);
    const [v, w] = Qh(o, m, {
      staticPosition: 0
    });
    l += w, d.push(v);
  }
  return d;
}
function Qh(e, t, { staticPosition: r }) {
  const o = UT(t.type);
  if (o) {
    const [l, d] = o;
    return BF(e, { ...t, type: d }, { length: l, staticPosition: r });
  }
  if (t.type === "tuple")
    return GF(e, t, { staticPosition: r });
  if (t.type === "address")
    return zF(e);
  if (t.type === "bool")
    return UF(e);
  if (t.type.startsWith("bytes"))
    return HF(e, t, { staticPosition: r });
  if (t.type.startsWith("uint") || t.type.startsWith("int"))
    return VF(e, t);
  if (t.type === "string")
    return qF(e, { staticPosition: r });
  throw new gN(t.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const uP = 32, pC = 32;
function zF(e) {
  const t = e.readBytes(32);
  return [t0(ua(cA(t, -20))), 32];
}
function BF(e, t, { length: r, staticPosition: o }) {
  if (!r) {
    const f = Al(e.readBytes(pC)), m = o + f, v = m + uP;
    e.setPosition(m);
    const w = Al(e.readBytes(uP)), x = wg(t);
    let b = 0;
    const k = [];
    for (let T = 0; T < w; ++T) {
      e.setPosition(v + (x ? T * 32 : b));
      const [O, R] = Qh(e, t, {
        staticPosition: v
      });
      b += R, k.push(O);
    }
    return e.setPosition(o + 32), [k, 32];
  }
  if (wg(t)) {
    const f = Al(e.readBytes(pC)), m = o + f, v = [];
    for (let w = 0; w < r; ++w) {
      e.setPosition(m + w * 32);
      const [x] = Qh(e, t, {
        staticPosition: m
      });
      v.push(x);
    }
    return e.setPosition(o + 32), [v, 32];
  }
  let l = 0;
  const d = [];
  for (let f = 0; f < r; ++f) {
    const [m, v] = Qh(e, t, {
      staticPosition: o + l
    });
    l += v, d.push(m);
  }
  return [d, l];
}
function UF(e) {
  return [NF(e.readBytes(32), { size: 32 }), 32];
}
function HF(e, t, { staticPosition: r }) {
  const [o, l] = t.type.split("bytes");
  if (!l) {
    const f = Al(e.readBytes(32));
    e.setPosition(r + f);
    const m = Al(e.readBytes(32));
    if (m === 0)
      return e.setPosition(r + 32), ["0x", 32];
    const v = e.readBytes(m);
    return e.setPosition(r + 32), [ua(v), 32];
  }
  return [ua(e.readBytes(parseInt(l), 32)), 32];
}
function VF(e, t) {
  const r = t.type.startsWith("int"), o = parseInt(t.type.split("int")[1] || "256"), l = e.readBytes(32);
  return [
    o > 48 ? LF(l, { signed: r }) : Al(l, { signed: r }),
    32
  ];
}
function GF(e, t, { staticPosition: r }) {
  const o = t.components.length === 0 || t.components.some(({ name: f }) => !f), l = o ? [] : {};
  let d = 0;
  if (wg(t)) {
    const f = Al(e.readBytes(pC)), m = r + f;
    for (let v = 0; v < t.components.length; ++v) {
      const w = t.components[v];
      e.setPosition(m + d);
      const [x, b] = Qh(e, w, {
        staticPosition: m
      });
      d += b, l[o ? v : w == null ? void 0 : w.name] = x;
    }
    return e.setPosition(r + 32), [l, 32];
  }
  for (let f = 0; f < t.components.length; ++f) {
    const m = t.components[f], [v, w] = Qh(e, m, {
      staticPosition: r
    });
    l[o ? f : m == null ? void 0 : m.name] = v, d += w;
  }
  return [l, d];
}
function qF(e, { staticPosition: t }) {
  const r = Al(e.readBytes(32)), o = t + r;
  e.setPosition(o);
  const l = Al(e.readBytes(32));
  if (l === 0)
    return e.setPosition(t + 32), ["", 32];
  const d = e.readBytes(l, 32), f = FF(ks(d));
  return e.setPosition(t + 32), [f, 32];
}
function wg(e) {
  var o;
  const { type: t } = e;
  if (t === "string" || t === "bytes" || t.endsWith("[]"))
    return !0;
  if (t === "tuple")
    return (o = e.components) == null ? void 0 : o.some(wg);
  const r = UT(e.type);
  return !!(r && wg({ ...e, type: r[1] }));
}
const WF = "1.0.0";
let Bo = class hC extends Error {
  constructor(t, r = {}) {
    var f;
    const o = r.cause instanceof hC ? r.cause.details : (f = r.cause) != null && f.message ? r.cause.message : r.details, l = r.cause instanceof hC && r.cause.docsPath || r.docsPath, d = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...l ? [`Docs: https://abitype.dev${l}`] : [],
      ...o ? [`Details: ${o}`] : [],
      `Version: abitype@${WF}`
    ].join(`
`);
    super(d), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiTypeError"
    }), r.cause && (this.cause = r.cause), this.details = o, this.docsPath = l, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
};
function Sd(e, t) {
  const r = e.exec(t);
  return r == null ? void 0 : r.groups;
}
const DA = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, IA = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, MA = /^\(.+?\).*?$/, lP = /^tuple(?<array>(\[(\d*)\])*)$/;
function mC(e) {
  let t = e.type;
  if (lP.test(e.type) && "components" in e) {
    t = "(";
    const r = e.components.length;
    for (let l = 0; l < r; l++) {
      const d = e.components[l];
      t += mC(d), l < r - 1 && (t += ", ");
    }
    const o = Sd(lP, e.type);
    return t += `)${(o == null ? void 0 : o.array) ?? ""}`, mC({
      ...e,
      type: t
    });
  }
  return "indexed" in e && e.indexed && (t = `${t} indexed`), e.name ? `${t} ${e.name}` : t;
}
function Vv(e) {
  let t = "";
  const r = e.length;
  for (let o = 0; o < r; o++) {
    const l = e[o];
    t += mC(l), o !== r - 1 && (t += ", ");
  }
  return t;
}
function YF(e) {
  return e.type === "function" ? `function ${e.name}(${Vv(e.inputs)})${e.stateMutability && e.stateMutability !== "nonpayable" ? ` ${e.stateMutability}` : ""}${e.outputs.length ? ` returns (${Vv(e.outputs)})` : ""}` : e.type === "event" ? `event ${e.name}(${Vv(e.inputs)})` : e.type === "error" ? `error ${e.name}(${Vv(e.inputs)})` : e.type === "constructor" ? `constructor(${Vv(e.inputs)})${e.stateMutability === "payable" ? " payable" : ""}` : e.type === "fallback" ? "fallback()" : "receive() external payable";
}
const $A = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function ZF(e) {
  return $A.test(e);
}
function KF(e) {
  return Sd($A, e);
}
const LA = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function QF(e) {
  return LA.test(e);
}
function XF(e) {
  return Sd(LA, e);
}
const NA = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function JF(e) {
  return NA.test(e);
}
function ez(e) {
  return Sd(NA, e);
}
const FA = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function zA(e) {
  return FA.test(e);
}
function tz(e) {
  return Sd(FA, e);
}
const BA = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function nz(e) {
  return BA.test(e);
}
function rz(e) {
  return Sd(BA, e);
}
const az = /^fallback\(\)$/;
function iz(e) {
  return az.test(e);
}
const oz = /^receive\(\) external payable$/;
function sz(e) {
  return oz.test(e);
}
const uz = /* @__PURE__ */ new Set(["indexed"]), yC = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);
class lz extends Bo {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [
        `Type "${t}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownTypeError"
    });
  }
}
class cz extends Bo {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [`Type "${t}" is not a valid ABI type.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSolidityTypeError"
    });
  }
}
class dz extends Bo {
  constructor({ param: t }) {
    super("Invalid ABI parameter.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParameterError"
    });
  }
}
class fz extends Bo {
  constructor({ param: t, name: r }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `"${r}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SolidityProtectedKeywordError"
    });
  }
}
class pz extends Bo {
  constructor({ param: t, type: r, modifier: o }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${o}" not allowed${r ? ` in "${r}" type` : ""}.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidModifierError"
    });
  }
}
class hz extends Bo {
  constructor({ param: t, type: r, modifier: o }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${o}" not allowed${r ? ` in "${r}" type` : ""}.`,
        `Data location can only be specified for array, struct, or mapping types, but "${o}" was given.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidFunctionModifierError"
    });
  }
}
class mz extends Bo {
  constructor({ abiParameter: t }) {
    super("Invalid ABI parameter.", {
      details: JSON.stringify(t, null, 2),
      metaMessages: ["ABI parameter type is invalid."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiTypeParameterError"
    });
  }
}
class Kv extends Bo {
  constructor({ signature: t, type: r }) {
    super(`Invalid ${r} signature.`, {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSignatureError"
    });
  }
}
class yz extends Bo {
  constructor({ signature: t }) {
    super("Unknown signature.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSignatureError"
    });
  }
}
class vz extends Bo {
  constructor({ signature: t }) {
    super("Invalid struct signature.", {
      details: t,
      metaMessages: ["No properties exist."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStructSignatureError"
    });
  }
}
class gz extends Bo {
  constructor({ type: t }) {
    super("Circular reference detected.", {
      metaMessages: [`Struct "${t}" is a circular reference.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CircularReferenceError"
    });
  }
}
class bz extends Bo {
  constructor({ current: t, depth: r }) {
    super("Unbalanced parentheses.", {
      metaMessages: [
        `"${t.trim()}" has too many ${r > 0 ? "opening" : "closing"} parentheses.`
      ],
      details: `Depth "${r}"`
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParenthesisError"
    });
  }
}
function wz(e, t) {
  return t ? `${t}:${e}` : e;
}
const yE = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: !0 }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: !0 }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ]
]);
function xz(e, t = {}) {
  if (JF(e)) {
    const r = ez(e);
    if (!r)
      throw new Kv({ signature: e, type: "function" });
    const o = xs(r.parameters), l = [], d = o.length;
    for (let m = 0; m < d; m++)
      l.push(Pf(o[m], {
        modifiers: yC,
        structs: t,
        type: "function"
      }));
    const f = [];
    if (r.returns) {
      const m = xs(r.returns), v = m.length;
      for (let w = 0; w < v; w++)
        f.push(Pf(m[w], {
          modifiers: yC,
          structs: t,
          type: "function"
        }));
    }
    return {
      name: r.name,
      type: "function",
      stateMutability: r.stateMutability ?? "nonpayable",
      inputs: l,
      outputs: f
    };
  }
  if (QF(e)) {
    const r = XF(e);
    if (!r)
      throw new Kv({ signature: e, type: "event" });
    const o = xs(r.parameters), l = [], d = o.length;
    for (let f = 0; f < d; f++)
      l.push(Pf(o[f], {
        modifiers: uz,
        structs: t,
        type: "event"
      }));
    return { name: r.name, type: "event", inputs: l };
  }
  if (ZF(e)) {
    const r = KF(e);
    if (!r)
      throw new Kv({ signature: e, type: "error" });
    const o = xs(r.parameters), l = [], d = o.length;
    for (let f = 0; f < d; f++)
      l.push(Pf(o[f], { structs: t, type: "error" }));
    return { name: r.name, type: "error", inputs: l };
  }
  if (nz(e)) {
    const r = rz(e);
    if (!r)
      throw new Kv({ signature: e, type: "constructor" });
    const o = xs(r.parameters), l = [], d = o.length;
    for (let f = 0; f < d; f++)
      l.push(Pf(o[f], { structs: t, type: "constructor" }));
    return {
      type: "constructor",
      stateMutability: r.stateMutability ?? "nonpayable",
      inputs: l
    };
  }
  if (iz(e))
    return { type: "fallback" };
  if (sz(e))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new yz({ signature: e });
}
const Sz = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, kz = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, Ez = /^u?int$/;
function Pf(e, t) {
  var b, k;
  const r = wz(e, t == null ? void 0 : t.type);
  if (yE.has(r))
    return yE.get(r);
  const o = MA.test(e), l = Sd(o ? kz : Sz, e);
  if (!l)
    throw new dz({ param: e });
  if (l.name && Tz(l.name))
    throw new fz({ param: e, name: l.name });
  const d = l.name ? { name: l.name } : {}, f = l.modifier === "indexed" ? { indexed: !0 } : {}, m = (t == null ? void 0 : t.structs) ?? {};
  let v, w = {};
  if (o) {
    v = "tuple";
    const T = xs(l.type), O = [], R = T.length;
    for (let j = 0; j < R; j++)
      O.push(Pf(T[j], { structs: m }));
    w = { components: O };
  } else if (l.type in m)
    v = "tuple", w = { components: m[l.type] };
  else if (Ez.test(l.type))
    v = `${l.type}256`;
  else if (v = l.type, (t == null ? void 0 : t.type) !== "struct" && !UA(v))
    throw new cz({ type: v });
  if (l.modifier) {
    if (!((k = (b = t == null ? void 0 : t.modifiers) == null ? void 0 : b.has) != null && k.call(b, l.modifier)))
      throw new pz({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: l.modifier
      });
    if (yC.has(l.modifier) && !_z(v, !!l.array))
      throw new hz({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: l.modifier
      });
  }
  const x = {
    type: `${v}${l.array ?? ""}`,
    ...d,
    ...f,
    ...w
  };
  return yE.set(r, x), x;
}
function xs(e, t = [], r = "", o = 0) {
  const l = e.trim().length;
  for (let d = 0; d < l; d++) {
    const f = e[d], m = e.slice(d + 1);
    switch (f) {
      case ",":
        return o === 0 ? xs(m, [...t, r.trim()]) : xs(m, t, `${r}${f}`, o);
      case "(":
        return xs(m, t, `${r}${f}`, o + 1);
      case ")":
        return xs(m, t, `${r}${f}`, o - 1);
      default:
        return xs(m, t, `${r}${f}`, o);
    }
  }
  if (r === "")
    return t;
  if (o !== 0)
    throw new bz({ current: r, depth: o });
  return t.push(r.trim()), t;
}
function UA(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || DA.test(e) || IA.test(e);
}
const Cz = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function Tz(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || e === "tuple" || DA.test(e) || IA.test(e) || Cz.test(e);
}
function _z(e, t) {
  return t || e === "bytes" || e === "string" || e === "tuple";
}
function Rz(e) {
  const t = {}, r = e.length;
  for (let f = 0; f < r; f++) {
    const m = e[f];
    if (!zA(m))
      continue;
    const v = tz(m);
    if (!v)
      throw new Kv({ signature: m, type: "struct" });
    const w = v.properties.split(";"), x = [], b = w.length;
    for (let k = 0; k < b; k++) {
      const O = w[k].trim();
      if (!O)
        continue;
      const R = Pf(O, {
        type: "struct"
      });
      x.push(R);
    }
    if (!x.length)
      throw new vz({ signature: m });
    t[v.name] = x;
  }
  const o = {}, l = Object.entries(t), d = l.length;
  for (let f = 0; f < d; f++) {
    const [m, v] = l[f];
    o[m] = HA(v, t);
  }
  return o;
}
const Oz = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function HA(e, t, r = /* @__PURE__ */ new Set()) {
  const o = [], l = e.length;
  for (let d = 0; d < l; d++) {
    const f = e[d];
    if (MA.test(f.type))
      o.push(f);
    else {
      const v = Sd(Oz, f.type);
      if (!(v != null && v.type))
        throw new mz({ abiParameter: f });
      const { array: w, type: x } = v;
      if (x in t) {
        if (r.has(x))
          throw new gz({ type: x });
        o.push({
          ...f,
          type: `tuple${w ?? ""}`,
          components: HA(t[x] ?? [], t, /* @__PURE__ */ new Set([...r, x]))
        });
      } else if (UA(x))
        o.push(f);
      else
        throw new lz({ type: x });
    }
  }
  return o;
}
function Pz(e) {
  const t = Rz(e), r = [], o = e.length;
  for (let l = 0; l < o; l++) {
    const d = e[l];
    zA(d) || r.push(xz(d, t));
  }
  return r;
}
const jz = (e) => Nn(Dl(e));
function Az(e) {
  return jz(e);
}
function Dz(e) {
  let t = !0, r = "", o = 0, l = "", d = !1;
  for (let f = 0; f < e.length; f++) {
    const m = e[f];
    if (["(", ")", ","].includes(m) && (t = !0), m === "(" && o++, m === ")" && o--, !!t) {
      if (o === 0) {
        if (m === " " && ["event", "function", ""].includes(l))
          l = "";
        else if (l += m, m === ")") {
          d = !0;
          break;
        }
        continue;
      }
      if (m === " ") {
        e[f - 1] !== "," && r !== "," && r !== ",(" && (r = "", t = !1);
        continue;
      }
      l += m, r += m;
    }
  }
  if (!d)
    throw new we("Unable to normalize signature.");
  return l;
}
const Iz = (e) => {
  const t = (() => typeof e == "string" ? e : YF(e))();
  return Dz(t);
};
function VA(e) {
  return Az(Iz(e));
}
const a3 = VA, i3 = (e) => fm(VA(e), 0, 4);
function i0(e) {
  const { abi: t, args: r = [], name: o } = e, l = Cs(o, { strict: !1 }), d = t.filter((m) => l ? m.type === "function" ? i3(m) === o : m.type === "event" ? a3(m) === o : !1 : "name" in m && m.name === o);
  if (d.length === 0)
    return;
  if (d.length === 1)
    return d[0];
  let f;
  for (const m of d) {
    if (!("inputs" in m))
      continue;
    if (!r || r.length === 0) {
      if (!m.inputs || m.inputs.length === 0)
        return m;
      continue;
    }
    if (!m.inputs || m.inputs.length === 0 || m.inputs.length !== r.length)
      continue;
    if (r.every((w, x) => {
      const b = "inputs" in m && m.inputs[x];
      return b ? vC(w, b) : !1;
    })) {
      if (f && "inputs" in f && f.inputs) {
        const w = GA(m.inputs, f.inputs, r);
        if (w)
          throw new mN({
            abiItem: m,
            type: w[0]
          }, {
            abiItem: f,
            type: w[1]
          });
      }
      f = m;
    }
  }
  return f || d[0];
}
function vC(e, t) {
  const r = typeof e, o = t.type;
  switch (o) {
    case "address":
      return Va(e, { strict: !1 });
    case "bool":
      return r === "boolean";
    case "function":
      return r === "string";
    case "string":
      return r === "string";
    default:
      return o === "tuple" && "components" in t ? Object.values(t.components).every((l, d) => vC(Object.values(e)[d], l)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(o) ? r === "number" || r === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(o) ? r === "string" || e instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(o) ? Array.isArray(e) && e.every((l) => vC(l, {
        ...t,
        // Pop off `[]` or `[M]` from end of type
        type: o.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function GA(e, t, r) {
  for (const o in e) {
    const l = e[o], d = t[o];
    if (l.type === "tuple" && d.type === "tuple" && "components" in l && "components" in d)
      return GA(l.components, d.components, r[o]);
    const f = [l.type, d.type];
    if ((() => f.includes("address") && f.includes("bytes20") ? !0 : f.includes("address") && f.includes("string") ? Va(r[o], { strict: !1 }) : f.includes("address") && f.includes("bytes") ? Va(r[o], { strict: !1 }) : !1)())
      return f;
  }
}
const vE = "/docs/contract/decodeFunctionResult";
function Cm(e) {
  const { abi: t, args: r, functionName: o, data: l } = e;
  let d = t[0];
  if (o) {
    const m = i0({ abi: t, args: r, name: o });
    if (!m)
      throw new P1(o, { docsPath: vE });
    d = m;
  }
  if (d.type !== "function")
    throw new P1(void 0, { docsPath: vE });
  if (!d.outputs)
    throw new hN(d.name, { docsPath: vE });
  const f = lx(d.outputs, l);
  if (f && f.length > 1)
    return f;
  if (f && f.length === 1)
    return f[0];
}
const cP = "/docs/contract/encodeFunctionData";
function Mz(e) {
  const { abi: t, args: r, functionName: o } = e;
  let l = t[0];
  if (o) {
    const d = i0({
      abi: t,
      args: r,
      name: o
    });
    if (!d)
      throw new P1(o, { docsPath: cP });
    l = d;
  }
  if (l.type !== "function")
    throw new P1(void 0, { docsPath: cP });
  return {
    abi: [l],
    functionName: i3(Ll(l))
  };
}
function di(e) {
  const { args: t } = e, { abi: r, functionName: o } = (() => {
    var m;
    return e.abi.length === 1 && ((m = e.functionName) != null && m.startsWith("0x")) ? e : Mz(e);
  })(), l = r[0], d = o, f = "inputs" in l && l.inputs ? ro(l.inputs, t ?? []) : void 0;
  return Ps([d, f ?? "0x"]);
}
function Tm({ blockNumber: e, chain: t, contract: r }) {
  var l;
  const o = (l = t == null ? void 0 : t.contracts) == null ? void 0 : l[r];
  if (!o)
    throw new nC({
      chain: t,
      contract: { name: r }
    });
  if (e && o.blockCreated && o.blockCreated > e)
    throw new nC({
      blockNumber: e,
      chain: t,
      contract: {
        name: r,
        blockCreated: o.blockCreated
      }
    });
  return o.address;
}
const qA = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, $z = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, Lz = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function gC(e) {
  const { abi: t, data: r } = e, o = fm(r, 0, 4);
  if (o === "0x")
    throw new tx();
  const d = [...t || [], $z, Lz].find((f) => f.type === "error" && o === i3(Ll(f)));
  if (!d)
    throw new eA(o, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: d,
    args: "inputs" in d && d.inputs && d.inputs.length > 0 ? lx(d.inputs, fm(r, 4)) : void 0,
    errorName: d.name
  };
}
function WA({ abiItem: e, args: t, includeFunctionName: r = !0, includeName: o = !1 }) {
  if ("name" in e && "inputs" in e && e.inputs)
    return `${r ? e.name : ""}(${e.inputs.map((l, d) => `${o && l.name ? `${l.name}: ` : ""}${typeof t[d] == "object" ? sa(t[d]) : t[d]}`).join(", ")})`;
}
class Nz extends we {
  constructor({ address: t }) {
    super(`State for account "${t}" is set multiple times.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountStateConflictError"
    });
  }
}
class Fz extends we {
  constructor() {
    super("state and stateDiff are set on the same account."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "StateAssignmentConflictError"
    });
  }
}
function dP(e) {
  return e.reduce((t, { slot: r, value: o }) => `${t}        ${r}: ${o}
`, "");
}
function zz(e) {
  return e.reduce((t, { address: r, ...o }) => {
    let l = `${t}    ${r}:
`;
    return o.nonce && (l += `      nonce: ${o.nonce}
`), o.balance && (l += `      balance: ${o.balance}
`), o.code && (l += `      code: ${o.code}
`), o.state && (l += `      state:
`, l += dP(o.state)), o.stateDiff && (l += `      stateDiff:
`, l += dP(o.stateDiff)), l;
  }, `  State Override:
`).slice(0, -1);
}
class YA extends we {
  constructor(t, { account: r, docsPath: o, chain: l, data: d, gas: f, gasPrice: m, maxFeePerGas: v, maxPriorityFeePerGas: w, nonce: x, to: b, value: k, stateOverride: T }) {
    var j;
    const O = r ? fi(r) : void 0;
    let R = n0({
      from: O == null ? void 0 : O.address,
      to: b,
      value: typeof k < "u" && `${VT(k)} ${((j = l == null ? void 0 : l.nativeCurrency) == null ? void 0 : j.symbol) || "ETH"}`,
      data: d,
      gas: f,
      gasPrice: typeof m < "u" && `${Fi(m)} gwei`,
      maxFeePerGas: typeof v < "u" && `${Fi(v)} gwei`,
      maxPriorityFeePerGas: typeof w < "u" && `${Fi(w)} gwei`,
      nonce: x
    });
    T && (R += `
${zz(T)}`), super(t.shortMessage, {
      cause: t,
      docsPath: o,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Raw Call Arguments:",
        R
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CallExecutionError"
    }), this.cause = t;
  }
}
class o3 extends we {
  constructor(t, { abi: r, args: o, contractAddress: l, docsPath: d, functionName: f, sender: m }) {
    const v = i0({ abi: r, args: o, name: f }), w = v ? WA({
      abiItem: v,
      args: o,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, x = v ? Ll(v, { includeName: !0 }) : void 0, b = n0({
      address: l && YL(l),
      function: x,
      args: w && w !== "()" && `${[...Array((f == null ? void 0 : f.length) ?? 0).keys()].map(() => " ").join("")}${w}`,
      sender: m
    });
    super(t.shortMessage || `An unknown error occurred while executing the contract function "${f}".`, {
      cause: t,
      docsPath: d,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Contract Call:",
        b
      ].filter(Boolean)
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionExecutionError"
    }), this.abi = r, this.args = o, this.cause = t, this.contractAddress = l, this.functionName = f, this.sender = m;
  }
}
class bC extends we {
  constructor({ abi: t, data: r, functionName: o, message: l }) {
    let d, f, m, v;
    if (r && r !== "0x")
      try {
        f = gC({ abi: t, data: r });
        const { abiItem: x, errorName: b, args: k } = f;
        if (b === "Error")
          v = k[0];
        else if (b === "Panic") {
          const [T] = k;
          v = qA[T];
        } else {
          const T = x ? Ll(x, { includeName: !0 }) : void 0, O = x && k ? WA({
            abiItem: x,
            args: k,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          m = [
            T ? `Error: ${T}` : "",
            O && O !== "()" ? `       ${[...Array((b == null ? void 0 : b.length) ?? 0).keys()].map(() => " ").join("")}${O}` : ""
          ];
        }
      } catch (x) {
        d = x;
      }
    else
      l && (v = l);
    let w;
    d instanceof eA && (w = d.signature, m = [
      `Unable to decode signature "${w}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${w}.`
    ]), super(v && v !== "execution reverted" || w ? [
      `The contract function "${o}" reverted with the following ${w ? "signature" : "reason"}:`,
      v || w
    ].join(`
`) : `The contract function "${o}" reverted.`, {
      cause: d,
      metaMessages: m
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = f, this.reason = v, this.signature = w;
  }
}
class Bz extends we {
  constructor({ functionName: t }) {
    super(`The contract function "${t}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${t}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionZeroDataError"
    });
  }
}
class s3 extends we {
  constructor({ data: t, message: r }) {
    super(r || ""), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RawContractError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t;
  }
}
function u3(e, t) {
  var o, l, d, f, m, v;
  if (!(e instanceof we))
    return !1;
  const r = e.walk((w) => w instanceof bC);
  return r instanceof bC ? !!(((o = r.data) == null ? void 0 : o.errorName) === "ResolverNotFound" || ((l = r.data) == null ? void 0 : l.errorName) === "ResolverWildcardNotSupported" || ((d = r.data) == null ? void 0 : d.errorName) === "ResolverNotContract" || ((f = r.data) == null ? void 0 : f.errorName) === "ResolverError" || ((m = r.data) == null ? void 0 : m.errorName) === "HttpError" || (v = r.reason) != null && v.includes("Wildcard on non-extended resolvers is not supported") || t === "reverse" && r.reason === qA[50]) : !1;
}
function ZA(e) {
  if (e.length !== 66 || e.indexOf("[") !== 0 || e.indexOf("]") !== 65)
    return null;
  const t = `0x${e.slice(1, 65)}`;
  return Cs(t) ? t : null;
}
function E1(e) {
  let t = new Uint8Array(32).fill(0);
  if (!e)
    return ua(t);
  const r = e.split(".");
  for (let o = r.length - 1; o >= 0; o -= 1) {
    const l = ZA(r[o]), d = l ? Dl(l) : Nn(Pl(r[o]), "bytes");
    t = Nn(ia([t, d]), "bytes");
  }
  return ua(t);
}
function Uz(e) {
  return `[${e.slice(2)}]`;
}
function Hz(e) {
  const t = new Uint8Array(32).fill(0);
  return e ? ZA(e) || Nn(Pl(e)) : ua(t);
}
function cx(e) {
  const t = e.replace(/^\.|\.$/gm, "");
  if (t.length === 0)
    return new Uint8Array(1);
  const r = new Uint8Array(Pl(t).byteLength + 2);
  let o = 0;
  const l = t.split(".");
  for (let d = 0; d < l.length; d++) {
    let f = Pl(l[d]);
    f.byteLength > 255 && (f = Pl(Uz(Hz(l[d])))), r[o] = f.length, r.set(f, o + 1), o += f.length + 1;
  }
  return r.byteLength !== o + 1 ? r.slice(0, o + 1) : r;
}
const Vz = 3;
function xg(e, { abi: t, address: r, args: o, docsPath: l, functionName: d, sender: f }) {
  const { code: m, data: v, message: w, shortMessage: x } = e instanceof s3 ? e : e instanceof we ? e.walk((k) => "data" in k) || e.walk() : {}, b = (() => e instanceof tx ? new Bz({ functionName: d }) : [Vz, Yf.code].includes(m) && (v || w || x) ? new bC({
    abi: t,
    data: typeof v == "object" ? v.data : v,
    functionName: d,
    message: x ?? w
  }) : e)();
  return new o3(b, {
    abi: t,
    args: o,
    contractAddress: r,
    docsPath: l,
    functionName: d,
    sender: f
  });
}
const Gz = "0x82ad56cb";
function qz(e, { docsPath: t, ...r }) {
  const o = (() => {
    const l = GT(e, r);
    return l instanceof jl ? e : l;
  })();
  return new YA(o, {
    docsPath: t,
    ...r
  });
}
const gE = /* @__PURE__ */ new Map();
function KA({ fn: e, id: t, shouldSplitBatch: r, wait: o = 0, sort: l }) {
  const d = async () => {
    const x = v();
    f();
    const b = x.map(({ args: k }) => k);
    b.length !== 0 && e(b).then((k) => {
      var T;
      l && Array.isArray(k) && k.sort(l);
      for (let O = 0; O < x.length; O++) {
        const { pendingPromise: R } = x[O];
        (T = R.resolve) == null || T.call(R, [k[O], k]);
      }
    }).catch((k) => {
      var T;
      for (let O = 0; O < x.length; O++) {
        const { pendingPromise: R } = x[O];
        (T = R.reject) == null || T.call(R, k);
      }
    });
  }, f = () => gE.delete(t), m = () => v().map(({ args: x }) => x), v = () => gE.get(t) || [], w = (x) => gE.set(t, [...v(), x]);
  return {
    flush: f,
    async schedule(x) {
      const b = {}, k = new Promise((R, j) => {
        b.resolve = R, b.reject = j;
      });
      return (r == null ? void 0 : r([...m(), x])) && d(), v().length > 0 ? (w({ args: x, pendingPromise: b }), k) : (w({ args: x, pendingPromise: b }), setTimeout(d, o), k);
    }
  };
}
async function dx(e, t) {
  var B, H, V, W;
  const { account: r = e.account, batch: o = !!((B = e.batch) != null && B.multicall), blockNumber: l, blockTag: d = "latest", accessList: f, blobs: m, data: v, gas: w, gasPrice: x, maxFeePerBlobGas: b, maxFeePerGas: k, maxPriorityFeePerGas: T, nonce: O, to: R, value: j, stateOverride: I, ...N } = t, L = r ? fi(r) : void 0;
  try {
    a0(t);
    const ce = (l ? Bt(l) : void 0) || d, ve = Qz(I), Se = (W = (V = (H = e.chain) == null ? void 0 : H.formatters) == null ? void 0 : V.transactionRequest) == null ? void 0 : W.format, Re = (Se || r0)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...qT(N, { format: Se }),
      from: L == null ? void 0 : L.address,
      accessList: f,
      blobs: m,
      data: v,
      gas: w,
      gasPrice: x,
      maxFeePerBlobGas: b,
      maxFeePerGas: k,
      maxPriorityFeePerGas: T,
      nonce: O,
      to: R,
      value: j
    });
    if (o && Wz({ request: Re }) && !ve)
      try {
        return await Yz(e, {
          ...Re,
          blockNumber: l,
          blockTag: d
        });
      } catch (se) {
        if (!(se instanceof fA) && !(se instanceof nC))
          throw se;
      }
    const Pe = await e.request({
      method: "eth_call",
      params: ve ? [
        Re,
        ce,
        ve
      ] : [Re, ce]
    });
    return Pe === "0x" ? { data: void 0 } : { data: Pe };
  } catch (Y) {
    const ce = Zz(Y), { offchainLookup: ve, offchainLookupSignature: Se } = await import("./ccip-8b1b871f.js");
    if (e.ccipRead !== !1 && (ce == null ? void 0 : ce.slice(0, 10)) === Se && R)
      return { data: await ve(e, { data: ce, to: R }) };
    throw qz(Y, {
      ...t,
      account: L,
      chain: e.chain
    });
  }
}
function Wz({ request: e }) {
  const { data: t, to: r, ...o } = e;
  return !(!t || t.startsWith(Gz) || !r || Object.values(o).filter((l) => typeof l < "u").length > 0);
}
async function Yz(e, t) {
  var R;
  const { batchSize: r = 1024, wait: o = 0 } = typeof ((R = e.batch) == null ? void 0 : R.multicall) == "object" ? e.batch.multicall : {}, { blockNumber: l, blockTag: d = "latest", data: f, multicallAddress: m, to: v } = t;
  let w = m;
  if (!w) {
    if (!e.chain)
      throw new fA();
    w = Tm({
      blockNumber: l,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const b = (l ? Bt(l) : void 0) || d, { schedule: k } = KA({
    id: `${e.uid}.${b}`,
    wait: o,
    shouldSplitBatch(j) {
      return j.reduce((N, { data: L }) => N + (L.length - 2), 0) > r * 2;
    },
    fn: async (j) => {
      const I = j.map((B) => ({
        allowFailure: !0,
        callData: B.data,
        target: B.to
      })), N = di({
        abi: fC,
        args: [I],
        functionName: "aggregate3"
      }), L = await e.request({
        method: "eth_call",
        params: [
          {
            data: N,
            to: w
          },
          b
        ]
      });
      return Cm({
        abi: fC,
        args: [I],
        functionName: "aggregate3",
        data: L || "0x"
      });
    }
  }), [{ returnData: T, success: O }] = await k({ data: f, to: v });
  if (!O)
    throw new s3({ data: T });
  return T === "0x" ? { data: void 0 } : { data: T };
}
function Zz(e) {
  var r;
  if (!(e instanceof we))
    return;
  const t = e.walk();
  return typeof (t == null ? void 0 : t.data) == "object" ? (r = t.data) == null ? void 0 : r.data : t.data;
}
function fP(e) {
  if (!(!e || e.length === 0))
    return e.reduce((t, { slot: r, value: o }) => {
      if (r.length !== 66)
        throw new ZO({
          size: r.length,
          targetSize: 66,
          type: "hex"
        });
      if (o.length !== 66)
        throw new ZO({
          size: o.length,
          targetSize: 66,
          type: "hex"
        });
      return t[r] = o, t;
    }, {});
}
function Kz(e) {
  const { balance: t, nonce: r, state: o, stateDiff: l, code: d } = e, f = {};
  if (d !== void 0 && (f.code = d), t !== void 0 && (f.balance = Bt(t)), r !== void 0 && (f.nonce = Bt(r)), o !== void 0 && (f.state = fP(o)), l !== void 0) {
    if (f.state)
      throw new Fz();
    f.stateDiff = fP(l);
  }
  return f;
}
function Qz(e) {
  if (!e)
    return;
  const t = {};
  for (const { address: r, ...o } of e) {
    if (!Va(r, { strict: !1 }))
      throw new Lo({ address: r });
    if (t[r])
      throw new Nz({ address: r });
    t[r] = Kz(o);
  }
  return t;
}
async function Ts(e, t) {
  const { abi: r, address: o, args: l, functionName: d, ...f } = t, m = di({
    abi: r,
    args: l,
    functionName: d
  });
  try {
    const { data: v } = await Ke(e, dx, "call")({
      ...f,
      data: m,
      to: o
    });
    return Cm({
      abi: r,
      args: l,
      functionName: d,
      data: v || "0x"
    });
  } catch (v) {
    throw xg(v, {
      abi: r,
      address: o,
      args: l,
      docsPath: "/docs/contract/readContract",
      functionName: d
    });
  }
}
async function Xz(e, { blockNumber: t, blockTag: r, coinType: o, name: l, gatewayUrls: d, strict: f, universalResolverAddress: m }) {
  let v = m;
  if (!v) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    v = Tm({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const w = di({
      abi: sP,
      functionName: "addr",
      ...o != null ? { args: [E1(l), BigInt(o)] } : { args: [E1(l)] }
    }), x = {
      address: v,
      abi: AA,
      functionName: "resolve",
      args: [St(cx(l)), w],
      blockNumber: t,
      blockTag: r
    }, b = Ke(e, Ts, "readContract"), k = d ? await b({
      ...x,
      args: [...x.args, d]
    }) : await b(x);
    if (k[0] === "0x")
      return null;
    const T = Cm({
      abi: sP,
      args: o != null ? [E1(l), BigInt(o)] : void 0,
      functionName: "addr",
      data: k[0]
    });
    return T === "0x" || ks(T) === "0x00" ? null : T;
  } catch (w) {
    if (f)
      throw w;
    if (u3(w, "resolve"))
      return null;
    throw w;
  }
}
class Jz extends we {
  constructor({ data: t }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(t)}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidMetadataError"
    });
  }
}
class Gv extends we {
  constructor({ reason: t }) {
    super(`ENS NFT avatar URI is invalid. ${t}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidNftUriError"
    });
  }
}
class l3 extends we {
  constructor({ uri: t }) {
    super(`Unable to resolve ENS avatar URI "${t}". The URI may be malformed, invalid, or does not respond with a valid image.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUriResolutionError"
    });
  }
}
class eB extends we {
  constructor({ namespace: t }) {
    super(`ENS NFT avatar namespace "${t}" is not supported. Must be "erc721" or "erc1155".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUnsupportedNamespaceError"
    });
  }
}
const tB = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, nB = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, rB = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, aB = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function iB(e) {
  try {
    const t = await fetch(e, { method: "HEAD" });
    if (t.status === 200) {
      const r = t.headers.get("content-type");
      return r == null ? void 0 : r.startsWith("image/");
    }
    return !1;
  } catch (t) {
    return typeof t == "object" && typeof t.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((r) => {
      const o = new Image();
      o.onload = () => {
        r(!0);
      }, o.onerror = () => {
        r(!1);
      }, o.src = e;
    });
  }
}
function pP(e, t) {
  return e ? e.endsWith("/") ? e.slice(0, -1) : e : t;
}
function QA({ uri: e, gatewayUrls: t }) {
  const r = rB.test(e);
  if (r)
    return { uri: e, isOnChain: !0, isEncoded: r };
  const o = pP(t == null ? void 0 : t.ipfs, "https://ipfs.io"), l = pP(t == null ? void 0 : t.arweave, "https://arweave.net"), d = e.match(tB), { protocol: f, subpath: m, target: v, subtarget: w = "" } = (d == null ? void 0 : d.groups) || {}, x = f === "ipns:/" || m === "ipns/", b = f === "ipfs:/" || m === "ipfs/" || nB.test(e);
  if (e.startsWith("http") && !x && !b) {
    let T = e;
    return t != null && t.arweave && (T = e.replace(/https:\/\/arweave.net/g, t == null ? void 0 : t.arweave)), { uri: T, isOnChain: !1, isEncoded: !1 };
  }
  if ((x || b) && v)
    return {
      uri: `${o}/${x ? "ipns" : "ipfs"}/${v}${w}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (f === "ar:/" && v)
    return {
      uri: `${l}/${v}${w || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let k = e.replace(aB, "");
  if (k.startsWith("<svg") && (k = `data:image/svg+xml;base64,${btoa(k)}`), k.startsWith("data:") || k.startsWith("{"))
    return {
      uri: k,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new l3({ uri: e });
}
function XA(e) {
  if (typeof e != "object" || !("image" in e) && !("image_url" in e) && !("image_data" in e))
    throw new Jz({ data: e });
  return e.image || e.image_url || e.image_data;
}
async function oB({ gatewayUrls: e, uri: t }) {
  try {
    const r = await fetch(t).then((l) => l.json());
    return await c3({
      gatewayUrls: e,
      uri: XA(r)
    });
  } catch {
    throw new l3({ uri: t });
  }
}
async function c3({ gatewayUrls: e, uri: t }) {
  const { uri: r, isOnChain: o } = QA({ uri: t, gatewayUrls: e });
  if (o || await iB(r))
    return r;
  throw new l3({ uri: t });
}
function sB(e) {
  let t = e;
  t.startsWith("did:nft:") && (t = t.replace("did:nft:", "").replace(/_/g, "/"));
  const [r, o, l] = t.split("/"), [d, f] = r.split(":"), [m, v] = o.split(":");
  if (!d || d.toLowerCase() !== "eip155")
    throw new Gv({ reason: "Only EIP-155 supported" });
  if (!f)
    throw new Gv({ reason: "Chain ID not found" });
  if (!v)
    throw new Gv({
      reason: "Contract address not found"
    });
  if (!l)
    throw new Gv({ reason: "Token ID not found" });
  if (!m)
    throw new Gv({ reason: "ERC namespace not found" });
  return {
    chainID: parseInt(f),
    namespace: m.toLowerCase(),
    contractAddress: v,
    tokenID: l
  };
}
async function uB(e, { nft: t }) {
  if (t.namespace === "erc721")
    return Ts(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(t.tokenID)]
    });
  if (t.namespace === "erc1155")
    return Ts(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(t.tokenID)]
    });
  throw new eB({ namespace: t.namespace });
}
async function lB(e, { gatewayUrls: t, record: r }) {
  return /eip155:/i.test(r) ? cB(e, { gatewayUrls: t, record: r }) : c3({ uri: r, gatewayUrls: t });
}
async function cB(e, { gatewayUrls: t, record: r }) {
  const o = sB(r), l = await uB(e, { nft: o }), { uri: d, isOnChain: f, isEncoded: m } = QA({ uri: l, gatewayUrls: t });
  if (f && (d.includes("data:application/json;base64,") || d.startsWith("{"))) {
    const w = m ? (
      // if it is encoded, decode it
      atob(d.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      d
    ), x = JSON.parse(w);
    return c3({ uri: XA(x), gatewayUrls: t });
  }
  let v = o.tokenID;
  return o.namespace === "erc1155" && (v = v.replace("0x", "").padStart(64, "0")), oB({
    gatewayUrls: t,
    uri: d.replace(/(?:0x)?{id}/, v)
  });
}
async function JA(e, { blockNumber: t, blockTag: r, name: o, key: l, gatewayUrls: d, strict: f, universalResolverAddress: m }) {
  let v = m;
  if (!v) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    v = Tm({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const w = {
      address: v,
      abi: AA,
      functionName: "resolve",
      args: [
        St(cx(o)),
        di({
          abi: oP,
          functionName: "text",
          args: [E1(o), l]
        })
      ],
      blockNumber: t,
      blockTag: r
    }, x = Ke(e, Ts, "readContract"), b = d ? await x({
      ...w,
      args: [...w.args, d]
    }) : await x(w);
    if (b[0] === "0x")
      return null;
    const k = Cm({
      abi: oP,
      functionName: "text",
      data: b[0]
    });
    return k === "" ? null : k;
  } catch (w) {
    if (f)
      throw w;
    if (u3(w, "resolve"))
      return null;
    throw w;
  }
}
async function dB(e, { blockNumber: t, blockTag: r, assetGatewayUrls: o, name: l, gatewayUrls: d, strict: f, universalResolverAddress: m }) {
  const v = await Ke(e, JA, "getEnsText")({
    blockNumber: t,
    blockTag: r,
    key: "avatar",
    name: l,
    universalResolverAddress: m,
    gatewayUrls: d,
    strict: f
  });
  if (!v)
    return null;
  try {
    return await lB(e, {
      record: v,
      gatewayUrls: o
    });
  } catch {
    return null;
  }
}
async function fB(e, { address: t, blockNumber: r, blockTag: o, gatewayUrls: l, strict: d, universalResolverAddress: f }) {
  let m = f;
  if (!m) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    m = Tm({
      blockNumber: r,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const v = `${t.toLowerCase().substring(2)}.addr.reverse`;
  try {
    const w = {
      address: m,
      abi: MF,
      functionName: "reverse",
      args: [St(cx(v))],
      blockNumber: r,
      blockTag: o
    }, x = Ke(e, Ts, "readContract"), [b, k] = l ? await x({
      ...w,
      args: [...w.args, l]
    }) : await x(w);
    return t.toLowerCase() !== k.toLowerCase() ? null : b;
  } catch (w) {
    if (d)
      throw w;
    if (u3(w, "reverse"))
      return null;
    throw w;
  }
}
async function pB(e, { blockNumber: t, blockTag: r, name: o, universalResolverAddress: l }) {
  let d = l;
  if (!d) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    d = Tm({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const [f] = await Ke(e, Ts, "readContract")({
    address: d,
    abi: [
      {
        inputs: [{ type: "bytes" }],
        name: "findResolver",
        outputs: [{ type: "address" }, { type: "bytes32" }],
        stateMutability: "view",
        type: "function"
      }
    ],
    functionName: "findResolver",
    args: [St(cx(o))],
    blockNumber: t,
    blockTag: r
  });
  return f;
}
function fx(e, { method: t }) {
  var o, l;
  const r = {};
  return e.transport.type === "fallback" && ((l = (o = e.transport).onResponse) == null || l.call(o, ({ method: d, response: f, status: m, transport: v }) => {
    m === "success" && t === d && (r[f] = v.request);
  })), (d) => r[d] || e.request;
}
async function hB(e) {
  const t = fx(e, {
    method: "eth_newBlockFilter"
  }), r = await e.request({
    method: "eth_newBlockFilter"
  });
  return { id: r, request: t(r), type: "block" };
}
class mB extends we {
  constructor(t) {
    super(`Filter type "${t}" is not supported.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FilterTypeNotSupportedError"
    });
  }
}
const hP = "/docs/contract/encodeEventTopics";
function o0(e) {
  var v;
  const { abi: t, eventName: r, args: o } = e;
  let l = t[0];
  if (r) {
    const w = i0({ abi: t, name: r });
    if (!w)
      throw new XO(r, { docsPath: hP });
    l = w;
  }
  if (l.type !== "event")
    throw new XO(void 0, { docsPath: hP });
  const d = Ll(l), f = a3(d);
  let m = [];
  if (o && "inputs" in l) {
    const w = (v = l.inputs) == null ? void 0 : v.filter((b) => "indexed" in b && b.indexed), x = Array.isArray(o) ? o : Object.values(o).length > 0 ? (w == null ? void 0 : w.map((b) => o[b.name])) ?? [] : [];
    x.length > 0 && (m = (w == null ? void 0 : w.map((b, k) => Array.isArray(x[k]) ? x[k].map((T, O) => mP({ param: b, value: x[k][O] })) : x[k] ? mP({ param: b, value: x[k] }) : null)) ?? []);
  }
  return [f, ...m];
}
function mP({ param: e, value: t }) {
  if (e.type === "string" || e.type === "bytes")
    return Nn(Dl(t));
  if (e.type === "tuple" || e.type.match(/^(.*)\[(\d+)?\]$/))
    throw new mB(e.type);
  return ro([e], [t]);
}
async function eD(e, t) {
  const { address: r, abi: o, args: l, eventName: d, fromBlock: f, strict: m, toBlock: v } = t, w = fx(e, {
    method: "eth_newFilter"
  }), x = d ? o0({
    abi: o,
    args: l,
    eventName: d
  }) : void 0, b = await e.request({
    method: "eth_newFilter",
    params: [
      {
        address: r,
        fromBlock: typeof f == "bigint" ? Bt(f) : f,
        toBlock: typeof v == "bigint" ? Bt(v) : v,
        topics: x
      }
    ]
  });
  return {
    abi: o,
    args: l,
    eventName: d,
    id: b,
    request: w(b),
    strict: !!m,
    type: "event"
  };
}
async function tD(e, { address: t, args: r, event: o, events: l, fromBlock: d, strict: f, toBlock: m } = {}) {
  const v = l ?? (o ? [o] : void 0), w = fx(e, {
    method: "eth_newFilter"
  });
  let x = [];
  v && (x = [
    v.flatMap((k) => o0({
      abi: [k],
      eventName: k.name,
      args: r
    }))
  ], o && (x = x[0]));
  const b = await e.request({
    method: "eth_newFilter",
    params: [
      {
        address: t,
        fromBlock: typeof d == "bigint" ? Bt(d) : d,
        toBlock: typeof m == "bigint" ? Bt(m) : m,
        ...x.length ? { topics: x } : {}
      }
    ]
  });
  return {
    abi: v,
    args: r,
    eventName: o ? o.name : void 0,
    fromBlock: d,
    id: b,
    request: w(b),
    strict: !!f,
    toBlock: m,
    type: "event"
  };
}
async function nD(e) {
  const t = fx(e, {
    method: "eth_newPendingTransactionFilter"
  }), r = await e.request({
    method: "eth_newPendingTransactionFilter"
  });
  return { id: r, request: t(r), type: "transaction" };
}
async function yB(e, t) {
  const { abi: r, address: o, args: l, functionName: d, ...f } = t, m = di({
    abi: r,
    args: l,
    functionName: d
  });
  try {
    return await Ke(e, QT, "estimateGas")({
      data: m,
      to: o,
      ...f
    });
  } catch (v) {
    const w = f.account ? fi(f.account) : void 0;
    throw xg(v, {
      abi: r,
      address: o,
      args: l,
      docsPath: "/docs/contract/estimateContractGas",
      functionName: d,
      sender: w == null ? void 0 : w.address
    });
  }
}
async function rD(e, { address: t, blockNumber: r, blockTag: o = "latest" }) {
  const l = r ? Bt(r) : void 0, d = await e.request({
    method: "eth_getBalance",
    params: [t, l || o]
  });
  return BigInt(d);
}
async function vB(e) {
  const t = await e.request({
    method: "eth_blobBaseFee"
  });
  return BigInt(t);
}
const gB = /* @__PURE__ */ new Map(), bB = /* @__PURE__ */ new Map();
function wB(e) {
  const t = (l, d) => ({
    clear: () => d.delete(l),
    get: () => d.get(l),
    set: (f) => d.set(l, f)
  }), r = t(e, gB), o = t(e, bB);
  return {
    clear: () => {
      r.clear(), o.clear();
    },
    promise: r,
    response: o
  };
}
async function xB(e, { cacheKey: t, cacheTime: r = 1 / 0 }) {
  const o = wB(t), l = o.response.get();
  if (l && r > 0 && (/* @__PURE__ */ new Date()).getTime() - l.created.getTime() < r)
    return l.data;
  let d = o.promise.get();
  d || (d = e(), o.promise.set(d));
  try {
    const f = await d;
    return o.response.set({ created: /* @__PURE__ */ new Date(), data: f }), f;
  } finally {
    o.promise.clear();
  }
}
const SB = (e) => `blockNumber.${e}`;
async function s0(e, { cacheTime: t = e.cacheTime } = {}) {
  const r = await xB(() => e.request({
    method: "eth_blockNumber"
  }), { cacheKey: SB(e.uid), cacheTime: t });
  return BigInt(r);
}
async function kB(e, { blockHash: t, blockNumber: r, blockTag: o = "latest" } = {}) {
  const l = r !== void 0 ? Bt(r) : void 0;
  let d;
  return t ? d = await e.request({
    method: "eth_getBlockTransactionCountByHash",
    params: [t]
  }) : d = await e.request({
    method: "eth_getBlockTransactionCountByNumber",
    params: [l || o]
  }), $l(d);
}
async function aD(e, { address: t, blockNumber: r, blockTag: o = "latest" }) {
  const l = r !== void 0 ? Bt(r) : void 0, d = await e.request({
    method: "eth_getCode",
    params: [t, l || o]
  });
  if (d !== "0x")
    return d;
}
const yP = "/docs/contract/decodeEventLog";
function d3(e) {
  const { abi: t, data: r, strict: o, topics: l } = e, d = o ?? !0, [f, ...m] = l;
  if (!f)
    throw new pN({ docsPath: yP });
  const v = t.find((R) => R.type === "event" && f === a3(Ll(R)));
  if (!(v && "name" in v) || v.type !== "event")
    throw new tA(f, { docsPath: yP });
  const { name: w, inputs: x } = v, b = x == null ? void 0 : x.some((R) => !("name" in R && R.name));
  let k = b ? [] : {};
  const T = x.filter((R) => "indexed" in R && R.indexed);
  for (let R = 0; R < T.length; R++) {
    const j = T[R], I = m[R];
    if (!I)
      throw new nx({
        abiItem: v,
        param: j
      });
    k[b ? R : j.name || R] = EB({ param: j, value: I });
  }
  const O = x.filter((R) => !("indexed" in R && R.indexed));
  if (O.length > 0) {
    if (r && r !== "0x")
      try {
        const R = lx(O, r);
        if (R)
          if (b)
            k = [...k, ...R];
          else
            for (let j = 0; j < O.length; j++)
              k[O[j].name] = R[j];
      } catch (R) {
        if (d)
          throw R instanceof Jj || R instanceof _A ? new rg({
            abiItem: v,
            data: r,
            params: O,
            size: Cr(r)
          }) : R;
      }
    else if (d)
      throw new rg({
        abiItem: v,
        data: "0x",
        params: O,
        size: 0
      });
  }
  return {
    eventName: w,
    args: Object.values(k).length > 0 ? k : void 0
  };
}
function EB({ param: e, value: t }) {
  return e.type === "string" || e.type === "bytes" || e.type === "tuple" || e.type.match(/^(.*)\[(\d+)?\]$/) ? t : (lx([e], t) || [])[0];
}
async function iD(e, t) {
  const { abi: r, address: o, args: l, dataSuffix: d, functionName: f, ...m } = t, v = m.account ? fi(m.account) : e.account, w = di({ abi: r, args: l, functionName: f });
  try {
    const { data: x } = await Ke(e, dx, "call")({
      batch: !1,
      data: `${w}${d ? d.replace("0x", "") : ""}`,
      to: o,
      ...m,
      account: v
    }), b = Cm({
      abi: r,
      args: l,
      functionName: f,
      data: x || "0x"
    }), k = r.filter((T) => "name" in T && T.name === t.functionName);
    return {
      result: b,
      request: {
        abi: k,
        address: o,
        args: l,
        dataSuffix: d,
        functionName: f,
        ...m,
        account: v
      }
    };
  } catch (x) {
    throw xg(x, {
      abi: r,
      address: o,
      args: l,
      docsPath: "/docs/contract/simulateContract",
      functionName: f,
      sender: v == null ? void 0 : v.address
    });
  }
}
function pd(e, { args: t, eventName: r } = {}) {
  return {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    logIndex: e.logIndex ? Number(e.logIndex) : null,
    transactionHash: e.transactionHash ? e.transactionHash : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    ...r ? { args: t, eventName: r } : {}
  };
}
const bE = /* @__PURE__ */ new Map(), vP = /* @__PURE__ */ new Map();
let CB = 0;
function hd(e, t, r) {
  const o = ++CB, l = () => bE.get(e) || [], d = () => {
    const x = l();
    bE.set(e, x.filter((b) => b.id !== o));
  }, f = () => {
    const x = vP.get(e);
    l().length === 1 && x && x(), d();
  }, m = l();
  if (bE.set(e, [
    ...m,
    { id: o, fns: t }
  ]), m && m.length > 0)
    return f;
  const v = {};
  for (const x in t)
    v[x] = (...b) => {
      var T, O;
      const k = l();
      if (k.length !== 0)
        for (const R of k)
          (O = (T = R.fns)[x]) == null || O.call(T, ...b);
    };
  const w = r(v);
  return typeof w == "function" && vP.set(e, w), f;
}
async function wC(e) {
  return new Promise((t) => setTimeout(t, e));
}
function u0(e, { emitOnBegin: t, initialWaitTime: r, interval: o }) {
  let l = !0;
  const d = () => l = !1;
  return (async () => {
    let m;
    t && (m = await e({ unpoll: d }));
    const v = await (r == null ? void 0 : r(m)) ?? o;
    await wC(v);
    const w = async () => {
      l && (await e({ unpoll: d }), await wC(o), w());
    };
    w();
  })(), d;
}
async function px(e, { filter: t }) {
  const r = "strict" in t && t.strict, o = await t.request({
    method: "eth_getFilterChanges",
    params: [t.id]
  });
  if (typeof o[0] == "string")
    return o;
  const l = o.map((d) => pd(d));
  return !("abi" in t) || !t.abi ? l : x3({
    abi: t.abi,
    logs: l,
    strict: r
  });
}
async function hx(e, { filter: t }) {
  return t.request({
    method: "eth_uninstallFilter",
    params: [t.id]
  });
}
function TB(e, t) {
  const { abi: r, address: o, args: l, batch: d = !0, eventName: f, fromBlock: m, onError: v, onLogs: w, poll: x, pollingInterval: b = e.pollingInterval, strict: k } = t;
  return (typeof x < "u" ? x : e.transport.type !== "webSocket" || typeof m == "number") ? (() => {
    const j = k ?? !1, I = sa([
      "watchContractEvent",
      o,
      l,
      d,
      e.uid,
      f,
      b,
      j,
      m
    ]);
    return hd(I, { onLogs: w, onError: v }, (N) => {
      let L;
      m !== void 0 && (L = m - 1n);
      let B, H = !1;
      const V = u0(async () => {
        var W;
        if (!H) {
          try {
            B = await Ke(e, eD, "createContractEventFilter")({
              abi: r,
              address: o,
              args: l,
              eventName: f,
              strict: j,
              fromBlock: m
            });
          } catch {
          }
          H = !0;
          return;
        }
        try {
          let Y;
          if (B)
            Y = await Ke(e, px, "getFilterChanges")({ filter: B });
          else {
            const ce = await Ke(e, s0, "getBlockNumber")({});
            L && L !== ce ? Y = await Ke(e, $D, "getContractEvents")({
              abi: r,
              address: o,
              args: l,
              eventName: f,
              fromBlock: L + 1n,
              toBlock: ce,
              strict: j
            }) : Y = [], L = ce;
          }
          if (Y.length === 0)
            return;
          if (d)
            N.onLogs(Y);
          else
            for (const ce of Y)
              N.onLogs([ce]);
        } catch (Y) {
          B && Y instanceof Zf && (H = !1), (W = N.onError) == null || W.call(N, Y);
        }
      }, {
        emitOnBegin: !0,
        interval: b
      });
      return async () => {
        B && await Ke(e, hx, "uninstallFilter")({ filter: B }), V();
      };
    });
  })() : (() => {
    const j = k ?? !1, I = sa([
      "watchContractEvent",
      o,
      l,
      d,
      e.uid,
      f,
      b,
      j
    ]);
    let N = !0, L = () => N = !1;
    return hd(I, { onLogs: w, onError: v }, (B) => ((async () => {
      try {
        const H = f ? o0({
          abi: r,
          eventName: f,
          args: l
        }) : [], { unsubscribe: V } = await e.transport.subscribe({
          params: ["logs", { address: o, topics: H }],
          onData(W) {
            var ce;
            if (!N)
              return;
            const Y = W.result;
            try {
              const { eventName: ve, args: Se } = d3({
                abi: r,
                data: Y.data,
                topics: Y.topics,
                strict: k
              }), De = pd(Y, {
                args: Se,
                eventName: ve
              });
              B.onLogs([De]);
            } catch (ve) {
              let Se, De;
              if (ve instanceof rg || ve instanceof nx) {
                if (k)
                  return;
                Se = ve.abiItem.name, De = (ce = ve.abiItem.inputs) == null ? void 0 : ce.some((Pe) => !("name" in Pe && Pe.name));
              }
              const Re = pd(Y, {
                args: De ? [] : {},
                eventName: Se
              });
              B.onLogs([Re]);
            }
          },
          onError(W) {
            var Y;
            (Y = B.onError) == null || Y.call(B, W);
          }
        });
        L = V, N || L();
      } catch (H) {
        v == null || v(H);
      }
    })(), () => L()));
  })();
}
async function xC(e, t) {
  const { abi: r, address: o, args: l, dataSuffix: d, functionName: f, ...m } = t, v = di({
    abi: r,
    args: l,
    functionName: f
  });
  return Ke(e, r3, "sendTransaction")({
    data: `${v}${d ? d.replace("0x", "") : ""}`,
    to: o,
    ...m
  });
}
function _B(e) {
  const t = Nn(`0x${e.substring(4)}`).substring(26);
  return t0(`0x${t}`);
}
const SC = 256;
let h1 = SC, m1;
function RB(e = 11) {
  if (!m1 || h1 + e > SC * 2) {
    m1 = "", h1 = 0;
    for (let t = 0; t < SC; t++)
      m1 += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return m1.substring(h1, h1++ + e);
}
function A1(e) {
  const { batch: t, cacheTime: r = e.pollingInterval ?? 4e3, ccipRead: o, key: l = "base", name: d = "Base Client", pollingInterval: f = 4e3, type: m = "base" } = e, v = e.chain, w = e.account ? fi(e.account) : void 0, { config: x, request: b, value: k } = e.transport({
    chain: v,
    pollingInterval: f
  }), T = { ...x, ...k }, O = {
    account: w,
    batch: t,
    cacheTime: r,
    ccipRead: o,
    chain: v,
    key: l,
    name: d,
    pollingInterval: f,
    request: b,
    transport: T,
    type: m,
    uid: RB()
  };
  function R(j) {
    return (I) => {
      const N = I(j);
      for (const B in O)
        delete N[B];
      const L = { ...j, ...N };
      return Object.assign(L, { extend: R(L) });
    };
  }
  return Object.assign(O, { extend: R(O) });
}
function kC(e, { delay: t = 100, retryCount: r = 2, shouldRetry: o = () => !0 } = {}) {
  return new Promise((l, d) => {
    const f = async ({ count: m = 0 } = {}) => {
      const v = async ({ error: w }) => {
        const x = typeof t == "function" ? t({ count: m, error: w }) : t;
        x && await wC(x), f({ count: m + 1 });
      };
      try {
        const w = await e();
        l(w);
      } catch (w) {
        if (m < r && await o({ count: m, error: w }))
          return v({ error: w });
        d(w);
      }
    };
    f();
  });
}
function OB(e, t = {}) {
  return async (r, o = {}) => {
    const { retryDelay: l = 150, retryCount: d = 3 } = {
      ...t,
      ...o
    };
    return kC(async () => {
      try {
        return await e(r);
      } catch (f) {
        const m = f;
        switch (m.code) {
          case ig.code:
            throw new ig(m);
          case og.code:
            throw new og(m);
          case sg.code:
            throw new sg(m);
          case ug.code:
            throw new ug(m);
          case Yf.code:
            throw new Yf(m);
          case Zf.code:
            throw new Zf(m);
          case lg.code:
            throw new lg(m);
          case cg.code:
            throw new cg(m);
          case dg.code:
            throw new dg(m);
          case fg.code:
            throw new fg(m);
          case pm.code:
            throw new pm(m);
          case pg.code:
            throw new pg(m);
          case Kh.code:
            throw new Kh(m);
          case hg.code:
            throw new hg(m);
          case mg.code:
            throw new mg(m);
          case yg.code:
            throw new yg(m);
          case vg.code:
            throw new vg(m);
          case gg.code:
            throw new gg(m);
          case 5e3:
            throw new Kh(m);
          default:
            throw f instanceof we ? f : new fF(m);
        }
      }
    }, {
      delay: ({ count: f, error: m }) => {
        var v;
        if (m && m instanceof ng) {
          const w = (v = m == null ? void 0 : m.headers) == null ? void 0 : v.get("Retry-After");
          if (w != null && w.match(/\d/))
            return parseInt(w) * 1e3;
        }
        return ~~(1 << f) * l;
      },
      retryCount: d,
      shouldRetry: ({ error: f }) => PB(f)
    });
  };
}
function PB(e) {
  return "code" in e && typeof e.code == "number" ? e.code === -1 || e.code === pm.code || e.code === Yf.code : e instanceof ng && e.status ? e.status === 403 || e.status === 408 || e.status === 413 || e.status === 429 || e.status === 500 || e.status === 502 || e.status === 503 || e.status === 504 : !0;
}
function oD({ key: e, name: t, request: r, retryCount: o = 3, retryDelay: l = 150, timeout: d, type: f }, m) {
  return {
    config: { key: e, name: t, request: r, retryCount: o, retryDelay: l, timeout: d, type: f },
    request: OB(r, { retryCount: o, retryDelay: l }),
    value: m
  };
}
function jB(e, t = {}) {
  const { key: r = "custom", name: o = "Custom Provider", retryDelay: l } = t;
  return ({ retryCount: d }) => oD({
    key: r,
    name: o,
    request: e.request.bind(e),
    retryCount: t.retryCount ?? d,
    retryDelay: l,
    type: "custom"
  });
}
class AB extends we {
  constructor() {
    super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
      docsPath: "/docs/clients/intro"
    });
  }
}
function DB(e, { errorInstance: t = new Error("timed out"), timeout: r, signal: o }) {
  return new Promise((l, d) => {
    (async () => {
      let f;
      try {
        const m = new AbortController();
        r > 0 && (f = setTimeout(() => {
          o ? m.abort() : d(t);
        }, r)), l(await e({ signal: (m == null ? void 0 : m.signal) || null }));
      } catch (m) {
        m.name === "AbortError" && d(t), d(m);
      } finally {
        clearTimeout(f);
      }
    })();
  });
}
function IB() {
  return {
    current: 0,
    take() {
      return this.current++;
    },
    reset() {
      this.current = 0;
    }
  };
}
const gP = /* @__PURE__ */ IB();
function MB(e, t = {}) {
  return {
    async request(r) {
      var b;
      const { body: o, fetchOptions: l = {}, onRequest: d = t.onRequest, onResponse: f = t.onResponse, timeout: m = t.timeout ?? 1e4 } = r, { headers: v, method: w, signal: x } = { ...t.fetchOptions, ...l };
      try {
        const k = await DB(async ({ signal: O }) => {
          const R = {
            ...l,
            body: Array.isArray(o) ? sa(o.map((N) => ({
              jsonrpc: "2.0",
              id: N.id ?? gP.take(),
              ...N
            }))) : sa({
              jsonrpc: "2.0",
              id: o.id ?? gP.take(),
              ...o
            }),
            headers: {
              ...v,
              "Content-Type": "application/json"
            },
            method: w || "POST",
            signal: x || (m > 0 ? O : null)
          }, j = new Request(e, R);
          return d && await d(j), await fetch(e, R);
        }, {
          errorInstance: new nP({ body: o, url: e }),
          timeout: m,
          signal: !0
        });
        f && await f(k);
        let T;
        if ((b = k.headers.get("Content-Type")) != null && b.startsWith("application/json") ? T = await k.json() : T = await k.text(), !k.ok)
          throw new ng({
            body: o,
            details: sa(T.error) || k.statusText,
            headers: k.headers,
            status: k.status,
            url: e
          });
        return T;
      } catch (k) {
        throw k instanceof ng || k instanceof nP ? k : new ng({
          body: o,
          details: k.message,
          url: e
        });
      }
    }
  };
}
function sD(e, t = {}) {
  const { batch: r, fetchOptions: o, key: l = "http", name: d = "HTTP JSON-RPC", onFetchRequest: f, onFetchResponse: m, retryDelay: v } = t;
  return ({ chain: w, retryCount: x, timeout: b }) => {
    const { batchSize: k = 1e3, wait: T = 0 } = typeof r == "object" ? r : {}, O = t.retryCount ?? x, R = b ?? t.timeout ?? 1e4, j = e || (w == null ? void 0 : w.rpcUrls.default.http[0]);
    if (!j)
      throw new AB();
    const I = MB(j, {
      fetchOptions: o,
      onRequest: f,
      onResponse: m,
      timeout: R
    });
    return oD({
      key: l,
      name: d,
      async request({ method: N, params: L }) {
        const B = { method: N, params: L }, { schedule: H } = KA({
          id: `${e}`,
          wait: T,
          shouldSplitBatch(ce) {
            return ce.length > k;
          },
          fn: (ce) => I.request({
            body: ce
          }),
          sort: (ce, ve) => ce.id - ve.id
        }), V = async (ce) => r ? H(ce) : [
          await I.request({
            body: ce
          })
        ], [{ error: W, result: Y }] = await V(B);
        if (W)
          throw new yA({
            body: B,
            error: W,
            url: j
          });
        return Y;
      },
      retryCount: O,
      retryDelay: v,
      timeout: R,
      type: "http"
    }, {
      fetchOptions: o,
      url: j
    });
  };
}
function $B(e) {
  var t;
  return {
    baseFeePerGas: e.baseFeePerGas.map((r) => BigInt(r)),
    gasUsedRatio: e.gasUsedRatio,
    oldestBlock: BigInt(e.oldestBlock),
    reward: (t = e.reward) == null ? void 0 : t.map((r) => r.map((o) => BigInt(o)))
  };
}
async function LB(e, { blockCount: t, blockNumber: r, blockTag: o = "latest", rewardPercentiles: l }) {
  const d = r ? Bt(r) : void 0, f = await e.request({
    method: "eth_feeHistory",
    params: [
      Bt(t),
      d || o,
      l
    ]
  });
  return $B(f);
}
async function NB(e, { filter: t }) {
  const r = t.strict ?? !1, l = (await t.request({
    method: "eth_getFilterLogs",
    params: [t.id]
  })).map((d) => pd(d));
  return t.abi ? x3({
    abi: t.abi,
    logs: l,
    strict: r
  }) : l;
}
const FB = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, zB = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function uD(e) {
  const { domain: t = {}, message: r, primaryType: o } = e, l = {
    EIP712Domain: p3({ domain: t }),
    ...e.types
  };
  f3({
    domain: t,
    message: r,
    primaryType: o,
    types: l
  });
  const d = ["0x1901"];
  return t && d.push(BB({
    domain: t,
    types: l
  })), o !== "EIP712Domain" && d.push(lD({
    data: r,
    primaryType: o,
    types: l
  })), Nn(ia(d));
}
function BB({ domain: e, types: t }) {
  return lD({
    data: e,
    primaryType: "EIP712Domain",
    types: t
  });
}
function lD({ data: e, primaryType: t, types: r }) {
  const o = cD({
    data: e,
    primaryType: t,
    types: r
  });
  return Nn(o);
}
function cD({ data: e, primaryType: t, types: r }) {
  const o = [{ type: "bytes32" }], l = [UB({ primaryType: t, types: r })];
  for (const d of r[t]) {
    const [f, m] = fD({
      types: r,
      name: d.name,
      type: d.type,
      value: e[d.name]
    });
    o.push(f), l.push(m);
  }
  return ro(o, l);
}
function UB({ primaryType: e, types: t }) {
  const r = St(HB({ primaryType: e, types: t }));
  return Nn(r);
}
function HB({ primaryType: e, types: t }) {
  let r = "";
  const o = dD({ primaryType: e, types: t });
  o.delete(e);
  const l = [e, ...Array.from(o).sort()];
  for (const d of l)
    r += `${d}(${t[d].map(({ name: f, type: m }) => `${m} ${f}`).join(",")})`;
  return r;
}
function dD({ primaryType: e, types: t }, r = /* @__PURE__ */ new Set()) {
  const o = e.match(/^\w*/u), l = o == null ? void 0 : o[0];
  if (r.has(l) || t[l] === void 0)
    return r;
  r.add(l);
  for (const d of t[l])
    dD({ primaryType: d.type, types: t }, r);
  return r;
}
function fD({ types: e, name: t, type: r, value: o }) {
  if (e[r] !== void 0)
    return [
      { type: "bytes32" },
      Nn(cD({ data: o, primaryType: r, types: e }))
    ];
  if (r === "bytes")
    return o = `0x${(o.length % 2 ? "0" : "") + o.slice(2)}`, [{ type: "bytes32" }, Nn(o)];
  if (r === "string")
    return [{ type: "bytes32" }, Nn(St(o))];
  if (r.lastIndexOf("]") === r.length - 1) {
    const l = r.slice(0, r.lastIndexOf("[")), d = o.map((f) => fD({
      name: t,
      type: l,
      types: e,
      value: f
    }));
    return [
      { type: "bytes32" },
      Nn(ro(d.map(([f]) => f), d.map(([, f]) => f)))
    ];
  }
  return [{ type: r }, o];
}
function f3(e) {
  const { domain: t, message: r, primaryType: o, types: l } = e, d = (f, m) => {
    for (const v of f) {
      const { name: w, type: x } = v, b = m[w], k = x.match(zB);
      if (k && (typeof b == "number" || typeof b == "bigint")) {
        const [R, j, I] = k;
        Bt(b, {
          signed: j === "int",
          size: parseInt(I) / 8
        });
      }
      if (x === "address" && typeof b == "string" && !Va(b))
        throw new Lo({ address: b });
      const T = x.match(FB);
      if (T) {
        const [R, j] = T;
        if (j && Cr(b) !== parseInt(j))
          throw new yN({
            expectedSize: parseInt(j),
            givenSize: Cr(b)
          });
      }
      const O = l[x];
      O && d(O, b);
    }
  };
  if (l.EIP712Domain && t && d(l.EIP712Domain, t), o !== "EIP712Domain") {
    const f = l[o];
    d(f, r);
  }
}
function p3({ domain: e }) {
  return [
    typeof (e == null ? void 0 : e.name) == "string" && { name: "name", type: "string" },
    (e == null ? void 0 : e.version) && { name: "version", type: "string" },
    typeof (e == null ? void 0 : e.chainId) == "number" && {
      name: "chainId",
      type: "uint256"
    },
    (e == null ? void 0 : e.verifyingContract) && {
      name: "verifyingContract",
      type: "address"
    },
    (e == null ? void 0 : e.salt) && { name: "salt", type: "bytes32" }
  ].filter(Boolean);
}
function Sg(e, t = "hex") {
  const r = pD(e), o = t3(new Uint8Array(r.length));
  return r.encode(o), t === "hex" ? ua(o.bytes) : o.bytes;
}
function pD(e) {
  return Array.isArray(e) ? VB(e.map((t) => pD(t))) : GB(e);
}
function VB(e) {
  const t = e.reduce((l, d) => l + d.length, 0), r = hD(t);
  return {
    length: (() => t <= 55 ? 1 + t : 1 + r + t)(),
    encode(l) {
      t <= 55 ? l.pushByte(192 + t) : (l.pushByte(192 + 55 + r), r === 1 ? l.pushUint8(t) : r === 2 ? l.pushUint16(t) : r === 3 ? l.pushUint24(t) : l.pushUint32(t));
      for (const { encode: d } of e)
        d(l);
    }
  };
}
function GB(e) {
  const t = typeof e == "string" ? Il(e) : e, r = hD(t.length);
  return {
    length: (() => t.length === 1 && t[0] < 128 ? 1 : t.length <= 55 ? 1 + t.length : 1 + r + t.length)(),
    encode(l) {
      t.length === 1 && t[0] < 128 ? l.pushBytes(t) : t.length <= 55 ? (l.pushByte(128 + t.length), l.pushBytes(t)) : (l.pushByte(128 + 55 + r), r === 1 ? l.pushUint8(t.length) : r === 2 ? l.pushUint16(t.length) : r === 3 ? l.pushUint24(t.length) : l.pushUint32(t.length), l.pushBytes(t));
    }
  };
}
function hD(e) {
  if (e < 2 ** 8)
    return 1;
  if (e < 2 ** 16)
    return 2;
  if (e < 2 ** 24)
    return 3;
  if (e < 2 ** 32)
    return 4;
  throw new we("Length is too large.");
}
const qB = {
  "0x0": "reverted",
  "0x1": "success"
};
function mD(e) {
  const t = {
    ...e,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    contractAddress: e.contractAddress ? e.contractAddress : null,
    cumulativeGasUsed: e.cumulativeGasUsed ? BigInt(e.cumulativeGasUsed) : null,
    effectiveGasPrice: e.effectiveGasPrice ? BigInt(e.effectiveGasPrice) : null,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : null,
    logs: e.logs ? e.logs.map((r) => pd(r)) : null,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? $l(e.transactionIndex) : null,
    status: e.status ? qB[e.status] : null,
    type: e.type ? gA[e.type] || e.type : null
  };
  return e.blobGasPrice && (t.blobGasPrice = BigInt(e.blobGasPrice)), e.blobGasUsed && (t.blobGasUsed = BigInt(e.blobGasUsed)), t;
}
const cX = /* @__PURE__ */ sx("transactionReceipt", mD), WB = `Ethereum Signed Message:
`;
function yD(e, t) {
  const r = (() => typeof e == "string" ? Pl(e) : e.raw instanceof Uint8Array ? e.raw : Dl(e.raw))(), o = Pl(`${WB}${r.length}`);
  return Nn(ia([o, r]), t);
}
function YB(e) {
  const { blobVersionedHashes: t } = e;
  if (t) {
    if (t.length === 0)
      throw new TA();
    for (const r of t) {
      const o = Cr(r), l = $l(fm(r, 0, 1));
      if (o !== 32)
        throw new OF({ hash: r, size: o });
      if (l !== CA)
        throw new PF({
          hash: r,
          version: l
        });
    }
  }
  vD(e);
}
function vD(e) {
  const { chainId: t, maxPriorityFeePerGas: r, maxFeePerGas: o, to: l } = e;
  if (t <= 0)
    throw new HT({ chainId: t });
  if (l && !Va(l))
    throw new Lo({ address: l });
  if (o && o > 2n ** 256n - 1n)
    throw new Wf({ maxFeePerGas: o });
  if (r && o && r > o)
    throw new ag({ maxFeePerGas: o, maxPriorityFeePerGas: r });
}
function ZB(e) {
  const { chainId: t, maxPriorityFeePerGas: r, gasPrice: o, maxFeePerGas: l, to: d } = e;
  if (t <= 0)
    throw new HT({ chainId: t });
  if (d && !Va(d))
    throw new Lo({ address: d });
  if (r || l)
    throw new we("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (o && o > 2n ** 256n - 1n)
    throw new Wf({ maxFeePerGas: o });
}
function KB(e) {
  const { chainId: t, maxPriorityFeePerGas: r, gasPrice: o, maxFeePerGas: l, to: d, accessList: f } = e;
  if (d && !Va(d))
    throw new Lo({ address: d });
  if (typeof t < "u" && t <= 0)
    throw new HT({ chainId: t });
  if (r || l)
    throw new we("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (o && o > 2n ** 256n - 1n)
    throw new Wf({ maxFeePerGas: o });
  if (f)
    throw new we("`accessList` is not a valid Legacy Transaction attribute.");
}
function h3(e) {
  if (!e || e.length === 0)
    return [];
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const { address: o, storageKeys: l } = e[r];
    for (let d = 0; d < l.length; d++)
      if (l[d].length - 2 !== 64)
        throw new uF({ storageKey: l[d] });
    if (!Va(o, { strict: !1 }))
      throw new Lo({ address: o });
    t.push([o, l]);
  }
  return t;
}
function QB(e, t) {
  const r = OA(e);
  return r === "eip1559" ? JB(e, t) : r === "eip2930" ? eU(e, t) : r === "eip4844" ? XB(e, t) : tU(e, t);
}
function XB(e, t) {
  const { chainId: r, gas: o, nonce: l, to: d, value: f, maxFeePerBlobGas: m, maxFeePerGas: v, maxPriorityFeePerGas: w, accessList: x, data: b } = e;
  YB(e);
  let k = e.blobVersionedHashes, T = e.sidecars;
  if (e.blobs && (typeof k > "u" || typeof T > "u")) {
    const L = typeof e.blobs[0] == "string" ? e.blobs : e.blobs.map((V) => ua(V)), B = e.kzg, H = XT({
      blobs: L,
      kzg: B
    });
    if (typeof k > "u" && (k = SA({
      commitments: H
    })), typeof T > "u") {
      const V = JT({ blobs: L, commitments: H, kzg: B });
      T = RA({ blobs: L, commitments: H, proofs: V });
    }
  }
  const O = h3(x), R = [
    St(r),
    l ? St(l) : "0x",
    w ? St(w) : "0x",
    v ? St(v) : "0x",
    o ? St(o) : "0x",
    d ?? "0x",
    f ? St(f) : "0x",
    b ?? "0x",
    O,
    m ? St(m) : "0x",
    k ?? [],
    ...m3(e, t)
  ], j = [], I = [], N = [];
  if (T)
    for (let L = 0; L < T.length; L++) {
      const { blob: B, commitment: H, proof: V } = T[L];
      j.push(B), I.push(H), N.push(V);
    }
  return Ps([
    "0x03",
    // If sidecars are enabled, envelope turns into a "wrapper":
    Sg(T ? [R, j, I, N] : R)
  ]);
}
function JB(e, t) {
  const { chainId: r, gas: o, nonce: l, to: d, value: f, maxFeePerGas: m, maxPriorityFeePerGas: v, accessList: w, data: x } = e;
  vD(e);
  const b = h3(w), k = [
    St(r),
    l ? St(l) : "0x",
    v ? St(v) : "0x",
    m ? St(m) : "0x",
    o ? St(o) : "0x",
    d ?? "0x",
    f ? St(f) : "0x",
    x ?? "0x",
    b,
    ...m3(e, t)
  ];
  return Ps([
    "0x02",
    Sg(k)
  ]);
}
function eU(e, t) {
  const { chainId: r, gas: o, data: l, nonce: d, to: f, value: m, accessList: v, gasPrice: w } = e;
  ZB(e);
  const x = h3(v), b = [
    St(r),
    d ? St(d) : "0x",
    w ? St(w) : "0x",
    o ? St(o) : "0x",
    f ?? "0x",
    m ? St(m) : "0x",
    l ?? "0x",
    x,
    ...m3(e, t)
  ];
  return Ps([
    "0x01",
    Sg(b)
  ]);
}
function tU(e, t) {
  const { chainId: r = 0, gas: o, data: l, nonce: d, to: f, value: m, gasPrice: v } = e;
  KB(e);
  let w = [
    d ? St(d) : "0x",
    v ? St(v) : "0x",
    o ? St(o) : "0x",
    f ?? "0x",
    m ? St(m) : "0x",
    l ?? "0x"
  ];
  if (t) {
    const x = (() => {
      if (t.v >= 35n)
        return (t.v - 35n) / 2n > 0 ? t.v : 27n + (t.v === 35n ? 0n : 1n);
      if (r > 0)
        return BigInt(r * 2) + BigInt(35n + t.v - 27n);
      const b = 27n + (t.v === 27n ? 0n : 1n);
      if (t.v !== b)
        throw new oF({ v: t.v });
      return b;
    })();
    w = [
      ...w,
      St(x),
      t.r,
      t.s
    ];
  } else
    r > 0 && (w = [
      ...w,
      St(r),
      "0x",
      "0x"
    ]);
  return Sg(w);
}
function m3(e, t) {
  const { r, s: o, v: l, yParity: d } = t ?? e;
  return typeof r > "u" ? [] : typeof o > "u" ? [] : typeof l > "u" && typeof d > "u" ? [] : [(() => typeof d == "number" ? d ? St(1) : "0x" : l === 0n ? "0x" : l === 1n ? St(1) : l === 27n ? "0x" : St(1))(), ks(r), ks(o)];
}
function nU(e) {
  return e.map((t) => ({
    ...t,
    value: BigInt(t.value)
  }));
}
function rU(e) {
  return {
    ...e,
    balance: e.balance ? BigInt(e.balance) : void 0,
    nonce: e.nonce ? $l(e.nonce) : void 0,
    storageProof: e.storageProof ? nU(e.storageProof) : void 0
  };
}
async function aU(e, { address: t, blockNumber: r, blockTag: o, storageKeys: l }) {
  const d = o ?? "latest", f = r !== void 0 ? Bt(r) : void 0, m = await e.request({
    method: "eth_getProof",
    params: [t, l, f || d]
  });
  return rU(m);
}
async function iU(e, { address: t, blockNumber: r, blockTag: o = "latest", slot: l }) {
  const d = r !== void 0 ? Bt(r) : void 0;
  return await e.request({
    method: "eth_getStorageAt",
    params: [t, l, d || o]
  });
}
async function y3(e, { blockHash: t, blockNumber: r, blockTag: o, hash: l, index: d }) {
  var x, b, k;
  const f = o || "latest", m = r !== void 0 ? Bt(r) : void 0;
  let v = null;
  if (l ? v = await e.request({
    method: "eth_getTransactionByHash",
    params: [l]
  }) : t ? v = await e.request({
    method: "eth_getTransactionByBlockHashAndIndex",
    params: [t, Bt(d)]
  }) : (m || f) && (v = await e.request({
    method: "eth_getTransactionByBlockNumberAndIndex",
    params: [m || f, Bt(d)]
  })), !v)
    throw new hA({
      blockHash: t,
      blockNumber: r,
      blockTag: f,
      hash: l,
      index: d
    });
  return (((k = (b = (x = e.chain) == null ? void 0 : x.formatters) == null ? void 0 : b.transaction) == null ? void 0 : k.format) || YT)(v);
}
async function oU(e, { hash: t, transactionReceipt: r }) {
  const [o, l] = await Promise.all([
    Ke(e, s0, "getBlockNumber")({}),
    t ? Ke(e, y3, "getBlockNumber")({ hash: t }) : void 0
  ]), d = (r == null ? void 0 : r.blockNumber) || (l == null ? void 0 : l.blockNumber);
  return d ? o - d + 1n : 0n;
}
async function EC(e, { hash: t }) {
  var l, d, f;
  const r = await e.request({
    method: "eth_getTransactionReceipt",
    params: [t]
  });
  if (!r)
    throw new mA({ hash: t });
  return (((f = (d = (l = e.chain) == null ? void 0 : l.formatters) == null ? void 0 : d.transactionReceipt) == null ? void 0 : f.format) || mD)(r);
}
async function gD(e, t) {
  var j;
  const { allowFailure: r = !0, batchSize: o, blockNumber: l, blockTag: d, multicallAddress: f, stateOverride: m } = t, v = t.contracts, w = o ?? (typeof ((j = e.batch) == null ? void 0 : j.multicall) == "object" && e.batch.multicall.batchSize || 1024);
  let x = f;
  if (!x) {
    if (!e.chain)
      throw new Error("client chain not configured. multicallAddress is required.");
    x = Tm({
      blockNumber: l,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const b = [[]];
  let k = 0, T = 0;
  for (let I = 0; I < v.length; I++) {
    const { abi: N, address: L, args: B, functionName: H } = v[I];
    try {
      const V = di({ abi: N, args: B, functionName: H });
      T += (V.length - 2) / 2, // Check if batching is enabled.
      w > 0 && // Check if the current size of the batch exceeds the size limit.
      T > w && // Check if the current chunk is not already empty.
      b[k].length > 0 && (k++, T = (V.length - 2) / 2, b[k] = []), b[k] = [
        ...b[k],
        {
          allowFailure: !0,
          callData: V,
          target: L
        }
      ];
    } catch (V) {
      const W = xg(V, {
        abi: N,
        address: L,
        args: B,
        docsPath: "/docs/contract/multicall",
        functionName: H
      });
      if (!r)
        throw W;
      b[k] = [
        ...b[k],
        {
          allowFailure: !0,
          callData: "0x",
          target: L
        }
      ];
    }
  }
  const O = await Promise.allSettled(b.map((I) => Ke(e, Ts, "readContract")({
    abi: fC,
    address: x,
    args: [I],
    blockNumber: l,
    blockTag: d,
    functionName: "aggregate3",
    stateOverride: m
  }))), R = [];
  for (let I = 0; I < O.length; I++) {
    const N = O[I];
    if (N.status === "rejected") {
      if (!r)
        throw N.reason;
      for (let B = 0; B < b[I].length; B++)
        R.push({
          status: "failure",
          error: N.reason,
          result: void 0
        });
      continue;
    }
    const L = N.value;
    for (let B = 0; B < L.length; B++) {
      const { returnData: H, success: V } = L[B], { callData: W } = b[I][B], { abi: Y, address: ce, functionName: ve, args: Se } = v[R.length];
      try {
        if (W === "0x")
          throw new tx();
        if (!V)
          throw new s3({ data: H });
        const De = Cm({
          abi: Y,
          args: Se,
          data: H,
          functionName: ve
        });
        R.push(r ? { result: De, status: "success" } : De);
      } catch (De) {
        const Re = xg(De, {
          abi: Y,
          address: ce,
          args: Se,
          docsPath: "/docs/contract/multicall",
          functionName: ve
        });
        if (!r)
          throw Re;
        R.push({ error: Re, result: void 0, status: "failure" });
      }
    }
  }
  if (R.length !== v.length)
    throw new we("multicall results mismatch");
  return R;
}
const sU = "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";
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const bD = BigInt(0), mx = BigInt(1), uU = BigInt(2), yx = (e) => e instanceof Uint8Array, lU = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function hm(e) {
  if (!yx(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += lU[e[r]];
  return t;
}
function wD(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function v3(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function mm(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const r = new Uint8Array(t / 2);
  for (let o = 0; o < r.length; o++) {
    const l = o * 2, d = e.slice(l, l + 2), f = Number.parseInt(d, 16);
    if (Number.isNaN(f) || f < 0)
      throw new Error("Invalid byte sequence");
    r[o] = f;
  }
  return r;
}
function Hf(e) {
  return v3(hm(e));
}
function g3(e) {
  if (!yx(e))
    throw new Error("Uint8Array expected");
  return v3(hm(Uint8Array.from(e).reverse()));
}
function ym(e, t) {
  return mm(e.toString(16).padStart(t * 2, "0"));
}
function b3(e, t) {
  return ym(e, t).reverse();
}
function cU(e) {
  return mm(wD(e));
}
function bs(e, t, r) {
  let o;
  if (typeof t == "string")
    try {
      o = mm(t);
    } catch (d) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${d}`);
    }
  else if (yx(t))
    o = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const l = o.length;
  if (typeof r == "number" && l !== r)
    throw new Error(`${e} expected ${r} bytes, got ${l}`);
  return o;
}
function kg(...e) {
  const t = new Uint8Array(e.reduce((o, l) => o + l.length, 0));
  let r = 0;
  return e.forEach((o) => {
    if (!yx(o))
      throw new Error("Uint8Array expected");
    t.set(o, r), r += o.length;
  }), t;
}
function xD(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function dU(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function fU(e) {
  let t;
  for (t = 0; e > bD; e >>= mx, t += 1)
    ;
  return t;
}
function pU(e, t) {
  return e >> BigInt(t) & mx;
}
const hU = (e, t, r) => e | (r ? mx : bD) << BigInt(t), w3 = (e) => (uU << BigInt(e - 1)) - mx, wE = (e) => new Uint8Array(e), bP = (e) => Uint8Array.from(e);
function SD(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let o = wE(e), l = wE(e), d = 0;
  const f = () => {
    o.fill(1), l.fill(0), d = 0;
  }, m = (...b) => r(l, o, ...b), v = (b = wE()) => {
    l = m(bP([0]), b), o = m(), b.length !== 0 && (l = m(bP([1]), b), o = m());
  }, w = () => {
    if (d++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let b = 0;
    const k = [];
    for (; b < t; ) {
      o = m();
      const T = o.slice();
      k.push(T), b += o.length;
    }
    return kg(...k);
  };
  return (b, k) => {
    f(), v(b);
    let T;
    for (; !(T = k(w())); )
      v();
    return f(), T;
  };
}
const mU = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || e instanceof Uint8Array,
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function l0(e, t, r = {}) {
  const o = (l, d, f) => {
    const m = mU[d];
    if (typeof m != "function")
      throw new Error(`Invalid validator "${d}", expected function`);
    const v = e[l];
    if (!(f && v === void 0) && !m(v, e))
      throw new Error(`Invalid param ${String(l)}=${v} (${typeof v}), expected ${d}`);
  };
  for (const [l, d] of Object.entries(t))
    o(l, d, !1);
  for (const [l, d] of Object.entries(r))
    o(l, d, !0);
  return e;
}
const yU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: pU,
  bitLen: fU,
  bitMask: w3,
  bitSet: hU,
  bytesToHex: hm,
  bytesToNumberBE: Hf,
  bytesToNumberLE: g3,
  concatBytes: kg,
  createHmacDrbg: SD,
  ensureBytes: bs,
  equalBytes: xD,
  hexToBytes: mm,
  hexToNumber: v3,
  numberToBytesBE: ym,
  numberToBytesLE: b3,
  numberToHexUnpadded: wD,
  numberToVarBytesBE: cU,
  utf8ToBytes: dU,
  validateObject: l0
}, Symbol.toStringTag, { value: "Module" }));
function vU(e, t) {
  const r = Cs(e) ? Dl(e) : e, o = Cs(t) ? Dl(t) : t;
  return xD(r, o);
}
async function kD(e, { address: t, hash: r, signature: o, ...l }) {
  const d = Cs(o) ? o : St(o);
  try {
    const { data: f } = await Ke(e, dx, "call")({
      data: dA({
        abi: $F,
        args: [t, r, d],
        bytecode: sU
      }),
      ...l
    });
    return vU(f ?? "0x0", "0x1");
  } catch (f) {
    if (f instanceof YA)
      return !1;
    throw f;
  }
}
async function gU(e, { address: t, message: r, signature: o, ...l }) {
  const d = yD(r);
  return kD(e, {
    address: t,
    hash: d,
    signature: o,
    ...l
  });
}
async function bU(e, t) {
  const { address: r, signature: o, message: l, primaryType: d, types: f, domain: m, ...v } = t, w = uD({ message: l, primaryType: d, types: f, domain: m });
  return kD(e, {
    address: r,
    hash: w,
    signature: o,
    ...v
  });
}
function ED(e, { emitOnBegin: t = !1, emitMissed: r = !1, onBlockNumber: o, onError: l, poll: d, pollingInterval: f = e.pollingInterval }) {
  const m = typeof d < "u" ? d : e.transport.type !== "webSocket";
  let v;
  return m ? (() => {
    const b = sa([
      "watchBlockNumber",
      e.uid,
      t,
      r,
      f
    ]);
    return hd(b, { onBlockNumber: o, onError: l }, (k) => u0(async () => {
      var T;
      try {
        const O = await Ke(e, s0, "getBlockNumber")({ cacheTime: 0 });
        if (v) {
          if (O === v)
            return;
          if (O - v > 1 && r)
            for (let R = v + 1n; R < O; R++)
              k.onBlockNumber(R, v), v = R;
        }
        (!v || O > v) && (k.onBlockNumber(O, v), v = O);
      } catch (O) {
        (T = k.onError) == null || T.call(k, O);
      }
    }, {
      emitOnBegin: t,
      interval: f
    }));
  })() : (() => {
    const b = sa([
      "watchBlockNumber",
      e.uid,
      t,
      r
    ]);
    return hd(b, { onBlockNumber: o, onError: l }, (k) => {
      let T = !0, O = () => T = !1;
      return (async () => {
        try {
          const { unsubscribe: R } = await e.transport.subscribe({
            params: ["newHeads"],
            onData(j) {
              var N;
              if (!T)
                return;
              const I = Ml((N = j.result) == null ? void 0 : N.number);
              k.onBlockNumber(I, v), v = I;
            },
            onError(j) {
              var I;
              (I = k.onError) == null || I.call(k, j);
            }
          });
          O = R, T || O();
        } catch (R) {
          l == null || l(R);
        }
      })(), () => O();
    });
  })();
}
async function wU(e, {
  confirmations: t = 1,
  hash: r,
  onReplaced: o,
  pollingInterval: l = e.pollingInterval,
  retryCount: d = 6,
  retryDelay: f = ({ count: v }) => ~~(1 << v) * 200,
  // exponential backoff
  timeout: m
}) {
  const v = sa(["waitForTransactionReceipt", e.uid, r]);
  let w, x, b, k = !1;
  return new Promise((T, O) => {
    m && setTimeout(() => O(new cF({ hash: r })), m);
    const R = hd(v, { onReplaced: o, resolve: T, reject: O }, (j) => {
      const I = Ke(e, ED, "watchBlockNumber")({
        emitMissed: !0,
        emitOnBegin: !0,
        poll: !0,
        pollingInterval: l,
        async onBlockNumber(N) {
          if (k)
            return;
          let L = N;
          const B = (H) => {
            I(), H(), R();
          };
          try {
            if (b) {
              if (t > 1 && (!b.blockNumber || L - b.blockNumber + 1n < t))
                return;
              B(() => j.resolve(b));
              return;
            }
            if (w || (k = !0, await kC(async () => {
              w = await Ke(e, y3, "getTransaction")({ hash: r }), w.blockNumber && (L = w.blockNumber);
            }, {
              delay: f,
              retryCount: d
            }), k = !1), b = await Ke(e, EC, "getTransactionReceipt")({ hash: r }), t > 1 && (!b.blockNumber || L - b.blockNumber + 1n < t))
              return;
            B(() => j.resolve(b));
          } catch (H) {
            if (H instanceof hA || H instanceof mA) {
              if (!w) {
                k = !1;
                return;
              }
              try {
                x = w, k = !0;
                const V = await kC(() => Ke(e, Nl, "getBlock")({
                  blockNumber: L,
                  includeTransactions: !0
                }), {
                  delay: f,
                  retryCount: d,
                  shouldRetry: ({ error: ce }) => ce instanceof vA
                });
                k = !1;
                const W = V.transactions.find(({ from: ce, nonce: ve }) => ce === x.from && ve === x.nonce);
                if (!W || (b = await Ke(e, EC, "getTransactionReceipt")({
                  hash: W.hash
                }), t > 1 && (!b.blockNumber || L - b.blockNumber + 1n < t)))
                  return;
                let Y = "replaced";
                W.to === x.to && W.value === x.value ? Y = "repriced" : W.from === W.to && W.value === 0n && (Y = "cancelled"), B(() => {
                  var ce;
                  (ce = j.onReplaced) == null || ce.call(j, {
                    reason: Y,
                    replacedTransaction: x,
                    transaction: W,
                    transactionReceipt: b
                  }), j.resolve(b);
                });
              } catch (V) {
                B(() => j.reject(V));
              }
            } else
              B(() => j.reject(H));
          }
        }
      });
    });
  });
}
function CD(e, { blockTag: t = "latest", emitMissed: r = !1, emitOnBegin: o = !1, onBlock: l, onError: d, includeTransactions: f, poll: m, pollingInterval: v = e.pollingInterval }) {
  const w = typeof m < "u" ? m : e.transport.type !== "webSocket", x = f ?? !1;
  let b;
  return w ? (() => {
    const O = sa([
      "watchBlocks",
      e.uid,
      t,
      r,
      o,
      x,
      v
    ]);
    return hd(O, { onBlock: l, onError: d }, (R) => u0(async () => {
      var j;
      try {
        const I = await Ke(e, Nl, "getBlock")({
          blockTag: t,
          includeTransactions: x
        });
        if (I.number && (b != null && b.number)) {
          if (I.number === b.number)
            return;
          if (I.number - b.number > 1 && r)
            for (let N = (b == null ? void 0 : b.number) + 1n; N < I.number; N++) {
              const L = await Ke(e, Nl, "getBlock")({
                blockNumber: N,
                includeTransactions: x
              });
              R.onBlock(L, b), b = L;
            }
        }
        // If no previous block exists, emit.
        (!(b != null && b.number) || // If the block tag is "pending" with no block number, emit.
        t === "pending" && !(I != null && I.number) || // If the next block number is greater than the previous block number, emit.
        // We don't want to emit blocks in the past.
        I.number && I.number > b.number) && (R.onBlock(I, b), b = I);
      } catch (I) {
        (j = R.onError) == null || j.call(R, I);
      }
    }, {
      emitOnBegin: o,
      interval: v
    }));
  })() : (() => {
    let O = !0, R = () => O = !1;
    return (async () => {
      try {
        const { unsubscribe: j } = await e.transport.subscribe({
          params: ["newHeads"],
          onData(I) {
            var B, H, V;
            if (!O)
              return;
            const L = (((V = (H = (B = e.chain) == null ? void 0 : B.formatters) == null ? void 0 : H.block) == null ? void 0 : V.format) || ZT)(I.result);
            l(L, b), b = L;
          },
          onError(I) {
            d == null || d(I);
          }
        });
        R = j, O || R();
      } catch (j) {
        d == null || d(j);
      }
    })(), () => R();
  })();
}
function xU(e, { address: t, args: r, batch: o = !0, event: l, events: d, fromBlock: f, onError: m, onLogs: v, poll: w, pollingInterval: x = e.pollingInterval, strict: b }) {
  const k = typeof w < "u" ? w : e.transport.type !== "webSocket" || typeof f == "bigint", T = b ?? !1;
  return k ? (() => {
    const j = sa([
      "watchEvent",
      t,
      r,
      o,
      e.uid,
      l,
      x,
      f
    ]);
    return hd(j, { onLogs: v, onError: m }, (I) => {
      let N;
      f !== void 0 && (N = f - 1n);
      let L, B = !1;
      const H = u0(async () => {
        var V;
        if (!B) {
          try {
            L = await Ke(e, tD, "createEventFilter")({
              address: t,
              args: r,
              event: l,
              events: d,
              strict: T,
              fromBlock: f
            });
          } catch {
          }
          B = !0;
          return;
        }
        try {
          let W;
          if (L)
            W = await Ke(e, px, "getFilterChanges")({ filter: L });
          else {
            const Y = await Ke(e, s0, "getBlockNumber")({});
            N && N !== Y ? W = await Ke(e, S3, "getLogs")({
              address: t,
              args: r,
              event: l,
              events: d,
              fromBlock: N + 1n,
              toBlock: Y
            }) : W = [], N = Y;
          }
          if (W.length === 0)
            return;
          if (o)
            I.onLogs(W);
          else
            for (const Y of W)
              I.onLogs([Y]);
        } catch (W) {
          L && W instanceof Zf && (B = !1), (V = I.onError) == null || V.call(I, W);
        }
      }, {
        emitOnBegin: !0,
        interval: x
      });
      return async () => {
        L && await Ke(e, hx, "uninstallFilter")({ filter: L }), H();
      };
    });
  })() : (() => {
    let j = !0, I = () => j = !1;
    return (async () => {
      try {
        const N = d ?? (l ? [l] : void 0);
        let L = [];
        N && (L = [
          N.flatMap((H) => o0({
            abi: [H],
            eventName: H.name,
            args: r
          }))
        ], l && (L = L[0]));
        const { unsubscribe: B } = await e.transport.subscribe({
          params: ["logs", { address: t, topics: L }],
          onData(H) {
            var W;
            if (!j)
              return;
            const V = H.result;
            try {
              const { eventName: Y, args: ce } = d3({
                abi: N ?? [],
                data: V.data,
                topics: V.topics,
                strict: T
              }), ve = pd(V, { args: ce, eventName: Y });
              v([ve]);
            } catch (Y) {
              let ce, ve;
              if (Y instanceof rg || Y instanceof nx) {
                if (b)
                  return;
                ce = Y.abiItem.name, ve = (W = Y.abiItem.inputs) == null ? void 0 : W.some((De) => !("name" in De && De.name));
              }
              const Se = pd(V, {
                args: ve ? [] : {},
                eventName: ce
              });
              v([Se]);
            }
          },
          onError(H) {
            m == null || m(H);
          }
        });
        I = B, j || I();
      } catch (N) {
        m == null || m(N);
      }
    })(), () => I();
  })();
}
function SU(e, { batch: t = !0, onError: r, onTransactions: o, poll: l, pollingInterval: d = e.pollingInterval }) {
  return (typeof l < "u" ? l : e.transport.type !== "webSocket") ? (() => {
    const w = sa([
      "watchPendingTransactions",
      e.uid,
      t,
      d
    ]);
    return hd(w, { onTransactions: o, onError: r }, (x) => {
      let b;
      const k = u0(async () => {
        var T;
        try {
          if (!b)
            try {
              b = await Ke(e, nD, "createPendingTransactionFilter")({});
              return;
            } catch (R) {
              throw k(), R;
            }
          const O = await Ke(e, px, "getFilterChanges")({ filter: b });
          if (O.length === 0)
            return;
          if (t)
            x.onTransactions(O);
          else
            for (const R of O)
              x.onTransactions([R]);
        } catch (O) {
          (T = x.onError) == null || T.call(x, O);
        }
      }, {
        emitOnBegin: !0,
        interval: d
      });
      return async () => {
        b && await Ke(e, hx, "uninstallFilter")({ filter: b }), k();
      };
    });
  })() : (() => {
    let w = !0, x = () => w = !1;
    return (async () => {
      try {
        const { unsubscribe: b } = await e.transport.subscribe({
          params: ["newPendingTransactions"],
          onData(k) {
            if (!w)
              return;
            const T = k.result;
            o([T]);
          },
          onError(k) {
            r == null || r(k);
          }
        });
        x = b, w || x();
      } catch (b) {
        r == null || r(b);
      }
    })(), () => x();
  })();
}
function C1(e) {
  return {
    call: (t) => dx(e, t),
    createBlockFilter: () => hB(e),
    createContractEventFilter: (t) => eD(e, t),
    createEventFilter: (t) => tD(e, t),
    createPendingTransactionFilter: () => nD(e),
    estimateContractGas: (t) => yB(e, t),
    estimateGas: (t) => QT(e, t),
    getBalance: (t) => rD(e, t),
    getBlobBaseFee: () => vB(e),
    getBlock: (t) => Nl(e, t),
    getBlockNumber: (t) => s0(e, t),
    getBlockTransactionCount: (t) => kB(e, t),
    getBytecode: (t) => aD(e, t),
    getChainId: () => Jf(e),
    getContractEvents: (t) => $D(e, t),
    getEnsAddress: (t) => Xz(e, t),
    getEnsAvatar: (t) => dB(e, t),
    getEnsName: (t) => fB(e, t),
    getEnsResolver: (t) => pB(e, t),
    getEnsText: (t) => JA(e, t),
    getFeeHistory: (t) => LB(e, t),
    estimateFeesPerGas: (t) => bg(e, t),
    getFilterChanges: (t) => px(e, t),
    getFilterLogs: (t) => NB(e, t),
    getGasPrice: () => KT(e),
    getLogs: (t) => S3(e, t),
    getProof: (t) => aU(e, t),
    estimateMaxPriorityFeePerGas: (t) => vF(e, t),
    getStorageAt: (t) => iU(e, t),
    getTransaction: (t) => y3(e, t),
    getTransactionConfirmations: (t) => oU(e, t),
    getTransactionCount: (t) => wA(e, t),
    getTransactionReceipt: (t) => EC(e, t),
    multicall: (t) => gD(e, t),
    prepareTransactionRequest: (t) => ux(e, t),
    readContract: (t) => Ts(e, t),
    sendRawTransaction: (t) => n3(e, t),
    simulateContract: (t) => iD(e, t),
    verifyMessage: (t) => gU(e, t),
    verifyTypedData: (t) => bU(e, t),
    uninstallFilter: (t) => hx(e, t),
    waitForTransactionReceipt: (t) => wU(e, t),
    watchBlocks: (t) => CD(e, t),
    watchBlockNumber: (t) => ED(e, t),
    watchContractEvent: (t) => TB(e, t),
    watchEvent: (t) => xU(e, t),
    watchPendingTransactions: (t) => SU(e, t)
  };
}
async function kU(e) {
  var r;
  return ((r = e.account) == null ? void 0 : r.type) === "local" ? [e.account.address] : (await e.request({ method: "eth_accounts" })).map((o) => t0(o));
}
async function EU(e) {
  return await e.request({ method: "wallet_getPermissions" });
}
async function CU(e) {
  return (await e.request({ method: "eth_requestAccounts" }, { retryCount: 0 })).map((r) => ax(r));
}
async function TU(e, t) {
  return e.request({
    method: "wallet_requestPermissions",
    params: [t]
  }, { retryCount: 0 });
}
async function TD(e, { account: t = e.account, message: r }) {
  if (!t)
    throw new ix({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const o = fi(t);
  if (o.type === "local")
    return o.signMessage({ message: r });
  const l = (() => typeof r == "string" ? Zh(r) : r.raw instanceof Uint8Array ? St(r.raw) : r.raw)();
  return e.request({
    method: "personal_sign",
    params: [l, o.address]
  }, { retryCount: 0 });
}
async function _U(e, t) {
  var w, x, b, k;
  const { account: r = e.account, chain: o = e.chain, ...l } = t;
  if (!r)
    throw new ix({
      docsPath: "/docs/actions/wallet/signTransaction"
    });
  const d = fi(r);
  a0({
    account: d,
    ...t
  });
  const f = await Ke(e, Jf, "getChainId")({});
  o !== null && pA({
    currentChainId: f,
    chain: o
  });
  const m = (o == null ? void 0 : o.formatters) || ((w = e.chain) == null ? void 0 : w.formatters), v = ((x = m == null ? void 0 : m.transactionRequest) == null ? void 0 : x.format) || r0;
  return d.type === "local" ? d.signTransaction({
    ...l,
    chainId: f
  }, { serializer: (k = (b = e.chain) == null ? void 0 : b.serializers) == null ? void 0 : k.transaction }) : await e.request({
    method: "eth_signTransaction",
    params: [
      {
        ...v(l),
        chainId: Bt(f),
        from: d.address
      }
    ]
  }, { retryCount: 0 });
}
async function _D(e, t) {
  const { account: r = e.account, domain: o, message: l, primaryType: d } = t;
  if (!r)
    throw new ix({
      docsPath: "/docs/actions/wallet/signTypedData"
    });
  const f = fi(r), m = {
    EIP712Domain: p3({ domain: o }),
    ...t.types
  };
  if (f3({ domain: o, message: l, primaryType: d, types: m }), f.type === "local")
    return f.signTypedData({ domain: o, message: l, primaryType: d, types: m });
  const v = sa({ domain: o ?? {}, message: l, primaryType: d, types: m }, (w, x) => Cs(x) ? x.toLowerCase() : x);
  return e.request({
    method: "eth_signTypedData_v4",
    params: [f.address, v]
  }, { retryCount: 0 });
}
async function RU(e, { id: t }) {
  await e.request({
    method: "wallet_switchEthereumChain",
    params: [
      {
        chainId: Bt(t)
      }
    ]
  }, { retryCount: 0 });
}
async function OU(e, t) {
  return await e.request({
    method: "wallet_watchAsset",
    params: t
  }, { retryCount: 0 });
}
function CC(e) {
  return {
    addChain: (t) => sN(e, t),
    deployContract: (t) => IF(e, t),
    getAddresses: () => kU(e),
    getChainId: () => Jf(e),
    getPermissions: () => EU(e),
    prepareTransactionRequest: (t) => ux(e, t),
    requestAddresses: () => CU(e),
    requestPermissions: (t) => TU(e, t),
    sendRawTransaction: (t) => n3(e, t),
    sendTransaction: (t) => r3(e, t),
    signMessage: (t) => TD(e, t),
    signTransaction: (t) => _U(e, t),
    signTypedData: (t) => _D(e, t),
    switchChain: (t) => RU(e, t),
    watchAsset: (t) => OU(e, t),
    writeContract: (t) => xC(e, t)
  };
}
const dX = 2n ** 16n - 1n, wP = 2n ** 256n - 1n;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const oa = BigInt(0), kr = BigInt(1), jf = BigInt(2), PU = BigInt(3), TC = BigInt(4), xP = BigInt(5), SP = BigInt(8);
BigInt(9);
BigInt(16);
function Ni(e, t) {
  const r = e % t;
  return r >= oa ? r : t + r;
}
function jU(e, t, r) {
  if (r <= oa || t < oa)
    throw new Error("Expected power/modulo > 0");
  if (r === kr)
    return oa;
  let o = kr;
  for (; t > oa; )
    t & kr && (o = o * e % r), e = e * e % r, t >>= kr;
  return o;
}
function Po(e, t, r) {
  let o = e;
  for (; t-- > oa; )
    o *= o, o %= r;
  return o;
}
function _C(e, t) {
  if (e === oa || t <= oa)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let r = Ni(e, t), o = t, l = oa, d = kr;
  for (; r !== oa; ) {
    const m = o / r, v = o % r, w = l - d * m;
    o = r, r = v, l = d, d = w;
  }
  if (o !== kr)
    throw new Error("invert: does not exist");
  return Ni(l, t);
}
function AU(e) {
  const t = (e - kr) / jf;
  let r, o, l;
  for (r = e - kr, o = 0; r % jf === oa; r /= jf, o++)
    ;
  for (l = jf; l < e && jU(l, t, e) !== e - kr; l++)
    ;
  if (o === 1) {
    const f = (e + kr) / TC;
    return function(v, w) {
      const x = v.pow(w, f);
      if (!v.eql(v.sqr(x), w))
        throw new Error("Cannot find square root");
      return x;
    };
  }
  const d = (r + kr) / jf;
  return function(m, v) {
    if (m.pow(v, t) === m.neg(m.ONE))
      throw new Error("Cannot find square root");
    let w = o, x = m.pow(m.mul(m.ONE, l), r), b = m.pow(v, d), k = m.pow(v, r);
    for (; !m.eql(k, m.ONE); ) {
      if (m.eql(k, m.ZERO))
        return m.ZERO;
      let T = 1;
      for (let R = m.sqr(k); T < w && !m.eql(R, m.ONE); T++)
        R = m.sqr(R);
      const O = m.pow(x, kr << BigInt(w - T - 1));
      x = m.sqr(O), b = m.mul(b, O), k = m.mul(k, x), w = T;
    }
    return b;
  };
}
function DU(e) {
  if (e % TC === PU) {
    const t = (e + kr) / TC;
    return function(o, l) {
      const d = o.pow(l, t);
      if (!o.eql(o.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  if (e % SP === xP) {
    const t = (e - xP) / SP;
    return function(o, l) {
      const d = o.mul(l, jf), f = o.pow(d, t), m = o.mul(l, f), v = o.mul(o.mul(m, jf), f), w = o.mul(m, o.sub(v, o.ONE));
      if (!o.eql(o.sqr(w), l))
        throw new Error("Cannot find square root");
      return w;
    };
  }
  return AU(e);
}
const IU = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function MU(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = IU.reduce((o, l) => (o[l] = "function", o), t);
  return l0(e, r);
}
function $U(e, t, r) {
  if (r < oa)
    throw new Error("Expected power > 0");
  if (r === oa)
    return e.ONE;
  if (r === kr)
    return t;
  let o = e.ONE, l = t;
  for (; r > oa; )
    r & kr && (o = e.mul(o, l)), l = e.sqr(l), r >>= kr;
  return o;
}
function LU(e, t) {
  const r = new Array(t.length), o = t.reduce((d, f, m) => e.is0(f) ? d : (r[m] = d, e.mul(d, f)), e.ONE), l = e.inv(o);
  return t.reduceRight((d, f, m) => e.is0(f) ? d : (r[m] = e.mul(d, r[m]), e.mul(d, f)), l), r;
}
function RD(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, o = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: o };
}
function NU(e, t, r = !1, o = {}) {
  if (e <= oa)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: l, nByteLength: d } = RD(e, t);
  if (d > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const f = DU(e), m = Object.freeze({
    ORDER: e,
    BITS: l,
    BYTES: d,
    MASK: w3(l),
    ZERO: oa,
    ONE: kr,
    create: (v) => Ni(v, e),
    isValid: (v) => {
      if (typeof v != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof v}`);
      return oa <= v && v < e;
    },
    is0: (v) => v === oa,
    isOdd: (v) => (v & kr) === kr,
    neg: (v) => Ni(-v, e),
    eql: (v, w) => v === w,
    sqr: (v) => Ni(v * v, e),
    add: (v, w) => Ni(v + w, e),
    sub: (v, w) => Ni(v - w, e),
    mul: (v, w) => Ni(v * w, e),
    pow: (v, w) => $U(m, v, w),
    div: (v, w) => Ni(v * _C(w, e), e),
    // Same as above, but doesn't normalize
    sqrN: (v) => v * v,
    addN: (v, w) => v + w,
    subN: (v, w) => v - w,
    mulN: (v, w) => v * w,
    inv: (v) => _C(v, e),
    sqrt: o.sqrt || ((v) => f(m, v)),
    invertBatch: (v) => LU(m, v),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (v, w, x) => x ? w : v,
    toBytes: (v) => r ? b3(v, d) : ym(v, d),
    fromBytes: (v) => {
      if (v.length !== d)
        throw new Error(`Fp.fromBytes: expected ${d}, got ${v.length}`);
      return r ? g3(v) : Hf(v);
    }
  });
  return Object.freeze(m);
}
function OD(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function PD(e) {
  const t = OD(e);
  return t + Math.ceil(t / 2);
}
function FU(e, t, r = !1) {
  const o = e.length, l = OD(t), d = PD(t);
  if (o < 16 || o < d || o > 1024)
    throw new Error(`expected ${d}-1024 bytes of input, got ${o}`);
  const f = r ? Hf(e) : g3(e), m = Ni(f, t - kr) + kr;
  return r ? b3(m, l) : ym(m, l);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zU = BigInt(0), xE = BigInt(1);
function BU(e, t) {
  const r = (l, d) => {
    const f = d.negate();
    return l ? f : d;
  }, o = (l) => {
    const d = Math.ceil(t / l) + 1, f = 2 ** (l - 1);
    return { windows: d, windowSize: f };
  };
  return {
    constTimeNegate: r,
    // non-const time multiplication ladder
    unsafeLadder(l, d) {
      let f = e.ZERO, m = l;
      for (; d > zU; )
        d & xE && (f = f.add(m)), m = m.double(), d >>= xE;
      return f;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(l, d) {
      const { windows: f, windowSize: m } = o(d), v = [];
      let w = l, x = w;
      for (let b = 0; b < f; b++) {
        x = w, v.push(x);
        for (let k = 1; k < m; k++)
          x = x.add(w), v.push(x);
        w = x.double();
      }
      return v;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(l, d, f) {
      const { windows: m, windowSize: v } = o(l);
      let w = e.ZERO, x = e.BASE;
      const b = BigInt(2 ** l - 1), k = 2 ** l, T = BigInt(l);
      for (let O = 0; O < m; O++) {
        const R = O * v;
        let j = Number(f & b);
        f >>= T, j > v && (j -= k, f += xE);
        const I = R, N = R + Math.abs(j) - 1, L = O % 2 !== 0, B = j < 0;
        j === 0 ? x = x.add(r(L, d[I])) : w = w.add(r(B, d[N]));
      }
      return { p: w, f: x };
    },
    wNAFCached(l, d, f, m) {
      const v = l._WINDOW_SIZE || 1;
      let w = d.get(l);
      return w || (w = this.precomputeWindow(l, v), v !== 1 && d.set(l, m(w))), this.wNAF(v, w, f);
    }
  };
}
function jD(e) {
  return MU(e.Fp), l0(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...RD(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function UU(e) {
  const t = jD(e);
  l0(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: o, a: l } = t;
  if (r) {
    if (!o.eql(l, o.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: HU, hexToBytes: VU } = yU, Af = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = Af;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const r = e[1], o = e.subarray(2, r + 2);
    if (!r || o.length !== r)
      throw new t("Invalid signature integer: wrong length");
    if (o[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (o[0] === 0 && !(o[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: HU(o), l: e.subarray(r + 2) };
  },
  toSig(e) {
    const { Err: t } = Af, r = typeof e == "string" ? VU(e) : e;
    if (!(r instanceof Uint8Array))
      throw new Error("ui8a expected");
    let o = r.length;
    if (o < 2 || r[0] != 48)
      throw new t("Invalid signature tag");
    if (r[1] !== o - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: l, l: d } = Af._parseInt(r.subarray(2)), { d: f, l: m } = Af._parseInt(d);
    if (m.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: l, s: f };
  },
  hexFromSig(e) {
    const t = (w) => Number.parseInt(w[0], 16) & 8 ? "00" + w : w, r = (w) => {
      const x = w.toString(16);
      return x.length & 1 ? `0${x}` : x;
    }, o = t(r(e.s)), l = t(r(e.r)), d = o.length / 2, f = l.length / 2, m = r(d), v = r(f);
    return `30${r(f + d + 4)}02${v}${l}02${m}${o}`;
  }
}, Ol = BigInt(0), Do = BigInt(1);
BigInt(2);
const kP = BigInt(3);
BigInt(4);
function GU(e) {
  const t = UU(e), { Fp: r } = t, o = t.toBytes || ((O, R, j) => {
    const I = R.toAffine();
    return kg(Uint8Array.from([4]), r.toBytes(I.x), r.toBytes(I.y));
  }), l = t.fromBytes || ((O) => {
    const R = O.subarray(1), j = r.fromBytes(R.subarray(0, r.BYTES)), I = r.fromBytes(R.subarray(r.BYTES, 2 * r.BYTES));
    return { x: j, y: I };
  });
  function d(O) {
    const { a: R, b: j } = t, I = r.sqr(O), N = r.mul(I, O);
    return r.add(r.add(N, r.mul(O, R)), j);
  }
  if (!r.eql(r.sqr(t.Gy), d(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function f(O) {
    return typeof O == "bigint" && Ol < O && O < t.n;
  }
  function m(O) {
    if (!f(O))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function v(O) {
    const { allowedPrivateKeyLengths: R, nByteLength: j, wrapPrivateKey: I, n: N } = t;
    if (R && typeof O != "bigint") {
      if (O instanceof Uint8Array && (O = hm(O)), typeof O != "string" || !R.includes(O.length))
        throw new Error("Invalid key");
      O = O.padStart(j * 2, "0");
    }
    let L;
    try {
      L = typeof O == "bigint" ? O : Hf(bs("private key", O, j));
    } catch {
      throw new Error(`private key must be ${j} bytes, hex or bigint, not ${typeof O}`);
    }
    return I && (L = Ni(L, N)), m(L), L;
  }
  const w = /* @__PURE__ */ new Map();
  function x(O) {
    if (!(O instanceof b))
      throw new Error("ProjectivePoint expected");
  }
  class b {
    constructor(R, j, I) {
      if (this.px = R, this.py = j, this.pz = I, R == null || !r.isValid(R))
        throw new Error("x required");
      if (j == null || !r.isValid(j))
        throw new Error("y required");
      if (I == null || !r.isValid(I))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(R) {
      const { x: j, y: I } = R || {};
      if (!R || !r.isValid(j) || !r.isValid(I))
        throw new Error("invalid affine point");
      if (R instanceof b)
        throw new Error("projective point not allowed");
      const N = (L) => r.eql(L, r.ZERO);
      return N(j) && N(I) ? b.ZERO : new b(j, I, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(R) {
      const j = r.invertBatch(R.map((I) => I.pz));
      return R.map((I, N) => I.toAffine(j[N])).map(b.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(R) {
      const j = b.fromAffine(l(bs("pointHex", R)));
      return j.assertValidity(), j;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(R) {
      return b.BASE.multiply(v(R));
    }
    // "Private method", don't use it directly
    _setWindowSize(R) {
      this._WINDOW_SIZE = R, w.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !r.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: R, y: j } = this.toAffine();
      if (!r.isValid(R) || !r.isValid(j))
        throw new Error("bad point: x or y not FE");
      const I = r.sqr(j), N = d(R);
      if (!r.eql(I, N))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: R } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(R);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(R) {
      x(R);
      const { px: j, py: I, pz: N } = this, { px: L, py: B, pz: H } = R, V = r.eql(r.mul(j, H), r.mul(L, N)), W = r.eql(r.mul(I, H), r.mul(B, N));
      return V && W;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new b(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: R, b: j } = t, I = r.mul(j, kP), { px: N, py: L, pz: B } = this;
      let H = r.ZERO, V = r.ZERO, W = r.ZERO, Y = r.mul(N, N), ce = r.mul(L, L), ve = r.mul(B, B), Se = r.mul(N, L);
      return Se = r.add(Se, Se), W = r.mul(N, B), W = r.add(W, W), H = r.mul(R, W), V = r.mul(I, ve), V = r.add(H, V), H = r.sub(ce, V), V = r.add(ce, V), V = r.mul(H, V), H = r.mul(Se, H), W = r.mul(I, W), ve = r.mul(R, ve), Se = r.sub(Y, ve), Se = r.mul(R, Se), Se = r.add(Se, W), W = r.add(Y, Y), Y = r.add(W, Y), Y = r.add(Y, ve), Y = r.mul(Y, Se), V = r.add(V, Y), ve = r.mul(L, B), ve = r.add(ve, ve), Y = r.mul(ve, Se), H = r.sub(H, Y), W = r.mul(ve, ce), W = r.add(W, W), W = r.add(W, W), new b(H, V, W);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(R) {
      x(R);
      const { px: j, py: I, pz: N } = this, { px: L, py: B, pz: H } = R;
      let V = r.ZERO, W = r.ZERO, Y = r.ZERO;
      const ce = t.a, ve = r.mul(t.b, kP);
      let Se = r.mul(j, L), De = r.mul(I, B), Re = r.mul(N, H), Pe = r.add(j, I), se = r.add(L, B);
      Pe = r.mul(Pe, se), se = r.add(Se, De), Pe = r.sub(Pe, se), se = r.add(j, N);
      let ge = r.add(L, H);
      return se = r.mul(se, ge), ge = r.add(Se, Re), se = r.sub(se, ge), ge = r.add(I, N), V = r.add(B, H), ge = r.mul(ge, V), V = r.add(De, Re), ge = r.sub(ge, V), Y = r.mul(ce, se), V = r.mul(ve, Re), Y = r.add(V, Y), V = r.sub(De, Y), Y = r.add(De, Y), W = r.mul(V, Y), De = r.add(Se, Se), De = r.add(De, Se), Re = r.mul(ce, Re), se = r.mul(ve, se), De = r.add(De, Re), Re = r.sub(Se, Re), Re = r.mul(ce, Re), se = r.add(se, Re), Se = r.mul(De, se), W = r.add(W, Se), Se = r.mul(ge, se), V = r.mul(Pe, V), V = r.sub(V, Se), Se = r.mul(Pe, De), Y = r.mul(ge, Y), Y = r.add(Y, Se), new b(V, W, Y);
    }
    subtract(R) {
      return this.add(R.negate());
    }
    is0() {
      return this.equals(b.ZERO);
    }
    wNAF(R) {
      return T.wNAFCached(this, w, R, (j) => {
        const I = r.invertBatch(j.map((N) => N.pz));
        return j.map((N, L) => N.toAffine(I[L])).map(b.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(R) {
      const j = b.ZERO;
      if (R === Ol)
        return j;
      if (m(R), R === Do)
        return this;
      const { endo: I } = t;
      if (!I)
        return T.unsafeLadder(this, R);
      let { k1neg: N, k1: L, k2neg: B, k2: H } = I.splitScalar(R), V = j, W = j, Y = this;
      for (; L > Ol || H > Ol; )
        L & Do && (V = V.add(Y)), H & Do && (W = W.add(Y)), Y = Y.double(), L >>= Do, H >>= Do;
      return N && (V = V.negate()), B && (W = W.negate()), W = new b(r.mul(W.px, I.beta), W.py, W.pz), V.add(W);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(R) {
      m(R);
      let j = R, I, N;
      const { endo: L } = t;
      if (L) {
        const { k1neg: B, k1: H, k2neg: V, k2: W } = L.splitScalar(j);
        let { p: Y, f: ce } = this.wNAF(H), { p: ve, f: Se } = this.wNAF(W);
        Y = T.constTimeNegate(B, Y), ve = T.constTimeNegate(V, ve), ve = new b(r.mul(ve.px, L.beta), ve.py, ve.pz), I = Y.add(ve), N = ce.add(Se);
      } else {
        const { p: B, f: H } = this.wNAF(j);
        I = B, N = H;
      }
      return b.normalizeZ([I, N])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(R, j, I) {
      const N = b.BASE, L = (H, V) => V === Ol || V === Do || !H.equals(N) ? H.multiplyUnsafe(V) : H.multiply(V), B = L(this, j).add(L(R, I));
      return B.is0() ? void 0 : B;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(R) {
      const { px: j, py: I, pz: N } = this, L = this.is0();
      R == null && (R = L ? r.ONE : r.inv(N));
      const B = r.mul(j, R), H = r.mul(I, R), V = r.mul(N, R);
      if (L)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(V, r.ONE))
        throw new Error("invZ was invalid");
      return { x: B, y: H };
    }
    isTorsionFree() {
      const { h: R, isTorsionFree: j } = t;
      if (R === Do)
        return !0;
      if (j)
        return j(b, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: R, clearCofactor: j } = t;
      return R === Do ? this : j ? j(b, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(R = !0) {
      return this.assertValidity(), o(b, this, R);
    }
    toHex(R = !0) {
      return hm(this.toRawBytes(R));
    }
  }
  b.BASE = new b(t.Gx, t.Gy, r.ONE), b.ZERO = new b(r.ZERO, r.ONE, r.ZERO);
  const k = t.nBitLength, T = BU(b, t.endo ? Math.ceil(k / 2) : k);
  return {
    CURVE: t,
    ProjectivePoint: b,
    normPrivateKeyToScalar: v,
    weierstrassEquation: d,
    isWithinCurveOrder: f
  };
}
function qU(e) {
  const t = jD(e);
  return l0(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function WU(e) {
  const t = qU(e), { Fp: r, n: o } = t, l = r.BYTES + 1, d = 2 * r.BYTES + 1;
  function f(se) {
    return Ol < se && se < r.ORDER;
  }
  function m(se) {
    return Ni(se, o);
  }
  function v(se) {
    return _C(se, o);
  }
  const { ProjectivePoint: w, normPrivateKeyToScalar: x, weierstrassEquation: b, isWithinCurveOrder: k } = GU({
    ...t,
    toBytes(se, ge, de) {
      const pe = ge.toAffine(), fe = r.toBytes(pe.x), z = kg;
      return de ? z(Uint8Array.from([ge.hasEvenY() ? 2 : 3]), fe) : z(Uint8Array.from([4]), fe, r.toBytes(pe.y));
    },
    fromBytes(se) {
      const ge = se.length, de = se[0], pe = se.subarray(1);
      if (ge === l && (de === 2 || de === 3)) {
        const fe = Hf(pe);
        if (!f(fe))
          throw new Error("Point is not on curve");
        const z = b(fe);
        let oe = r.sqrt(z);
        const ke = (oe & Do) === Do;
        return (de & 1) === 1 !== ke && (oe = r.neg(oe)), { x: fe, y: oe };
      } else if (ge === d && de === 4) {
        const fe = r.fromBytes(pe.subarray(0, r.BYTES)), z = r.fromBytes(pe.subarray(r.BYTES, 2 * r.BYTES));
        return { x: fe, y: z };
      } else
        throw new Error(`Point of length ${ge} was invalid. Expected ${l} compressed bytes or ${d} uncompressed bytes`);
    }
  }), T = (se) => hm(ym(se, t.nByteLength));
  function O(se) {
    const ge = o >> Do;
    return se > ge;
  }
  function R(se) {
    return O(se) ? m(-se) : se;
  }
  const j = (se, ge, de) => Hf(se.slice(ge, de));
  class I {
    constructor(ge, de, pe) {
      this.r = ge, this.s = de, this.recovery = pe, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(ge) {
      const de = t.nByteLength;
      return ge = bs("compactSignature", ge, de * 2), new I(j(ge, 0, de), j(ge, de, 2 * de));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(ge) {
      const { r: de, s: pe } = Af.toSig(bs("DER", ge));
      return new I(de, pe);
    }
    assertValidity() {
      if (!k(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!k(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(ge) {
      return new I(this.r, this.s, ge);
    }
    recoverPublicKey(ge) {
      const { r: de, s: pe, recovery: fe } = this, z = W(bs("msgHash", ge));
      if (fe == null || ![0, 1, 2, 3].includes(fe))
        throw new Error("recovery id invalid");
      const oe = fe === 2 || fe === 3 ? de + t.n : de;
      if (oe >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const ke = fe & 1 ? "03" : "02", Qe = w.fromHex(ke + T(oe)), Xe = v(oe), bt = m(-z * Xe), at = m(pe * Xe), ut = w.BASE.multiplyAndAddUnsafe(Qe, bt, at);
      if (!ut)
        throw new Error("point at infinify");
      return ut.assertValidity(), ut;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return O(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new I(this.r, m(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return mm(this.toDERHex());
    }
    toDERHex() {
      return Af.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return mm(this.toCompactHex());
    }
    toCompactHex() {
      return T(this.r) + T(this.s);
    }
  }
  const N = {
    isValidPrivateKey(se) {
      try {
        return x(se), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: x,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const se = PD(t.n);
      return FU(t.randomBytes(se), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(se = 8, ge = w.BASE) {
      return ge._setWindowSize(se), ge.multiply(BigInt(3)), ge;
    }
  };
  function L(se, ge = !0) {
    return w.fromPrivateKey(se).toRawBytes(ge);
  }
  function B(se) {
    const ge = se instanceof Uint8Array, de = typeof se == "string", pe = (ge || de) && se.length;
    return ge ? pe === l || pe === d : de ? pe === 2 * l || pe === 2 * d : se instanceof w;
  }
  function H(se, ge, de = !0) {
    if (B(se))
      throw new Error("first arg must be private key");
    if (!B(ge))
      throw new Error("second arg must be public key");
    return w.fromHex(ge).multiply(x(se)).toRawBytes(de);
  }
  const V = t.bits2int || function(se) {
    const ge = Hf(se), de = se.length * 8 - t.nBitLength;
    return de > 0 ? ge >> BigInt(de) : ge;
  }, W = t.bits2int_modN || function(se) {
    return m(V(se));
  }, Y = w3(t.nBitLength);
  function ce(se) {
    if (typeof se != "bigint")
      throw new Error("bigint expected");
    if (!(Ol <= se && se < Y))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return ym(se, t.nByteLength);
  }
  function ve(se, ge, de = Se) {
    if (["recovered", "canonical"].some((pt) => pt in de))
      throw new Error("sign() legacy options not supported");
    const { hash: pe, randomBytes: fe } = t;
    let { lowS: z, prehash: oe, extraEntropy: ke } = de;
    z == null && (z = !0), se = bs("msgHash", se), oe && (se = bs("prehashed msgHash", pe(se)));
    const Qe = W(se), Xe = x(ge), bt = [ce(Xe), ce(Qe)];
    if (ke != null) {
      const pt = ke === !0 ? fe(r.BYTES) : ke;
      bt.push(bs("extraEntropy", pt));
    }
    const at = kg(...bt), ut = Qe;
    function wt(pt) {
      const Rn = V(pt);
      if (!k(Rn))
        return;
      const rr = v(Rn), Hn = w.BASE.multiply(Rn).toAffine(), Vt = m(Hn.x);
      if (Vt === Ol)
        return;
      const xn = m(rr * m(ut + Vt * Xe));
      if (xn === Ol)
        return;
      let gn = (Hn.x === Vt ? 0 : 2) | Number(Hn.y & Do), An = xn;
      return z && O(xn) && (An = R(xn), gn ^= 1), new I(Vt, An, gn);
    }
    return { seed: at, k2sig: wt };
  }
  const Se = { lowS: t.lowS, prehash: !1 }, De = { lowS: t.lowS, prehash: !1 };
  function Re(se, ge, de = Se) {
    const { seed: pe, k2sig: fe } = ve(se, ge, de), z = t;
    return SD(z.hash.outputLen, z.nByteLength, z.hmac)(pe, fe);
  }
  w.BASE._setWindowSize(8);
  function Pe(se, ge, de, pe = De) {
    var Hn;
    const fe = se;
    if (ge = bs("msgHash", ge), de = bs("publicKey", de), "strict" in pe)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: z, prehash: oe } = pe;
    let ke, Qe;
    try {
      if (typeof fe == "string" || fe instanceof Uint8Array)
        try {
          ke = I.fromDER(fe);
        } catch (Vt) {
          if (!(Vt instanceof Af.Err))
            throw Vt;
          ke = I.fromCompact(fe);
        }
      else if (typeof fe == "object" && typeof fe.r == "bigint" && typeof fe.s == "bigint") {
        const { r: Vt, s: xn } = fe;
        ke = new I(Vt, xn);
      } else
        throw new Error("PARSE");
      Qe = w.fromHex(de);
    } catch (Vt) {
      if (Vt.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (z && ke.hasHighS())
      return !1;
    oe && (ge = t.hash(ge));
    const { r: Xe, s: bt } = ke, at = W(ge), ut = v(bt), wt = m(at * ut), pt = m(Xe * ut), Rn = (Hn = w.BASE.multiplyAndAddUnsafe(Qe, wt, pt)) == null ? void 0 : Hn.toAffine();
    return Rn ? m(Rn.x) === Xe : !1;
  }
  return {
    CURVE: t,
    getPublicKey: L,
    getSharedSecret: H,
    sign: Re,
    verify: Pe,
    ProjectivePoint: w,
    Signature: I,
    utils: N
  };
}
class AD extends NT {
  constructor(t, r) {
    super(), this.finished = !1, this.destroyed = !1, kN(t);
    const o = rx(r);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const l = this.blockLen, d = new Uint8Array(l);
    d.set(o.length > l ? t.create().update(o).digest() : o);
    for (let f = 0; f < d.length; f++)
      d[f] ^= 54;
    this.iHash.update(d), this.oHash = t.create();
    for (let f = 0; f < d.length; f++)
      d[f] ^= 106;
    this.oHash.update(d), d.fill(0);
  }
  update(t) {
    return dm(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    dm(this), LT(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: o, finished: l, destroyed: d, blockLen: f, outputLen: m } = this;
    return t = t, t.finished = l, t.destroyed = d, t.blockLen = f, t.outputLen = m, t.oHash = r._cloneInto(t.oHash), t.iHash = o._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const DD = (e, t, r) => new AD(e, t).update(r).digest();
DD.create = (e, t) => new AD(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function YU(e) {
  return {
    hash: e,
    hmac: (t, ...r) => DD(e, t, DN(...r)),
    randomBytes: IN
  };
}
function ZU(e, t) {
  const r = (o) => WU({ ...e, ...YU(o) });
  return Object.freeze({ ...r(t), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ID = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), EP = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), KU = BigInt(1), RC = BigInt(2), CP = (e, t) => (e + t / RC) / t;
function QU(e) {
  const t = ID, r = BigInt(3), o = BigInt(6), l = BigInt(11), d = BigInt(22), f = BigInt(23), m = BigInt(44), v = BigInt(88), w = e * e * e % t, x = w * w * e % t, b = Po(x, r, t) * x % t, k = Po(b, r, t) * x % t, T = Po(k, RC, t) * w % t, O = Po(T, l, t) * T % t, R = Po(O, d, t) * O % t, j = Po(R, m, t) * R % t, I = Po(j, v, t) * j % t, N = Po(I, m, t) * R % t, L = Po(N, r, t) * x % t, B = Po(L, f, t) * O % t, H = Po(B, o, t) * w % t, V = Po(H, RC, t);
  if (!OC.eql(OC.sqr(V), e))
    throw new Error("Cannot find square root");
  return V;
}
const OC = NU(ID, void 0, void 0, { sqrt: QU }), vx = ZU({
  a: BigInt(0),
  b: BigInt(7),
  Fp: OC,
  n: EP,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = EP, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), o = -KU * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), l = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), d = r, f = BigInt("0x100000000000000000000000000000000"), m = CP(d * e, t), v = CP(-o * e, t);
      let w = Ni(e - m * r - v * l, t), x = Ni(-m * o - v * d, t);
      const b = w > f, k = x > f;
      if (b && (w = t - w), k && (x = t - x), w > f || x > f)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: b, k1: w, k2neg: k, k2: x };
    }
  }
}, xA);
BigInt(0);
vx.ProjectivePoint;
function MD({ r: e, s: t, v: r, yParity: o }) {
  const l = (() => {
    if (r === 27n || o === 0)
      return "1b";
    if (r === 28n || o === 1)
      return "1c";
    throw new Error("Invalid v value");
  })();
  return `0x${new vx.Signature(Ml(e), Ml(t)).toCompactHex()}${l}`;
}
function x3({ abi: e, eventName: t, logs: r, strict: o = !0 }) {
  return r.map((l) => {
    var d;
    try {
      const f = d3({
        ...l,
        abi: e,
        strict: o
      });
      return t && !t.includes(f.eventName) ? null : { ...f, ...l };
    } catch (f) {
      let m, v;
      if (f instanceof tA)
        return null;
      if (f instanceof rg || f instanceof nx) {
        if (o)
          return null;
        m = f.abiItem.name, v = (d = f.abiItem.inputs) == null ? void 0 : d.some((w) => !("name" in w && w.name));
      }
      return { ...l, args: v ? [] : {}, eventName: m };
    }
  }).filter(Boolean);
}
async function S3(e, { address: t, blockHash: r, fromBlock: o, toBlock: l, event: d, events: f, args: m, strict: v } = {}) {
  const w = v ?? !1, x = f ?? (d ? [d] : void 0);
  let b = [];
  x && (b = [
    x.flatMap((O) => o0({
      abi: [O],
      eventName: O.name,
      args: m
    }))
  ], d && (b = b[0]));
  let k;
  r ? k = await e.request({
    method: "eth_getLogs",
    params: [{ address: t, topics: b, blockHash: r }]
  }) : k = await e.request({
    method: "eth_getLogs",
    params: [
      {
        address: t,
        topics: b,
        fromBlock: typeof o == "bigint" ? Bt(o) : o,
        toBlock: typeof l == "bigint" ? Bt(l) : l
      }
    ]
  });
  const T = k.map((O) => pd(O));
  return x ? x3({
    abi: x,
    logs: T,
    strict: w
  }) : T;
}
async function $D(e, t) {
  const { abi: r, address: o, args: l, blockHash: d, eventName: f, fromBlock: m, toBlock: v, strict: w } = t, x = f ? i0({ abi: r, name: f }) : void 0, b = x ? void 0 : r.filter((k) => k.type === "event");
  return Ke(e, S3, "getLogs")({
    address: o,
    args: l,
    blockHash: d,
    event: x,
    events: b,
    fromBlock: m,
    toBlock: v,
    strict: w
  });
}
var XU = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function o() {
  }
  Object.create && (o.prototype = /* @__PURE__ */ Object.create(null), new o().__proto__ || (r = !1));
  function l(v, w, x) {
    this.fn = v, this.context = w, this.once = x || !1;
  }
  function d(v, w, x, b, k) {
    if (typeof x != "function")
      throw new TypeError("The listener must be a function");
    var T = new l(x, b || v, k), O = r ? r + w : w;
    return v._events[O] ? v._events[O].fn ? v._events[O] = [v._events[O], T] : v._events[O].push(T) : (v._events[O] = T, v._eventsCount++), v;
  }
  function f(v, w) {
    --v._eventsCount === 0 ? v._events = new o() : delete v._events[w];
  }
  function m() {
    this._events = new o(), this._eventsCount = 0;
  }
  m.prototype.eventNames = function() {
    var w = [], x, b;
    if (this._eventsCount === 0)
      return w;
    for (b in x = this._events)
      t.call(x, b) && w.push(r ? b.slice(1) : b);
    return Object.getOwnPropertySymbols ? w.concat(Object.getOwnPropertySymbols(x)) : w;
  }, m.prototype.listeners = function(w) {
    var x = r ? r + w : w, b = this._events[x];
    if (!b)
      return [];
    if (b.fn)
      return [b.fn];
    for (var k = 0, T = b.length, O = new Array(T); k < T; k++)
      O[k] = b[k].fn;
    return O;
  }, m.prototype.listenerCount = function(w) {
    var x = r ? r + w : w, b = this._events[x];
    return b ? b.fn ? 1 : b.length : 0;
  }, m.prototype.emit = function(w, x, b, k, T, O) {
    var R = r ? r + w : w;
    if (!this._events[R])
      return !1;
    var j = this._events[R], I = arguments.length, N, L;
    if (j.fn) {
      switch (j.once && this.removeListener(w, j.fn, void 0, !0), I) {
        case 1:
          return j.fn.call(j.context), !0;
        case 2:
          return j.fn.call(j.context, x), !0;
        case 3:
          return j.fn.call(j.context, x, b), !0;
        case 4:
          return j.fn.call(j.context, x, b, k), !0;
        case 5:
          return j.fn.call(j.context, x, b, k, T), !0;
        case 6:
          return j.fn.call(j.context, x, b, k, T, O), !0;
      }
      for (L = 1, N = new Array(I - 1); L < I; L++)
        N[L - 1] = arguments[L];
      j.fn.apply(j.context, N);
    } else {
      var B = j.length, H;
      for (L = 0; L < B; L++)
        switch (j[L].once && this.removeListener(w, j[L].fn, void 0, !0), I) {
          case 1:
            j[L].fn.call(j[L].context);
            break;
          case 2:
            j[L].fn.call(j[L].context, x);
            break;
          case 3:
            j[L].fn.call(j[L].context, x, b);
            break;
          case 4:
            j[L].fn.call(j[L].context, x, b, k);
            break;
          default:
            if (!N)
              for (H = 1, N = new Array(I - 1); H < I; H++)
                N[H - 1] = arguments[H];
            j[L].fn.apply(j[L].context, N);
        }
    }
    return !0;
  }, m.prototype.on = function(w, x, b) {
    return d(this, w, x, b, !1);
  }, m.prototype.once = function(w, x, b) {
    return d(this, w, x, b, !0);
  }, m.prototype.removeListener = function(w, x, b, k) {
    var T = r ? r + w : w;
    if (!this._events[T])
      return this;
    if (!x)
      return f(this, T), this;
    var O = this._events[T];
    if (O.fn)
      O.fn === x && (!k || O.once) && (!b || O.context === b) && f(this, T);
    else {
      for (var R = 0, j = [], I = O.length; R < I; R++)
        (O[R].fn !== x || k && !O[R].once || b && O[R].context !== b) && j.push(O[R]);
      j.length ? this._events[T] = j.length === 1 ? j[0] : j : f(this, T);
    }
    return this;
  }, m.prototype.removeAllListeners = function(w) {
    var x;
    return w ? (x = r ? r + w : w, this._events[x] && f(this, x)) : (this._events = new o(), this._eventsCount = 0), this;
  }, m.prototype.off = m.prototype.removeListener, m.prototype.addListener = m.prototype.on, m.prefixed = r, m.EventEmitter = m, e.exports = m;
})(XU);
const JU = "2.10.3", e9 = () => `@wagmi/core@${JU}`;
var LD = globalThis && globalThis.__classPrivateFieldGet || function(e, t, r, o) {
  if (r === "a" && !o)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? o : r === "a" ? o.call(e) : o ? o.value : t.get(e);
}, D1, ND;
let c0 = class PC extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return e9();
  }
  constructor(t, r = {}) {
    var d;
    super(), D1.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const o = r.cause instanceof PC ? r.cause.details : (d = r.cause) != null && d.message ? r.cause.message : r.details, l = r.cause instanceof PC && r.cause.docsPath || r.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...l ? [
        `Docs: ${this.docsBaseUrl}${l}.html${r.docsSlug ? `#${r.docsSlug}` : ""}`
      ] : [],
      ...o ? [`Details: ${o}`] : [],
      `Version: ${this.version}`
    ].join(`
`), r.cause && (this.cause = r.cause), this.details = o, this.docsPath = l, this.metaMessages = r.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return LD(this, D1, "m", ND).call(this, this, t);
  }
};
D1 = /* @__PURE__ */ new WeakSet(), ND = function e(t, r) {
  return r != null && r(t) ? t : t.cause ? LD(this, D1, "m", e).call(this, t.cause, r) : t;
};
class pX extends c0 {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class hX extends c0 {
  constructor() {
    super("Connector already connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAlreadyConnectedError"
    });
  }
}
class t9 extends c0 {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class n9 extends c0 {
  constructor({ address: t, connector: r }) {
    super(`Account "${t}" not found for connector "${r.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
function d0(e, t, r) {
  const o = e[t.name];
  if (typeof o == "function")
    return o;
  const l = e[r];
  return typeof l == "function" ? l : (d) => t(e, d);
}
async function r9(e, t = {}) {
  var l, d;
  let r;
  if (t.connector)
    r = t.connector;
  else {
    const { connections: f, current: m } = e.state, v = f.get(m);
    r = v == null ? void 0 : v.connector;
  }
  const o = e.state.connections;
  r && (await r.disconnect(), r.emitter.off("change", e._internal.events.change), r.emitter.off("disconnect", e._internal.events.disconnect), r.emitter.on("connect", e._internal.events.connect), o.delete(r.uid)), e.setState((f) => {
    if (o.size === 0)
      return {
        ...f,
        connections: /* @__PURE__ */ new Map(),
        current: null,
        status: "disconnected"
      };
    const m = o.values().next().value;
    return {
      ...f,
      connections: new Map(o),
      current: m.connector.uid
    };
  });
  {
    const f = e.state.current;
    if (!f)
      return;
    const m = (l = e.state.connections.get(f)) == null ? void 0 : l.connector;
    if (!m)
      return;
    await ((d = e.storage) == null ? void 0 : d.setItem("recentConnectorId", m.id));
  }
}
async function a9(e, t = {}) {
  let r;
  if (t.connector) {
    const { connector: v } = t, [w, x] = await Promise.all([
      v.getAccounts(),
      v.getChainId()
    ]);
    r = {
      accounts: w,
      chainId: x,
      connector: v
    };
  } else
    r = e.state.connections.get(e.state.current);
  if (!r)
    throw new t9();
  const o = t.chainId ?? r.chainId, l = r.connector;
  if (l.getClient)
    return l.getClient({ chainId: o });
  const d = fi(t.account ?? r.accounts[0]);
  d.address = ax(d.address);
  const f = e.chains.find((v) => v.id === o), m = await r.connector.getProvider({ chainId: o });
  if (t.account && !r.accounts.some((v) => v.toLowerCase() === d.address.toLowerCase()))
    throw new n9({
      address: d.address,
      connector: l
    });
  return A1({
    account: d,
    chain: f,
    name: "Connector Client",
    transport: (v) => jB(m)({ ...v, retryCount: 0 })
  });
}
function FD(e) {
  return typeof e == "number" ? e : e === "wei" ? 0 : Math.abs(aF[e]);
}
function zD(e) {
  const t = e.state.current, r = e.state.connections.get(t), o = r == null ? void 0 : r.accounts, l = o == null ? void 0 : o[0], d = e.chains.find((m) => m.id === (r == null ? void 0 : r.chainId)), f = e.state.status;
  switch (f) {
    case "connected":
      return {
        address: l,
        addresses: o,
        chain: d,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !0,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !1,
        status: f
      };
    case "reconnecting":
      return {
        address: l,
        addresses: o,
        chain: d,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !!l,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !0,
        status: f
      };
    case "connecting":
      return {
        address: l,
        addresses: o,
        chain: d,
        chainId: r == null ? void 0 : r.chainId,
        connector: r == null ? void 0 : r.connector,
        isConnected: !1,
        isConnecting: !0,
        isDisconnected: !1,
        isReconnecting: !1,
        status: f
      };
    case "disconnected":
      return {
        address: void 0,
        addresses: void 0,
        chain: void 0,
        chainId: void 0,
        connector: void 0,
        isConnected: !1,
        isConnecting: !1,
        isDisconnected: !0,
        isReconnecting: !1,
        status: f
      };
  }
}
async function i9(e, t) {
  const { allowFailure: r = !0, chainId: o, contracts: l, ...d } = t, f = e.getClient({ chainId: o });
  return d0(f, gD, "multicall")({
    allowFailure: r,
    contracts: l,
    ...d
  });
}
function BD(e, t) {
  const { chainId: r, ...o } = t, l = e.getClient({ chainId: r });
  return d0(l, Ts, "readContract")(o);
}
async function o9(e, t) {
  const { allowFailure: r = !0, blockNumber: o, blockTag: l, ...d } = t, f = t.contracts;
  try {
    const m = f.reduce((b, k, T) => {
      const O = k.chainId ?? e.state.chainId;
      return {
        ...b,
        [O]: [...b[O] || [], { contract: k, index: T }]
      };
    }, {}), v = () => Object.entries(m).map(([b, k]) => i9(e, {
      ...d,
      allowFailure: r,
      blockNumber: o,
      blockTag: l,
      chainId: parseInt(b),
      contracts: k.map(({ contract: T }) => T)
    })), w = (await Promise.all(v())).flat(), x = Object.values(m).flatMap((b) => b.map(({ index: k }) => k));
    return w.reduce((b, k, T) => (b && (b[x[T]] = k), b), []);
  } catch (m) {
    if (m instanceof o3)
      throw m;
    const v = () => f.map((w) => BD(e, { ...w, blockNumber: o, blockTag: l }));
    return r ? (await Promise.allSettled(v())).map((w) => w.status === "fulfilled" ? { result: w.value, status: "success" } : { error: w.reason, result: void 0, status: "failure" }) : await Promise.all(v());
  }
}
async function s9(e, t) {
  const { address: r, blockNumber: o, blockTag: l, chainId: d, token: f, unit: m = "ether" } = t;
  if (f)
    try {
      return TP(e, {
        balanceAddress: r,
        chainId: d,
        symbolType: "string",
        tokenAddress: f
      });
    } catch (k) {
      if (k instanceof o3) {
        const T = await TP(e, {
          balanceAddress: r,
          chainId: d,
          symbolType: "bytes32",
          tokenAddress: f
        }), O = eg(ks(T.symbol, { dir: "right" }));
        return { ...T, symbol: O };
      }
      throw k;
    }
  const v = e.getClient({ chainId: d }), x = await d0(v, rD, "getBalance")(o ? { address: r, blockNumber: o } : { address: r, blockTag: l }), b = e.chains.find((k) => k.id === d) ?? v.chain;
  return {
    decimals: b.nativeCurrency.decimals,
    formatted: ox(x, FD(m)),
    symbol: b.nativeCurrency.symbol,
    value: x
  };
}
async function TP(e, t) {
  const { balanceAddress: r, chainId: o, symbolType: l, tokenAddress: d, unit: f } = t, m = {
    abi: [
      {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [{ type: "address" }],
        outputs: [{ type: "uint256" }]
      },
      {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: "uint8" }]
      },
      {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: l }]
      }
    ],
    address: d
  }, [v, w, x] = await o9(e, {
    allowFailure: !1,
    contracts: [
      {
        ...m,
        functionName: "balanceOf",
        args: [r],
        chainId: o
      },
      { ...m, functionName: "decimals", chainId: o },
      { ...m, functionName: "symbol", chainId: o }
    ]
  }), b = ox(v ?? "0", FD(f ?? w));
  return { decimals: w, formatted: b, symbol: x, value: v };
}
async function u9(e, t = {}) {
  const { chainId: r, ...o } = t, l = e.getClient({ chainId: r });
  return {
    ...await d0(l, Nl, "getBlock")(o),
    chainId: l.chain.id
  };
}
function _P(e) {
  return e.state.chainId;
}
function md(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    let r, o;
    if (Array.isArray(e) && Array.isArray(t)) {
      if (r = e.length, r !== t.length)
        return !1;
      for (o = r; o-- !== 0; )
        if (!md(e[o], t[o]))
          return !1;
      return !0;
    }
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const l = Object.keys(e);
    if (r = l.length, r !== Object.keys(t).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, l[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      const d = l[o];
      if (d && !md(e[d], t[d]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
let SE = [];
function RP(e) {
  const t = e.chains;
  return md(SE, t) ? SE : (SE = t, t);
}
function l9(e, t = {}) {
  let r;
  try {
    r = e.getClient(t);
  } catch {
  }
  return r;
}
let y1 = [];
function jC(e) {
  const t = [...e.state.connections.values()];
  return e.state.status === "reconnecting" || md(y1, t) ? y1 : (y1 = t, t);
}
function AC(e, t = {}) {
  const r = l9(e, t);
  return r == null ? void 0 : r.extend(C1);
}
async function c9(e, t = {}) {
  const r = await a9(e, t);
  return r.extend(CC), r.extend(CC);
}
let kE = !1;
async function d9(e, t = {}) {
  var w, x;
  if (kE)
    return [];
  kE = !0, e.setState((b) => ({
    ...b,
    status: b.current ? "reconnecting" : "connecting"
  }));
  const r = [];
  if ((w = t.connectors) != null && w.length)
    for (const b of t.connectors) {
      let k;
      typeof b == "function" ? k = e._internal.connectors.setup(b) : k = b, r.push(k);
    }
  else
    r.push(...e.connectors);
  let o;
  try {
    o = await ((x = e.storage) == null ? void 0 : x.getItem("recentConnectorId"));
  } catch {
  }
  const l = {};
  for (const [, b] of e.state.connections)
    l[b.connector.id] = 1;
  o && (l[o] = 0);
  const d = Object.keys(l).length > 0 ? (
    // .toSorted()
    [...r].sort((b, k) => (l[b.id] ?? 10) - (l[k.id] ?? 10))
  ) : r;
  let f = !1;
  const m = [], v = [];
  for (const b of d) {
    const k = await b.getProvider().catch(() => {
    });
    if (!k || v.some((R) => R === k) || !await b.isAuthorized())
      continue;
    const O = await b.connect({ isReconnecting: !0 }).catch(() => null);
    O && (b.emitter.off("connect", e._internal.events.connect), b.emitter.on("change", e._internal.events.change), b.emitter.on("disconnect", e._internal.events.disconnect), e.setState((R) => {
      const j = new Map(f ? R.connections : /* @__PURE__ */ new Map()).set(b.uid, { accounts: O.accounts, chainId: O.chainId, connector: b });
      return {
        ...R,
        current: f ? R.current : b.uid,
        connections: j
      };
    }), m.push({
      accounts: O.accounts,
      chainId: O.chainId,
      connector: b
    }), v.push(k), f = !0);
  }
  return (e.state.status === "reconnecting" || e.state.status === "connecting") && (f ? e.setState((b) => ({ ...b, status: "connected" })) : e.setState((b) => ({
    ...b,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), kE = !1, m;
}
function f9(e, t) {
  const { onChange: r } = t;
  return e.subscribe(() => zD(e), r, {
    equalityFn(o, l) {
      const { connector: d, ...f } = o, { connector: m, ...v } = l;
      return md(f, v) && // check connector separately
      (d == null ? void 0 : d.id) === (m == null ? void 0 : m.id) && (d == null ? void 0 : d.uid) === (m == null ? void 0 : m.uid);
    }
  });
}
function p9(e, t) {
  const { syncConnectedChain: r = e._internal.syncConnectedChain, ...o } = t;
  let l;
  const d = (v) => {
    l && l();
    const w = e.getClient({ chainId: v });
    return l = d0(w, CD, "watchBlocks")(o), l;
  }, f = d(t.chainId);
  let m;
  return r && !t.chainId && (m = e.subscribe(({ chainId: v }) => v, async (v) => d(v))), () => {
    f == null || f(), m == null || m();
  };
}
function h9(e, t) {
  const { onChange: r } = t;
  return e.subscribe((o) => o.chainId, r);
}
function m9(e, t) {
  const { onChange: r } = t;
  return e.subscribe(() => jC(e), r, {
    equalityFn: md
  });
}
function y9(e, t) {
  const { onChange: r } = t;
  return e.subscribe(() => AC(e), r, {
    equalityFn(o, l) {
      return (o == null ? void 0 : o.uid) === (l == null ? void 0 : l.uid);
    }
  });
}
function v9(e, t) {
  const { initialState: r, reconnectOnMount: o } = t;
  return r && !e._internal.store.persist.hasHydrated() && e.setState({
    ...r,
    connections: o ? r.connections : /* @__PURE__ */ new Map(),
    status: o ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      var l;
      if (e._internal.ssr) {
        await e._internal.store.persist.rehydrate();
        const d = (l = e._internal.mipd) == null ? void 0 : l.getProviders().map(e._internal.connectors.providerDetailToConnector).map(e._internal.connectors.setup);
        e._internal.connectors.setState((f) => [
          ...f,
          ...d ?? []
        ]);
      }
      o ? d9(e) : e.storage && e.setState((d) => ({
        ...d,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
function g9(e) {
  const { children: t, config: r, initialState: o, reconnectOnMount: l = !0 } = e, { onMount: d } = v9(r, {
    initialState: o,
    reconnectOnMount: l
  });
  r._internal.ssr || d();
  const f = $.useRef(!0);
  return $.useEffect(() => {
    if (f.current && r._internal.ssr)
      return d(), () => {
        f.current = !1;
      };
  }, []), t;
}
const UD = $.createContext(void 0);
function mX(e) {
  const { children: t, config: r } = e, o = { value: r };
  return $.createElement(g9, e, $.createElement(UD.Provider, o, t));
}
const b9 = "2.9.4", w9 = () => `wagmi@${b9}`;
class x9 extends c0 {
  constructor() {
    super(...arguments), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiError"
    });
  }
  get docsBaseUrl() {
    return "https://wagmi.sh/react";
  }
  get version() {
    return w9();
  }
}
class S9 extends x9 {
  constructor() {
    super("`useConfig` must be used within `WagmiProvider`.", {
      docsPath: "/api/WagmiProvider"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiProviderNotFoundError"
    });
  }
}
var gx = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, vm = typeof window > "u" || "Deno" in globalThis;
function DC() {
}
function yX(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function IC(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function HD(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function vX(e, t) {
  const {
    type: r = "all",
    exact: o,
    fetchStatus: l,
    predicate: d,
    queryKey: f,
    stale: m
  } = e;
  if (f) {
    if (o) {
      if (t.queryHash !== k9(f, t.options))
        return !1;
    } else if (!k3(t.queryKey, f))
      return !1;
  }
  if (r !== "all") {
    const v = t.isActive();
    if (r === "active" && !v || r === "inactive" && v)
      return !1;
  }
  return !(typeof m == "boolean" && t.isStale() !== m || l && l !== t.state.fetchStatus || d && !d(t));
}
function gX(e, t) {
  const { exact: r, status: o, predicate: l, mutationKey: d } = e;
  if (d) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (Eg(t.options.mutationKey) !== Eg(d))
        return !1;
    } else if (!k3(t.options.mutationKey, d))
      return !1;
  }
  return !(o && t.state.status !== o || l && !l(t));
}
function k9(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Eg)(e);
}
function Eg(e) {
  return JSON.stringify(
    e,
    (t, r) => MC(r) ? Object.keys(r).sort().reduce((o, l) => (o[l] = r[l], o), {}) : r
  );
}
function k3(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((r) => !k3(e[r], t[r])) : !1;
}
function E3(e, t) {
  if (e === t)
    return e;
  const r = OP(e) && OP(t);
  if (r || MC(e) && MC(t)) {
    const o = r ? e : Object.keys(e), l = o.length, d = r ? t : Object.keys(t), f = d.length, m = r ? [] : {};
    let v = 0;
    for (let w = 0; w < f; w++) {
      const x = r ? w : d[w];
      (!r && o.includes(x) || r) && e[x] === void 0 && t[x] === void 0 ? (m[x] = void 0, v++) : (m[x] = E3(e[x], t[x]), m[x] === e[x] && e[x] !== void 0 && v++);
    }
    return l === f && v === l ? e : m;
  }
  return t;
}
function I1(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function OP(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function MC(e) {
  if (!PP(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(!PP(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function PP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function E9(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function $C(e, t, r) {
  return typeof r.structuralSharing == "function" ? r.structuralSharing(e, t) : r.structuralSharing !== !1 ? E3(e, t) : t;
}
function bX(e, t, r = 0) {
  const o = [...e, t];
  return r && o.length > r ? o.slice(1) : o;
}
function wX(e, t, r = 0) {
  const o = [t, ...e];
  return r && o.length > r ? o.slice(0, -1) : o;
}
var jP = Symbol(), If, id, tm, Lj, C9 = (Lj = class extends gx {
  constructor() {
    super();
    Ot(this, If, void 0);
    Ot(this, id, void 0);
    Ot(this, tm, void 0);
    xt(this, tm, (t) => {
      if (!vm && window.addEventListener) {
        const r = () => t();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    le(this, id) || this.setEventListener(le(this, tm));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = le(this, id)) == null || t.call(this), xt(this, id, void 0));
  }
  setEventListener(t) {
    var r;
    xt(this, tm, t), (r = le(this, id)) == null || r.call(this), xt(this, id, t((o) => {
      typeof o == "boolean" ? this.setFocused(o) : this.onFocus();
    }));
  }
  setFocused(t) {
    le(this, If) !== t && (xt(this, If, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((r) => {
      r(t);
    });
  }
  isFocused() {
    var t;
    return typeof le(this, If) == "boolean" ? le(this, If) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, If = new WeakMap(), id = new WeakMap(), tm = new WeakMap(), Lj), VD = new C9(), nm, od, rm, Nj, T9 = (Nj = class extends gx {
  constructor() {
    super();
    Ot(this, nm, !0);
    Ot(this, od, void 0);
    Ot(this, rm, void 0);
    xt(this, rm, (t) => {
      if (!vm && window.addEventListener) {
        const r = () => t(!0), o = () => t(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", o, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", o);
        };
      }
    });
  }
  onSubscribe() {
    le(this, od) || this.setEventListener(le(this, rm));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = le(this, od)) == null || t.call(this), xt(this, od, void 0));
  }
  setEventListener(t) {
    var r;
    xt(this, rm, t), (r = le(this, od)) == null || r.call(this), xt(this, od, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    le(this, nm) !== t && (xt(this, nm, t), this.listeners.forEach((o) => {
      o(t);
    }));
  }
  isOnline() {
    return le(this, nm);
  }
}, nm = new WeakMap(), od = new WeakMap(), rm = new WeakMap(), Nj), GD = new T9();
function _9(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function qD(e) {
  return (e ?? "online") === "online" ? GD.isOnline() : !0;
}
var WD = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function EE(e) {
  return e instanceof WD;
}
function YD(e) {
  let t = !1, r = 0, o = !1, l, d, f;
  const m = new Promise((I, N) => {
    d = I, f = N;
  }), v = (I) => {
    var N;
    o || (O(new WD(I)), (N = e.abort) == null || N.call(e));
  }, w = () => {
    t = !0;
  }, x = () => {
    t = !1;
  }, b = () => VD.isFocused() && (e.networkMode === "always" || GD.isOnline()) && e.canRun(), k = () => qD(e.networkMode) && e.canRun(), T = (I) => {
    var N;
    o || (o = !0, (N = e.onSuccess) == null || N.call(e, I), l == null || l(), d(I));
  }, O = (I) => {
    var N;
    o || (o = !0, (N = e.onError) == null || N.call(e, I), l == null || l(), f(I));
  }, R = () => new Promise((I) => {
    var N;
    l = (L) => {
      (o || b()) && I(L);
    }, (N = e.onPause) == null || N.call(e);
  }).then(() => {
    var I;
    l = void 0, o || (I = e.onContinue) == null || I.call(e);
  }), j = () => {
    if (o)
      return;
    let I;
    try {
      I = e.fn();
    } catch (N) {
      I = Promise.reject(N);
    }
    Promise.resolve(I).then(T).catch((N) => {
      var W;
      if (o)
        return;
      const L = e.retry ?? (vm ? 0 : 3), B = e.retryDelay ?? _9, H = typeof B == "function" ? B(r, N) : B, V = L === !0 || typeof L == "number" && r < L || typeof L == "function" && L(r, N);
      if (t || !V) {
        O(N);
        return;
      }
      r++, (W = e.onFail) == null || W.call(e, r, N), E9(H).then(() => b() ? void 0 : R()).then(() => {
        t ? O(N) : j();
      });
    });
  };
  return {
    promise: m,
    cancel: v,
    continue: () => (l == null || l(), m),
    cancelRetry: w,
    continueRetry: x,
    canStart: k,
    start: () => (k() ? j() : R().then(j), m)
  };
}
function R9() {
  let e = [], t = 0, r = (k) => {
    k();
  }, o = (k) => {
    k();
  }, l = (k) => setTimeout(k, 0);
  const d = (k) => {
    l = k;
  }, f = (k) => {
    let T;
    t++;
    try {
      T = k();
    } finally {
      t--, t || w();
    }
    return T;
  }, m = (k) => {
    t ? e.push(k) : l(() => {
      r(k);
    });
  }, v = (k) => (...T) => {
    m(() => {
      k(...T);
    });
  }, w = () => {
    const k = e;
    e = [], k.length && l(() => {
      o(() => {
        k.forEach((T) => {
          r(T);
        });
      });
    });
  };
  return {
    batch: f,
    batchCalls: v,
    schedule: m,
    setNotifyFunction: (k) => {
      r = k;
    },
    setBatchNotifyFunction: (k) => {
      o = k;
    },
    setScheduler: d
  };
}
var _m = R9(), Mf, Fj, ZD = (Fj = class {
  constructor() {
    Ot(this, Mf, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), IC(this.gcTime) && xt(this, Mf, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (vm ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    le(this, Mf) && (clearTimeout(le(this, Mf)), xt(this, Mf, void 0));
  }
}, Mf = new WeakMap(), Fj), am, im, Ao, ui, Hg, $f, ws, Tl, zj, xX = (zj = class extends ZD {
  constructor(t) {
    super();
    Ot(this, ws);
    Ot(this, am, void 0);
    Ot(this, im, void 0);
    Ot(this, Ao, void 0);
    Ot(this, ui, void 0);
    Ot(this, Hg, void 0);
    Ot(this, $f, void 0);
    xt(this, $f, !1), xt(this, Hg, t.defaultOptions), this.setOptions(t.options), this.observers = [], xt(this, Ao, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, xt(this, am, t.state || O9(this.options)), this.state = le(this, am), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = { ...le(this, Hg), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && le(this, Ao).remove(this);
  }
  setData(t, r) {
    const o = $C(this.state.data, t, this.options);
    return Ut(this, ws, Tl).call(this, {
      data: o,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), o;
  }
  setState(t, r) {
    Ut(this, ws, Tl).call(this, { type: "setState", state: t, setStateOptions: r });
  }
  cancel(t) {
    var o, l;
    const r = (o = le(this, ui)) == null ? void 0 : o.promise;
    return (l = le(this, ui)) == null || l.cancel(t), r ? r.then(DC).catch(DC) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(le(this, am));
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !HD(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var r;
    const t = this.observers.find((o) => o.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (r = le(this, ui)) == null || r.continue();
  }
  onOnline() {
    var r;
    const t = this.observers.find((o) => o.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (r = le(this, ui)) == null || r.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), le(this, Ao).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((r) => r !== t), this.observers.length || (le(this, ui) && (le(this, $f) ? le(this, ui).cancel({ revert: !0 }) : le(this, ui).cancelRetry()), this.scheduleGc()), le(this, Ao).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || Ut(this, ws, Tl).call(this, { type: "invalidate" });
  }
  fetch(t, r) {
    var w, x, b;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (r != null && r.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (le(this, ui))
        return le(this, ui).continueRetry(), le(this, ui).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const k = this.observers.find((T) => T.options.queryFn);
      k && this.setOptions(k.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const o = new AbortController(), l = {
      queryKey: this.queryKey,
      meta: this.meta
    }, d = (k) => {
      Object.defineProperty(k, "signal", {
        enumerable: !0,
        get: () => (xt(this, $f, !0), o.signal)
      });
    };
    d(l);
    const f = () => (process.env.NODE_ENV !== "production" && this.options.queryFn === jP && console.error(
      `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${this.options.queryHash}'`
    ), !this.options.queryFn || this.options.queryFn === jP ? Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ) : (xt(this, $f, !1), this.options.persister ? this.options.persister(
      this.options.queryFn,
      l,
      this
    ) : this.options.queryFn(
      l
    ))), m = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: f
    };
    d(m), (w = this.options.behavior) == null || w.onFetch(
      m,
      this
    ), xt(this, im, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((x = m.fetchOptions) == null ? void 0 : x.meta)) && Ut(this, ws, Tl).call(this, { type: "fetch", meta: (b = m.fetchOptions) == null ? void 0 : b.meta });
    const v = (k) => {
      var T, O, R, j;
      EE(k) && k.silent || Ut(this, ws, Tl).call(this, {
        type: "error",
        error: k
      }), EE(k) || ((O = (T = le(this, Ao).config).onError) == null || O.call(
        T,
        k,
        this
      ), (j = (R = le(this, Ao).config).onSettled) == null || j.call(
        R,
        this.state.data,
        k,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return xt(this, ui, YD({
      fn: m.fetchFn,
      abort: o.abort.bind(o),
      onSuccess: (k) => {
        var T, O, R, j;
        if (k === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), v(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(k), (O = (T = le(this, Ao).config).onSuccess) == null || O.call(T, k, this), (j = (R = le(this, Ao).config).onSettled) == null || j.call(
          R,
          k,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: v,
      onFail: (k, T) => {
        Ut(this, ws, Tl).call(this, { type: "failed", failureCount: k, error: T });
      },
      onPause: () => {
        Ut(this, ws, Tl).call(this, { type: "pause" });
      },
      onContinue: () => {
        Ut(this, ws, Tl).call(this, { type: "continue" });
      },
      retry: m.options.retry,
      retryDelay: m.options.retryDelay,
      networkMode: m.options.networkMode,
      canRun: () => !0
    })), le(this, ui).start();
  }
}, am = new WeakMap(), im = new WeakMap(), Ao = new WeakMap(), ui = new WeakMap(), Hg = new WeakMap(), $f = new WeakMap(), ws = new WeakSet(), Tl = function(t) {
  const r = (o) => {
    switch (t.type) {
      case "failed":
        return {
          ...o,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...o,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...o,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...o,
          ...KD(o.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...o,
          data: t.data,
          dataUpdateCount: o.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const l = t.error;
        return EE(l) && l.revert && le(this, im) ? { ...le(this, im), fetchStatus: "idle" } : {
          ...o,
          error: l,
          errorUpdateCount: o.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: o.fetchFailureCount + 1,
          fetchFailureReason: l,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...o,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...o,
          ...t.state
        };
    }
  };
  this.state = r(this.state), _m.batch(() => {
    this.observers.forEach((o) => {
      o.onQueryUpdate();
    }), le(this, Ao).notify({ query: this, type: "updated", action: t });
  });
}, zj);
function KD(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: qD(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function O9(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, r = t !== void 0, o = r ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? o ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var ku, li, Lf, Eu, td, Bj, SX = (Bj = class extends ZD {
  constructor(t) {
    super();
    Ot(this, Eu);
    Ot(this, ku, void 0);
    Ot(this, li, void 0);
    Ot(this, Lf, void 0);
    this.mutationId = t.mutationId, xt(this, li, t.mutationCache), xt(this, ku, []), this.state = t.state || QD(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    le(this, ku).includes(t) || (le(this, ku).push(t), this.clearGcTimeout(), le(this, li).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    xt(this, ku, le(this, ku).filter((r) => r !== t)), this.scheduleGc(), le(this, li).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    le(this, ku).length || (this.state.status === "pending" ? this.scheduleGc() : le(this, li).remove(this));
  }
  continue() {
    var t;
    return ((t = le(this, Lf)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var l, d, f, m, v, w, x, b, k, T, O, R, j, I, N, L, B, H, V, W;
    xt(this, Lf, YD({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (Y, ce) => {
        Ut(this, Eu, td).call(this, { type: "failed", failureCount: Y, error: ce });
      },
      onPause: () => {
        Ut(this, Eu, td).call(this, { type: "pause" });
      },
      onContinue: () => {
        Ut(this, Eu, td).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => le(this, li).canRun(this)
    }));
    const r = this.state.status === "pending", o = !le(this, Lf).canStart();
    try {
      if (!r) {
        Ut(this, Eu, td).call(this, { type: "pending", variables: t, isPaused: o }), await ((d = (l = le(this, li).config).onMutate) == null ? void 0 : d.call(
          l,
          t,
          this
        ));
        const ce = await ((m = (f = this.options).onMutate) == null ? void 0 : m.call(f, t));
        ce !== this.state.context && Ut(this, Eu, td).call(this, {
          type: "pending",
          context: ce,
          variables: t,
          isPaused: o
        });
      }
      const Y = await le(this, Lf).start();
      return await ((w = (v = le(this, li).config).onSuccess) == null ? void 0 : w.call(
        v,
        Y,
        t,
        this.state.context,
        this
      )), await ((b = (x = this.options).onSuccess) == null ? void 0 : b.call(x, Y, t, this.state.context)), await ((T = (k = le(this, li).config).onSettled) == null ? void 0 : T.call(
        k,
        Y,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((R = (O = this.options).onSettled) == null ? void 0 : R.call(O, Y, null, t, this.state.context)), Ut(this, Eu, td).call(this, { type: "success", data: Y }), Y;
    } catch (Y) {
      try {
        throw await ((I = (j = le(this, li).config).onError) == null ? void 0 : I.call(
          j,
          Y,
          t,
          this.state.context,
          this
        )), await ((L = (N = this.options).onError) == null ? void 0 : L.call(
          N,
          Y,
          t,
          this.state.context
        )), await ((H = (B = le(this, li).config).onSettled) == null ? void 0 : H.call(
          B,
          void 0,
          Y,
          this.state.variables,
          this.state.context,
          this
        )), await ((W = (V = this.options).onSettled) == null ? void 0 : W.call(
          V,
          void 0,
          Y,
          t,
          this.state.context
        )), Y;
      } finally {
        Ut(this, Eu, td).call(this, { type: "error", error: Y });
      }
    } finally {
      le(this, li).runNext(this);
    }
  }
}, ku = new WeakMap(), li = new WeakMap(), Lf = new WeakMap(), Eu = new WeakSet(), td = function(t) {
  const r = (o) => {
    switch (t.type) {
      case "failed":
        return {
          ...o,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...o,
          isPaused: !0
        };
      case "continue":
        return {
          ...o,
          isPaused: !1
        };
      case "pending":
        return {
          ...o,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...o,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...o,
          data: void 0,
          error: t.error,
          failureCount: o.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = r(this.state), _m.batch(() => {
    le(this, ku).forEach((o) => {
      o.onMutationUpdate(t);
    }), le(this, li).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, Bj);
function QD() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var $i, Bn, Vg, ci, Nf, om, Cu, Gg, sm, um, Ff, zf, sd, lm, Bf, Qv, qg, LC, Wg, NC, Yg, FC, Zg, zC, Kg, BC, Qg, UC, Xg, HC, Q1, XD, Uj, P9 = (Uj = class extends gx {
  constructor(t, r) {
    super();
    Ot(this, Bf);
    Ot(this, qg);
    Ot(this, Wg);
    Ot(this, Yg);
    Ot(this, Zg);
    Ot(this, Kg);
    Ot(this, Qg);
    Ot(this, Xg);
    Ot(this, Q1);
    Ot(this, $i, void 0);
    Ot(this, Bn, void 0);
    Ot(this, Vg, void 0);
    Ot(this, ci, void 0);
    Ot(this, Nf, void 0);
    Ot(this, om, void 0);
    Ot(this, Cu, void 0);
    Ot(this, Gg, void 0);
    Ot(this, sm, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    Ot(this, um, void 0);
    Ot(this, Ff, void 0);
    Ot(this, zf, void 0);
    Ot(this, sd, void 0);
    Ot(this, lm, /* @__PURE__ */ new Set());
    this.options = r, xt(this, $i, t), xt(this, Cu, null), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (le(this, Bn).addObserver(this), AP(le(this, Bn), this.options) ? Ut(this, Bf, Qv).call(this) : this.updateResult(), Ut(this, Zg, zC).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return VC(
      le(this, Bn),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return VC(
      le(this, Bn),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Ut(this, Kg, BC).call(this), Ut(this, Qg, UC).call(this), le(this, Bn).removeObserver(this);
  }
  setOptions(t, r) {
    const o = this.options, l = le(this, Bn);
    if (this.options = le(this, $i).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    Ut(this, Xg, HC).call(this), le(this, Bn).setOptions(this.options), o._defaulted && !I1(this.options, o) && le(this, $i).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: le(this, Bn),
      observer: this
    });
    const d = this.hasListeners();
    d && DP(
      le(this, Bn),
      l,
      this.options,
      o
    ) && Ut(this, Bf, Qv).call(this), this.updateResult(r), d && (le(this, Bn) !== l || this.options.enabled !== o.enabled || this.options.staleTime !== o.staleTime) && Ut(this, qg, LC).call(this);
    const f = Ut(this, Wg, NC).call(this);
    d && (le(this, Bn) !== l || this.options.enabled !== o.enabled || f !== le(this, sd)) && Ut(this, Yg, FC).call(this, f);
  }
  getOptimisticResult(t) {
    const r = le(this, $i).getQueryCache().build(le(this, $i), t), o = this.createResult(r, t);
    return A9(this, o) && (xt(this, ci, o), xt(this, om, this.options), xt(this, Nf, le(this, Bn).state)), o;
  }
  getCurrentResult() {
    return le(this, ci);
  }
  trackResult(t, r) {
    const o = {};
    return Object.keys(t).forEach((l) => {
      Object.defineProperty(o, l, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(l), r == null || r(l), t[l])
      });
    }), o;
  }
  trackProp(t) {
    le(this, lm).add(t);
  }
  getCurrentQuery() {
    return le(this, Bn);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const r = le(this, $i).defaultQueryOptions(t), o = le(this, $i).getQueryCache().build(le(this, $i), r);
    return o.isFetchingOptimistic = !0, o.fetch().then(() => this.createResult(o, r));
  }
  fetch(t) {
    return Ut(this, Bf, Qv).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), le(this, ci)));
  }
  createResult(t, r) {
    var W;
    const o = le(this, Bn), l = this.options, d = le(this, ci), f = le(this, Nf), m = le(this, om), w = t !== o ? t.state : le(this, Vg), { state: x } = t;
    let b = { ...x }, k = !1, T;
    if (r._optimisticResults) {
      const Y = this.hasListeners(), ce = !Y && AP(t, r), ve = Y && DP(t, o, r, l);
      (ce || ve) && (b = {
        ...b,
        ...KD(x.data, t.options)
      }), r._optimisticResults === "isRestoring" && (b.fetchStatus = "idle");
    }
    let { error: O, errorUpdatedAt: R, status: j } = b;
    if (r.select && b.data !== void 0)
      if (d && b.data === (f == null ? void 0 : f.data) && r.select === le(this, Gg))
        T = le(this, sm);
      else
        try {
          xt(this, Gg, r.select), T = r.select(b.data), T = $C(d == null ? void 0 : d.data, T, r), xt(this, sm, T), xt(this, Cu, null);
        } catch (Y) {
          xt(this, Cu, Y);
        }
    else
      T = b.data;
    if (r.placeholderData !== void 0 && T === void 0 && j === "pending") {
      let Y;
      if (d != null && d.isPlaceholderData && r.placeholderData === (m == null ? void 0 : m.placeholderData))
        Y = d.data;
      else if (Y = typeof r.placeholderData == "function" ? r.placeholderData(
        (W = le(this, um)) == null ? void 0 : W.state.data,
        le(this, um)
      ) : r.placeholderData, r.select && Y !== void 0)
        try {
          Y = r.select(Y), xt(this, Cu, null);
        } catch (ce) {
          xt(this, Cu, ce);
        }
      Y !== void 0 && (j = "success", T = $C(
        d == null ? void 0 : d.data,
        Y,
        r
      ), k = !0);
    }
    le(this, Cu) && (O = le(this, Cu), T = le(this, sm), R = Date.now(), j = "error");
    const I = b.fetchStatus === "fetching", N = j === "pending", L = j === "error", B = N && I, H = T !== void 0;
    return {
      status: j,
      fetchStatus: b.fetchStatus,
      isPending: N,
      isSuccess: j === "success",
      isError: L,
      isInitialLoading: B,
      isLoading: B,
      data: T,
      dataUpdatedAt: b.dataUpdatedAt,
      error: O,
      errorUpdatedAt: R,
      failureCount: b.fetchFailureCount,
      failureReason: b.fetchFailureReason,
      errorUpdateCount: b.errorUpdateCount,
      isFetched: b.dataUpdateCount > 0 || b.errorUpdateCount > 0,
      isFetchedAfterMount: b.dataUpdateCount > w.dataUpdateCount || b.errorUpdateCount > w.errorUpdateCount,
      isFetching: I,
      isRefetching: I && !N,
      isLoadingError: L && !H,
      isPaused: b.fetchStatus === "paused",
      isPlaceholderData: k,
      isRefetchError: L && H,
      isStale: C3(t, r),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const r = le(this, ci), o = this.createResult(le(this, Bn), this.options);
    if (xt(this, Nf, le(this, Bn).state), xt(this, om, this.options), le(this, Nf).data !== void 0 && xt(this, um, le(this, Bn)), I1(o, r))
      return;
    xt(this, ci, o);
    const l = {}, d = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: f } = this.options, m = typeof f == "function" ? f() : f;
      if (m === "all" || !m && !le(this, lm).size)
        return !0;
      const v = new Set(
        m ?? le(this, lm)
      );
      return this.options.throwOnError && v.add("error"), Object.keys(le(this, ci)).some((w) => {
        const x = w;
        return le(this, ci)[x] !== r[x] && v.has(x);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && d() && (l.listeners = !0), Ut(this, Q1, XD).call(this, { ...l, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Ut(this, Zg, zC).call(this);
  }
}, $i = new WeakMap(), Bn = new WeakMap(), Vg = new WeakMap(), ci = new WeakMap(), Nf = new WeakMap(), om = new WeakMap(), Cu = new WeakMap(), Gg = new WeakMap(), sm = new WeakMap(), um = new WeakMap(), Ff = new WeakMap(), zf = new WeakMap(), sd = new WeakMap(), lm = new WeakMap(), Bf = new WeakSet(), Qv = function(t) {
  Ut(this, Xg, HC).call(this);
  let r = le(this, Bn).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (r = r.catch(DC)), r;
}, qg = new WeakSet(), LC = function() {
  if (Ut(this, Kg, BC).call(this), vm || le(this, ci).isStale || !IC(this.options.staleTime))
    return;
  const r = HD(
    le(this, ci).dataUpdatedAt,
    this.options.staleTime
  ) + 1;
  xt(this, Ff, setTimeout(() => {
    le(this, ci).isStale || this.updateResult();
  }, r));
}, Wg = new WeakSet(), NC = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(le(this, Bn)) : this.options.refetchInterval) ?? !1;
}, Yg = new WeakSet(), FC = function(t) {
  Ut(this, Qg, UC).call(this), xt(this, sd, t), !(vm || this.options.enabled === !1 || !IC(le(this, sd)) || le(this, sd) === 0) && xt(this, zf, setInterval(() => {
    (this.options.refetchIntervalInBackground || VD.isFocused()) && Ut(this, Bf, Qv).call(this);
  }, le(this, sd)));
}, Zg = new WeakSet(), zC = function() {
  Ut(this, qg, LC).call(this), Ut(this, Yg, FC).call(this, Ut(this, Wg, NC).call(this));
}, Kg = new WeakSet(), BC = function() {
  le(this, Ff) && (clearTimeout(le(this, Ff)), xt(this, Ff, void 0));
}, Qg = new WeakSet(), UC = function() {
  le(this, zf) && (clearInterval(le(this, zf)), xt(this, zf, void 0));
}, Xg = new WeakSet(), HC = function() {
  const t = le(this, $i).getQueryCache().build(le(this, $i), this.options);
  if (t === le(this, Bn))
    return;
  const r = le(this, Bn);
  xt(this, Bn, t), xt(this, Vg, t.state), this.hasListeners() && (r == null || r.removeObserver(this), t.addObserver(this));
}, Q1 = new WeakSet(), XD = function(t) {
  _m.batch(() => {
    t.listeners && this.listeners.forEach((r) => {
      r(le(this, ci));
    }), le(this, $i).getQueryCache().notify({
      query: le(this, Bn),
      type: "observerResultsUpdated"
    });
  });
}, Uj);
function j9(e, t) {
  return t.enabled !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function AP(e, t) {
  return j9(e, t) || e.state.data !== void 0 && VC(e, t, t.refetchOnMount);
}
function VC(e, t, r) {
  if (t.enabled !== !1) {
    const o = typeof r == "function" ? r(e) : r;
    return o === "always" || o !== !1 && C3(e, t);
  }
  return !1;
}
function DP(e, t, r, o) {
  return (e !== t || o.enabled === !1) && (!r.suspense || e.state.status !== "error") && C3(e, r);
}
function C3(e, t) {
  return t.enabled !== !1 && e.isStaleByTime(t.staleTime);
}
function A9(e, t) {
  return !I1(e.getCurrentResult(), t);
}
var ud, ld, Li, Rl, cm, T1, Jg, GC, Hj, D9 = (Hj = class extends gx {
  constructor(r, o) {
    super();
    Ot(this, cm);
    Ot(this, Jg);
    Ot(this, ud, void 0);
    Ot(this, ld, void 0);
    Ot(this, Li, void 0);
    Ot(this, Rl, void 0);
    xt(this, ud, r), this.setOptions(o), this.bindMethods(), Ut(this, cm, T1).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(r) {
    var l;
    const o = this.options;
    this.options = le(this, ud).defaultMutationOptions(r), I1(this.options, o) || le(this, ud).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: le(this, Li),
      observer: this
    }), o != null && o.mutationKey && this.options.mutationKey && Eg(o.mutationKey) !== Eg(this.options.mutationKey) ? this.reset() : ((l = le(this, Li)) == null ? void 0 : l.state.status) === "pending" && le(this, Li).setOptions(this.options);
  }
  onUnsubscribe() {
    var r;
    this.hasListeners() || (r = le(this, Li)) == null || r.removeObserver(this);
  }
  onMutationUpdate(r) {
    Ut(this, cm, T1).call(this), Ut(this, Jg, GC).call(this, r);
  }
  getCurrentResult() {
    return le(this, ld);
  }
  reset() {
    var r;
    (r = le(this, Li)) == null || r.removeObserver(this), xt(this, Li, void 0), Ut(this, cm, T1).call(this), Ut(this, Jg, GC).call(this);
  }
  mutate(r, o) {
    var l;
    return xt(this, Rl, o), (l = le(this, Li)) == null || l.removeObserver(this), xt(this, Li, le(this, ud).getMutationCache().build(le(this, ud), this.options)), le(this, Li).addObserver(this), le(this, Li).execute(r);
  }
}, ud = new WeakMap(), ld = new WeakMap(), Li = new WeakMap(), Rl = new WeakMap(), cm = new WeakSet(), T1 = function() {
  var o;
  const r = ((o = le(this, Li)) == null ? void 0 : o.state) ?? QD();
  xt(this, ld, {
    ...r,
    isPending: r.status === "pending",
    isSuccess: r.status === "success",
    isError: r.status === "error",
    isIdle: r.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, Jg = new WeakSet(), GC = function(r) {
  _m.batch(() => {
    var o, l, d, f, m, v, w, x;
    if (le(this, Rl) && this.hasListeners()) {
      const b = le(this, ld).variables, k = le(this, ld).context;
      (r == null ? void 0 : r.type) === "success" ? ((l = (o = le(this, Rl)).onSuccess) == null || l.call(o, r.data, b, k), (f = (d = le(this, Rl)).onSettled) == null || f.call(d, r.data, null, b, k)) : (r == null ? void 0 : r.type) === "error" && ((v = (m = le(this, Rl)).onError) == null || v.call(m, r.error, b, k), (x = (w = le(this, Rl)).onSettled) == null || x.call(
        w,
        void 0,
        r.error,
        b,
        k
      ));
    }
    this.listeners.forEach((b) => {
      b(le(this, ld));
    });
  });
}, Hj), JD = $.createContext(
  void 0
), bx = (e) => {
  const t = $.useContext(JD);
  if (e)
    return e;
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, EX = ({
  client: e,
  children: t
}) => ($.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ ze.jsx(JD.Provider, { value: e, children: t })), e5 = $.createContext(!1), I9 = () => $.useContext(e5);
e5.Provider;
function M9() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var $9 = $.createContext(M9()), L9 = () => $.useContext($9);
function t5(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
function N9() {
}
var F9 = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, z9 = (e) => {
  $.useEffect(() => {
    e.clearReset();
  }, [e]);
}, B9 = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: r,
  query: o
}) => e.isError && !t.isReset() && !e.isFetching && o && t5(r, [e.error, o]), U9 = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, H9 = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, V9 = (e, t, r) => t.fetchOptimistic(e).catch(() => {
  r.clearReset();
});
function G9(e, t, r) {
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const o = bx(r), l = I9(), d = L9(), f = o.defaultQueryOptions(e);
  f._optimisticResults = l ? "isRestoring" : "optimistic", U9(f), F9(f, d), z9(d);
  const [m] = $.useState(
    () => new t(
      o,
      f
    )
  ), v = m.getOptimisticResult(f);
  if ($.useSyncExternalStore(
    $.useCallback(
      (w) => {
        const x = l ? () => {
        } : m.subscribe(_m.batchCalls(w));
        return m.updateResult(), x;
      },
      [m, l]
    ),
    () => m.getCurrentResult(),
    () => m.getCurrentResult()
  ), $.useEffect(() => {
    m.setOptions(f, { listeners: !1 });
  }, [f, m]), H9(f, v))
    throw V9(f, m, d);
  if (B9({
    result: v,
    errorResetBoundary: d,
    throwOnError: f.throwOnError,
    query: o.getQueryCache().get(f.queryHash)
  }))
    throw v.error;
  return f.notifyOnChangeProps ? v : m.trackResult(v);
}
function wx(e, t) {
  return G9(e, P9, t);
}
function n5(e, t) {
  const r = bx(t), [o] = $.useState(
    () => new D9(
      r,
      e
    )
  );
  $.useEffect(() => {
    o.setOptions(e);
  }, [o, e]);
  const l = $.useSyncExternalStore(
    $.useCallback(
      (f) => o.subscribe(_m.batchCalls(f)),
      [o]
    ),
    () => o.getCurrentResult(),
    () => o.getCurrentResult()
  ), d = $.useCallback(
    (f, m) => {
      o.mutate(f, m).catch(N9);
    },
    [o]
  );
  if (l.error && t5(o.options.throwOnError, [l.error]))
    throw l.error;
  return { ...l, mutate: d, mutateAsync: l.mutate };
}
function q9(e, t) {
  const { onChange: r } = t;
  return e._internal.chains.subscribe((o, l) => {
    r(o, l);
  });
}
function js(e = {}) {
  const t = e.config ?? $.useContext(UD);
  if (!t)
    throw new S9();
  return t;
}
const CE = (e) => typeof e == "object" && !Array.isArray(e);
function W9(e, t, r = t, o = md) {
  const l = $.useRef([]), d = MT.useSyncExternalStoreWithSelector(e, t, r, (f) => f, (f, m) => {
    if (CE(f) && CE(m) && l.current.length) {
      for (const v of l.current)
        if (!o(f[v], m[v]))
          return !1;
      return !0;
    }
    return o(f, m);
  });
  if (CE(d)) {
    const f = { ...d };
    return Object.defineProperties(f, Object.entries(f).reduce((m, [v, w]) => ({
      ...m,
      [v]: {
        configurable: !1,
        enumerable: !0,
        get: () => (l.current.includes(v) || l.current.push(v), w)
      }
    }), {})), f;
  }
  return d;
}
function kd(e = {}) {
  const t = js(e);
  return W9((r) => f9(t, { onChange: r }), () => zD(t));
}
function Y9(e, t) {
  return md(e, t) ? e : E3(e, t);
}
function Z9(e) {
  return JSON.stringify(e, (t, r) => K9(r) ? Object.keys(r).sort().reduce((o, l) => (o[l] = r[l], o), {}) : typeof r == "bigint" ? r.toString() : r);
}
function K9(e) {
  if (!IP(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const r = t.prototype;
  return !(!IP(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function IP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function xx(e) {
  const {
    // import('@tanstack/query-core').QueryOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    _defaulted: t,
    behavior: r,
    gcTime: o,
    initialData: l,
    initialDataUpdatedAt: d,
    maxPages: f,
    meta: m,
    networkMode: v,
    queryFn: w,
    queryHash: x,
    queryKey: b,
    queryKeyHashFn: k,
    retry: T,
    retryDelay: O,
    structuralSharing: R,
    // import('@tanstack/query-core').InfiniteQueryObserverOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    getPreviousPageParam: j,
    getNextPageParam: I,
    initialPageParam: N,
    // import('@tanstack/react-query').UseQueryOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    _optimisticResults: L,
    enabled: B,
    notifyOnChangeProps: H,
    placeholderData: V,
    refetchInterval: W,
    refetchIntervalInBackground: Y,
    refetchOnMount: ce,
    refetchOnReconnect: ve,
    refetchOnWindowFocus: Se,
    retryOnMount: De,
    select: Re,
    staleTime: Pe,
    suspense: se,
    throwOnError: ge,
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // wagmi
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    config: de,
    connector: pe,
    query: fe,
    ...z
  } = e;
  return z;
}
function Q9(e) {
  return {
    mutationFn(t) {
      return r9(e, t);
    },
    mutationKey: ["disconnect"]
  };
}
function X9(e, t = {}) {
  return {
    async queryFn({ queryKey: r }) {
      const { address: o, scopeKey: l, ...d } = r[1];
      if (!o)
        throw new Error("address is required");
      return await s9(e, {
        ...d,
        address: o
      }) ?? null;
    },
    queryKey: J9(t)
  };
}
function J9(e = {}) {
  return ["balance", xx(e)];
}
function eH(e, t = {}) {
  return {
    async queryFn({ queryKey: r }) {
      const { scopeKey: o, ...l } = r[1];
      return await u9(e, l) ?? null;
    },
    queryKey: tH(t)
  };
}
function tH(e = {}) {
  return ["block", xx(e)];
}
function nH(e, t = {}) {
  return {
    gcTime: 0,
    async queryFn({ queryKey: r }) {
      const { connector: o } = t, { connectorUid: l, scopeKey: d, ...f } = r[1];
      return c9(e, { ...f, connector: o });
    },
    queryKey: rH(t)
  };
}
function rH(e = {}) {
  const { connector: t, ...r } = e;
  return [
    "walletClient",
    { ...xx(r), connectorUid: t == null ? void 0 : t.uid }
  ];
}
function aH(e, t = {}) {
  return {
    // TODO: Support `signal` once Viem actions allow passthrough
    // https://tkdodo.eu/blog/why-you-want-react-query#bonus-cancellation
    async queryFn({ queryKey: r }) {
      const o = t.abi;
      if (!o)
        throw new Error("abi is required");
      const { address: l, functionName: d, scopeKey: f, ...m } = r[1];
      if (!l)
        throw new Error("address is required");
      if (!d)
        throw new Error("functionName is required");
      const v = m.args;
      return BD(e, {
        abi: o,
        address: l,
        functionName: d,
        args: v,
        ...m
      });
    },
    queryKey: iH(t)
  };
}
function iH(e = {}) {
  const { abi: t, ...r } = e;
  return ["readContract", xx(r)];
}
function Sx(e) {
  const t = wx({
    ...e,
    queryKeyHashFn: Z9
    // for bigint support
  });
  return t.queryKey = e.queryKey, t;
}
function f0(e = {}) {
  const t = js(e);
  return $.useSyncExternalStore((r) => h9(t, { onChange: r }), () => _P(t), () => _P(t));
}
function oH(e = {}) {
  const { address: t, query: r = {} } = e, o = js(e), l = f0({ config: o }), d = X9(o, {
    ...e,
    chainId: e.chainId ?? l
  }), f = !!(t && (r.enabled ?? !0));
  return Sx({ ...r, ...d, enabled: f });
}
function sH(e = {}) {
  const { enabled: t = !0, onBlock: r, config: o, ...l } = e, d = js(e), f = f0({ config: d }), m = e.chainId ?? f;
  $.useEffect(() => {
    if (t && r)
      return p9(d, {
        ...l,
        chainId: m,
        onBlock: r
      });
  }, [m, d, t, r, l]);
}
function uH(e = {}) {
  const { query: t = {}, watch: r } = e, o = js(e), l = bx(), d = f0({ config: o }), f = e.chainId ?? d, m = eH(o, {
    ...e,
    chainId: f
  }), v = !!(t.enabled ?? !0);
  return sH({
    config: e.config,
    chainId: e.chainId,
    ...typeof r == "object" ? r : {},
    enabled: !!(v && (typeof r == "object" ? r.enabled : r)),
    onBlock(w) {
      l.setQueryData(m.queryKey, w);
    }
  }), Sx({
    ...t,
    ...m,
    enabled: v
  });
}
function lH(e = {}) {
  const t = js(e);
  return $.useSyncExternalStore((r) => q9(t, { onChange: r }), () => RP(t), () => RP(t));
}
function cH(e = {}) {
  const t = js(e);
  return $.useSyncExternalStore((r) => m9(t, { onChange: r }), () => jC(t), () => jC(t));
}
function dH(e = {}) {
  const { mutation: t } = e, r = js(e), o = Q9(r), { mutate: l, mutateAsync: d, ...f } = n5({
    ...t,
    ...o
  });
  return {
    ...f,
    connectors: cH({ config: r }).map((m) => m.connector),
    disconnect: l,
    disconnectAsync: d
  };
}
function r5(e = {}) {
  const t = js(e);
  return MT.useSyncExternalStoreWithSelector((r) => y9(t, { onChange: r }), () => AC(t, e), () => AC(t, e), (r) => r, (r, o) => (r == null ? void 0 : r.uid) === (o == null ? void 0 : o.uid));
}
function fH(e = {}) {
  const { abi: t, address: r, functionName: o, query: l = {} } = e, d = js(e), f = f0({ config: d }), m = aH(d, { ...e, chainId: e.chainId ?? f }), v = !!(r && t && o && (l.enabled ?? !0));
  return Sx({
    ...l,
    ...m,
    enabled: v,
    structuralSharing: l.structuralSharing ?? Y9
  });
}
function a5(e = {}) {
  const { query: t = {}, ...r } = e, o = js(r), l = bx(), { address: d, connector: f, status: m } = kd({ config: o }), v = f0({ config: o }), { queryKey: w, ...x } = nH(o, {
    ...e,
    chainId: e.chainId ?? v,
    connector: e.connector ?? f
  }), b = !!(m !== "disconnected" && (t.enabled ?? !0)), k = $.useRef(d);
  return $.useEffect(() => {
    const T = k.current;
    !d && T ? (l.removeQueries({ queryKey: w }), k.current = void 0) : d !== T && (l.invalidateQueries({ queryKey: w }), k.current = d);
  }, [d, l]), Sx({
    ...t,
    ...x,
    queryKey: w,
    enabled: b,
    staleTime: 1 / 0
  });
}
var pH = "Expected a function", MP = 0 / 0, hH = "[object Symbol]", mH = /^\s+|\s+$/g, yH = /^[-+]0x[0-9a-f]+$/i, vH = /^0b[01]+$/i, gH = /^0o[0-7]+$/i, bH = parseInt, wH = typeof l1 == "object" && l1 && l1.Object === Object && l1, xH = typeof self == "object" && self && self.Object === Object && self, SH = wH || xH || Function("return this")(), kH = Object.prototype, EH = kH.toString, CH = Math.max, TH = Math.min, TE = function() {
  return SH.Date.now();
};
function _H(e, t, r) {
  var o, l, d, f, m, v, w = 0, x = !1, b = !1, k = !0;
  if (typeof e != "function")
    throw new TypeError(pH);
  t = $P(t) || 0, qC(r) && (x = !!r.leading, b = "maxWait" in r, d = b ? CH($P(r.maxWait) || 0, t) : d, k = "trailing" in r ? !!r.trailing : k);
  function T(V) {
    var W = o, Y = l;
    return o = l = void 0, w = V, f = e.apply(Y, W), f;
  }
  function O(V) {
    return w = V, m = setTimeout(I, t), x ? T(V) : f;
  }
  function R(V) {
    var W = V - v, Y = V - w, ce = t - W;
    return b ? TH(ce, d - Y) : ce;
  }
  function j(V) {
    var W = V - v, Y = V - w;
    return v === void 0 || W >= t || W < 0 || b && Y >= d;
  }
  function I() {
    var V = TE();
    if (j(V))
      return N(V);
    m = setTimeout(I, R(V));
  }
  function N(V) {
    return m = void 0, k && o ? T(V) : (o = l = void 0, f);
  }
  function L() {
    m !== void 0 && clearTimeout(m), w = 0, o = v = l = m = void 0;
  }
  function B() {
    return m === void 0 ? f : N(TE());
  }
  function H() {
    var V = TE(), W = j(V);
    if (o = arguments, l = this, v = V, W) {
      if (m === void 0)
        return O(v);
      if (b)
        return m = setTimeout(I, t), T(v);
    }
    return m === void 0 && (m = setTimeout(I, t)), f;
  }
  return H.cancel = L, H.flush = B, H;
}
function qC(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function RH(e) {
  return !!e && typeof e == "object";
}
function OH(e) {
  return typeof e == "symbol" || RH(e) && EH.call(e) == hH;
}
function $P(e) {
  if (typeof e == "number")
    return e;
  if (OH(e))
    return MP;
  if (qC(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = qC(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(mH, "");
  var r = vH.test(e);
  return r || gH.test(e) ? bH(e.slice(2), r ? 2 : 8) : yH.test(e) ? MP : +e;
}
var PH = _H;
const LP = /* @__PURE__ */ km(PH);
var T3 = typeof window < "u" ? $.useLayoutEffect : $.useEffect;
function NP(e, t, r, o) {
  const l = $.useRef(t);
  T3(() => {
    l.current = t;
  }, [t]), $.useEffect(() => {
    const d = (r == null ? void 0 : r.current) ?? window;
    if (!(d && d.addEventListener))
      return;
    const f = (m) => {
      l.current(m);
    };
    return d.addEventListener(e, f, o), () => {
      d.removeEventListener(e, f, o);
    };
  }, [e, r, o]);
}
function FP(e) {
  const t = $.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return T3(() => {
    t.current = e;
  }, [e]), $.useCallback((...r) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...r);
  }, [t]);
}
var _E = typeof window > "u";
function jH(e, t, r = {}) {
  const { initializeWithValue: o = !0 } = r, l = $.useCallback(
    (k) => r.serializer ? r.serializer(k) : JSON.stringify(k),
    [r]
  ), d = $.useCallback(
    (k) => {
      if (r.deserializer)
        return r.deserializer(k);
      if (k === "undefined")
        return;
      const T = t instanceof Function ? t() : t;
      let O;
      try {
        O = JSON.parse(k);
      } catch (R) {
        return console.error("Error parsing JSON:", R), T;
      }
      return O;
    },
    [r, t]
  ), f = $.useCallback(() => {
    const k = t instanceof Function ? t() : t;
    if (_E)
      return k;
    try {
      const T = window.localStorage.getItem(e);
      return T ? d(T) : k;
    } catch (T) {
      return console.warn(`Error reading localStorage key “${e}”:`, T), k;
    }
  }, [t, e, d]), [m, v] = $.useState(() => o ? f() : t instanceof Function ? t() : t), w = FP((k) => {
    _E && console.warn(
      `Tried setting localStorage key “${e}” even though environment is not a client`
    );
    try {
      const T = k instanceof Function ? k(f()) : k;
      window.localStorage.setItem(e, l(T)), v(T), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
    } catch (T) {
      console.warn(`Error setting localStorage key “${e}”:`, T);
    }
  }), x = FP(() => {
    _E && console.warn(
      `Tried removing localStorage key “${e}” even though environment is not a client`
    );
    const k = t instanceof Function ? t() : t;
    window.localStorage.removeItem(e), v(k), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
  });
  $.useEffect(() => {
    v(f());
  }, [e]);
  const b = $.useCallback(
    (k) => {
      k.key && k.key !== e || v(f());
    },
    [e, f]
  );
  return NP("storage", b), NP("local-storage", b), [m, w, x];
}
var AH = typeof window > "u";
function DH(e, {
  defaultValue: t = !1,
  initializeWithValue: r = !0
} = {}) {
  const o = (m) => AH ? t : window.matchMedia(m).matches, [l, d] = $.useState(() => r ? o(e) : t);
  function f() {
    d(o(e));
  }
  return T3(() => {
    const m = window.matchMedia(e);
    return f(), m.addListener ? m.addListener(f) : m.addEventListener("change", f), () => {
      m.removeListener ? m.removeListener(f) : m.removeEventListener("change", f);
    };
  }, [e]), l;
}
function IH(e) {
  const t = $.useRef(e);
  t.current = e, $.useEffect(
    () => () => {
      t.current();
    },
    []
  );
}
function MH(e, t = 500, r) {
  const o = $.useRef();
  IH(() => {
    o.current && o.current.cancel();
  });
  const l = $.useMemo(() => {
    const d = LP(e, t, r), f = (...m) => d(...m);
    return f.cancel = () => {
      d.cancel();
    }, f.isPending = () => !!o.current, f.flush = () => d.flush(), f;
  }, [e, t, r]);
  return $.useEffect(() => {
    o.current = LP(e, t, r);
  }, [e, t, r]), l;
}
function CX(e, t, r) {
  const o = (r == null ? void 0 : r.equalityFn) ?? ((w, x) => w === x), l = e instanceof Function ? e() : e, [d, f] = $.useState(l), m = $.useRef(l), v = MH(
    f,
    t,
    r
  );
  return o(m.current, l) || (v(l), m.current = l), [d, v];
}
function $H() {
  const e = $.useRef(!1);
  return $.useEffect(() => (e.current = !0, () => {
    e.current = !1;
  }), []), $.useCallback(() => e.current, []);
}
var zP = {
  width: void 0,
  height: void 0
};
function LH(e) {
  const { ref: t, box: r = "content-box" } = e, [{ width: o, height: l }, d] = $.useState(zP), f = $H(), m = $.useRef({ ...zP }), v = $.useRef(void 0);
  return v.current = e.onResize, $.useEffect(() => {
    if (!t.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const w = new ResizeObserver(([x]) => {
      const b = r === "border-box" ? "borderBoxSize" : r === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", k = BP(x, b, "inlineSize"), T = BP(x, b, "blockSize");
      if (m.current.width !== k || m.current.height !== T) {
        const R = { width: k, height: T };
        m.current.width = k, m.current.height = T, v.current ? v.current(R) : f() && d(R);
      }
    });
    return w.observe(t.current, { box: r }), () => {
      w.disconnect();
    };
  }, [r, t, f]), { width: o, height: l };
}
function BP(e, t, r) {
  return e[t] ? Array.isArray(e[t]) ? e[t][0][r] : (
    // @ts-ignore Support Firefox's non-standard behavior
    e[t][r]
  ) : t === "contentBoxSize" ? e.contentRect[r === "inlineSize" ? "width" : "height"] : void 0;
}
function i5(e) {
  if (typeof e == "string") {
    if (!Va(e, { strict: !1 }))
      throw new Lo({ address: e });
    return {
      address: e,
      type: "json-rpc"
    };
  }
  if (!Va(e.address, { strict: !1 }))
    throw new Lo({ address: e.address });
  return {
    address: e.address,
    signMessage: e.signMessage,
    signTransaction: e.signTransaction,
    signTypedData: e.signTypedData,
    source: "custom",
    type: "local"
  };
}
async function _3({ hash: e, privateKey: t }) {
  const { r, s: o, recovery: l } = vx.sign(e.slice(2), t.slice(2));
  return {
    r: St(r),
    s: St(o),
    v: l ? 28n : 27n,
    yParity: l
  };
}
async function NH({ message: e, privateKey: t }) {
  const r = await _3({ hash: yD(e), privateKey: t });
  return MD(r);
}
async function FH(e) {
  const { privateKey: t, transaction: r, serializer: o = QB } = e, l = (() => r.type === "eip4844" ? {
    ...r,
    sidecars: !1
  } : r)(), d = await _3({
    hash: Nn(o(l)),
    privateKey: t
  });
  return o(r, d);
}
async function zH(e) {
  const { privateKey: t, ...r } = e, o = await _3({
    hash: uD(r),
    privateKey: t
  });
  return MD(o);
}
function BH(e) {
  const t = St(vx.getPublicKey(e.slice(2), !1)), r = _B(t);
  return {
    ...i5({
      address: r,
      async signMessage({ message: l }) {
        return NH({ message: l, privateKey: e });
      },
      async signTransaction(l, { serializer: d } = {}) {
        return FH({ privateKey: e, transaction: l, serializer: d });
      },
      async signTypedData(l) {
        return zH({ ...l, privateKey: e });
      }
    }),
    publicKey: t,
    source: "privateKey"
  };
}
function o5() {
  const { address: e } = kd(), t = `mud:appSigner:privateKey:${(e == null ? void 0 : e.toLowerCase()) ?? ""}`, [r, o] = jH(t, void 0);
  return $.useMemo(
    () => [r ? BH(r) : void 0, e ? o : () => {
    }],
    [e, r, o]
  );
}
const WC = $.createContext(null);
function TX({ config: e, children: t }) {
  if ($.useContext(WC))
    throw new Error("`AccountKitProvider` can only be used once.");
  return /* @__PURE__ */ ze.jsx(WC.Provider, { value: e, children: t });
}
function Iu() {
  const e = $.useContext(WC);
  if (!e)
    throw new Error("`useConfig` can only be used within a `AccountKitProvider`.");
  return e;
}
var YC = { exports: {} }, RE, UP;
function UH() {
  if (UP)
    return RE;
  UP = 1;
  var e = 1e3, t = e * 60, r = t * 60, o = r * 24, l = o * 7, d = o * 365.25;
  RE = function(x, b) {
    b = b || {};
    var k = typeof x;
    if (k === "string" && x.length > 0)
      return f(x);
    if (k === "number" && isFinite(x))
      return b.long ? v(x) : m(x);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(x)
    );
  };
  function f(x) {
    if (x = String(x), !(x.length > 100)) {
      var b = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        x
      );
      if (b) {
        var k = parseFloat(b[1]), T = (b[2] || "ms").toLowerCase();
        switch (T) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return k * d;
          case "weeks":
          case "week":
          case "w":
            return k * l;
          case "days":
          case "day":
          case "d":
            return k * o;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return k * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return k * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return k * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return k;
          default:
            return;
        }
      }
    }
  }
  function m(x) {
    var b = Math.abs(x);
    return b >= o ? Math.round(x / o) + "d" : b >= r ? Math.round(x / r) + "h" : b >= t ? Math.round(x / t) + "m" : b >= e ? Math.round(x / e) + "s" : x + "ms";
  }
  function v(x) {
    var b = Math.abs(x);
    return b >= o ? w(x, b, o, "day") : b >= r ? w(x, b, r, "hour") : b >= t ? w(x, b, t, "minute") : b >= e ? w(x, b, e, "second") : x + " ms";
  }
  function w(x, b, k, T) {
    var O = b >= k * 1.5;
    return Math.round(x / k) + " " + T + (O ? "s" : "");
  }
  return RE;
}
function HH(e) {
  r.debug = r, r.default = r, r.coerce = v, r.disable = d, r.enable = l, r.enabled = f, r.humanize = UH(), r.destroy = w, Object.keys(e).forEach((x) => {
    r[x] = e[x];
  }), r.names = [], r.skips = [], r.formatters = {};
  function t(x) {
    let b = 0;
    for (let k = 0; k < x.length; k++)
      b = (b << 5) - b + x.charCodeAt(k), b |= 0;
    return r.colors[Math.abs(b) % r.colors.length];
  }
  r.selectColor = t;
  function r(x) {
    let b, k = null, T, O;
    function R(...j) {
      if (!R.enabled)
        return;
      const I = R, N = Number(/* @__PURE__ */ new Date()), L = N - (b || N);
      I.diff = L, I.prev = b, I.curr = N, b = N, j[0] = r.coerce(j[0]), typeof j[0] != "string" && j.unshift("%O");
      let B = 0;
      j[0] = j[0].replace(/%([a-zA-Z%])/g, (V, W) => {
        if (V === "%%")
          return "%";
        B++;
        const Y = r.formatters[W];
        if (typeof Y == "function") {
          const ce = j[B];
          V = Y.call(I, ce), j.splice(B, 1), B--;
        }
        return V;
      }), r.formatArgs.call(I, j), (I.log || r.log).apply(I, j);
    }
    return R.namespace = x, R.useColors = r.useColors(), R.color = r.selectColor(x), R.extend = o, R.destroy = r.destroy, Object.defineProperty(R, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => k !== null ? k : (T !== r.namespaces && (T = r.namespaces, O = r.enabled(x)), O),
      set: (j) => {
        k = j;
      }
    }), typeof r.init == "function" && r.init(R), R;
  }
  function o(x, b) {
    const k = r(this.namespace + (typeof b > "u" ? ":" : b) + x);
    return k.log = this.log, k;
  }
  function l(x) {
    r.save(x), r.namespaces = x, r.names = [], r.skips = [];
    let b;
    const k = (typeof x == "string" ? x : "").split(/[\s,]+/), T = k.length;
    for (b = 0; b < T; b++)
      k[b] && (x = k[b].replace(/\*/g, ".*?"), x[0] === "-" ? r.skips.push(new RegExp("^" + x.slice(1) + "$")) : r.names.push(new RegExp("^" + x + "$")));
  }
  function d() {
    const x = [
      ...r.names.map(m),
      ...r.skips.map(m).map((b) => "-" + b)
    ].join(",");
    return r.enable(""), x;
  }
  function f(x) {
    if (x[x.length - 1] === "*")
      return !0;
    let b, k;
    for (b = 0, k = r.skips.length; b < k; b++)
      if (r.skips[b].test(x))
        return !1;
    for (b = 0, k = r.names.length; b < k; b++)
      if (r.names[b].test(x))
        return !0;
    return !1;
  }
  function m(x) {
    return x.toString().substring(2, x.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function v(x) {
    return x instanceof Error ? x.stack || x.message : x;
  }
  function w() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var VH = HH;
(function(e, t) {
  t.formatArgs = o, t.save = l, t.load = d, t.useColors = r, t.storage = f(), t.destroy = (() => {
    let v = !1;
    return () => {
      v || (v = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), t.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function o(v) {
    if (v[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + v[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
      return;
    const w = "color: " + this.color;
    v.splice(1, 0, w, "color: inherit");
    let x = 0, b = 0;
    v[0].replace(/%[a-zA-Z%]/g, (k) => {
      k !== "%%" && (x++, k === "%c" && (b = x));
    }), v.splice(b, 0, w);
  }
  t.log = console.debug || console.log || (() => {
  });
  function l(v) {
    try {
      v ? t.storage.setItem("debug", v) : t.storage.removeItem("debug");
    } catch {
    }
  }
  function d() {
    let v;
    try {
      v = t.storage.getItem("debug");
    } catch {
    }
    return !v && typeof process < "u" && "env" in process && (v = process.env.DEBUG), v;
  }
  function f() {
    try {
      return localStorage;
    } catch {
    }
  }
  e.exports = VH(t);
  const { formatters: m } = e.exports;
  m.j = function(v) {
    try {
      return JSON.stringify(v);
    } catch (w) {
      return "[UnexpectedJSONParseError]: " + w.message;
    }
  };
})(YC, YC.exports);
var GH = YC.exports;
const p0 = /* @__PURE__ */ km(GH);
var h0 = p0("mud:common"), qH = p0("mud:common");
h0.log = console.debug.bind(console);
qH.log = console.error.bind(console);
globalThis && globalThis.__classPrivateFieldGet;
globalThis && globalThis.__classPrivateFieldSet;
globalThis && globalThis.__classPrivateFieldGet;
var s5 = {};
function No(e, t) {
  typeof t == "boolean" && (t = { forever: t }), this._originalTimeouts = JSON.parse(JSON.stringify(e)), this._timeouts = e, this._options = t || {}, this._maxRetryTime = t && t.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var WH = No;
No.prototype.reset = function() {
  this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
};
No.prototype.stop = function() {
  this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
};
No.prototype.retry = function(e) {
  if (this._timeout && clearTimeout(this._timeout), !e)
    return !1;
  var t = (/* @__PURE__ */ new Date()).getTime();
  if (e && t - this._operationStart >= this._maxRetryTime)
    return this._errors.push(e), this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;
  this._errors.push(e);
  var r = this._timeouts.shift();
  if (r === void 0)
    if (this._cachedTimeouts)
      this._errors.splice(0, this._errors.length - 1), r = this._cachedTimeouts.slice(-1);
    else
      return !1;
  var o = this;
  return this._timer = setTimeout(function() {
    o._attempts++, o._operationTimeoutCb && (o._timeout = setTimeout(function() {
      o._operationTimeoutCb(o._attempts);
    }, o._operationTimeout), o._options.unref && o._timeout.unref()), o._fn(o._attempts);
  }, r), this._options.unref && this._timer.unref(), !0;
};
No.prototype.attempt = function(e, t) {
  this._fn = e, t && (t.timeout && (this._operationTimeout = t.timeout), t.cb && (this._operationTimeoutCb = t.cb));
  var r = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function() {
    r._operationTimeoutCb();
  }, r._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
};
No.prototype.try = function(e) {
  console.log("Using RetryOperation.try() is deprecated"), this.attempt(e);
};
No.prototype.start = function(e) {
  console.log("Using RetryOperation.start() is deprecated"), this.attempt(e);
};
No.prototype.start = No.prototype.try;
No.prototype.errors = function() {
  return this._errors;
};
No.prototype.attempts = function() {
  return this._attempts;
};
No.prototype.mainError = function() {
  if (this._errors.length === 0)
    return null;
  for (var e = {}, t = null, r = 0, o = 0; o < this._errors.length; o++) {
    var l = this._errors[o], d = l.message, f = (e[d] || 0) + 1;
    e[d] = f, f >= r && (t = l, r = f);
  }
  return t;
};
(function(e) {
  var t = WH;
  e.operation = function(r) {
    var o = e.timeouts(r);
    return new t(o, {
      forever: r && (r.forever || r.retries === 1 / 0),
      unref: r && r.unref,
      maxRetryTime: r && r.maxRetryTime
    });
  }, e.timeouts = function(r) {
    if (r instanceof Array)
      return [].concat(r);
    var o = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1e3,
      maxTimeout: 1 / 0,
      randomize: !1
    };
    for (var l in r)
      o[l] = r[l];
    if (o.minTimeout > o.maxTimeout)
      throw new Error("minTimeout is greater than maxTimeout");
    for (var d = [], f = 0; f < o.retries; f++)
      d.push(this.createTimeout(f, o));
    return r && r.forever && !d.length && d.push(this.createTimeout(f, o)), d.sort(function(m, v) {
      return m - v;
    }), d;
  }, e.createTimeout = function(r, o) {
    var l = o.randomize ? Math.random() + 1 : 1, d = Math.round(l * Math.max(o.minTimeout, 1) * Math.pow(o.factor, r));
    return d = Math.min(d, o.maxTimeout), d;
  }, e.wrap = function(r, o, l) {
    if (o instanceof Array && (l = o, o = null), !l) {
      l = [];
      for (var d in r)
        typeof r[d] == "function" && l.push(d);
    }
    for (var f = 0; f < l.length; f++) {
      var m = l[f], v = r[m];
      r[m] = function(x) {
        var b = e.operation(o), k = Array.prototype.slice.call(arguments, 1), T = k.pop();
        k.push(function(O) {
          b.retry(O) || (O && (arguments[0] = b.mainError()), T.apply(this, arguments));
        }), b.attempt(function() {
          x.apply(r, k);
        });
      }.bind(r, v), r[m].options = o;
    }
  };
})(s5);
var YH = s5;
const ZH = /* @__PURE__ */ km(YH), KH = /* @__PURE__ */ new Set([
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari
  "Network request failed",
  // `cross-fetch`
  "fetch failed"
  // Undici (Node.js)
]);
class QH extends Error {
  constructor(t) {
    super(), t instanceof Error ? (this.originalError = t, { message: t } = t) : (this.originalError = new Error(t), this.originalError.stack = this.stack), this.name = "AbortError", this.message = t;
  }
}
const XH = (e, t, r) => {
  const o = r.retries - (t - 1);
  return e.attemptNumber = t, e.retriesLeft = o, e;
}, JH = (e) => KH.has(e), HP = (e) => globalThis.DOMException === void 0 ? new Error(e) : new DOMException(e);
async function eV(e, t) {
  return new Promise((r, o) => {
    t = {
      onFailedAttempt() {
      },
      retries: 10,
      ...t
    };
    const l = ZH.operation(t);
    l.attempt(async (d) => {
      try {
        r(await e(d));
      } catch (f) {
        if (!(f instanceof Error)) {
          o(new TypeError(`Non-error was thrown: "${f}". You should only throw errors.`));
          return;
        }
        if (f instanceof QH)
          l.stop(), o(f.originalError);
        else if (f instanceof TypeError && !JH(f.message))
          l.stop(), o(f);
        else {
          XH(f, d, t);
          try {
            await t.onFailedAttempt(f);
          } catch (m) {
            o(m);
            return;
          }
          l.retry(f) || o(l.mainError());
        }
      }
    }), t.signal && !t.signal.aborted && t.signal.addEventListener("abort", () => {
      l.stop();
      const d = t.signal.reason === void 0 ? HP("The operation was aborted.") : t.signal.reason;
      o(d instanceof Error ? d : HP(d));
    }, {
      once: !0
    });
  });
}
h0.extend("createNonceManager");
async function tV({ client: e, args: t, refreshInterval: r }) {
  let o = { fees: {}, lastUpdatedTimestamp: 0 };
  async function l() {
    let d = await bg(e, t);
    o.fees = d, o.lastUpdatedTimestamp = Date.now();
  }
  return setInterval(l, r), await l(), o;
}
var VP = /* @__PURE__ */ new Map();
async function nV(e) {
  var l, d, f;
  let t = ((d = (l = e.args) == null ? void 0 : l.chain) == null ? void 0 : d.id) ?? ((f = e.client.chain) == null ? void 0 : f.id) ?? await Jf(e.client), r = VP.get(t);
  if (r)
    return r;
  let o = await tV(e);
  return VP.set(t, o), o;
}
h0.extend("writeContract");
h0.extend("sendTransaction");
var rV = ["table", "offchainTable", "namespace", "module", "system"], u5 = { table: "tb", offchainTable: "ot", namespace: "ns", module: "md", system: "sy" };
function R3(e) {
  let t = u5[e.type];
  return Ps([Zh(t, { size: 2 }), Zh(e.namespace.slice(0, 14), { size: 14 }), Zh(e.name.slice(0, 16), { size: 16 })]);
}
var aV = "";
function iV({ namespace: e, name: t }) {
  return e === aV ? t : `${e}__${t}`;
}
var oV = Object.fromEntries(Object.entries(u5).map(([e, t]) => [t, e]));
function sV(e) {
  let t = oV[e];
  if (rV.includes(t))
    return t;
}
function uV(e) {
  let t = eg(tg(e, 0, 2)).replace(/\0+$/, ""), r = sV(t), o = eg(tg(e, 2, 16)).replace(/\0+$/, ""), l = eg(tg(e, 16, 32)).replace(/\0+$/, "");
  if (!r)
    throw new Error(`Unknown type (${t}) for resource (${iV({ namespace: o, name: l })})`);
  return { resourceId: e, type: r, namespace: o, name: l };
}
var lV = p0("mud:benchmark");
lV.log = console.info.bind(console);
function Vf(e, t, r) {
  return `0x${e.replace(/^0x/, "").slice(t * 2, r != null ? r * 2 : void 0).padEnd(((r ?? t) - t) * 2, "0")}`;
}
h0.extend("transportObserver");
class cV extends we {
  constructor({ cause: t, entryPoint: r } = {}) {
    super(`The entry point address (\`entryPoint\`${r ? ` = ${r}` : ""}) is not a valid entry point. getSenderAddress did not revert with a SenderAddressResult error.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidEntryPointError"
    });
  }
}
const GP = async (e, t) => {
  var f, m, v, w;
  const { initCode: r, entryPoint: o, factory: l, factoryData: d } = t;
  if (!r && !l && !d)
    throw new Error("Either `initCode` or `factory` and `factoryData` must be provided");
  try {
    await Ke(e, iD, "simulateContract")({
      address: o,
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "sender",
              type: "address"
            }
          ],
          name: "SenderAddressResult",
          type: "error"
        },
        {
          inputs: [
            {
              internalType: "bytes",
              name: "initCode",
              type: "bytes"
            }
          ],
          name: "getSenderAddress",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function"
        }
      ],
      functionName: "getSenderAddress",
      args: [r || ia([l, d])]
    });
  } catch (x) {
    const b = x;
    if (b.cause.name === "ContractFunctionRevertedError") {
      const k = b.cause;
      if ((((f = k.data) == null ? void 0 : f.errorName) ?? "") === "SenderAddressResult" && ((m = k.data) != null && m.args) && ((v = k.data) != null && v.args[0]))
        return (w = k.data) == null ? void 0 : w.args[0];
    }
    if (b.cause.name === "CallExecutionError") {
      const k = b.cause;
      if (k.cause.name === "RpcRequestError") {
        const O = k.cause.cause.data.split(" ")[1];
        return gC({
          abi: [
            {
              inputs: [
                {
                  internalType: "address",
                  name: "sender",
                  type: "address"
                }
              ],
              name: "SenderAddressResult",
              type: "error"
            }
          ],
          data: O
        }).args[0];
      }
      if (k.cause.name === "InvalidInputRpcError") {
        const O = k.cause.cause.data;
        return gC({
          abi: [
            {
              inputs: [
                {
                  internalType: "address",
                  name: "sender",
                  type: "address"
                }
              ],
              name: "SenderAddressResult",
              type: "error"
            }
          ],
          data: O
        }).args[0];
      }
    }
    throw x;
  }
  throw new cV({ entryPoint: o });
}, dV = async (e) => Number(await e.request({
  method: "eth_chainId",
  params: []
})), fV = {
  "0x0": "reverted",
  "0x1": "success"
};
function Cg(e) {
  if (typeof e != "function")
    return e == null || typeof e == "string" || typeof e == "boolean" ? e : typeof e == "bigint" ? St(e) : e._isBigNumber != null || typeof e != "object" ? St(e).replace(/^0x0/, "0x") : Array.isArray(e) ? e.map((t) => Cg(t)) : Object.keys(e).reduce(
      // biome-ignore lint/suspicious/noExplicitAny: it's a recursive function, so it's hard to type
      (t, r) => (t[r] = Cg(e[r]), t),
      {}
    );
}
function m0(e) {
  if (e && e.length >= 42)
    return ax(e.slice(0, 42));
}
const l5 = "0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789", pV = "0x0000000071727De22E5E9d8BAf0edAc6f37da032", y0 = (e) => e === l5 ? "v0.6" : "v0.7";
function hV(e, t) {
  return y0(e) === "v0.6";
}
function mV({ userOperation: e, entryPoint: t }) {
  if (hV(t)) {
    const d = Nn(e.initCode), f = Nn(e.callData), m = Nn(e.paymasterAndData);
    return ro([
      { type: "address" },
      { type: "uint256" },
      { type: "bytes32" },
      { type: "bytes32" },
      { type: "uint256" },
      { type: "uint256" },
      { type: "uint256" },
      { type: "uint256" },
      { type: "uint256" },
      { type: "bytes32" }
    ], [
      e.sender,
      e.nonce,
      d,
      f,
      e.callGasLimit,
      e.verificationGasLimit,
      e.preVerificationGas,
      e.maxFeePerGas,
      e.maxPriorityFeePerGas,
      m
    ]);
  }
  const r = Nn(e.factory && e.factoryData ? ia([e.factory, e.factoryData]) : "0x"), o = Nn(e.callData), l = Nn(e.paymaster ? ia([
    e.paymaster,
    Io(St(e.paymasterVerificationGasLimit || BigInt(0)), {
      size: 16
    }),
    Io(St(e.paymasterPostOpGasLimit || BigInt(0)), {
      size: 16
    }),
    e.paymasterData || "0x"
  ]) : "0x");
  return ro([
    { type: "address" },
    { type: "uint256" },
    { type: "bytes32" },
    { type: "bytes32" },
    { type: "bytes32" },
    { type: "uint256" },
    { type: "bytes32" },
    { type: "bytes32" }
  ], [
    e.sender,
    e.nonce,
    r,
    o,
    ia([
      Io(St(e.verificationGasLimit), {
        size: 16
      }),
      Io(St(e.callGasLimit), { size: 16 })
    ]),
    e.preVerificationGas,
    ia([
      Io(St(e.maxPriorityFeePerGas), {
        size: 16
      }),
      Io(St(e.maxFeePerGas), { size: 16 })
    ]),
    l
  ]);
}
const yV = ({ userOperation: e, entryPoint: t, chainId: r }) => {
  const o = ro([{ type: "bytes32" }, { type: "address" }, { type: "uint256" }], [
    Nn(mV({
      userOperation: e,
      entryPoint: t
    })),
    t,
    BigInt(r)
  ]);
  return Nn(o);
}, Wh = async (e, t) => {
  const r = await aD(e, {
    address: t
  });
  return ((r == null ? void 0 : r.length) ?? 0) > 2;
};
class _s extends we {
  constructor({ docsPath: t } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
    ].join(`
`), {
      docsPath: t,
      docsSlug: "account"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountOrClientNotFoundError"
    });
  }
}
function Ul(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
function c5(e) {
  const t = Object.entries(e).map(([o, l]) => l === void 0 || l === !1 ? null : [o, l]).filter(Boolean), r = t.reduce((o, [l]) => Math.max(o, l.length), 0);
  return t.map(([o, l]) => `  ${`${o}:`.padEnd(r + 1)}  ${l}`).join(`
`);
}
class vV extends we {
  constructor(t, { userOperation: r, entryPoint: o, docsPath: l }) {
    const d = c5({
      sender: r.sender,
      nonce: r.nonce,
      initCode: r.initCode,
      callData: r.callData,
      callGasLimit: r.callGasLimit,
      verificationGasLimit: r.verificationGasLimit,
      preVerificationGas: r.preVerificationGas,
      maxFeePerGas: r.maxFeePerGas,
      maxPriorityFeePerGas: r.maxPriorityFeePerGas,
      paymasterAndData: r.paymasterAndData,
      signature: r.signature,
      entryPoint: o
    });
    super(t.shortMessage, {
      cause: t,
      docsPath: l,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        d
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EstimateUserOperationGasError"
    }), this.cause = t;
  }
}
class ZC extends we {
  constructor({ cause: t, sender: r, docsPath: o } = {}) {
    super([
      `Smart account ${r} is already deployed.`,
      "",
      "Possible solutions:",
      '• Remove the initCode from the user operation and set it to "0x"',
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SenderAlreadyDeployedError"
    });
  }
}
Object.defineProperty(ZC, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa10/
});
class KC extends we {
  constructor({ cause: t, docsPath: r } = {}) {
    super([
      "EntryPoint failed to create the smart account with the initCode provided.",
      "",
      "Possible reasons:",
      "• The initCode ran out of gas",
      "• The initCode reverted during the account deployment process",
      "",
      "Possible solutions:",
      "• Verify that the factory address in the initCode is correct (the factory address is the first 20 bytes of the initCode).",
      "• Verify that the initCode is correct.",
      "• Check whether the verificationGasLimit is sufficient for the initCode to complete without running out of gas.",
      "",
      r ? `Docs: ${r}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InitCodeRevertedError"
    });
  }
}
Object.defineProperty(KC, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa13/
});
class QC extends we {
  constructor({ cause: t, sender: r, docsPath: o }) {
    super([
      "The initCode returned a different smart account address than expected.",
      `Expected: ${r}`,
      "",
      "Possible reasons:",
      "• Account deployed with the initCode provided does not match match the sender address provided",
      "",
      "Possible solutions:",
      "• Verify that the sender address was generated deterministically from the initCode. (consider leveraging functions like getSenderAddress)",
      "• Verify that the factory address in the initCode is correct (the factory address is the first 20 bytes of the initCode)",
      "• Verify that the initCode is correct.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SenderAddressMismatchError"
    });
  }
}
Object.defineProperty(QC, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa14/
});
class XC extends we {
  constructor({ cause: t, sender: r, docsPath: o }) {
    super([
      `The initCode did not deploy the sender at the address ${r}.`,
      "",
      "Possible reasons:",
      "• The initCode factory is not creating an account.",
      "• The initCode factory is creating an account, but is not implemented correctly as it is not deploying at the sender address",
      "",
      "Possible solutions:",
      "• Verify that the factory address in the initCode is correct (the factory address is the first 20 bytes of the initCode).",
      "• Verify that the initCode factory is implemented correctly. The factory must deploy the smart account at the sender address.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InitCodeDidNotDeploySenderError"
    });
  }
}
Object.defineProperty(XC, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa15/
});
class JC extends we {
  constructor({ cause: t, sender: r, docsPath: o }) {
    super([
      `Smart account ${r} is not deployed.`,
      "",
      "Possible reasons:",
      "• An initCode was not specified, but the sender address (i.e. the smart account) is not deployed.",
      "",
      "Possible solutions:",
      "• If this is the first transaction by this account, make sure the initCode is included in the user operation.",
      "• If the smart account is already supposed to be deployed, verify that you have selected the correct sender address for the user operation.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SenderNotDeployedError"
    });
  }
}
Object.defineProperty(JC, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa20/
});
class eT extends we {
  constructor({ cause: t, sender: r, docsPath: o }) {
    super([
      `You are not using a paymaster, and the ${r} address did not have enough native tokens to cover the gas costs associated with the user operation.`,
      "",
      "Possible solutions:",
      "• If you are not using a paymaster, verify that the sender address has enough native tokens to cover the required prefund. Consider leveraging functions like getRequiredPrefund.",
      "• If you are looking to use a paymaster to cover the gas fees, verify that the paymasterAndData field is set.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SmartAccountInsufficientFundsError"
    });
  }
}
Object.defineProperty(eT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa21/
});
class tT extends we {
  constructor({ cause: t, docsPath: r }) {
    super([
      "The signature used in the user operation is not valid, because it is outside of the time range it specified.",
      "",
      "Possible reasons:",
      "• This error occurs when the block.timestamp falls after the validUntil timestamp, or before the validAfter timestamp.",
      "",
      "Possible solutions:",
      "• If you are looking to use time-based signatures, verify that the validAfter and validUntil fields are set correctly and that the user operation is sent within the specified range.",
      "• If you are not looking to use time-based signatures, verify that the validAfter and validUntil fields are set to 0.",
      "",
      r ? `Docs: ${r}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SmartAccountSignatureValidityPeriodError"
    });
  }
}
Object.defineProperty(tT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa22/
});
class nT extends we {
  constructor({ cause: t, sender: r, docsPath: o }) {
    super([
      `The smart account ${r} reverted or ran out of gas during the validation of the user operation.`,
      "",
      "Possible solutions:",
      "• Verify that the verificationGasLimit is high enough to cover the validateUserOp function's gas costs.",
      "• Make sure validateUserOp returns uint(1) for invalid signatures, and MUST NOT REVERT when the signature is invalid",
      "• If you are not using a paymaster, verify that the sender address has enough native tokens to cover the required pre fund. Consider leveraging functions like getRequiredPrefund.",
      "• Verify that the validateUserOp function is implemented with the correct logic, and that the user operation is supposed to be valid.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SmartAccountValidationRevertedError"
    });
  }
}
Object.defineProperty(nT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa23/
});
class rT extends we {
  constructor({ cause: t, sender: r, nonce: o, docsPath: l }) {
    const d = o >> BigInt(64), f = o & 0xffffffffffffffffn;
    super([
      `The smart account ${r} nonce is invalid.`,
      `Nonce sent: ${o} (key: ${d}, sequence: ${f})`,
      "",
      "Possible solutions:",
      "• Verify that you are using the correct nonce for the user operation. The nonce should be the current nonce of the smart account for the selected key. Consider leveraging functions like getAccountNonce.",
      "• Verify that the nonce is formatted correctly.",
      "",
      l ? `Docs: ${l}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSmartAccountNonceError"
    });
  }
}
Object.defineProperty(rT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa25/
});
class gV extends we {
  constructor(t, { userOperation: r, entryPoint: o, docsPath: l }) {
    const d = c5({
      ...r,
      entryPoint: o
    });
    super(t.shortMessage, {
      cause: t,
      docsPath: l,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "sendUserOperation Arguments:",
        d
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SendUserOperationError"
    }), this.cause = t;
  }
}
class aT extends we {
  constructor({ cause: t, paymasterAndData: r, docsPath: o } = {}) {
    const l = r ? m0(r) : "0x";
    super([
      `Paymaster ${l} is not deployed.`,
      "",
      "Possible solutions:",
      "• Verify that the paymasterAndData field is correct, and that the first 20 bytes are the address of the paymaster contract you intend to use.",
      "• Verify that the paymaster contract is deployed on the network you are using.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PaymasterNotDeployedError"
    });
  }
}
Object.defineProperty(aT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa30/
});
class iT extends we {
  constructor({ cause: t, paymasterAndData: r, docsPath: o } = {}) {
    const l = r ? m0(r) : "0x";
    super([
      `Paymaster ${l} contract does not have enough funds deposited into the EntryPoint contract to cover the required funds for the user operation.`,
      "",
      "Possible solutions:",
      "• If you are using your own paymaster contract, deposit more funds into the EntryPoint contract through the deposit() function of the paymaster contract.",
      "• Verify that the paymasterAndData field is correct, and that the first 20 bytes are the address of the paymaster contract you intend to useVerify that the paymasterAndData field is correct, and that the first 20 bytes are the address of the paymaster contract you intend to use.",
      "• If you are using a paymaster service, reach out to them.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PaymasterDepositTooLowError"
    });
  }
}
Object.defineProperty(iT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa31/
});
class oT extends we {
  constructor({ cause: t, paymasterAndData: r, docsPath: o }) {
    const l = r ? m0(r) : "0x";
    super([
      `Paymaster ${l}'s data used in the paymasterAndData field of the user operation is not valid, because it is outside of the time range it specified.`,
      "",
      "Possible reasons:",
      "• This error occurs when the block.timestamp falls after the validUntil timestamp, or before the validAfter timestamp.",
      "",
      "Possible solutions:",
      "• If you are using your own paymaster contract and using time-based signatures, verify that the validAfter and validUntil fields are set correctly and that the user operation is sent within the specified range.",
      "• If you are using your own paymaster contract and not looking to use time-based signatures, verify that the validAfter and validUntil fields are set to 0.",
      "• If you are using a service, contact your service provider for their paymaster's validity.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PaymasterValidityPeriodError"
    });
  }
}
Object.defineProperty(oT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa32/
});
class sT extends we {
  constructor({ cause: t, paymasterAndData: r, docsPath: o }) {
    const l = r ? m0(r) : "0x";
    super([
      `The validatePaymasterUserOp function of the paymaster ${l} either reverted or ran out of gas.`,
      "",
      "Possible solutions:",
      "• Verify that the verificationGasLimit is high enough to cover the validatePaymasterUserOp function's gas costs.",
      "• If you are using your own paymaster contract, verify that the validatePaymasterUserOp function is implemented with the correct logic, and that the user operation is supposed to be valid.",
      "• If you are using a paymaster service, and the user operation is well formed with a high enough verificationGasLimit, reach out to them.",
      "• If you are not looking to use a paymaster to cover the gas fees, verify that the paymasterAndData field is not set.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PaymasterValidationRevertedError"
    });
  }
}
Object.defineProperty(sT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa33/
});
class uT extends we {
  constructor({ cause: t, paymasterAndData: r, docsPath: o }) {
    const l = r ? m0(r) : "0x";
    super([
      `The validatePaymasterUserOp function of the paymaster ${l} rejected paymasterAndData.`,
      "",
      "Possible solutions:",
      "• If you are using your own paymaster contract, verify that the user operation was correctly signed according to your implementation, and that the paymaster signature was correctly encoded in the paymasterAndData field of the user operation.",
      "• If you are using a paymaster service, make sure you do not modify any of the fields of the user operation after the paymaster signs over it (except the signature field).",
      "• If you are using a paymaster service and you have not modified any of the fields except the signature but you are still getting this error, reach out to them.",
      "",
      o ? `Docs: ${o}` : ""
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PaymasterDataRejectedError"
    });
  }
}
Object.defineProperty(uT, "message", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /aa34/
});
function d5(e, t) {
  const r = (e.details || "").toLowerCase(), o = e instanceof we ? e.walk((l) => l.code === cd.code) : e;
  return o instanceof we ? new cd({
    cause: e,
    message: o.details
  }) : t.userOperation.sender === void 0 ? new jl({ cause: e }) : t.userOperation.nonce === void 0 ? new jl({ cause: e }) : ZC.message.test(r) ? new ZC({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa10"
  }) : KC.message.test(r) ? new KC({
    cause: e,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa13"
  }) : QC.message.test(r) ? new QC({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa14"
  }) : XC.message.test(r) ? new XC({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa15"
  }) : JC.message.test(r) ? new JC({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa20"
  }) : eT.message.test(r) ? new eT({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa21"
  }) : tT.message.test(r) ? new tT({
    cause: e,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa22"
  }) : nT.message.test(r) ? new nT({
    cause: e,
    sender: t.userOperation.sender,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa23"
  }) : rT.message.test(r) ? new rT({
    cause: e,
    sender: t.userOperation.sender,
    nonce: t.userOperation.nonce,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa25"
  }) : aT.message.test(r) ? new aT({
    cause: e,
    paymasterAndData: t.userOperation.paymasterAndData,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa30"
  }) : iT.message.test(r) ? new iT({
    cause: e,
    paymasterAndData: t.userOperation.paymasterAndData,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa31"
  }) : oT.message.test(r) ? new oT({
    cause: e,
    paymasterAndData: t.userOperation.paymasterAndData,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa32"
  }) : sT.message.test(r) ? new sT({
    cause: e,
    paymasterAndData: t.userOperation.paymasterAndData,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa33"
  }) : uT.message.test(r) ? new uT({
    cause: e,
    paymasterAndData: t.userOperation.paymasterAndData,
    docsPath: "https://docs.pimlico.io/bundler/reference/entrypoint-errors/aa34"
  }) : new jl({ cause: e });
}
function bV(e, t) {
  const r = (() => {
    const o = d5(
      // biome-ignore lint/complexity/noBannedTypes: <explanation>
      e,
      t
    );
    return o instanceof jl ? e : o;
  })();
  throw new vV(r, {
    ...t
  });
}
const O3 = async (e, t, r) => {
  const { userOperation: o, entryPoint: l } = t, d = Cg(o), f = Cg(r);
  try {
    const m = await e.request({
      method: "eth_estimateUserOperationGas",
      params: r ? [
        d,
        l,
        f
      ] : [d, l]
    });
    if (y0(l) === "v0.6") {
      const x = m;
      return {
        preVerificationGas: BigInt(x.preVerificationGas || 0),
        verificationGasLimit: BigInt(x.verificationGasLimit || 0),
        callGasLimit: BigInt(x.callGasLimit || 0)
      };
    }
    const w = m;
    return {
      preVerificationGas: BigInt(w.preVerificationGas || 0),
      verificationGasLimit: BigInt(w.verificationGasLimit || 0),
      callGasLimit: BigInt(w.callGasLimit || 0),
      paymasterVerificationGasLimit: w.paymasterVerificationGasLimit ? BigInt(w.paymasterVerificationGasLimit) : void 0,
      paymasterPostOpGasLimit: w.paymasterPostOpGasLimit ? BigInt(w.paymasterPostOpGasLimit) : void 0
    };
  } catch (m) {
    throw bV(m, t);
  }
}, wV = async (e, { hash: t }) => {
  const r = [t], o = await e.request({
    method: "eth_getUserOperationByHash",
    params: r
  });
  if (!o)
    return null;
  const { userOperation: l, entryPoint: d, transactionHash: f, blockHash: m, blockNumber: v } = o;
  return {
    userOperation: d === l5 ? {
      ...l,
      nonce: BigInt(l.nonce),
      callGasLimit: BigInt(l.callGasLimit),
      verificationGasLimit: BigInt(l.verificationGasLimit),
      preVerificationGas: BigInt(l.preVerificationGas),
      maxFeePerGas: BigInt(l.maxFeePerGas),
      maxPriorityFeePerGas: BigInt(l.maxPriorityFeePerGas)
    } : {
      ...l,
      nonce: BigInt(l.nonce),
      callGasLimit: BigInt(l.callGasLimit),
      verificationGasLimit: BigInt(l.verificationGasLimit),
      preVerificationGas: BigInt(l.preVerificationGas),
      maxFeePerGas: BigInt(l.maxFeePerGas),
      maxPriorityFeePerGas: BigInt(l.maxPriorityFeePerGas),
      paymasterVerificationGasLimit: l.paymasterVerificationGasLimit ? BigInt(l.paymasterVerificationGasLimit) : void 0,
      paymasterPostOpGasLimit: l.paymasterVerificationGasLimit ? BigInt(l.paymasterPostOpGasLimit) : void 0
    },
    entryPoint: d,
    transactionHash: f,
    blockHash: m,
    blockNumber: BigInt(v)
  };
}, f5 = async (e, { hash: t }) => {
  const r = [t], o = await e.request({
    method: "eth_getUserOperationReceipt",
    params: r
  });
  return o ? {
    userOpHash: o.userOpHash,
    entryPoint: o.entryPoint,
    sender: o.sender,
    nonce: BigInt(o.nonce),
    paymaster: o.paymaster,
    actualGasUsed: BigInt(o.actualGasUsed),
    actualGasCost: BigInt(o.actualGasCost),
    success: o.success,
    reason: o.reason,
    receipt: {
      transactionHash: o.receipt.transactionHash,
      transactionIndex: BigInt(o.receipt.transactionIndex),
      blockHash: o.receipt.blockHash,
      blockNumber: BigInt(o.receipt.blockNumber),
      from: o.receipt.from,
      to: o.receipt.to,
      cumulativeGasUsed: BigInt(o.receipt.cumulativeGasUsed),
      status: fV[o.receipt.status],
      gasUsed: BigInt(o.receipt.gasUsed),
      contractAddress: o.receipt.contractAddress,
      logsBloom: o.receipt.logsBloom,
      effectiveGasPrice: BigInt(o.receipt.effectiveGasPrice)
    },
    logs: o.logs.map((d) => ({
      data: d.data,
      blockNumber: BigInt(d.blockNumber),
      blockHash: d.blockHash,
      transactionHash: d.transactionHash,
      logIndex: Number(d.logIndex),
      transactionIndex: Number(d.transactionIndex),
      address: d.address,
      topics: d.topics,
      removed: d.removed
    }))
  } : null;
};
function xV(e, t) {
  const r = (() => {
    const o = d5(e, t);
    return o instanceof jl ? e : o;
  })();
  throw new gV(r, {
    ...t
  });
}
const P3 = async (e, t) => {
  const { userOperation: r, entryPoint: o } = t;
  try {
    return await e.request({
      method: "eth_sendUserOperation",
      params: [
        Cg(r),
        o
      ]
    });
  } catch (l) {
    throw xV(l, t);
  }
}, SV = async (e) => e.request({
  method: "eth_supportedEntryPoints",
  params: []
}), OE = /* @__PURE__ */ new Map(), qP = /* @__PURE__ */ new Map();
let kV = 0;
function EV(e, t, r) {
  const o = ++kV, l = () => OE.get(e) || [], d = () => {
    const x = l();
    OE.set(
      e,
      // biome-ignore lint/suspicious/noExplicitAny: it's a recursive function, so it's hard to type
      x.filter((b) => b.id !== o)
    );
  }, f = () => {
    const x = qP.get(e);
    l().length === 1 && x && x(), d();
  }, m = l();
  if (OE.set(e, [
    ...m,
    { id: o, fns: t }
  ]), m && m.length > 0)
    return f;
  const v = {};
  for (const x in t)
    v[x] = (...b) => {
      var T, O;
      const k = l();
      if (k.length !== 0)
        for (const R of k)
          (O = (T = R.fns)[x]) == null || O.call(T, ...b);
    };
  const w = r(v);
  return typeof w == "function" && qP.set(e, w), f;
}
let CV = class extends we {
  constructor({ hash: t }) {
    super(`Timed out while waiting for transaction with hash "${t}" to be confirmed.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WaitForUserOperationReceiptTimeoutError"
    });
  }
};
const v0 = (e, { hash: t, pollingInterval: r = e.pollingInterval, timeout: o }) => {
  const l = sa([
    "waitForUserOperationReceipt",
    e.uid,
    t
  ]);
  let d;
  return new Promise((f, m) => {
    const v = EV(l, { resolve: f, reject: m }, async (w) => {
      let x;
      const b = setInterval(async () => {
        const k = (T) => {
          clearInterval(b), T(), v(), o && clearTimeout(x);
        };
        try {
          const T = await Ke(e, f5, "getUserOperationReceipt")({ hash: t });
          if (T !== null && (d = T), d) {
            k(() => w.resolve(d));
            return;
          }
        } catch (T) {
          k(() => w.reject(T));
          return;
        }
      }, r);
      o && (x = setTimeout(() => {
        clearInterval(b), v(), m(new CV({
          hash: t
        })), clearTimeout(x);
      }, o));
    });
  });
}, TV = async (e, t) => {
  const { sender: r, entryPoint: o, key: l = BigInt(0) } = t;
  return await Ke(e, Ts, "readContract")({
    address: o,
    abi: [
      {
        inputs: [
          {
            name: "sender",
            type: "address"
          },
          {
            name: "key",
            type: "uint192"
          }
        ],
        name: "getNonce",
        outputs: [
          {
            name: "nonce",
            type: "uint256"
          }
        ],
        stateMutability: "view",
        type: "function"
      }
    ],
    functionName: "getNonce",
    args: [r, l]
  });
}, _V = (e) => (t) => ({
  sendUserOperation: async (r) => P3(t, {
    ...r,
    entryPoint: e
  }),
  estimateUserOperationGas: (r, o) => O3(t, { ...r, entryPoint: e }, o),
  supportedEntryPoints: () => SV(t),
  chainId: () => dV(t),
  getUserOperationByHash: (r) => wV(t, r),
  getUserOperationReceipt: (r) => f5(t, r),
  waitForUserOperationReceipt: (r) => v0(t, r)
});
class lT extends we {
  constructor({ docsPath: t } = {}) {
    super([
      "A smart account cannot sign or send transaction, it can only sign message or userOperation.",
      "Please send user operation instead."
    ].join(`
`), {
      docsPath: t,
      docsSlug: "account"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SignTransactionNotSupportedBySmartAccount"
    });
  }
}
async function RV(e, t, r) {
  const { account: o = e.account, userOperation: l, middleware: d } = t;
  if (!o)
    throw new _s();
  const f = Ul(o), [m, v, w, x] = await Promise.all([
    l.sender || f.address,
    l.nonce || f.getNonce(),
    l.initCode || f.getInitCode(),
    l.callData
  ]), b = {
    sender: m,
    nonce: v,
    initCode: w,
    callData: x,
    paymasterAndData: "0x",
    signature: l.signature || "0x",
    maxFeePerGas: l.maxFeePerGas || BigInt(0),
    maxPriorityFeePerGas: l.maxPriorityFeePerGas || BigInt(0),
    callGasLimit: l.callGasLimit || BigInt(0),
    verificationGasLimit: l.verificationGasLimit || BigInt(0),
    preVerificationGas: l.preVerificationGas || BigInt(0)
  };
  if (b.signature === "0x" && (b.signature = await f.getDummySignature(b)), typeof d == "function")
    return d({
      userOperation: b,
      entryPoint: f.entryPoint
    });
  if (d && typeof d != "function" && d.gasPrice) {
    const k = await d.gasPrice();
    b.maxFeePerGas = k.maxFeePerGas, b.maxPriorityFeePerGas = k.maxPriorityFeePerGas;
  }
  if (!b.maxFeePerGas || !b.maxPriorityFeePerGas) {
    const k = await bg(f.client);
    b.maxFeePerGas = b.maxFeePerGas || k.maxFeePerGas, b.maxPriorityFeePerGas = b.maxPriorityFeePerGas || k.maxPriorityFeePerGas;
  }
  if (d && typeof d != "function" && d.sponsorUserOperation) {
    const k = await d.sponsorUserOperation({
      userOperation: b,
      entryPoint: f.entryPoint
    });
    return b.callGasLimit = k.callGasLimit, b.verificationGasLimit = k.verificationGasLimit, b.preVerificationGas = k.preVerificationGas, b.paymasterAndData = k.paymasterAndData, b.maxFeePerGas = k.maxFeePerGas || b.maxFeePerGas, b.maxPriorityFeePerGas = k.maxPriorityFeePerGas || b.maxPriorityFeePerGas, b;
  }
  if (!b.callGasLimit || !b.verificationGasLimit || !b.preVerificationGas) {
    const k = await Ke(e, O3, "estimateUserOperationGas")(
      {
        userOperation: b,
        entryPoint: f.entryPoint
      },
      // @ts-ignore getAction takes only two params but when compiled this will work
      r
    );
    b.callGasLimit |= k.callGasLimit, b.verificationGasLimit = b.verificationGasLimit || k.verificationGasLimit, b.preVerificationGas = b.preVerificationGas || k.preVerificationGas;
  }
  return b;
}
async function OV(e, t, r) {
  const { account: o = e.account, userOperation: l, middleware: d } = t;
  if (!o)
    throw new _s();
  const f = Ul(o), [m, v, w, x, b, k] = await Promise.all([
    l.sender || f.address,
    l.nonce || f.getNonce(),
    l.factory || f.getFactory(),
    l.factoryData || f.getFactoryData(),
    l.callData,
    !l.maxFeePerGas || !l.maxPriorityFeePerGas ? bg(f.client) : void 0
  ]), T = {
    sender: m,
    nonce: v,
    factory: w,
    factoryData: x,
    callData: b,
    callGasLimit: l.callGasLimit || BigInt(0),
    verificationGasLimit: l.verificationGasLimit || BigInt(0),
    preVerificationGas: l.preVerificationGas || BigInt(0),
    maxFeePerGas: l.maxFeePerGas || (k == null ? void 0 : k.maxFeePerGas) || BigInt(0),
    maxPriorityFeePerGas: l.maxPriorityFeePerGas || (k == null ? void 0 : k.maxPriorityFeePerGas) || BigInt(0),
    signature: l.signature || "0x"
  };
  if (T.signature === "0x" && (T.signature = await f.getDummySignature(T)), typeof d == "function")
    return d({
      userOperation: T,
      entryPoint: f.entryPoint
    });
  if (d && typeof d != "function" && d.gasPrice) {
    const O = await d.gasPrice();
    T.maxFeePerGas = O.maxFeePerGas, T.maxPriorityFeePerGas = O.maxPriorityFeePerGas;
  }
  if (!T.maxFeePerGas || !T.maxPriorityFeePerGas) {
    const O = await bg(f.client);
    T.maxFeePerGas = T.maxFeePerGas || O.maxFeePerGas, T.maxPriorityFeePerGas = T.maxPriorityFeePerGas || O.maxPriorityFeePerGas;
  }
  if (d && typeof d != "function" && d.sponsorUserOperation) {
    const O = await d.sponsorUserOperation({
      userOperation: T,
      entryPoint: f.entryPoint
    });
    return T.callGasLimit = O.callGasLimit, T.verificationGasLimit = O.verificationGasLimit, T.preVerificationGas = O.preVerificationGas, T.paymaster = O.paymaster, T.paymasterVerificationGasLimit = O.paymasterVerificationGasLimit, T.paymasterPostOpGasLimit = O.paymasterPostOpGasLimit, T.paymasterData = O.paymasterData, T.maxFeePerGas = O.maxFeePerGas || T.maxFeePerGas, T.maxPriorityFeePerGas = O.maxPriorityFeePerGas || T.maxPriorityFeePerGas, T;
  }
  if (!T.callGasLimit || !T.verificationGasLimit || !T.preVerificationGas) {
    const O = await Ke(e, O3, "estimateUserOperationGas")(
      {
        userOperation: T,
        entryPoint: f.entryPoint
      },
      // @ts-ignore getAction takes only two params but when compiled this will work
      r
    );
    T.callGasLimit |= O.callGasLimit, T.verificationGasLimit = T.verificationGasLimit || O.verificationGasLimit, T.preVerificationGas = T.preVerificationGas || O.preVerificationGas, T.paymasterPostOpGasLimit = T.paymasterPostOpGasLimit || O.paymasterPostOpGasLimit, T.paymasterPostOpGasLimit = T.paymasterPostOpGasLimit || O.paymasterPostOpGasLimit;
  }
  return T;
}
async function j3(e, t, r) {
  const { account: o = e.account } = t;
  if (!o)
    throw new _s();
  const l = Ul(o);
  return y0(l.entryPoint) === "v0.6" ? RV(e, t, r) : OV(e, t, r);
}
async function kx(e, t) {
  const { account: r = e.account } = t;
  if (!r)
    throw new _s();
  const o = Ul(r), l = await Ke(e, j3, "prepareUserOperationRequest")(t);
  return l.signature = await o.signUserOperation(l), P3(e, {
    userOperation: l,
    entryPoint: o.entryPoint
  });
}
async function PV(e, t) {
  const { abi: r, args: o, bytecode: l, middleware: d, ...f } = t, { account: m = e.account } = f;
  if (!m)
    throw new _s({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const v = Ul(m), w = await Ke(e, kx, "sendUserOperation")({
    userOperation: {
      sender: v.address,
      maxFeePerGas: f.maxFeePerGas || BigInt(0),
      maxPriorityFeePerGas: f.maxPriorityFeePerGas || BigInt(0),
      callData: await v.encodeDeployCallData({
        abi: r,
        bytecode: l,
        args: o
      })
    },
    account: v,
    middleware: d
  }), x = await Ke(e, v0, "waitForUserOperationReceipt")({
    hash: w
  });
  return x == null ? void 0 : x.receipt.transactionHash;
}
async function p5(e, t) {
  const { account: r = e.account, data: o, maxFeePerGas: l, maxPriorityFeePerGas: d, to: f, value: m, nonce: v, middleware: w } = t;
  if (!r)
    throw new _s({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const x = Ul(r);
  if (!f)
    throw new Error("Missing to address");
  if (x.type !== "local")
    throw new Error("RPC account type not supported");
  const b = await x.encodeCallData({
    to: f,
    value: m || BigInt(0),
    data: o || "0x"
  }), k = await Ke(e, kx, "sendUserOperation")({
    userOperation: {
      sender: x.address,
      maxFeePerGas: l || BigInt(0),
      maxPriorityFeePerGas: d || BigInt(0),
      callData: b,
      nonce: v ? BigInt(v) : void 0
    },
    account: x,
    middleware: w
  }), T = await Ke(e, v0, "waitForUserOperationReceipt")({
    hash: k
  });
  return T == null ? void 0 : T.receipt.transactionHash;
}
async function jV(e, { account: t = e.account, message: r }) {
  if (!t)
    throw new _s({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const o = Ul(t);
  if (o.type === "local")
    return o.signMessage({ message: r });
  throw new Error("Sign message is not supported by this account");
}
async function AV(e, { account: t = e.account, domain: r, message: o, primaryType: l, types: d }) {
  if (!t)
    throw new _s({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const f = Ul(t), m = {
    EIP712Domain: p3({ domain: r }),
    ...d
  };
  if (f3({
    domain: r,
    message: o,
    primaryType: l,
    types: m
  }), f.type === "local")
    return f.signTypedData({
      domain: r,
      primaryType: l,
      types: m,
      message: o
    });
  throw new Error("Sign type message is not supported by this account");
}
async function DV(e, t) {
  const { account: r = e.account, transactions: o, middleware: l, maxFeePerGas: d, maxPriorityFeePerGas: f, nonce: m } = t;
  if (!r)
    throw new _s({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const v = Ul(r);
  if (v.type !== "local")
    throw new Error("RPC account type not supported");
  const w = await v.encodeCallData(o.map(({ to: k, value: T, data: O }) => {
    if (!k)
      throw new Error("Missing to address");
    return {
      to: k,
      value: T || BigInt(0),
      data: O || "0x"
    };
  })), x = await Ke(e, kx, "sendUserOperation")({
    userOperation: {
      sender: v.address,
      maxFeePerGas: d || BigInt(0),
      maxPriorityFeePerGas: f || BigInt(0),
      callData: w,
      nonce: m
    },
    account: v,
    middleware: l
  }), b = await Ke(e, v0, "waitForUserOperationReceipt")({
    hash: x
  });
  return b == null ? void 0 : b.receipt.transactionHash;
}
async function IV(e, { abi: t, address: r, args: o, dataSuffix: l, functionName: d, ...f }) {
  const m = di({
    abi: t,
    args: o,
    functionName: d
  });
  return await Ke(e, p5, "sendTransaction")({
    data: `${m}${l ? l.replace("0x", "") : ""}`,
    to: r,
    ...f
  });
}
function MV({ middleware: e }) {
  return (t) => ({
    prepareUserOperationRequest: (r, o) => j3(t, {
      ...r,
      middleware: e
    }, o),
    deployContract: (r) => PV(t, {
      ...r,
      middleware: e
    }),
    sendTransaction: (r) => p5(t, {
      ...r,
      middleware: e
    }),
    sendTransactions: (r) => DV(t, {
      ...r,
      middleware: e
    }),
    sendUserOperation: (r) => kx(t, {
      ...r,
      middleware: e
    }),
    signMessage: (r) => jV(t, r),
    signTypedData: (r) => AV(t, r),
    writeContract: (r) => IV(t, {
      ...r,
      middleware: e
    })
  });
}
const h5 = R3({ type: "system", namespace: "", name: "unlimited" }), PE = 250, jE = pV, $V = 0n, LV = "0x91E60e0613810449d098b0b5Ec8b51A0FE8c8985";
var M1 = { registerFunctionSelector: !0, openAccess: !0, accessList: [] }, Jc = { worldContractName: void 0, worldInterfaceName: "IWorld", systems: {}, excludeSystems: [], postDeployScript: "PostDeploy", deploysDirectory: "./deploys", worldsFile: "./worlds.json", worldgenDirectory: "world", worldImportPath: "@latticexyz/world/src/" }, Ex = ["uint8", "uint16", "uint24", "uint32", "uint40", "uint48", "uint56", "uint64", "uint72", "uint80", "uint88", "uint96", "uint104", "uint112", "uint120", "uint128", "uint136", "uint144", "uint152", "uint160", "uint168", "uint176", "uint184", "uint192", "uint200", "uint208", "uint216", "uint224", "uint232", "uint240", "uint248", "uint256", "int8", "int16", "int24", "int32", "int40", "int48", "int56", "int64", "int72", "int80", "int88", "int96", "int104", "int112", "int120", "int128", "int136", "int144", "int152", "int160", "int168", "int176", "int184", "int192", "int200", "int208", "int216", "int224", "int232", "int240", "int248", "int256", "bytes1", "bytes2", "bytes3", "bytes4", "bytes5", "bytes6", "bytes7", "bytes8", "bytes9", "bytes10", "bytes11", "bytes12", "bytes13", "bytes14", "bytes15", "bytes16", "bytes17", "bytes18", "bytes19", "bytes20", "bytes21", "bytes22", "bytes23", "bytes24", "bytes25", "bytes26", "bytes27", "bytes28", "bytes29", "bytes30", "bytes31", "bytes32", "bool", "address", "uint8[]", "uint16[]", "uint24[]", "uint32[]", "uint40[]", "uint48[]", "uint56[]", "uint64[]", "uint72[]", "uint80[]", "uint88[]", "uint96[]", "uint104[]", "uint112[]", "uint120[]", "uint128[]", "uint136[]", "uint144[]", "uint152[]", "uint160[]", "uint168[]", "uint176[]", "uint184[]", "uint192[]", "uint200[]", "uint208[]", "uint216[]", "uint224[]", "uint232[]", "uint240[]", "uint248[]", "uint256[]", "int8[]", "int16[]", "int24[]", "int32[]", "int40[]", "int48[]", "int56[]", "int64[]", "int72[]", "int80[]", "int88[]", "int96[]", "int104[]", "int112[]", "int120[]", "int128[]", "int136[]", "int144[]", "int152[]", "int160[]", "int168[]", "int176[]", "int184[]", "int192[]", "int200[]", "int208[]", "int216[]", "int224[]", "int232[]", "int240[]", "int248[]", "int256[]", "bytes1[]", "bytes2[]", "bytes3[]", "bytes4[]", "bytes5[]", "bytes6[]", "bytes7[]", "bytes8[]", "bytes9[]", "bytes10[]", "bytes11[]", "bytes12[]", "bytes13[]", "bytes14[]", "bytes15[]", "bytes16[]", "bytes17[]", "bytes18[]", "bytes19[]", "bytes20[]", "bytes21[]", "bytes22[]", "bytes23[]", "bytes24[]", "bytes25[]", "bytes26[]", "bytes27[]", "bytes28[]", "bytes29[]", "bytes30[]", "bytes31[]", "bytes32[]", "bool[]", "address[]", "bytes", "string"], NV = Ex.slice(0, 98), FV = Ex.slice(98);
function zV(e) {
  return Ex.includes(e);
}
var BV = { uint8: 0, uint16: 0, uint24: 0, uint32: 0, uint40: 0, uint48: 0, uint56: 0n, uint64: 0n, uint72: 0n, uint80: 0n, uint88: 0n, uint96: 0n, uint104: 0n, uint112: 0n, uint120: 0n, uint128: 0n, uint136: 0n, uint144: 0n, uint152: 0n, uint160: 0n, uint168: 0n, uint176: 0n, uint184: 0n, uint192: 0n, uint200: 0n, uint208: 0n, uint216: 0n, uint224: 0n, uint232: 0n, uint240: 0n, uint248: 0n, uint256: 0n, int8: 0, int16: 0, int24: 0, int32: 0, int40: 0, int48: 0, int56: 0n, int64: 0n, int72: 0n, int80: 0n, int88: 0n, int96: 0n, int104: 0n, int112: 0n, int120: 0n, int128: 0n, int136: 0n, int144: 0n, int152: 0n, int160: 0n, int168: 0n, int176: 0n, int184: 0n, int192: 0n, int200: 0n, int208: 0n, int216: 0n, int224: 0n, int232: 0n, int240: 0n, int248: 0n, int256: 0n, bytes1: "0x00", bytes2: "0x0000", bytes3: "0x000000", bytes4: "0x00000000", bytes5: "0x0000000000", bytes6: "0x000000000000", bytes7: "0x00000000000000", bytes8: "0x0000000000000000", bytes9: "0x000000000000000000", bytes10: "0x00000000000000000000", bytes11: "0x0000000000000000000000", bytes12: "0x000000000000000000000000", bytes13: "0x00000000000000000000000000", bytes14: "0x0000000000000000000000000000", bytes15: "0x000000000000000000000000000000", bytes16: "0x00000000000000000000000000000000", bytes17: "0x0000000000000000000000000000000000", bytes18: "0x000000000000000000000000000000000000", bytes19: "0x00000000000000000000000000000000000000", bytes20: "0x0000000000000000000000000000000000000000", bytes21: "0x000000000000000000000000000000000000000000", bytes22: "0x00000000000000000000000000000000000000000000", bytes23: "0x0000000000000000000000000000000000000000000000", bytes24: "0x000000000000000000000000000000000000000000000000", bytes25: "0x00000000000000000000000000000000000000000000000000", bytes26: "0x0000000000000000000000000000000000000000000000000000", bytes27: "0x000000000000000000000000000000000000000000000000000000", bytes28: "0x00000000000000000000000000000000000000000000000000000000", bytes29: "0x0000000000000000000000000000000000000000000000000000000000", bytes30: "0x000000000000000000000000000000000000000000000000000000000000", bytes31: "0x00000000000000000000000000000000000000000000000000000000000000", bytes32: "0x0000000000000000000000000000000000000000000000000000000000000000", bool: !1, address: "0x0000000000000000000000000000000000000000" }, Rm = { uint8: 1, uint16: 2, uint24: 3, uint32: 4, uint40: 5, uint48: 6, uint56: 7, uint64: 8, uint72: 9, uint80: 10, uint88: 11, uint96: 12, uint104: 13, uint112: 14, uint120: 15, uint128: 16, uint136: 17, uint144: 18, uint152: 19, uint160: 20, uint168: 21, uint176: 22, uint184: 23, uint192: 24, uint200: 25, uint208: 26, uint216: 27, uint224: 28, uint232: 29, uint240: 30, uint248: 31, uint256: 32, int8: 1, int16: 2, int24: 3, int32: 4, int40: 5, int48: 6, int56: 7, int64: 8, int72: 9, int80: 10, int88: 11, int96: 12, int104: 13, int112: 14, int120: 15, int128: 16, int136: 17, int144: 18, int152: 19, int160: 20, int168: 21, int176: 22, int184: 23, int192: 24, int200: 25, int208: 26, int216: 27, int224: 28, int232: 29, int240: 30, int248: 31, int256: 32, bytes1: 1, bytes2: 2, bytes3: 3, bytes4: 4, bytes5: 5, bytes6: 6, bytes7: 7, bytes8: 8, bytes9: 9, bytes10: 10, bytes11: 11, bytes12: 12, bytes13: 13, bytes14: 14, bytes15: 15, bytes16: 16, bytes17: 17, bytes18: 18, bytes19: 19, bytes20: 20, bytes21: 21, bytes22: 22, bytes23: 23, bytes24: 24, bytes25: 25, bytes26: 26, bytes27: 27, bytes28: 28, bytes29: 29, bytes30: 30, bytes31: 31, bytes32: 32, bool: 1, address: 20 };
function ep(e) {
  return NV.includes(e);
}
var UV = /\[\]$/, cT = /\[\d+\]$/;
function Cx(e) {
  return typeof e == "string" && cT.test(e) && ep(e.replace(cT, ""));
}
function HV(e) {
  return e.replace(UV, "");
}
function VV(e) {
  return e.replace(cT, "[]");
}
var GV = { "uint8[]": [], "uint16[]": [], "uint24[]": [], "uint32[]": [], "uint40[]": [], "uint48[]": [], "uint56[]": [], "uint64[]": [], "uint72[]": [], "uint80[]": [], "uint88[]": [], "uint96[]": [], "uint104[]": [], "uint112[]": [], "uint120[]": [], "uint128[]": [], "uint136[]": [], "uint144[]": [], "uint152[]": [], "uint160[]": [], "uint168[]": [], "uint176[]": [], "uint184[]": [], "uint192[]": [], "uint200[]": [], "uint208[]": [], "uint216[]": [], "uint224[]": [], "uint232[]": [], "uint240[]": [], "uint248[]": [], "uint256[]": [], "int8[]": [], "int16[]": [], "int24[]": [], "int32[]": [], "int40[]": [], "int48[]": [], "int56[]": [], "int64[]": [], "int72[]": [], "int80[]": [], "int88[]": [], "int96[]": [], "int104[]": [], "int112[]": [], "int120[]": [], "int128[]": [], "int136[]": [], "int144[]": [], "int152[]": [], "int160[]": [], "int168[]": [], "int176[]": [], "int184[]": [], "int192[]": [], "int200[]": [], "int208[]": [], "int216[]": [], "int224[]": [], "int232[]": [], "int240[]": [], "int248[]": [], "int256[]": [], "bytes1[]": [], "bytes2[]": [], "bytes3[]": [], "bytes4[]": [], "bytes5[]": [], "bytes6[]": [], "bytes7[]": [], "bytes8[]": [], "bytes9[]": [], "bytes10[]": [], "bytes11[]": [], "bytes12[]": [], "bytes13[]": [], "bytes14[]": [], "bytes15[]": [], "bytes16[]": [], "bytes17[]": [], "bytes18[]": [], "bytes19[]": [], "bytes20[]": [], "bytes21[]": [], "bytes22[]": [], "bytes23[]": [], "bytes24[]": [], "bytes25[]": [], "bytes26[]": [], "bytes27[]": [], "bytes28[]": [], "bytes29[]": [], "bytes30[]": [], "bytes31[]": [], "bytes32[]": [], "bool[]": [], "address[]": [], bytes: "0x", string: "" };
function qV(e) {
  return FV.includes(e);
}
function WP(e, t) {
  if (typeof e > "u")
    throw new Error(t);
  return e;
}
function m5(e, t) {
  throw new Error(t ?? `assertExhaustive received unexpected value: ${e}`);
}
function RX(e) {
  return e !== void 0;
}
function Gf(e, t) {
  return Object.fromEntries(Object.entries(e).map(([r, o]) => [r, t(o, r)]));
}
function OX(e) {
  return new Promise((t) => setTimeout(() => t(), e));
}
function dT(e, t) {
  var d;
  const r = Array.isArray(e), o = Object.entries(e).flatMap((f, m) => {
    const v = r ? t(m, f[1]) : t(...f, m);
    return Array.isArray(v[0]) || v.length === 0 ? (
      // if we have an empty array (for filtering) or an array with
      // another array as its first element, treat it as a list of
      v
    ) : (
      // otherwise, it should be a single entry, so nest it in a tuple
      // so it doesn't get spread when the result is flattened
      [v]
    );
  }), l = Object.fromEntries(o);
  return typeof ((d = o[0]) == null ? void 0 : d[0]) == "number" ? Object.assign([], l) : l;
}
const qv = (e) => {
  const t = [];
  for (; e !== Object.prototype && e !== null && e !== void 0; ) {
    for (const r of Object.getOwnPropertyNames(e))
      r !== "constructor" && !t.includes(r) && t.push(r);
    for (const r of Object.getOwnPropertySymbols(e))
      t.includes(r) || t.push(r);
    e = Object.getPrototypeOf(e);
  }
  return t;
};
qv(0n), qv(!1), qv(0), qv(""), qv(Symbol());
const WV = {};
globalThis.$ark = WV;
var YP;
(function(e) {
  class t {
  }
  e.Kind = t, e.reify = (o) => o.f;
  class r {
  }
  e.UnaryKind = r, e.pipe = (...o) => (l) => o.reduce((d, f) => f.f(d), l);
})(YP || (YP = {}));
const ZP = /^(?!^-0$)-?(?:0|[1-9]\d*)(?:\.\d*[1-9])?$/;
ZP.test.bind(ZP);
const KP = /^(?:0|(?:-?[1-9]\d*))$/;
KP.test.bind(KP);
const QP = /^-?\d+$/;
QP.test.bind(QP);
function Mo(e, t) {
  return typeof e == "object" && e != null && Er(e, t) ? e[t] : void 0;
}
function y5(e, t) {
  return t.length ? y5(Mo(e, t[0]), t.slice(1)) : e;
}
function Er(e, t) {
  return typeof e == "object" && e !== null && e.hasOwnProperty(t);
}
function ao(e) {
  return e != null && typeof e == "object";
}
function $o(e, t) {
  let r = [.../* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)])];
  return Object.fromEntries(r.map((o) => [o, e[o] ?? t[o]]));
}
var XP = { storeImportPath: "@latticexyz/store/src/", userTypesFilename: "common.sol", outputDirectory: "codegen", namespaceDirectories: !1, indexFilename: "index.sol" }, AE = { outputDirectory: "tables", tableIdArgument: !1, storeArgument: !1 }, YV = { disabled: !1 }, JP = { namespace: "", type: "table" }, ej = { sourceDirectory: "src", namespace: "" }, io = { types: Object.fromEntries(Ex.map((e) => [e, e])) };
function v5(e, t) {
  return { types: { ...e.types, ...t } };
}
function ZV(e, t = io) {
  if (!ao(e))
    throw new Error(`Expected schema, received ${JSON.stringify(e)}`);
  for (let r of Object.values(e))
    if (!Cx(r) && !Er(t.types, r))
      throw new Error(`"${String(r)}" is not a valid type in this scope.`);
}
function KV(e, t = io) {
  return Object.fromEntries(Object.entries(e).map(([r, o]) => [r, { type: Cx(o) ? VV(o) : t.types[o], internalType: o }]));
}
function g5(e, t = io) {
  return typeof e == "object" && e != null && Object.values(e).every((r) => Cx(r) || Er(t.types, r));
}
function QV(e, t = io) {
  return Object.entries(e).filter(([, r]) => Er(t.types, r) && ep(t.types[r])).map(([r]) => r);
}
function XV(e, t, r = io) {
  return Array.isArray(e) && e.every((o) => Er(t, o) && Er(r.types, t[o]) && ep(r.types[t[o]]));
}
function A3(e, t = io, r = { inStoreContext: !1 }) {
  if (typeof e != "object" || e == null)
    throw new Error(`Expected full table config, got \`${JSON.stringify(e)}\``);
  if (!Er(e, "schema"))
    throw new Error("Missing schema input");
  if (ZV(e.schema, t), !Er(e, "key") || !XV(e.key, e.schema, t))
    throw new Error(`Invalid key. Expected \`(${QV(e.schema, t).map((o) => `"${String(o)}"`).join(" | ")})[]\`, received \`${Er(e, "key") && Array.isArray(e.key) ? `[${e.key.map((o) => `"${o}"`).join(", ")}]` : String(Mo(e, "key"))}\``);
  if (r.inStoreContext && Er(e, "name") || Er(e, "namespace"))
    throw new Error("Overrides of `name` and `namespace` are not allowed for tables in a store config.");
}
function JV(e) {
  let t = e.codegen;
  return { outputDirectory: Mo(t, "outputDirectory") ?? AE.outputDirectory, tableIdArgument: Mo(t, "tableIdArgument") ?? AE.tableIdArgument, storeArgument: Mo(t, "storeArgument") ?? AE.storeArgument, dataStruct: Mo(t, "dataStruct") ?? Object.keys(e.schema).length - e.key.length > 1 };
}
function b5(e, t = io) {
  let r = e.name, o = e.type ?? JP.type, l = e.namespace ?? JP.namespace;
  return { tableId: e.tableId ?? R3({ type: o, namespace: l, name: r }), name: r, namespace: l, type: o, key: e.key, schema: KV(e.schema, t), codegen: JV(e), deploy: $o(e.deploy ?? {}, YV) };
}
function w5(e, t) {
  if (ao(e)) {
    for (let r of Object.values(e))
      A3(r, t, { inStoreContext: !0 });
    return;
  }
  throw new Error(`Expected store config, received ${JSON.stringify(e)}`);
}
function eG(e, t = io) {
  if (!ao(e))
    throw new Error(`Expected tables config, received ${JSON.stringify(e)}`);
  return Object.fromEntries(Object.entries(e).map(([r, o]) => [r, b5($o(o, { name: r }), t)]));
}
function tG(e) {
  return Gf(e, (t) => t.type);
}
function nG(e) {
  return ao(e) && Object.values(e).every((t) => zV(t.type));
}
function rG(e, t = io) {
  return nG(e) ? v5(t, tG(e)) : t;
}
function aG(e) {
  if (!ao(e))
    throw new Error(`Expected userTypes, received ${JSON.stringify(e)}`);
  for (let { type: t } of Object.values(e))
    if (!Er(io.types, t))
      throw new Error(`"${String(t)}" is not a valid ABI type.`);
}
function iG(e) {
  return typeof e == "object" && e != null && Object.values(e).every((t) => Array.isArray(t) && t.every((r) => typeof r == "string"));
}
function oG(e, t = io) {
  if (iG(e)) {
    let r = Object.fromEntries(Object.keys(e).map((o) => [o, "uint8"]));
    return v5(t, r);
  }
  return t;
}
function sG(e) {
  return dT(e, (t, r) => [t, dT(r, (o, l) => [l, o])]);
}
function uG(e) {
  return ao(e) ? $o(e, XP) : XP;
}
function Ed(e) {
  return oG(Mo(e, "enums"), rG(Mo(e, "userTypes")));
}
function x5(e) {
  let t = Ed(e);
  Er(e, "tables") && w5(e.tables, t), Er(e, "userTypes") && aG(e.userTypes);
}
function S5(e) {
  let t = uG(e.codegen);
  return { sourceDirectory: e.sourceDirectory ?? ej.sourceDirectory, tables: eG(dT(e.tables ?? {}, (r, o) => {
    let l = e.namespace;
    return [l ? `${l}__${r}` : r, $o(o, { namespace: l, name: r, codegen: $o(o.codegen ?? {}, { outputDirectory: t.namespaceDirectories && (l != null && l.length) ? `${l}/tables` : "tables" }) })];
  }), Ed(e)), userTypes: e.userTypes ?? {}, enums: e.enums ?? {}, enumValues: sG(e.enums ?? {}), namespace: e.namespace ?? ej.namespace, codegen: t };
}
function $1(e) {
  return typeof e == "string" || ao(e) && Object.values(e).every((t) => typeof t == "string");
}
function lG(e, t = io) {
  if (typeof e == "string") {
    if (Cx(e) || Er(t.types, e))
      return;
    throw new Error(`Invalid ABI type. \`${e}\` not found in scope.`);
  }
  if (typeof e == "object" && e !== null) {
    if (g5(e, t)) {
      if (Er(e, "id") && ep(t.types[e.id]))
        return;
      throw new Error("Invalid schema. Expected an `id` field with a static ABI type or an explicit `key` option.");
    }
    throw new Error("Invalid schema. Are you using invalid types or missing types in your scope?");
  }
  throw new Error("Invalid table shorthand.");
}
function fT(e, t = io) {
  return g5(e, t) ? { schema: e, key: ["id"] } : { schema: { id: "bytes32", value: e }, key: ["id"] };
}
function pT(e, t) {
  if (ao(e))
    for (let r of Object.keys(e))
      $1(Mo(e, r)) ? lG(Mo(e, r), t) : A3(Mo(e, r), t);
}
function cG(e) {
  let t = Ed(e);
  Er(e, "tables") && ao(e.tables) && pT(e.tables, t);
}
function dG(e) {
  let t = Ed(e), r = { ...e, tables: Gf(e.tables, (o) => $1(o) ? fT(o, t) : o) };
  return x5(r), S5(r);
}
function fG(e) {
  return cG(e), dG(e);
}
var g0 = class extends Error {
  constructor() {
    super(...arguments);
    Oo(this, "name", "MUDError");
  }
}, k5 = class extends g0 {
  constructor(r) {
    super(`Hex value "${r}" is an odd length (${r.length - 2}). It must be an even length.`);
    Oo(this, "name", "InvalidHexValueError");
  }
}, pG = class extends g0 {
  constructor(r) {
    super(`Hex value "${r}" has length of ${r.length - 2}, but expected length of 64 for encoded lengths.`);
    Oo(this, "name", "InvalidHexLengthForEncodedLengthsError");
  }
}, hG = class extends g0 {
  constructor(t, r) {
    super(`Hex value "${r}" has length of ${r.length - 2}, but expected length of ${Rm[t] * 2} for ${t} type.`);
    Oo(this, "name", "InvalidHexLengthForStaticFieldError");
  }
}, mG = class extends g0 {
  constructor(r, o) {
    super(`Hex value "${o}" has length of ${o.length - 2}, but expected a multiple of ${Rm[r] * 2} for ${r}[] type.`);
    Oo(this, "name", "InvalidHexLengthForArrayFieldError");
  }
}, yG = class extends g0 {
  constructor(t, r, o) {
    super(`EncodedLengths "${t}" total bytes length (${r}) did not match the summed length of all field byte lengths (${o}).`);
    Oo(this, "name", "EncodedLengthsLengthMismatchError");
  }
};
function D3(e, t) {
  if (t.length > 3 && t.length % 2 !== 0)
    throw new k5(t);
  if ((t.length - 2) / 2 !== Rm[e])
    throw new hG(e, t);
  switch (e) {
    case "uint8":
    case "uint16":
    case "uint24":
    case "uint32":
    case "uint40":
    case "uint48":
    case "uint56":
    case "uint64":
    case "uint72":
    case "uint80":
    case "uint88":
    case "uint96":
    case "uint104":
    case "uint112":
    case "uint120":
    case "uint128":
    case "uint136":
    case "uint144":
    case "uint152":
    case "uint160":
    case "uint168":
    case "uint176":
    case "uint184":
    case "uint192":
    case "uint200":
    case "uint208":
    case "uint216":
    case "uint224":
    case "uint232":
    case "uint240":
    case "uint248":
    case "uint256":
    case "int8":
    case "int16":
    case "int24":
    case "int32":
    case "int40":
    case "int48":
    case "int56":
    case "int64":
    case "int72":
    case "int80":
    case "int88":
    case "int96":
    case "int104":
    case "int112":
    case "int120":
    case "int128":
    case "int136":
    case "int144":
    case "int152":
    case "int160":
    case "int168":
    case "int176":
    case "int184":
    case "int192":
    case "int200":
    case "int208":
    case "int216":
    case "int224":
    case "int232":
    case "int240":
    case "int248":
    case "int256": {
      let r = Ml(t, { signed: e.startsWith("int") }), o = typeof BV[e];
      if (o === "number")
        return Number(r);
      if (o === "bigint")
        return r;
      throw new Error(`Unexpected default value type (${o}) for ABI type (${e})`);
    }
    case "bytes1":
    case "bytes2":
    case "bytes3":
    case "bytes4":
    case "bytes5":
    case "bytes6":
    case "bytes7":
    case "bytes8":
    case "bytes9":
    case "bytes10":
    case "bytes11":
    case "bytes12":
    case "bytes13":
    case "bytes14":
    case "bytes15":
    case "bytes16":
    case "bytes17":
    case "bytes18":
    case "bytes19":
    case "bytes20":
    case "bytes21":
    case "bytes22":
    case "bytes23":
    case "bytes24":
    case "bytes25":
    case "bytes26":
    case "bytes27":
    case "bytes28":
    case "bytes29":
    case "bytes30":
    case "bytes31":
    case "bytes32":
      return t;
    case "bool":
      return aN(t);
    case "address":
      return ax(t);
  }
  return m5(e, `Unsupported static ABI type: ${e}`);
}
function E5(e, t) {
  if (e === "bytes")
    return t;
  if (e === "string")
    return eg(t);
  if (t.length > 3 && t.length % 2 !== 0)
    throw new k5(t);
  let r = (t.length - 2) / 2;
  switch (e) {
    case "uint8[]":
    case "uint16[]":
    case "uint24[]":
    case "uint32[]":
    case "uint40[]":
    case "uint48[]":
    case "uint56[]":
    case "uint64[]":
    case "uint72[]":
    case "uint80[]":
    case "uint88[]":
    case "uint96[]":
    case "uint104[]":
    case "uint112[]":
    case "uint120[]":
    case "uint128[]":
    case "uint136[]":
    case "uint144[]":
    case "uint152[]":
    case "uint160[]":
    case "uint168[]":
    case "uint176[]":
    case "uint184[]":
    case "uint192[]":
    case "uint200[]":
    case "uint208[]":
    case "uint216[]":
    case "uint224[]":
    case "uint232[]":
    case "uint240[]":
    case "uint248[]":
    case "uint256[]":
    case "int8[]":
    case "int16[]":
    case "int24[]":
    case "int32[]":
    case "int40[]":
    case "int48[]":
    case "int56[]":
    case "int64[]":
    case "int72[]":
    case "int80[]":
    case "int88[]":
    case "int96[]":
    case "int104[]":
    case "int112[]":
    case "int120[]":
    case "int128[]":
    case "int136[]":
    case "int144[]":
    case "int152[]":
    case "int160[]":
    case "int168[]":
    case "int176[]":
    case "int184[]":
    case "int192[]":
    case "int200[]":
    case "int208[]":
    case "int216[]":
    case "int224[]":
    case "int232[]":
    case "int240[]":
    case "int248[]":
    case "int256[]":
    case "bytes1[]":
    case "bytes2[]":
    case "bytes3[]":
    case "bytes4[]":
    case "bytes5[]":
    case "bytes6[]":
    case "bytes7[]":
    case "bytes8[]":
    case "bytes9[]":
    case "bytes10[]":
    case "bytes11[]":
    case "bytes12[]":
    case "bytes13[]":
    case "bytes14[]":
    case "bytes15[]":
    case "bytes16[]":
    case "bytes17[]":
    case "bytes18[]":
    case "bytes19[]":
    case "bytes20[]":
    case "bytes21[]":
    case "bytes22[]":
    case "bytes23[]":
    case "bytes24[]":
    case "bytes25[]":
    case "bytes26[]":
    case "bytes27[]":
    case "bytes28[]":
    case "bytes29[]":
    case "bytes30[]":
    case "bytes31[]":
    case "bytes32[]":
    case "bool[]":
    case "address[]": {
      let o = HV(e), l = Rm[o];
      if (r % l !== 0)
        throw new mG(o, t);
      return new Array(r / l).fill(void 0).map((d, f) => {
        let m = tg(t, f * l, (f + 1) * l);
        return D3(o, m);
      });
    }
  }
  return m5(e, `Unsupported dynamic ABI type: ${e}`);
}
function vG(e) {
  if (e.length !== 66)
    throw new pG(e);
  let t = D3("uint56", Vf(e, 32 - 7, 32)), r = E5("uint40[]", Vf(e, 0, 32 - 7)), o = Object.freeze([...r].reverse()), l = BigInt(o.reduce((d, f) => d + f, 0));
  if (l !== t)
    throw new yG(e, t, l);
  return { totalByteLength: t, fieldByteLengths: o };
}
function C5(e) {
  return e.reduce((t, r) => t + Rm[r], 0);
}
function gG(e, t) {
  let r = [], o = 0;
  e.staticFields.forEach((f) => {
    let m = Rm[f], v = D3(f, Vf(t, o, o + m));
    o += m, r.push(v);
  });
  let l = C5(e.staticFields), d = o;
  if (d !== l && console.warn("Decoded static data length does not match value schema's expected static data length. Data may get corrupted. Is `getStaticByteLength` outdated?", { expectedLength: l, actualLength: d, bytesOffset: o }), e.dynamicFields.length > 0) {
    let f = vG(Vf(t, o, o + 32));
    o += 32, e.dynamicFields.forEach((v, w) => {
      let x = f.fieldByteLengths[w];
      if (x > 0) {
        let b = E5(v, Vf(t, o, o + x));
        o += x, r.push(b);
      } else
        r.push(GV[v]);
    });
    let m = o - 32 - d;
    BigInt(m) !== f.totalByteLength && console.warn("Decoded dynamic data length does not match data layout's expected data length. Data may get corrupted. Did the data layout change?", { expectedLength: f.totalByteLength, actualLength: m, bytesOffset: o });
  }
  return r;
}
function bG(e, t) {
  let r = Object.values(e).filter(ep), o = Object.values(e).filter(qV), l = gG({ staticFields: r, dynamicFields: o }, t);
  return Object.fromEntries(Object.keys(e).map((d, f) => [d, l[f]]));
}
function I3(e, { staticData: t, encodedLengths: r, dynamicData: o }) {
  return bG(e, Ps([Vf(t, 0, C5(Object.values(e).filter(ep))), r, o]));
}
function wG(e, t) {
  return t.map((r, o) => ro([{ type: e.staticFields[o] }], [r]));
}
function xG(e, t) {
  let r = Object.values(e).filter(ep);
  return wG({ staticFields: r, dynamicFields: [] }, Object.values(t));
}
function Tx(e) {
  return Object.fromEntries(e.key.map((t) => [t, e.schema[t]]));
}
function M3(e) {
  return Object.fromEntries(Object.entries(e.schema).filter(([t]) => !e.key.includes(t)));
}
function L1(e) {
  return Gf(e, (t) => t.type);
}
var SG = { root: !1, args: [], artifactPath: void 0 }, hT = { worldInterfaceName: "IWorld", worldgenDirectory: "world", worldImportPath: "@latticexyz/world/src/" }, mT = { customWorldContract: void 0, postDeployScript: "PostDeploy", deploysDirectory: "./deploys", worldsFile: "./worlds.json", upgradeableWorldImplementation: !1 }, DE = { systems: {}, tables: {}, excludeSystems: [], modules: [], codegen: hT, deploy: mT };
function kG(e) {
  return Gf(e, (t) => $o(t, M1));
}
function EG(e) {
  return ao(e) ? $o(e, hT) : hT;
}
function CG(e) {
  return ao(e) ? $o(e, mT) : mT;
}
function T5(e) {
  let t = Ed(e);
  if (x5(e), Er(e, "namespaces")) {
    if (!ao(e.namespaces))
      throw new Error(`Expected namespaces, received ${JSON.stringify(e.namespaces)}`);
    for (let r of Object.values(e.namespaces))
      Er(r, "tables") && w5(r.tables, t);
  }
}
function _5(e) {
  let t = Ed(e), r = e.namespaces ?? {}, o = Object.fromEntries(Object.entries(r).map(([f, m]) => Object.entries(m.tables ?? {}).map(([v, w]) => (A3(w, t), [`${f}__${v}`, b5($o(w, { namespace: f, name: v }), t)]))).flat()), l = S5(e), d = (e.modules ?? DE.modules).map((f) => $o(f, SG));
  return $o({ ...l, tables: { ...l.tables, ...o }, codegen: $o(l.codegen, EG(e.codegen)), deploy: CG(e.deploy), systems: kG(e.systems ?? DE.systems), excludeSystems: Mo(e, "excludeSystems"), modules: d }, DE);
}
function TG(e) {
  return T5(e), _5(e);
}
var R5 = TG({ codegen: { worldImportPath: "../../", worldgenDirectory: "interfaces", worldInterfaceName: "IBaseWorld" }, namespace: "world", userTypes: { ResourceId: { filePath: "@latticexyz/store/src/ResourceId.sol", type: "bytes32" } }, tables: { NamespaceOwner: { schema: { namespaceId: "ResourceId", owner: "address" }, key: ["namespaceId"] }, ResourceAccess: { schema: { resourceId: "ResourceId", caller: "address", access: "bool" }, key: ["resourceId", "caller"] }, InstalledModules: { schema: { moduleAddress: "address", argumentsHash: "bytes32", isInstalled: "bool" }, key: ["moduleAddress", "argumentsHash"] }, UserDelegationControl: { schema: { delegator: "address", delegatee: "address", delegationControlId: "ResourceId" }, key: ["delegator", "delegatee"] }, NamespaceDelegationControl: { schema: { namespaceId: "ResourceId", delegationControlId: "ResourceId" }, key: ["namespaceId"] }, Balances: { schema: { namespaceId: "ResourceId", balance: "uint256" }, key: ["namespaceId"] }, Systems: { schema: { systemId: "ResourceId", system: "address", publicAccess: "bool" }, key: ["systemId"], codegen: { dataStruct: !1 } }, SystemRegistry: { schema: { system: "address", systemId: "ResourceId" }, key: ["system"] }, SystemHooks: { schema: { systemId: "ResourceId", value: "bytes21[]" }, key: ["systemId"] }, FunctionSelectors: { schema: { worldFunctionSelector: "bytes4", systemId: "ResourceId", systemFunctionSelector: "bytes4" }, key: ["worldFunctionSelector"], codegen: { dataStruct: !1 } }, FunctionSignatures: { type: "offchainTable", schema: { functionSelector: "bytes4", functionSignature: "string" }, key: ["functionSelector"] }, InitModuleAddress: { schema: { value: "address" }, key: [] } }, excludeSystems: ["StoreRegistrationSystem"] });
const O5 = [
  {
    type: "function",
    name: "getDynamicField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getDynamicFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getDynamicFieldSlice",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "start",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "end",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLayout",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getKeySchema",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "keySchema",
        type: "bytes32",
        internalType: "Schema"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "staticData",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      }
    ],
    outputs: [
      {
        name: "staticData",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getStaticField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getValueSchema",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "valueSchema",
        type: "bytes32",
        internalType: "Schema"
      }
    ],
    stateMutability: "view"
  }
];
function $3(e, t) {
  return Object.keys(e).map((r) => ro([e[r]], [t[r]]));
}
function _x({
  table: e,
  key: t,
  ...r
}) {
  var l;
  const o = fH(
    e && t && ((l = r.query) == null ? void 0 : l.enabled) !== !1 ? {
      ...r,
      abi: O5,
      functionName: "getRecord",
      args: [e.tableId, $3(Tx(e), t)]
    } : {}
  );
  return {
    ...o,
    record: e && t && o.data != null ? {
      ...t,
      ...I3(L1(M3(e)), {
        staticData: o.data[0],
        encodedLengths: o.data[1],
        dynamicData: o.data[2]
      })
    } : void 0
  };
}
var sn;
(function(e) {
  e.assertEqual = (l) => l;
  function t(l) {
  }
  e.assertIs = t;
  function r(l) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (l) => {
    const d = {};
    for (const f of l)
      d[f] = f;
    return d;
  }, e.getValidEnumValues = (l) => {
    const d = e.objectKeys(l).filter((m) => typeof l[l[m]] != "number"), f = {};
    for (const m of d)
      f[m] = l[m];
    return e.objectValues(f);
  }, e.objectValues = (l) => e.objectKeys(l).map(function(d) {
    return l[d];
  }), e.objectKeys = typeof Object.keys == "function" ? (l) => Object.keys(l) : (l) => {
    const d = [];
    for (const f in l)
      Object.prototype.hasOwnProperty.call(l, f) && d.push(f);
    return d;
  }, e.find = (l, d) => {
    for (const f of l)
      if (d(f))
        return f;
  }, e.isInteger = typeof Number.isInteger == "function" ? (l) => Number.isInteger(l) : (l) => typeof l == "number" && isFinite(l) && Math.floor(l) === l;
  function o(l, d = " | ") {
    return l.map((f) => typeof f == "string" ? `'${f}'` : f).join(d);
  }
  e.joinValues = o, e.jsonStringifyReplacer = (l, d) => typeof d == "bigint" ? d.toString() : d;
})(sn || (sn = {}));
var yT;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(yT || (yT = {}));
const Ye = sn.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ad = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ye.undefined;
    case "string":
      return Ye.string;
    case "number":
      return isNaN(e) ? Ye.nan : Ye.number;
    case "boolean":
      return Ye.boolean;
    case "function":
      return Ye.function;
    case "bigint":
      return Ye.bigint;
    case "symbol":
      return Ye.symbol;
    case "object":
      return Array.isArray(e) ? Ye.array : e === null ? Ye.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ye.promise : typeof Map < "u" && e instanceof Map ? Ye.map : typeof Set < "u" && e instanceof Set ? Ye.set : typeof Date < "u" && e instanceof Date ? Ye.date : Ye.object;
    default:
      return Ye.unknown;
  }
}, Ee = sn.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), _G = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class to extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (o) => {
      this.issues = [...this.issues, o];
    }, this.addIssues = (o = []) => {
      this.issues = [...this.issues, ...o];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(d) {
      return d.message;
    }, o = { _errors: [] }, l = (d) => {
      for (const f of d.issues)
        if (f.code === "invalid_union")
          f.unionErrors.map(l);
        else if (f.code === "invalid_return_type")
          l(f.returnTypeError);
        else if (f.code === "invalid_arguments")
          l(f.argumentsError);
        else if (f.path.length === 0)
          o._errors.push(r(f));
        else {
          let m = o, v = 0;
          for (; v < f.path.length; ) {
            const w = f.path[v];
            v === f.path.length - 1 ? (m[w] = m[w] || { _errors: [] }, m[w]._errors.push(r(f))) : m[w] = m[w] || { _errors: [] }, m = m[w], v++;
          }
        }
    };
    return l(this), o;
  }
  static assert(t) {
    if (!(t instanceof to))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, sn.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, o = [];
    for (const l of this.issues)
      l.path.length > 0 ? (r[l.path[0]] = r[l.path[0]] || [], r[l.path[0]].push(t(l))) : o.push(t(l));
    return { formErrors: o, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
to.create = (e) => new to(e);
const gm = (e, t) => {
  let r;
  switch (e.code) {
    case Ee.invalid_type:
      e.received === Ye.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Ee.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, sn.jsonStringifyReplacer)}`;
      break;
    case Ee.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${sn.joinValues(e.keys, ", ")}`;
      break;
    case Ee.invalid_union:
      r = "Invalid input";
      break;
    case Ee.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${sn.joinValues(e.options)}`;
      break;
    case Ee.invalid_enum_value:
      r = `Invalid enum value. Expected ${sn.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Ee.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Ee.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Ee.invalid_date:
      r = "Invalid date";
      break;
    case Ee.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : sn.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case Ee.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case Ee.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case Ee.custom:
      r = "Invalid input";
      break;
    case Ee.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Ee.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Ee.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, sn.assertNever(e);
  }
  return { message: r };
};
let P5 = gm;
function RG(e) {
  P5 = e;
}
function N1() {
  return P5;
}
const F1 = (e) => {
  const { data: t, path: r, errorMaps: o, issueData: l } = e, d = [...r, ...l.path || []], f = {
    ...l,
    path: d
  };
  if (l.message !== void 0)
    return {
      ...l,
      path: d,
      message: l.message
    };
  let m = "";
  const v = o.filter((w) => !!w).slice().reverse();
  for (const w of v)
    m = w(f, { data: t, defaultError: m }).message;
  return {
    ...l,
    path: d,
    message: m
  };
}, OG = [];
function Ve(e, t) {
  const r = N1(), o = F1({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      r,
      r === gm ? void 0 : gm
      // then global default map
    ].filter((l) => !!l)
  });
  e.common.issues.push(o);
}
class Ga {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const o = [];
    for (const l of r) {
      if (l.status === "aborted")
        return Pt;
      l.status === "dirty" && t.dirty(), o.push(l.value);
    }
    return { status: t.value, value: o };
  }
  static async mergeObjectAsync(t, r) {
    const o = [];
    for (const l of r) {
      const d = await l.key, f = await l.value;
      o.push({
        key: d,
        value: f
      });
    }
    return Ga.mergeObjectSync(t, o);
  }
  static mergeObjectSync(t, r) {
    const o = {};
    for (const l of r) {
      const { key: d, value: f } = l;
      if (d.status === "aborted" || f.status === "aborted")
        return Pt;
      d.status === "dirty" && t.dirty(), f.status === "dirty" && t.dirty(), d.value !== "__proto__" && (typeof f.value < "u" || l.alwaysSet) && (o[d.value] = f.value);
    }
    return { status: t.value, value: o };
  }
}
const Pt = Object.freeze({
  status: "aborted"
}), Yh = (e) => ({ status: "dirty", value: e }), pi = (e) => ({ status: "valid", value: e }), vT = (e) => e.status === "aborted", gT = (e) => e.status === "dirty", Tg = (e) => e.status === "valid", _g = (e) => typeof Promise < "u" && e instanceof Promise;
function z1(e, t, r, o) {
  if (r === "a" && !o)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? o : r === "a" ? o.call(e) : o ? o.value : t.get(e);
}
function j5(e, t, r, o, l) {
  if (o === "m")
    throw new TypeError("Private method is not writable");
  if (o === "a" && !l)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !l : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return o === "a" ? l.call(e, r) : l ? l.value = r : t.set(e, r), r;
}
var ct;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(ct || (ct = {}));
var Xv, Jv;
class Ou {
  constructor(t, r, o, l) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = o, this._key = l;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const tj = (e, t) => {
  if (Tg(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new to(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Lt(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: o, description: l } = e;
  if (t && (r || o))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: l } : { errorMap: (f, m) => {
    var v, w;
    const { message: x } = e;
    return f.code === "invalid_enum_value" ? { message: x ?? m.defaultError } : typeof m.data > "u" ? { message: (v = x ?? o) !== null && v !== void 0 ? v : m.defaultError } : f.code !== "invalid_type" ? { message: m.defaultError } : { message: (w = x ?? r) !== null && w !== void 0 ? w : m.defaultError };
  }, description: l };
}
class Ht {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ad(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: ad(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Ga(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ad(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (_g(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const o = this.safeParse(t, r);
    if (o.success)
      return o.data;
    throw o.error;
  }
  safeParse(t, r) {
    var o;
    const l = {
      common: {
        issues: [],
        async: (o = r == null ? void 0 : r.async) !== null && o !== void 0 ? o : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ad(t)
    }, d = this._parseSync({ data: t, path: l.path, parent: l });
    return tj(l, d);
  }
  async parseAsync(t, r) {
    const o = await this.safeParseAsync(t, r);
    if (o.success)
      return o.data;
    throw o.error;
  }
  async safeParseAsync(t, r) {
    const o = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ad(t)
    }, l = this._parse({ data: t, path: o.path, parent: o }), d = await (_g(l) ? l : Promise.resolve(l));
    return tj(o, d);
  }
  refine(t, r) {
    const o = (l) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(l) : r;
    return this._refinement((l, d) => {
      const f = t(l), m = () => d.addIssue({
        code: Ee.custom,
        ...o(l)
      });
      return typeof Promise < "u" && f instanceof Promise ? f.then((v) => v ? !0 : (m(), !1)) : f ? !0 : (m(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((o, l) => t(o) ? !0 : (l.addIssue(typeof r == "function" ? r(o, l) : r), !1));
  }
  _refinement(t) {
    return new Rs({
      schema: this,
      typeName: Tt.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return Ru.create(this, this._def);
  }
  nullable() {
    return bd.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Es.create(this, this._def);
  }
  promise() {
    return wm.create(this, this._def);
  }
  or(t) {
    return jg.create([this, t], this._def);
  }
  and(t) {
    return Ag.create(this, t, this._def);
  }
  transform(t) {
    return new Rs({
      ...Lt(this._def),
      schema: this,
      typeName: Tt.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Lg({
      ...Lt(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Tt.ZodDefault
    });
  }
  brand() {
    return new L3({
      typeName: Tt.ZodBranded,
      type: this,
      ...Lt(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Ng({
      ...Lt(this._def),
      innerType: this,
      catchValue: r,
      typeName: Tt.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return b0.create(this, t);
  }
  readonly() {
    return Fg.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const PG = /^c[^\s-]{8,}$/i, jG = /^[0-9a-z]+$/, AG = /^[0-9A-HJKMNP-TV-Z]{26}$/, DG = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, IG = /^[a-z0-9_-]{21}$/i, MG = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, $G = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, LG = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let IE;
const NG = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, FG = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, zG = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, A5 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", BG = new RegExp(`^${A5}$`);
function D5(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function UG(e) {
  return new RegExp(`^${D5(e)}$`);
}
function I5(e) {
  let t = `${A5}T${D5(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function HG(e, t) {
  return !!((t === "v4" || !t) && NG.test(e) || (t === "v6" || !t) && FG.test(e));
}
class Ss extends Ht {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Ye.string) {
      const d = this._getOrReturnCtx(t);
      return Ve(d, {
        code: Ee.invalid_type,
        expected: Ye.string,
        received: d.parsedType
      }), Pt;
    }
    const o = new Ga();
    let l;
    for (const d of this._def.checks)
      if (d.kind === "min")
        t.data.length < d.value && (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.too_small,
          minimum: d.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: d.message
        }), o.dirty());
      else if (d.kind === "max")
        t.data.length > d.value && (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.too_big,
          maximum: d.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: d.message
        }), o.dirty());
      else if (d.kind === "length") {
        const f = t.data.length > d.value, m = t.data.length < d.value;
        (f || m) && (l = this._getOrReturnCtx(t, l), f ? Ve(l, {
          code: Ee.too_big,
          maximum: d.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: d.message
        }) : m && Ve(l, {
          code: Ee.too_small,
          minimum: d.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: d.message
        }), o.dirty());
      } else if (d.kind === "email")
        $G.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "email",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "emoji")
        IE || (IE = new RegExp(LG, "u")), IE.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "emoji",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "uuid")
        DG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "uuid",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "nanoid")
        IG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "nanoid",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "cuid")
        PG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "cuid",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "cuid2")
        jG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "cuid2",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "ulid")
        AG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "ulid",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty());
      else if (d.kind === "url")
        try {
          new URL(t.data);
        } catch {
          l = this._getOrReturnCtx(t, l), Ve(l, {
            validation: "url",
            code: Ee.invalid_string,
            message: d.message
          }), o.dirty();
        }
      else
        d.kind === "regex" ? (d.regex.lastIndex = 0, d.regex.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "regex",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty())) : d.kind === "trim" ? t.data = t.data.trim() : d.kind === "includes" ? t.data.includes(d.value, d.position) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: { includes: d.value, position: d.position },
          message: d.message
        }), o.dirty()) : d.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : d.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : d.kind === "startsWith" ? t.data.startsWith(d.value) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: { startsWith: d.value },
          message: d.message
        }), o.dirty()) : d.kind === "endsWith" ? t.data.endsWith(d.value) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: { endsWith: d.value },
          message: d.message
        }), o.dirty()) : d.kind === "datetime" ? I5(d).test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: "datetime",
          message: d.message
        }), o.dirty()) : d.kind === "date" ? BG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: "date",
          message: d.message
        }), o.dirty()) : d.kind === "time" ? UG(d).test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          code: Ee.invalid_string,
          validation: "time",
          message: d.message
        }), o.dirty()) : d.kind === "duration" ? MG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "duration",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty()) : d.kind === "ip" ? HG(t.data, d.version) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "ip",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty()) : d.kind === "base64" ? zG.test(t.data) || (l = this._getOrReturnCtx(t, l), Ve(l, {
          validation: "base64",
          code: Ee.invalid_string,
          message: d.message
        }), o.dirty()) : sn.assertNever(d);
    return { status: o.value, value: t.data };
  }
  _regex(t, r, o) {
    return this.refinement((l) => t.test(l), {
      validation: r,
      code: Ee.invalid_string,
      ...ct.errToObj(o)
    });
  }
  _addCheck(t) {
    return new Ss({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...ct.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...ct.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...ct.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...ct.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...ct.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...ct.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...ct.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...ct.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...ct.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...ct.errToObj(t) });
  }
  datetime(t) {
    var r, o;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (o = t == null ? void 0 : t.local) !== null && o !== void 0 ? o : !1,
      ...ct.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...ct.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...ct.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...ct.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...ct.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...ct.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...ct.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...ct.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...ct.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...ct.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, ct.errToObj(t));
  }
  trim() {
    return new Ss({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ss({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ss({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Ss.create = (e) => {
  var t;
  return new Ss({
    checks: [],
    typeName: Tt.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Lt(e)
  });
};
function VG(e, t) {
  const r = (e.toString().split(".")[1] || "").length, o = (t.toString().split(".")[1] || "").length, l = r > o ? r : o, d = parseInt(e.toFixed(l).replace(".", "")), f = parseInt(t.toFixed(l).replace(".", ""));
  return d % f / Math.pow(10, l);
}
class yd extends Ht {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Ye.number) {
      const d = this._getOrReturnCtx(t);
      return Ve(d, {
        code: Ee.invalid_type,
        expected: Ye.number,
        received: d.parsedType
      }), Pt;
    }
    let o;
    const l = new Ga();
    for (const d of this._def.checks)
      d.kind === "int" ? sn.isInteger(t.data) || (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.invalid_type,
        expected: "integer",
        received: "float",
        message: d.message
      }), l.dirty()) : d.kind === "min" ? (d.inclusive ? t.data < d.value : t.data <= d.value) && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.too_small,
        minimum: d.value,
        type: "number",
        inclusive: d.inclusive,
        exact: !1,
        message: d.message
      }), l.dirty()) : d.kind === "max" ? (d.inclusive ? t.data > d.value : t.data >= d.value) && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.too_big,
        maximum: d.value,
        type: "number",
        inclusive: d.inclusive,
        exact: !1,
        message: d.message
      }), l.dirty()) : d.kind === "multipleOf" ? VG(t.data, d.value) !== 0 && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.not_multiple_of,
        multipleOf: d.value,
        message: d.message
      }), l.dirty()) : d.kind === "finite" ? Number.isFinite(t.data) || (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.not_finite,
        message: d.message
      }), l.dirty()) : sn.assertNever(d);
    return { status: l.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, ct.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, ct.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, ct.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, ct.toString(r));
  }
  setLimit(t, r, o, l) {
    return new yd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: o,
          message: ct.toString(l)
        }
      ]
    });
  }
  _addCheck(t) {
    return new yd({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: ct.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: ct.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: ct.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: ct.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: ct.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: ct.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: ct.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: ct.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: ct.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && sn.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const o of this._def.checks) {
      if (o.kind === "finite" || o.kind === "int" || o.kind === "multipleOf")
        return !0;
      o.kind === "min" ? (r === null || o.value > r) && (r = o.value) : o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
yd.create = (e) => new yd({
  checks: [],
  typeName: Tt.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Lt(e)
});
class vd extends Ht {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== Ye.bigint) {
      const d = this._getOrReturnCtx(t);
      return Ve(d, {
        code: Ee.invalid_type,
        expected: Ye.bigint,
        received: d.parsedType
      }), Pt;
    }
    let o;
    const l = new Ga();
    for (const d of this._def.checks)
      d.kind === "min" ? (d.inclusive ? t.data < d.value : t.data <= d.value) && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.too_small,
        type: "bigint",
        minimum: d.value,
        inclusive: d.inclusive,
        message: d.message
      }), l.dirty()) : d.kind === "max" ? (d.inclusive ? t.data > d.value : t.data >= d.value) && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.too_big,
        type: "bigint",
        maximum: d.value,
        inclusive: d.inclusive,
        message: d.message
      }), l.dirty()) : d.kind === "multipleOf" ? t.data % d.value !== BigInt(0) && (o = this._getOrReturnCtx(t, o), Ve(o, {
        code: Ee.not_multiple_of,
        multipleOf: d.value,
        message: d.message
      }), l.dirty()) : sn.assertNever(d);
    return { status: l.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, ct.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, ct.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, ct.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, ct.toString(r));
  }
  setLimit(t, r, o, l) {
    return new vd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: o,
          message: ct.toString(l)
        }
      ]
    });
  }
  _addCheck(t) {
    return new vd({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: ct.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: ct.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: ct.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: ct.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: ct.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
vd.create = (e) => {
  var t;
  return new vd({
    checks: [],
    typeName: Tt.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Lt(e)
  });
};
class Rg extends Ht {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Ye.boolean) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.boolean,
        received: o.parsedType
      }), Pt;
    }
    return pi(t.data);
  }
}
Rg.create = (e) => new Rg({
  typeName: Tt.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Lt(e)
});
class Kf extends Ht {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Ye.date) {
      const d = this._getOrReturnCtx(t);
      return Ve(d, {
        code: Ee.invalid_type,
        expected: Ye.date,
        received: d.parsedType
      }), Pt;
    }
    if (isNaN(t.data.getTime())) {
      const d = this._getOrReturnCtx(t);
      return Ve(d, {
        code: Ee.invalid_date
      }), Pt;
    }
    const o = new Ga();
    let l;
    for (const d of this._def.checks)
      d.kind === "min" ? t.data.getTime() < d.value && (l = this._getOrReturnCtx(t, l), Ve(l, {
        code: Ee.too_small,
        message: d.message,
        inclusive: !0,
        exact: !1,
        minimum: d.value,
        type: "date"
      }), o.dirty()) : d.kind === "max" ? t.data.getTime() > d.value && (l = this._getOrReturnCtx(t, l), Ve(l, {
        code: Ee.too_big,
        message: d.message,
        inclusive: !0,
        exact: !1,
        maximum: d.value,
        type: "date"
      }), o.dirty()) : sn.assertNever(d);
    return {
      status: o.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Kf({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: ct.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: ct.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
Kf.create = (e) => new Kf({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Tt.ZodDate,
  ...Lt(e)
});
class B1 extends Ht {
  _parse(t) {
    if (this._getType(t) !== Ye.symbol) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.symbol,
        received: o.parsedType
      }), Pt;
    }
    return pi(t.data);
  }
}
B1.create = (e) => new B1({
  typeName: Tt.ZodSymbol,
  ...Lt(e)
});
class Og extends Ht {
  _parse(t) {
    if (this._getType(t) !== Ye.undefined) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.undefined,
        received: o.parsedType
      }), Pt;
    }
    return pi(t.data);
  }
}
Og.create = (e) => new Og({
  typeName: Tt.ZodUndefined,
  ...Lt(e)
});
class Pg extends Ht {
  _parse(t) {
    if (this._getType(t) !== Ye.null) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.null,
        received: o.parsedType
      }), Pt;
    }
    return pi(t.data);
  }
}
Pg.create = (e) => new Pg({
  typeName: Tt.ZodNull,
  ...Lt(e)
});
class bm extends Ht {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return pi(t.data);
  }
}
bm.create = (e) => new bm({
  typeName: Tt.ZodAny,
  ...Lt(e)
});
class qf extends Ht {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return pi(t.data);
  }
}
qf.create = (e) => new qf({
  typeName: Tt.ZodUnknown,
  ...Lt(e)
});
class Fl extends Ht {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return Ve(r, {
      code: Ee.invalid_type,
      expected: Ye.never,
      received: r.parsedType
    }), Pt;
  }
}
Fl.create = (e) => new Fl({
  typeName: Tt.ZodNever,
  ...Lt(e)
});
class U1 extends Ht {
  _parse(t) {
    if (this._getType(t) !== Ye.undefined) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.void,
        received: o.parsedType
      }), Pt;
    }
    return pi(t.data);
  }
}
U1.create = (e) => new U1({
  typeName: Tt.ZodVoid,
  ...Lt(e)
});
class Es extends Ht {
  _parse(t) {
    const { ctx: r, status: o } = this._processInputParams(t), l = this._def;
    if (r.parsedType !== Ye.array)
      return Ve(r, {
        code: Ee.invalid_type,
        expected: Ye.array,
        received: r.parsedType
      }), Pt;
    if (l.exactLength !== null) {
      const f = r.data.length > l.exactLength.value, m = r.data.length < l.exactLength.value;
      (f || m) && (Ve(r, {
        code: f ? Ee.too_big : Ee.too_small,
        minimum: m ? l.exactLength.value : void 0,
        maximum: f ? l.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: l.exactLength.message
      }), o.dirty());
    }
    if (l.minLength !== null && r.data.length < l.minLength.value && (Ve(r, {
      code: Ee.too_small,
      minimum: l.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: l.minLength.message
    }), o.dirty()), l.maxLength !== null && r.data.length > l.maxLength.value && (Ve(r, {
      code: Ee.too_big,
      maximum: l.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: l.maxLength.message
    }), o.dirty()), r.common.async)
      return Promise.all([...r.data].map((f, m) => l.type._parseAsync(new Ou(r, f, r.path, m)))).then((f) => Ga.mergeArray(o, f));
    const d = [...r.data].map((f, m) => l.type._parseSync(new Ou(r, f, r.path, m)));
    return Ga.mergeArray(o, d);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Es({
      ...this._def,
      minLength: { value: t, message: ct.toString(r) }
    });
  }
  max(t, r) {
    return new Es({
      ...this._def,
      maxLength: { value: t, message: ct.toString(r) }
    });
  }
  length(t, r) {
    return new Es({
      ...this._def,
      exactLength: { value: t, message: ct.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Es.create = (e, t) => new Es({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Tt.ZodArray,
  ...Lt(t)
});
function qh(e) {
  if (e instanceof lr) {
    const t = {};
    for (const r in e.shape) {
      const o = e.shape[r];
      t[r] = Ru.create(qh(o));
    }
    return new lr({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof Es ? new Es({
      ...e._def,
      type: qh(e.element)
    }) : e instanceof Ru ? Ru.create(qh(e.unwrap())) : e instanceof bd ? bd.create(qh(e.unwrap())) : e instanceof Pu ? Pu.create(e.items.map((t) => qh(t))) : e;
}
class lr extends Ht {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = sn.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== Ye.object) {
      const w = this._getOrReturnCtx(t);
      return Ve(w, {
        code: Ee.invalid_type,
        expected: Ye.object,
        received: w.parsedType
      }), Pt;
    }
    const { status: o, ctx: l } = this._processInputParams(t), { shape: d, keys: f } = this._getCached(), m = [];
    if (!(this._def.catchall instanceof Fl && this._def.unknownKeys === "strip"))
      for (const w in l.data)
        f.includes(w) || m.push(w);
    const v = [];
    for (const w of f) {
      const x = d[w], b = l.data[w];
      v.push({
        key: { status: "valid", value: w },
        value: x._parse(new Ou(l, b, l.path, w)),
        alwaysSet: w in l.data
      });
    }
    if (this._def.catchall instanceof Fl) {
      const w = this._def.unknownKeys;
      if (w === "passthrough")
        for (const x of m)
          v.push({
            key: { status: "valid", value: x },
            value: { status: "valid", value: l.data[x] }
          });
      else if (w === "strict")
        m.length > 0 && (Ve(l, {
          code: Ee.unrecognized_keys,
          keys: m
        }), o.dirty());
      else if (w !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const w = this._def.catchall;
      for (const x of m) {
        const b = l.data[x];
        v.push({
          key: { status: "valid", value: x },
          value: w._parse(
            new Ou(l, b, l.path, x)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: x in l.data
        });
      }
    }
    return l.common.async ? Promise.resolve().then(async () => {
      const w = [];
      for (const x of v) {
        const b = await x.key, k = await x.value;
        w.push({
          key: b,
          value: k,
          alwaysSet: x.alwaysSet
        });
      }
      return w;
    }).then((w) => Ga.mergeObjectSync(o, w)) : Ga.mergeObjectSync(o, v);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return ct.errToObj, new lr({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, o) => {
          var l, d, f, m;
          const v = (f = (d = (l = this._def).errorMap) === null || d === void 0 ? void 0 : d.call(l, r, o).message) !== null && f !== void 0 ? f : o.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (m = ct.errToObj(t).message) !== null && m !== void 0 ? m : v
          } : {
            message: v
          };
        }
      } : {}
    });
  }
  strip() {
    return new lr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new lr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new lr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new lr({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Tt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new lr({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return sn.objectKeys(t).forEach((o) => {
      t[o] && this.shape[o] && (r[o] = this.shape[o]);
    }), new lr({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return sn.objectKeys(this.shape).forEach((o) => {
      t[o] || (r[o] = this.shape[o]);
    }), new lr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return qh(this);
  }
  partial(t) {
    const r = {};
    return sn.objectKeys(this.shape).forEach((o) => {
      const l = this.shape[o];
      t && !t[o] ? r[o] = l : r[o] = l.optional();
    }), new lr({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return sn.objectKeys(this.shape).forEach((o) => {
      if (t && !t[o])
        r[o] = this.shape[o];
      else {
        let d = this.shape[o];
        for (; d instanceof Ru; )
          d = d._def.innerType;
        r[o] = d;
      }
    }), new lr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return M5(sn.objectKeys(this.shape));
  }
}
lr.create = (e, t) => new lr({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Fl.create(),
  typeName: Tt.ZodObject,
  ...Lt(t)
});
lr.strictCreate = (e, t) => new lr({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Fl.create(),
  typeName: Tt.ZodObject,
  ...Lt(t)
});
lr.lazycreate = (e, t) => new lr({
  shape: e,
  unknownKeys: "strip",
  catchall: Fl.create(),
  typeName: Tt.ZodObject,
  ...Lt(t)
});
class jg extends Ht {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = this._def.options;
    function l(d) {
      for (const m of d)
        if (m.result.status === "valid")
          return m.result;
      for (const m of d)
        if (m.result.status === "dirty")
          return r.common.issues.push(...m.ctx.common.issues), m.result;
      const f = d.map((m) => new to(m.ctx.common.issues));
      return Ve(r, {
        code: Ee.invalid_union,
        unionErrors: f
      }), Pt;
    }
    if (r.common.async)
      return Promise.all(o.map(async (d) => {
        const f = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await d._parseAsync({
            data: r.data,
            path: r.path,
            parent: f
          }),
          ctx: f
        };
      })).then(l);
    {
      let d;
      const f = [];
      for (const v of o) {
        const w = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, x = v._parseSync({
          data: r.data,
          path: r.path,
          parent: w
        });
        if (x.status === "valid")
          return x;
        x.status === "dirty" && !d && (d = { result: x, ctx: w }), w.common.issues.length && f.push(w.common.issues);
      }
      if (d)
        return r.common.issues.push(...d.ctx.common.issues), d.result;
      const m = f.map((v) => new to(v));
      return Ve(r, {
        code: Ee.invalid_union,
        unionErrors: m
      }), Pt;
    }
  }
  get options() {
    return this._def.options;
  }
}
jg.create = (e, t) => new jg({
  options: e,
  typeName: Tt.ZodUnion,
  ...Lt(t)
});
const _l = (e) => e instanceof Ig ? _l(e.schema) : e instanceof Rs ? _l(e.innerType()) : e instanceof Mg ? [e.value] : e instanceof gd ? e.options : e instanceof $g ? sn.objectValues(e.enum) : e instanceof Lg ? _l(e._def.innerType) : e instanceof Og ? [void 0] : e instanceof Pg ? [null] : e instanceof Ru ? [void 0, ..._l(e.unwrap())] : e instanceof bd ? [null, ..._l(e.unwrap())] : e instanceof L3 || e instanceof Fg ? _l(e.unwrap()) : e instanceof Ng ? _l(e._def.innerType) : [];
class Rx extends Ht {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ye.object)
      return Ve(r, {
        code: Ee.invalid_type,
        expected: Ye.object,
        received: r.parsedType
      }), Pt;
    const o = this.discriminator, l = r.data[o], d = this.optionsMap.get(l);
    return d ? r.common.async ? d._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : d._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (Ve(r, {
      code: Ee.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [o]
    }), Pt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, o) {
    const l = /* @__PURE__ */ new Map();
    for (const d of r) {
      const f = _l(d.shape[t]);
      if (!f.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const m of f) {
        if (l.has(m))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(m)}`);
        l.set(m, d);
      }
    }
    return new Rx({
      typeName: Tt.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: l,
      ...Lt(o)
    });
  }
}
function bT(e, t) {
  const r = ad(e), o = ad(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Ye.object && o === Ye.object) {
    const l = sn.objectKeys(t), d = sn.objectKeys(e).filter((m) => l.indexOf(m) !== -1), f = { ...e, ...t };
    for (const m of d) {
      const v = bT(e[m], t[m]);
      if (!v.valid)
        return { valid: !1 };
      f[m] = v.data;
    }
    return { valid: !0, data: f };
  } else if (r === Ye.array && o === Ye.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const l = [];
    for (let d = 0; d < e.length; d++) {
      const f = e[d], m = t[d], v = bT(f, m);
      if (!v.valid)
        return { valid: !1 };
      l.push(v.data);
    }
    return { valid: !0, data: l };
  } else
    return r === Ye.date && o === Ye.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Ag extends Ht {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t), l = (d, f) => {
      if (vT(d) || vT(f))
        return Pt;
      const m = bT(d.value, f.value);
      return m.valid ? ((gT(d) || gT(f)) && r.dirty(), { status: r.value, value: m.data }) : (Ve(o, {
        code: Ee.invalid_intersection_types
      }), Pt);
    };
    return o.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      }),
      this._def.right._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      })
    ]).then(([d, f]) => l(d, f)) : l(this._def.left._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }), this._def.right._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }));
  }
}
Ag.create = (e, t, r) => new Ag({
  left: e,
  right: t,
  typeName: Tt.ZodIntersection,
  ...Lt(r)
});
class Pu extends Ht {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Ye.array)
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.array,
        received: o.parsedType
      }), Pt;
    if (o.data.length < this._def.items.length)
      return Ve(o, {
        code: Ee.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Pt;
    !this._def.rest && o.data.length > this._def.items.length && (Ve(o, {
      code: Ee.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const d = [...o.data].map((f, m) => {
      const v = this._def.items[m] || this._def.rest;
      return v ? v._parse(new Ou(o, f, o.path, m)) : null;
    }).filter((f) => !!f);
    return o.common.async ? Promise.all(d).then((f) => Ga.mergeArray(r, f)) : Ga.mergeArray(r, d);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Pu({
      ...this._def,
      rest: t
    });
  }
}
Pu.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Pu({
    items: e,
    typeName: Tt.ZodTuple,
    rest: null,
    ...Lt(t)
  });
};
class Dg extends Ht {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Ye.object)
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.object,
        received: o.parsedType
      }), Pt;
    const l = [], d = this._def.keyType, f = this._def.valueType;
    for (const m in o.data)
      l.push({
        key: d._parse(new Ou(o, m, o.path, m)),
        value: f._parse(new Ou(o, o.data[m], o.path, m)),
        alwaysSet: m in o.data
      });
    return o.common.async ? Ga.mergeObjectAsync(r, l) : Ga.mergeObjectSync(r, l);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, o) {
    return r instanceof Ht ? new Dg({
      keyType: t,
      valueType: r,
      typeName: Tt.ZodRecord,
      ...Lt(o)
    }) : new Dg({
      keyType: Ss.create(),
      valueType: t,
      typeName: Tt.ZodRecord,
      ...Lt(r)
    });
  }
}
class H1 extends Ht {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Ye.map)
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.map,
        received: o.parsedType
      }), Pt;
    const l = this._def.keyType, d = this._def.valueType, f = [...o.data.entries()].map(([m, v], w) => ({
      key: l._parse(new Ou(o, m, o.path, [w, "key"])),
      value: d._parse(new Ou(o, v, o.path, [w, "value"]))
    }));
    if (o.common.async) {
      const m = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const v of f) {
          const w = await v.key, x = await v.value;
          if (w.status === "aborted" || x.status === "aborted")
            return Pt;
          (w.status === "dirty" || x.status === "dirty") && r.dirty(), m.set(w.value, x.value);
        }
        return { status: r.value, value: m };
      });
    } else {
      const m = /* @__PURE__ */ new Map();
      for (const v of f) {
        const w = v.key, x = v.value;
        if (w.status === "aborted" || x.status === "aborted")
          return Pt;
        (w.status === "dirty" || x.status === "dirty") && r.dirty(), m.set(w.value, x.value);
      }
      return { status: r.value, value: m };
    }
  }
}
H1.create = (e, t, r) => new H1({
  valueType: t,
  keyType: e,
  typeName: Tt.ZodMap,
  ...Lt(r)
});
class Qf extends Ht {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Ye.set)
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.set,
        received: o.parsedType
      }), Pt;
    const l = this._def;
    l.minSize !== null && o.data.size < l.minSize.value && (Ve(o, {
      code: Ee.too_small,
      minimum: l.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: l.minSize.message
    }), r.dirty()), l.maxSize !== null && o.data.size > l.maxSize.value && (Ve(o, {
      code: Ee.too_big,
      maximum: l.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: l.maxSize.message
    }), r.dirty());
    const d = this._def.valueType;
    function f(v) {
      const w = /* @__PURE__ */ new Set();
      for (const x of v) {
        if (x.status === "aborted")
          return Pt;
        x.status === "dirty" && r.dirty(), w.add(x.value);
      }
      return { status: r.value, value: w };
    }
    const m = [...o.data.values()].map((v, w) => d._parse(new Ou(o, v, o.path, w)));
    return o.common.async ? Promise.all(m).then((v) => f(v)) : f(m);
  }
  min(t, r) {
    return new Qf({
      ...this._def,
      minSize: { value: t, message: ct.toString(r) }
    });
  }
  max(t, r) {
    return new Qf({
      ...this._def,
      maxSize: { value: t, message: ct.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Qf.create = (e, t) => new Qf({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Tt.ZodSet,
  ...Lt(t)
});
class Xh extends Ht {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ye.function)
      return Ve(r, {
        code: Ee.invalid_type,
        expected: Ye.function,
        received: r.parsedType
      }), Pt;
    function o(m, v) {
      return F1({
        data: m,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          N1(),
          gm
        ].filter((w) => !!w),
        issueData: {
          code: Ee.invalid_arguments,
          argumentsError: v
        }
      });
    }
    function l(m, v) {
      return F1({
        data: m,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          N1(),
          gm
        ].filter((w) => !!w),
        issueData: {
          code: Ee.invalid_return_type,
          returnTypeError: v
        }
      });
    }
    const d = { errorMap: r.common.contextualErrorMap }, f = r.data;
    if (this._def.returns instanceof wm) {
      const m = this;
      return pi(async function(...v) {
        const w = new to([]), x = await m._def.args.parseAsync(v, d).catch((T) => {
          throw w.addIssue(o(v, T)), w;
        }), b = await Reflect.apply(f, this, x);
        return await m._def.returns._def.type.parseAsync(b, d).catch((T) => {
          throw w.addIssue(l(b, T)), w;
        });
      });
    } else {
      const m = this;
      return pi(function(...v) {
        const w = m._def.args.safeParse(v, d);
        if (!w.success)
          throw new to([o(v, w.error)]);
        const x = Reflect.apply(f, this, w.data), b = m._def.returns.safeParse(x, d);
        if (!b.success)
          throw new to([l(x, b.error)]);
        return b.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Xh({
      ...this._def,
      args: Pu.create(t).rest(qf.create())
    });
  }
  returns(t) {
    return new Xh({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, o) {
    return new Xh({
      args: t || Pu.create([]).rest(qf.create()),
      returns: r || qf.create(),
      typeName: Tt.ZodFunction,
      ...Lt(o)
    });
  }
}
class Ig extends Ht {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Ig.create = (e, t) => new Ig({
  getter: e,
  typeName: Tt.ZodLazy,
  ...Lt(t)
});
class Mg extends Ht {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return Ve(r, {
        received: r.data,
        code: Ee.invalid_literal,
        expected: this._def.value
      }), Pt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Mg.create = (e, t) => new Mg({
  value: e,
  typeName: Tt.ZodLiteral,
  ...Lt(t)
});
function M5(e, t) {
  return new gd({
    values: e,
    typeName: Tt.ZodEnum,
    ...Lt(t)
  });
}
class gd extends Ht {
  constructor() {
    super(...arguments), Xv.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), o = this._def.values;
      return Ve(r, {
        expected: sn.joinValues(o),
        received: r.parsedType,
        code: Ee.invalid_type
      }), Pt;
    }
    if (z1(this, Xv, "f") || j5(this, Xv, new Set(this._def.values), "f"), !z1(this, Xv, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), o = this._def.values;
      return Ve(r, {
        received: r.data,
        code: Ee.invalid_enum_value,
        options: o
      }), Pt;
    }
    return pi(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return gd.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return gd.create(this.options.filter((o) => !t.includes(o)), {
      ...this._def,
      ...r
    });
  }
}
Xv = /* @__PURE__ */ new WeakMap();
gd.create = M5;
class $g extends Ht {
  constructor() {
    super(...arguments), Jv.set(this, void 0);
  }
  _parse(t) {
    const r = sn.getValidEnumValues(this._def.values), o = this._getOrReturnCtx(t);
    if (o.parsedType !== Ye.string && o.parsedType !== Ye.number) {
      const l = sn.objectValues(r);
      return Ve(o, {
        expected: sn.joinValues(l),
        received: o.parsedType,
        code: Ee.invalid_type
      }), Pt;
    }
    if (z1(this, Jv, "f") || j5(this, Jv, new Set(sn.getValidEnumValues(this._def.values)), "f"), !z1(this, Jv, "f").has(t.data)) {
      const l = sn.objectValues(r);
      return Ve(o, {
        received: o.data,
        code: Ee.invalid_enum_value,
        options: l
      }), Pt;
    }
    return pi(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Jv = /* @__PURE__ */ new WeakMap();
$g.create = (e, t) => new $g({
  values: e,
  typeName: Tt.ZodNativeEnum,
  ...Lt(t)
});
class wm extends Ht {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ye.promise && r.common.async === !1)
      return Ve(r, {
        code: Ee.invalid_type,
        expected: Ye.promise,
        received: r.parsedType
      }), Pt;
    const o = r.parsedType === Ye.promise ? r.data : Promise.resolve(r.data);
    return pi(o.then((l) => this._def.type.parseAsync(l, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
wm.create = (e, t) => new wm({
  type: e,
  typeName: Tt.ZodPromise,
  ...Lt(t)
});
class Rs extends Ht {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Tt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t), l = this._def.effect || null, d = {
      addIssue: (f) => {
        Ve(o, f), f.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return o.path;
      }
    };
    if (d.addIssue = d.addIssue.bind(d), l.type === "preprocess") {
      const f = l.transform(o.data, d);
      if (o.common.async)
        return Promise.resolve(f).then(async (m) => {
          if (r.value === "aborted")
            return Pt;
          const v = await this._def.schema._parseAsync({
            data: m,
            path: o.path,
            parent: o
          });
          return v.status === "aborted" ? Pt : v.status === "dirty" || r.value === "dirty" ? Yh(v.value) : v;
        });
      {
        if (r.value === "aborted")
          return Pt;
        const m = this._def.schema._parseSync({
          data: f,
          path: o.path,
          parent: o
        });
        return m.status === "aborted" ? Pt : m.status === "dirty" || r.value === "dirty" ? Yh(m.value) : m;
      }
    }
    if (l.type === "refinement") {
      const f = (m) => {
        const v = l.refinement(m, d);
        if (o.common.async)
          return Promise.resolve(v);
        if (v instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return m;
      };
      if (o.common.async === !1) {
        const m = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return m.status === "aborted" ? Pt : (m.status === "dirty" && r.dirty(), f(m.value), { status: r.value, value: m.value });
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((m) => m.status === "aborted" ? Pt : (m.status === "dirty" && r.dirty(), f(m.value).then(() => ({ status: r.value, value: m.value }))));
    }
    if (l.type === "transform")
      if (o.common.async === !1) {
        const f = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        if (!Tg(f))
          return f;
        const m = l.transform(f.value, d);
        if (m instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: m };
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((f) => Tg(f) ? Promise.resolve(l.transform(f.value, d)).then((m) => ({ status: r.value, value: m })) : f);
    sn.assertNever(l);
  }
}
Rs.create = (e, t, r) => new Rs({
  schema: e,
  typeName: Tt.ZodEffects,
  effect: t,
  ...Lt(r)
});
Rs.createWithPreprocess = (e, t, r) => new Rs({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Tt.ZodEffects,
  ...Lt(r)
});
class Ru extends Ht {
  _parse(t) {
    return this._getType(t) === Ye.undefined ? pi(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ru.create = (e, t) => new Ru({
  innerType: e,
  typeName: Tt.ZodOptional,
  ...Lt(t)
});
class bd extends Ht {
  _parse(t) {
    return this._getType(t) === Ye.null ? pi(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
bd.create = (e, t) => new bd({
  innerType: e,
  typeName: Tt.ZodNullable,
  ...Lt(t)
});
class Lg extends Ht {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let o = r.data;
    return r.parsedType === Ye.undefined && (o = this._def.defaultValue()), this._def.innerType._parse({
      data: o,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Lg.create = (e, t) => new Lg({
  innerType: e,
  typeName: Tt.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Lt(t)
});
class Ng extends Ht {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, l = this._def.innerType._parse({
      data: o.data,
      path: o.path,
      parent: {
        ...o
      }
    });
    return _g(l) ? l.then((d) => ({
      status: "valid",
      value: d.status === "valid" ? d.value : this._def.catchValue({
        get error() {
          return new to(o.common.issues);
        },
        input: o.data
      })
    })) : {
      status: "valid",
      value: l.status === "valid" ? l.value : this._def.catchValue({
        get error() {
          return new to(o.common.issues);
        },
        input: o.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ng.create = (e, t) => new Ng({
  innerType: e,
  typeName: Tt.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Lt(t)
});
class V1 extends Ht {
  _parse(t) {
    if (this._getType(t) !== Ye.nan) {
      const o = this._getOrReturnCtx(t);
      return Ve(o, {
        code: Ee.invalid_type,
        expected: Ye.nan,
        received: o.parsedType
      }), Pt;
    }
    return { status: "valid", value: t.data };
  }
}
V1.create = (e) => new V1({
  typeName: Tt.ZodNaN,
  ...Lt(e)
});
const GG = Symbol("zod_brand");
class L3 extends Ht {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = r.data;
    return this._def.type._parse({
      data: o,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class b0 extends Ht {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.common.async)
      return (async () => {
        const d = await this._def.in._parseAsync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return d.status === "aborted" ? Pt : d.status === "dirty" ? (r.dirty(), Yh(d.value)) : this._def.out._parseAsync({
          data: d.value,
          path: o.path,
          parent: o
        });
      })();
    {
      const l = this._def.in._parseSync({
        data: o.data,
        path: o.path,
        parent: o
      });
      return l.status === "aborted" ? Pt : l.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: l.value
      }) : this._def.out._parseSync({
        data: l.value,
        path: o.path,
        parent: o
      });
    }
  }
  static create(t, r) {
    return new b0({
      in: t,
      out: r,
      typeName: Tt.ZodPipeline
    });
  }
}
class Fg extends Ht {
  _parse(t) {
    const r = this._def.innerType._parse(t), o = (l) => (Tg(l) && (l.value = Object.freeze(l.value)), l);
    return _g(r) ? r.then((l) => o(l)) : o(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Fg.create = (e, t) => new Fg({
  innerType: e,
  typeName: Tt.ZodReadonly,
  ...Lt(t)
});
function $5(e, t = {}, r) {
  return e ? bm.create().superRefine((o, l) => {
    var d, f;
    if (!e(o)) {
      const m = typeof t == "function" ? t(o) : typeof t == "string" ? { message: t } : t, v = (f = (d = m.fatal) !== null && d !== void 0 ? d : r) !== null && f !== void 0 ? f : !0, w = typeof m == "string" ? { message: m } : m;
      l.addIssue({ code: "custom", ...w, fatal: v });
    }
  }) : bm.create();
}
const qG = {
  object: lr.lazycreate
};
var Tt;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Tt || (Tt = {}));
const WG = (e, t = {
  message: `Input not instance of ${e.name}`
}) => $5((r) => r instanceof e, t), L5 = Ss.create, N5 = yd.create, YG = V1.create, ZG = vd.create, F5 = Rg.create, KG = Kf.create, QG = B1.create, XG = Og.create, JG = Pg.create, eq = bm.create, tq = qf.create, nq = Fl.create, rq = U1.create, aq = Es.create, iq = lr.create, oq = lr.strictCreate, sq = jg.create, uq = Rx.create, lq = Ag.create, cq = Pu.create, dq = Dg.create, fq = H1.create, pq = Qf.create, hq = Xh.create, mq = Ig.create, yq = Mg.create, vq = gd.create, gq = $g.create, bq = wm.create, nj = Rs.create, wq = Ru.create, xq = bd.create, Sq = Rs.createWithPreprocess, kq = b0.create, Eq = () => L5().optional(), Cq = () => N5().optional(), Tq = () => F5().optional(), _q = {
  string: (e) => Ss.create({ ...e, coerce: !0 }),
  number: (e) => yd.create({ ...e, coerce: !0 }),
  boolean: (e) => Rg.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => vd.create({ ...e, coerce: !0 }),
  date: (e) => Kf.create({ ...e, coerce: !0 })
}, Rq = Pt;
var Tn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: gm,
  setErrorMap: RG,
  getErrorMap: N1,
  makeIssue: F1,
  EMPTY_PATH: OG,
  addIssueToContext: Ve,
  ParseStatus: Ga,
  INVALID: Pt,
  DIRTY: Yh,
  OK: pi,
  isAborted: vT,
  isDirty: gT,
  isValid: Tg,
  isAsync: _g,
  get util() {
    return sn;
  },
  get objectUtil() {
    return yT;
  },
  ZodParsedType: Ye,
  getParsedType: ad,
  ZodType: Ht,
  datetimeRegex: I5,
  ZodString: Ss,
  ZodNumber: yd,
  ZodBigInt: vd,
  ZodBoolean: Rg,
  ZodDate: Kf,
  ZodSymbol: B1,
  ZodUndefined: Og,
  ZodNull: Pg,
  ZodAny: bm,
  ZodUnknown: qf,
  ZodNever: Fl,
  ZodVoid: U1,
  ZodArray: Es,
  ZodObject: lr,
  ZodUnion: jg,
  ZodDiscriminatedUnion: Rx,
  ZodIntersection: Ag,
  ZodTuple: Pu,
  ZodRecord: Dg,
  ZodMap: H1,
  ZodSet: Qf,
  ZodFunction: Xh,
  ZodLazy: Ig,
  ZodLiteral: Mg,
  ZodEnum: gd,
  ZodNativeEnum: $g,
  ZodPromise: wm,
  ZodEffects: Rs,
  ZodTransformer: Rs,
  ZodOptional: Ru,
  ZodNullable: bd,
  ZodDefault: Lg,
  ZodCatch: Ng,
  ZodNaN: V1,
  BRAND: GG,
  ZodBranded: L3,
  ZodPipeline: b0,
  ZodReadonly: Fg,
  custom: $5,
  Schema: Ht,
  ZodSchema: Ht,
  late: qG,
  get ZodFirstPartyTypeKind() {
    return Tt;
  },
  coerce: _q,
  any: eq,
  array: aq,
  bigint: ZG,
  boolean: F5,
  date: KG,
  discriminatedUnion: uq,
  effect: nj,
  enum: vq,
  function: hq,
  instanceof: WG,
  intersection: lq,
  lazy: mq,
  literal: yq,
  map: fq,
  nan: YG,
  nativeEnum: gq,
  never: nq,
  null: JG,
  nullable: xq,
  number: N5,
  object: iq,
  oboolean: Tq,
  onumber: Cq,
  optional: wq,
  ostring: Eq,
  pipeline: kq,
  preprocess: Sq,
  promise: bq,
  record: dq,
  set: pq,
  strictObject: oq,
  string: L5,
  symbol: QG,
  transformer: nj,
  tuple: cq,
  undefined: XG,
  union: sq,
  unknown: tq,
  void: rq,
  NEVER: Rq,
  ZodIssueCode: Ee,
  quotelessJson: _G,
  ZodError: to
}), Oq = Object.defineProperty, Pq = (e, t, r) => t in e ? Oq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, jq = (e, t, r) => (Pq(e, typeof t != "symbol" ? t + "" : t, r), r), Aq = class extends Error {
  constructor() {
    super(...arguments);
    Oo(this, "name", "MUDContextAlreadyCreatedError");
    Oo(this, "message", "MUD context was already created");
  }
}, Dq = class extends Error {
  constructor() {
    super(...arguments);
    Oo(this, "name", "MUDContextNotCreatedError");
    Oo(this, "message", "MUD context has not been created");
  }
}, rj = 14;
function N3(e, t) {
  /^\w+$/.test(e) || t.addIssue({ code: Ee.custom, message: "Name must contain only alphanumeric & underscore characters" });
}
function Iq(e, t) {
  N3(e, t), /^[A-Z]/.test(e) || t.addIssue({ code: Ee.custom, message: "Name must start with a capital letter" });
}
function Mq(e, t) {
  N3(e, t), /^[a-z]/.test(e) || t.addIssue({ code: Ee.custom, message: "Name must start with a lowercase letter" });
}
function $q(e, t) {
  e.length === 0 && t.addIssue({ code: Ee.custom, message: "Enum must not be empty" }), e.length >= 256 && t.addIssue({ code: Ee.custom, message: "Length of enum must be < 256" });
  let r = Bq(e);
  r.length > 0 && t.addIssue({ code: Ee.custom, message: `Enum must not have duplicate names for: ${r.join(", ")}` });
}
function F3(e, t) {
  return (r, o) => {
    if (r === "") {
      e && o.addIssue({ code: Ee.custom, message: "Route must not be empty" });
      return;
    }
    r[0] !== "/" && o.addIssue({ code: Ee.custom, message: 'Route must start with "/"' }), r[r.length - 1] === "/" && o.addIssue({ code: Ee.custom, message: 'Route must not end with "/"' });
    let l = r.split("/");
    t && l.length > 2 && o.addIssue({ code: Ee.custom, message: 'Route must only have one level (e.g. "/foo")' });
    for (let d = 1; d < l.length; d++)
      l[d] === "" && o.addIssue({ code: Ee.custom, message: 'Route must not contain empty route fragments (e.g. "//")' }), /^\w+$/.test(l[d]) || o.addIssue({ code: Ee.custom, message: "Route must contain only alphanumeric & underscore characters" });
  };
}
var Lq = F3(!0, !1), Nq = F3(!1, !1), Fq = F3(!0, !0);
function zq(e, t) {
  Va(e) || t.addIssue({ code: Ee.custom, message: "Address must be a valid Ethereum address" });
}
function Bq(e) {
  let t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
  for (let o of e)
    t.has(o) && r.add(o), t.add(o);
  return [...r];
}
function Uq(e, t) {
  e.length > rj && t.addIssue({ code: Ee.custom, message: `Namespace must be <= ${rj} characters` }), /^\w*$/.test(e) || t.addIssue({ code: Ee.custom, message: "Selector must contain only alphanumeric & underscore characters" });
}
var z5 = Tn.string().superRefine(Iq);
Tn.string().superRefine(Mq);
var Hq = Tn.string().superRefine(N3);
Tn.string().superRefine(Uq);
Tn.array(z5).superRefine($q);
Tn.string().superRefine(Lq);
Tn.string().superRefine(Fq);
Tn.string().superRefine(Nq);
var Vq = Tn.string().superRefine(zq), B5 = class {
  constructor() {
    Oo(this, "configExtenders", []);
  }
  static isCreated() {
    return this._global.__mudCoreContext !== void 0;
  }
  static createContext() {
    if (this.isCreated())
      throw new Aq();
    let e = this._global, t = new B5();
    return e.__mudCoreContext = t, t;
  }
  static getContext() {
    let e = this._global.__mudCoreContext;
    if (e === void 0)
      throw new Dq();
    return e;
  }
}, Gq = B5;
jq(Gq, "_global", typeof global > "u" ? window.global ?? {} : global);
var wT = z5, qq = Tn.array(wT.or(Vq)).readonly().default(M1.accessList), Wq = Tn.intersection(Tn.object({ name: Hq.optional(), registerFunctionSelectors: Tn.boolean().default(M1.registerFunctionSelector) }), Tn.discriminatedUnion("openAccess", [Tn.object({ openAccess: Tn.literal(!0).default(M1.openAccess) }), Tn.object({ openAccess: Tn.literal(!1), accessList: qq })])), Yq = Tn.object({ worldContractName: Tn.string().optional(), worldInterfaceName: Tn.string().default(Jc.worldInterfaceName), systems: Tn.record(wT, Wq).default(Jc.systems), excludeSystems: Tn.array(wT).readonly().default(Jc.excludeSystems), postDeployScript: Tn.string().default(Jc.postDeployScript), deploysDirectory: Tn.string().default(Jc.deploysDirectory), worldsFile: Tn.string().default(Jc.worldsFile), worldgenDirectory: Tn.string().default(Jc.worldgenDirectory), worldImportPath: Tn.string().default(Jc.worldImportPath) });
Yq.catchall(Tn.any());
var Zq = [{ type: "function", name: "getDynamicField", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "dynamicFieldIndex", type: "uint8", internalType: "uint8" }], outputs: [{ name: "", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getDynamicFieldLength", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "dynamicFieldIndex", type: "uint8", internalType: "uint8" }], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "getDynamicFieldSlice", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "dynamicFieldIndex", type: "uint8", internalType: "uint8" }, { name: "start", type: "uint256", internalType: "uint256" }, { name: "end", type: "uint256", internalType: "uint256" }], outputs: [{ name: "data", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getField", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldIndex", type: "uint8", internalType: "uint8" }, { name: "fieldLayout", type: "bytes32", internalType: "FieldLayout" }], outputs: [{ name: "data", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getField", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldIndex", type: "uint8", internalType: "uint8" }], outputs: [{ name: "data", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getFieldLayout", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }], outputs: [{ name: "fieldLayout", type: "bytes32", internalType: "FieldLayout" }], stateMutability: "view" }, { type: "function", name: "getFieldLength", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldIndex", type: "uint8", internalType: "uint8" }, { name: "fieldLayout", type: "bytes32", internalType: "FieldLayout" }], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "getFieldLength", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldIndex", type: "uint8", internalType: "uint8" }], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "getKeySchema", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }], outputs: [{ name: "keySchema", type: "bytes32", internalType: "Schema" }], stateMutability: "view" }, { type: "function", name: "getRecord", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldLayout", type: "bytes32", internalType: "FieldLayout" }], outputs: [{ name: "staticData", type: "bytes", internalType: "bytes" }, { name: "encodedLengths", type: "bytes32", internalType: "EncodedLengths" }, { name: "dynamicData", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getRecord", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }], outputs: [{ name: "staticData", type: "bytes", internalType: "bytes" }, { name: "encodedLengths", type: "bytes32", internalType: "EncodedLengths" }, { name: "dynamicData", type: "bytes", internalType: "bytes" }], stateMutability: "view" }, { type: "function", name: "getStaticField", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }, { name: "keyTuple", type: "bytes32[]", internalType: "bytes32[]" }, { name: "fieldIndex", type: "uint8", internalType: "uint8" }, { name: "fieldLayout", type: "bytes32", internalType: "FieldLayout" }], outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }], stateMutability: "view" }, { type: "function", name: "getValueSchema", inputs: [{ name: "tableId", type: "bytes32", internalType: "ResourceId" }], outputs: [{ name: "valueSchema", type: "bytes32", internalType: "Schema" }], stateMutability: "view" }];
function aj(e) {
  return (t) => ({ writeContract: async (r) => {
    if (console.log("writeArgs", r), r.address !== e.worldAddress || r.functionName === "call" || r.functionName === "callFrom" || r.functionName === "callWithSignature")
      return Ke(t, xC, "writeContract")(r);
    let o = di({ abi: r.abi, functionName: r.functionName, args: r.args }), l = fm(o, 0, 4), { systemId: d, systemFunctionSelector: f } = await Kq(e, l), m = ia([f, Vf(o, 4)]), v = { ...r, functionName: "callFrom", args: [e.delegatorAddress, d, m] };
    return Ke(t, xC, "writeContract")(v);
  } });
}
var ij = /* @__PURE__ */ new Map();
async function Kq(e, t) {
  let r = ia([e.worldAddress, t]), o = ij.get(r);
  if (o)
    return o;
  let l = e.worldFunctionToSystemFunction ? await e.worldFunctionToSystemFunction(t) : await Qq(e.publicClient, e.worldAddress, t);
  return ij.set(r, l), l;
}
async function Qq(e, t, r) {
  let o = R5.tables.world__FunctionSelectors, l = L1(Tx(o)), d = L1(M3(o)), [f, m, v] = await e.readContract({ address: t, abi: Zq, functionName: "getRecord", args: [o.tableId, xG(l, { worldFunctionSelector: r })] }), w = I3(d, { staticData: f, encodedLengths: m, dynamicData: v });
  return { systemId: w.systemId, systemFunctionSelector: w.systemFunctionSelector };
}
var Xq = { Call: [{ name: "signer", type: "address" }, { name: "systemNamespace", type: "string" }, { name: "systemName", type: "string" }, { name: "callData", type: "bytes" }, { name: "nonce", type: "uint256" }] };
const Jq = async (e) => {
  const t = await e.request({
    method: "pimlico_getUserOperationGasPrice",
    params: []
  });
  return {
    slow: {
      maxFeePerGas: BigInt(t.slow.maxFeePerGas),
      maxPriorityFeePerGas: BigInt(t.slow.maxPriorityFeePerGas)
    },
    standard: {
      maxFeePerGas: BigInt(t.standard.maxFeePerGas),
      maxPriorityFeePerGas: BigInt(t.standard.maxPriorityFeePerGas)
    },
    fast: {
      maxFeePerGas: BigInt(t.fast.maxFeePerGas),
      maxPriorityFeePerGas: BigInt(t.fast.maxPriorityFeePerGas)
    }
  };
}, U5 = async (e, { hash: t }) => e.request({
  method: "pimlico_getUserOperationStatus",
  params: [t]
}), eW = async (e, t) => {
  const { compressedUserOperation: r, inflatorAddress: o, entryPoint: l } = t;
  return e.request({
    method: "pimlico_sendCompressedUserOperation",
    params: [
      r,
      o,
      l
    ]
  });
}, tW = (e) => (t) => ({
  getUserOperationGasPrice: async () => Jq(t),
  getUserOperationStatus: async (r) => U5(t, r),
  sendCompressedUserOperation: async (r) => eW(t, {
    ...r,
    entryPoint: e
  })
}), nW = (e) => {
  const { key: t = "public", name: r = "Pimlico Bundler Client" } = e;
  return A1({
    ...e,
    key: t,
    name: r,
    type: "pimlicoBundlerClient"
  }).extend(_V(e.entryPoint)).extend(tW(e.entryPoint));
};
var rW = "event Store_SetRecord(bytes32 indexed tableId, bytes32[] keyTuple, bytes staticData, bytes32 encodedLengths, bytes dynamicData)", aW = "event Store_SpliceStaticData(bytes32 indexed tableId, bytes32[] keyTuple, uint48 start, bytes data)", iW = "event Store_SpliceDynamicData(bytes32 indexed tableId, bytes32[] keyTuple, uint8 dynamicFieldIndex, uint48 start, uint40 deleteCount, bytes32 encodedLengths, bytes data)", oW = "event Store_DeleteRecord(bytes32 indexed tableId, bytes32[] keyTuple)", sW = [rW, aW, iW, oW];
Pz(sW);
const G1 = fG({
  tables: {
    EntryPoint: {
      schema: {
        addr: "address"
      },
      key: []
    },
    UserBalances: {
      schema: {
        userAccount: "address",
        balance: "uint256"
      },
      key: ["userAccount"]
    },
    Spender: {
      schema: {
        spender: "address",
        userAccount: "address"
      },
      key: ["spender"]
    }
  }
}), uW = Ml(Nn(Dl("mud.store")));
function lW(e, t) {
  return St(uW ^ Ml(Nn(Ps([e, ...t]))), { size: 32 });
}
function cW(e) {
  return lW(
    G1.tables.UserBalances.tableId,
    $3(Tx(G1.tables.UserBalances), { userAccount: e })
  );
}
function dW(e) {
  return Nn(
    ro([{ type: "address" }, { type: "uint256" }], [e, $V])
  );
}
const q1 = p0("mud:account-kit"), fW = p0("mud:account-kit");
q1.log = console.debug.bind(console);
fW.log = console.error.bind(console);
function ME(e, t) {
  return (r) => {
    const o = t(r);
    return {
      ...o,
      request: async (d) => {
        q1("request", e, d);
        const f = await o.request(d);
        return q1("response", e, f), f;
      }
    };
  };
}
function H5() {
  const { chainId: e } = Iu(), r = lH().find((o) => o.id === e);
  if (!r)
    throw new Error(
      `Account Kit is configured to use chain ${e}, but the corresponding chain was not found in wagmi's configured chains.`
    );
  return r;
}
function V5() {
  var r, o, l;
  const e = Iu(), t = H5();
  if (e.erc4337 !== !1)
    return e.erc4337 != null ? e.erc4337 : {
      transport: sD(
        WP(
          (r = t.rpcUrls.erc4337Bundler) == null ? void 0 : r.http[0],
          // eslint-disable-next-line max-len
          "Account Kit was not configured with `erc4337` and is attempting to set up a default transport, but did not find an `erc4337Bundler.http` URL on `chain.rpcUrls`.\n\nYou can either add that to your chain config or disable ERC-4337 with `erc4337: false`."
        )
      ),
      paymasters: [
        {
          type: "gasTank",
          address: WP(
            (l = (o = t.contracts) == null ? void 0 : o.gasTank) == null ? void 0 : l.address,
            // eslint-disable-next-line max-len
            "Account Kit was not configured with `erc4337` and is attempting to set up a default paymaster, but did not find a `gasTank` contract on `chain.contracts`.\n\nYou can either add that to your chain config or disable ERC-4337 with `erc4337: false`."
          )
        }
      ]
    };
}
function z3(e) {
  const t = V5();
  return t == null ? void 0 : t.paymasters.find((r) => r.type === e);
}
const $E = /* @__PURE__ */ new Map(), oj = /* @__PURE__ */ new Map();
let pW = 0;
function hW(e, t, r) {
  const o = ++pW, l = () => $E.get(e) || [], d = () => {
    const x = l();
    $E.set(
      e,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      x.filter((b) => b.id !== o)
    );
  }, f = () => {
    const x = oj.get(e);
    l().length === 1 && x && x(), d();
  }, m = l();
  if ($E.set(e, [...m, { id: o, fns: t }]), m && m.length > 0)
    return f;
  const v = {};
  for (const x in t)
    v[x] = (...b) => {
      var T, O;
      const k = l();
      if (k.length !== 0)
        for (const R of k)
          (O = (T = R.fns)[x]) == null || O.call(T, ...b);
    };
  const w = r(v);
  return typeof w == "function" && oj.set(e, w), f;
}
class mW extends we {
  constructor({ hash: t }) {
    super(`Timed out while waiting for transaction with hash "${t}" to be confirmed.`), this.name = "WaitForUserOperationReceiptTimeoutError";
  }
}
const yW = async (e, { hash: t, pollingInterval: r = e.pollingInterval, timeout: o }) => {
  const l = sa(["waitForUserOperationReceipt", e.uid, t]), d = new Promise((f, m) => {
    const v = hW(l, { resolve: f, reject: m }, async (w) => {
      let x;
      const b = setInterval(async () => {
        const k = (T) => {
          clearInterval(b), T(), v(), o && clearTimeout(x);
        };
        try {
          const T = await Ke(
            e,
            U5,
            "getUserOperationStatus"
          )({ hash: t });
          if (T.transactionHash !== null) {
            k(() => w.resolve({ transactionHash: T.transactionHash }));
            return;
          }
          T.status !== "not_submitted" && T.status !== "not_found" && k(() => w.reject("Unexpected transaction status: " + T.status));
        } catch (T) {
          k(() => w.reject(T));
          return;
        }
      }, r);
      o && (x = setTimeout(() => {
        clearInterval(b), v(), m(
          new mW({
            hash: t
          })
        ), clearTimeout(x);
      }, o));
    });
  });
  try {
    return await d;
  } catch {
    return { transactionHash: (await Ke(e, v0, "waitForUserOperationReceipt")({ hash: t })).receipt.transactionHash };
  }
};
async function vW(e, t, r = {}) {
  const {
    account: o = e.account,
    data: l,
    maxFeePerGas: d,
    maxPriorityFeePerGas: f,
    to: m,
    value: v,
    nonce: w,
    middleware: x
  } = t;
  if (!o)
    throw new _s({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const b = fi(o);
  if (!m)
    throw new Error("Missing to address");
  if (b.type !== "local")
    throw new Error("RPC account type not supported");
  const k = await nV({
    client: e,
    refreshInterval: 1e4,
    args: { chain: e.chain },
    estimateFeesPerGas: r.estimateFeesPerGas
  }), T = await b.encodeCallData({
    to: m,
    value: v || BigInt(0),
    data: l || "0x"
  });
  return eV(
    async () => {
      const { account: O = e.account } = t;
      if (!O)
        throw new _s();
      const R = fi(O), j = await Ke(
        e,
        j3,
        "prepareUserOperationRequest"
      )({
        userOperation: {
          sender: R.address,
          maxFeePerGas: d ?? k.fees.maxFeePerGas ?? BigInt(0),
          maxPriorityFeePerGas: f ?? k.fees.maxPriorityFeePerGas ?? BigInt(0),
          callData: T,
          nonce: w ? BigInt(w) : void 0
        },
        account: R,
        middleware: x
      });
      j.nonce = w ? BigInt(w) : BigInt(Date.now()) << 64n, j.signature = await R.signUserOperation(
        j
      );
      const I = await Ke(
        e,
        P3,
        "sendUserOperationBundler"
      )({
        userOperation: j,
        entryPoint: R.entryPoint
      });
      return (await Ke(
        e,
        yW,
        "waitForUserOperationTransactionHash"
      )({
        hash: I,
        timeout: 1e4
      })).transactionHash;
    },
    {
      retries: 3,
      onFailedAttempt: async (O) => {
        throw O;
      }
    }
  );
}
const sj = "0x6492649264926492649264926492649264926492649264926492649264926492";
function gW({ address: e, client: t, source: r, entryPoint: o, getNonce: l, getInitCode: d, getFactory: f, getFactoryData: m, encodeCallData: v, getDummySignature: w, encodeDeployCallData: x, signUserOperation: b, signMessage: k, signTypedData: T }) {
  return {
    ...i5({
      address: e,
      signMessage: async ({ message: R }) => {
        const j = await Wh(t, e), I = await k({ message: R });
        if (j)
          return I;
        const N = ro([
          {
            type: "address",
            name: "create2Factory"
          },
          {
            type: "bytes",
            name: "factoryCalldata"
          },
          {
            type: "bytes",
            name: "originalERC1271Signature"
          }
        ], [
          await f() ?? "0x",
          // "0x should never happen if it's deployed"
          await m() ?? "0x",
          // "0x should never happen if it's deployed"
          I
        ]);
        return ia([N, sj]);
      },
      signTypedData: async (R) => {
        const j = await Wh(t, e), I = await T(R);
        if (j)
          return I;
        const N = ro([
          {
            type: "address",
            name: "create2Factory"
          },
          {
            type: "bytes",
            name: "factoryCalldata"
          },
          {
            type: "bytes",
            name: "originalERC1271Signature"
          }
        ], [
          await f() ?? "0x",
          // "0x should never happen if it's deployed"
          await m() ?? "0x",
          // "0x should never happen if it's deployed"
          I
        ]);
        return ia([N, sj]);
      },
      async signTransaction(R, j) {
        throw new lT();
      }
    }),
    source: r,
    client: t,
    type: "local",
    entryPoint: o,
    publicKey: e,
    getNonce: l,
    getInitCode: d,
    getFactory: f,
    getFactoryData: m,
    encodeCallData: v,
    getDummySignature: w,
    encodeDeployCallData: x,
    signUserOperation: b
  };
}
const xT = async (e, t = BigInt(0)) => {
  if (!e)
    throw new Error("Owner account not found");
  return di({
    abi: [
      {
        inputs: [
          {
            internalType: "address",
            name: "owner",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "salt",
            type: "uint256"
          }
        ],
        name: "createAccount",
        outputs: [
          {
            internalType: "contract SimpleAccount",
            name: "ret",
            type: "address"
          }
        ],
        stateMutability: "nonpayable",
        type: "function"
      }
    ],
    functionName: "createAccount",
    args: [e, t]
  });
}, bW = async ({ client: e, factoryAddress: t, entryPoint: r, owner: o, index: l = BigInt(0) }) => {
  const d = y0(r), f = await xT(o, l);
  return d === "v0.6" ? GP(e, {
    initCode: Ps([t, f]),
    entryPoint: r
  }) : GP(e, {
    factory: t,
    factoryData: f,
    entryPoint: r
  });
};
async function wW(e, { signer: t, factoryAddress: r, entryPoint: o, index: l = BigInt(0), address: d }) {
  var x;
  const f = {
    ...t,
    signTransaction: (b, k) => {
      throw new lT();
    }
  }, [m, v] = await Promise.all([
    d ?? bW({
      client: e,
      factoryAddress: r,
      entryPoint: o,
      owner: f.address,
      index: l
    }),
    ((x = e.chain) == null ? void 0 : x.id) ?? Jf(e)
  ]);
  if (!m)
    throw new Error("Account address not found");
  let w = await Wh(e, m);
  return gW({
    address: m,
    signMessage: async (b) => {
      throw new Error("Simple account isn't 1271 compliant");
    },
    signTransaction: (b, k) => {
      throw new lT();
    },
    signTypedData: async (b) => {
      throw new Error("Simple account isn't 1271 compliant");
    },
    client: e,
    publicKey: m,
    entryPoint: o,
    source: "SimpleSmartAccount",
    async getNonce() {
      return TV(e, {
        sender: m,
        entryPoint: o
      });
    },
    async signUserOperation(b) {
      return TD(e, {
        account: f,
        message: {
          raw: yV({
            userOperation: b,
            entryPoint: o,
            chainId: v
          })
        }
      });
    },
    async getInitCode() {
      return w || (w = await Wh(e, m), w) ? "0x" : Ps([
        r,
        await xT(f.address, l)
      ]);
    },
    async getFactory() {
      if (!w && (w = await Wh(e, m), !w))
        return r;
    },
    async getFactoryData() {
      if (!w && (w = await Wh(e, m), !w))
        return xT(f.address, l);
    },
    async encodeDeployCallData(b) {
      throw new Error("Simple account doesn't support account deployment");
    },
    async encodeCallData(b) {
      if (Array.isArray(b)) {
        const R = b;
        return y0(o) === "v0.6" ? di({
          abi: [
            {
              inputs: [
                {
                  internalType: "address[]",
                  name: "dest",
                  type: "address[]"
                },
                {
                  internalType: "bytes[]",
                  name: "func",
                  type: "bytes[]"
                }
              ],
              name: "executeBatch",
              outputs: [],
              stateMutability: "nonpayable",
              type: "function"
            }
          ],
          functionName: "executeBatch",
          args: [
            R.map((j) => j.to),
            R.map((j) => j.data)
          ]
        }) : di({
          abi: [
            {
              inputs: [
                {
                  internalType: "address[]",
                  name: "dest",
                  type: "address[]"
                },
                {
                  internalType: "uint256[]",
                  name: "value",
                  type: "uint256[]"
                },
                {
                  internalType: "bytes[]",
                  name: "func",
                  type: "bytes[]"
                }
              ],
              name: "executeBatch",
              outputs: [],
              stateMutability: "nonpayable",
              type: "function"
            }
          ],
          functionName: "executeBatch",
          args: [
            R.map((j) => j.to),
            R.map((j) => j.value),
            R.map((j) => j.data)
          ]
        });
      }
      const { to: k, value: T, data: O } = b;
      return di({
        abi: [
          {
            inputs: [
              {
                internalType: "address",
                name: "dest",
                type: "address"
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256"
              },
              {
                internalType: "bytes",
                name: "func",
                type: "bytes"
              }
            ],
            name: "execute",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function"
          }
        ],
        functionName: "execute",
        args: [k, T, O]
      });
    },
    async getDummySignature(b) {
      return "0xfffffffffffffffffffffffffffffff0000000000000000000000000000000007aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa1c";
    }
  });
}
function Ox() {
  const [e] = o5(), { worldAddress: t } = Iu(), r = H5(), o = V5(), l = z3("gasTank"), { address: d } = kd(), f = r5({ chainId: r.id }), m = [
    "mud:appAccountClient",
    r.id,
    t,
    e == null ? void 0 : e.address,
    d,
    // this currently assumes a statically defined ERC-4337 config
    // TODO: add a `key` config option or similar to allow for dynamic usages?
    !!o,
    l == null ? void 0 : l.address
  ];
  return wx(
    e && d && f ? {
      queryKey: m,
      staleTime: 1 / 0,
      queryFn: async () => {
        if (!o)
          return q1("no ERC-4337 config, using app signer as app account"), A1({
            type: "appSignerClient",
            // TODO: figure out what effect `key` has and how to use this option properly
            key: "appSignerClient",
            // TODO: figure out what effect `name` has and how to use this option properly
            name: "App Signer Client",
            chain: r,
            account: e,
            pollingInterval: PE,
            // TODO: add websocket + fallback?
            // TODO: provide way to override this transport?
            transport: ME("app account (signer) client", sD())
          }).extend(CC).extend(
            aj({
              worldAddress: t,
              delegatorAddress: d,
              publicClient: f
            })
          ).extend(() => C1(f));
        const v = await wW(f, {
          entryPoint: jE,
          factoryAddress: LV,
          signer: e
        }), w = nW({
          chain: f.chain,
          transport: ME("pimlico bundler client", o.transport),
          entryPoint: jE,
          pollingInterval: PE
        }).extend(() => C1(f)), x = l ? {
          // Pimlico's gas estimation runs with high gas limits, which can make the estimation fail if
          // the cost would exceed the user's balance.
          // We override the user's balance in the paymaster contract and the deposit balance of the
          // paymaster in the entry point contract to make the gas estimation succeed.
          [l.address]: {
            stateDiff: {
              [cW(d)]: St(wP)
            }
          },
          [jE]: {
            stateDiff: {
              [dW(l.address)]: St(wP)
            }
          }
        } : void 0, k = { ...l ? {
          sponsorUserOperation: async ({ userOperation: O }) => {
            const R = await w.estimateUserOperationGas(
              {
                userOperation: {
                  ...O,
                  paymaster: l.address,
                  paymasterData: "0x"
                }
              },
              x
            );
            return {
              paymasterData: "0x",
              paymaster: l.address,
              ...R
            };
          }
        } : null };
        return A1({
          key: "Account",
          name: "Smart Account Client",
          type: "smartAccountClient",
          chain: f.chain,
          account: v,
          pollingInterval: PE,
          transport: ME("app smart account client", o.transport)
        }).extend(() => C1(f)).extend((O) => ({
          sendTransaction: (R) => vW(
            O,
            {
              ...R,
              middleware: k
            },
            {
              estimateFeesPerGas: async () => (await w.getUserOperationGasPrice()).fast
            }
          )
        })).extend(MV({ middleware: k })).extend(
          aj({
            worldAddress: t,
            delegatorAddress: d,
            publicClient: f
          })
        );
      }
    } : {
      queryKey: m,
      enabled: !1
    }
  );
}
function xW() {
  var m;
  const { chainId: e, worldAddress: t } = Iu(), o = kd().address, { data: l } = Ox(), d = l == null ? void 0 : l.account.address, f = _x(
    o && d ? {
      chainId: e,
      address: t,
      table: R5.tables.world__UserDelegationControl,
      key: {
        delegator: o,
        delegatee: d
      },
      blockTag: "pending",
      query: {
        staleTime: 1e3 * 60 * 5
      }
    } : {}
  );
  return {
    ...f,
    hasDelegation: ((m = f.record) == null ? void 0 : m.delegationControlId) === h5
  };
}
function SW() {
  var m, v;
  const { chainId: e } = Iu(), { data: t } = Ox(), r = oH(
    t && t.type !== "smartAccountClient" ? {
      chainId: e,
      address: t.account.address,
      query: {
        refetchInterval: 2e3
      }
    } : { query: { enabled: !1 } }
  ), o = z3("gasTank"), d = kd().address, f = _x(
    (t == null ? void 0 : t.type) === "smartAccountClient" && d && o ? {
      chainId: e,
      address: o.address,
      table: G1.tables.UserBalances,
      key: { userAccount: d },
      blockTag: "pending",
      query: {
        refetchInterval: 2e3
      }
    } : {}
  );
  return (t == null ? void 0 : t.type) === "smartAccountClient" ? {
    ...f,
    gasTankBalance: (m = f.record) == null ? void 0 : m.balance
  } : {
    ...r,
    gasTankBalance: (v = r.data) == null ? void 0 : v.value
  };
}
function kW() {
  var m;
  const { chainId: e } = Iu(), t = z3("gasTank"), o = kd().address, { data: l } = Ox(), d = l == null ? void 0 : l.account.address, f = _x(
    (l == null ? void 0 : l.type) === "smartAccountClient" && d && t ? {
      chainId: e,
      address: t.address,
      table: G1.tables.Spender,
      key: { spender: d },
      blockTag: "pending"
    } : {}
  );
  return {
    ...f,
    isGasSpender: (l == null ? void 0 : l.type) === "smartAccountClient" ? o && o === ((m = f.record) == null ? void 0 : m.userAccount) : !0
  };
}
const EW = [
  {
    type: "function",
    name: "batchCall",
    inputs: [
      {
        name: "systemCalls",
        type: "tuple[]",
        internalType: "struct SystemCallData[]",
        components: [
          {
            name: "systemId",
            type: "bytes32",
            internalType: "ResourceId"
          },
          {
            name: "callData",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "returnDatas",
        type: "bytes[]",
        internalType: "bytes[]"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "batchCallFrom",
    inputs: [
      {
        name: "systemCalls",
        type: "tuple[]",
        internalType: "struct SystemCallFromData[]",
        components: [
          {
            name: "from",
            type: "address",
            internalType: "address"
          },
          {
            name: "systemId",
            type: "bytes32",
            internalType: "ResourceId"
          },
          {
            name: "callData",
            type: "bytes",
            internalType: "bytes"
          }
        ]
      }
    ],
    outputs: [
      {
        name: "returnDatas",
        type: "bytes[]",
        internalType: "bytes[]"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "call",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "callData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "callFrom",
    inputs: [
      {
        name: "delegator",
        type: "address",
        internalType: "address"
      },
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "callData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "creator",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "deleteRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getDynamicField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getDynamicFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getDynamicFieldSlice",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "start",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "end",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLayout",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFieldLength",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getKeySchema",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "keySchema",
        type: "bytes32",
        internalType: "Schema"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "staticData",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      }
    ],
    outputs: [
      {
        name: "staticData",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getStaticField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getValueSchema",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [
      {
        name: "valueSchema",
        type: "bytes32",
        internalType: "Schema"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "grantAccess",
    inputs: [
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "grantee",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      {
        name: "initModule",
        type: "address",
        internalType: "contract IModule"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "installModule",
    inputs: [
      {
        name: "module",
        type: "address",
        internalType: "contract IModule"
      },
      {
        name: "encodedArgs",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "installRootModule",
    inputs: [
      {
        name: "module",
        type: "address",
        internalType: "contract IModule"
      },
      {
        name: "encodedArgs",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "popFromDynamicField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "byteLengthToPop",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pushToDynamicField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "dataToPush",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerDelegation",
    inputs: [
      {
        name: "delegatee",
        type: "address",
        internalType: "address"
      },
      {
        name: "delegationControlId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "initCallData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerFunctionSelector",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "systemFunctionSignature",
        type: "string",
        internalType: "string"
      }
    ],
    outputs: [
      {
        name: "worldFunctionSelector",
        type: "bytes4",
        internalType: "bytes4"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerNamespace",
    inputs: [
      {
        name: "namespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerNamespaceDelegation",
    inputs: [
      {
        name: "namespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "delegationControlId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "initCallData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerRootFunctionSelector",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "worldFunctionSignature",
        type: "string",
        internalType: "string"
      },
      {
        name: "systemFunctionSignature",
        type: "string",
        internalType: "string"
      }
    ],
    outputs: [
      {
        name: "worldFunctionSelector",
        type: "bytes4",
        internalType: "bytes4"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerStoreHook",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "hookAddress",
        type: "address",
        internalType: "contract IStoreHook"
      },
      {
        name: "enabledHooksBitmap",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerSystem",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "system",
        type: "address",
        internalType: "contract System"
      },
      {
        name: "publicAccess",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerSystemHook",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "hookAddress",
        type: "address",
        internalType: "contract ISystemHook"
      },
      {
        name: "enabledHooksBitmap",
        type: "uint8",
        internalType: "uint8"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registerTable",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      },
      {
        name: "keySchema",
        type: "bytes32",
        internalType: "Schema"
      },
      {
        name: "valueSchema",
        type: "bytes32",
        internalType: "Schema"
      },
      {
        name: "keyNames",
        type: "string[]",
        internalType: "string[]"
      },
      {
        name: "fieldNames",
        type: "string[]",
        internalType: "string[]"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [
      {
        name: "namespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "revokeAccess",
    inputs: [
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "grantee",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setDynamicField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "staticData",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setStaticField",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "fieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "fieldLayout",
        type: "bytes32",
        internalType: "FieldLayout"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "spliceDynamicData",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        internalType: "uint8"
      },
      {
        name: "startWithinField",
        type: "uint40",
        internalType: "uint40"
      },
      {
        name: "deleteCount",
        type: "uint40",
        internalType: "uint40"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "spliceStaticData",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        name: "start",
        type: "uint48",
        internalType: "uint48"
      },
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "storeVersion",
    inputs: [],
    outputs: [
      {
        name: "version",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transferBalanceToAddress",
    inputs: [
      {
        name: "fromNamespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "toAddress",
        type: "address",
        internalType: "address"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferBalanceToNamespace",
    inputs: [
      {
        name: "fromNamespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "toNamespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "namespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "newOwner",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unregisterDelegation",
    inputs: [
      {
        name: "delegatee",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unregisterNamespaceDelegation",
    inputs: [
      {
        name: "namespaceId",
        type: "bytes32",
        internalType: "ResourceId"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unregisterStoreHook",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "hookAddress",
        type: "address",
        internalType: "contract IStoreHook"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unregisterSystemHook",
    inputs: [
      {
        name: "systemId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "hookAddress",
        type: "address",
        internalType: "contract ISystemHook"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "worldVersion",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "HelloStore",
    inputs: [
      {
        name: "storeVersion",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "HelloWorld",
    inputs: [
      {
        name: "worldVersion",
        type: "bytes32",
        indexed: !0,
        internalType: "bytes32"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Store_DeleteRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        indexed: !0,
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        indexed: !1,
        internalType: "bytes32[]"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Store_SetRecord",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        indexed: !0,
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        indexed: !1,
        internalType: "bytes32[]"
      },
      {
        name: "staticData",
        type: "bytes",
        indexed: !1,
        internalType: "bytes"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        indexed: !1,
        internalType: "EncodedLengths"
      },
      {
        name: "dynamicData",
        type: "bytes",
        indexed: !1,
        internalType: "bytes"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Store_SpliceDynamicData",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        indexed: !0,
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        indexed: !1,
        internalType: "bytes32[]"
      },
      {
        name: "dynamicFieldIndex",
        type: "uint8",
        indexed: !1,
        internalType: "uint8"
      },
      {
        name: "start",
        type: "uint48",
        indexed: !1,
        internalType: "uint48"
      },
      {
        name: "deleteCount",
        type: "uint40",
        indexed: !1,
        internalType: "uint40"
      },
      {
        name: "encodedLengths",
        type: "bytes32",
        indexed: !1,
        internalType: "EncodedLengths"
      },
      {
        name: "data",
        type: "bytes",
        indexed: !1,
        internalType: "bytes"
      }
    ],
    anonymous: !1
  },
  {
    type: "event",
    name: "Store_SpliceStaticData",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        indexed: !0,
        internalType: "ResourceId"
      },
      {
        name: "keyTuple",
        type: "bytes32[]",
        indexed: !1,
        internalType: "bytes32[]"
      },
      {
        name: "start",
        type: "uint48",
        indexed: !1,
        internalType: "uint48"
      },
      {
        name: "data",
        type: "bytes",
        indexed: !1,
        internalType: "bytes"
      }
    ],
    anonymous: !1
  },
  {
    type: "error",
    name: "EncodedLengths_InvalidLength",
    inputs: [
      {
        name: "length",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_Empty",
    inputs: []
  },
  {
    type: "error",
    name: "FieldLayout_InvalidStaticDataLength",
    inputs: [
      {
        name: "staticDataLength",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "computedStaticDataLength",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_StaticLengthDoesNotFitInAWord",
    inputs: [
      {
        name: "index",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_StaticLengthIsNotZero",
    inputs: [
      {
        name: "index",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_StaticLengthIsZero",
    inputs: [
      {
        name: "index",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_TooManyDynamicFields",
    inputs: [
      {
        name: "numFields",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "maxFields",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "FieldLayout_TooManyFields",
    inputs: [
      {
        name: "numFields",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "maxFields",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Module_AlreadyInstalled",
    inputs: []
  },
  {
    type: "error",
    name: "Module_MissingDependency",
    inputs: [
      {
        name: "dependency",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "Module_NonRootInstallNotSupported",
    inputs: []
  },
  {
    type: "error",
    name: "Module_RootInstallNotSupported",
    inputs: []
  },
  {
    type: "error",
    name: "Schema_InvalidLength",
    inputs: [
      {
        name: "length",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Schema_StaticTypeAfterDynamicType",
    inputs: []
  },
  {
    type: "error",
    name: "Slice_OutOfBounds",
    inputs: [
      {
        name: "data",
        type: "bytes",
        internalType: "bytes"
      },
      {
        name: "start",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "end",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_IndexOutOfBounds",
    inputs: [
      {
        name: "length",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "accessedIndex",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidBounds",
    inputs: [
      {
        name: "start",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "end",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidFieldNamesLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidKeyNamesLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidResourceType",
    inputs: [
      {
        name: "expected",
        type: "bytes2",
        internalType: "bytes2"
      },
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "resourceIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidSplice",
    inputs: [
      {
        name: "startWithinField",
        type: "uint40",
        internalType: "uint40"
      },
      {
        name: "deleteCount",
        type: "uint40",
        internalType: "uint40"
      },
      {
        name: "fieldLength",
        type: "uint40",
        internalType: "uint40"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidStaticDataLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidValueSchemaDynamicLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidValueSchemaLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_InvalidValueSchemaStaticLength",
    inputs: [
      {
        name: "expected",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "received",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "Store_TableAlreadyExists",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "tableIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "Store_TableNotFound",
    inputs: [
      {
        name: "tableId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "tableIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "World_AccessDenied",
    inputs: [
      {
        name: "resource",
        type: "string",
        internalType: "string"
      },
      {
        name: "caller",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "World_AlreadyInitialized",
    inputs: []
  },
  {
    type: "error",
    name: "World_CallbackNotAllowed",
    inputs: [
      {
        name: "functionSelector",
        type: "bytes4",
        internalType: "bytes4"
      }
    ]
  },
  {
    type: "error",
    name: "World_DelegationNotFound",
    inputs: [
      {
        name: "delegator",
        type: "address",
        internalType: "address"
      },
      {
        name: "delegatee",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "World_FunctionSelectorAlreadyExists",
    inputs: [
      {
        name: "functionSelector",
        type: "bytes4",
        internalType: "bytes4"
      }
    ]
  },
  {
    type: "error",
    name: "World_FunctionSelectorNotFound",
    inputs: [
      {
        name: "functionSelector",
        type: "bytes4",
        internalType: "bytes4"
      }
    ]
  },
  {
    type: "error",
    name: "World_InsufficientBalance",
    inputs: [
      {
        name: "balance",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "error",
    name: "World_InterfaceNotSupported",
    inputs: [
      {
        name: "contractAddress",
        type: "address",
        internalType: "address"
      },
      {
        name: "interfaceId",
        type: "bytes4",
        internalType: "bytes4"
      }
    ]
  },
  {
    type: "error",
    name: "World_InvalidNamespace",
    inputs: [
      {
        name: "namespace",
        type: "bytes14",
        internalType: "bytes14"
      }
    ]
  },
  {
    type: "error",
    name: "World_InvalidResourceId",
    inputs: [
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "resourceIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "World_InvalidResourceType",
    inputs: [
      {
        name: "expected",
        type: "bytes2",
        internalType: "bytes2"
      },
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "resourceIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "World_ResourceAlreadyExists",
    inputs: [
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "resourceIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "World_ResourceNotFound",
    inputs: [
      {
        name: "resourceId",
        type: "bytes32",
        internalType: "ResourceId"
      },
      {
        name: "resourceIdString",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "error",
    name: "World_SystemAlreadyExists",
    inputs: [
      {
        name: "system",
        type: "address",
        internalType: "address"
      }
    ]
  },
  {
    type: "error",
    name: "World_UnlimitedDelegationNotAllowed",
    inputs: []
  }
];
async function CW(e, { storeAddress: t, table: r, key: o, blockTag: l }) {
  const d = $3(Tx(r), o), [f, m, v] = await Ts(e, {
    address: t,
    abi: O5,
    functionName: "getRecord",
    args: [r.tableId, d],
    blockTag: l
  });
  return {
    ...o,
    ...I3(L1(M3(r)), { staticData: f, encodedLengths: m, dynamicData: v })
  };
}
function TW(e) {
  let t = Ed(e);
  if (Er(e, "tables") && pT(e.tables, t), Er(e, "namespaces") && ao(e.namespaces))
    for (let r of Object.keys(e.namespaces))
      pT(y5(e.namespaces, [r, "tables"]) ?? {}, t);
}
function _W(e) {
  let t = Ed(e), r = Gf(e.tables ?? {}, (d) => $1(d) ? fT(d, t) : d), o = Gf(e.namespaces ?? {}, (d) => ({ ...d, tables: Gf(d.tables ?? {}, (f) => $1(f) ? fT(f, t) : f) })), l = { ...e, tables: r, namespaces: o };
  return T5(l), _5(l);
}
function RW(e) {
  return TW(e), _W(e);
}
var G5 = RW({ codegen: { worldgenDirectory: "interfaces", worldInterfaceName: "IBaseWorld", outputDirectory: "." }, userTypes: { ResourceId: { filePath: "@latticexyz/store/src/ResourceId.sol", type: "bytes32" } }, tables: { KeysWithValue: { schema: { valueHash: "bytes32", keysWithValue: "bytes32[]" }, key: ["valueHash"], codegen: { outputDirectory: "modules/keyswithvalue/tables", tableIdArgument: !0, storeArgument: !0 } }, KeysInTable: { schema: { sourceTableId: "ResourceId", keys0: "bytes32[]", keys1: "bytes32[]", keys2: "bytes32[]", keys3: "bytes32[]", keys4: "bytes32[]" }, key: ["sourceTableId"], codegen: { outputDirectory: "modules/keysintable/tables", storeArgument: !0 } }, UsedKeysIndex: { schema: { sourceTableId: "ResourceId", keysHash: "bytes32", has: "bool", index: "uint40" }, key: ["sourceTableId", "keysHash"], codegen: { outputDirectory: "modules/keysintable/tables", dataStruct: !1, storeArgument: !0 } }, UniqueEntity: { schema: { value: "uint256" }, key: [], codegen: { outputDirectory: "modules/uniqueentity/tables", tableIdArgument: !0, storeArgument: !0 } }, CallboundDelegations: { schema: { delegator: "address", delegatee: "address", systemId: "ResourceId", callDataHash: "bytes32", availableCalls: "uint256" }, key: ["delegator", "delegatee", "systemId", "callDataHash"], codegen: { outputDirectory: "modules/std-delegations/tables" } }, SystemboundDelegations: { schema: { delegator: "address", delegatee: "address", systemId: "ResourceId", availableCalls: "uint256" }, key: ["delegator", "delegatee", "systemId"], codegen: { outputDirectory: "modules/std-delegations/tables" } }, TimeboundDelegations: { schema: { delegator: "address", delegatee: "address", maxTimestamp: "uint256" }, key: ["delegator", "delegatee"], codegen: { outputDirectory: "modules/std-delegations/tables" } }, PuppetRegistry: { schema: { systemId: "ResourceId", puppet: "address" }, key: ["systemId"], codegen: { outputDirectory: "modules/puppet/tables", tableIdArgument: !0 } }, Balances: { schema: { account: "address", value: "uint256" }, key: ["account"], codegen: { outputDirectory: "modules/tokens/tables", tableIdArgument: !0 } }, ERC20Metadata: { schema: { decimals: "uint8", name: "string", symbol: "string" }, key: [], codegen: { outputDirectory: "modules/erc20-puppet/tables", tableIdArgument: !0 } }, Allowances: { schema: { account: "address", spender: "address", value: "uint256" }, key: ["account", "spender"], codegen: { outputDirectory: "modules/erc20-puppet/tables", tableIdArgument: !0 } }, TotalSupply: { schema: { totalSupply: "uint256" }, key: [], codegen: { outputDirectory: "modules/erc20-puppet/tables", tableIdArgument: !0 } }, ERC20Registry: { schema: { namespaceId: "ResourceId", tokenAddress: "address" }, key: ["namespaceId"], codegen: { outputDirectory: "modules/erc20-puppet/tables", tableIdArgument: !0 } }, ERC721Metadata: { schema: { name: "string", symbol: "string", baseURI: "string" }, key: [], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, TokenURI: { schema: { tokenId: "uint256", tokenURI: "string" }, key: ["tokenId"], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, Owners: { schema: { tokenId: "uint256", owner: "address" }, key: ["tokenId"], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, TokenApproval: { schema: { tokenId: "uint256", account: "address" }, key: ["tokenId"], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, OperatorApproval: { schema: { owner: "address", operator: "address", approved: "bool" }, key: ["owner", "operator"], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, ERC721Registry: { schema: { namespaceId: "ResourceId", tokenAddress: "address" }, key: ["namespaceId"], codegen: { outputDirectory: "modules/erc721-puppet/tables", tableIdArgument: !0 } }, CallWithSignatureNonces: { schema: { signer: "address", nonce: "uint256" }, key: ["signer"], codegen: { outputDirectory: "modules/callwithsignature/tables" } } }, excludeSystems: ["UniqueEntitySystem", "PuppetFactorySystem", "ERC20System", "ERC721System", "Unstable_CallWithSignatureSystem"] });
async function OW({
  userAccountClient: e,
  chainId: t,
  worldAddress: r,
  systemId: o,
  callData: l,
  nonce: d,
  publicClient: f
}) {
  const m = d ?? (f ? (await CW(f, {
    storeAddress: r,
    table: G5.tables.CallWithSignatureNonces,
    key: { signer: e.account.address },
    blockTag: "pending"
  })).nonce : 0n), { namespace: v, name: w } = uV(o);
  return await _D(e, {
    account: e.account,
    domain: {
      verifyingContract: r,
      salt: St(t, { size: 32 })
    },
    types: Xq,
    primaryType: "Call",
    message: {
      signer: e.account.address,
      systemNamespace: v,
      systemName: w,
      callData: l,
      nonce: m
    }
  });
}
function PW() {
  var d;
  const { chainId: e, worldAddress: t } = Iu(), { data: r } = a5({ chainId: e }), o = r == null ? void 0 : r.account.address, l = _x(
    o ? {
      chainId: e,
      address: t,
      table: G5.tables.CallWithSignatureNonces,
      key: { signer: o },
      blockTag: "pending"
    } : {}
  );
  return {
    ...l,
    nonce: (d = l.record) == null ? void 0 : d.nonce
  };
}
const LE = e0(() => ({ signature: void 0 }));
function jW() {
  const { chainId: e, worldAddress: t } = Iu(), r = r5({ chainId: e }), { data: o } = a5({ chainId: e }), { data: l } = Ox(), { nonce: d } = PW(), f = J1(LE, (v) => v.signature), m = n5({
    mutationFn: async () => {
      if (!r)
        throw new Error("Public client not ready. Not connected?");
      if (!o)
        throw new Error("Wallet client not ready. Not connected?");
      if (!l)
        throw new Error("App account client not ready.");
      if (d == null)
        throw new Error("Nonce not ready.");
      const v = await OW({
        userAccountClient: o,
        chainId: e,
        worldAddress: t,
        systemId: R3({ type: "system", namespace: "", name: "Registration" }),
        callData: di({
          abi: EW,
          functionName: "registerDelegation",
          args: [l.account.address, h5, "0x"]
        }),
        nonce: d
      });
      return LE.setState({ signature: v }), v;
    }
  });
  return $.useMemo(
    () => ({
      ...m,
      signRegisterDelegation: m.mutate,
      signRegisterDelegationAsync: m.mutateAsync,
      registerDelegationSignature: f,
      clearSignature: () => LE.setState({ signature: void 0 })
    }),
    [f, m]
  );
}
function AW() {
  const { chainId: e } = Iu(), { data: t } = uH({
    chainId: e,
    query: {
      refetchOnMount: !1,
      refetchOnReconnect: !1,
      refetchOnWindowFocus: !1,
      staleTime: 1 / 0
    }
  });
  return (t == null ? void 0 : t.baseFeePerGas) === 0n;
}
const DW = [
  "connectedWallet",
  "appSigner",
  "gasAllowance",
  "gasSpender",
  "accountDelegation",
  "accountDelegationConfirmed"
];
function q5() {
  const e = kd(), [t] = o5(), { gasTankBalance: r } = SW(), { isGasSpender: o } = kW(), { hasDelegation: l } = xW(), { registerDelegationSignature: d } = jW(), f = AW();
  return $.useMemo(() => {
    const v = {
      connectedWallet: () => e.status === "connected",
      appSigner: () => t != null,
      gasAllowance: () => f || r != null && r > 0n,
      gasSpender: () => o === !0,
      accountDelegation: () => l === !0 || d != null,
      accountDelegationConfirmed: () => l === !0
    }, w = DW.filter((x) => !v[x]());
    return {
      requirement: w.at(0) ?? null,
      requirements: w
    };
  }, [
    t,
    r,
    l,
    f,
    o,
    d,
    e.status
  ]);
}
const IW = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type="button"]),input:where([type="reset"]),input:where([type="submit"]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.grid-cols-2.divide-y>:not([hidden])~:not([hidden]):nth-child(-n + 2){border-top-width:0;border-bottom-width:0}.pointer-events-none{pointer-events:none}.fixed{position:fixed}.relative{position:relative}.inset-0{inset:0px}.col-start-1{grid-column-start:1}.row-start-1{grid-row-start:1}.-m-1{margin:-.25rem}.-m-2{margin:-.5rem}.m-2{margin:.5rem}.-mx-0{margin-left:-0px;margin-right:-0px}.-mx-0\\.5{margin-left:-.125rem;margin-right:-.125rem}.-my-1{margin-top:-.25rem;margin-bottom:-.25rem}.-my-\\[0\\.125em\\]{margin-top:-.125em;margin-bottom:-.125em}.-my-px{margin-top:-1px;margin-bottom:-1px}.-ml-3{margin-left:-.75rem}.-mr-1{margin-right:-.25rem}.-mr-1\\.5{margin-right:-.375rem}.-mr-3{margin-right:-.75rem}.-mt-px{margin-top:-1px}.mt-1{margin-top:.25rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.inline-grid{display:inline-grid}.contents{display:contents}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.h-16{height:4rem}.h-6{height:1.5rem}.h-\\[1\\.25em\\]{height:1.25em}.h-\\[1em\\]{height:1em}.h-\\[2px\\]{height:2px}.h-full{height:100%}.max-h-32{max-height:8rem}.min-h-\\[28rem\\]{min-height:28rem}.w-16{width:4rem}.w-6{width:1.5rem}.w-60{width:15rem}.w-8{width:2rem}.w-80{width:20rem}.w-\\[0\\.6em\\]{width:.6em}.w-\\[1\\.25em\\]{width:1.25em}.w-\\[16rem\\]{width:16rem}.w-\\[44rem\\]{width:44rem}.w-full{width:100%}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.translate-x-1{--tw-translate-x: .25rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-2{--tw-translate-x: .5rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-90{--tw-rotate: -90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-90{--tw-rotate: 90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-100{--tw-scale-x: 1;--tw-scale-y: 1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-50{--tw-scale-x: .5;--tw-scale-y: .5;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-pointer{cursor:pointer}.cursor-text{cursor:text}.grid-flow-col{grid-auto-flow:column}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-\\[1fr_auto_1fr\\]{grid-template-columns:1fr auto 1fr}.flex-col{flex-direction:column}.place-items-center{place-items:center}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-stretch{justify-content:stretch}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-2\\.5{gap:.625rem}.gap-3{gap:.75rem}.gap-4{gap:1rem}.gap-5{gap:1.25rem}.gap-6{gap:1.5rem}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse: 0;border-right-width:calc(1px * var(--tw-divide-x-reverse));border-left-width:calc(1px * calc(1 - var(--tw-divide-x-reverse)))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-neutral-200>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(229 229 229 / var(--tw-divide-opacity))}.divide-neutral-300>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(212 212 212 / var(--tw-divide-opacity))}.self-start{align-self:flex-start}.self-end{align-self:flex-end}.self-center{align-self:center}.self-stretch{align-self:stretch}.overflow-clip{overflow:clip}.overflow-y-auto{overflow-y:auto}.overflow-y-scroll{overflow-y:scroll}.whitespace-break-spaces{white-space:break-spaces}.break-all{word-break:break-all}.rounded-full{border-radius:9999px}.border{border-width:1px}.border-2{border-width:2px}.border-y{border-top-width:1px;border-bottom-width:1px}.border-l-4{border-left-width:4px}.border-dashed{border-style:dashed}.border-black\\/20{border-color:#0003}.border-neutral-300{--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity))}.border-neutral-400{--tw-border-opacity: 1;border-color:rgb(163 163 163 / var(--tw-border-opacity))}.border-red-500{--tw-border-opacity: 1;border-color:rgb(239 68 68 / var(--tw-border-opacity))}.border-transparent{border-color:transparent}.bg-black\\/10{background-color:#0000001a}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(59 130 246 / var(--tw-bg-opacity))}.bg-green-500{--tw-bg-opacity: 1;background-color:rgb(34 197 94 / var(--tw-bg-opacity))}.bg-green-600{--tw-bg-opacity: 1;background-color:rgb(22 163 74 / var(--tw-bg-opacity))}.bg-neutral-100{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.bg-neutral-200{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity))}.bg-neutral-700\\/50{background-color:#40404080}.bg-neutral-900{--tw-bg-opacity: 1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.bg-orange-500{--tw-bg-opacity: 1;background-color:rgb(249 115 22 / var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity: 1;background-color:rgb(254 226 226 / var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239 68 68 / var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.bg-cover{background-size:cover}.bg-center{background-position:center}.bg-no-repeat{background-repeat:no-repeat}.object-cover{object-fit:cover}.p-2{padding:.5rem}.p-2\\.5{padding:.625rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-5{padding:1.25rem}.p-6{padding:1.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-5{padding-top:1.25rem;padding-bottom:1.25rem}.py-6{padding-top:1.5rem;padding-bottom:1.5rem}.py-\\[8vh\\]{padding-top:8vh;padding-bottom:8vh}.text-left{text-align:left}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.text-2xl{font-size:1.5rem;line-height:2rem}.text-\\[\\.75em\\]{font-size:.75em}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-medium{font-weight:500}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.leading-loose{line-height:2}.leading-none{line-height:1}.tracking-\\[-1ch\\]{letter-spacing:-1ch}.text-amber-500{--tw-text-opacity: 1;color:rgb(245 158 11 / var(--tw-text-opacity))}.text-black{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.text-green-600{--tw-text-opacity: 1;color:rgb(22 163 74 / var(--tw-text-opacity))}.text-neutral-400{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.text-neutral-500{--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity))}.text-neutral-600{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity))}.text-neutral-700{--tw-text-opacity: 1;color:rgb(64 64 64 / var(--tw-text-opacity))}.text-orange-500{--tw-text-opacity: 1;color:rgb(249 115 22 / var(--tw-text-opacity))}.text-red-500{--tw-text-opacity: 1;color:rgb(239 68 68 / var(--tw-text-opacity))}.text-red-900{--tw-text-opacity: 1;color:rgb(127 29 29 / var(--tw-text-opacity))}.text-transparent{color:transparent}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-25{opacity:.25}.opacity-50{opacity:.5}.opacity-75{opacity:.75}.outline-none{outline:2px solid transparent;outline-offset:2px}.ring-2{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-transparent{--tw-ring-color: transparent}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.duration-300{transition-duration:.3s}.ease-linear{transition-timing-function:linear}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.animate-in{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.animate-out{animation-name:exit;animation-duration:.15s;--tw-exit-opacity: initial;--tw-exit-scale: initial;--tw-exit-rotate: initial;--tw-exit-translate-x: initial;--tw-exit-translate-y: initial}.fade-in{--tw-enter-opacity: 0}.fade-out{--tw-exit-opacity: 0}.slide-in-from-bottom-2{--tw-enter-translate-y: .5rem}.slide-in-from-bottom-4{--tw-enter-translate-y: 1rem}.slide-in-from-left-2{--tw-enter-translate-x: -.5rem}.slide-in-from-top-2{--tw-enter-translate-y: -.5rem}.animate-duration-200{animation-duration:.2s}.animate-duration-500{animation-duration:.5s}.ease-linear{animation-timing-function:linear}@property --tw-border-gradient-angle{syntax: "<angle>"; inherits: true; initial-value: 0deg;}@property --tw-conic-gradient-angle{syntax: "<angle>"; inherits: true; initial-value: 0deg;}@keyframes border-gradient{to{--tw-border-gradient-angle: 360deg}}.placeholder\\:text-neutral-400::placeholder{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.after\\:select-none:after{content:var(--tw-content);-webkit-user-select:none;user-select:none}.after\\:content-\\[\\'…\\'\\]:after{--tw-content: "…";content:var(--tw-content)}.focus-within\\:border-transparent:focus-within{border-color:transparent}.focus-within\\:ring-orange-500:focus-within{--tw-ring-opacity: 1;--tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity))}.hover\\:border-neutral-500:hover{--tw-border-opacity: 1;border-color:rgb(115 115 115 / var(--tw-border-opacity))}.hover\\:bg-neutral-100:hover{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.hover\\:bg-neutral-200:hover{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity))}.hover\\:bg-neutral-300:hover{--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity))}.hover\\:bg-neutral-700:hover{--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.hover\\:bg-orange-400:hover{--tw-bg-opacity: 1;background-color:rgb(251 146 60 / var(--tw-bg-opacity))}.hover\\:text-black:hover{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.hover\\:text-neutral-600:hover{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity))}.focus\\:border-transparent:focus{border-color:transparent}.focus\\:bg-white:focus{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.focus\\:ring-orange-500:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity))}.active\\:border-neutral-600:active{--tw-border-opacity: 1;border-color:rgb(82 82 82 / var(--tw-border-opacity))}.active\\:bg-neutral-300:active{--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity))}.active\\:bg-neutral-600:active{--tw-bg-opacity: 1;background-color:rgb(82 82 82 / var(--tw-bg-opacity))}.active\\:bg-orange-600:active{--tw-bg-opacity: 1;background-color:rgb(234 88 12 / var(--tw-bg-opacity))}.group:hover .group-hover\\:pointer-events-none{pointer-events:none}.group:hover .group-hover\\:pointer-events-auto{pointer-events:auto}.group:hover .group-hover\\:translate-x-0{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group:hover .group-hover\\:text-black{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.group:hover .group-hover\\:opacity-0{opacity:0}.group:hover .group-hover\\:opacity-100{opacity:1}.peer:placeholder-shown~.peer-placeholder-shown\\:text-neutral-400{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.aria-busy\\:pointer-events-none[aria-busy=true]{pointer-events:none}.aria-busy\\:opacity-50[aria-busy=true]{opacity:.5}.aria-busy\\:saturate-50[aria-busy=true]{--tw-saturate: saturate(.5);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.aria-disabled\\:pointer-events-none[aria-disabled=true]{pointer-events:none}.aria-disabled\\:border-neutral-300[aria-disabled=true]{--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity))}.aria-disabled\\:bg-neutral-200[aria-disabled=true]{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity))}.aria-disabled\\:text-neutral-400[aria-disabled=true]{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.aria-selected\\:border-neutral-300[aria-selected=true]{--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity))}.aria-selected\\:border-b-transparent[aria-selected=true]{border-bottom-color:transparent}.aria-selected\\:bg-transparent[aria-selected=true]{background-color:transparent}.group[aria-busy=true] .group-aria-busy\\:translate-x-0{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[aria-busy=true] .group-aria-busy\\:scale-100{--tw-scale-x: 1;--tw-scale-y: 1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[aria-busy=true] .group-aria-busy\\:scale-125{--tw-scale-x: 1.25;--tw-scale-y: 1.25;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[aria-busy=true] .group-aria-busy\\:opacity-0{opacity:0}.group[aria-busy=true] .group-aria-busy\\:opacity-100{opacity:1}.group[aria-busy=true] .group-aria-busy\\:duration-300{transition-duration:.3s}.group[aria-expanded=true] .group-aria-expanded\\:inline{display:inline}.group[aria-expanded=true] .group-aria-expanded\\:hidden{display:none}.data-\\[highlighted\\]\\:bg-neutral-200[data-highlighted],.data-\\[state\\=checked\\]\\:bg-neutral-200[data-state=checked]{--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity))}.links\\:font-medium a[href]{font-weight:500}.links\\:text-black a[href]{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.links\\:underline a[href]{text-decoration-line:underline}.links\\:decoration-neutral-300 a[href]{text-decoration-color:#d4d4d4}.links\\:underline-offset-4 a[href]{text-underline-offset:4px}.hover\\:links\\:decoration-orange-500 a[href]:hover{text-decoration-color:#f97316}.dark\\:divide-neutral-700:where([data-theme="dark"],[data-theme="dark"] *)>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(64 64 64 / var(--tw-divide-opacity))}.dark\\:border-neutral-400:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(163 163 163 / var(--tw-border-opacity))}.dark\\:border-neutral-700:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(64 64 64 / var(--tw-border-opacity))}.dark\\:border-white\\/50:where([data-theme="dark"],[data-theme="dark"] *){border-color:#ffffff80}.dark\\:bg-blue-600:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(37 99 235 / var(--tw-bg-opacity))}.dark\\:bg-green-600:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(22 163 74 / var(--tw-bg-opacity))}.dark\\:bg-green-700:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(21 128 61 / var(--tw-bg-opacity))}.dark\\:bg-neutral-100:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.dark\\:bg-neutral-700:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.dark\\:bg-neutral-800:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}.dark\\:bg-neutral-900:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.dark\\:bg-neutral-900\\/75:where([data-theme="dark"],[data-theme="dark"] *){background-color:#171717bf}.dark\\:bg-red-600:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(220 38 38 / var(--tw-bg-opacity))}.dark\\:bg-red-900:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(127 29 29 / var(--tw-bg-opacity))}.dark\\:bg-transparent:where([data-theme="dark"],[data-theme="dark"] *){background-color:transparent}.dark\\:bg-white\\/10:where([data-theme="dark"],[data-theme="dark"] *){background-color:#ffffff1a}.dark\\:text-black:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.dark\\:text-neutral-300:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(212 212 212 / var(--tw-text-opacity))}.dark\\:text-neutral-400:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.dark\\:text-neutral-500:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity))}.dark\\:text-red-50:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(254 242 242 / var(--tw-text-opacity))}.dark\\:text-white:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark\\:placeholder\\:text-neutral-500:where([data-theme="dark"],[data-theme="dark"] *)::placeholder{--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity))}.dark\\:hover\\:border-neutral-300:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(212 212 212 / var(--tw-border-opacity))}.dark\\:hover\\:bg-neutral-200:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(229 229 229 / var(--tw-bg-opacity))}.dark\\:hover\\:bg-neutral-600:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(82 82 82 / var(--tw-bg-opacity))}.dark\\:hover\\:bg-neutral-700:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.dark\\:hover\\:bg-neutral-800:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}.dark\\:hover\\:text-neutral-400:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.dark\\:hover\\:text-white:hover:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark\\:focus\\:bg-neutral-700:focus:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.dark\\:active\\:border-neutral-200:active:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(229 229 229 / var(--tw-border-opacity))}.dark\\:active\\:bg-neutral-300:active:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity))}.dark\\:active\\:bg-neutral-600:active:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(82 82 82 / var(--tw-bg-opacity))}.group:hover .dark\\:group-hover\\:text-white:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.peer:placeholder-shown~.dark\\:peer-placeholder-shown\\:text-neutral-500:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity))}.dark\\:aria-disabled\\:border-neutral-600[aria-disabled=true]:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(82 82 82 / var(--tw-border-opacity))}.dark\\:aria-disabled\\:bg-neutral-400[aria-disabled=true]:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(163 163 163 / var(--tw-bg-opacity))}.dark\\:aria-disabled\\:text-neutral-500[aria-disabled=true]:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(115 115 115 / var(--tw-text-opacity))}.dark\\:aria-disabled\\:text-neutral-600[aria-disabled=true]:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity))}.dark\\:aria-selected\\:border-neutral-600[aria-selected=true]:where([data-theme="dark"],[data-theme="dark"] *){--tw-border-opacity: 1;border-color:rgb(82 82 82 / var(--tw-border-opacity))}.dark\\:aria-selected\\:border-b-transparent[aria-selected=true]:where([data-theme="dark"],[data-theme="dark"] *){border-bottom-color:transparent}.dark\\:aria-selected\\:bg-transparent[aria-selected=true]:where([data-theme="dark"],[data-theme="dark"] *){background-color:transparent}.dark\\:data-\\[state\\=checked\\]\\:bg-neutral-900[data-state=checked]:where([data-theme="dark"],[data-theme="dark"] *){--tw-bg-opacity: 1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.dark\\:links\\:text-white a[href]:where([data-theme="dark"],[data-theme="dark"] *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark\\:links\\:decoration-neutral-500 a[href]:where([data-theme="dark"],[data-theme="dark"] *){text-decoration-color:#737373}.\\[\\&_\\>_\\:is\\(dt\\,dd\\)\\]\\:px-1>:is(dt,dd){padding-left:.25rem;padding-right:.25rem}.\\[\\&_\\>_dd\\]\\:text-right>dd{text-align:right}
`;
function MW(e) {
  return (t) => {
    e.forEach((r) => {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}
const ST = $.createContext(null);
function $W({ frame: e, children: t }) {
  if ($.useContext(ST))
    throw new Error("`FrameProvider` can only be used once.");
  return /* @__PURE__ */ ze.jsx(ST.Provider, { value: { frame: e }, children: t });
}
function $X() {
  const e = $.useContext(ST);
  if (!e)
    throw new Error("`useFrame` can only be used within a `FrameProvider`.");
  return e;
}
function LW() {
  const { theme: e } = Iu(), t = DH("(prefers-color-scheme: dark)");
  return e ?? (t ? "dark" : "light");
}
function NW({
  onSize: e,
  ...t
}) {
  const r = $.useRef(null);
  return LH({ ref: r, onResize: e }), /* @__PURE__ */ ze.jsx("div", { ref: r, ...t, style: { ...t.style, display: "inline-block" } });
}
const NE = $.forwardRef(function({ mode: t, children: r }, o) {
  const l = $.useRef(null), [d, f] = $.useState(!1), m = d ? l.current : null, [v, w] = $.useState({
    width: void 0,
    height: void 0
  }), x = m == null ? void 0 : m.contentDocument, b = LW();
  $.useEffect(() => {
    x && x.body.setAttribute("data-theme", b);
  }, [x, b]);
  const k = t === "modal" ? {
    all: "unset",
    display: "block",
    position: "fixed",
    inset: "0",
    width: "100vw",
    height: "100vh",
    zIndex: "2147483646"
  } : v.width && v.height ? {
    all: "unset",
    display: "inline-block",
    width: `${v.width}px`,
    height: `${v.height}px`
  } : {
    all: "unset",
    display: "block",
    position: "fixed",
    inset: "0",
    width: "100vw",
    height: "100vh",
    opacity: 0,
    pointerEvents: "none"
  };
  return /* @__PURE__ */ ze.jsx(
    "iframe",
    {
      ref: MW([o, l]),
      style: k,
      onLoad: () => f(!0),
      srcDoc: "<!doctype html><title>…</title>",
      children: x ? IT.createPortal(
        /* @__PURE__ */ ze.jsxs($W, { frame: m, children: [
          /* @__PURE__ */ ze.jsx("div", { children: t === "modal" ? r : /* @__PURE__ */ ze.jsx(NW, { onSize: w, children: r }) }),
          /* @__PURE__ */ ze.jsx("style", { dangerouslySetInnerHTML: { __html: IW } })
        ] }),
        x.body
      ) : null
    }
  );
});
function FW() {
  for (var e = 0, t, r, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (r = W5(t)) && (o && (o += " "), o += r);
  return o;
}
function W5(e) {
  if (typeof e == "string")
    return e;
  for (var t, r = "", o = 0; o < e.length; o++)
    e[o] && (t = W5(e[o])) && (r && (r += " "), r += t);
  return r;
}
var B3 = "-";
function zW(e) {
  var t = UW(e), r = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, l = o === void 0 ? {} : o;
  function d(m) {
    var v = m.split(B3);
    return v[0] === "" && v.length !== 1 && v.shift(), Y5(v, t) || BW(m);
  }
  function f(m, v) {
    var w = r[m] || [];
    return v && l[m] ? [].concat(w, l[m]) : w;
  }
  return {
    getClassGroupId: d,
    getConflictingClassGroupIds: f
  };
}
function Y5(e, t) {
  var f;
  if (e.length === 0)
    return t.classGroupId;
  var r = e[0], o = t.nextPart.get(r), l = o ? Y5(e.slice(1), o) : void 0;
  if (l)
    return l;
  if (t.validators.length !== 0) {
    var d = e.join(B3);
    return (f = t.validators.find(function(m) {
      var v = m.validator;
      return v(d);
    })) == null ? void 0 : f.classGroupId;
  }
}
var uj = /^\[(.+)\]$/;
function BW(e) {
  if (uj.test(e)) {
    var t = uj.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function UW(e) {
  var t = e.theme, r = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, l = VW(Object.entries(e.classGroups), r);
  return l.forEach(function(d) {
    var f = d[0], m = d[1];
    kT(m, o, f, t);
  }), o;
}
function kT(e, t, r, o) {
  e.forEach(function(l) {
    if (typeof l == "string") {
      var d = l === "" ? t : lj(t, l);
      d.classGroupId = r;
      return;
    }
    if (typeof l == "function") {
      if (HW(l)) {
        kT(l(o), t, r, o);
        return;
      }
      t.validators.push({
        validator: l,
        classGroupId: r
      });
      return;
    }
    Object.entries(l).forEach(function(f) {
      var m = f[0], v = f[1];
      kT(v, lj(t, m), r, o);
    });
  });
}
function lj(e, t) {
  var r = e;
  return t.split(B3).forEach(function(o) {
    r.nextPart.has(o) || r.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(o);
  }), r;
}
function HW(e) {
  return e.isThemeGetter;
}
function VW(e, t) {
  return t ? e.map(function(r) {
    var o = r[0], l = r[1], d = l.map(function(f) {
      return typeof f == "string" ? t + f : typeof f == "object" ? Object.fromEntries(Object.entries(f).map(function(m) {
        var v = m[0], w = m[1];
        return [t + v, w];
      })) : f;
    });
    return [o, d];
  }) : e;
}
function GW(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function l(d, f) {
    r.set(d, f), t++, t > e && (t = 0, o = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get: function(f) {
      var m = r.get(f);
      if (m !== void 0)
        return m;
      if ((m = o.get(f)) !== void 0)
        return l(f, m), m;
    },
    set: function(f, m) {
      r.has(f) ? r.set(f, m) : l(f, m);
    }
  };
}
var Z5 = "!";
function qW(e) {
  var t = e.separator || ":", r = t.length === 1, o = t[0], l = t.length;
  return function(f) {
    for (var m = [], v = 0, w = 0, x, b = 0; b < f.length; b++) {
      var k = f[b];
      if (v === 0) {
        if (k === o && (r || f.slice(b, b + l) === t)) {
          m.push(f.slice(w, b)), w = b + l;
          continue;
        }
        if (k === "/") {
          x = b;
          continue;
        }
      }
      k === "[" ? v++ : k === "]" && v--;
    }
    var T = m.length === 0 ? f : f.substring(w), O = T.startsWith(Z5), R = O ? T.substring(1) : T, j = x && x > w ? x - w : void 0;
    return {
      modifiers: m,
      hasImportantModifier: O,
      baseClassName: R,
      maybePostfixModifierPosition: j
    };
  };
}
function WW(e) {
  if (e.length <= 1)
    return e;
  var t = [], r = [];
  return e.forEach(function(o) {
    var l = o[0] === "[";
    l ? (t.push.apply(t, r.sort().concat([o])), r = []) : r.push(o);
  }), t.push.apply(t, r.sort()), t;
}
function YW(e) {
  return {
    cache: GW(e.cacheSize),
    splitModifiers: qW(e),
    ...zW(e)
  };
}
var ZW = /\s+/;
function KW(e, t) {
  var r = t.splitModifiers, o = t.getClassGroupId, l = t.getConflictingClassGroupIds, d = /* @__PURE__ */ new Set();
  return e.trim().split(ZW).map(function(f) {
    var m = r(f), v = m.modifiers, w = m.hasImportantModifier, x = m.baseClassName, b = m.maybePostfixModifierPosition, k = o(b ? x.substring(0, b) : x), T = !!b;
    if (!k) {
      if (!b)
        return {
          isTailwindClass: !1,
          originalClassName: f
        };
      if (k = o(x), !k)
        return {
          isTailwindClass: !1,
          originalClassName: f
        };
      T = !1;
    }
    var O = WW(v).join(":"), R = w ? O + Z5 : O;
    return {
      isTailwindClass: !0,
      modifierId: R,
      classGroupId: k,
      originalClassName: f,
      hasPostfixModifier: T
    };
  }).reverse().filter(function(f) {
    if (!f.isTailwindClass)
      return !0;
    var m = f.modifierId, v = f.classGroupId, w = f.hasPostfixModifier, x = m + v;
    return d.has(x) ? !1 : (d.add(x), l(v, w).forEach(function(b) {
      return d.add(m + b);
    }), !0);
  }).reverse().map(function(f) {
    return f.originalClassName;
  }).join(" ");
}
function QW() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var o, l, d, f = m;
  function m(w) {
    var x = t[0], b = t.slice(1), k = b.reduce(function(T, O) {
      return O(T);
    }, x());
    return o = YW(k), l = o.cache.get, d = o.cache.set, f = v, v(w);
  }
  function v(w) {
    var x = l(w);
    if (x)
      return x;
    var b = KW(w, o);
    return d(w, b), b;
  }
  return function() {
    return f(FW.apply(null, arguments));
  };
}
function Xn(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var K5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, XW = /^\d+\/\d+$/, JW = /* @__PURE__ */ new Set(["px", "full", "screen"]), eY = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, tY = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))/, nY = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function gs(e) {
  return Df(e) || JW.has(e) || XW.test(e) || nd(e);
}
function nd(e) {
  return tp(e, "length", uY);
}
function rY(e) {
  return tp(e, "size", Q5);
}
function aY(e) {
  return tp(e, "position", Q5);
}
function iY(e) {
  return tp(e, "url", lY);
}
function v1(e) {
  return tp(e, "number", Df);
}
function Df(e) {
  return !Number.isNaN(Number(e));
}
function oY(e) {
  return e.endsWith("%") && Df(e.slice(0, -1));
}
function Wv(e) {
  return cj(e) || tp(e, "number", cj);
}
function Sr(e) {
  return K5.test(e);
}
function Yv() {
  return !0;
}
function ed(e) {
  return eY.test(e);
}
function sY(e) {
  return tp(e, "", cY);
}
function tp(e, t, r) {
  var o = K5.exec(e);
  return o ? o[1] ? o[1] === t : r(o[2]) : !1;
}
function uY(e) {
  return tY.test(e);
}
function Q5() {
  return !1;
}
function lY(e) {
  return e.startsWith("url(");
}
function cj(e) {
  return Number.isInteger(Number(e));
}
function cY(e) {
  return nY.test(e);
}
function dY() {
  var e = Xn("colors"), t = Xn("spacing"), r = Xn("blur"), o = Xn("brightness"), l = Xn("borderColor"), d = Xn("borderRadius"), f = Xn("borderSpacing"), m = Xn("borderWidth"), v = Xn("contrast"), w = Xn("grayscale"), x = Xn("hueRotate"), b = Xn("invert"), k = Xn("gap"), T = Xn("gradientColorStops"), O = Xn("gradientColorStopPositions"), R = Xn("inset"), j = Xn("margin"), I = Xn("opacity"), N = Xn("padding"), L = Xn("saturate"), B = Xn("scale"), H = Xn("sepia"), V = Xn("skew"), W = Xn("space"), Y = Xn("translate"), ce = function() {
    return ["auto", "contain", "none"];
  }, ve = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, Se = function() {
    return ["auto", t];
  }, De = function() {
    return ["", gs];
  }, Re = function() {
    return ["auto", Df, Sr];
  }, Pe = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, se = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, ge = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, de = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, pe = function() {
    return ["", "0", Sr];
  }, fe = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, z = function() {
    return [Df, v1];
  }, oe = function() {
    return [Df, Sr];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Yv],
      spacing: [gs],
      blur: ["none", "", ed, nd],
      brightness: z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ed, nd],
      borderSpacing: [t],
      borderWidth: De(),
      contrast: z(),
      grayscale: pe(),
      hueRotate: oe(),
      invert: pe(),
      gap: [t],
      gradientColorStops: [e],
      gradientColorStopPositions: [oY, nd],
      inset: Se(),
      margin: Se(),
      opacity: z(),
      padding: [t],
      saturate: z(),
      scale: z(),
      sepia: pe(),
      skew: oe(),
      space: [t],
      translate: [t]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Sr]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ed]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": fe()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": fe()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(Pe(), [Sr])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: ve()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": ve()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": ve()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: ce()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": ce()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": ce()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [R]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [R]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [R]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [R]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [R]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [R]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [R]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [R]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [R]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Wv]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [t]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Sr]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: pe()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: pe()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Wv]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Yv]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [Wv]
        }, Sr]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Re()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Re()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Yv]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Wv]
        }, Sr]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Re()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Re()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Sr]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Sr]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [k]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [k]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [k]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(de())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(de(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(de(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [N]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [N]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [N]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [N]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [N]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [N]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [N]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [N]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [N]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [j]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [j]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [j]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [j]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [j]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [j]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [j]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [j]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [j]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [W]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [W]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", gs]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [ed]
        }, ed, nd]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", gs]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ed, nd]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", v1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Yv]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", nd]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Df, v1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", gs]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Sr]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Sr]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [I]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [I]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(se(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", gs]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", gs]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [t]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", nd]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Sr]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [I]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(Pe(), [aY])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", rY]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, iY]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [O]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [O]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [O]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [T]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [T]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [T]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [d]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [d]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [d]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [d]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [d]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [d]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [d]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [d]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [d]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [d]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [d]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [d]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [d]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [d]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [d]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [m]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [m]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [m]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [m]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [m]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [m]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [m]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [m]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [m]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [I]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(se(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [m]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [m]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [I]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: se()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [l]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [l]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [l]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [l]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [l]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [l]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [l]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [l]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(se())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [gs]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [gs]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: De()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [I]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [gs]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ed, sY]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Yv]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [I]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": ge()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ge()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [v]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ed, Sr]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [w]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [x]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [b]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [L]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [H]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [v]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [w]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [x]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [b]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [I]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [L]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [H]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [f]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [f]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [f]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Sr]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: oe()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Sr]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: oe()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Sr]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [B]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [B]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [B]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Wv, Sr]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [Y]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [Y]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [V]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [V]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Sr]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Sr]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [t]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [t]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [t]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [t]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [t]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [t]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [t]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [t]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [t]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [t]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [t]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [t]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [t]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [t]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [t]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [t]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [t]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [t]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Sr]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [gs, v1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var aa = /* @__PURE__ */ QW(dY);
function X5({ className: e, ...t }) {
  return /* @__PURE__ */ ze.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 8 8",
      fill: "currentColor",
      shapeRendering: "crispEdges",
      className: aa("-my-[0.125em] h-[1.25em] w-[1.25em]", e),
      ...t,
      children: [
        /* @__PURE__ */ ze.jsx("path", { d: "M0 0h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm0 1h1v1H0zm1 0h1v1H1zm1 0h1v1H2zm1 0h1v1H3zm1 0h1v1H4zm1 0h1v1H5zm2-1h1v1H7zm0 1h1v1H7zM6 7h1v1H6zm1-2h1v1H7zm0-1h1v1H7zm0-1h1v1H7z" }),
        /* @__PURE__ */ ze.jsx(
          "path",
          {
            d: "M2 2h1v1H2zm0 1h1v1H2zm0 1h1v1H2zm0 1h1v1H2zm1-3h1v1H3zm1 0h1v1H4zm1 0h1v1H5zm0 1h1v1H5zm0 1h1v1H5zm0 1h1v1H5zM4 5h1v1H4zM3 5h1v1H3z",
            opacity: ".5"
          }
        ),
        /* @__PURE__ */ ze.jsx("path", { d: "M7 2h1v1H7zm0-1h1v1H7zM1 0h1v1H1zm1 0h1v1H2zm1 0h1v1H3zm1 0h1v1H4zm1 0h1v1H5zm1 0h1v1H6zm1 0h1v1H7z" })
      ]
    }
  );
}
function _n() {
  return _n = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, _n.apply(this, arguments);
}
function Un(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(l) {
    if (e == null || e(l), r === !1 || !l.defaultPrevented)
      return t == null ? void 0 : t(l);
  };
}
function fY(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function U3(...e) {
  return (t) => e.forEach(
    (r) => fY(r, t)
  );
}
function Fo(...e) {
  return $.useCallback(U3(...e), e);
}
function w0(e, t = []) {
  let r = [];
  function o(d, f) {
    const m = /* @__PURE__ */ $.createContext(f), v = r.length;
    r = [
      ...r,
      f
    ];
    function w(b) {
      const { scope: k, children: T, ...O } = b, R = (k == null ? void 0 : k[e][v]) || m, j = $.useMemo(
        () => O,
        Object.values(O)
      );
      return /* @__PURE__ */ $.createElement(R.Provider, {
        value: j
      }, T);
    }
    function x(b, k) {
      const T = (k == null ? void 0 : k[e][v]) || m, O = $.useContext(T);
      if (O)
        return O;
      if (f !== void 0)
        return f;
      throw new Error(`\`${b}\` must be used within \`${d}\``);
    }
    return w.displayName = d + "Provider", [
      w,
      x
    ];
  }
  const l = () => {
    const d = r.map((f) => /* @__PURE__ */ $.createContext(f));
    return function(m) {
      const v = (m == null ? void 0 : m[e]) || d;
      return $.useMemo(
        () => ({
          [`__scope${e}`]: {
            ...m,
            [e]: v
          }
        }),
        [
          m,
          v
        ]
      );
    };
  };
  return l.scopeName = e, [
    o,
    pY(l, ...t)
  ];
}
function pY(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const r = () => {
    const o = e.map(
      (l) => ({
        useScope: l(),
        scopeName: l.scopeName
      })
    );
    return function(d) {
      const f = o.reduce((m, { useScope: v, scopeName: w }) => {
        const b = v(d)[`__scope${w}`];
        return {
          ...m,
          ...b
        };
      }, {});
      return $.useMemo(
        () => ({
          [`__scope${t.scopeName}`]: f
        }),
        [
          f
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function ju(e) {
  const t = $.useRef(e);
  return $.useEffect(() => {
    t.current = e;
  }), $.useMemo(
    () => (...r) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...r);
    },
    []
  );
}
function J5({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [o, l] = hY({
    defaultProp: t,
    onChange: r
  }), d = e !== void 0, f = d ? e : o, m = ju(r), v = $.useCallback((w) => {
    if (d) {
      const b = typeof w == "function" ? w(e) : w;
      b !== e && m(b);
    } else
      l(w);
  }, [
    d,
    e,
    l,
    m
  ]);
  return [
    f,
    v
  ];
}
function hY({ defaultProp: e, onChange: t }) {
  const r = $.useState(e), [o] = r, l = $.useRef(o), d = ju(t);
  return $.useEffect(() => {
    l.current !== o && (d(o), l.current = o);
  }, [
    o,
    l,
    d
  ]), r;
}
const zg = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { children: r, ...o } = e, l = $.Children.toArray(r), d = l.find(yY);
  if (d) {
    const f = d.props.children, m = l.map((v) => v === d ? $.Children.count(f) > 1 ? $.Children.only(null) : /* @__PURE__ */ $.isValidElement(f) ? f.props.children : null : v);
    return /* @__PURE__ */ $.createElement(ET, _n({}, o, {
      ref: t
    }), /* @__PURE__ */ $.isValidElement(f) ? /* @__PURE__ */ $.cloneElement(f, void 0, m) : null);
  }
  return /* @__PURE__ */ $.createElement(ET, _n({}, o, {
    ref: t
  }), r);
});
zg.displayName = "Slot";
const ET = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { children: r, ...o } = e;
  return /* @__PURE__ */ $.isValidElement(r) ? /* @__PURE__ */ $.cloneElement(r, {
    ...vY(o, r.props),
    ref: t ? U3(t, r.ref) : r.ref
  }) : $.Children.count(r) > 1 ? $.Children.only(null) : null;
});
ET.displayName = "SlotClone";
const mY = ({ children: e }) => /* @__PURE__ */ $.createElement($.Fragment, null, e);
function yY(e) {
  return /* @__PURE__ */ $.isValidElement(e) && e.type === mY;
}
function vY(e, t) {
  const r = {
    ...t
  };
  for (const o in t) {
    const l = e[o], d = t[o];
    /^on[A-Z]/.test(o) ? l && d ? r[o] = (...m) => {
      d(...m), l(...m);
    } : l && (r[o] = l) : o === "style" ? r[o] = {
      ...l,
      ...d
    } : o === "className" && (r[o] = [
      l,
      d
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const gY = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Hl = gY.reduce((e, t) => {
  const r = /* @__PURE__ */ $.forwardRef((o, l) => {
    const { asChild: d, ...f } = o, m = d ? zg : t;
    return $.useEffect(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ $.createElement(m, _n({}, f, {
      ref: l
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function eI(e, t) {
  e && X1.flushSync(
    () => e.dispatchEvent(t)
  );
}
function tI(e) {
  const t = e + "CollectionProvider", [r, o] = w0(t), [l, d] = r(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), f = (T) => {
    const { scope: O, children: R } = T, j = jo.useRef(null), I = jo.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ jo.createElement(l, {
      scope: O,
      itemMap: I,
      collectionRef: j
    }, R);
  }, m = e + "CollectionSlot", v = /* @__PURE__ */ jo.forwardRef((T, O) => {
    const { scope: R, children: j } = T, I = d(m, R), N = Fo(O, I.collectionRef);
    return /* @__PURE__ */ jo.createElement(zg, {
      ref: N
    }, j);
  }), w = e + "CollectionItemSlot", x = "data-radix-collection-item", b = /* @__PURE__ */ jo.forwardRef((T, O) => {
    const { scope: R, children: j, ...I } = T, N = jo.useRef(null), L = Fo(O, N), B = d(w, R);
    return jo.useEffect(() => (B.itemMap.set(N, {
      ref: N,
      ...I
    }), () => void B.itemMap.delete(N))), /* @__PURE__ */ jo.createElement(zg, {
      [x]: "",
      ref: L
    }, j);
  });
  function k(T) {
    const O = d(e + "CollectionConsumer", T);
    return jo.useCallback(() => {
      const j = O.collectionRef.current;
      if (!j)
        return [];
      const I = Array.from(j.querySelectorAll(`[${x}]`));
      return Array.from(O.itemMap.values()).sort(
        (B, H) => I.indexOf(B.ref.current) - I.indexOf(H.ref.current)
      );
    }, [
      O.collectionRef,
      O.itemMap
    ]);
  }
  return [
    {
      Provider: f,
      Slot: v,
      ItemSlot: b
    },
    k,
    o
  ];
}
const bY = /* @__PURE__ */ $.createContext(void 0);
function nI(e) {
  const t = $.useContext(bY);
  return e || t || "ltr";
}
function wY(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = ju(e);
  $.useEffect(() => {
    const o = (l) => {
      l.key === "Escape" && r(l);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    r,
    t
  ]);
}
const CT = "dismissableLayer.update", xY = "dismissableLayer.pointerDownOutside", SY = "dismissableLayer.focusOutside";
let dj;
const kY = /* @__PURE__ */ $.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), EY = /* @__PURE__ */ $.forwardRef((e, t) => {
  var r;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: l, onPointerDownOutside: d, onFocusOutside: f, onInteractOutside: m, onDismiss: v, ...w } = e, x = $.useContext(kY), [b, k] = $.useState(null), T = (r = b == null ? void 0 : b.ownerDocument) !== null && r !== void 0 ? r : globalThis == null ? void 0 : globalThis.document, [, O] = $.useState({}), R = Fo(
    t,
    (Y) => k(Y)
  ), j = Array.from(x.layers), [I] = [
    ...x.layersWithOutsidePointerEventsDisabled
  ].slice(-1), N = j.indexOf(I), L = b ? j.indexOf(b) : -1, B = x.layersWithOutsidePointerEventsDisabled.size > 0, H = L >= N, V = CY((Y) => {
    const ce = Y.target, ve = [
      ...x.branches
    ].some(
      (Se) => Se.contains(ce)
    );
    !H || ve || (d == null || d(Y), m == null || m(Y), Y.defaultPrevented || v == null || v());
  }, T), W = TY((Y) => {
    const ce = Y.target;
    [
      ...x.branches
    ].some(
      (Se) => Se.contains(ce)
    ) || (f == null || f(Y), m == null || m(Y), Y.defaultPrevented || v == null || v());
  }, T);
  return wY((Y) => {
    L === x.layers.size - 1 && (l == null || l(Y), !Y.defaultPrevented && v && (Y.preventDefault(), v()));
  }, T), $.useEffect(() => {
    if (b)
      return o && (x.layersWithOutsidePointerEventsDisabled.size === 0 && (dj = T.body.style.pointerEvents, T.body.style.pointerEvents = "none"), x.layersWithOutsidePointerEventsDisabled.add(b)), x.layers.add(b), fj(), () => {
        o && x.layersWithOutsidePointerEventsDisabled.size === 1 && (T.body.style.pointerEvents = dj);
      };
  }, [
    b,
    T,
    o,
    x
  ]), $.useEffect(() => () => {
    b && (x.layers.delete(b), x.layersWithOutsidePointerEventsDisabled.delete(b), fj());
  }, [
    b,
    x
  ]), $.useEffect(() => {
    const Y = () => O({});
    return document.addEventListener(CT, Y), () => document.removeEventListener(CT, Y);
  }, []), /* @__PURE__ */ $.createElement(Hl.div, _n({}, w, {
    ref: R,
    style: {
      pointerEvents: B ? H ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Un(e.onFocusCapture, W.onFocusCapture),
    onBlurCapture: Un(e.onBlurCapture, W.onBlurCapture),
    onPointerDownCapture: Un(e.onPointerDownCapture, V.onPointerDownCapture)
  }));
});
function CY(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = ju(e), o = $.useRef(!1), l = $.useRef(() => {
  });
  return $.useEffect(() => {
    const d = (m) => {
      if (m.target && !o.current) {
        let w = function() {
          rI(xY, r, v, {
            discrete: !0
          });
        };
        const v = {
          originalEvent: m
        };
        m.pointerType === "touch" ? (t.removeEventListener("click", l.current), l.current = w, t.addEventListener("click", l.current, {
          once: !0
        })) : w();
      } else
        t.removeEventListener("click", l.current);
      o.current = !1;
    }, f = window.setTimeout(() => {
      t.addEventListener("pointerdown", d);
    }, 0);
    return () => {
      window.clearTimeout(f), t.removeEventListener("pointerdown", d), t.removeEventListener("click", l.current);
    };
  }, [
    t,
    r
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function TY(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = ju(e), o = $.useRef(!1);
  return $.useEffect(() => {
    const l = (d) => {
      d.target && !o.current && rI(SY, r, {
        originalEvent: d
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", l), () => t.removeEventListener("focusin", l);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function fj() {
  const e = new CustomEvent(CT);
  document.dispatchEvent(e);
}
function rI(e, t, r, { discrete: o }) {
  const l = r.originalEvent.target, d = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && l.addEventListener(e, t, {
    once: !0
  }), o ? eI(l, d) : l.dispatchEvent(d);
}
let FE = 0;
function _Y() {
  $.useEffect(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : pj()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : pj()), FE++, () => {
      FE === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), FE--;
    };
  }, []);
}
function pj() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const zE = "focusScope.autoFocusOnMount", BE = "focusScope.autoFocusOnUnmount", hj = {
  bubbles: !1,
  cancelable: !0
}, RY = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { loop: r = !1, trapped: o = !1, onMountAutoFocus: l, onUnmountAutoFocus: d, ...f } = e, [m, v] = $.useState(null), w = ju(l), x = ju(d), b = $.useRef(null), k = Fo(
    t,
    (R) => v(R)
  ), T = $.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  $.useEffect(() => {
    if (o) {
      let R = function(L) {
        if (T.paused || !m)
          return;
        const B = L.target;
        m.contains(B) ? b.current = B : rd(b.current, {
          select: !0
        });
      }, j = function(L) {
        if (T.paused || !m)
          return;
        const B = L.relatedTarget;
        B !== null && (m.contains(B) || rd(b.current, {
          select: !0
        }));
      }, I = function(L) {
        if (document.activeElement === document.body)
          for (const H of L)
            H.removedNodes.length > 0 && rd(m);
      };
      document.addEventListener("focusin", R), document.addEventListener("focusout", j);
      const N = new MutationObserver(I);
      return m && N.observe(m, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", R), document.removeEventListener("focusout", j), N.disconnect();
      };
    }
  }, [
    o,
    m,
    T.paused
  ]), $.useEffect(() => {
    if (m) {
      yj.add(T);
      const R = document.activeElement;
      if (!m.contains(R)) {
        const I = new CustomEvent(zE, hj);
        m.addEventListener(zE, w), m.dispatchEvent(I), I.defaultPrevented || (OY(IY(aI(m)), {
          select: !0
        }), document.activeElement === R && rd(m));
      }
      return () => {
        m.removeEventListener(zE, w), setTimeout(() => {
          const I = new CustomEvent(BE, hj);
          m.addEventListener(BE, x), m.dispatchEvent(I), I.defaultPrevented || rd(R ?? document.body, {
            select: !0
          }), m.removeEventListener(BE, x), yj.remove(T);
        }, 0);
      };
    }
  }, [
    m,
    w,
    x,
    T
  ]);
  const O = $.useCallback((R) => {
    if (!r && !o || T.paused)
      return;
    const j = R.key === "Tab" && !R.altKey && !R.ctrlKey && !R.metaKey, I = document.activeElement;
    if (j && I) {
      const N = R.currentTarget, [L, B] = PY(N);
      L && B ? !R.shiftKey && I === B ? (R.preventDefault(), r && rd(L, {
        select: !0
      })) : R.shiftKey && I === L && (R.preventDefault(), r && rd(B, {
        select: !0
      })) : I === N && R.preventDefault();
    }
  }, [
    r,
    o,
    T.paused
  ]);
  return /* @__PURE__ */ $.createElement(Hl.div, _n({
    tabIndex: -1
  }, f, {
    ref: k,
    onKeyDown: O
  }));
});
function OY(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const o of e)
    if (rd(o, {
      select: t
    }), document.activeElement !== r)
      return;
}
function PY(e) {
  const t = aI(e), r = mj(t, e), o = mj(t.reverse(), e);
  return [
    r,
    o
  ];
}
function aI(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const l = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || l ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); )
    t.push(r.currentNode);
  return t;
}
function mj(e, t) {
  for (const r of e)
    if (!jY(r, {
      upTo: t
    }))
      return r;
}
function jY(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function AY(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function rd(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && AY(e) && t && e.select();
  }
}
const yj = DY();
function DY() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = vj(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = vj(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function vj(e, t) {
  const r = [
    ...e
  ], o = r.indexOf(t);
  return o !== -1 && r.splice(o, 1), r;
}
function IY(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const xm = globalThis != null && globalThis.document ? $.useLayoutEffect : () => {
}, MY = Vj["useId".toString()] || (() => {
});
let $Y = 0;
function TT(e) {
  const [t, r] = $.useState(MY());
  return xm(() => {
    e || r(
      (o) => o ?? String($Y++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const LY = ["top", "right", "bottom", "left"], _u = Math.min, eo = Math.max, W1 = Math.round, g1 = Math.floor, wd = (e) => ({
  x: e,
  y: e
}), NY = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, FY = {
  start: "end",
  end: "start"
};
function _T(e, t, r) {
  return eo(e, _u(t, r));
}
function zl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Bl(e) {
  return e.split("-")[0];
}
function Om(e) {
  return e.split("-")[1];
}
function H3(e) {
  return e === "x" ? "y" : "x";
}
function V3(e) {
  return e === "y" ? "height" : "width";
}
function Pm(e) {
  return ["top", "bottom"].includes(Bl(e)) ? "y" : "x";
}
function G3(e) {
  return H3(Pm(e));
}
function zY(e, t, r) {
  r === void 0 && (r = !1);
  const o = Om(e), l = G3(e), d = V3(l);
  let f = l === "x" ? o === (r ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[d] > t.floating[d] && (f = Y1(f)), [f, Y1(f)];
}
function BY(e) {
  const t = Y1(e);
  return [RT(e), t, RT(t)];
}
function RT(e) {
  return e.replace(/start|end/g, (t) => FY[t]);
}
function UY(e, t, r) {
  const o = ["left", "right"], l = ["right", "left"], d = ["top", "bottom"], f = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? l : o : t ? o : l;
    case "left":
    case "right":
      return t ? d : f;
    default:
      return [];
  }
}
function HY(e, t, r, o) {
  const l = Om(e);
  let d = UY(Bl(e), r === "start", o);
  return l && (d = d.map((f) => f + "-" + l), t && (d = d.concat(d.map(RT)))), d;
}
function Y1(e) {
  return e.replace(/left|right|bottom|top/g, (t) => NY[t]);
}
function VY(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function iI(e) {
  return typeof e != "number" ? VY(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Z1(e) {
  const {
    x: t,
    y: r,
    width: o,
    height: l
  } = e;
  return {
    width: o,
    height: l,
    top: r,
    left: t,
    right: t + o,
    bottom: r + l,
    x: t,
    y: r
  };
}
function gj(e, t, r) {
  let {
    reference: o,
    floating: l
  } = e;
  const d = Pm(t), f = G3(t), m = V3(f), v = Bl(t), w = d === "y", x = o.x + o.width / 2 - l.width / 2, b = o.y + o.height / 2 - l.height / 2, k = o[m] / 2 - l[m] / 2;
  let T;
  switch (v) {
    case "top":
      T = {
        x,
        y: o.y - l.height
      };
      break;
    case "bottom":
      T = {
        x,
        y: o.y + o.height
      };
      break;
    case "right":
      T = {
        x: o.x + o.width,
        y: b
      };
      break;
    case "left":
      T = {
        x: o.x - l.width,
        y: b
      };
      break;
    default:
      T = {
        x: o.x,
        y: o.y
      };
  }
  switch (Om(t)) {
    case "start":
      T[f] -= k * (r && w ? -1 : 1);
      break;
    case "end":
      T[f] += k * (r && w ? -1 : 1);
      break;
  }
  return T;
}
const GY = async (e, t, r) => {
  const {
    placement: o = "bottom",
    strategy: l = "absolute",
    middleware: d = [],
    platform: f
  } = r, m = d.filter(Boolean), v = await (f.isRTL == null ? void 0 : f.isRTL(t));
  let w = await f.getElementRects({
    reference: e,
    floating: t,
    strategy: l
  }), {
    x,
    y: b
  } = gj(w, o, v), k = o, T = {}, O = 0;
  for (let R = 0; R < m.length; R++) {
    const {
      name: j,
      fn: I
    } = m[R], {
      x: N,
      y: L,
      data: B,
      reset: H
    } = await I({
      x,
      y: b,
      initialPlacement: o,
      placement: k,
      strategy: l,
      middlewareData: T,
      rects: w,
      platform: f,
      elements: {
        reference: e,
        floating: t
      }
    });
    x = N ?? x, b = L ?? b, T = {
      ...T,
      [j]: {
        ...T[j],
        ...B
      }
    }, H && O <= 50 && (O++, typeof H == "object" && (H.placement && (k = H.placement), H.rects && (w = H.rects === !0 ? await f.getElementRects({
      reference: e,
      floating: t,
      strategy: l
    }) : H.rects), {
      x,
      y: b
    } = gj(w, k, v)), R = -1);
  }
  return {
    x,
    y: b,
    placement: k,
    strategy: l,
    middlewareData: T
  };
};
async function Bg(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: o,
    y: l,
    platform: d,
    rects: f,
    elements: m,
    strategy: v
  } = e, {
    boundary: w = "clippingAncestors",
    rootBoundary: x = "viewport",
    elementContext: b = "floating",
    altBoundary: k = !1,
    padding: T = 0
  } = zl(t, e), O = iI(T), j = m[k ? b === "floating" ? "reference" : "floating" : b], I = Z1(await d.getClippingRect({
    element: (r = await (d.isElement == null ? void 0 : d.isElement(j))) == null || r ? j : j.contextElement || await (d.getDocumentElement == null ? void 0 : d.getDocumentElement(m.floating)),
    boundary: w,
    rootBoundary: x,
    strategy: v
  })), N = b === "floating" ? {
    x: o,
    y: l,
    width: f.floating.width,
    height: f.floating.height
  } : f.reference, L = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(m.floating)), B = await (d.isElement == null ? void 0 : d.isElement(L)) ? await (d.getScale == null ? void 0 : d.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, H = Z1(d.convertOffsetParentRelativeRectToViewportRelativeRect ? await d.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: m,
    rect: N,
    offsetParent: L,
    strategy: v
  }) : N);
  return {
    top: (I.top - H.top + O.top) / B.y,
    bottom: (H.bottom - I.bottom + O.bottom) / B.y,
    left: (I.left - H.left + O.left) / B.x,
    right: (H.right - I.right + O.right) / B.x
  };
}
const qY = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: o,
      placement: l,
      rects: d,
      platform: f,
      elements: m,
      middlewareData: v
    } = t, {
      element: w,
      padding: x = 0
    } = zl(e, t) || {};
    if (w == null)
      return {};
    const b = iI(x), k = {
      x: r,
      y: o
    }, T = G3(l), O = V3(T), R = await f.getDimensions(w), j = T === "y", I = j ? "top" : "left", N = j ? "bottom" : "right", L = j ? "clientHeight" : "clientWidth", B = d.reference[O] + d.reference[T] - k[T] - d.floating[O], H = k[T] - d.reference[T], V = await (f.getOffsetParent == null ? void 0 : f.getOffsetParent(w));
    let W = V ? V[L] : 0;
    (!W || !await (f.isElement == null ? void 0 : f.isElement(V))) && (W = m.floating[L] || d.floating[O]);
    const Y = B / 2 - H / 2, ce = W / 2 - R[O] / 2 - 1, ve = _u(b[I], ce), Se = _u(b[N], ce), De = ve, Re = W - R[O] - Se, Pe = W / 2 - R[O] / 2 + Y, se = _T(De, Pe, Re), ge = !v.arrow && Om(l) != null && Pe !== se && d.reference[O] / 2 - (Pe < De ? ve : Se) - R[O] / 2 < 0, de = ge ? Pe < De ? Pe - De : Pe - Re : 0;
    return {
      [T]: k[T] + de,
      data: {
        [T]: se,
        centerOffset: Pe - se - de,
        ...ge && {
          alignmentOffset: de
        }
      },
      reset: ge
    };
  }
}), WY = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, o;
      const {
        placement: l,
        middlewareData: d,
        rects: f,
        initialPlacement: m,
        platform: v,
        elements: w
      } = t, {
        mainAxis: x = !0,
        crossAxis: b = !0,
        fallbackPlacements: k,
        fallbackStrategy: T = "bestFit",
        fallbackAxisSideDirection: O = "none",
        flipAlignment: R = !0,
        ...j
      } = zl(e, t);
      if ((r = d.arrow) != null && r.alignmentOffset)
        return {};
      const I = Bl(l), N = Bl(m) === m, L = await (v.isRTL == null ? void 0 : v.isRTL(w.floating)), B = k || (N || !R ? [Y1(m)] : BY(m));
      !k && O !== "none" && B.push(...HY(m, R, O, L));
      const H = [m, ...B], V = await Bg(t, j), W = [];
      let Y = ((o = d.flip) == null ? void 0 : o.overflows) || [];
      if (x && W.push(V[I]), b) {
        const De = zY(l, f, L);
        W.push(V[De[0]], V[De[1]]);
      }
      if (Y = [...Y, {
        placement: l,
        overflows: W
      }], !W.every((De) => De <= 0)) {
        var ce, ve;
        const De = (((ce = d.flip) == null ? void 0 : ce.index) || 0) + 1, Re = H[De];
        if (Re)
          return {
            data: {
              index: De,
              overflows: Y
            },
            reset: {
              placement: Re
            }
          };
        let Pe = (ve = Y.filter((se) => se.overflows[0] <= 0).sort((se, ge) => se.overflows[1] - ge.overflows[1])[0]) == null ? void 0 : ve.placement;
        if (!Pe)
          switch (T) {
            case "bestFit": {
              var Se;
              const se = (Se = Y.map((ge) => [ge.placement, ge.overflows.filter((de) => de > 0).reduce((de, pe) => de + pe, 0)]).sort((ge, de) => ge[1] - de[1])[0]) == null ? void 0 : Se[0];
              se && (Pe = se);
              break;
            }
            case "initialPlacement":
              Pe = m;
              break;
          }
        if (l !== Pe)
          return {
            reset: {
              placement: Pe
            }
          };
      }
      return {};
    }
  };
};
function bj(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function wj(e) {
  return LY.some((t) => e[t] >= 0);
}
const YY = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: o = "referenceHidden",
        ...l
      } = zl(e, t);
      switch (o) {
        case "referenceHidden": {
          const d = await Bg(t, {
            ...l,
            elementContext: "reference"
          }), f = bj(d, r.reference);
          return {
            data: {
              referenceHiddenOffsets: f,
              referenceHidden: wj(f)
            }
          };
        }
        case "escaped": {
          const d = await Bg(t, {
            ...l,
            altBoundary: !0
          }), f = bj(d, r.floating);
          return {
            data: {
              escapedOffsets: f,
              escaped: wj(f)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function ZY(e, t) {
  const {
    placement: r,
    platform: o,
    elements: l
  } = e, d = await (o.isRTL == null ? void 0 : o.isRTL(l.floating)), f = Bl(r), m = Om(r), v = Pm(r) === "y", w = ["left", "top"].includes(f) ? -1 : 1, x = d && v ? -1 : 1, b = zl(t, e);
  let {
    mainAxis: k,
    crossAxis: T,
    alignmentAxis: O
  } = typeof b == "number" ? {
    mainAxis: b,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...b
  };
  return m && typeof O == "number" && (T = m === "end" ? O * -1 : O), v ? {
    x: T * x,
    y: k * w
  } : {
    x: k * w,
    y: T * x
  };
}
const KY = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, o;
      const {
        x: l,
        y: d,
        placement: f,
        middlewareData: m
      } = t, v = await ZY(t, e);
      return f === ((r = m.offset) == null ? void 0 : r.placement) && (o = m.arrow) != null && o.alignmentOffset ? {} : {
        x: l + v.x,
        y: d + v.y,
        data: {
          ...v,
          placement: f
        }
      };
    }
  };
}, QY = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: o,
        placement: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !1,
        limiter: m = {
          fn: (j) => {
            let {
              x: I,
              y: N
            } = j;
            return {
              x: I,
              y: N
            };
          }
        },
        ...v
      } = zl(e, t), w = {
        x: r,
        y: o
      }, x = await Bg(t, v), b = Pm(Bl(l)), k = H3(b);
      let T = w[k], O = w[b];
      if (d) {
        const j = k === "y" ? "top" : "left", I = k === "y" ? "bottom" : "right", N = T + x[j], L = T - x[I];
        T = _T(N, T, L);
      }
      if (f) {
        const j = b === "y" ? "top" : "left", I = b === "y" ? "bottom" : "right", N = O + x[j], L = O - x[I];
        O = _T(N, O, L);
      }
      const R = m.fn({
        ...t,
        [k]: T,
        [b]: O
      });
      return {
        ...R,
        data: {
          x: R.x - r,
          y: R.y - o
        }
      };
    }
  };
}, XY = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: o,
        placement: l,
        rects: d,
        middlewareData: f
      } = t, {
        offset: m = 0,
        mainAxis: v = !0,
        crossAxis: w = !0
      } = zl(e, t), x = {
        x: r,
        y: o
      }, b = Pm(l), k = H3(b);
      let T = x[k], O = x[b];
      const R = zl(m, t), j = typeof R == "number" ? {
        mainAxis: R,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...R
      };
      if (v) {
        const L = k === "y" ? "height" : "width", B = d.reference[k] - d.floating[L] + j.mainAxis, H = d.reference[k] + d.reference[L] - j.mainAxis;
        T < B ? T = B : T > H && (T = H);
      }
      if (w) {
        var I, N;
        const L = k === "y" ? "width" : "height", B = ["top", "left"].includes(Bl(l)), H = d.reference[b] - d.floating[L] + (B && ((I = f.offset) == null ? void 0 : I[b]) || 0) + (B ? 0 : j.crossAxis), V = d.reference[b] + d.reference[L] + (B ? 0 : ((N = f.offset) == null ? void 0 : N[b]) || 0) - (B ? j.crossAxis : 0);
        O < H ? O = H : O > V && (O = V);
      }
      return {
        [k]: T,
        [b]: O
      };
    }
  };
}, JY = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: o,
        platform: l,
        elements: d
      } = t, {
        apply: f = () => {
        },
        ...m
      } = zl(e, t), v = await Bg(t, m), w = Bl(r), x = Om(r), b = Pm(r) === "y", {
        width: k,
        height: T
      } = o.floating;
      let O, R;
      w === "top" || w === "bottom" ? (O = w, R = x === (await (l.isRTL == null ? void 0 : l.isRTL(d.floating)) ? "start" : "end") ? "left" : "right") : (R = w, O = x === "end" ? "top" : "bottom");
      const j = T - v.top - v.bottom, I = k - v.left - v.right, N = _u(T - v[O], j), L = _u(k - v[R], I), B = !t.middlewareData.shift;
      let H = N, V = L;
      if (b ? V = x || B ? _u(L, I) : I : H = x || B ? _u(N, j) : j, B && !x) {
        const Y = eo(v.left, 0), ce = eo(v.right, 0), ve = eo(v.top, 0), Se = eo(v.bottom, 0);
        b ? V = k - 2 * (Y !== 0 || ce !== 0 ? Y + ce : eo(v.left, v.right)) : H = T - 2 * (ve !== 0 || Se !== 0 ? ve + Se : eo(v.top, v.bottom));
      }
      await f({
        ...t,
        availableWidth: V,
        availableHeight: H
      });
      const W = await l.getDimensions(d.floating);
      return k !== W.width || T !== W.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function jm(e) {
  return oI(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function no(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Vl(e) {
  var t;
  return (t = (oI(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function oI(e) {
  return e instanceof Node || e instanceof no(e).Node;
}
function Au(e) {
  return e instanceof Element || e instanceof no(e).Element;
}
function Du(e) {
  return e instanceof HTMLElement || e instanceof no(e).HTMLElement;
}
function xj(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof no(e).ShadowRoot;
}
function x0(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: o,
    display: l
  } = Os(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + r) && !["inline", "contents"].includes(l);
}
function eZ(e) {
  return ["table", "td", "th"].includes(jm(e));
}
function q3(e) {
  const t = W3(), r = Os(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (r.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (r.contain || "").includes(o));
}
function tZ(e) {
  let t = xd(e);
  for (; Du(t) && !Sm(t); ) {
    if (q3(t))
      return t;
    t = xd(t);
  }
  return null;
}
function W3() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Sm(e) {
  return ["html", "body", "#document"].includes(jm(e));
}
function Os(e) {
  return no(e).getComputedStyle(e);
}
function Px(e) {
  return Au(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function xd(e) {
  if (jm(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    xj(e) && e.host || // Fallback.
    Vl(e)
  );
  return xj(t) ? t.host : t;
}
function sI(e) {
  const t = xd(e);
  return Sm(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Du(t) && x0(t) ? t : sI(t);
}
function Ug(e, t, r) {
  var o;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const l = sI(e), d = l === ((o = e.ownerDocument) == null ? void 0 : o.body), f = no(l);
  return d ? t.concat(f, f.visualViewport || [], x0(l) ? l : [], f.frameElement && r ? Ug(f.frameElement) : []) : t.concat(l, Ug(l, [], r));
}
function uI(e) {
  const t = Os(e);
  let r = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const l = Du(e), d = l ? e.offsetWidth : r, f = l ? e.offsetHeight : o, m = W1(r) !== d || W1(o) !== f;
  return m && (r = d, o = f), {
    width: r,
    height: o,
    $: m
  };
}
function Y3(e) {
  return Au(e) ? e : e.contextElement;
}
function Jh(e) {
  const t = Y3(e);
  if (!Du(t))
    return wd(1);
  const r = t.getBoundingClientRect(), {
    width: o,
    height: l,
    $: d
  } = uI(t);
  let f = (d ? W1(r.width) : r.width) / o, m = (d ? W1(r.height) : r.height) / l;
  return (!f || !Number.isFinite(f)) && (f = 1), (!m || !Number.isFinite(m)) && (m = 1), {
    x: f,
    y: m
  };
}
const nZ = /* @__PURE__ */ wd(0);
function lI(e) {
  const t = no(e);
  return !W3() || !t.visualViewport ? nZ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function rZ(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== no(e) ? !1 : t;
}
function Xf(e, t, r, o) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const l = e.getBoundingClientRect(), d = Y3(e);
  let f = wd(1);
  t && (o ? Au(o) && (f = Jh(o)) : f = Jh(e));
  const m = rZ(d, r, o) ? lI(d) : wd(0);
  let v = (l.left + m.x) / f.x, w = (l.top + m.y) / f.y, x = l.width / f.x, b = l.height / f.y;
  if (d) {
    const k = no(d), T = o && Au(o) ? no(o) : o;
    let O = k, R = O.frameElement;
    for (; R && o && T !== O; ) {
      const j = Jh(R), I = R.getBoundingClientRect(), N = Os(R), L = I.left + (R.clientLeft + parseFloat(N.paddingLeft)) * j.x, B = I.top + (R.clientTop + parseFloat(N.paddingTop)) * j.y;
      v *= j.x, w *= j.y, x *= j.x, b *= j.y, v += L, w += B, O = no(R), R = O.frameElement;
    }
  }
  return Z1({
    width: x,
    height: b,
    x: v,
    y: w
  });
}
const aZ = [":popover-open", ":modal"];
function Z3(e) {
  return aZ.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function iZ(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: o,
    strategy: l
  } = e;
  const d = l === "fixed", f = Vl(o), m = t ? Z3(t.floating) : !1;
  if (o === f || m && d)
    return r;
  let v = {
    scrollLeft: 0,
    scrollTop: 0
  }, w = wd(1);
  const x = wd(0), b = Du(o);
  if ((b || !b && !d) && ((jm(o) !== "body" || x0(f)) && (v = Px(o)), Du(o))) {
    const k = Xf(o);
    w = Jh(o), x.x = k.x + o.clientLeft, x.y = k.y + o.clientTop;
  }
  return {
    width: r.width * w.x,
    height: r.height * w.y,
    x: r.x * w.x - v.scrollLeft * w.x + x.x,
    y: r.y * w.y - v.scrollTop * w.y + x.y
  };
}
function oZ(e) {
  return Array.from(e.getClientRects());
}
function cI(e) {
  return Xf(Vl(e)).left + Px(e).scrollLeft;
}
function sZ(e) {
  const t = Vl(e), r = Px(e), o = e.ownerDocument.body, l = eo(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), d = eo(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let f = -r.scrollLeft + cI(e);
  const m = -r.scrollTop;
  return Os(o).direction === "rtl" && (f += eo(t.clientWidth, o.clientWidth) - l), {
    width: l,
    height: d,
    x: f,
    y: m
  };
}
function uZ(e, t) {
  const r = no(e), o = Vl(e), l = r.visualViewport;
  let d = o.clientWidth, f = o.clientHeight, m = 0, v = 0;
  if (l) {
    d = l.width, f = l.height;
    const w = W3();
    (!w || w && t === "fixed") && (m = l.offsetLeft, v = l.offsetTop);
  }
  return {
    width: d,
    height: f,
    x: m,
    y: v
  };
}
function lZ(e, t) {
  const r = Xf(e, !0, t === "fixed"), o = r.top + e.clientTop, l = r.left + e.clientLeft, d = Du(e) ? Jh(e) : wd(1), f = e.clientWidth * d.x, m = e.clientHeight * d.y, v = l * d.x, w = o * d.y;
  return {
    width: f,
    height: m,
    x: v,
    y: w
  };
}
function Sj(e, t, r) {
  let o;
  if (t === "viewport")
    o = uZ(e, r);
  else if (t === "document")
    o = sZ(Vl(e));
  else if (Au(t))
    o = lZ(t, r);
  else {
    const l = lI(e);
    o = {
      ...t,
      x: t.x - l.x,
      y: t.y - l.y
    };
  }
  return Z1(o);
}
function dI(e, t) {
  const r = xd(e);
  return r === t || !Au(r) || Sm(r) ? !1 : Os(r).position === "fixed" || dI(r, t);
}
function cZ(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let o = Ug(e, [], !1).filter((m) => Au(m) && jm(m) !== "body"), l = null;
  const d = Os(e).position === "fixed";
  let f = d ? xd(e) : e;
  for (; Au(f) && !Sm(f); ) {
    const m = Os(f), v = q3(f);
    !v && m.position === "fixed" && (l = null), (d ? !v && !l : !v && m.position === "static" && !!l && ["absolute", "fixed"].includes(l.position) || x0(f) && !v && dI(e, f)) ? o = o.filter((x) => x !== f) : l = m, f = xd(f);
  }
  return t.set(e, o), o;
}
function dZ(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: o,
    strategy: l
  } = e;
  const f = [...r === "clippingAncestors" ? Z3(t) ? [] : cZ(t, this._c) : [].concat(r), o], m = f[0], v = f.reduce((w, x) => {
    const b = Sj(t, x, l);
    return w.top = eo(b.top, w.top), w.right = _u(b.right, w.right), w.bottom = _u(b.bottom, w.bottom), w.left = eo(b.left, w.left), w;
  }, Sj(t, m, l));
  return {
    width: v.right - v.left,
    height: v.bottom - v.top,
    x: v.left,
    y: v.top
  };
}
function fZ(e) {
  const {
    width: t,
    height: r
  } = uI(e);
  return {
    width: t,
    height: r
  };
}
function pZ(e, t, r) {
  const o = Du(t), l = Vl(t), d = r === "fixed", f = Xf(e, !0, d, t);
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const v = wd(0);
  if (o || !o && !d)
    if ((jm(t) !== "body" || x0(l)) && (m = Px(t)), o) {
      const b = Xf(t, !0, d, t);
      v.x = b.x + t.clientLeft, v.y = b.y + t.clientTop;
    } else
      l && (v.x = cI(l));
  const w = f.left + m.scrollLeft - v.x, x = f.top + m.scrollTop - v.y;
  return {
    x: w,
    y: x,
    width: f.width,
    height: f.height
  };
}
function UE(e) {
  return Os(e).position === "static";
}
function kj(e, t) {
  return !Du(e) || Os(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function fI(e, t) {
  const r = no(e);
  if (Z3(e))
    return r;
  if (!Du(e)) {
    let l = xd(e);
    for (; l && !Sm(l); ) {
      if (Au(l) && !UE(l))
        return l;
      l = xd(l);
    }
    return r;
  }
  let o = kj(e, t);
  for (; o && eZ(o) && UE(o); )
    o = kj(o, t);
  return o && Sm(o) && UE(o) && !q3(o) ? r : o || tZ(e) || r;
}
const hZ = async function(e) {
  const t = this.getOffsetParent || fI, r = this.getDimensions, o = await r(e.floating);
  return {
    reference: pZ(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function mZ(e) {
  return Os(e).direction === "rtl";
}
const yZ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iZ,
  getDocumentElement: Vl,
  getClippingRect: dZ,
  getOffsetParent: fI,
  getElementRects: hZ,
  getClientRects: oZ,
  getDimensions: fZ,
  getScale: Jh,
  isElement: Au,
  isRTL: mZ
};
function vZ(e, t) {
  let r = null, o;
  const l = Vl(e);
  function d() {
    var m;
    clearTimeout(o), (m = r) == null || m.disconnect(), r = null;
  }
  function f(m, v) {
    m === void 0 && (m = !1), v === void 0 && (v = 1), d();
    const {
      left: w,
      top: x,
      width: b,
      height: k
    } = e.getBoundingClientRect();
    if (m || t(), !b || !k)
      return;
    const T = g1(x), O = g1(l.clientWidth - (w + b)), R = g1(l.clientHeight - (x + k)), j = g1(w), N = {
      rootMargin: -T + "px " + -O + "px " + -R + "px " + -j + "px",
      threshold: eo(0, _u(1, v)) || 1
    };
    let L = !0;
    function B(H) {
      const V = H[0].intersectionRatio;
      if (V !== v) {
        if (!L)
          return f();
        V ? f(!1, V) : o = setTimeout(() => {
          f(!1, 1e-7);
        }, 1e3);
      }
      L = !1;
    }
    try {
      r = new IntersectionObserver(B, {
        ...N,
        // Handle <iframe>s
        root: l.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(B, N);
    }
    r.observe(e);
  }
  return f(!0), d;
}
function gZ(e, t, r, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: d = !0,
    elementResize: f = typeof ResizeObserver == "function",
    layoutShift: m = typeof IntersectionObserver == "function",
    animationFrame: v = !1
  } = o, w = Y3(e), x = l || d ? [...w ? Ug(w) : [], ...Ug(t)] : [];
  x.forEach((I) => {
    l && I.addEventListener("scroll", r, {
      passive: !0
    }), d && I.addEventListener("resize", r);
  });
  const b = w && m ? vZ(w, r) : null;
  let k = -1, T = null;
  f && (T = new ResizeObserver((I) => {
    let [N] = I;
    N && N.target === w && T && (T.unobserve(t), cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      var L;
      (L = T) == null || L.observe(t);
    })), r();
  }), w && !v && T.observe(w), T.observe(t));
  let O, R = v ? Xf(e) : null;
  v && j();
  function j() {
    const I = Xf(e);
    R && (I.x !== R.x || I.y !== R.y || I.width !== R.width || I.height !== R.height) && r(), R = I, O = requestAnimationFrame(j);
  }
  return r(), () => {
    var I;
    x.forEach((N) => {
      l && N.removeEventListener("scroll", r), d && N.removeEventListener("resize", r);
    }), b == null || b(), (I = T) == null || I.disconnect(), T = null, v && cancelAnimationFrame(O);
  };
}
const bZ = KY, wZ = QY, xZ = WY, SZ = JY, kZ = YY, Ej = qY, EZ = XY, CZ = (e, t, r) => {
  const o = /* @__PURE__ */ new Map(), l = {
    platform: yZ,
    ...r
  }, d = {
    ...l.platform,
    _c: o
  };
  return GY(e, t, {
    ...l,
    platform: d
  });
};
var _1 = typeof document < "u" ? $.useLayoutEffect : $.useEffect;
function K1(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, o, l;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length)
        return !1;
      for (o = r; o-- !== 0; )
        if (!K1(e[o], t[o]))
          return !1;
      return !0;
    }
    if (l = Object.keys(e), r = l.length, r !== Object.keys(t).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, l[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      const d = l[o];
      if (!(d === "_owner" && e.$$typeof) && !K1(e[d], t[d]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function pI(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Cj(e, t) {
  const r = pI(e);
  return Math.round(t * r) / r;
}
function Tj(e) {
  const t = $.useRef(e);
  return _1(() => {
    t.current = e;
  }), t;
}
function TZ(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: l,
    elements: {
      reference: d,
      floating: f
    } = {},
    transform: m = !0,
    whileElementsMounted: v,
    open: w
  } = e, [x, b] = $.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [k, T] = $.useState(o);
  K1(k, o) || T(o);
  const [O, R] = $.useState(null), [j, I] = $.useState(null), N = $.useCallback((de) => {
    de !== V.current && (V.current = de, R(de));
  }, []), L = $.useCallback((de) => {
    de !== W.current && (W.current = de, I(de));
  }, []), B = d || O, H = f || j, V = $.useRef(null), W = $.useRef(null), Y = $.useRef(x), ce = v != null, ve = Tj(v), Se = Tj(l), De = $.useCallback(() => {
    if (!V.current || !W.current)
      return;
    const de = {
      placement: t,
      strategy: r,
      middleware: k
    };
    Se.current && (de.platform = Se.current), CZ(V.current, W.current, de).then((pe) => {
      const fe = {
        ...pe,
        isPositioned: !0
      };
      Re.current && !K1(Y.current, fe) && (Y.current = fe, X1.flushSync(() => {
        b(fe);
      }));
    });
  }, [k, t, r, Se]);
  _1(() => {
    w === !1 && Y.current.isPositioned && (Y.current.isPositioned = !1, b((de) => ({
      ...de,
      isPositioned: !1
    })));
  }, [w]);
  const Re = $.useRef(!1);
  _1(() => (Re.current = !0, () => {
    Re.current = !1;
  }), []), _1(() => {
    if (B && (V.current = B), H && (W.current = H), B && H) {
      if (ve.current)
        return ve.current(B, H, De);
      De();
    }
  }, [B, H, De, ve, ce]);
  const Pe = $.useMemo(() => ({
    reference: V,
    floating: W,
    setReference: N,
    setFloating: L
  }), [N, L]), se = $.useMemo(() => ({
    reference: B,
    floating: H
  }), [B, H]), ge = $.useMemo(() => {
    const de = {
      position: r,
      left: 0,
      top: 0
    };
    if (!se.floating)
      return de;
    const pe = Cj(se.floating, x.x), fe = Cj(se.floating, x.y);
    return m ? {
      ...de,
      transform: "translate(" + pe + "px, " + fe + "px)",
      ...pI(se.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: pe,
      top: fe
    };
  }, [r, m, se.floating, x.x, x.y]);
  return $.useMemo(() => ({
    ...x,
    update: De,
    refs: Pe,
    elements: se,
    floatingStyles: ge
  }), [x, De, Pe, se, ge]);
}
const _Z = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: o,
        padding: l
      } = typeof e == "function" ? e(r) : e;
      return o && t(o) ? o.current != null ? Ej({
        element: o.current,
        padding: l
      }).fn(r) : {} : o ? Ej({
        element: o,
        padding: l
      }).fn(r) : {};
    }
  };
}, RZ = (e, t) => ({
  ...bZ(e),
  options: [e, t]
}), OZ = (e, t) => ({
  ...wZ(e),
  options: [e, t]
}), PZ = (e, t) => ({
  ...EZ(e),
  options: [e, t]
}), jZ = (e, t) => ({
  ...xZ(e),
  options: [e, t]
}), AZ = (e, t) => ({
  ...SZ(e),
  options: [e, t]
}), DZ = (e, t) => ({
  ...kZ(e),
  options: [e, t]
}), IZ = (e, t) => ({
  ..._Z(e),
  options: [e, t]
});
function MZ(e) {
  const [t, r] = $.useState(void 0);
  return xm(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((l) => {
        if (!Array.isArray(l) || !l.length)
          return;
        const d = l[0];
        let f, m;
        if ("borderBoxSize" in d) {
          const v = d.borderBoxSize, w = Array.isArray(v) ? v[0] : v;
          f = w.inlineSize, m = w.blockSize;
        } else
          f = e.offsetWidth, m = e.offsetHeight;
        r({
          width: f,
          height: m
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const hI = "Popper", [mI, yI] = w0(hI), [$Z, vI] = mI(hI), LZ = (e) => {
  const { __scopePopper: t, children: r } = e, [o, l] = $.useState(null);
  return /* @__PURE__ */ $.createElement($Z, {
    scope: t,
    anchor: o,
    onAnchorChange: l
  }, r);
}, NZ = "PopperAnchor", FZ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopePopper: r, virtualRef: o, ...l } = e, d = vI(NZ, r), f = $.useRef(null), m = Fo(t, f);
  return $.useEffect(() => {
    d.onAnchorChange((o == null ? void 0 : o.current) || f.current);
  }), o ? null : /* @__PURE__ */ $.createElement(Hl.div, _n({}, l, {
    ref: m
  }));
}), gI = "PopperContent", [zZ, LX] = mI(gI), BZ = /* @__PURE__ */ $.forwardRef((e, t) => {
  var r, o, l, d, f, m, v, w;
  const { __scopePopper: x, side: b = "bottom", sideOffset: k = 0, align: T = "center", alignOffset: O = 0, arrowPadding: R = 0, avoidCollisions: j = !0, collisionBoundary: I = [], collisionPadding: N = 0, sticky: L = "partial", hideWhenDetached: B = !1, updatePositionStrategy: H = "optimized", onPlaced: V, ...W } = e, Y = vI(gI, x), [ce, ve] = $.useState(null), Se = Fo(
    t,
    (gn) => ve(gn)
  ), [De, Re] = $.useState(null), Pe = MZ(De), se = (r = Pe == null ? void 0 : Pe.width) !== null && r !== void 0 ? r : 0, ge = (o = Pe == null ? void 0 : Pe.height) !== null && o !== void 0 ? o : 0, de = b + (T !== "center" ? "-" + T : ""), pe = typeof N == "number" ? N : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...N
  }, fe = Array.isArray(I) ? I : [
    I
  ], z = fe.length > 0, oe = {
    padding: pe,
    boundary: fe.filter(UZ),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: z
  }, { refs: ke, floatingStyles: Qe, placement: Xe, isPositioned: bt, middlewareData: at } = TZ({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: de,
    whileElementsMounted: (...gn) => gZ(...gn, {
      animationFrame: H === "always"
    }),
    elements: {
      reference: Y.anchor
    },
    middleware: [
      RZ({
        mainAxis: k + ge,
        alignmentAxis: O
      }),
      j && OZ({
        mainAxis: !0,
        crossAxis: !1,
        limiter: L === "partial" ? PZ() : void 0,
        ...oe
      }),
      j && jZ({
        ...oe
      }),
      AZ({
        ...oe,
        apply: ({ elements: gn, rects: An, availableWidth: Vn, availableHeight: Wr }) => {
          const { width: Yr, height: cr } = An.reference, ar = gn.floating.style;
          ar.setProperty("--radix-popper-available-width", `${Vn}px`), ar.setProperty("--radix-popper-available-height", `${Wr}px`), ar.setProperty("--radix-popper-anchor-width", `${Yr}px`), ar.setProperty("--radix-popper-anchor-height", `${cr}px`);
        }
      }),
      De && IZ({
        element: De,
        padding: R
      }),
      HZ({
        arrowWidth: se,
        arrowHeight: ge
      }),
      B && DZ({
        strategy: "referenceHidden",
        ...oe
      })
    ]
  }), [ut, wt] = bI(Xe), pt = ju(V);
  xm(() => {
    bt && (pt == null || pt());
  }, [
    bt,
    pt
  ]);
  const Rn = (l = at.arrow) === null || l === void 0 ? void 0 : l.x, rr = (d = at.arrow) === null || d === void 0 ? void 0 : d.y, Hn = ((f = at.arrow) === null || f === void 0 ? void 0 : f.centerOffset) !== 0, [Vt, xn] = $.useState();
  return xm(() => {
    ce && xn(window.getComputedStyle(ce).zIndex);
  }, [
    ce
  ]), /* @__PURE__ */ $.createElement("div", {
    ref: ke.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...Qe,
      transform: bt ? Qe.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Vt,
      ["--radix-popper-transform-origin"]: [
        (m = at.transformOrigin) === null || m === void 0 ? void 0 : m.x,
        (v = at.transformOrigin) === null || v === void 0 ? void 0 : v.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ $.createElement(zZ, {
    scope: x,
    placedSide: ut,
    onArrowChange: Re,
    arrowX: Rn,
    arrowY: rr,
    shouldHideArrow: Hn
  }, /* @__PURE__ */ $.createElement(Hl.div, _n({
    "data-side": ut,
    "data-align": wt
  }, W, {
    ref: Se,
    style: {
      ...W.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: bt ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (w = at.hide) !== null && w !== void 0 && w.referenceHidden ? 0 : void 0
    }
  }))));
});
function UZ(e) {
  return e !== null;
}
const HZ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, o, l, d, f;
    const { placement: m, rects: v, middlewareData: w } = t, b = ((r = w.arrow) === null || r === void 0 ? void 0 : r.centerOffset) !== 0, k = b ? 0 : e.arrowWidth, T = b ? 0 : e.arrowHeight, [O, R] = bI(m), j = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[R], I = ((o = (l = w.arrow) === null || l === void 0 ? void 0 : l.x) !== null && o !== void 0 ? o : 0) + k / 2, N = ((d = (f = w.arrow) === null || f === void 0 ? void 0 : f.y) !== null && d !== void 0 ? d : 0) + T / 2;
    let L = "", B = "";
    return O === "bottom" ? (L = b ? j : `${I}px`, B = `${-T}px`) : O === "top" ? (L = b ? j : `${I}px`, B = `${v.floating.height + T}px`) : O === "right" ? (L = `${-T}px`, B = b ? j : `${N}px`) : O === "left" && (L = `${v.floating.width + T}px`, B = b ? j : `${N}px`), {
      data: {
        x: L,
        y: B
      }
    };
  }
});
function bI(e) {
  const [t, r = "center"] = e.split("-");
  return [
    t,
    r
  ];
}
const VZ = LZ, GZ = FZ, qZ = BZ, WZ = /* @__PURE__ */ $.forwardRef((e, t) => {
  var r;
  const { container: o = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...l } = e;
  return o ? /* @__PURE__ */ IT.createPortal(/* @__PURE__ */ $.createElement(Hl.div, _n({}, l, {
    ref: t
  })), o) : null;
});
function YZ(e, t) {
  return $.useReducer((r, o) => {
    const l = t[r][o];
    return l ?? r;
  }, e);
}
const K3 = (e) => {
  const { present: t, children: r } = e, o = ZZ(t), l = typeof r == "function" ? r({
    present: o.isPresent
  }) : $.Children.only(r), d = Fo(o.ref, l.ref);
  return typeof r == "function" || o.isPresent ? /* @__PURE__ */ $.cloneElement(l, {
    ref: d
  }) : null;
};
K3.displayName = "Presence";
function ZZ(e) {
  const [t, r] = $.useState(), o = $.useRef({}), l = $.useRef(e), d = $.useRef("none"), f = e ? "mounted" : "unmounted", [m, v] = YZ(f, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return $.useEffect(() => {
    const w = b1(o.current);
    d.current = m === "mounted" ? w : "none";
  }, [
    m
  ]), xm(() => {
    const w = o.current, x = l.current;
    if (x !== e) {
      const k = d.current, T = b1(w);
      e ? v("MOUNT") : T === "none" || (w == null ? void 0 : w.display) === "none" ? v("UNMOUNT") : v(x && k !== T ? "ANIMATION_OUT" : "UNMOUNT"), l.current = e;
    }
  }, [
    e,
    v
  ]), xm(() => {
    if (t) {
      const w = (b) => {
        const T = b1(o.current).includes(b.animationName);
        b.target === t && T && X1.flushSync(
          () => v("ANIMATION_END")
        );
      }, x = (b) => {
        b.target === t && (d.current = b1(o.current));
      };
      return t.addEventListener("animationstart", x), t.addEventListener("animationcancel", w), t.addEventListener("animationend", w), () => {
        t.removeEventListener("animationstart", x), t.removeEventListener("animationcancel", w), t.removeEventListener("animationend", w);
      };
    } else
      v("ANIMATION_END");
  }, [
    t,
    v
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(m),
    ref: $.useCallback((w) => {
      w && (o.current = getComputedStyle(w)), r(w);
    }, [])
  };
}
function b1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const HE = "rovingFocusGroup.onEntryFocus", KZ = {
  bubbles: !1,
  cancelable: !0
}, Q3 = "RovingFocusGroup", [OT, wI, QZ] = tI(Q3), [XZ, xI] = w0(Q3, [
  QZ
]), [JZ, eK] = XZ(Q3), tK = /* @__PURE__ */ $.forwardRef((e, t) => /* @__PURE__ */ $.createElement(OT.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ $.createElement(OT.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ $.createElement(nK, _n({}, e, {
  ref: t
}))))), nK = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeRovingFocusGroup: r, orientation: o, loop: l = !1, dir: d, currentTabStopId: f, defaultCurrentTabStopId: m, onCurrentTabStopIdChange: v, onEntryFocus: w, ...x } = e, b = $.useRef(null), k = Fo(t, b), T = nI(d), [O = null, R] = J5({
    prop: f,
    defaultProp: m,
    onChange: v
  }), [j, I] = $.useState(!1), N = ju(w), L = wI(r), B = $.useRef(!1), [H, V] = $.useState(0);
  return $.useEffect(() => {
    const W = b.current;
    if (W)
      return W.addEventListener(HE, N), () => W.removeEventListener(HE, N);
  }, [
    N
  ]), /* @__PURE__ */ $.createElement(JZ, {
    scope: r,
    orientation: o,
    dir: T,
    loop: l,
    currentTabStopId: O,
    onItemFocus: $.useCallback(
      (W) => R(W),
      [
        R
      ]
    ),
    onItemShiftTab: $.useCallback(
      () => I(!0),
      []
    ),
    onFocusableItemAdd: $.useCallback(
      () => V(
        (W) => W + 1
      ),
      []
    ),
    onFocusableItemRemove: $.useCallback(
      () => V(
        (W) => W - 1
      ),
      []
    )
  }, /* @__PURE__ */ $.createElement(Hl.div, _n({
    tabIndex: j || H === 0 ? -1 : 0,
    "data-orientation": o
  }, x, {
    ref: k,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Un(e.onMouseDown, () => {
      B.current = !0;
    }),
    onFocus: Un(e.onFocus, (W) => {
      const Y = !B.current;
      if (W.target === W.currentTarget && Y && !j) {
        const ce = new CustomEvent(HE, KZ);
        if (W.currentTarget.dispatchEvent(ce), !ce.defaultPrevented) {
          const ve = L().filter(
            (se) => se.focusable
          ), Se = ve.find(
            (se) => se.active
          ), De = ve.find(
            (se) => se.id === O
          ), Pe = [
            Se,
            De,
            ...ve
          ].filter(Boolean).map(
            (se) => se.ref.current
          );
          SI(Pe);
        }
      }
      B.current = !1;
    }),
    onBlur: Un(
      e.onBlur,
      () => I(!1)
    )
  })));
}), rK = "RovingFocusGroupItem", aK = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeRovingFocusGroup: r, focusable: o = !0, active: l = !1, tabStopId: d, ...f } = e, m = TT(), v = d || m, w = eK(rK, r), x = w.currentTabStopId === v, b = wI(r), { onFocusableItemAdd: k, onFocusableItemRemove: T } = w;
  return $.useEffect(() => {
    if (o)
      return k(), () => T();
  }, [
    o,
    k,
    T
  ]), /* @__PURE__ */ $.createElement(OT.ItemSlot, {
    scope: r,
    id: v,
    focusable: o,
    active: l
  }, /* @__PURE__ */ $.createElement(Hl.span, _n({
    tabIndex: x ? 0 : -1,
    "data-orientation": w.orientation
  }, f, {
    ref: t,
    onMouseDown: Un(e.onMouseDown, (O) => {
      o ? w.onItemFocus(v) : O.preventDefault();
    }),
    onFocus: Un(
      e.onFocus,
      () => w.onItemFocus(v)
    ),
    onKeyDown: Un(e.onKeyDown, (O) => {
      if (O.key === "Tab" && O.shiftKey) {
        w.onItemShiftTab();
        return;
      }
      if (O.target !== O.currentTarget)
        return;
      const R = sK(O, w.orientation, w.dir);
      if (R !== void 0) {
        O.preventDefault();
        let I = b().filter(
          (N) => N.focusable
        ).map(
          (N) => N.ref.current
        );
        if (R === "last")
          I.reverse();
        else if (R === "prev" || R === "next") {
          R === "prev" && I.reverse();
          const N = I.indexOf(O.currentTarget);
          I = w.loop ? uK(I, N + 1) : I.slice(N + 1);
        }
        setTimeout(
          () => SI(I)
        );
      }
    })
  })));
}), iK = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function oK(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function sK(e, t, r) {
  const o = oK(e.key, r);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(o)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(o)))
    return iK[o];
}
function SI(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t))
      return;
}
function uK(e, t) {
  return e.map(
    (r, o) => e[(t + o) % e.length]
  );
}
const lK = tK, cK = aK;
var dK = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Hh = /* @__PURE__ */ new WeakMap(), w1 = /* @__PURE__ */ new WeakMap(), x1 = {}, VE = 0, kI = function(e) {
  return e && (e.host || kI(e.parentNode));
}, fK = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var o = kI(r);
    return o && e.contains(o) ? o : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, pK = function(e, t, r, o) {
  var l = fK(t, Array.isArray(e) ? e : [e]);
  x1[r] || (x1[r] = /* @__PURE__ */ new WeakMap());
  var d = x1[r], f = [], m = /* @__PURE__ */ new Set(), v = new Set(l), w = function(b) {
    !b || m.has(b) || (m.add(b), w(b.parentNode));
  };
  l.forEach(w);
  var x = function(b) {
    !b || v.has(b) || Array.prototype.forEach.call(b.children, function(k) {
      if (m.has(k))
        x(k);
      else
        try {
          var T = k.getAttribute(o), O = T !== null && T !== "false", R = (Hh.get(k) || 0) + 1, j = (d.get(k) || 0) + 1;
          Hh.set(k, R), d.set(k, j), f.push(k), R === 1 && O && w1.set(k, !0), j === 1 && k.setAttribute(r, "true"), O || k.setAttribute(o, "true");
        } catch (I) {
          console.error("aria-hidden: cannot operate on ", k, I);
        }
    });
  };
  return x(t), m.clear(), VE++, function() {
    f.forEach(function(b) {
      var k = Hh.get(b) - 1, T = d.get(b) - 1;
      Hh.set(b, k), d.set(b, T), k || (w1.has(b) || b.removeAttribute(o), w1.delete(b)), T || b.removeAttribute(r);
    }), VE--, VE || (Hh = /* @__PURE__ */ new WeakMap(), Hh = /* @__PURE__ */ new WeakMap(), w1 = /* @__PURE__ */ new WeakMap(), x1 = {});
  };
}, hK = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), l = t || dK(e);
  return l ? (o.push.apply(o, Array.from(l.querySelectorAll("[aria-live]"))), pK(o, l, r, "aria-hidden")) : function() {
    return null;
  };
}, Tu = function() {
  return Tu = Object.assign || function(t) {
    for (var r, o = 1, l = arguments.length; o < l; o++) {
      r = arguments[o];
      for (var d in r)
        Object.prototype.hasOwnProperty.call(r, d) && (t[d] = r[d]);
    }
    return t;
  }, Tu.apply(this, arguments);
};
function EI(e, t) {
  var r = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var l = 0, o = Object.getOwnPropertySymbols(e); l < o.length; l++)
      t.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[l]) && (r[o[l]] = e[o[l]]);
  return r;
}
function mK(e, t, r) {
  if (r || arguments.length === 2)
    for (var o = 0, l = t.length, d; o < l; o++)
      (d || !(o in t)) && (d || (d = Array.prototype.slice.call(t, 0, o)), d[o] = t[o]);
  return e.concat(d || Array.prototype.slice.call(t));
}
var R1 = "right-scroll-bar-position", O1 = "width-before-scroll-bar", yK = "with-scroll-bars-hidden", vK = "--removed-body-scroll-bar-size";
function GE(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function gK(e, t) {
  var r = $.useState(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(o) {
          var l = r.value;
          l !== o && (r.value = o, r.callback(o, l));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var bK = typeof window < "u" ? $.useLayoutEffect : $.useEffect, _j = /* @__PURE__ */ new WeakMap();
function wK(e, t) {
  var r = gK(t || null, function(o) {
    return e.forEach(function(l) {
      return GE(l, o);
    });
  });
  return bK(function() {
    var o = _j.get(r);
    if (o) {
      var l = new Set(o), d = new Set(e), f = r.current;
      l.forEach(function(m) {
        d.has(m) || GE(m, null);
      }), d.forEach(function(m) {
        l.has(m) || GE(m, f);
      });
    }
    _j.set(r, e);
  }, [e]), r;
}
function xK(e) {
  return e;
}
function SK(e, t) {
  t === void 0 && (t = xK);
  var r = [], o = !1, l = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(d) {
      var f = t(d, o);
      return r.push(f), function() {
        r = r.filter(function(m) {
          return m !== f;
        });
      };
    },
    assignSyncMedium: function(d) {
      for (o = !0; r.length; ) {
        var f = r;
        r = [], f.forEach(d);
      }
      r = {
        push: function(m) {
          return d(m);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(d) {
      o = !0;
      var f = [];
      if (r.length) {
        var m = r;
        r = [], m.forEach(d), f = r;
      }
      var v = function() {
        var x = f;
        f = [], x.forEach(d);
      }, w = function() {
        return Promise.resolve().then(v);
      };
      w(), r = {
        push: function(x) {
          f.push(x), w();
        },
        filter: function(x) {
          return f = f.filter(x), r;
        }
      };
    }
  };
  return l;
}
function kK(e) {
  e === void 0 && (e = {});
  var t = SK(null);
  return t.options = Tu({ async: !0, ssr: !1 }, e), t;
}
var CI = function(e) {
  var t = e.sideCar, r = EI(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return $.createElement(o, Tu({}, r));
};
CI.isSideCarExport = !0;
function EK(e, t) {
  return e.useMedium(t), CI;
}
var TI = kK(), qE = function() {
}, jx = $.forwardRef(function(e, t) {
  var r = $.useRef(null), o = $.useState({
    onScrollCapture: qE,
    onWheelCapture: qE,
    onTouchMoveCapture: qE
  }), l = o[0], d = o[1], f = e.forwardProps, m = e.children, v = e.className, w = e.removeScrollBar, x = e.enabled, b = e.shards, k = e.sideCar, T = e.noIsolation, O = e.inert, R = e.allowPinchZoom, j = e.as, I = j === void 0 ? "div" : j, N = EI(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), L = k, B = wK([r, t]), H = Tu(Tu({}, N), l);
  return $.createElement(
    $.Fragment,
    null,
    x && $.createElement(L, { sideCar: TI, removeScrollBar: w, shards: b, noIsolation: T, inert: O, setCallbacks: d, allowPinchZoom: !!R, lockRef: r }),
    f ? $.cloneElement($.Children.only(m), Tu(Tu({}, H), { ref: B })) : $.createElement(I, Tu({}, H, { className: v, ref: B }), m)
  );
});
jx.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
jx.classNames = {
  fullWidth: O1,
  zeroRight: R1
};
var Rj, CK = function() {
  if (Rj)
    return Rj;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function TK() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = CK();
  return t && e.setAttribute("nonce", t), e;
}
function _K(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function RK(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var OK = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = TK()) && (_K(t, r), RK(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, PK = function() {
  var e = OK();
  return function(t, r) {
    $.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, _I = function() {
  var e = PK(), t = function(r) {
    var o = r.styles, l = r.dynamic;
    return e(o, l), null;
  };
  return t;
}, jK = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, WE = function(e) {
  return parseInt(e || "", 10) || 0;
}, AK = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], l = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [WE(r), WE(o), WE(l)];
}, DK = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return jK;
  var t = AK(e), r = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - r + t[2] - t[0])
  };
}, IK = _I(), em = "data-scroll-locked", MK = function(e, t, r, o) {
  var l = e.left, d = e.top, f = e.right, m = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(yK, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(m, "px ").concat(o, `;
  }
  body[`).concat(em, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    r === "margin" && `
    padding-left: `.concat(l, `px;
    padding-top: `).concat(d, `px;
    padding-right: `).concat(f, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(m, "px ").concat(o, `;
    `),
    r === "padding" && "padding-right: ".concat(m, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(R1, ` {
    right: `).concat(m, "px ").concat(o, `;
  }
  
  .`).concat(O1, ` {
    margin-right: `).concat(m, "px ").concat(o, `;
  }
  
  .`).concat(R1, " .").concat(R1, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(O1, " .").concat(O1, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(em, `] {
    `).concat(vK, ": ").concat(m, `px;
  }
`);
}, Oj = function() {
  var e = parseInt(document.body.getAttribute(em) || "0", 10);
  return isFinite(e) ? e : 0;
}, $K = function() {
  $.useEffect(function() {
    return document.body.setAttribute(em, (Oj() + 1).toString()), function() {
      var e = Oj() - 1;
      e <= 0 ? document.body.removeAttribute(em) : document.body.setAttribute(em, e.toString());
    };
  }, []);
}, LK = function(e) {
  var t = e.noRelative, r = e.noImportant, o = e.gapMode, l = o === void 0 ? "margin" : o;
  $K();
  var d = $.useMemo(function() {
    return DK(l);
  }, [l]);
  return $.createElement(IK, { styles: MK(d, !t, l, r ? "" : "!important") });
}, PT = !1;
if (typeof window < "u")
  try {
    var S1 = Object.defineProperty({}, "passive", {
      get: function() {
        return PT = !0, !0;
      }
    });
    window.addEventListener("test", S1, S1), window.removeEventListener("test", S1, S1);
  } catch {
    PT = !1;
  }
var Vh = PT ? { passive: !1 } : !1, NK = function(e) {
  return e.tagName === "TEXTAREA";
}, RI = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !NK(e) && r[t] === "visible")
  );
}, FK = function(e) {
  return RI(e, "overflowY");
}, zK = function(e) {
  return RI(e, "overflowX");
}, Pj = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = OI(e, r);
    if (o) {
      var l = PI(e, r), d = l[1], f = l[2];
      if (d > f)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, BK = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    r,
    o
  ];
}, UK = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    r,
    o
  ];
}, OI = function(e, t) {
  return e === "v" ? FK(t) : zK(t);
}, PI = function(e, t) {
  return e === "v" ? BK(t) : UK(t);
}, HK = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, VK = function(e, t, r, o, l) {
  var d = HK(e, window.getComputedStyle(t).direction), f = d * o, m = r.target, v = t.contains(m), w = !1, x = f > 0, b = 0, k = 0;
  do {
    var T = PI(e, m), O = T[0], R = T[1], j = T[2], I = R - j - d * O;
    (O || I) && OI(e, m) && (b += I, k += O), m = m.parentNode;
  } while (
    // portaled content
    !v && m !== document.body || // self content
    v && (t.contains(m) || t === m)
  );
  return (x && (l && b === 0 || !l && f > b) || !x && (l && k === 0 || !l && -f > k)) && (w = !0), w;
}, k1 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, jj = function(e) {
  return [e.deltaX, e.deltaY];
}, Aj = function(e) {
  return e && "current" in e ? e.current : e;
}, GK = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, qK = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, WK = 0, Gh = [];
function YK(e) {
  var t = $.useRef([]), r = $.useRef([0, 0]), o = $.useRef(), l = $.useState(WK++)[0], d = $.useState(function() {
    return _I();
  })[0], f = $.useRef(e);
  $.useEffect(function() {
    f.current = e;
  }, [e]), $.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(l));
      var R = mK([e.lockRef.current], (e.shards || []).map(Aj), !0).filter(Boolean);
      return R.forEach(function(j) {
        return j.classList.add("allow-interactivity-".concat(l));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(l)), R.forEach(function(j) {
          return j.classList.remove("allow-interactivity-".concat(l));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var m = $.useCallback(function(R, j) {
    if ("touches" in R && R.touches.length === 2)
      return !f.current.allowPinchZoom;
    var I = k1(R), N = r.current, L = "deltaX" in R ? R.deltaX : N[0] - I[0], B = "deltaY" in R ? R.deltaY : N[1] - I[1], H, V = R.target, W = Math.abs(L) > Math.abs(B) ? "h" : "v";
    if ("touches" in R && W === "h" && V.type === "range")
      return !1;
    var Y = Pj(W, V);
    if (!Y)
      return !0;
    if (Y ? H = W : (H = W === "v" ? "h" : "v", Y = Pj(W, V)), !Y)
      return !1;
    if (!o.current && "changedTouches" in R && (L || B) && (o.current = H), !H)
      return !0;
    var ce = o.current || H;
    return VK(ce, j, R, ce === "h" ? L : B, !0);
  }, []), v = $.useCallback(function(R) {
    var j = R;
    if (!(!Gh.length || Gh[Gh.length - 1] !== d)) {
      var I = "deltaY" in j ? jj(j) : k1(j), N = t.current.filter(function(H) {
        return H.name === j.type && H.target === j.target && GK(H.delta, I);
      })[0];
      if (N && N.should) {
        j.cancelable && j.preventDefault();
        return;
      }
      if (!N) {
        var L = (f.current.shards || []).map(Aj).filter(Boolean).filter(function(H) {
          return H.contains(j.target);
        }), B = L.length > 0 ? m(j, L[0]) : !f.current.noIsolation;
        B && j.cancelable && j.preventDefault();
      }
    }
  }, []), w = $.useCallback(function(R, j, I, N) {
    var L = { name: R, delta: j, target: I, should: N };
    t.current.push(L), setTimeout(function() {
      t.current = t.current.filter(function(B) {
        return B !== L;
      });
    }, 1);
  }, []), x = $.useCallback(function(R) {
    r.current = k1(R), o.current = void 0;
  }, []), b = $.useCallback(function(R) {
    w(R.type, jj(R), R.target, m(R, e.lockRef.current));
  }, []), k = $.useCallback(function(R) {
    w(R.type, k1(R), R.target, m(R, e.lockRef.current));
  }, []);
  $.useEffect(function() {
    return Gh.push(d), e.setCallbacks({
      onScrollCapture: b,
      onWheelCapture: b,
      onTouchMoveCapture: k
    }), document.addEventListener("wheel", v, Vh), document.addEventListener("touchmove", v, Vh), document.addEventListener("touchstart", x, Vh), function() {
      Gh = Gh.filter(function(R) {
        return R !== d;
      }), document.removeEventListener("wheel", v, Vh), document.removeEventListener("touchmove", v, Vh), document.removeEventListener("touchstart", x, Vh);
    };
  }, []);
  var T = e.removeScrollBar, O = e.inert;
  return $.createElement(
    $.Fragment,
    null,
    O ? $.createElement(d, { styles: qK(l) }) : null,
    T ? $.createElement(LK, { gapMode: "margin" }) : null
  );
}
const ZK = EK(TI, YK);
var jI = $.forwardRef(function(e, t) {
  return $.createElement(jx, Tu({}, e, { ref: t, sideCar: ZK }));
});
jI.classNames = jx.classNames;
const KK = jI, QK = [
  "Enter",
  " "
], XK = [
  "ArrowDown",
  "PageUp",
  "Home"
], AI = [
  "ArrowUp",
  "PageDown",
  "End"
], JK = [
  ...XK,
  ...AI
], Ax = "Menu", [jT, eQ, tQ] = tI(Ax), [np, DI] = w0(Ax, [
  tQ,
  yI,
  xI
]), X3 = yI(), II = xI(), [nQ, S0] = np(Ax), [rQ, J3] = np(Ax), aQ = (e) => {
  const { __scopeMenu: t, open: r = !1, children: o, dir: l, onOpenChange: d, modal: f = !0 } = e, m = X3(t), [v, w] = $.useState(null), x = $.useRef(!1), b = ju(d), k = nI(l);
  return $.useEffect(() => {
    const T = () => {
      x.current = !0, document.addEventListener("pointerdown", O, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", O, {
        capture: !0,
        once: !0
      });
    }, O = () => x.current = !1;
    return document.addEventListener("keydown", T, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", T, {
        capture: !0
      }), document.removeEventListener("pointerdown", O, {
        capture: !0
      }), document.removeEventListener("pointermove", O, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ $.createElement(VZ, m, /* @__PURE__ */ $.createElement(nQ, {
    scope: t,
    open: r,
    onOpenChange: b,
    content: v,
    onContentChange: w
  }, /* @__PURE__ */ $.createElement(rQ, {
    scope: t,
    onClose: $.useCallback(
      () => b(!1),
      [
        b
      ]
    ),
    isUsingKeyboardRef: x,
    dir: k,
    modal: f
  }, o)));
}, iQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeMenu: r, ...o } = e, l = X3(r);
  return /* @__PURE__ */ $.createElement(GZ, _n({}, l, o, {
    ref: t
  }));
}), MI = "MenuPortal", [oQ, sQ] = np(MI, {
  forceMount: void 0
}), uQ = (e) => {
  const { __scopeMenu: t, forceMount: r, children: o, container: l } = e, d = S0(MI, t);
  return /* @__PURE__ */ $.createElement(oQ, {
    scope: t,
    forceMount: r
  }, /* @__PURE__ */ $.createElement(K3, {
    present: r || d.open
  }, /* @__PURE__ */ $.createElement(WZ, {
    asChild: !0,
    container: l
  }, o)));
}, fd = "MenuContent", [lQ, $I] = np(fd), cQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const r = sQ(fd, e.__scopeMenu), { forceMount: o = r.forceMount, ...l } = e, d = S0(fd, e.__scopeMenu), f = J3(fd, e.__scopeMenu);
  return /* @__PURE__ */ $.createElement(jT.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ $.createElement(K3, {
    present: o || d.open
  }, /* @__PURE__ */ $.createElement(jT.Slot, {
    scope: e.__scopeMenu
  }, f.modal ? /* @__PURE__ */ $.createElement(dQ, _n({}, l, {
    ref: t
  })) : /* @__PURE__ */ $.createElement(fQ, _n({}, l, {
    ref: t
  })))));
}), dQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const r = S0(fd, e.__scopeMenu), o = $.useRef(null), l = Fo(t, o);
  return $.useEffect(() => {
    const d = o.current;
    if (d)
      return hK(d);
  }, []), /* @__PURE__ */ $.createElement(LI, _n({}, e, {
    ref: l,
    trapFocus: r.open,
    disableOutsidePointerEvents: r.open,
    disableOutsideScroll: !0,
    onFocusOutside: Un(
      e.onFocusOutside,
      (d) => d.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => r.onOpenChange(!1)
  }));
}), fQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const r = S0(fd, e.__scopeMenu);
  return /* @__PURE__ */ $.createElement(LI, _n({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => r.onOpenChange(!1)
  }));
}), LI = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeMenu: r, loop: o = !1, trapFocus: l, onOpenAutoFocus: d, onCloseAutoFocus: f, disableOutsidePointerEvents: m, onEntryFocus: v, onEscapeKeyDown: w, onPointerDownOutside: x, onFocusOutside: b, onInteractOutside: k, onDismiss: T, disableOutsideScroll: O, ...R } = e, j = S0(fd, r), I = J3(fd, r), N = X3(r), L = II(r), B = eQ(r), [H, V] = $.useState(null), W = $.useRef(null), Y = Fo(t, W, j.onContentChange), ce = $.useRef(0), ve = $.useRef(""), Se = $.useRef(0), De = $.useRef(null), Re = $.useRef("right"), Pe = $.useRef(0), se = O ? KK : $.Fragment, ge = O ? {
    as: zg,
    allowPinchZoom: !0
  } : void 0, de = (fe) => {
    var z, oe;
    const ke = ve.current + fe, Qe = B().filter(
      (pt) => !pt.disabled
    ), Xe = document.activeElement, bt = (z = Qe.find(
      (pt) => pt.ref.current === Xe
    )) === null || z === void 0 ? void 0 : z.textValue, at = Qe.map(
      (pt) => pt.textValue
    ), ut = xQ(at, ke, bt), wt = (oe = Qe.find(
      (pt) => pt.textValue === ut
    )) === null || oe === void 0 ? void 0 : oe.ref.current;
    (function pt(Rn) {
      ve.current = Rn, window.clearTimeout(ce.current), Rn !== "" && (ce.current = window.setTimeout(
        () => pt(""),
        1e3
      ));
    })(ke), wt && setTimeout(
      () => wt.focus()
    );
  };
  $.useEffect(() => () => window.clearTimeout(ce.current), []), _Y();
  const pe = $.useCallback((fe) => {
    var z, oe;
    return Re.current === ((z = De.current) === null || z === void 0 ? void 0 : z.side) && kQ(fe, (oe = De.current) === null || oe === void 0 ? void 0 : oe.area);
  }, []);
  return /* @__PURE__ */ $.createElement(lQ, {
    scope: r,
    searchRef: ve,
    onItemEnter: $.useCallback((fe) => {
      pe(fe) && fe.preventDefault();
    }, [
      pe
    ]),
    onItemLeave: $.useCallback((fe) => {
      var z;
      pe(fe) || ((z = W.current) === null || z === void 0 || z.focus(), V(null));
    }, [
      pe
    ]),
    onTriggerLeave: $.useCallback((fe) => {
      pe(fe) && fe.preventDefault();
    }, [
      pe
    ]),
    pointerGraceTimerRef: Se,
    onPointerGraceIntentChange: $.useCallback((fe) => {
      De.current = fe;
    }, [])
  }, /* @__PURE__ */ $.createElement(se, ge, /* @__PURE__ */ $.createElement(RY, {
    asChild: !0,
    trapped: l,
    onMountAutoFocus: Un(d, (fe) => {
      var z;
      fe.preventDefault(), (z = W.current) === null || z === void 0 || z.focus();
    }),
    onUnmountAutoFocus: f
  }, /* @__PURE__ */ $.createElement(EY, {
    asChild: !0,
    disableOutsidePointerEvents: m,
    onEscapeKeyDown: w,
    onPointerDownOutside: x,
    onFocusOutside: b,
    onInteractOutside: k,
    onDismiss: T
  }, /* @__PURE__ */ $.createElement(lK, _n({
    asChild: !0
  }, L, {
    dir: I.dir,
    orientation: "vertical",
    loop: o,
    currentTabStopId: H,
    onCurrentTabStopIdChange: V,
    onEntryFocus: Un(v, (fe) => {
      I.isUsingKeyboardRef.current || fe.preventDefault();
    })
  }), /* @__PURE__ */ $.createElement(qZ, _n({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": gQ(j.open),
    "data-radix-menu-content": "",
    dir: I.dir
  }, N, R, {
    ref: Y,
    style: {
      outline: "none",
      ...R.style
    },
    onKeyDown: Un(R.onKeyDown, (fe) => {
      const oe = fe.target.closest("[data-radix-menu-content]") === fe.currentTarget, ke = fe.ctrlKey || fe.altKey || fe.metaKey, Qe = fe.key.length === 1;
      oe && (fe.key === "Tab" && fe.preventDefault(), !ke && Qe && de(fe.key));
      const Xe = W.current;
      if (fe.target !== Xe || !JK.includes(fe.key))
        return;
      fe.preventDefault();
      const at = B().filter(
        (ut) => !ut.disabled
      ).map(
        (ut) => ut.ref.current
      );
      AI.includes(fe.key) && at.reverse(), bQ(at);
    }),
    onBlur: Un(e.onBlur, (fe) => {
      fe.currentTarget.contains(fe.target) || (window.clearTimeout(ce.current), ve.current = "");
    }),
    onPointerMove: Un(e.onPointerMove, DT((fe) => {
      const z = fe.target, oe = Pe.current !== fe.clientX;
      if (fe.currentTarget.contains(z) && oe) {
        const ke = fe.clientX > Pe.current ? "right" : "left";
        Re.current = ke, Pe.current = fe.clientX;
      }
    }))
  })))))));
}), AT = "MenuItem", Dj = "menu.itemSelect", pQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { disabled: r = !1, onSelect: o, ...l } = e, d = $.useRef(null), f = J3(AT, e.__scopeMenu), m = $I(AT, e.__scopeMenu), v = Fo(t, d), w = $.useRef(!1), x = () => {
    const b = d.current;
    if (!r && b) {
      const k = new CustomEvent(Dj, {
        bubbles: !0,
        cancelable: !0
      });
      b.addEventListener(
        Dj,
        (T) => o == null ? void 0 : o(T),
        {
          once: !0
        }
      ), eI(b, k), k.defaultPrevented ? w.current = !1 : f.onClose();
    }
  };
  return /* @__PURE__ */ $.createElement(hQ, _n({}, l, {
    ref: v,
    disabled: r,
    onClick: Un(e.onClick, x),
    onPointerDown: (b) => {
      var k;
      (k = e.onPointerDown) === null || k === void 0 || k.call(e, b), w.current = !0;
    },
    onPointerUp: Un(e.onPointerUp, (b) => {
      var k;
      w.current || (k = b.currentTarget) === null || k === void 0 || k.click();
    }),
    onKeyDown: Un(e.onKeyDown, (b) => {
      const k = m.searchRef.current !== "";
      r || k && b.key === " " || QK.includes(b.key) && (b.currentTarget.click(), b.preventDefault());
    })
  }));
}), hQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeMenu: r, disabled: o = !1, textValue: l, ...d } = e, f = $I(AT, r), m = II(r), v = $.useRef(null), w = Fo(t, v), [x, b] = $.useState(!1), [k, T] = $.useState("");
  return $.useEffect(() => {
    const O = v.current;
    if (O) {
      var R;
      T(((R = O.textContent) !== null && R !== void 0 ? R : "").trim());
    }
  }, [
    d.children
  ]), /* @__PURE__ */ $.createElement(jT.ItemSlot, {
    scope: r,
    disabled: o,
    textValue: l ?? k
  }, /* @__PURE__ */ $.createElement(cK, _n({
    asChild: !0
  }, m, {
    focusable: !o
  }), /* @__PURE__ */ $.createElement(Hl.div, _n({
    role: "menuitem",
    "data-highlighted": x ? "" : void 0,
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0
  }, d, {
    ref: w,
    onPointerMove: Un(e.onPointerMove, DT((O) => {
      o ? f.onItemLeave(O) : (f.onItemEnter(O), O.defaultPrevented || O.currentTarget.focus());
    })),
    onPointerLeave: Un(e.onPointerLeave, DT(
      (O) => f.onItemLeave(O)
    )),
    onFocus: Un(
      e.onFocus,
      () => b(!0)
    ),
    onBlur: Un(
      e.onBlur,
      () => b(!1)
    )
  }))));
}), mQ = "MenuRadioGroup";
np(mQ, {
  value: void 0,
  onValueChange: () => {
  }
});
const yQ = "MenuItemIndicator";
np(yQ, {
  checked: !1
});
const vQ = "MenuSub";
np(vQ);
function gQ(e) {
  return e ? "open" : "closed";
}
function bQ(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t))
      return;
}
function wQ(e, t) {
  return e.map(
    (r, o) => e[(t + o) % e.length]
  );
}
function xQ(e, t, r) {
  const l = t.length > 1 && Array.from(t).every(
    (w) => w === t[0]
  ) ? t[0] : t, d = r ? e.indexOf(r) : -1;
  let f = wQ(e, Math.max(d, 0));
  l.length === 1 && (f = f.filter(
    (w) => w !== r
  ));
  const v = f.find(
    (w) => w.toLowerCase().startsWith(l.toLowerCase())
  );
  return v !== r ? v : void 0;
}
function SQ(e, t) {
  const { x: r, y: o } = e;
  let l = !1;
  for (let d = 0, f = t.length - 1; d < t.length; f = d++) {
    const m = t[d].x, v = t[d].y, w = t[f].x, x = t[f].y;
    v > o != x > o && r < (w - m) * (o - v) / (x - v) + m && (l = !l);
  }
  return l;
}
function kQ(e, t) {
  if (!t)
    return !1;
  const r = {
    x: e.clientX,
    y: e.clientY
  };
  return SQ(r, t);
}
function DT(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const EQ = aQ, CQ = iQ, TQ = uQ, _Q = cQ, RQ = pQ, NI = "DropdownMenu", [OQ, NX] = w0(NI, [
  DI
]), k0 = DI(), [PQ, FI] = OQ(NI), jQ = (e) => {
  const { __scopeDropdownMenu: t, children: r, dir: o, open: l, defaultOpen: d, onOpenChange: f, modal: m = !0 } = e, v = k0(t), w = $.useRef(null), [x = !1, b] = J5({
    prop: l,
    defaultProp: d,
    onChange: f
  });
  return /* @__PURE__ */ $.createElement(PQ, {
    scope: t,
    triggerId: TT(),
    triggerRef: w,
    contentId: TT(),
    open: x,
    onOpenChange: b,
    onOpenToggle: $.useCallback(
      () => b(
        (k) => !k
      ),
      [
        b
      ]
    ),
    modal: m
  }, /* @__PURE__ */ $.createElement(EQ, _n({}, v, {
    open: x,
    onOpenChange: b,
    dir: o,
    modal: m
  }), r));
}, AQ = "DropdownMenuTrigger", DQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, disabled: o = !1, ...l } = e, d = FI(AQ, r), f = k0(r);
  return /* @__PURE__ */ $.createElement(CQ, _n({
    asChild: !0
  }, f), /* @__PURE__ */ $.createElement(Hl.button, _n({
    type: "button",
    id: d.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": d.open,
    "aria-controls": d.open ? d.contentId : void 0,
    "data-state": d.open ? "open" : "closed",
    "data-disabled": o ? "" : void 0,
    disabled: o
  }, l, {
    ref: U3(t, d.triggerRef),
    onPointerDown: Un(e.onPointerDown, (m) => {
      !o && m.button === 0 && m.ctrlKey === !1 && (d.onOpenToggle(), d.open || m.preventDefault());
    }),
    onKeyDown: Un(e.onKeyDown, (m) => {
      o || ([
        "Enter",
        " "
      ].includes(m.key) && d.onOpenToggle(), m.key === "ArrowDown" && d.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(m.key) && m.preventDefault());
    })
  })));
}), IQ = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = k0(t);
  return /* @__PURE__ */ $.createElement(TQ, _n({}, o, r));
}, MQ = "DropdownMenuContent", $Q = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...o } = e, l = FI(MQ, r), d = k0(r), f = $.useRef(!1);
  return /* @__PURE__ */ $.createElement(_Q, _n({
    id: l.contentId,
    "aria-labelledby": l.triggerId
  }, d, o, {
    ref: t,
    onCloseAutoFocus: Un(e.onCloseAutoFocus, (m) => {
      var v;
      f.current || (v = l.triggerRef.current) === null || v === void 0 || v.focus(), f.current = !1, m.preventDefault();
    }),
    onInteractOutside: Un(e.onInteractOutside, (m) => {
      const v = m.detail.originalEvent, w = v.button === 0 && v.ctrlKey === !0, x = v.button === 2 || w;
      (!l.modal || x) && (f.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), LQ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...o } = e, l = k0(r);
  return /* @__PURE__ */ $.createElement(RQ, _n({}, l, o, {
    ref: t
  }));
}), NQ = jQ, FQ = DQ, zQ = IQ, BQ = $Q, Ij = LQ;
function UQ({ className: e, ...t }) {
  return /* @__PURE__ */ ze.jsxs(
    "svg",
    {
      className: aa("-my-[0.125em] h-[1.25em] w-[1.25em] animate-spin", e),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...t,
      children: [
        /* @__PURE__ */ ze.jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
        /* @__PURE__ */ ze.jsx(
          "path",
          {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
}
function Dx({ className: e, children: t, ...r }) {
  return /* @__PURE__ */ ze.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      className: aa("-my-[0.125em] h-[1.25em] w-[1.25em]", e),
      ...r,
      children: t
    }
  );
}
function HQ(e) {
  return /* @__PURE__ */ ze.jsx(Dx, { ...e, children: /* @__PURE__ */ ze.jsx(
    "path",
    {
      d: "M17 9V7C17 5.89543 16.1046 5 15 5H5C3.89543 5 3 5.89543 3 7V13C3 14.1046 3.89543 15 5 15H7M9 19H19C20.1046 19 21 18.1046 21 17V11C21 9.89543 20.1046 9 19 9H9C7.89543 9 7 9.89543 7 11V17C7 18.1046 7.89543 19 9 19ZM16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function VQ(e) {
  return /* @__PURE__ */ ze.jsxs(Dx, { viewBox: "0 0 20 20", ...e, children: [
    /* @__PURE__ */ ze.jsx("path", { d: "M3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17C3.55228 17 4 16.5523 4 16V4C4 3.44772 3.55228 3 3 3Z" }),
    /* @__PURE__ */ ze.jsx("path", { d: "M13.2929 12.2929C12.9024 12.6834 12.9024 13.3166 13.2929 13.7071C13.6834 14.0976 14.3166 14.0976 14.7071 13.7071L17.7071 10.7071C17.8946 10.5196 18 10.2652 18 10C18 9.73478 17.8946 9.48043 17.7071 9.29289L14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289C12.9024 6.68342 12.9024 7.31658 13.2929 7.70711L14.5858 9L7 9C6.44771 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H14.5858L13.2929 12.2929Z" })
  ] });
}
function GQ(e) {
  return /* @__PURE__ */ ze.jsx(Dx, { ...e, children: /* @__PURE__ */ ze.jsx(
    "path",
    {
      d: "M12 5L12 5.01M12 12L12 12.01M12 19L12 19.01M12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13ZM12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function qQ(e) {
  return /* @__PURE__ */ ze.jsx(Dx, { viewBox: "0 0 20 20", ...e, children: /* @__PURE__ */ ze.jsx(
    "path",
    {
      d: "M14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L10 9.41421L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071Z",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ) });
}
function WQ(e) {
  const t = e == null ? void 0 : e.toLowerCase();
  return wx({
    enabled: !!t,
    queryKey: ["ens", t],
    initialData: {
      address: void 0,
      name: void 0,
      displayName: void 0,
      avatar: void 0
    },
    queryFn: async () => {
      const r = await fetch(`https://api.ensideas.com/ens/resolve/${t}`).then((o) => o.json());
      return {
        address: r.address ?? void 0,
        name: r.name ?? void 0,
        displayName: r.displayName ?? void 0,
        avatar: r.avatar ?? void 0
      };
    }
  });
}
function YQ({ hex: e }) {
  return e.length <= 10 ? /* @__PURE__ */ ze.jsx("span", { children: e }) : /* @__PURE__ */ ze.jsxs("span", { children: [
    /* @__PURE__ */ ze.jsx("span", { className: "after:select-none after:content-['…']", children: e.slice(0, 6) }),
    /* @__PURE__ */ ze.jsx("span", { className: "tracking-[-1ch] text-transparent", children: e.slice(6, -4) }),
    e.slice(-4)
  ] });
}
function ZQ(e) {
  return wx({
    enabled: !!e,
    retry: !1,
    retryOnMount: !1,
    refetchOnMount: !1,
    refetchOnWindowFocus: !1,
    queryKey: [e],
    queryFn: () => new Promise((t, r) => {
      if (!e)
        throw new Error("usePreloadImage: Must provide `url` to preload image.");
      const o = new Image();
      o.onload = () => t(o), o.onerror = () => r(new Error(`usePreloadImage: Could not load image.

	URL: ${e}`)), o.src = e;
    })
  });
}
function KQ({ address: e }) {
  const { data: t } = WQ(e), { isSuccess: r } = ZQ(t.avatar);
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsxs("span", { className: "flex-shrink-0 w-6 h-6 -my-1 -mx-0.5 grid place-items-center", children: [
      /* @__PURE__ */ ze.jsx(
        "img",
        {
          src: r ? t.avatar : void 0,
          className: aa(
            "col-start-1 row-start-1",
            "inline-flex w-full h-full rounded-full bg-black/10 dark:bg-white/10 bg-cover bg-no-repeat bg-center",
            r ? "opacity-100" : "opacity-0"
          )
        }
      ),
      /* @__PURE__ */ ze.jsx(
        X5,
        {
          className: aa(
            "col-start-1 row-start-1 text-orange-500",
            "transition duration-300",
            r ? "opacity-0" : "opacity-100"
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx("span", { className: "flex-grow", children: t.name ?? (e ? /* @__PURE__ */ ze.jsx(YQ, { hex: e }) : null) })
  ] });
}
function QQ(e) {
  return Object.keys(e);
}
const Mj = {
  wallet: {
    label: "Connect",
    requires: [],
    satisfies: ["connectedWallet"]
  },
  "app-account": {
    label: "Sign in",
    requires: ["connectedWallet"],
    satisfies: ["appSigner", "accountDelegation"]
  },
  deposit: {
    label: "Top up",
    requires: ["connectedWallet", "appSigner", "accountDelegation"],
    satisfies: ["gasAllowance", "gasSpender"]
  },
  // TODO: rework this, feels weird to show this as a step on the left
  finalizing: {
    label: "Finalizing",
    requires: ["connectedWallet", "gasAllowance", "gasSpender", "accountDelegation"],
    satisfies: ["accountDelegationConfirmed"]
  }
}, YE = e0(() => ({ step: null }));
function XQ() {
  const e = J1(YE, (v) => v.step), { closeAccountModal: t } = Yj(), { requirements: r } = q5(), { step: o, nextStep: l, steps: d } = $.useMemo(() => {
    const v = QQ(Mj).map((b) => {
      const k = Mj[b];
      return {
        id: b,
        ...k,
        canComplete: k.requires.every((T) => !r.includes(T)),
        isComplete: k.satisfies.every((T) => !r.includes(T))
      };
    }), w = v.filter((b) => !b.isComplete).at(0);
    return {
      step: e ?? (w == null ? void 0 : w.id) ?? v.filter((b) => b.id !== "finalizing").at(-1).id,
      nextStep: w,
      steps: v
    };
  }, [e, r]), f = $.useCallback((v) => {
    YE.setState({ step: v });
  }, []), m = $.useCallback(() => {
    YE.setState({ step: null }), l || t();
  }, [t, l]);
  return $.useMemo(
    () => ({
      step: o,
      steps: d,
      setStep: f,
      resetStep: m
    }),
    [m, f, o, d]
  );
}
const ZE = aa(
  "w-60 inline-flex outline-none transition",
  "border border-transparent",
  "text-base leading-none"
), $j = aa(
  "bg-neutral-100 border-neutral-300 text-black",
  "dark:bg-neutral-800 dark:border-neutral-700 dark:text-white"
), JQ = aa("divide-y divide-neutral-300 dark:divide-neutral-700"), KE = aa(
  "cursor-pointer outline-none hover:bg-neutral-200 data-[highlighted]:bg-neutral-200 dark:hover:bg-neutral-700"
);
function eX() {
  const { requirement: e } = q5(), { openAccountModal: t, accountModalOpen: r } = Yj(), { address: o } = kd(), [l, d] = $.useState(!1), { disconnect: f, isPending: m } = dH(), { setStep: v } = XQ();
  return e != null ? /* @__PURE__ */ ze.jsx(NE, { mode: "child", children: /* @__PURE__ */ ze.jsxs(
    "button",
    {
      type: "button",
      className: aa(
        ZE,
        "group",
        "items-center justify-center gap-2.5 p-3",
        "bg-orange-500 text-white font-medium",
        "hover:bg-orange-400",
        "active:bg-orange-600",
        "aria-busy:saturate-50"
      ),
      "aria-busy": r,
      onClick: t,
      children: [
        /* @__PURE__ */ ze.jsxs("span", { className: "pointer-events-none inline-grid place-items-center -ml-3", children: [
          /* @__PURE__ */ ze.jsx(
            "span",
            {
              className: aa(
                "col-start-1 row-start-1 leading-none",
                "scale-100 opacity-100 transition duration-300",
                "group-aria-busy:scale-125 group-aria-busy:opacity-0"
              ),
              children: /* @__PURE__ */ ze.jsx(X5, {})
            }
          ),
          /* @__PURE__ */ ze.jsx(
            "span",
            {
              "aria-hidden": !0,
              className: aa(
                "col-start-1 row-start-1",
                "scale-50 opacity-0 transition duration-300 delay-50",
                "group-aria-busy:scale-100 group-aria-busy:opacity-100"
              ),
              children: /* @__PURE__ */ ze.jsx(UQ, {})
            }
          )
        ] }),
        /* @__PURE__ */ ze.jsx("span", { className: "font-medium", children: "Sign in" })
      ]
    }
  ) }) : /* @__PURE__ */ ze.jsxs(NQ, { open: l, onOpenChange: d, children: [
    /* @__PURE__ */ ze.jsx(FQ, { asChild: !0, children: /* @__PURE__ */ ze.jsx(NE, { mode: "child", children: /* @__PURE__ */ ze.jsx(
      "button",
      {
        type: "button",
        className: aa(ZE, $j, KE, "p-3"),
        onClick: () => d(!l),
        children: /* @__PURE__ */ ze.jsxs("span", { className: "flex-grow inline-flex gap-2.5 items-center text-left font-medium", children: [
          /* @__PURE__ */ ze.jsx(KQ, { address: o }),
          /* @__PURE__ */ ze.jsxs("span", { className: "flex-shrink-0 pointer-events-none inline-grid place-items-center -mr-1.5", children: [
            /* @__PURE__ */ ze.jsx(
              "span",
              {
                className: aa(
                  "col-start-1 row-start-1 leading-none",
                  "transition duration-300",
                  l ? "opacity-0 scale-50 rotate-90" : "opacity-100 scale-100"
                ),
                children: /* @__PURE__ */ ze.jsx(GQ, { className: "flex-shrink-0 opacity-50" })
              }
            ),
            /* @__PURE__ */ ze.jsx(
              "span",
              {
                "aria-hidden": !0,
                className: aa(
                  "col-start-1 row-start-1",
                  "transition duration-300",
                  l ? "opacity-100 scale-100" : "opacity-0 scale-50 -rotate-90"
                ),
                children: /* @__PURE__ */ ze.jsx(qQ, { className: "flex-shrink-0 opacity-50" })
              }
            )
          ] })
        ] })
      }
    ) }) }),
    /* @__PURE__ */ ze.jsx(zQ, { children: /* @__PURE__ */ ze.jsx(BQ, { align: "start", style: { zIndex: "2147483646" }, children: /* @__PURE__ */ ze.jsx(NE, { mode: "child", children: /* @__PURE__ */ ze.jsxs(
      "div",
      {
        className: aa(
          ZE,
          $j,
          JQ,
          "-mt-px flex-col animate-in fade-in slide-in-from-top-2 animate-duration-200"
        ),
        children: [
          /* @__PURE__ */ ze.jsxs(
            Ij,
            {
              className: aa(KE, "flex gap-2.5 p-3 items-center"),
              onSelect: () => {
                t(), v("deposit");
              },
              children: [
                /* @__PURE__ */ ze.jsx(HQ, { className: "flex-shrink-0 opacity-50" }),
                /* @__PURE__ */ ze.jsx("span", { className: "flex-grow", children: "Gas balance" })
              ]
            }
          ),
          /* @__PURE__ */ ze.jsxs(
            Ij,
            {
              className: aa(
                KE,
                "flex gap-2.5 p-3 items-center",
                // TODO: better pending state
                "aria-busy:opacity-50"
              ),
              "aria-busy": m,
              onSelect: () => f(),
              children: [
                /* @__PURE__ */ ze.jsx(VQ, { className: "flex-shrink-0 text-red-500" }),
                /* @__PURE__ */ ze.jsx("span", { className: "flex-grow", children: "Disconnect" })
              ]
            }
          )
        ]
      }
    ) }) }) })
  ] });
}
function tX() {
  const e = J1(Uf, (t) => t.buttonContainers);
  return /* @__PURE__ */ ze.jsx(ze.Fragment, { children: e.map((t) => IT.createPortal(/* @__PURE__ */ ze.jsx(eX, {}), t)) });
}
if (typeof window > "u" || typeof document > "u")
  throw new Error("MUD Account Kit should only be used in browser bundles.");
function FX({
  rootContainer: e,
  wagmiConfig: t,
  accountKitConfig: r
}) {
  if (Uf.getState().rootContainer)
    throw new Error("MUD Account Kit is already mounted and only one instance is allowed on the page at a time.");
  const o = e ?? document.body.appendChild(document.createElement("div"));
  Uf.setState({ rootContainer: o });
  async function l() {
    var N;
    const f = await Promise.resolve().then(() => Vj), m = await import("./client-df234e4d.js").then((L) => L.c), { WagmiProvider: v } = await import("./index-00e395b4.js"), { QueryClientProvider: w, QueryClient: x } = await import("./index-88f8d112.js"), { RainbowKitProvider: b, lightTheme: k, midnightTheme: T } = await import("./index-a7becef5.js").then((L) => L.i), { AccountKitProvider: O } = await import("./AccountKitProvider-07cc0d94.js"), { SyncStore: R } = await import("./SyncStore-2629a870.js"), j = new x(), I = m.createRoot(o);
    return I.render(
      /* @__PURE__ */ ze.jsx(f.StrictMode, { children: /* @__PURE__ */ ze.jsx(v, { config: t, children: /* @__PURE__ */ ze.jsx(w, { client: j, children: /* @__PURE__ */ ze.jsx(
        b,
        {
          appInfo: {
            appName: (N = r.appInfo) == null ? void 0 : N.name
            // TODO: learn more and disclaimer
          },
          theme: r.theme === "light" ? k({ borderRadius: "none" }) : r.theme === "dark" ? T({ borderRadius: "none" }) : {
            lightMode: k({ borderRadius: "none" }),
            darkMode: T({ borderRadius: "none" })
          },
          children: /* @__PURE__ */ ze.jsxs(O, { config: r, children: [
            /* @__PURE__ */ ze.jsx(R, { store: IL }),
            /* @__PURE__ */ ze.jsx(tX, {}),
            /* @__PURE__ */ ze.jsx("style", { dangerouslySetInnerHTML: { __html: DL } })
          ] })
        }
      ) }) }) })
    ), () => {
      I.unmount();
    };
  }
  const d = l().catch((f) => {
    console.error("Failed to mount MUD Account Kit.", f);
  });
  return () => {
    Uf.setState({ rootContainer: void 0 }), o !== e && o.remove(), d.then((f) => f == null ? void 0 : f());
  };
}
function zX(e) {
  return Uf.getState().rootContainer || console.warn(
    "MUD Account Kit `mountButton` was called before `mount`. You will not see buttons rendered until `mount` is called."
  ), Uf.setState((t) => ({
    buttonContainers: [...t.buttonContainers, e]
  })), () => {
    Uf.setState((t) => ({
      buttonContainers: t.buttonContainers.filter((r) => r !== e)
    }));
  };
}
export {
  E3 as $,
  jP as A,
  x9 as B,
  pX as C,
  wX as D,
  bX as E,
  VD as F,
  GD as G,
  g9 as H,
  yX as I,
  Eg as J,
  k3 as K,
  JD as L,
  SX as M,
  EX as N,
  I9 as O,
  n5 as P,
  xX as Q,
  wx as R,
  gx as S,
  bx as T,
  L9 as U,
  WD as V,
  UD as W,
  D9 as X,
  P9 as Y,
  EE as Z,
  vm as _,
  mX as a,
  jW as a$,
  oD as a0,
  dg as a1,
  Kh as a2,
  wC as a3,
  oX as a4,
  Il as a5,
  t3 as a6,
  ua as a7,
  we as a8,
  nF as a9,
  Io as aA,
  w0 as aB,
  $ as aC,
  J5 as aD,
  TT as aE,
  K3 as aF,
  WZ as aG,
  _n as aH,
  Fo as aI,
  hK as aJ,
  Un as aK,
  _Y as aL,
  RY as aM,
  EY as aN,
  Hl as aO,
  ze as aP,
  NE as aQ,
  aa as aR,
  Dx as aS,
  UQ as aT,
  WQ as aU,
  XQ as aV,
  Yj as aW,
  YQ as aX,
  Iu as aY,
  ZQ as aZ,
  X5 as a_,
  A1 as aa,
  C1 as ab,
  lX as ac,
  YT as ad,
  Ml as ae,
  uX as af,
  cX as ag,
  QB as ah,
  St as ai,
  Ps as aj,
  Sg as ak,
  Va as al,
  Lo as am,
  ks as an,
  sX as ao,
  Bt as ap,
  h3 as aq,
  m3 as ar,
  HT as as,
  Wf as at,
  ag as au,
  pd as av,
  $l as aw,
  dX as ax,
  Dl as ay,
  TF as az,
  S9 as b,
  d0 as b$,
  o5 as b0,
  Nn as b1,
  Ox as b2,
  Ke as b3,
  EW as b4,
  xC as b5,
  wU as b6,
  xW as b7,
  VT as b8,
  rD as b9,
  SW as bA,
  H5 as bB,
  q1 as bC,
  RX as bD,
  tI as bE,
  yI as bF,
  nI as bG,
  VZ as bH,
  GZ as bI,
  xm as bJ,
  KK as bK,
  zg as bL,
  ju as bM,
  qZ as bN,
  LW as bO,
  $X as bP,
  qQ as bQ,
  Fi as bR,
  $H as bS,
  e0 as bT,
  J1 as bU,
  m5 as bV,
  CX as bW,
  R3 as bX,
  h5 as bY,
  OX as bZ,
  TX as b_,
  bg as ba,
  Tm as bb,
  Ts as bc,
  r3 as bd,
  fi as be,
  ux as bf,
  ro as bg,
  lx as bh,
  aU as bi,
  Nl as bj,
  yB as bk,
  a0 as bl,
  di as bm,
  xg as bn,
  QT as bo,
  KT as bp,
  xB as bq,
  gD as br,
  x3 as bs,
  bC as bt,
  u0 as bu,
  fm as bv,
  Cr as bw,
  ia as bx,
  dd as by,
  nC as bz,
  oH as c,
  ox as c0,
  FD as c1,
  zD as c2,
  xx as c3,
  Sx as c4,
  kK as c5,
  EI as c6,
  wK as c7,
  Tu as c8,
  O1 as c9,
  R1 as ca,
  _I as cb,
  mK as cc,
  LK as cd,
  EK as ce,
  l1 as cf,
  jo as cg,
  c0 as ch,
  dB as ci,
  fB as cj,
  a9 as ck,
  TD as cl,
  f9 as cm,
  q5 as cn,
  $T as co,
  sa as cp,
  gC as cq,
  dx as cr,
  ng as cs,
  Cs as ct,
  FX as cu,
  zX as cv,
  IL as cw,
  uH as d,
  f0 as e,
  lH as f,
  js as g,
  cH as h,
  dH as i,
  r5 as j,
  fH as k,
  a5 as l,
  sH as m,
  hX as n,
  n9 as o,
  jB as p,
  sD as q,
  X1 as r,
  md as s,
  k9 as t,
  kd as u,
  b9 as v,
  _m as w,
  vX as x,
  gX as y,
  DC as z
};
//# sourceMappingURL=bundle-32f13ea4.js.map
